[
    { "id": 1, "word": "ក" },
    { "id": 2, "word": "ក៏" },
    { "id": 3, "word": "កក" },
    { "id": 4, "word": "កក់" },
    { "id": 5, "word": "កក្កដ" },
    { "id": 6, "word": "កករ" },
    { "id": 7, "word": "កកាត" },
    { "id": 8, "word": "កកាយ" },
    { "id": 9, "word": "កកិចកកុច" },
    { "id": 10, "word": "កកិត" },
    { "id": 11, "word": "កកិល" },
    { "id": 12, "word": "កកូរ" },
    { "id": 13, "word": "កកេបកកាប" },
    { "id": 14, "word": "កកេរ" },
    { "id": 15, "word": "កកេះ" },
    { "id": 16, "word": "កកែកករ" },
    { "id": 17, "word": "កកែកកកោក" },
    { "id": 18, "word": "កកែងកកោង" },
    { "id": 19, "word": "កកែប" },
    { "id": 20, "word": "កកោក" },
    { "id": 21, "word": "កកោស" },
    { "id": 22, "word": "កកោះ" },
    { "id": 23, "word": "កក្រិត" },
    { "id": 24, "word": "កក្រើក" },
    { "id": 25, "word": "កក្រោះ" },
    { "id": 26, "word": "កក្លាក់" },
    { "id": 27, "word": "កក្អាក" },
    { "id": 28, "word": "កក្អាយ" },
    { "id": 29, "word": "កក្អិច" },
    { "id": 30, "word": "កក្អិល" },
    { "id": 31, "word": "កក្អឹក" },
    { "id": 32, "word": "កក្អៀក" },
    { "id": 33, "word": "កក្អៀច" },
    { "id": 34, "word": "កខិកកខក់" },
    { "id": 35, "word": "កខិបកខុប" },
    { "id": 36, "word": "កខឹក" },
    { "id": 37, "word": "កខុប" },
    { "id": 38, "word": "កខ្វក់" },
    { "id": 39, "word": "កខ្វិក" },
    { "id": 40, "word": "កខ្វេសកខ្វាស" },
    { "id": 41, "word": "កង" },
    { "id": 42, "word": "កងមាស" },
    { "id": 43, "word": "កង់" },
    { "id": 44, "word": "កង្កុញ" },
    { "id": 45, "word": "កង្កួច" },
    { "id": 46, "word": "កង្កួញ" },
    { "id": 47, "word": "កង្កែប" },
    { "id": 48, "word": "កង្កែបកូប" },
    { "id": 49, "word": "កង្កែបប្រុយ" },
    { "id": 50, "word": "កង្កែបអាចម៍គោ" },
    { "id": 51, "word": "កង្ខា" },
    { "id": 52, "word": "កង្ខើញ" },
    { "id": 53, "word": "កង្វល់" },
    { "id": 54, "word": "កង្វារ" },
    { "id": 55, "word": "កង្វេរ" },
    { "id": 56, "word": "កង្ហារ" },
    { "id": 57, "word": "កង្ហិច" },
    { "id": 58, "word": "កង្ហែន" },
    { "id": 59, "word": "កងកេង" },
    { "id": 60, "word": "កងចៅ" },
    { "id": 61, "word": "កងព័ន្ធ" },
    { "id": 62, "word": "កងសោយ" },
    { "id": 63, "word": "កច្ចាយនៈ" },
    { "id": 64, "word": "កច្ចាយនូបត្ថម្ភកៈ" },
    { "id": 65, "word": "កញ្ចក" },
    { "id": 66, "word": "កញ្ចក់" },
    { "id": 67, "word": "កញ្ចប់" },
    { "id": 68, "word": "កញ្ចប់កញ្ចូវ" },
    { "id": 69, "word": "កញ្ចាញ់ចេក" },
    { "id": 70, "word": "កញ្ចាញ់ច្រាស" },
    { "id": 71, "word": "កញ្ចាម" },
    { "id": 72, "word": "កញ្ចាស់" },
    { "id": 73, "word": "កញ្ចឹងក" },
    { "id": 74, "word": "កញ្ចុះ" },
    { "id": 75, "word": "កញ្ចែ" },
    { "id": 76, "word": "កញ្ចោង" },
    { "id": 77, "word": "កញ្ចោត" },
    { "id": 78, "word": "កញ្ចោប" },
    { "id": 79, "word": "កញ្ចុំ" },
    { "id": 80, "word": "កញ្ចាំង" },
    { "id": 81, "word": "កញ្ច្រង់" },
    { "id": 82, "word": "កញ្ច្រឹក" },
    { "id": 83, "word": "កញ្ច្រឺប" },
    { "id": 84, "word": "កញ្ច្រែង" },
    { "id": 85, "word": "កញ្ឆក់" },
    { "id": 86, "word": "កញ្ឆក់កញ្ឆែង" },
    { "id": 87, "word": "កញ្ឆត" },
    { "id": 88, "word": "កញ្ឆល" },
    { "id": 89, "word": "កញ្ឆា" },
    { "id": 90, "word": "កញ្ឆាត់" },
    { "id": 91, "word": "កញ្ឆិត" },
    { "id": 92, "word": "កញ្ឆិល" },
    { "id": 93, "word": "កញ្ឆឹម" },
    { "id": 94, "word": "កញ្ឆួង" },
    { "id": 95, "word": "កញ្ឆើញ" },
    { "id": 96, "word": "កញ្ឆៀវ" },
    { "id": 97, "word": "កញ្ឆេង" },
    { "id": 98, "word": "កញ្ឆែត" },
    { "id": 99, "word": "កញ្ឆែវ" },
    { "id": 100, "word": "កញ្ឆោត" },
    { "id": 101, "word": "កញ្ជង់" },
    { "id": 102, "word": "កញ្ជនជៃ" },
    { "id": 103, "word": "កញ្ជប់" },
    { "id": 104, "word": "កញ្ជរ" },
    { "id": 105, "word": "កញ្ជាក់" },
    { "id": 106, "word": "កញ្ជាក់ស្លា" },
    { "id": 107, "word": "កញ្ជាត" },
    { "id": 108, "word": "កញ្ជុសមាន់" },
    { "id": 109, "word": "កញ្ជួ" },
    { "id": 110, "word": "កញ្ជើ" },
    { "id": 111, "word": "កញ្ជើជំពោះ" },
    { "id": 112, "word": "កញ្ជើបាយដាច" },
    { "id": 113, "word": "កញ្ជែះ" },
    { "id": 114, "word": "កញ្ជះ" },
    { "id": 115, "word": "កញ្ជះកញ្ជាយ" },
    { "id": 116, "word": "កញ្ជ្រក់" },
    { "id": 117, "word": "កញ្ជ្រម" },
    { "id": 118, "word": "កញ្ជ្រឹល" },
    { "id": 119, "word": "កញ្ជ្រូក" },
    { "id": 120, "word": "កញ្ជ្រៀច" },
    { "id": 121, "word": "កញ្ជ្រៀប" },
    { "id": 122, "word": "កញ្ជ្រៀវ" },
    { "id": 123, "word": "កញ្ជ្រោក" },
    { "id": 124, "word": "កញ្ជ្រោកបោកបាច" },
    { "id": 125, "word": "កញ្ជ្រោង" },
    { "id": 126, "word": "កញ្ជ្រោល" },
    { "id": 127, "word": "កញ្ឈូស" },
    { "id": 128, "word": "កញ្ញា" },
    { "id": 129, "word": "កញ្ញាកិត្តិយស" },
    { "id": 130, "word": "កដប" },
    { "id": 131, "word": "កដ្ឋគ្គិ" },
    { "id": 132, "word": "កឋិន" },
    { "id": 133, "word": "កណិការ" },
    { "id": 134, "word": "កណ្ដក់" },
    { "id": 135, "word": "កណ្ដក់សញ្ញា" },
    { "id": 136, "word": "កណ្ដប" },
    { "id": 137, "word": "កណ្ដាច" },
    { "id": 138, "word": "កណ្ដាច់" },
    { "id": 139, "word": "កណ្ដាញ់" },
    { "id": 140, "word": "កណ្ដាប់" },
    { "id": 141, "word": "កណ្ដាប់ចង្អេរ" },
    { "id": 142, "word": "កណ្ដាប់ដៃ" },
    { "id": 143, "word": "កណ្ដារ" },
    { "id": 144, "word": "កណ្ដាល" },
    { "id": 145, "word": "កណ្ដាលស្ទឹង" },
    { "id": 146, "word": "កណ្ដាស់" },
    { "id": 147, "word": "កណ្ដឹង" },
    { "id": 148, "word": "កណ្ដឹងគោ" },
    { "id": 149, "word": "កណ្ដឹមឆែប!" },
    { "id": 150, "word": "កណ្ដុក" },
    { "id": 151, "word": "កណ្ដុរ" },
    { "id": 152, "word": "កណ្ដូង" },
    { "id": 153, "word": "កណ្ដូប" },
    { "id": 154, "word": "កណ្ដួយ" },
    { "id": 155, "word": "កណ្ដៀខ្មូត" },
    { "id": 156, "word": "កណ្ដៀង" },
    { "id": 157, "word": "កណ្ដៀត" },
    { "id": 158, "word": "កណ្ដៀតក្អម" },
    { "id": 159, "word": "កណ្ដៀទៀ" },
    { "id": 160, "word": "កណ្ដៀន" },
    { "id": 161, "word": "កណ្ដៀរ" },
    { "id": 162, "word": "កណ្ដៀវ" },
    { "id": 163, "word": "កណ្ដេង" },
    { "id": 164, "word": "កណ្ដែងកណ្ដោច" },
    { "id": 165, "word": "កណ្ដោច" },
    { "id": 166, "word": "កណ្ដោល" },
    { "id": 167, "word": "កណ្ដោលបាត" },
    { "id": 168, "word": "កណ្ឌ" },
    { "id": 169, "word": "កណ្ហាជិនា" },
    { "id": 170, "word": "កត់" },
    { "id": 171, "word": "កតញ្ញុតា" },
    { "id": 172, "word": "កតញ្ញូ" },
    { "id": 173, "word": "កតវេទិតា" },
    { "id": 174, "word": "កតវេទី" },
    { "id": 175, "word": "កតិកា" },
    { "id": 176, "word": "កតូបការៈ" },
    { "id": 177, "word": "កត្តា" },
    { "id": 178, "word": "កត្តិក" },
    { "id": 179, "word": "កត្តុវាចក" },
    { "id": 180, "word": "កថា" },
    { "id": 181, "word": "កថិន" },
    { "id": 182, "word": "កន" },
    { "id": 183, "word": "កនិដ្ឋា" },
    { "id": 184, "word": "កន្តរ៉" },
    { "id": 185, "word": "កន្ដាញ" },
    { "id": 186, "word": "កន្ដារ" },
    { "id": 187, "word": "កន្តាវរ៉ាវ" },
    { "id": 188, "word": "កន្តិញកន្តុញ" },
    { "id": 189, "word": "កន្តិល" },
    { "id": 190, "word": "កន្តឹប" },
    { "id": 191, "word": "កន្តឹម" },
    { "id": 192, "word": "កន្តុញ" },
    { "id": 193, "word": "កន្តុប" },
    { "id": 194, "word": "កន្តុល" },
    { "id": 195, "word": "កន្ដុលឪ" },
    { "id": 196, "word": "កន្តូ" },
    { "id": 197, "word": "កន្តូឡេត" },
    { "id": 198, "word": "កន្តើយ" },
    { "id": 199, "word": "កន្តេះឡង់" },
    { "id": 200, "word": "កន្តែរ៉ែ" },
    { "id": 201, "word": "កន្តាំង" },
    { "id": 202, "word": "កន្ត្រ" },
    { "id": 203, "word": "កន្ត្រង" },
    { "id": 204, "word": "កន្ត្រងប្រេង" },
    { "id": 205, "word": "កន្ត្រប់" },
    { "id": 206, "word": "កន្ត្រាក" },
    { "id": 207, "word": "កន្ត្រាក់" },
    { "id": 208, "word": "កន្ត្រើយ" },
    { "id": 209, "word": "កន្ត្រេកកន្ត្រាក" },
    { "id": 210, "word": "កន្ត្រែង" },
    { "id": 211, "word": "កន្ត្រៃ" },
    { "id": 212, "word": "កន្ដ្រោង" },
    { "id": 213, "word": "កន្ត្រោន" },
    { "id": 214, "word": "កន្ថឹក" },
    { "id": 215, "word": "កន្ថោរ" },
    { "id": 216, "word": "កន្ទក់" },
    { "id": 217, "word": "កន្ទក់កន្ទេញ" },
    { "id": 218, "word": "កន្ទក់អង្កាន់" },
    { "id": 219, "word": "កន្ទនជៃ" },
    { "id": 220, "word": "កន្ទន់បាក់ក" },
    { "id": 221, "word": "កន្ទប" },
    { "id": 222, "word": "កន្ទាទូក" },
    { "id": 223, "word": "កន្ទាលត្រអាក" },
    { "id": 224, "word": "កន្ទី" },
    { "id": 225, "word": "កន្ទីងរីង" },
    { "id": 226, "word": "កន្ទឹស" },
    { "id": 227, "word": "កន្ទុយ" },
    { "id": 228, "word": "កន្ទុយក្រពើ" },
    { "id": 229, "word": "កន្ទុយចចក" },
    { "id": 230, "word": "កន្ទុយឆ្កែ" },
    { "id": 231, "word": "កន្ទុយដំរី" },
    { "id": 232, "word": "កន្ទុយថ្លែន" },
    { "id": 233, "word": "កន្ទុយលឹន" },
    { "id": 234, "word": "កន្ទុល" },
    { "id": 235, "word": "កន្ទូតអូង" },
    { "id": 236, "word": "កន្ទួត" },
    { "id": 237, "word": "កន្ទួតប្រោង" },
    { "id": 238, "word": "កន្ទួតព្រៃ" },
    { "id": 239, "word": "កន្ទួល" },
    { "id": 240, "word": "កន្ទើញ" },
    { "id": 241, "word": "កន្ទេចអាល" },
    { "id": 242, "word": "កន្ទេល" },
    { "id": 243, "word": "កន្ទែក" },
    { "id": 244, "word": "កន្ទោក" },
    { "id": 245, "word": "កន្ទោង" },
    { "id": 246, "word": "កន្ទុំរុយ" },
    { "id": 247, "word": "កន្ទាំងបាយស" },
    { "id": 248, "word": "កន្ទាំងហែ" },
    { "id": 249, "word": "កន្ទះរា" },
    { "id": 250, "word": "កន្ទ្រង់" },
    { "id": 251, "word": "កន្ទ្រម" },
    { "id": 252, "word": "កន្ទ្រល" },
    { "id": 253, "word": "កន្ទ្រាញ" },
    { "id": 254, "word": "កន្ទ្រឹស" },
    { "id": 255, "word": "កន្ទ្រុប" },
    { "id": 256, "word": "កន្ទ្រួក" },
    { "id": 257, "word": "កន្ទ្រួប" },
    { "id": 258, "word": "កន្ទ្រើង" },
    { "id": 259, "word": "កន្ទ្រែត" },
    { "id": 260, "word": "កន្ទ្រោក" },
    { "id": 261, "word": "កន្ទ្រោកដំរី" },
    { "id": 262, "word": "កន្ទ្រុំ" },
    { "id": 263, "word": "កន្ទ្រាំ" },
    { "id": 264, "word": "កន្ធរ" },
    { "id": 265, "word": "កន្ធា" },
    { "id": 266, "word": "កន្ធាញ" },
    { "id": 267, "word": "កន្ធាត់" },
    { "id": 268, "word": "កន្ធាយ" },
    { "id": 269, "word": "កន្ធិងកន្ធាំង" },
    { "id": 270, "word": "កន្ធីង" },
    { "id": 271, "word": "កន្ធឹប" },
    { "id": 272, "word": "កន្ធុក" },
    { "id": 273, "word": "កន្ធុច" },
    { "id": 274, "word": "កន្ធុល" },
    { "id": 275, "word": "កន្ធួក" },
    { "id": 276, "word": "កន្ធែក" },
    { "id": 277, "word": "កន្ធាំង" },
    { "id": 278, "word": "កន្យា" },
    { "id": 279, "word": "កន្លង" },
    { "id": 280, "word": "កន្លងខ្នប់" },
    { "id": 281, "word": "កន្លងភ្នំ" },
    { "id": 282, "word": "កន្លង់" },
    { "id": 283, "word": "កន្លាត" },
    { "id": 284, "word": "កន្លាស់" },
    { "id": 285, "word": "កន្លុក" },
    { "id": 286, "word": "កន្លុះ" },
    { "id": 287, "word": "កន្លើត" },
    { "id": 288, "word": "កន្លើតចក" },
    { "id": 289, "word": "កន្លៀត" },
    { "id": 290, "word": "កន្លេង" },
    { "id": 291, "word": "កន្លែង" },
    { "id": 292, "word": "កន្លោង" },
    { "id": 293, "word": "កន្លះ" },
    { "id": 294, "word": "កន្សែង" },
    { "id": 295, "word": "កន្សៃ" },
    { "id": 296, "word": "កន្សៃសារពេជ្ញ" },
    { "id": 297, "word": "កន្សោម" },
    { "id": 298, "word": "កន្សោមតាឱ" },
    { "id": 299, "word": "កន្សុំ" },
    { "id": 300, "word": "កប" },
    { "id": 301, "word": "កប់" },
    { "id": 302, "word": "កប៉ាល់" },
    { "id": 303, "word": "កបិលវត្ថុ" },
    { "id": 304, "word": "កប្ប" },
    { "id": 305, "word": "កប្បព្រឹក្ស" },
    { "id": 306, "word": "កប្បាស" },
    { "id": 307, "word": "កម" },
    { "id": 308, "word": "កមល" },
    { "id": 309, "word": "កម្ចាត់" },
    { "id": 310, "word": "កម្ចាយ" },
    { "id": 311, "word": "កម្ចី" },
    { "id": 312, "word": "កម្ជាប់" },
    { "id": 313, "word": "កម្ជិល" },
    { "id": 314, "word": "កម្ជេញ" },
    { "id": 315, "word": "កម្ញី" },
    { "id": 316, "word": "កម្ដៅ" },
    { "id": 317, "word": "កម្ទរ" },
    { "id": 318, "word": "កម្ទារ" },
    { "id": 319, "word": "កម្ទេច" },
    { "id": 320, "word": "កម្បង់" },
    { "id": 321, "word": "កម្ពល" },
    { "id": 322, "word": "កម្ពស់" },
    { "id": 323, "word": "កម្ពុ" },
    { "id": 324, "word": "កម្ពុជ" },
    { "id": 326, "word": "កម្ពោជ" },
    { "id": 327, "word": "កម្ពោជិក" },
    { "id": 328, "word": "កម្ម" },
    { "id": 329, "word": "កម្ម--" },
    { "id": 330, "word": "កម្មិកសមាជិក" },
    { "id": 331, "word": "កម្រ" },
    { "id": 332, "word": "កម្រង" },
    { "id": 333, "word": "កម្រាប" },
    { "id": 334, "word": "កម្រាល" },
    { "id": 335, "word": "កម្រាស់" },
    { "id": 336, "word": "កម្រិត" },
    { "id": 337, "word": "កម្រើក" },
    { "id": 338, "word": "កម្រៀម" },
    { "id": 339, "word": "កម្រៀមកម្រោះ" },
    { "id": 340, "word": "កម្រៀវ" },
    { "id": 341, "word": "កម្រៃ" },
    { "id": 342, "word": "កម្លា" },
    { "id": 343, "word": "កម្លាច" },
    { "id": 344, "word": "កម្លោច" },
    { "id": 345, "word": "កម្លៅ" },
    { "id": 346, "word": "កម្លាំង" },
    { "id": 347, "word": "កម្សត់" },
    { "id": 348, "word": "កម្សត់កម្រ" },
    { "id": 349, "word": "កម្សាន្ត" },
    { "id": 350, "word": "កម្សួល" },
    { "id": 351, "word": "កម្សោយ" },
    { "id": 352, "word": "កម្អួត" },
    { "id": 353, "word": "កម្អែល" },
    { "id": 354, "word": "កក៌ដ" },
    { "id": 355, "word": "កប៌ូរ" },
    { "id": 356, "word": "ករ" },
    { "id": 357, "word": "ករជកាយ" },
    { "id": 358, "word": "ករណនាម" },
    { "id": 359, "word": "ករណី" },
    { "id": 360, "word": "ករណីយកិច្ច" },
    { "id": 361, "word": "ករវិក" },
    { "id": 362, "word": "ករី" },
    { "id": 363, "word": "ករុណា" },
    { "id": 364, "word": "ករុណាវិសេស" },
    { "id": 365, "word": "កល" },
    { "id": 366, "word": "កល់" },
    { "id": 367, "word": "កល់កែ" },
    { "id": 368, "word": "កលហៈ" },
    { "id": 369, "word": "កលហប្បវឌ្ឍនី" },
    { "id": 370, "word": "កលហពិរោធ" },
    { "id": 371, "word": "កលិយុគ" },
    { "id": 372, "word": "កលោបាយ" },
    { "id": 373, "word": "កល្ប" },
    { "id": 374, "word": "កល្បព្រឹក្ស" },
    { "id": 375, "word": "កល្បសព្ទ" },
    { "id": 376, "word": "កល្យាណ" },
    { "id": 377, "word": "កល្យាណី" },
    { "id": 378, "word": "កវី" },
    { "id": 379, "word": "កវីនិពន្ធ" },
    { "id": 380, "word": "កវីនិពន្ធន៍" },
    { "id": 381, "word": "កសិកម្ម" },
    { "id": 382, "word": "កសិករ" },
    { "id": 383, "word": "កសិការ" },
    { "id": 384, "word": "កសិណ" },
    { "id": 385, "word": "កស្យាជីវកម្ម" },
    { "id": 386, "word": "កហាបណៈ" },
    { "id": 387, "word": "កឡោបិ៍" },
    { "id": 388, "word": "កា" },
    { "id": 389, "word": "កាក" },
    { "id": 390, "word": "កាកគតិ" },
    { "id": 391, "word": "កាកណិក" },
    { "id": 392, "word": "កាកនាសូរ" },
    { "id": 393, "word": "កាកបាទ" },
    { "id": 394, "word": "កាក់" },
    { "id": 395, "word": "កាក់ៗ" },
    { "id": 396, "word": "កាកី" },
    { "id": 397, "word": "កាខែកកាខោក" },
    { "id": 398, "word": "កាង" },
    { "id": 399, "word": "កាច" },
    { "id": 400, "word": "កាច់" },
    { "id": 401, "word": "កាច់សង្រែក" },
    { "id": 402, "word": "កាញ់" },
    { "id": 403, "word": "កាត" },
    { "id": 404, "word": "កាត់" },
    { "id": 405, "word": "កាត់កាល់" },
    { "id": 406, "word": "កាតព្វកិច្ច" },
    { "id": 407, "word": "កាត់សាំ" },
    { "id": 408, "word": "កាតាក" },
    { "id": 409, "word": "កាតិក" },
    { "id": 410, "word": "កាតឹប" },
    { "id": 411, "word": "កាតៅ" },
    { "id": 412, "word": "កាតំ" },
    { "id": 413, "word": "កាន់" },
    { "id": 414, "word": "កាន់តែ" },
    { "id": 415, "word": "កាប" },
    { "id": 416, "word": "កាបៗ" },
    { "id": 417, "word": "កាប់" },
    { "id": 418, "word": "កាប៊ីណេត៍" },
    { "id": 419, "word": "កាបូប" },
    { "id": 420, "word": "កាពិ" },
    { "id": 421, "word": "កាពិផៅ" },
    { "id": 422, "word": "កាព្យ" },
    { "id": 423, "word": "កាម" },
    { "id": 424, "word": "កាម--" },
    { "id": 425, "word": "កាយ" },
    { "id": 426, "word": "កាយ--" },
    { "id": 427, "word": "កាណ៌" },
    { "id": 428, "word": "កាប៌ាស" },
    { "id": 429, "word": "ការ" },
    { "id": 430, "word": "ការកនាម" },
    { "id": 431, "word": "ការកេត" },
    { "id": 432, "word": "ការងារ" },
    { "id": 433, "word": "ការដ្ឋាន" },
    { "id": 434, "word": "ការណ៍" },
    { "id": 435, "word": "ការន្ត" },
    { "id": 436, "word": "ការពារ" },
    { "id": 437, "word": "ការាត់" },
    { "id": 438, "word": "ការិយកម្ម" },
    { "id": 439, "word": "ការិយបរិច្ឆេទ" },
    { "id": 440, "word": "ការិយាល័យ" },
    { "id": 441, "word": "ការី" },
    { "id": 442, "word": "ការី" },
    { "id": 443, "word": "ការុង" },
    { "id": 444, "word": "ការុញ្ញចិត្ត" },
    { "id": 445, "word": "ការុញ្ញភាព" },
    { "id": 446, "word": "ការុណិក" },
    { "id": 447, "word": "កាល" },
    { "id": 448, "word": "កាលកិរិយា" },
    { "id": 449, "word": "កាលៈទេសៈ" },
    { "id": 450, "word": "កាល់" },
    { "id": 451, "word": "កាលិក" },
    { "id": 452, "word": "កាលិកបត្រ" },
    { "id": 453, "word": "កាវ" },
    { "id": 454, "word": "កាស" },
    { "id": 455, "word": "កាសអង្ករ" },
    { "id": 456, "word": "កាសាវពស្ត្រ" },
    { "id": 457, "word": "កាសែត" },
    { "id": 458, "word": "កាហាត" },
    { "id": 459, "word": "កាហែ" },
    { "id": 460, "word": "កាហោ" },
    { "id": 461, "word": "កាឡកណ្ណី" },
    { "id": 462, "word": "កាឡកិណី" },
    { "id": 463, "word": "កាឡា" },
    { "id": 464, "word": "កាឡាប៉ា" },
    { "id": 465, "word": "កាឡី" },
    { "id": 466, "word": "កាឡៃ" },
    { "id": 467, "word": "កិកិ" },
    { "id": 468, "word": "កិកកុក" },
    { "id": 469, "word": "កិង" },
    { "id": 470, "word": "កិច្ច" },
    { "id": 471, "word": "កិត" },
    { "id": 472, "word": "កិតនាម" },
    { "id": 473, "word": "កិតអាចម៍" },
    { "id": 474, "word": "កិត្តិ" },
    { "id": 475, "word": "កិត្តិគុណ" },
    { "id": 476, "word": "កិត្តិនាម" },
    { "id": 477, "word": "កិត្តិយស" },
    { "id": 478, "word": "កិត្តិសព្ទ" },
    { "id": 479, "word": "កិត្យានុភាព" },
    { "id": 480, "word": "កិន" },
    { "id": 481, "word": "កិន្នរ" },
    { "id": 482, "word": "កិប" },
    { "id": 483, "word": "កិមិជាតិ" },
    { "id": 484, "word": "កិរ្តិ៍" },
    { "id": 485, "word": "កិរ្តិសព្ទ" },
    { "id": 486, "word": "កិរិយា" },
    { "id": 487, "word": "កិរិយាវិសេសន៍" },
    { "id": 488, "word": "កិរិយាសព្ទ" },
    { "id": 489, "word": "កិល" },
    { "id": 490, "word": "កិលេស" },
    { "id": 491, "word": "កី" },
    { "id": 492, "word": "កីលែន" },
    { "id": 493, "word": "កីឡដ្ឋាន" },
    { "id": 494, "word": "កីឡា" },
    { "id": 495, "word": "កីឡាមណ្ឌល" },
    { "id": 496, "word": "កីឡាអត្តពលកម្ម" },
    { "id": 497, "word": "កឹងកន្ត្រៃ" },
    { "id": 498, "word": "កឹះ" },
    { "id": 499, "word": "កុក" },
    { "id": 500, "word": "កុក្កុដនេត្រ" },
    { "id": 501, "word": "កុង" },
    { "id": 502, "word": "កុងកាប់" },
    { "id": 503, "word": "កុងផាត់" },
    { "id": 504, "word": "កុង្សីយ៍" },
    { "id": 505, "word": "កុង្សីយ៍សេនាបតី" },
    { "id": 506, "word": "កុងស៊ី" },
    { "id": 507, "word": "កុងស៊ុល" },
    { "id": 508, "word": "កុញ" },
    { "id": 509, "word": "កុញ្ជរ" },
    { "id": 510, "word": "កុញ្ជរាធិបតី" },
    { "id": 511, "word": "កុដិ" },
    { "id": 512, "word": "កុដិកភត្ត" },
    { "id": 513, "word": "កុដុម្ពិកៈ" },
    { "id": 514, "word": "កុណ្ឌក" },
    { "id": 515, "word": "កុណ្ឌល" },
    { "id": 516, "word": "កុណ្ឌី" },
    { "id": 517, "word": "កុទិដ្ឋិ" },
    { "id": 518, "word": "កុន" },
    { "id": 519, "word": "កុប" },
    { "id": 520, "word": "កុបកម្ម" },
    { "id": 521, "word": "កុបករ" },
    { "id": 522, "word": "កុមារ" },
    { "id": 523, "word": "កុមារដ្ឋាន" },
    { "id": 524, "word": "កុមារភាព" },
    { "id": 525, "word": "កុមារសង្គ្រោះ" },
    { "id": 526, "word": "កុមារានុគ្រោះ" },
    { "id": 527, "word": "កុមារី" },
    { "id": 528, "word": "កុមុទ" },
    { "id": 529, "word": "កុម្ភៈ" },
    { "id": 530, "word": "កុម្ភការ" },
    { "id": 531, "word": "កុម្ភការដ្ឋាន" },
    { "id": 532, "word": "កុម្ភណ្ឌ" },
    { "id": 533, "word": "កុយ" },
    { "id": 534, "word": "កុរ" },
    { "id": 535, "word": "កុលធីតា" },
    { "id": 536, "word": "កុលបលិពោធ" },
    { "id": 537, "word": "កុលបុត្រ" },
    { "id": 538, "word": "កុលពិរោធ" },
    { "id": 539, "word": "កុលមច្ឆរិយៈ" },
    { "id": 540, "word": "កុលវគ្គ" },
    { "id": 541, "word": "កុលវិបត្តិ" },
    { "id": 542, "word": "កុលសម្បត្តិ" },
    { "id": 543, "word": "កុលសម្ព័ន្ធ" },
    { "id": 544, "word": "កុលវំសៈ" },
    { "id": 545, "word": "កុលាប" },
    { "id": 546, "word": "កុលាលភាជន៍" },
    { "id": 547, "word": "កុសល" },
    { "id": 548, "word": "កុសលោបាយ" },
    { "id": 549, "word": "កុសិនារា" },
    { "id": 550, "word": "កុសីតបុគ្គល" },
    { "id": 551, "word": "កុសុម" },
    { "id": 552, "word": "កុហក" },
    { "id": 553, "word": "កុះ" },
    { "id": 554, "word": "កុះករ" },
    { "id": 555, "word": "កុឡា" },
    { "id": 556, "word": "កូ៎ក!" },
    { "id": 557, "word": "កូ៎កៗ" },
    { "id": 558, "word": "កូដកម្ម" },
    { "id": 559, "word": "កូដោបាយ" },
    { "id": 560, "word": "កូត" },
    { "id": 561, "word": "កូន" },
    { "id": 562, "word": "កូនកណ្ដុរ" },
    { "id": 563, "word": "កូនកំព្រា" },
    { "id": 564, "word": "កូនក្រាញ់" },
    { "id": 565, "word": "កូនគោល" },
    { "id": 566, "word": "កូនគ្លី" },
    { "id": 567, "word": "កូនចាប" },
    { "id": 568, "word": "កូនជញ្ជីង" },
    { "id": 569, "word": "កូនតឹង" },
    { "id": 570, "word": "កូនទោល" },
    { "id": 571, "word": "កូនប្រយោល" },
    { "id": 572, "word": "កូនលង" },
    { "id": 573, "word": "កូនលោក" },
    { "id": 574, "word": "កូនសង្កត់" },
    { "id": 575, "word": "កូនសរ" },
    { "id": 576, "word": "កូនស្ងើន" },
    { "id": 577, "word": "កូប" },
    { "id": 578, "word": "កូបៗ" },
    { "id": 579, "word": "កូរ" },
    { "id": 580, "word": "កូវ" },
    { "id": 581, "word": "កូវកែ" },
    { "id": 582, "word": "កួច" },
    { "id": 583, "word": "កួត" },
    { "id": 584, "word": "កួន" },
    { "id": 585, "word": "កួយ" },
    { "id": 586, "word": "កួរ" },
    { "id": 587, "word": "កើ" },
    { "id": 588, "word": "កើង" },
    { "id": 589, "word": "កើច" },
    { "id": 590, "word": "កើត" },
    { "id": 591, "word": "កើតក្ដី" },
    { "id": 592, "word": "កើន" },
    { "id": 593, "word": "កើប" },
    { "id": 594, "word": "កើយ" },
    { "id": 595, "word": "កើល" },
    { "id": 596, "word": "កើលប្រើស" },
    { "id": 597, "word": "កឿង" },
    { "id": 598, "word": "កៀក" },
    { "id": 599, "word": "កៀង" },
    { "id": 600, "word": "កៀច" },
    { "id": 601, "word": "កៀត" },
    { "id": 602, "word": "កៀន" },
    { "id": 603, "word": "កៀនស្វាយ" },
    { "id": 604, "word": "កៀប" },
    { "id": 605, "word": "កៀរ" },
    { "id": 606, "word": "កៀរគរ" },
    { "id": 607, "word": "កៀវ" },
    { "id": 608, "word": "កៀស" },
    { "id": 609, "word": "កេកៗ" },
    { "id": 610, "word": "កេង" },
    { "id": 611, "word": "កេងកង" },
    { "id": 612, "word": "កេងកាង" },
    { "id": 613, "word": "កេណ្ឌ" },
    { "id": 614, "word": "កេតនភណ្ឌ" },
    { "id": 615, "word": "កេតុ" },
    { "id": 616, "word": "កេតុមាលា" },
    { "id": 617, "word": "កេរ" },
    { "id": 618, "word": "កេរកាល" },
    { "id": 619, "word": "កេរ្តិ៍" },
    { "id": 620, "word": "កេរាដិកជន" },
    { "id": 621, "word": "កេល" },
    { "id": 622, "word": "កេវ" },
    { "id": 623, "word": "កេស" },
    { "id": 624, "word": "កេសរ" },
    { "id": 625, "word": "កេសរសីហៈ" },
    { "id": 626, "word": "កេះ" },
    { "id": 627, "word": "កែ" },
    { "id": 628, "word": "កែក" },
    { "id": 629, "word": "កែក្រាយ" },
    { "id": 630, "word": "កែខៃ" },
    { "id": 631, "word": "កែង" },
    { "id": 632, "word": "កែងកោង" },
    { "id": 633, "word": "កែន" },
    { "id": 634, "word": "កែប" },
    { "id": 635, "word": "កែម" },
    { "id": 636, "word": "កែវ" },
    { "id": 637, "word": "កែស" },
    { "id": 638, "word": "កែអួក" },
    { "id": 639, "word": "កែះ" },
    { "id": 640, "word": "កៃ" },
    { "id": 641, "word": "កៃលាស" },
    { "id": 642, "word": "កោកៗ" },
    { "id": 643, "word": "កោង" },
    { "id": 644, "word": "កោញ្ចនាទ" },
    { "id": 645, "word": "កោដិ" },
    { "id": 646, "word": "កោដ្ឋ" },
    { "id": 647, "word": "កោណ" },
    { "id": 648, "word": "កោត" },
    { "id": 649, "word": "កោន" },
    { "id": 650, "word": "កោប" },
    { "id": 651, "word": "កោមល" },
    { "id": 652, "word": "កោយ" },
    { "id": 653, "word": "កោរ" },
    { "id": 654, "word": "កោលាហល" },
    { "id": 655, "word": "កោស" },
    { "id": 656, "word": "កោសរូស" },
    { "id": 657, "word": "កោសល្ល" },
    { "id": 658, "word": "កោសិយ" },
    { "id": 659, "word": "កោសុម" },
    { "id": 660, "word": "កោសេយ្យ" },
    { "id": 661, "word": "កោសេយ្យពស្ដ្រ" },
    { "id": 662, "word": "កោសេយ្យវប្បកម្ម" },
    { "id": 663, "word": "កោសេយ្យវប្បករ" },
    { "id": 664, "word": "កោះ" },
    { "id": 665, "word": "កោះកុង" },
    { "id": 666, "word": "កោះធំ" },
    { "id": 667, "word": "កោះសូទិន" },
    { "id": 668, "word": "កោះអណ្ដែត" },
    { "id": 669, "word": "កៅទណ្ឌ" },
    { "id": 670, "word": "កៅយក់" },
    { "id": 671, "word": "កៅសិប" },
    { "id": 672, "word": "កៅស៊ូ" },
    { "id": 673, "word": "កៅហាយ" },
    { "id": 674, "word": "កៅឡាក់" },
    { "id": 675, "word": "កៅឡៅ" },
    { "id": 676, "word": "កៅអី" },
    { "id": 677, "word": "កៅអូវ" },
    { "id": 678, "word": "កុំ" },
    { "id": 679, "word": "កំចាយ" },
    { "id": 680, "word": "កំចាយមារ" },
    { "id": 681, "word": "កំចោក" },
    { "id": 682, "word": "កំចោករោក" },
    { "id": 683, "word": "កំញម" },
    { "id": 684, "word": "កំញាន" },
    { "id": 685, "word": "កំញើញ" },
    { "id": 686, "word": "កំដរ" },
    { "id": 687, "word": "កំដឹង" },
    { "id": 688, "word": "កំណក" },
    { "id": 689, "word": "កំណត់" },
    { "id": 690, "word": "កំណត់ហេតុ" },
    { "id": 691, "word": "កំណប់" },
    { "id": 692, "word": "កំណល់" },
    { "id": 693, "word": "កំណារ" },
    { "id": 694, "word": "កំណាច" },
    { "id": 695, "word": "កំណាច់" },
    { "id": 696, "word": "កំណាញ់" },
    { "id": 697, "word": "កំណាត់" },
    { "id": 698, "word": "កំណាន់" },
    { "id": 699, "word": "កំណាព្យ" },
    { "id": 700, "word": "កំណិន" },
    { "id": 701, "word": "កំណួច" },
    { "id": 702, "word": "កំណើត" },
    { "id": 703, "word": "កំណើន" },
    { "id": 704, "word": "កំណើល" },
    { "id": 705, "word": "កំណៀង" },
    { "id": 706, "word": "កំណៀច" },
    { "id": 707, "word": "កំណៀរ" },
    { "id": 708, "word": "កំណៀវ" },
    { "id": 709, "word": "កំណៀស" },
    { "id": 710, "word": "កំណេះ" },
    { "id": 711, "word": "កំណែ" },
    { "id": 712, "word": "កំណែន" },
    { "id": 713, "word": "កំណោង" },
    { "id": 714, "word": "កំណោត" },
    { "id": 715, "word": "កំណោន" },
    { "id": 716, "word": "កំណោរ" },
    { "id": 717, "word": "កំណោស" },
    { "id": 718, "word": "កំណោះ" },
    { "id": 719, "word": "កំនួច" },
    { "id": 720, "word": "កំនៀរ" },
    { "id": 721, "word": "កំបាក់" },
    { "id": 722, "word": "កំបាប" },
    { "id": 723, "word": "កំបុត" },
    { "id": 724, "word": "កំបុតច្រមុះ" },
    { "id": 725, "word": "កំបុតត្បូង" },
    { "id": 726, "word": "កំបូវ" },
    { "id": 727, "word": "កំបែក" },
    { "id": 728, "word": "កំបោរ" },
    { "id": 729, "word": "កំបាំង" },
    { "id": 730, "word": "កំប៉ុង" },
    { "id": 731, "word": "កំប៉ាង" },
    { "id": 732, "word": "កំប៉ាត" },
    { "id": 733, "word": "កំប៉ិកកំប៉ុក" },
    { "id": 734, "word": "កំប៉ឺត" },
    { "id": 735, "word": "កំប៉ុក" },
    { "id": 736, "word": "កំប៉ុល" },
    { "id": 737, "word": "កំប៉ូត" },
    { "id": 738, "word": "កំប៉ើញ" },
    { "id": 739, "word": "កំប៉េង" },
    { "id": 740, "word": "កំប៉េវអារ៉េវ" },
    { "id": 741, "word": "កំប៉េះ" },
    { "id": 742, "word": "កំប៉ែត" },
    { "id": 743, "word": "កំប៉ោង" },
    { "id": 744, "word": "កំប៉ោយ" },
    { "id": 745, "word": "កំប្រុក" },
    { "id": 746, "word": "កំប្រេវ" },
    { "id": 747, "word": "កំប្រោង" },
    { "id": 748, "word": "កំប្រោន" },
    { "id": 749, "word": "កំប្លង់" },
    { "id": 750, "word": "កំប្លុក" },
    { "id": 751, "word": "កំប្លូច" },
    { "id": 752, "word": "កំប្លែង" },
    { "id": 753, "word": "កំប្លោក" },
    { "id": 754, "word": "កំផិត" },
    { "id": 755, "word": "កំផែង" },
    { "id": 756, "word": "កំផែល" },
    { "id": 757, "word": "កំផ្លឹម" },
    { "id": 758, "word": "កំផ្លៀង" },
    { "id": 759, "word": "កំផ្លៀវ" },
    { "id": 760, "word": "កំផ្លេស" },
    { "id": 761, "word": "កំពក" },
    { "id": 762, "word": "កំពង់" },
    { "id": 763, "word": "កំពត" },
    { "id": 764, "word": "កំពប់" },
    { "id": 765, "word": "កំពយ" },
    { "id": 766, "word": "កំពាង" },
    { "id": 767, "word": "កំពាញ" },
    { "id": 768, "word": "កំពាយ" },
    { "id": 769, "word": "កំពីកកំពក" },
    { "id": 770, "word": "កំពីង" },
    { "id": 771, "word": "កំពីងដូង" },
    { "id": 772, "word": "កំពីងពួយ" },
    { "id": 773, "word": "កំពឹស" },
    { "id": 774, "word": "កំពុក" },
    { "id": 775, "word": "កំពុង" },
    { "id": 776, "word": "កំពូក" },
    { "id": 777, "word": "កំពូជ" },
    { "id": 778, "word": "កំពូល" },
    { "id": 779, "word": "កំពួរ" },
    { "id": 780, "word": "កំពើង" },
    { "id": 781, "word": "កំពៀច" },
    { "id": 782, "word": "កំពែង" },
    { "id": 783, "word": "កំពោង" },
    { "id": 784, "word": "កំព្រយ" },
    { "id": 785, "word": "កំព្រា" },
    { "id": 786, "word": "កំព្រឹង" },
    { "id": 787, "word": "កំព្រឹស" },
    { "id": 788, "word": "កំព្រើល" },
    { "id": 789, "word": "កំភរ" },
    { "id": 790, "word": "កំភូត" },
    { "id": 791, "word": "កំភួន" },
    { "id": 792, "word": "កំភួនជើង" },
    { "id": 793, "word": "កំភួនដៃ" },
    { "id": 794, "word": "កំភេម" },
    { "id": 795, "word": "កំភែល" },
    { "id": 796, "word": "កំភ្លាញ" },
    { "id": 797, "word": "កំភ្លឹង" },
    { "id": 798, "word": "កំរើប" },
    { "id": 799, "word": "កំរោល" },
    { "id": 800, "word": "កំលុង" },
    { "id": 801, "word": "កំលោះ" },
    { "id": 802, "word": "កំសាក" },
    { "id": 803, "word": "កំសាកញី" },
    { "id": 804, "word": "កំសួល" },
    { "id": 805, "word": "កំសៀវ" },
    { "id": 806, "word": "កំហល់" },
    { "id": 807, "word": "កំហាក" },
    { "id": 808, "word": "កំហាត" },
    { "id": 809, "word": "កំហិត" },
    { "id": 810, "word": "កំហិល" },
    { "id": 811, "word": "កំហឹង" },
    { "id": 812, "word": "កំហុល" },
    { "id": 813, "word": "កំហុស" },
    { "id": 814, "word": "កំហូច" },
    { "id": 815, "word": "កំហើច" },
    { "id": 816, "word": "កំហែង" },
    { "id": 817, "word": "កំហោក" },
    { "id": 818, "word": "កំអួក" },
    { "id": 819, "word": "កាំ" },
    { "id": 820, "word": "កាំជ្រួច" },
    { "id": 821, "word": "កាំបិត" },
    { "id": 822, "word": "កាំប្រមា" },
    { "id": 823, "word": "កាំភ្លោះ" },
    { "id": 824, "word": "កាំភ្លើង" },
    { "id": 825, "word": "កាំម្រឹត" },
    { "id": 826, "word": "កាំរន្ទះ" },
    { "id": 827, "word": "ក្ង" },
    { "id": 828, "word": "ក្ងក់" },
    { "id": 829, "word": "ក្ងង់" },
    { "id": 830, "word": "ក្ងាន" },
    { "id": 831, "word": "ក្ងិងក្ងង់" },
    { "id": 832, "word": "ក្ងិច" },
    { "id": 833, "word": "ក្ងិចក្ងក់" },
    { "id": 834, "word": "ក្ងិត" },
    { "id": 835, "word": "ក្ងុក" },
    { "id": 836, "word": "ក្ងុង" },
    { "id": 837, "word": "ក្ងុល" },
    { "id": 838, "word": "ក្ងុះ" },
    { "id": 839, "word": "ក្ងួរ" },
    { "id": 840, "word": "ក្ងៀក" },
    { "id": 841, "word": "ក្ងៀង" },
    { "id": 842, "word": "ក្ងេះ" },
    { "id": 843, "word": "ក្ងែង" },
    { "id": 844, "word": "ក្ងោក" },
    { "id": 845, "word": "ក្ដ" },
    { "id": 846, "word": "ក្ដក់" },
    { "id": 847, "word": "ក្ដន់" },
    { "id": 848, "word": "ក្ដាត" },
    { "id": 849, "word": "ក្ដាត់" },
    { "id": 850, "word": "ក្ដាន់" },
    { "id": 851, "word": "ក្ដាប់" },
    { "id": 852, "word": "ក្ដាម" },
    { "id": 853, "word": "ក្ដាមទូក" },
    { "id": 854, "word": "ក្ដារ" },
    { "id": 855, "word": "ក្ដារខៀន" },
    { "id": 856, "word": "ក្ដារឆ្នួន" },
    { "id": 857, "word": "ក្ដិច" },
    { "id": 858, "word": "ក្ដិត" },
    { "id": 859, "word": "ក្ដី" },
    { "id": 860, "word": "ក្ដីក្ដាំ" },
    { "id": 861, "word": "ក្ដីណា" },
    { "id": 862, "word": "ក្ដឹប" },
    { "id": 863, "word": "ក្ដឹះ" },
    { "id": 864, "word": "ក្ដុក" },
    { "id": 865, "word": "ក្ដុកៗ" },
    { "id": 866, "word": "ក្ដុង" },
    { "id": 867, "word": "ក្ដុងក្ដាំង" },
    { "id": 868, "word": "ក្ដុល" },
    { "id": 869, "word": "ក្ដូនចេស" },
    { "id": 870, "word": "ក្ដួច" },
    { "id": 871, "word": "ក្ដួល" },
    { "id": 872, "word": "ក្ដឿង" },
    { "id": 873, "word": "ក្ដៀន" },
    { "id": 874, "word": "ក្ដៀប" },
    { "id": 875, "word": "ក្ដែងៗ" },
    { "id": 876, "word": "ក្ដោង" },
    { "id": 877, "word": "ក្ដោប" },
    { "id": 878, "word": "ក្ដៅ" },
    { "id": 879, "word": "ក្ដាំ" },
    { "id": 880, "word": "ក្ដាំង" },
    { "id": 881, "word": "ក្ដាំងងា" },
    { "id": 882, "word": "ក្ឌឺង" },
    { "id": 883, "word": "ក្ឌុក" },
    { "id": 884, "word": "ក្ឌុង" },
    { "id": 885, "word": "ក្ឌុំ" },
    { "id": 886, "word": "ក្ឌាំង" },
    { "id": 887, "word": "ក្ទម្ព" },
    { "id": 888, "word": "ក្ទម្ពទេស" },
    { "id": 889, "word": "ក្នក់" },
    { "id": 890, "word": "ក្នាញ់" },
    { "id": 891, "word": "ក្និកក្នក់" },
    { "id": 892, "word": "ក្និច" },
    { "id": 893, "word": "ក្នុង" },
    { "id": 894, "word": "ក្បក" },
    { "id": 895, "word": "ក្បង់" },
    { "id": 896, "word": "ក្បត់" },
    { "id": 897, "word": "ក្បាន" },
    { "id": 898, "word": "ក្បាប" },
    { "id": 899, "word": "ក្បាយ" },
    { "id": 900, "word": "ក្បាល" },
    { "id": 901, "word": "ក្បាលក្រពើ" },
    { "id": 902, "word": "ក្បាក់" },
    { "id": 903, "word": "ក្បាច់" },
    { "id": 904, "word": "ក្បិត" },
    { "id": 905, "word": "ក្បិតក្បៀត" },
    { "id": 906, "word": "ក្បិន" },
    { "id": 907, "word": "ក្បិល" },
    { "id": 908, "word": "ក្បឺត" },
    { "id": 909, "word": "ក្បុង" },
    { "id": 910, "word": "ក្បុស" },
    { "id": 911, "word": "ក្បូន" },
    { "id": 912, "word": "ក្បូរ" },
    { "id": 913, "word": "ក្បួន" },
    { "id": 914, "word": "ក្បឿង" },
    { "id": 915, "word": "ក្បៀប" },
    { "id": 916, "word": "ក្បៀស" },
    { "id": 917, "word": "ក្បេត" },
    { "id": 918, "word": "ក្បែរ" },
    { "id": 919, "word": "ក្បោះ" },
    { "id": 920, "word": "ក្បោះក្បាយ" },
    { "id": 921, "word": "ក្បំ" },
    { "id": 922, "word": "ក្បាំង" },
    { "id": 923, "word": "ក្មាង" },
    { "id": 924, "word": "ក្មួយ" },
    { "id": 925, "word": "ក្មេក" },
    { "id": 926, "word": "ក្មេង" },
    { "id": 927, "word": "ក្រ" },
    { "id": 928, "word": "ក្រក" },
    { "id": 929, "word": "ក្រកី" },
    { "id": 930, "word": "ក្រកោ" },
    { "id": 931, "word": "ក្រខុប" },
    { "id": 932, "word": "ក្រគរ" },
    { "id": 933, "word": "ក្រង" },
    { "id": 934, "word": "ក្រង់" },
    { "id": 935, "word": "ក្រចក" },
    { "id": 936, "word": "ក្រចកអណ្ដើក" },
    { "id": 937, "word": "ក្រចកចាប" },
    { "id": 938, "word": "ក្រចាស" },
    { "id": 939, "word": "ក្រចាប់" },
    { "id": 940, "word": "ក្រចេះ" },
    { "id": 941, "word": "ក្រចៅ" },
    { "id": 942, "word": "ក្រជីង" },
    { "id": 943, "word": "ក្រជាំ" },
    { "id": 944, "word": "ក្រញង់" },
    { "id": 945, "word": "ក្រញរ" },
    { "id": 946, "word": "ក្រញាង" },
    { "id": 947, "word": "ក្រញាស" },
    { "id": 948, "word": "ក្រញាញ់" },
    { "id": 949, "word": "ក្រញិកក្រញុក" },
    { "id": 950, "word": "ក្រញី" },
    { "id": 951, "word": "ក្រញឹង" },
    { "id": 952, "word": "ក្រញឹប" },
    { "id": 953, "word": "ក្រញឹម" },
    { "id": 954, "word": "ក្រញុច" },
    { "id": 955, "word": "ក្រញុញ" },
    { "id": 956, "word": "ក្រញុល" },
    { "id": 957, "word": "ក្រញុះ" },
    { "id": 958, "word": "ក្រញូវ" },
    { "id": 959, "word": "ក្រញូស" },
    { "id": 960, "word": "ក្រញើត" },
    { "id": 961, "word": "ក្រញេង" },
    { "id": 962, "word": "ក្រញេញ" },
    { "id": 963, "word": "ក្រញេស" },
    { "id": 964, "word": "ក្រញោន" },
    { "id": 965, "word": "ក្រញៅ" },
    { "id": 966, "word": "ក្រញាំ" },
    { "id": 967, "word": "ក្រញាំង" },
    { "id": 968, "word": "ក្រដាស" },
    { "id": 969, "word": "ក្រតៗ" },
    { "id": 970, "word": "ក្រតើន" },
    { "id": 971, "word": "ក្រទា" },
    { "id": 972, "word": "ក្រទី" },
    { "id": 973, "word": "ក្រទីក្រទា" },
    { "id": 974, "word": "ក្រទឺត" },
    { "id": 975, "word": "ក្រទែ" },
    { "id": 976, "word": "ក្រទាំង" },
    { "id": 977, "word": "ក្រនៀវ" },
    { "id": 978, "word": "ក្រនៀវកែវ" },
    { "id": 979, "word": "ក្រប" },
    { "id": 980, "word": "ក្របខ័ណ្ឌ" },
    { "id": 981, "word": "ក្របី" },
    { "id": 982, "word": "ក្របួច" },
    { "id": 983, "word": "ក្របែល" },
    { "id": 984, "word": "ក្របៅ" },
    { "id": 985, "word": "ក្រពក" },
    { "id": 986, "word": "ក្រពង" },
    { "id": 987, "word": "ក្រពត" },
    { "id": 988, "word": "ក្រពា" },
    { "id": 989, "word": "ក្រពាត់" },
    { "id": 990, "word": "ក្រពាត់ជ្រូក" },
    { "id": 991, "word": "ក្រពាត់ដៃ" },
    { "id": 992, "word": "ក្រពឹត" },
    { "id": 993, "word": "ក្រពុល" },
    { "id": 994, "word": "ក្រពុលបាយ" },
    { "id": 995, "word": "ក្រពើ" },
    { "id": 996, "word": "ក្រពេញ" },
    { "id": 997, "word": "ក្រពេន" },
    { "id": 998, "word": "ក្រពុំ" },
    { "id": 999, "word": "ក្រពះ" },
    { "id": 1000, "word": "ក្រម" },
    { "id": 1001, "word": "ក្រមការ" },
    { "id": 1002, "word": "ក្រមប់" },
    { "id": 1003, "word": "ក្រមម" },
    { "id": 1004, "word": "ក្រមរ" },
    { "id": 1005, "word": "ក្រមា" },
    { "id": 1006, "word": "ក្រមាច" },
    { "id": 1007, "word": "ក្រមាច់" },
    { "id": 1008, "word": "ក្រមាល់" },
    { "id": 1009, "word": "ក្រមិចក្រមើម" },
    { "id": 1010, "word": "ក្រមី" },
    { "id": 1011, "word": "ក្រមឹម" },
    { "id": 1012, "word": "ក្រមឺម" },
    { "id": 1013, "word": "ក្រមួន" },
    { "id": 1014, "word": "ក្រមៅ" },
    { "id": 1015, "word": "ក្រមុំ" },
    { "id": 1016, "word": "ក្រមាំ" },
    { "id": 1017, "word": "ក្រយា" },
    { "id": 1018, "word": "ក្រយាតំណាំង" },
    { "id": 1019, "word": "ក្រយាសម្ពាន់" },
    { "id": 1020, "word": "ក្រយាស្ងោយ" },
    { "id": 1021, "word": "ក្រយៅ" },
    { "id": 1022, "word": "ក្រលៀន" },
    { "id": 1023, "word": "ក្រវង់" },
    { "id": 1024, "word": "ក្រវល់ក្រវាយ" },
    { "id": 1025, "word": "ក្រវាញ" },
    { "id": 1026, "word": "ក្រវាញជ្រូក" },
    { "id": 1027, "word": "ក្រវាម" },
    { "id": 1028, "word": "ក្រវាត់" },
    { "id": 1029, "word": "ក្រវាន់" },
    { "id": 1030, "word": "ក្រវិកក្រវក់" },
    { "id": 1031, "word": "ក្រវិន" },
    { "id": 1032, "word": "ក្រវិល" },
    { "id": 1033, "word": "ក្រវឹម" },
    { "id": 1034, "word": "ក្រវើន" },
    { "id": 1035, "word": "ក្រវើនក្រតើន" },
    { "id": 1036, "word": "ក្រវៀច" },
    { "id": 1037, "word": "ក្រវៀន" },
    { "id": 1038, "word": "ក្រវេច" },
    { "id": 1039, "word": "ក្រវេមក្រវាម" },
    { "id": 1040, "word": "ក្រវែល" },
    { "id": 1041, "word": "ក្រស័យ" },
    { "id": 1042, "word": "ក្រសារ" },
    { "id": 1043, "word": "ក្រសាល" },
    { "id": 1044, "word": "ក្រសាវ" },
    { "id": 1045, "word": "ក្រសួង" },
    { "id": 1046, "word": "ក្រសៀន" },
    { "id": 1047, "word": "ក្រសែ" },
    { "id": 1048, "word": "ក្រសោប" },
    { "id": 1049, "word": "ក្រសាំង" },
    { "id": 1050, "word": "ក្រសាំងទាប" },
    { "id": 1051, "word": "ក្រសាំងទំហំ" },
    { "id": 1052, "word": "ក្រស្នា" },
    { "id": 1053, "word": "ក្រហត" },
    { "id": 1054, "word": "ក្រហម" },
    { "id": 1055, "word": "ក្រហល់" },
    { "id": 1056, "word": "ក្រហាយ" },
    { "id": 1057, "word": "ក្រហូង" },
    { "id": 1058, "word": "ក្រហួង" },
    { "id": 1059, "word": "ក្រហួច" },
    { "id": 1060, "word": "ក្រហេង" },
    { "id": 1061, "word": "ក្រហេត" },
    { "id": 1062, "word": "ក្រហែង" },
    { "id": 1063, "word": "ក្រហែត" },
    { "id": 1064, "word": "ក្រឡ" },
    { "id": 1065, "word": "ក្រឡក" },
    { "id": 1066, "word": "ក្រឡង់" },
    { "id": 1067, "word": "ក្រឡា" },
    { "id": 1068, "word": "ក្រឡាច់" },
    { "id": 1069, "word": "ក្រឡាញ" },
    { "id": 1070, "word": "ក្រឡាញ់" },
    { "id": 1071, "word": "ក្រឡាដុងដោរ" },
    { "id": 1072, "word": "ក្រឡាតបៈ" },
    { "id": 1073, "word": "ក្រឡាបញ្ជី" },
    { "id": 1074, "word": "ក្រឡាន" },
    { "id": 1075, "word": "ក្រឡាប់" },
    { "id": 1076, "word": "ក្រឡាពាស" },
    { "id": 1077, "word": "ក្រឡាភ្លើង" },
    { "id": 1078, "word": "ក្រឡាស់" },
    { "id": 1079, "word": "ក្រឡាហោម" },
    { "id": 1080, "word": "ក្រឡិត" },
    { "id": 1081, "word": "ក្រឡឹង" },
    { "id": 1082, "word": "ក្រឡឹប" },
    { "id": 1083, "word": "ក្រឡឹម" },
    { "id": 1084, "word": "ក្រឡឺម" },
    { "id": 1085, "word": "ក្រឡុញ" },
    { "id": 1086, "word": "ក្រឡុប" },
    { "id": 1087, "word": "ក្រឡូម" },
    { "id": 1088, "word": "ក្រឡេក" },
    { "id": 1089, "word": "ក្រឡេច" },
    { "id": 1090, "word": "ក្រឡេចក្រឡុច" },
    { "id": 1091, "word": "ក្រឡែត" },
    { "id": 1092, "word": "ក្រឡោ" },
    { "id": 1093, "word": "ក្រឡោជី" },
    { "id": 1094, "word": "ក្រឡោត" },
    { "id": 1095, "word": "ក្រឡៅ" },
    { "id": 1096, "word": "ក្រអាញ" },
    { "id": 1097, "word": "ក្រអឹមក្រអៀម" },
    { "id": 1098, "word": "ក្រអឺត" },
    { "id": 1099, "word": "ក្រអឺតក្រទម" },
    { "id": 1100, "word": "ក្រអឺតក្រអោង" },
    { "id": 1101, "word": "ក្រអុច" },
    { "id": 1102, "word": "ក្រអុល" },
    { "id": 1103, "word": "ក្រអូប" },
    { "id": 1104, "word": "ក្រអូម" },
    { "id": 1105, "word": "ក្រអួន" },
    { "id": 1106, "word": "ក្រអេក" },
    { "id": 1107, "word": "ក្រអែងក្រអោង" },
    { "id": 1108, "word": "ក្រអែប" },
    { "id": 1109, "word": "ក្រអែស" },
    { "id": 1110, "word": "ក្រឱង" },
    { "id": 1111, "word": "ក្រឳ" },
    { "id": 1112, "word": "ក្រា" },
    { "id": 1113, "word": "ក្រាក" },
    { "id": 1114, "word": "ក្រាក់" },
    { "id": 1115, "word": "ក្រាក់ៗ" },
    { "id": 1116, "word": "ក្រាក់អាច់" },
    { "id": 1117, "word": "ក្រាងក្រឳ" },
    { "id": 1118, "word": "ក្រាញ" },
    { "id": 1119, "word": "ក្រាញ់" },
    { "id": 1120, "word": "ក្រាន" },
    { "id": 1121, "word": "ក្រាប" },
    { "id": 1122, "word": "ក្រាប់" },
    { "id": 1123, "word": "ក្រាប់ៗ" },
    { "id": 1124, "word": "ក្រាម" },
    { "id": 1125, "word": "ក្រាមទាល់" },
    { "id": 1126, "word": "ក្រាមរមាស" },
    { "id": 1127, "word": "ក្រាយ" },
    { "id": 1128, "word": "ក្រាល" },
    { "id": 1129, "word": "ក្រាល់" },
    { "id": 1130, "word": "ក្រាស" },
    { "id": 1131, "word": "ក្រាស់" },
    { "id": 1132, "word": "ក្រិត" },
    { "id": 1133, "word": "ក្រិន" },
    { "id": 1134, "word": "ក្រិបៗ" },
    { "id": 1135, "word": "ក្រិស" },
    { "id": 1136, "word": "ក្រិះ" },
    { "id": 1137, "word": "ក្រី" },
    { "id": 1138, "word": "ក្រឹកៗ" },
    { "id": 1139, "word": "ក្រឹត្យ" },
    { "id": 1140, "word": "ក្រឹត្យក្រម" },
    { "id": 1141, "word": "ក្រឹប" },
    { "id": 1142, "word": "ក្រឹបក្រៀប" },
    { "id": 1143, "word": "ក្រឹម" },
    { "id": 1144, "word": "ក្រឹស" },
    { "id": 1145, "word": "ក្រឺត" },
    { "id": 1146, "word": "ក្រុកៗ" },
    { "id": 1147, "word": "ក្រុង" },
    { "id": 1148, "word": "ក្រុបៗ" },
    { "id": 1149, "word": "ក្រុម" },
    { "id": 1150, "word": "ក្រុស" },
    { "id": 1151, "word": "ក្រូច" },
    { "id": 1152, "word": "ក្រូចឆ្មារ" },
    { "id": 1153, "word": "ក្រួច" },
    { "id": 1154, "word": "ក្រួប" },
    { "id": 1155, "word": "ក្រួស" },
    { "id": 1156, "word": "ក្រើន" },
    { "id": 1157, "word": "ក្រៀក" },
    { "id": 1158, "word": "ក្រៀប" },
    { "id": 1159, "word": "ក្រៀបៗ" },
    { "id": 1160, "word": "ក្រៀម" },
    { "id": 1161, "word": "ក្រៀមក្រោះ" },
    { "id": 1162, "word": "ក្រៀល" },
    { "id": 1163, "word": "ក្រេប" },
    { "id": 1164, "word": "ក្រេវ" },
    { "id": 1165, "word": "ក្រេវក្រោធ" },
    { "id": 1166, "word": "ក្រេស" },
    { "id": 1167, "word": "ក្រេះ" },
    { "id": 1168, "word": "ក្រែក" },
    { "id": 1169, "word": "ក្រែកៗ" },
    { "id": 1170, "word": "ក្រែង" },
    { "id": 1171, "word": "ក្រែងតែ" },
    { "id": 1172, "word": "ក្រែងលោ" },
    { "id": 1173, "word": "ក្រែប" },
    { "id": 1174, "word": "ក្រែល" },
    { "id": 1175, "word": "ក្រែះ" },
    { "id": 1176, "word": "ក្រៃ" },
    { "id": 1177, "word": "ក្រៃពេក" },
    { "id": 1178, "word": "ក្រៃសរ" },
    { "id": 1179, "word": "ក្រោក" },
    { "id": 1180, "word": "ក្រោធ" },
    { "id": 1181, "word": "ក្រោម" },
    { "id": 1182, "word": "ក្រោយ" },
    { "id": 1183, "word": "ក្រោល" },
    { "id": 1184, "word": "ក្រោះ" },
    { "id": 1185, "word": "ក្រោះរមាស" },
    { "id": 1186, "word": "ក្រៅ" },
    { "id": 1187, "word": "ក្រំ" },
    { "id": 1188, "word": "ក្រាំង" },
    { "id": 1189, "word": "ក្លង" },
    { "id": 1190, "word": "ក្លងខែក" },
    { "id": 1191, "word": "ក្លងឆ្នៈ" },
    { "id": 1192, "word": "ក្លងយ៉ូន" },
    { "id": 1193, "word": "ក្លន" },
    { "id": 1194, "word": "ក្លម" },
    { "id": 1195, "word": "ក្លស់" },
    { "id": 1196, "word": "ក្លា" },
    { "id": 1197, "word": "ក្លាក់" },
    { "id": 1198, "word": "ក្លាត់" },
    { "id": 1199, "word": "ក្លាយ" },
    { "id": 1200, "word": "ក្លាវ" },
    { "id": 1201, "word": "ក្លាស់" },
    { "id": 1202, "word": "ក្លាហាន" },
    { "id": 1203, "word": "ក្លិង្គ" },
    { "id": 1204, "word": "ក្លិង្គ្រាស្ត្រ" },
    { "id": 1205, "word": "ក្លិត" },
    { "id": 1206, "word": "ក្លិន" },
    { "id": 1207, "word": "ក្លឹង" },
    { "id": 1208, "word": "ក្លឹស" },
    { "id": 1209, "word": "ក្លុក" },
    { "id": 1210, "word": "ក្លើ" },
    { "id": 1211, "word": "ក្លៀក" },
    { "id": 1212, "word": "ក្លៀវក្លម" },
    { "id": 1213, "word": "ក្លេត" },
    { "id": 1214, "word": "ក្លែង" },
    { "id": 1215, "word": "ក្លែប" },
    { "id": 1216, "word": "ក្លែម" },
    { "id": 1217, "word": "ក្លុំ" },
    { "id": 1218, "word": "ក្លំ" },
    { "id": 1219, "word": "ក្លាំ" },
    { "id": 1220, "word": "ក្លាំងហាយ" },
    { "id": 1221, "word": "ក្លាំពាក់" },
    { "id": 1222, "word": "ក្លាំពូ" },
    { "id": 1223, "word": "ក្វាត" },
    { "id": 1224, "word": "ក្វែន" },
    { "id": 1225, "word": "ក្សណៈ" },
    { "id": 1226, "word": "ក្សត្រ" },
    { "id": 1227, "word": "ក្ស័យ" },
    { "id": 1228, "word": "ក្សាន្ត" },
    { "id": 1229, "word": "ក្សិណ" },
    { "id": 1230, "word": "ក្សិណក្ស័យ" },
    { "id": 1231, "word": "ក្សីណ" },
    { "id": 1232, "word": "ក្សីរ" },
    { "id": 1233, "word": "ក្សេត្រ" },
    { "id": 1234, "word": "ក្សេត្រាជីវកម្ម" },
    { "id": 1235, "word": "ក្សេត្រាធិការ" },
    { "id": 1236, "word": "ក្សេត្រារក្ស" },
    { "id": 1237, "word": "ក្សេម" },
    { "id": 1238, "word": "ក្សេមក្សាន្ត" },
    { "id": 1239, "word": "ក្អក" },
    { "id": 1240, "word": "ក្អម" },
    { "id": 1241, "word": "ក្អាក" },
    { "id": 1242, "word": "ក្អាកៗ" },
    { "id": 1243, "word": "ក្អាកក្អាយ" },
    { "id": 1244, "word": "ក្អាង" },
    { "id": 1245, "word": "ក្អាត" },
    { "id": 1246, "word": "ក្អាត់" },
    { "id": 1247, "word": "ក្អិត" },
    { "id": 1248, "word": "ក្អិល" },
    { "id": 1249, "word": "ក្អី" },
    { "id": 1250, "word": "ក្អឹកៗ" },
    { "id": 1251, "word": "ក្អុក" },
    { "id": 1252, "word": "ក្អួត" },
    { "id": 1253, "word": "ក្អឿយ" },
    { "id": 1254, "word": "ក្អៀកៗ" },
    { "id": 1255, "word": "ក្អេង" },
    { "id": 1256, "word": "ក្អេងក្អាង" },
    { "id": 1257, "word": "ក្អែ" },
    { "id": 1258, "word": "ក្អែក" },
    { "id": 1259, "word": "ក្អែប" },
    { "id": 1260, "word": "ក្អែល" },
    { "id": 1261, "word": "កង្វាក់" },
    { "id": 1262, "word": "កង្វិន" },
    { "id": 1263, "word": "កញ្ចូញ" },
    { "id": 1264, "word": "កញ្ឆាញ" },
    { "id": 1265, "word": "កណ្តេង" },
    { "id": 1266, "word": "កត់" },
    { "id": 1267, "word": "កន្លាញ់" },
    { "id": 1268, "word": "កម្រាញ" },
    { "id": 1269, "word": "កម្រិន" },
    { "id": 1270, "word": "កាត់" },
    { "id": 1271, "word": "កាន់ជើង" },
    { "id": 1272, "word": "កុងតាក់" },
    { "id": 1273, "word": "កូនក្រក" },
    { "id": 1274, "word": "កូនក្រាប់" },
    { "id": 1275, "word": "កូនបណ្ដែត" },
    { "id": 1276, "word": "កែវពង្រីក" },
    { "id": 1277, "word": "កំហក" },
    { "id": 1278, "word": "កំហាត់" },
    { "id": 1279, "word": "កំហាន" },
    { "id": 1280, "word": "ក្បាច់" },
    { "id": 1281, "word": "ក្រចេ" },
    { "id": 1282, "word": "ក្រណាន់" },
    { "id": 1283, "word": "ក្រៀវ" },
    { "id": 1284, "word": "ខ" },
    { "id": 1285, "word": "ខៗ" },
    { "id": 1286, "word": "ខក" },
    { "id": 1287, "word": "ខក់" },
    { "id": 1288, "word": "ខខិត" },
    { "id": 1289, "word": "ខ័ឌ្គ" },
    { "id": 1290, "word": "ខណៈ" },
    { "id": 1291, "word": "ខណ្ឌ" },
    { "id": 1292, "word": "ខណ្ឌខាប់" },
    { "id": 1293, "word": "ខណ្ឌសញ្ញា" },
    { "id": 1294, "word": "ខណ្ឌស្ករ" },
    { "id": 1295, "word": "ខណ្ឌសីមា" },
    { "id": 1296, "word": "ខត្តិយៈ" },
    { "id": 1297, "word": "ខន" },
    { "id": 1298, "word": "ខន់" },
    { "id": 1299, "word": "ខ័ន" },
    { "id": 1300, "word": "ខន្តី" },
    { "id": 1301, "word": "ខន្ទរា" },
    { "id": 1302, "word": "ខន្ធ" },
    { "id": 1303, "word": "ខម" },
    { "id": 1304, "word": "ខមាទោស" },
    { "id": 1305, "word": "ខរ" },
    { "id": 1306, "word": "ខរាពាធ" },
    { "id": 1307, "word": "ខលុបច្ឆាភត្តិកង្គ" },
    { "id": 1308, "word": "ខាក" },
    { "id": 1309, "word": "ខាង" },
    { "id": 1310, "word": "ខាត" },
    { "id": 1311, "word": "ខាត់" },
    { "id": 1312, "word": "ខាទនីយាហារ" },
    { "id": 1313, "word": "ខាន" },
    { "id": 1314, "word": "ខានស្អែក" },
    { "id": 1315, "word": "ខានស្អែកមួយ" },
    { "id": 1316, "word": "ខានស្អែកមួយនាយ" },
    { "id": 1317, "word": "ខាន់" },
    { "id": 1318, "word": "ខាន់ខៅ" },
    { "id": 1319, "word": "ខាន់ជីប" },
    { "id": 1320, "word": "ខាន់បៀត" },
    { "id": 1321, "word": "ខាន់លឿង" },
    { "id": 1322, "word": "ខាន់ស្លា" },
    { "id": 1323, "word": "ខាន់ស្លាក់" },
    { "id": 1324, "word": "ខាប" },
    { "id": 1325, "word": "ខាបខា" },
    { "id": 1326, "word": "ខាប់" },
    { "id": 1327, "word": "ខាប់ខណ្ឌ" },
    { "id": 1328, "word": "ខាម" },
    { "id": 1329, "word": "ខារ" },
    { "id": 1330, "word": "ខាល" },
    { "id": 1331, "word": "ខាល់" },
    { "id": 1332, "word": "ខាវ" },
    { "id": 1333, "word": "ខិង" },
    { "id": 1334, "word": "ខិត" },
    { "id": 1335, "word": "ខិតខាត់" },
    { "id": 1336, "word": "ខិតខំ" },
    { "id": 1337, "word": "ខិត្តប័ណ្ណ" },
    { "id": 1338, "word": "ខិម" },
    { "id": 1339, "word": "ខិល" },
    { "id": 1340, "word": "ខីណភាព" },
    { "id": 1341, "word": "ខីណាស្រព" },
    { "id": 1342, "word": "ខីរជាតិ" },
    { "id": 1343, "word": "ខឹកៗ" },
    { "id": 1344, "word": "ខឹង" },
    { "id": 1345, "word": "ខឹមខាត់" },
    { "id": 1346, "word": "ខុងៗ" },
    { "id": 1347, "word": "ខុទ្ទកភាព" },
    { "id": 1348, "word": "ខុទ្ទកាល័យ" },
    { "id": 1349, "word": "ខុន" },
    { "id": 1350, "word": "ខុនណាង" },
    { "id": 1351, "word": "ខុនហ្នឹង" },
    { "id": 1352, "word": "ខុប" },
    { "id": 1353, "word": "ខុយ" },
    { "id": 1354, "word": "ខុរៗ" },
    { "id": 1355, "word": "ខុល" },
    { "id": 1356, "word": "ខុស" },
    { "id": 1357, "word": "ខូង" },
    { "id": 1358, "word": "ខូច" },
    { "id": 1359, "word": "ខួ" },
    { "id": 1360, "word": "ខួង" },
    { "id": 1361, "word": "ខួច" },
    { "id": 1362, "word": "ខួញ" },
    { "id": 1363, "word": "ខួប" },
    { "id": 1364, "word": "ខួរ" },
    { "id": 1365, "word": "ខើច" },
    { "id": 1366, "word": "ខឿន" },
    { "id": 1367, "word": "ខៀន" },
    { "id": 1368, "word": "ខៀវ" },
    { "id": 1369, "word": "ខេ" },
    { "id": 1370, "word": "ខេត្ត" },
    { "id": 1371, "word": "ខេន" },
    { "id": 1372, "word": "ខេមរៈ" },
    { "id": 1373, "word": "ខេមរភាសា" },
    { "id": 1374, "word": "ខេមររដ្ឋ" },
    { "id": 1375, "word": "ខែ" },
    { "id": 1376, "word": "ខែង" },
    { "id": 1377, "word": "ខែត្រ" },
    { "id": 1378, "word": "ខែល" },
    { "id": 1379, "word": "ខៃ" },
    { "id": 1380, "word": "ខោ" },
    { "id": 1381, "word": "ខោក" },
    { "id": 1382, "word": "ខោរ" },
    { "id": 1383, "word": "ខោល" },
    { "id": 1384, "word": "ខោស" },
    { "id": 1385, "word": "ខៅតាក" },
    { "id": 1386, "word": "ខំ" },
    { "id": 1387, "word": "ខាំ" },
    { "id": 1388, "word": "ខាំង" },
    { "id": 1389, "word": "ខះ" },
    { "id": 1390, "word": "ខះខំ" },
    { "id": 1391, "word": "ខ្ចក" },
    { "id": 1392, "word": "ខ្ចប់" },
    { "id": 1393, "word": "ខ្ចរ" },
    { "id": 1394, "word": "ខ្ចរខ្ចាយ" },
    { "id": 1395, "word": "ខ្ចាត់" },
    { "id": 1396, "word": "ខ្ចាត់ខ្ចាយ" },
    { "id": 1397, "word": "ខ្ចាយ" },
    { "id": 1398, "word": "ខ្ចាស់" },
    { "id": 1399, "word": "ខ្ចី" },
    { "id": 1400, "word": "ខ្ចូវ" },
    { "id": 1401, "word": "ខ្ចើច" },
    { "id": 1402, "word": "ខ្ចោប" },
    { "id": 1403, "word": "ខ្ចោះ" },
    { "id": 1404, "word": "ខ្ចៅ" },
    { "id": 1405, "word": "ខ្ជាក" },
    { "id": 1406, "word": "ខ្ជាក់" },
    { "id": 1407, "word": "ខ្ជាង" },
    { "id": 1408, "word": "ខ្ជាន់ៗ" },
    { "id": 1409, "word": "ខ្ជាប់" },
    { "id": 1410, "word": "ខ្ជាប់ខ្ជួន" },
    { "id": 1411, "word": "ខ្ជាយ" },
    { "id": 1412, "word": "ខ្ជីខ្ជា" },
    { "id": 1413, "word": "ខ្ជិល" },
    { "id": 1414, "word": "ខ្ជឹប" },
    { "id": 1415, "word": "ខ្ជឹង" },
    { "id": 1416, "word": "ខ្ជឹប" },
    { "id": 1417, "word": "ខ្ជួន" },
    { "id": 1418, "word": "ខ្ជើច" },
    { "id": 1419, "word": "ខ្ជេញ" },
    { "id": 1420, "word": "ខ្ជែង" },
    { "id": 1421, "word": "ខ្ជោក" },
    { "id": 1422, "word": "ខ្ជោកខ្ជាក" },
    { "id": 1423, "word": "ខ្ជោល" },
    { "id": 1424, "word": "ខ្ជាំ" },
    { "id": 1425, "word": "ខ្ជាំងៗ" },
    { "id": 1426, "word": "ខ្ជះខ្ជាយ" },
    { "id": 1427, "word": "ខ្ញក" },
    { "id": 1428, "word": "ខ្ញង់" },
    { "id": 1429, "word": "ខ្ញាក" },
    { "id": 1430, "word": "ខ្ញារ" },
    { "id": 1431, "word": "ខ្ញាល់" },
    { "id": 1432, "word": "ខ្ញិកៗ" },
    { "id": 1433, "word": "ខ្ញិកខ្ញុក" },
    { "id": 1434, "word": "ខ្ញិលៗ" },
    { "id": 1435, "word": "ខ្ញី" },
    { "id": 1436, "word": "ខ្ញីវខ្ញូវ" },
    { "id": 1437, "word": "ខ្ញឹង" },
    { "id": 1438, "word": "ខ្ញុកខ្ញូវ" },
    { "id": 1439, "word": "ខ្ញុង" },
    { "id": 1440, "word": "ខ្ញូច" },
    { "id": 1441, "word": "ខ្ញើច" },
    { "id": 1442, "word": "ខ្ញៀវ" },
    { "id": 1443, "word": "ខ្ញៀវខ្ញារ" },
    { "id": 1444, "word": "ខ្ញែកខ្ញក" },
    { "id": 1445, "word": "ខ្ញែក" },
    { "id": 1446, "word": "ខ្ញែតៗ" },
    { "id": 1447, "word": "ខ្ញែម" },
    { "id": 1448, "word": "ខ្ញែរ" },
    { "id": 1449, "word": "ខ្ញោក" },
    { "id": 1450, "word": "ខ្ញុំ" },
    { "id": 1451, "word": "ខ្ញាំ" },
    { "id": 1452, "word": "ខ្តត" },
    { "id": 1453, "word": "ខ្ទង់" },
    { "id": 1454, "word": "ខ្ទប" },
    { "id": 1455, "word": "ខ្ទប់" },
    { "id": 1456, "word": "ខ្ទម" },
    { "id": 1457, "word": "ខ្ទរ" },
    { "id": 1458, "word": "ខ្ទរខ្ទ័រ" },
    { "id": 1459, "word": "ខ្ទ័រ" },
    { "id": 1460, "word": "ខ្ទាត" },
    { "id": 1461, "word": "ខ្ទារ" },
    { "id": 1462, "word": "ខ្ទាស់" },
    { "id": 1463, "word": "ខ្ទិះ" },
    { "id": 1464, "word": "ខ្ទីង" },
    { "id": 1465, "word": "ខ្ទីត" },
    { "id": 1466, "word": "ខ្ទឹង" },
    { "id": 1467, "word": "ខ្ទឹម" },
    { "id": 1468, "word": "ខ្ទុត" },
    { "id": 1469, "word": "ខ្ទុតដី" },
    { "id": 1470, "word": "ខ្ទុះ" },
    { "id": 1471, "word": "ខ្ទួយ" },
    { "id": 1472, "word": "ខ្ទើត" },
    { "id": 1473, "word": "ខ្ទើយ" },
    { "id": 1474, "word": "ខ្ទេច" },
    { "id": 1475, "word": "ខ្ទេចខ្ទី" },
    { "id": 1476, "word": "ខ្ទែង" },
    { "id": 1477, "word": "ខ្ទែត" },
    { "id": 1478, "word": "ខ្ទោកៗ" },
    { "id": 1479, "word": "ខ្ទាំ" },
    { "id": 1480, "word": "ខ្ទះ" },
    { "id": 1481, "word": "ខ្ទះត្នោត" },
    { "id": 1482, "word": "ខ្នង" },
    { "id": 1483, "word": "ខ្នប់" },
    { "id": 1484, "word": "ខ្នល់" },
    { "id": 1485, "word": "ខ្នន់" },
    { "id": 1486, "word": "ខ្នាច" },
    { "id": 1487, "word": "ខ្នាច់" },
    { "id": 1488, "word": "ខ្នាត" },
    { "id": 1489, "word": "ខ្នាន" },
    { "id": 1490, "word": "ខ្នាន់" },
    { "id": 1491, "word": "ខ្នាន់ខ្នាប់" },
    { "id": 1492, "word": "ខ្នាប" },
    { "id": 1493, "word": "ខ្នាយ" },
    { "id": 1494, "word": "ខ្នារ" },
    { "id": 1495, "word": "ខ្និច" },
    { "id": 1496, "word": "ខ្និត" },
    { "id": 1497, "word": "ខ្នឺប" },
    { "id": 1498, "word": "ខ្នុរ" },
    { "id": 1499, "word": "ខ្នុរសម្ល" },
    { "id": 1500, "word": "ខ្នួច" },
    { "id": 1501, "word": "ខ្នួត" },
    { "id": 1502, "word": "ខ្នួតអំបោះ" },
    { "id": 1503, "word": "ខ្នើត" },
    { "id": 1504, "word": "ខ្នើយ" },
    { "id": 1505, "word": "ខ្នែង" },
    { "id": 1506, "word": "ខ្នៀរ" },
    { "id": 1507, "word": "ខ្នៀស" },
    { "id": 1508, "word": "ខ្នោស" },
    { "id": 1509, "word": "ខ្នោះ" },
    { "id": 1510, "word": "ខ្នៅ" },
    { "id": 1511, "word": "ខ្នះខ្នែង" },
    { "id": 1512, "word": "ខ្ព" },
    { "id": 1513, "word": "ខ្ពង់" },
    { "id": 1514, "word": "ខ្ពង់ខ្ពស់" },
    { "id": 1515, "word": "ខ្ពង់មេឃ" },
    { "id": 1516, "word": "ខ្ពង់រាប" },
    { "id": 1517, "word": "ខ្ពប" },
    { "id": 1518, "word": "ខ្ពស់" },
    { "id": 1519, "word": "ខ្ពាក" },
    { "id": 1520, "word": "ខ្ពាក់ៗ" },
    { "id": 1521, "word": "ខ្ពាប់" },
    { "id": 1522, "word": "ខ្ពុក" },
    { "id": 1523, "word": "ខ្ពុរ" },
    { "id": 1524, "word": "ខ្ពើម" },
    { "id": 1525, "word": "ខ្ពោក" },
    { "id": 1526, "word": "ខ្មង" },
    { "id": 1527, "word": "ខ្មាញ់" },
    { "id": 1528, "word": "ខ្មាន់" },
    { "id": 1529, "word": "ខ្មាយ" },
    { "id": 1530, "word": "ខ្មាស" },
    { "id": 1531, "word": "ខ្មី" },
    { "id": 1532, "word": "ខ្មីឃ្មាត" },
    { "id": 1533, "word": "ខ្មឺត" },
    { "id": 1534, "word": "ខ្មុក" },
    { "id": 1535, "word": "ខ្មុល" },
    { "id": 1536, "word": "ខ្មូត" },
    { "id": 1537, "word": "ខ្មូរ" },
    { "id": 1538, "word": "ខ្មួញ" },
    { "id": 1539, "word": "ខ្មួយ" },
    { "id": 1540, "word": "ខ្មួល" },
    { "id": 1541, "word": "ខ្មួរ" },
    { "id": 1542, "word": "ខ្មេរ" },
    { "id": 1543, "word": "ខ្មេះ" },
    { "id": 1544, "word": "ខ្មែរ" },
    { "id": 1545, "word": "ខ្មោច" },
    { "id": 1546, "word": "ខ្មៅ" },
    { "id": 1547, "word": "ខ្មោះ" },
    { "id": 1548, "word": "ខ្មោះខ្មួរ" },
    { "id": 1549, "word": "ខ្មាំង" },
    { "id": 1550, "word": "ខ្មាំងមិល" },
    { "id": 1551, "word": "ខ្យង" },
    { "id": 1552, "word": "ខ្យល់" },
    { "id": 1553, "word": "ខ្យាដំរី" },
    { "id": 1554, "word": "ខ្លប" },
    { "id": 1555, "word": "ខ្លា" },
    { "id": 1556, "word": "ខ្លាច" },
    { "id": 1557, "word": "ខ្លាញ់" },
    { "id": 1558, "word": "ខ្លី" },
    { "id": 1559, "word": "ខ្លឹម" },
    { "id": 1560, "word": "ខ្លឺត" },
    { "id": 1561, "word": "ខ្លុក" },
    { "id": 1562, "word": "ខ្លុង" },
    { "id": 1563, "word": "ខ្លុយ" },
    { "id": 1564, "word": "ខ្លុះ" },
    { "id": 1565, "word": "ខ្លូត" },
    { "id": 1566, "word": "ខ្លួន" },
    { "id": 1567, "word": "ខ្លេវៗ" },
    { "id": 1568, "word": "ខ្លែង" },
    { "id": 1569, "word": "ខ្លោង" },
    { "id": 1570, "word": "ខ្លោងទ្វារ" },
    { "id": 1571, "word": "ខ្លោច" },
    { "id": 1572, "word": "ខ្លោញៗ" },
    { "id": 1573, "word": "ខ្លោត" },
    { "id": 1574, "word": "ខ្លៅ" },
    { "id": 1575, "word": "ខ្លាំង" },
    { "id": 1576, "word": "ខ្លះ" },
    { "id": 1577, "word": "ខ្វក" },
    { "id": 1578, "word": "ខ្វក់" },
    { "id": 1579, "word": "ខ្វង" },
    { "id": 1580, "word": "ខ្វង់" },
    { "id": 1581, "word": "ខ្វល់" },
    { "id": 1582, "word": "ខ្វល់ខ្វាយ" },
    { "id": 1583, "word": "ខ្វាក" },
    { "id": 1584, "word": "ខ្វាក់" },
    { "id": 1585, "word": "ខ្វាក់មាន់" },
    { "id": 1586, "word": "ខ្វាង" },
    { "id": 1587, "word": "ខ្វាច" },
    { "id": 1588, "word": "ខ្វាច់" },
    { "id": 1589, "word": "ខ្វាត់" },
    { "id": 1590, "word": "ខ្វាត់ខ្វែង" },
    { "id": 1591, "word": "ខ្វាន" },
    { "id": 1592, "word": "ខ្វាន់" },
    { "id": 1593, "word": "ខ្វាន់នាគ" },
    { "id": 1594, "word": "ខ្វាប់" },
    { "id": 1595, "word": "ខ្វាម" },
    { "id": 1596, "word": "ខ្វាសៗ" },
    { "id": 1597, "word": "ខ្វារ" },
    { "id": 1598, "word": "ខ្វាវ" },
    { "id": 1599, "word": "ខ្វិច" },
    { "id": 1600, "word": "ខ្វិត" },
    { "id": 1601, "word": "ខ្វិន" },
    { "id": 1602, "word": "ខ្វិល" },
    { "id": 1603, "word": "ខ្វើក" },
    { "id": 1604, "word": "ខ្វើយៗ" },
    { "id": 1605, "word": "ខ្វៀក" },
    { "id": 1606, "word": "ខ្វៀន" },
    { "id": 1607, "word": "ខ្វៀប" },
    { "id": 1608, "word": "ខ្វេរ" },
    { "id": 1609, "word": "ខ្វេះ" },
    { "id": 1610, "word": "ខ្វែ" },
    { "id": 1611, "word": "ខ្វែក" },
    { "id": 1612, "word": "ខ្វែកត្រោក" },
    { "id": 1613, "word": "ខ្វែង" },
    { "id": 1614, "word": "ខ្វែត" },
    { "id": 1615, "word": "ខ្វែវ" },
    { "id": 1616, "word": "ខ្វែះ" },
    { "id": 1617, "word": "ខ្វោក" },
    { "id": 1618, "word": "ខ្វោកខ្វាក" },
    { "id": 1619, "word": "ខ្វោះ" },
    { "id": 1620, "word": "ខ្វះ" },
    { "id": 1621, "word": "ខ្សត" },
    { "id": 1622, "word": "ខ្សត់" },
    { "id": 1623, "word": "ខ្សាក" },
    { "id": 1624, "word": "ខ្សាច់" },
    { "id": 1625, "word": "ខ្សាច់កណ្ដាល" },
    { "id": 1626, "word": "ខ្សាន" },
    { "id": 1627, "word": "ខ្សាប" },
    { "id": 1628, "word": "ខ្សាយ" },
    { "id": 1629, "word": "ខ្សាវ" },
    { "id": 1630, "word": "ខ្សឹកខ្សួល" },
    { "id": 1631, "word": "ខ្សឹប" },
    { "id": 1632, "word": "ខ្សឺត" },
    { "id": 1633, "word": "ខ្សុក" },
    { "id": 1634, "word": "ខ្សុច" },
    { "id": 1635, "word": "ខ្សុយ" },
    { "id": 1636, "word": "ខ្សុល" },
    { "id": 1637, "word": "ខ្សួល" },
    { "id": 1638, "word": "ខ្សួស" },
    { "id": 1639, "word": "ខ្សៀ" },
    { "id": 1640, "word": "ខ្សៀគ្រក់" },
    { "id": 1641, "word": "ខ្សៀក" },
    { "id": 1642, "word": "ខ្សៀវ" },
    { "id": 1643, "word": "ខ្សេវ" },
    { "id": 1644, "word": "ខ្សែ" },
    { "id": 1645, "word": "ខ្សែក្រវាត់" },
    { "id": 1646, "word": "ខ្សែបាស" },
    { "id": 1647, "word": "ខ្សែភាពយន្ដ" },
    { "id": 1648, "word": "ខ្សែសយ" },
    { "id": 1649, "word": "ខ្សោយ" },
    { "id": 1650, "word": "ខ្សោះ" },
    { "id": 1651, "word": "ខ្ជេញខ្ជិល" },
    { "id": 1652, "word": "ខ្ញុំកំដរ" },
    { "id": 1653, "word": "គ" },
    { "id": 1654, "word": "គក" },
    { "id": 1655, "word": "គក់" },
    { "id": 1656, "word": "គគាច" },
    { "id": 1657, "word": "គគាត" },
    { "id": 1658, "word": "គគីរ" },
    { "id": 1659, "word": "គគឹក" },
    { "id": 1660, "word": "គគឹត" },
    { "id": 1661, "word": "គគុក" },
    { "id": 1662, "word": "គគុកគគាក់" },
    { "id": 1663, "word": "គគុល" },
    { "id": 1664, "word": "គគុះ" },
    { "id": 1665, "word": "គគើម" },
    { "id": 1666, "word": "គគ្រក់" },
    { "id": 1667, "word": "គគ្រន់" },
    { "id": 1668, "word": "គគ្រាក់" },
    { "id": 1669, "word": "គគ្រាត" },
    { "id": 1670, "word": "គគ្រិងគគ្រាំង" },
    { "id": 1671, "word": "គគ្រិច" },
    { "id": 1672, "word": "គគ្រិះ" },
    { "id": 1673, "word": "គគ្រីតគគ្រាត" },
    { "id": 1674, "word": "គគ្រីវ" },
    { "id": 1675, "word": "គគ្រីសគគ្រូស" },
    { "id": 1676, "word": "គគ្រឹក" },
    { "id": 1677, "word": "គគ្រឹកគគ្រេង" },
    { "id": 1678, "word": "គគ្រឹម" },
    { "id": 1679, "word": "គគ្រឺត" },
    { "id": 1680, "word": "គគ្រុក" },
    { "id": 1681, "word": "គគ្រុម" },
    { "id": 1682, "word": "គគ្រុយ" },
    { "id": 1683, "word": "គគ្រូក" },
    { "id": 1684, "word": "គគ្រួប" },
    { "id": 1685, "word": "គគ្រើម" },
    { "id": 1686, "word": "គគ្រេង" },
    { "id": 1687, "word": "គគ្រេងគគ្រាំ" },
    { "id": 1688, "word": "គគ្រោក" },
    { "id": 1689, "word": "គគ្រាំ" },
    { "id": 1690, "word": "គគ្រាំង" },
    { "id": 1691, "word": "គឃរ" },
    { "id": 1692, "word": "គឃារ" },
    { "id": 1693, "word": "គឃឹក" },
    { "id": 1694, "word": "គឃូស" },
    { "id": 1695, "word": "គឃៀរ" },
    { "id": 1696, "word": "គឃ្លើន" },
    { "id": 1697, "word": "គង" },
    { "id": 1698, "word": "គងពិសី" },
    { "id": 1699, "word": "គង់" },
    { "id": 1700, "word": "គង់តែ" },
    { "id": 1701, "word": "គង់នៅ" },
    { "id": 1702, "word": "គង់វង្ស" },
    { "id": 1703, "word": "គង្គា" },
    { "id": 1704, "word": "គង្គាន" },
    { "id": 1705, "word": "គង្គួន" },
    { "id": 1706, "word": "គង្វាល" },
    { "id": 1707, "word": "គជ" },
    { "id": 1708, "word": "គជ់" },
    { "id": 1709, "word": "គជតា" },
    { "id": 1710, "word": "គជទន្ត" },
    { "id": 1711, "word": "គជមុក្តា" },
    { "id": 1712, "word": "គជសារ" },
    { "id": 1713, "word": "គជសីហ៍" },
    { "id": 1714, "word": "គជា" },
    { "id": 1715, "word": "គជេន្ទ្រ" },
    { "id": 1716, "word": "គជ្រា" },
    { "id": 1717, "word": "គណ" },
    { "id": 1718, "word": "គណៈ" },
    { "id": 1719, "word": "គណៈកម្មការ" },
    { "id": 1720, "word": "គណៈកម្មាធិការ" },
    { "id": 1721, "word": "គណ្ឋី" },
    { "id": 1722, "word": "គណនា" },
    { "id": 1723, "word": "គណនី" },
    { "id": 1724, "word": "គណនីយដ្ឋាន" },
    { "id": 1725, "word": "គណនេយ្យ" },
    { "id": 1726, "word": "គណនេយ្យករ" },
    { "id": 1727, "word": "គណបក្ខ" },
    { "id": 1728, "word": "គណៈប្រតិភូ" },
    { "id": 1729, "word": "គណៈរដ្ឋមន្ត្រី" },
    { "id": 1730, "word": "គណិតសាស្ត្រ" },
    { "id": 1731, "word": "គណេស" },
    { "id": 1732, "word": "គត់" },
    { "id": 1733, "word": "គត់មត់" },
    { "id": 1734, "word": "គតិ" },
    { "id": 1735, "word": "គតិបណ្ឌិត" },
    { "id": 1736, "word": "គន" },
    { "id": 1737, "word": "គន់" },
    { "id": 1738, "word": "គន់គូរ" },
    { "id": 1739, "word": "គន្ថៈ" },
    { "id": 1740, "word": "គន្ថធុរៈ" },
    { "id": 1741, "word": "គន្ថរចនា" },
    { "id": 1742, "word": "គន្ថរចនាចារ្យ" },
    { "id": 1743, "word": "គន្ធ" },
    { "id": 1744, "word": "គន្ធព្វ" },
    { "id": 1745, "word": "គន្លង" },
    { "id": 1746, "word": "គន្លាក់" },
    { "id": 1747, "word": "គន្លាក់គន្លើន" },
    { "id": 1748, "word": "គន្លាក់អាចម៍" },
    { "id": 1749, "word": "គន្លាស់" },
    { "id": 1750, "word": "គន្លាស់គន្លោង" },
    { "id": 1751, "word": "គន្លិកគន្លាក់" },
    { "id": 1752, "word": "គន្លឹះ" },
    { "id": 1753, "word": "គន្លោង" },
    { "id": 1754, "word": "គប់" },
    { "id": 1755, "word": "គប់គិត" },
    { "id": 1756, "word": "គប្បី" },
    { "id": 1757, "word": "គភ៌" },
    { "id": 1758, "word": "គម" },
    { "id": 1759, "word": "គមនាការ" },
    { "id": 1760, "word": "គមនាគមន៍" },
    { "id": 1761, "word": "គម្ដែង" },
    { "id": 1762, "word": "គម្ពីរ" },
    { "id": 1763, "word": "គម្ភីរ" },
    { "id": 1764, "word": "គម្រក់" },
    { "id": 1765, "word": "គម្រង" },
    { "id": 1766, "word": "គម្រប" },
    { "id": 1767, "word": "គម្រប់" },
    { "id": 1768, "word": "គម្រិងគម្រាំង" },
    { "id": 1769, "word": "គម្រិះ" },
    { "id": 1770, "word": "គម្រៀវ" },
    { "id": 1771, "word": "គម្រោង" },
    { "id": 1772, "word": "គម្រាំង" },
    { "id": 1773, "word": "គម្លង់" },
    { "id": 1774, "word": "គម្លាន" },
    { "id": 1775, "word": "គយ" },
    { "id": 1776, "word": "គយគន់" },
    { "id": 1777, "word": "គយឃ្លាំ" },
    { "id": 1778, "word": "គរ" },
    { "id": 1779, "word": "គរគោក" },
    { "id": 1780, "word": "គរហា" },
    { "id": 1781, "word": "គរុ" },
    { "id": 1782, "word": "គរុកោសល្យ" },
    { "id": 1783, "word": "គរុទោស" },
    { "id": 1784, "word": "គរុភណ្ឌ" },
    { "id": 1785, "word": "គរុវិជ្ជា" },
    { "id": 1786, "word": "គល់" },
    { "id": 1787, "word": "គល់កែ" },
    { "id": 1788, "word": "គល់រាំង" },
    { "id": 1789, "word": "គហបតី" },
    { "id": 1790, "word": "គាក់" },
    { "id": 1791, "word": "គាង" },
    { "id": 1792, "word": "គាងឃ្វាយ" },
    { "id": 1793, "word": "គាត" },
    { "id": 1794, "word": "គាត់" },
    { "id": 1795, "word": "គាថា" },
    { "id": 1796, "word": "គាថាពន្ធ" },
    { "id": 1797, "word": "គាថាពាន់" },
    { "id": 1798, "word": "គាប" },
    { "id": 1799, "word": "គាប់" },
    { "id": 1800, "word": "គាមកថា" },
    { "id": 1801, "word": "គាមភាសា" },
    { "id": 1802, "word": "គាមភោជក" },
    { "id": 1803, "word": "គាយ" },
    { "id": 1804, "word": "គារវៈ" },
    { "id": 1805, "word": "គាល់" },
    { "id": 1806, "word": "គាវ" },
    { "id": 1807, "word": "គាវុត" },
    { "id": 1808, "word": "គាស់" },
    { "id": 1809, "word": "គិត" },
    { "id": 1810, "word": "គិរី" },
    { "id": 1811, "word": "គិរីវង្កត" },
    { "id": 1812, "word": "គិរីវង់" },
    { "id": 1813, "word": "គិល" },
    { "id": 1814, "word": "គិលាន" },
    { "id": 1815, "word": "គី" },
    { "id": 1816, "word": "គីង្គក់" },
    { "id": 1817, "word": "គីតសាស្ត្រ" },
    { "id": 1818, "word": "គីមី" },
    { "id": 1819, "word": "គឹកៗ" },
    { "id": 1820, "word": "គឹល" },
    { "id": 1821, "word": "គឺ" },
    { "id": 1822, "word": "គុក" },
    { "id": 1823, "word": "គុកៗ" },
    { "id": 1824, "word": "គុណ" },
    { "id": 1825, "word": "គុណ--" },
    { "id": 1826, "word": "គុត" },
    { "id": 1827, "word": "គុន" },
    { "id": 1828, "word": "គុម្ព" },
    { "id": 1829, "word": "គុម្ពោត" },
    { "id": 1830, "word": "គុយ" },
    { "id": 1831, "word": "គុយទាវ" },
    { "id": 1832, "word": "គុយ្ហៈ" },
    { "id": 1833, "word": "គុល" },
    { "id": 1834, "word": "គុលិកា" },
    { "id": 1835, "word": "គុលី" },
    { "id": 1836, "word": "គុហា" },
    { "id": 1837, "word": "គូ" },
    { "id": 1838, "word": "គូក" },
    { "id": 1839, "word": "គូកន" },
    { "id": 1840, "word": "គូឆាយ" },
    { "id": 1841, "word": "គូថ" },
    { "id": 1842, "word": "គូទ" },
    { "id": 1843, "word": "គូរ" },
    { "id": 1844, "word": "គូលី" },
    { "id": 1845, "word": "គូលីត" },
    { "id": 1846, "word": "គូលែន" },
    { "id": 1847, "word": "គូស" },
    { "id": 1848, "word": "គួប" },
    { "id": 1849, "word": "គួរ" },
    { "id": 1850, "word": "គួរ" },
    { "id": 1851, "word": "គួរនា" },
    { "id": 1852, "word": "គួរីយេរ" },
    { "id": 1853, "word": "គើមៗ" },
    { "id": 1854, "word": "គេ" },
    { "id": 1855, "word": "គេង" },
    { "id": 1856, "word": "គេច" },
    { "id": 1857, "word": "គេចកែ" },
    { "id": 1858, "word": "គេចវេះ" },
    { "id": 1859, "word": "គេហ៍" },
    { "id": 1860, "word": "គេហជន" },
    { "id": 1861, "word": "គេហដ្ឋាន" },
    { "id": 1862, "word": "គេហបាល" },
    { "id": 1863, "word": "គេហស្សាមិក" },
    { "id": 1864, "word": "គេហាភិបាល" },
    { "id": 1865, "word": "គែ" },
    { "id": 1866, "word": "គែន" },
    { "id": 1867, "word": "គែប" },
    { "id": 1868, "word": "គែម" },
    { "id": 1869, "word": "គែល" },
    { "id": 1870, "word": "គែលលក" },
    { "id": 1871, "word": "គែហ៊ៅ" },
    { "id": 1872, "word": "គៃ" },
    { "id": 1873, "word": "គោ" },
    { "id": 1874, "word": "គោក" },
    { "id": 1875, "word": "គោខ្មែរ" },
    { "id": 1876, "word": "គោឃាតក៍" },
    { "id": 1877, "word": "គោឃាតកម្ម" },
    { "id": 1878, "word": "គោឃាតដ្ឋាន" },
    { "id": 1879, "word": "គោឃាតស្ថាន" },
    { "id": 1880, "word": "គោង" },
    { "id": 1881, "word": "គោងៗ" },
    { "id": 1882, "word": "គោចរ" },
    { "id": 1883, "word": "គោឆ្មាត់" },
    { "id": 1884, "word": "គោត" },
    { "id": 1885, "word": "គោតម" },
    { "id": 1886, "word": "គោតមគោត្ត" },
    { "id": 1887, "word": "គោតមពុទ្ធ" },
    { "id": 1888, "word": "គោត្ត" },
    { "id": 1889, "word": "គោត្តនាម" },
    { "id": 1890, "word": "គោត្រ" },
    { "id": 1891, "word": "គោត្រកូល" },
    { "id": 1892, "word": "គោត្រភូ" },
    { "id": 1893, "word": "គោត្រភូញាណ" },
    { "id": 1894, "word": "គោត្រភូសង្ឃ" },
    { "id": 1895, "word": "គោទាវរី" },
    { "id": 1896, "word": "គោធិក" },
    { "id": 1897, "word": "គោបា" },
    { "id": 1898, "word": "គោបាល" },
    { "id": 1899, "word": "គោព្រៃ" },
    { "id": 1900, "word": "គោព្រោះ" },
    { "id": 1901, "word": "គោម" },
    { "id": 1902, "word": "គោមហោះ" },
    { "id": 1903, "word": "គោម៉" },
    { "id": 1904, "word": "គោម័យ" },
    { "id": 1905, "word": "គោមូត្រ" },
    { "id": 1906, "word": "គោមួយ" },
    { "id": 1907, "word": "គោរក្ខកម្ម" },
    { "id": 1908, "word": "គោរក្ខា" },
    { "id": 1909, "word": "គោរព" },
    { "id": 1910, "word": "គោរម" },
    { "id": 1911, "word": "គោរមងារ" },
    { "id": 1912, "word": "គោរស" },
    { "id": 1913, "word": "គោរាត" },
    { "id": 1914, "word": "គោល" },
    { "id": 1915, "word": "គោល្បាយ" },
    { "id": 1916, "word": "គោវត្ត" },
    { "id": 1917, "word": "គោសៀម" },
    { "id": 1918, "word": "គោហៀ" },
    { "id": 1919, "word": "គោហ្ម" },
    { "id": 1920, "word": "គោះ" },
    { "id": 1921, "word": "គោះពព្លាក់" },
    { "id": 1922, "word": "គុំ" },
    { "id": 1923, "word": "គំ" },
    { "id": 1924, "word": "គំនង" },
    { "id": 1925, "word": "គំនម" },
    { "id": 1926, "word": "គំនរ" },
    { "id": 1927, "word": "គំនាក់" },
    { "id": 1928, "word": "គំនាត" },
    { "id": 1929, "word": "គំនាប" },
    { "id": 1930, "word": "គំនាប់" },
    { "id": 1931, "word": "គំនាល់" },
    { "id": 1932, "word": "គំនាស់" },
    { "id": 1933, "word": "គំនិត" },
    { "id": 1934, "word": "គំនូរ" },
    { "id": 1935, "word": "គំនូស" },
    { "id": 1936, "word": "គំនួប" },
    { "id": 1937, "word": "គំនួរ" },
    { "id": 1938, "word": "គំនោះ" },
    { "id": 1939, "word": "គំនុំ" },
    { "id": 1940, "word": "គំរង់" },
    { "id": 1941, "word": "គំរល" },
    { "id": 1942, "word": "គំរាម" },
    { "id": 1943, "word": "គំរឹល" },
    { "id": 1944, "word": "គំរូ" },
    { "id": 1945, "word": "គំរើយ" },
    { "id": 1946, "word": "គំរេច" },
    { "id": 1947, "word": "គំរោះ" },
    { "id": 1948, "word": "គំហក" },
    { "id": 1949, "word": "គំហាត់" },
    { "id": 1950, "word": "គំហឹន" },
    { "id": 1951, "word": "គំហុក" },
    { "id": 1952, "word": "គំហែត" },
    { "id": 1953, "word": "គាំ" },
    { "id": 1954, "word": "គាំង" },
    { "id": 1955, "word": "គាំពារ" },
    { "id": 1956, "word": "គះ" },
    { "id": 1957, "word": "គះគា" },
    { "id": 1958, "word": "គ្នា" },
    { "id": 1959, "word": "គ្នាន់" },
    { "id": 1960, "word": "គ្នី" },
    { "id": 1961, "word": "គ្នេរ" },
    { "id": 1962, "word": "គ្នេរគ្នាន់" },
    { "id": 1963, "word": "គ្មាន" },
    { "id": 1964, "word": "គ្រ" },
    { "id": 1965, "word": "គ្រក" },
    { "id": 1966, "word": "គ្រកៗ" },
    { "id": 1967, "word": "គ្រក់" },
    { "id": 1968, "word": "គ្រក់ៗ" },
    { "id": 1969, "word": "គ្រង" },
    { "id": 1970, "word": "គ្រង់" },
    { "id": 1971, "word": "គ្រជីវ" },
    { "id": 1972, "word": "គ្រជឹប" },
    { "id": 1973, "word": "គ្រជឹបគ្រជីវ" },
    { "id": 1974, "word": "គ្រជឹបគ្រជួច" },
    { "id": 1975, "word": "គ្រជូរ" },
    { "id": 1976, "word": "គ្រជាំ" },
    { "id": 1977, "word": "គ្រញិច" },
    { "id": 1978, "word": "គ្រញឹក" },
    { "id": 1979, "word": "គ្រញូង" },
    { "id": 1980, "word": "គ្រញែង" },
    { "id": 1981, "word": "គ្រប" },
    { "id": 1982, "word": "គ្របគ្រង" },
    { "id": 1983, "word": "គ្របធ្មេញឈើ" },
    { "id": 1984, "word": "គ្រប់" },
    { "id": 1985, "word": "គ្រប់គ្រង" },
    { "id": 1986, "word": "គ្រមរ" },
    { "id": 1987, "word": "គ្រមល់" },
    { "id": 1988, "word": "គ្រមាក" },
    { "id": 1989, "word": "គ្រមាញ" },
    { "id": 1990, "word": "គ្រមាម" },
    { "id": 1991, "word": "គ្រមិងគ្រមាំង" },
    { "id": 1992, "word": "គ្រមើម" },
    { "id": 1993, "word": "គ្រមាំង" },
    { "id": 1994, "word": "គ្រលង់" },
    { "id": 1995, "word": "គ្រលរ" },
    { "id": 1996, "word": "គ្រលស" },
    { "id": 1997, "word": "គ្រលីត" },
    { "id": 1998, "word": "គ្រលុក" },
    { "id": 1999, "word": "គ្រលួង" },
    { "id": 2000, "word": "គ្រលួច" },
    { "id": 2001, "word": "គ្រលៀវ" },
    { "id": 2002, "word": "គ្រលៀស" },
    { "id": 2003, "word": "គ្រលេងគ្រលោង" },
    { "id": 2004, "word": "គ្រលេវ" },
    { "id": 2005, "word": "គ្រលែង" },
    { "id": 2006, "word": "គ្រលែងវែក" },
    { "id": 2007, "word": "គ្រវាត់" },
    { "id": 2008, "word": "គ្រវាស" },
    { "id": 2009, "word": "គ្រវី" },
    { "id": 2010, "word": "គ្រវីស" },
    { "id": 2011, "word": "គ្រវៀច" },
    { "id": 2012, "word": "គ្រវៀន" },
    { "id": 2013, "word": "គ្រវែង" },
    { "id": 2014, "word": "គ្រស៊ែត" },
    { "id": 2015, "word": "គ្រហរ" },
    { "id": 2016, "word": "គ្រហស្ថ" },
    { "id": 2017, "word": "គ្រហាញ" },
    { "id": 2018, "word": "គ្រហិកគ្រហុក" },
    { "id": 2019, "word": "គ្រហីត" },
    { "id": 2020, "word": "គ្រហឹម" },
    { "id": 2021, "word": "គ្រហុច" },
    { "id": 2022, "word": "គ្រហុប" },
    { "id": 2023, "word": "គ្រហូ" },
    { "id": 2024, "word": "គ្រហួង" },
    { "id": 2025, "word": "គ្រហុច" },
    { "id": 2026, "word": "គ្រហុប" },
    { "id": 2027, "word": "គ្រហើ" },
    { "id": 2028, "word": "គ្រហែត" },
    { "id": 2029, "word": "គ្រហែម" },
    { "id": 2030, "word": "គ្រា" },
    { "id": 2031, "word": "គ្រាក" },
    { "id": 2032, "word": "គ្រាក់" },
    { "id": 2033, "word": "គ្រាក់ៗ" },
    { "id": 2034, "word": "គ្រាង" },
    { "id": 2035, "word": "គ្រាន់" },
    { "id": 2036, "word": "គ្រាន់គ្រប់" },
    { "id": 2037, "word": "គ្រាន់តែ" },
    { "id": 2038, "word": "គ្រាន់បើ" },
    { "id": 2039, "word": "គ្រាប់" },
    { "id": 2040, "word": "គ្រាម" },
    { "id": 2041, "word": "គ្រាមណី" },
    { "id": 2042, "word": "គ្រាមភាសា" },
    { "id": 2043, "word": "គ្រាមភោជក" },
    { "id": 2044, "word": "គ្រាមមុខ" },
    { "id": 2045, "word": "គ្រាមេស" },
    { "id": 2046, "word": "គ្រាវ" },
    { "id": 2047, "word": "គ្រាស" },
    { "id": 2048, "word": "គ្រាហ៍" },
    { "id": 2049, "word": "គ្រាះ" },
    { "id": 2050, "word": "គ្រិចៗ" },
    { "id": 2051, "word": "គ្រិស្តសករាជ" },
    { "id": 2052, "word": "គ្រីតគ្រាត" },
    { "id": 2053, "word": "គ្រីប" },
    { "id": 2054, "word": "គ្រឹកៗ" },
    { "id": 2055, "word": "គ្រឹប" },
    { "id": 2056, "word": "គ្រឹមៗ" },
    { "id": 2057, "word": "គ្រឹហា" },
    { "id": 2058, "word": "គ្រឹហាវាស" },
    { "id": 2059, "word": "គ្រឹះ" },
    { "id": 2060, "word": "គ្រឹះស្ថាន" },
    { "id": 2061, "word": "គ្រឺតៗ" },
    { "id": 2062, "word": "គ្រុកៗ" },
    { "id": 2063, "word": "គ្រុឌ" },
    { "id": 2064, "word": "គ្រុន" },
    { "id": 2065, "word": "គ្រុប" },
    { "id": 2066, "word": "គ្រុម" },
    { "id": 2067, "word": "គ្រុយ" },
    { "id": 2068, "word": "គ្រុះ" },
    { "id": 2069, "word": "គ្រូ" },
    { "id": 2070, "word": "គ្រូក" },
    { "id": 2071, "word": "គ្រូបាធ្យាយ" },
    { "id": 2072, "word": "គ្រួ" },
    { "id": 2073, "word": "គ្រួបៗ" },
    { "id": 2074, "word": "គ្រួសារ" },
    { "id": 2075, "word": "គ្រើម" },
    { "id": 2076, "word": "គ្រើល" },
    { "id": 2077, "word": "គ្រឿង" },
    { "id": 2078, "word": "គ្រឿន" },
    { "id": 2079, "word": "គ្រៀវ" },
    { "id": 2080, "word": "គ្រៀស" },
    { "id": 2081, "word": "គ្រេង" },
    { "id": 2082, "word": "គ្រេច" },
    { "id": 2083, "word": "គ្រែ" },
    { "id": 2084, "word": "គ្រែង" },
    { "id": 2085, "word": "គ្រោង" },
    { "id": 2086, "word": "គ្រោត" },
    { "id": 2087, "word": "គ្រោះ" },
    { "id": 2088, "word": "គ្រោះជា" },
    { "id": 2089, "word": "គ្រុំ" },
    { "id": 2090, "word": "គ្រំ" },
    { "id": 2091, "word": "គ្រាំ" },
    { "id": 2092, "word": "គ្រាំគ្រា" },
    { "id": 2093, "word": "គ្រាំងៗ" },
    { "id": 2094, "word": "គ្វាម" },
    { "id": 2095, "word": "គតសញ្ញា" },
    { "id": 2096, "word": "គម្រៀវ" },
    { "id": 2097, "word": "គម្រេច" },
    { "id": 2098, "word": "គីឡូ" },
    { "id": 2099, "word": "គីឡូក្រាម" },
    { "id": 2100, "word": "គីឡូតោន" },
    { "id": 2101, "word": "គីឡូម៉ែត្រ" },
    { "id": 2102, "word": "គីឡូវ៉ាត់" },
    { "id": 2103, "word": "គីឡូវ៉ុល" },
    { "id": 2104, "word": "គីឡូស៊ីក" },
    { "id": 2105, "word": "គោលោត" },
    { "id": 2106, "word": "គំនក់" },
    { "id": 2107, "word": "គំនង" },
    { "id": 2108, "word": "គំនង់" },
    { "id": 2109, "word": "គំនន់" },
    { "id": 2110, "word": "គនប់" },
    { "id": 2111, "word": "គ្រាប់បែក" },
    { "id": 2112, "word": "ឃ" },
    { "id": 2113, "word": "ឃរណី" },
    { "id": 2114, "word": "ឃរមូល" },
    { "id": 2115, "word": "ឃរាវាស" },
    { "id": 2116, "word": "ឃាង" },
    { "id": 2117, "word": "ឃាត" },
    { "id": 2118, "word": "ឃាត់" },
    { "id": 2119, "word": "ឃាតកៈ" },
    { "id": 2120, "word": "ឃាតកម្ម" },
    { "id": 2121, "word": "ឃិនឆាយ" },
    { "id": 2122, "word": "ឃឹកៗ" },
    { "id": 2123, "word": "ឃឹម" },
    { "id": 2124, "word": "ឃុន" },
    { "id": 2125, "word": "ឃុយឆាយ" },
    { "id": 2126, "word": "ឃូរៗ" },
    { "id": 2127, "word": "ឃូសៗ" },
    { "id": 2128, "word": "ឃើញ" },
    { "id": 2129, "word": "ឃែត" },
    { "id": 2130, "word": "ឃោរ" },
    { "id": 2131, "word": "ឃោរឃៅ" },
    { "id": 2132, "word": "ឃោស" },
    { "id": 2133, "word": "ឃោសនា" },
    { "id": 2134, "word": "ឃោសនាការ" },
    { "id": 2135, "word": "ឃោសាឃោសវិមុត្ត" },
    { "id": 2136, "word": "ឃោស្នា" },
    { "id": 2137, "word": "ឃុំ" },
    { "id": 2138, "word": "ឃាំង" },
    { "id": 2139, "word": "ឃ្ញើច" },
    { "id": 2140, "word": "ឃ្នង" },
    { "id": 2141, "word": "ឃ្នាង" },
    { "id": 2142, "word": "ឃ្នាប" },
    { "id": 2143, "word": "ឃ្នូស" },
    { "id": 2144, "word": "ឃ្នើស" },
    { "id": 2145, "word": "ឃ្នើសឃ្នង" },
    { "id": 2146, "word": "ឃ្មង់" },
    { "id": 2147, "word": "ឃ្មត់" },
    { "id": 2148, "word": "ឃ្មមៗ" },
    { "id": 2149, "word": "ឃ្មាតខ្មី" },
    { "id": 2150, "word": "ឃ្មាមៗ" },
    { "id": 2151, "word": "ឃ្មឹក" },
    { "id": 2152, "word": "ឃ្មឹល" },
    { "id": 2153, "word": "ឃ្មោះ" },
    { "id": 2154, "word": "ឃ្មុំ" },
    { "id": 2155, "word": "ឃ្លង់" },
    { "id": 2156, "word": "ឃ្លា" },
    { "id": 2157, "word": "ឃ្លាត" },
    { "id": 2158, "word": "ឃ្លាតឃ្លា" },
    { "id": 2159, "word": "ឃ្លាតឃ្លៃ" },
    { "id": 2160, "word": "ឃ្លាន" },
    { "id": 2161, "word": "ឃ្លាយបាត" },
    { "id": 2162, "word": "ឃ្លិប" },
    { "id": 2163, "word": "ឃ្លុកៗ" },
    { "id": 2164, "word": "ឃ្លុប" },
    { "id": 2165, "word": "ឃ្លួប" },
    { "id": 2166, "word": "ឃ្លៀង" },
    { "id": 2167, "word": "ឃ្លៀងឃ្លាត" },
    { "id": 2168, "word": "ឃ្លៀច" },
    { "id": 2169, "word": "ឃ្លេ" },
    { "id": 2170, "word": "ឃ្លេងឃ្លោង" },
    { "id": 2171, "word": "ឃ្លៃ" },
    { "id": 2172, "word": "ឃ្លោក" },
    { "id": 2173, "word": "ឃ្លោង" },
    { "id": 2174, "word": "ឃ្លុំ" },
    { "id": 2175, "word": "ឃ្លាំ" },
    { "id": 2176, "word": "ឃ្លាំង" },
    { "id": 2177, "word": "ឃ្វាង" },
    { "id": 2178, "word": "ឃ្វាចៗ" },
    { "id": 2179, "word": "ឃ្វាម" },
    { "id": 2180, "word": "ឃ្វាយៗ" },
    { "id": 2181, "word": "ឃ្វាល" },
    { "id": 2182, "word": "ឃ្វិច" },
    { "id": 2183, "word": "ឃ្វើង" },
    { "id": 2184, "word": "ឃ្វើចៗ" },
    { "id": 2185, "word": "ង" },
    { "id": 2186, "word": "ងក់" },
    { "id": 2187, "word": "ង៉ក់" },
    { "id": 2188, "word": "ងងក់" },
    { "id": 2189, "word": "ងងល់" },
    { "id": 2190, "word": "ងងាស" },
    { "id": 2191, "word": "ងងិះងងុះ" },
    { "id": 2192, "word": "ងងីសងងាស" },
    { "id": 2193, "word": "ងងឹត" },
    { "id": 2194, "word": "ងងុយ" },
    { "id": 2195, "word": "ងងុល" },
    { "id": 2196, "word": "ងងុះ" },
    { "id": 2197, "word": "ងងូស" },
    { "id": 2198, "word": "ងងើល" },
    { "id": 2199, "word": "ងង៉េស" },
    { "id": 2200, "word": "ងប់" },
    { "id": 2201, "word": "ងរ" },
    { "id": 2202, "word": "ងា" },
    { "id": 2203, "word": "ងាក" },
    { "id": 2204, "word": "ង៉ាង" },
    { "id": 2205, "word": "ង៉ាងៗ" },
    { "id": 2206, "word": "ង៉ាញ់ៗ" },
    { "id": 2207, "word": "ងាប់" },
    { "id": 2208, "word": "ងាយ" },
    { "id": 2209, "word": "ងារ" },
    { "id": 2210, "word": "ងាវ" },
    { "id": 2211, "word": "ង៉ាវ" },
    { "id": 2212, "word": "ង៉ាវៗ" },
    { "id": 2213, "word": "ងាស" },
    { "id": 2214, "word": "ងាស់" },
    { "id": 2215, "word": "ង៉ិកង៉ក់" },
    { "id": 2216, "word": "ងីក" },
    { "id": 2217, "word": "ងីងើ" },
    { "id": 2218, "word": "ងីវ" },
    { "id": 2219, "word": "ងឹល" },
    { "id": 2220, "word": "ង៉ឹក" },
    { "id": 2221, "word": "ងឺៗ" },
    { "id": 2222, "word": "ង៉ឺតៗ" },
    { "id": 2223, "word": "ង៉ឺសៗ" },
    { "id": 2224, "word": "ង៉ុម" },
    { "id": 2225, "word": "ង៉ុមៗ" },
    { "id": 2226, "word": "ងុរងក់" },
    { "id": 2227, "word": "ង៉ុលៗ" },
    { "id": 2228, "word": "ងូងៗ" },
    { "id": 2229, "word": "ង៉ូង" },
    { "id": 2230, "word": "ងូត" },
    { "id": 2231, "word": "ង៉ូតៗ" },
    { "id": 2232, "word": "ង៉ូវៗ" },
    { "id": 2233, "word": "ងូសៗ" },
    { "id": 2234, "word": "ងើត" },
    { "id": 2235, "word": "ងើប" },
    { "id": 2236, "word": "ងើយ" },
    { "id": 2237, "word": "ងឿ" },
    { "id": 2238, "word": "ងឿក" },
    { "id": 2239, "word": "ងឿង" },
    { "id": 2240, "word": "ងៀង" },
    { "id": 2241, "word": "ងៀត" },
    { "id": 2242, "word": "ង៉េកៗ" },
    { "id": 2243, "word": "ងេកងោក" },
    { "id": 2244, "word": "ងេងងោង" },
    { "id": 2245, "word": "ងេងើ" },
    { "id": 2246, "word": "ង៉េតៗ" },
    { "id": 2247, "word": "ង៉េវៗ" },
    { "id": 2248, "word": "ង៉េសៗ" },
    { "id": 2249, "word": "ង៉េះៗ" },
    { "id": 2250, "word": "ង៉ែង៉" },
    { "id": 2251, "word": "ង៉ែង៉រ" },
    { "id": 2252, "word": "ង៉ែត" },
    { "id": 2253, "word": "ង៉ៃ" },
    { "id": 2254, "word": "ងោក" },
    { "id": 2255, "word": "ង៉ោកង៉ាក" },
    { "id": 2256, "word": "ងោង" },
    { "id": 2257, "word": "ង៉ោង" },
    { "id": 2258, "word": "ងោចៗ" },
    { "id": 2259, "word": "ងោះ" },
    { "id": 2260, "word": "ង៉ោះៗ" },
    { "id": 2261, "word": "ងៅ" },
    { "id": 2262, "word": "ង៉ៅ" },
    { "id": 2263, "word": "ងំ" },
    { "id": 2264, "word": "ង៉ាំ" },
    { "id": 2265, "word": "ងាំៗ" },
    { "id": 2266, "word": "ងាំង" },
    { "id": 2267, "word": "ង៉ាំង" },
    { "id": 2268, "word": "ច" },
    { "id": 2269, "word": "ចក" },
    { "id": 2270, "word": "ចក់" },
    { "id": 2271, "word": "ច័ក្កច័ន" },
    { "id": 2272, "word": "ចក្ខុ" },
    { "id": 2273, "word": "ចក្ខុ--" },
    { "id": 2274, "word": "ចក្រ" },
    { "id": 2275, "word": "ចក្រក្រឹស្ណ" },
    { "id": 2276, "word": "ចក្របាណី" },
    { "id": 2277, "word": "ចក្រពង្ស" },
    { "id": 2278, "word": "ចក្រពត្តិ" },
    { "id": 2279, "word": "ចក្រពត្តិនិយម" },
    { "id": 2280, "word": "ចក្រពត្រាធិរាជ" },
    { "id": 2281, "word": "ចក្ររាសី" },
    { "id": 2282, "word": "ចក្រវាត" },
    { "id": 2283, "word": "ចក្រវាល" },
    { "id": 2284, "word": "ចក្រាយុធ" },
    { "id": 2285, "word": "ចក្រី" },
    { "id": 2286, "word": "ចក្សុ" },
    { "id": 2287, "word": "ចង" },
    { "id": 2288, "word": "ចងការ" },
    { "id": 2289, "word": "ចងដៃ" },
    { "id": 2290, "word": "ចងពន្ធ" },
    { "id": 2291, "word": "ចងពុង" },
    { "id": 2292, "word": "ចងសំរោង" },
    { "id": 2293, "word": "ចង់" },
    { "id": 2294, "word": "ចង្កា" },
    { "id": 2295, "word": "ចង្កាក់" },
    { "id": 2296, "word": "ចង្កឹះ" },
    { "id": 2297, "word": "ចង្កុលណី" },
    { "id": 2298, "word": "ចង្កូត" },
    { "id": 2299, "word": "ចង្កូម" },
    { "id": 2300, "word": "ចង្កូមស្កា" },
    { "id": 2301, "word": "ចង្កួយ" },
    { "id": 2302, "word": "ចង្កៀង" },
    { "id": 2303, "word": "ចង្កៀល" },
    { "id": 2304, "word": "ចង្កៀលខ្យង" },
    { "id": 2305, "word": "ចង្កៀស" },
    { "id": 2306, "word": "ចង្កេះ" },
    { "id": 2307, "word": "ចង្កោម" },
    { "id": 2308, "word": "ចង្កំ" },
    { "id": 2309, "word": "ចង្ក្រង់" },
    { "id": 2310, "word": "ចង្ក្រង់ស្វា" },
    { "id": 2311, "word": "ចង្ក្រត់" },
    { "id": 2312, "word": "ចង្ក្រម" },
    { "id": 2313, "word": "ចង្ក្រាន" },
    { "id": 2314, "word": "ចង្គ្រក់" },
    { "id": 2315, "word": "ចង្គ្រាង" },
    { "id": 2316, "word": "ចង្គ្រាស់" },
    { "id": 2317, "word": "ចង្គ្រុង" },
    { "id": 2318, "word": "ចង្គ្រោង" },
    { "id": 2319, "word": "ចង្រក" },
    { "id": 2320, "word": "ចង្រប់" },
    { "id": 2321, "word": "ចង្រិត" },
    { "id": 2322, "word": "ចង្រៃ" },
    { "id": 2323, "word": "ចង្វា" },
    { "id": 2324, "word": "ចង្វាក់" },
    { "id": 2325, "word": "ចង្វាយ" },
    { "id": 2326, "word": "ចង្វែក" },
    { "id": 2327, "word": "ចង្ហាន់" },
    { "id": 2328, "word": "ចង្ហាយ" },
    { "id": 2329, "word": "ចង្ហូរ" },
    { "id": 2330, "word": "ចង្អល់" },
    { "id": 2331, "word": "ចង្អុល" },
    { "id": 2332, "word": "ចង្អុលខ្មោច" },
    { "id": 2333, "word": "ចង្អុលដៃ" },
    { "id": 2334, "word": "ចង្អូរ" },
    { "id": 2335, "word": "ចង្អួរ" },
    { "id": 2336, "word": "ចង្អួរត្មាត" },
    { "id": 2337, "word": "ចង្អើរ" },
    { "id": 2338, "word": "ចង្អៀត" },
    { "id": 2339, "word": "ចង្អេរ" },
    { "id": 2340, "word": "ចង្អោរ" },
    { "id": 2341, "word": "ចចក" },
    { "id": 2342, "word": "ចចក់" },
    { "id": 2343, "word": "ចចាកអារ៉ាក" },
    { "id": 2344, "word": "ចចាក់ចចុច" },
    { "id": 2345, "word": "ចចាត" },
    { "id": 2346, "word": "ចចាមអារ៉ាម" },
    { "id": 2347, "word": "ចចិកចចុក" },
    { "id": 2348, "word": "ចចឹក" },
    { "id": 2349, "word": "ចចូត" },
    { "id": 2350, "word": "ចចើង" },
    { "id": 2351, "word": "ចចេស" },
    { "id": 2352, "word": "ចច្រេសចច្រាស" },
    { "id": 2353, "word": "ចណ្ឌ" },
    { "id": 2354, "word": "ចណ្ឌាល" },
    { "id": 2355, "word": "ចណ្ឌាលី" },
    { "id": 2356, "word": "ចត" },
    { "id": 2357, "word": "ចត់" },
    { "id": 2358, "word": "ចតុ" },
    { "id": 2359, "word": "ចតុក្កុលវគ្គ" },
    { "id": 2360, "word": "ចតុទ្ទិស" },
    { "id": 2361, "word": "ចតុទ្វីប" },
    { "id": 2362, "word": "ចតុប្បច្ច័យ" },
    { "id": 2363, "word": "ចតុប្បាទ" },
    { "id": 2364, "word": "ចតុប្បារិសុទ្ធិសីល" },
    { "id": 2365, "word": "ចតុព្ភាគ" },
    { "id": 2366, "word": "ចតុព្ភាគី" },
    { "id": 2367, "word": "ចតុព្ភូត" },
    { "id": 2368, "word": "ចតុម្មុខ" },
    { "id": 2369, "word": "ចតុរង្គ" },
    { "id": 2370, "word": "ចតុរង្គសន្និបាត" },
    { "id": 2371, "word": "ចតុរង្គាធិបតី" },
    { "id": 2372, "word": "ចតុរង្គិនី" },
    { "id": 2373, "word": "ចតុរ័ង្ស" },
    { "id": 2374, "word": "ចតុរមុខ" },
    { "id": 2375, "word": "ចតុរស្ស" },
    { "id": 2376, "word": "ចតុរាបាយ" },
    { "id": 2377, "word": "ចតុរារិយសច្ច" },
    { "id": 2378, "word": "ចតុលោកបាល" },
    { "id": 2379, "word": "ចតុស្ដម្ភ" },
    { "id": 2380, "word": "ចត្រង្គ" },
    { "id": 2381, "word": "ចត្វ័ង្ស" },
    { "id": 2382, "word": "ចត្វា" },
    { "id": 2383, "word": "ច័ន" },
    { "id": 2384, "word": "ចន្ទ" },
    { "id": 2385, "word": "ចន្ទគតិ" },
    { "id": 2386, "word": "ចន្ទគតិកាល" },
    { "id": 2387, "word": "ចន្ទច្ឆាយា" },
    { "id": 2388, "word": "ចន្ទន៍" },
    { "id": 2389, "word": "ចន្ទមណ្ឌល" },
    { "id": 2390, "word": "ចន្ទរង្សី" },
    { "id": 2391, "word": "ចន្ទល់" },
    { "id": 2392, "word": "ចន្ទលេខា" },
    { "id": 2393, "word": "ចន្ទាកា" },
    { "id": 2394, "word": "ចន្ទាល់" },
    { "id": 2395, "word": "ចន្ទាស" },
    { "id": 2396, "word": "ចន្ទាស់" },
    { "id": 2397, "word": "ចន្ទាស់ទឹក" },
    { "id": 2398, "word": "ចន្ទី" },
    { "id": 2399, "word": "ចន្ទូបមា" },
    { "id": 2400, "word": "ចន្ទោភាស" },
    { "id": 2401, "word": "ចន្ទោល" },
    { "id": 2402, "word": "ចន្ទ្រ" },
    { "id": 2403, "word": "ចន្ទ្រគ្រាស" },
    { "id": 2404, "word": "ច័ន្ធូ" },
    { "id": 2405, "word": "ចន្លន់" },
    { "id": 2406, "word": "ចន្លុះ" },
    { "id": 2407, "word": "ចន្លោះ" },
    { "id": 2408, "word": "ចប" },
    { "id": 2409, "word": "ចប់" },
    { "id": 2410, "word": "ចម" },
    { "id": 2411, "word": "ចម្កយ" },
    { "id": 2412, "word": "ចម្ការ" },
    { "id": 2413, "word": "ចម្ការលើ" },
    { "id": 2414, "word": "ចម្កួត" },
    { "id": 2415, "word": "ចម្ងាយ" },
    { "id": 2416, "word": "ចម្បង" },
    { "id": 2417, "word": "ចម្ប៉ា" },
    { "id": 2418, "word": "ចម្ប៉ាដាក់" },
    { "id": 2419, "word": "ចម្បាំង" },
    { "id": 2420, "word": "ចម្ពាម" },
    { "id": 2421, "word": "ចម្មបក្សី" },
    { "id": 2422, "word": "ចម្រក" },
    { "id": 2423, "word": "ចម្រាញ់" },
    { "id": 2424, "word": "ចម្រាស" },
    { "id": 2425, "word": "ចម្រឹង" },
    { "id": 2426, "word": "ចម្រុង" },
    { "id": 2427, "word": "ចម្រុះ" },
    { "id": 2428, "word": "ចម្រូង" },
    { "id": 2429, "word": "ចម្រូងចម្រាស" },
    { "id": 2430, "word": "ចម្រូត" },
    { "id": 2431, "word": "ចម្រើន" },
    { "id": 2432, "word": "ចម្រៀក" },
    { "id": 2433, "word": "ចម្រៀង" },
    { "id": 2434, "word": "ចម្រេះ" },
    { "id": 2435, "word": "ចម្រោះ" },
    { "id": 2436, "word": "ចម្លង" },
    { "id": 2437, "word": "ចម្លាក់" },
    { "id": 2438, "word": "ចម្លើយ" },
    { "id": 2439, "word": "ចម្លែក" },
    { "id": 2440, "word": "ចម្អាប" },
    { "id": 2441, "word": "ចម្អិន" },
    { "id": 2442, "word": "ចម្អឹង" },
    { "id": 2443, "word": "ចម្អេះ" },
    { "id": 2444, "word": "ចម្អែត" },
    { "id": 2445, "word": "ចរ" },
    { "id": 2446, "word": "ចរក" },
    { "id": 2447, "word": "ចរចា" },
    { "id": 2448, "word": "ចរច្រប់" },
    { "id": 2449, "word": "ចរណៈ" },
    { "id": 2450, "word": "ចរណាវុធ" },
    { "id": 2451, "word": "ចរណៃ" },
    { "id": 2452, "word": "ចរន្ត" },
    { "id": 2453, "word": "ចរភាព" },
    { "id": 2454, "word": "ចរលីលា" },
    { "id": 2455, "word": "ចរាចរ" },
    { "id": 2456, "word": "ចរាចរក" },
    { "id": 2457, "word": "ចររាចរណ៍" },
    { "id": 2458, "word": "ចរិត" },
    { "id": 2459, "word": "ចរិយា" },
    { "id": 2460, "word": "ចរិយាសាស្ត្រ" },
    { "id": 2461, "word": "ចរី" },
    { "id": 2462, "word": "ចល័ត" },
    { "id": 2463, "word": "ចលនវត្ថុ" },
    { "id": 2464, "word": "ចលនា" },
    { "id": 2465, "word": "ចលនាចក្រ" },
    { "id": 2466, "word": "ចលាចល" },
    { "id": 2467, "word": "ចហាង" },
    { "id": 2468, "word": "ចាក" },
    { "id": 2469, "word": "ចាក់" },
    { "id": 2470, "word": "ចាក់កណ្ដាញ់" },
    { "id": 2471, "word": "ចាក់កន្ទ្រង់" },
    { "id": 2472, "word": "ចាក់ក្រឡេក" },
    { "id": 2473, "word": "ចាក់ចុច" },
    { "id": 2474, "word": "ចាក់ចុល" },
    { "id": 2475, "word": "ចាក់ច្រាស" },
    { "id": 2476, "word": "ចាក់ច្រែង" },
    { "id": 2477, "word": "ចាក់ឆែវ" },
    { "id": 2478, "word": "ចាក់ទីង" },
    { "id": 2479, "word": "ចាក់ទឹកដូង" },
    { "id": 2480, "word": "ចាក់បណ្ដោយ" },
    { "id": 2481, "word": "ចាក់ស្មុគ" },
    { "id": 2482, "word": "ចាក់ស្រេះ" },
    { "id": 2483, "word": "ចាកឹក" },
    { "id": 2484, "word": "ចាក្រពាក" },
    { "id": 2485, "word": "ចាគៈ" },
    { "id": 2486, "word": "ចាគចេតនា" },
    { "id": 2487, "word": "ចាង" },
    { "id": 2488, "word": "ចាងណាង" },
    { "id": 2489, "word": "ចាងវ៉ាង" },
    { "id": 2490, "word": "ចាច់!" },
    { "id": 2491, "word": "ចាញ់" },
    { "id": 2492, "word": "ចាត់" },
    { "id": 2493, "word": "ចាត់ចែង" },
    { "id": 2494, "word": "ចាន" },
    { "id": 2495, "word": "ចាប" },
    { "id": 2496, "word": "ចាបចង្ក្រង់" },
    { "id": 2497, "word": "ចាប់" },
    { "id": 2498, "word": "ចាប់កូនខ្លែង" },
    { "id": 2499, "word": "ចាប់ចិត្ត" },
    { "id": 2500, "word": "ចាប់ឆាយ" },
    { "id": 2501, "word": "ចាប់ដក" },
    { "id": 2502, "word": "ចាប់ភ្លឹក" },
    { "id": 2503, "word": "ចាប៉ី" },
    { "id": 2504, "word": "ចាប៉ឹក" },
    { "id": 2505, "word": "ចាប៉ឹង" },
    { "id": 2506, "word": "ចាប៉ុក" },
    { "id": 2507, "word": "ចាប៉ុច" },
    { "id": 2508, "word": "ចាព្លូ" },
    { "id": 2509, "word": "ចាម" },
    { "id": 2510, "word": "ចាមរ" },
    { "id": 2511, "word": "ចាមរី" },
    { "id": 2512, "word": "ចាយ" },
    { "id": 2513, "word": "ចាយដី" },
    { "id": 2514, "word": "ចារ" },
    { "id": 2515, "word": "ចារចែង" },
    { "id": 2516, "word": "ចារបុរស" },
    { "id": 2517, "word": "ចារិក" },
    { "id": 2518, "word": "ចារឹក" },
    { "id": 2519, "word": "ចារុ៍" },
    { "id": 2520, "word": "ចាល" },
    { "id": 2521, "word": "ចាល់" },
    { "id": 2522, "word": "ចាវ" },
    { "id": 2523, "word": "ចាស" },
    { "id": 2524, "word": "ចាស់" },
    { "id": 2525, "word": "ចាហួយ" },
    { "id": 2526, "word": "ចិក" },
    { "id": 2527, "word": "ចិញ្ចាច" },
    { "id": 2528, "word": "ចិញ្ចឹម" },
    { "id": 2529, "word": "ចិញ្ចើម" },
    { "id": 2530, "word": "ចិញ្ចៀន" },
    { "id": 2531, "word": "ចិញ្ចែង" },
    { "id": 2532, "word": "ចិញ្ច្រាំ" },
    { "id": 2533, "word": "ចិត" },
    { "id": 2534, "word": "ចិតសិប" },
    { "id": 2535, "word": "ចិត្ត" },
    { "id": 2536, "word": "ចិត្ត" },
    { "id": 2537, "word": "ចិត្រមូលភ្លើង" },
    { "id": 2538, "word": "ចិន" },
    { "id": 2539, "word": "ចិន្តនាការ" },
    { "id": 2540, "word": "ចិន្ដា" },
    { "id": 2541, "word": "ចិន្ដាមណី" },
    { "id": 2542, "word": "ចិរស្សការ" },
    { "id": 2543, "word": "ចីពរ" },
    { "id": 2544, "word": "ចីរកាល" },
    { "id": 2545, "word": "ចីរចរ" },
    { "id": 2546, "word": "ចីវរ" },
    { "id": 2547, "word": "ចីវរកាល" },
    { "id": 2548, "word": "ចឹក" },
    { "id": 2549, "word": "ចឹប" },
    { "id": 2550, "word": "ចីបចរ" },
    { "id": 2551, "word": "ចឹស" },
    { "id": 2552, "word": "ចឺងគ្រឹមៗ" },
    { "id": 2553, "word": "ចឺន" },
    { "id": 2554, "word": "ចឺម" },
    { "id": 2555, "word": "ចុក" },
    { "id": 2556, "word": "ចុង" },
    { "id": 2557, "word": "ចុងកាល់" },
    { "id": 2558, "word": "ចុងកុល" },
    { "id": 2559, "word": "ចុងដួច" },
    { "id": 2560, "word": "ចុងភៅ" },
    { "id": 2561, "word": "ចុងអង្ករ" },
    { "id": 2562, "word": "ចុងអំបុក" },
    { "id": 2563, "word": "ចុច" },
    { "id": 2564, "word": "ចុតិ" },
    { "id": 2565, "word": "ចុន" },
    { "id": 2566, "word": "ចុយ" },
    { "id": 2567, "word": "ចុល្លសករាជ" },
    { "id": 2568, "word": "ចុះ" },
    { "id": 2569, "word": "ចុះប្រេង" },
    { "id": 2570, "word": "ចូក" },
    { "id": 2571, "word": "ចូរ" },
    { "id": 2572, "word": "ចូល" },
    { "id": 2573, "word": "ចូឡពន" },
    { "id": 2574, "word": "ចូឡា" },
    { "id": 2575, "word": "ចូឡាមណី" },
    { "id": 2576, "word": "ចួន" },
    { "id": 2577, "word": "ចួប" },
    { "id": 2578, "word": "ចើក" },
    { "id": 2579, "word": "ចើងម៉ើង" },
    { "id": 2580, "word": "ចើស" },
    { "id": 2581, "word": "ចៀន" },
    { "id": 2582, "word": "ចៀនចួន" },
    { "id": 2583, "word": "ចៀម" },
    { "id": 2584, "word": "ចៀមជាំ" },
    { "id": 2585, "word": "ចៀរ" },
    { "id": 2586, "word": "ចៀស" },
    { "id": 2587, "word": "ចេក" },
    { "id": 2588, "word": "ចេកទេស" },
    { "id": 2589, "word": "ចេកទុំ" },
    { "id": 2590, "word": "ចេចៗ" },
    { "id": 2591, "word": "ចេចចាច" },
    { "id": 2592, "word": "ចេញ" },
    { "id": 2593, "word": "ចេតនា" },
    { "id": 2594, "word": "ចេតបុត្រ" },
    { "id": 2595, "word": "ចេតិយ" },
    { "id": 2596, "word": "ចេត្រ" },
    { "id": 2597, "word": "ចេតសិក" },
    { "id": 2598, "word": "ចេបៗ" },
    { "id": 2599, "word": "ចេរ" },
    { "id": 2600, "word": "ចេរចា" },
    { "id": 2601, "word": "ចេរវិល" },
    { "id": 2602, "word": "ចេលកជន" },
    { "id": 2603, "word": "ចេស" },
    { "id": 2604, "word": "ចេស្ដា" },
    { "id": 2605, "word": "ចេះ" },
    { "id": 2606, "word": "ចែ" },
    { "id": 2607, "word": "ចែៗ" },
    { "id": 2608, "word": "ចែក" },
    { "id": 2609, "word": "ចែង" },
    { "id": 2610, "word": "ចែងចា" },
    { "id": 2611, "word": "ចែងថ្ងៃ" },
    { "id": 2612, "word": "ចែងម៉ែង" },
    { "id": 2613, "word": "ចែងវ៉ែង" },
    { "id": 2614, "word": "ចែចូវ" },
    { "id": 2615, "word": "ចែត" },
    { "id": 2616, "word": "ចែប៉ប្រែ" },
    { "id": 2617, "word": "ចែវ" },
    { "id": 2618, "word": "ចែស" },
    { "id": 2619, "word": "ចៃ" },
    { "id": 2620, "word": "ចៃដន់" },
    { "id": 2621, "word": "ចៃដី" },
    { "id": 2622, "word": "ចៃត្យ" },
    { "id": 2623, "word": "ចៃរ៉ា" },
    { "id": 2624, "word": "ចោងហោង" },
    { "id": 2625, "word": "ចោត" },
    { "id": 2626, "word": "ចោទ" },
    { "id": 2627, "word": "ចោទកៈ" },
    { "id": 2628, "word": "ចោទនា" },
    { "id": 2629, "word": "ចោម" },
    { "id": 2630, "word": "ចោមពុង" },
    { "id": 2631, "word": "ចោរ" },
    { "id": 2632, "word": "ចោរកណ្ដកៈ" },
    { "id": 2633, "word": "ចោរកន្ដារ" },
    { "id": 2634, "word": "ចោរកម្ម" },
    { "id": 2635, "word": "ចោរឃាត" },
    { "id": 2636, "word": "ចោរឃាតកៈ" },
    { "id": 2637, "word": "ចោរឃាតកម្ម" },
    { "id": 2638, "word": "ចោល" },
    { "id": 2639, "word": "ចោះ" },
    { "id": 2640, "word": "ចៅ" },
    { "id": 2641, "word": "ចៅកូវ" },
    { "id": 2642, "word": "ចៅក្រម" },
    { "id": 2643, "word": "ចៅចម" },
    { "id": 2644, "word": "ចៅជិត" },
    { "id": 2645, "word": "ចៅទេស" },
    { "id": 2646, "word": "ចៅទៃ" },
    { "id": 2647, "word": "ចៅពញា" },
    { "id": 2648, "word": "ចៅរ៉ៅ" },
    { "id": 2649, "word": "ចៅហ្វាយ" },
    { "id": 2650, "word": "ចៅអធិការ" },
    { "id": 2651, "word": "ចំ" },
    { "id": 2652, "word": "ចំកាង" },
    { "id": 2653, "word": "ចំកោង" },
    { "id": 2654, "word": "ចំណង" },
    { "id": 2655, "word": "ចំណង់" },
    { "id": 2656, "word": "ចំណត" },
    { "id": 2657, "word": "ចំណត់" },
    { "id": 2658, "word": "ចំណាក់" },
    { "id": 2659, "word": "ចំណាន" },
    { "id": 2660, "word": "ចំណាប់" },
    { "id": 2661, "word": "ចំណាយ" },
    { "id": 2662, "word": "ចំណារ" },
    { "id": 2663, "word": "ចំណាល់" },
    { "id": 2664, "word": "ចំណាស់" },
    { "id": 2665, "word": "ចំណិត" },
    { "id": 2666, "word": "ចំណី" },
    { "id": 2667, "word": "ចំណុក" },
    { "id": 2668, "word": "ចំណុច" },
    { "id": 2669, "word": "ចំណុចចិត្ត" },
    { "id": 2670, "word": "ចំណុះ" },
    { "id": 2671, "word": "ចំណូក" },
    { "id": 2672, "word": "ចំណូរ" },
    { "id": 2673, "word": "ចំណូល" },
    { "id": 2674, "word": "ចំណេញ" },
    { "id": 2675, "word": "ចំណេរ" },
    { "id": 2676, "word": "ចំណេះ" },
    { "id": 2677, "word": "ចំណែក" },
    { "id": 2678, "word": "ចំណោត" },
    { "id": 2679, "word": "ចំណោទ" },
    { "id": 2680, "word": "ចំណោម" },
    { "id": 2681, "word": "ចំណោះ" },
    { "id": 2682, "word": "ចំណាំ" },
    { "id": 2683, "word": "ចំណាំតែ" },
    { "id": 2684, "word": "ចំណាំង" },
    { "id": 2685, "word": "ចំតិត" },
    { "id": 2686, "word": "ចំតូង" },
    { "id": 2687, "word": "ចំតើត" },
    { "id": 2688, "word": "ចំទង់" },
    { "id": 2689, "word": "ចំទយ" },
    { "id": 2690, "word": "ចំទាញ" },
    { "id": 2691, "word": "ចំទាល" },
    { "id": 2692, "word": "ចំទាស់" },
    { "id": 2693, "word": "ចំទួយ" },
    { "id": 2694, "word": "ចំទើត" },
    { "id": 2695, "word": "ចំទើរ" },
    { "id": 2696, "word": "ចំទើស" },
    { "id": 2697, "word": "ចំទែង" },
    { "id": 2698, "word": "ចំទាំង" },
    { "id": 2699, "word": "ចំនួន" },
    { "id": 2700, "word": "ចំនួប" },
    { "id": 2701, "word": "ចំនៀរ" },
    { "id": 2702, "word": "ចំបក់" },
    { "id": 2703, "word": "ចំបាប់" },
    { "id": 2704, "word": "ចំប៉ី" },
    { "id": 2705, "word": "ចំប៉ីទេស" },
    { "id": 2706, "word": "ចំបួរ" },
    { "id": 2707, "word": "ចំបើង" },
    { "id": 2708, "word": "ចំបែង" },
    { "id": 2709, "word": "ចំប្រប់" },
    { "id": 2710, "word": "ចំប្រាវ" },
    { "id": 2711, "word": "ចំពប់" },
    { "id": 2712, "word": "ចំពាក់" },
    { "id": 2713, "word": "ចំពាស់" },
    { "id": 2714, "word": "ចំពិត" },
    { "id": 2715, "word": "ចំពុះ" },
    { "id": 2716, "word": "ចំពុះទា" },
    { "id": 2717, "word": "ចំពុះទុង" },
    { "id": 2718, "word": "ចំពូក" },
    { "id": 2719, "word": "ចំពួក" },
    { "id": 2720, "word": "ចំពួយ" },
    { "id": 2721, "word": "ចំពើប" },
    { "id": 2722, "word": "ចំពោះ" },
    { "id": 2723, "word": "ចំឡក" },
    { "id": 2724, "word": "ចំឡក់" },
    { "id": 2725, "word": "ចំលៀវ" },
    { "id": 2726, "word": "ចំឡៅក្អែក" },
    { "id": 2727, "word": "ចំហ" },
    { "id": 2728, "word": "ចំហាយ" },
    { "id": 2729, "word": "ចំហុង" },
    { "id": 2730, "word": "ចំហុត" },
    { "id": 2731, "word": "ចំហុយ" },
    { "id": 2732, "word": "ចំហូវ" },
    { "id": 2733, "word": "ចំហៀង" },
    { "id": 2734, "word": "ចំហៀវ" },
    { "id": 2735, "word": "ចំហាំង" },
    { "id": 2736, "word": "ចំអក" },
    { "id": 2737, "word": "ចំអន់" },
    { "id": 2738, "word": "ចំអាម" },
    { "id": 2739, "word": "ចំអាស" },
    { "id": 2740, "word": "ចំអើត" },
    { "id": 2741, "word": "ចំអៀក" },
    { "id": 2742, "word": "ចំអេង" },
    { "id": 2743, "word": "ចំអែ" },
    { "id": 2744, "word": "ចាំ" },
    { "id": 2745, "word": "ចាំង" },
    { "id": 2746, "word": "ចាំងជើង" },
    { "id": 2747, "word": "ចាំតែ" },
    { "id": 2748, "word": "ចាំបាច់" },
    { "id": 2749, "word": "ច្នឹង" },
    { "id": 2750, "word": "ច្នេះ" },
    { "id": 2751, "word": "ច្នៃ" },
    { "id": 2752, "word": "ច្នោះ" },
    { "id": 2753, "word": "ច្បង" },
    { "id": 2754, "word": "ច្បា" },
    { "id": 2755, "word": "ច្បាក់" },
    { "id": 2756, "word": "ច្បាប់" },
    { "id": 2757, "word": "ច្បាប់ក្រម" },
    { "id": 2758, "word": "ច្បាម" },
    { "id": 2759, "word": "ច្បារ" },
    { "id": 2760, "word": "ច្បាស់" },
    { "id": 2761, "word": "ច្បាស់ច្បង" },
    { "id": 2762, "word": "ច្បាស់លាស់" },
    { "id": 2763, "word": "ច្បិច" },
    { "id": 2764, "word": "ច្បិចច្បើម" },
    { "id": 2765, "word": "ច្បុច" },
    { "id": 2766, "word": "ច្បូក" },
    { "id": 2767, "word": "ច្បូត" },
    { "id": 2768, "word": "ច្បែប" },
    { "id": 2769, "word": "ច្បោល" },
    { "id": 2770, "word": "ច្បោលៗ" },
    { "id": 2771, "word": "ច្បោស" },
    { "id": 2772, "word": "ច្បោះ" },
    { "id": 2773, "word": "ច្បាំង" },
    { "id": 2774, "word": "ច្យុត" },
    { "id": 2775, "word": "ច្យុតិ" },
    { "id": 2776, "word": "ច្រក" },
    { "id": 2777, "word": "ច្រក់" },
    { "id": 2778, "word": "ច្រកាចច្រកូវ" },
    { "id": 2779, "word": "ច្រកែង" },
    { "id": 2780, "word": "ច្រកែងទួយ" },
    { "id": 2781, "word": "ច្រគាង" },
    { "id": 2782, "word": "ច្រគីងច្រគាង" },
    { "id": 2783, "word": "ច្រង់" },
    { "id": 2784, "word": "ច្រងក់" },
    { "id": 2785, "word": "ច្រងាង" },
    { "id": 2786, "word": "ច្រងាប់ច្រងិល" },
    { "id": 2787, "word": "ច្រងាម" },
    { "id": 2788, "word": "ច្រងូវ" },
    { "id": 2789, "word": "ច្រងេងច្រងាង" },
    { "id": 2790, "word": "ច្រងោ" },
    { "id": 2791, "word": "ច្រងាំង" },
    { "id": 2792, "word": "ច្រច" },
    { "id": 2793, "word": "ច្រចៗ" },
    { "id": 2794, "word": "ច្រណែន" },
    { "id": 2795, "word": "ច្រត់" },
    { "id": 2796, "word": "ច្រត់នង្គ័ល" },
    { "id": 2797, "word": "ច្រនួច" },
    { "id": 2798, "word": "ច្រនៀង" },
    { "id": 2799, "word": "ច្រប់" },
    { "id": 2800, "word": "ច្រប់" },
    { "id": 2801, "word": "ច្របល់" },
    { "id": 2802, "word": "ច្របាច់" },
    { "id": 2803, "word": "ច្របុច" },
    { "id": 2804, "word": "ច្របូក" },
    { "id": 2805, "word": "ច្របូញ" },
    { "id": 2806, "word": "ច្រពើង" },
    { "id": 2807, "word": "ច្រពើស" },
    { "id": 2808, "word": "ច្រម" },
    { "id": 2809, "word": "ច្រមក់" },
    { "id": 2810, "word": "ច្រមិច" },
    { "id": 2811, "word": "ច្រមុះ" },
    { "id": 2812, "word": "ច្រមូញ" },
    { "id": 2813, "word": "ច្រមូល" },
    { "id": 2814, "word": "ច្រមួន" },
    { "id": 2815, "word": "ច្រវា" },
    { "id": 2816, "word": "ច្រវាក់" },
    { "id": 2817, "word": "ច្រវាត់" },
    { "id": 2818, "word": "ច្រវាប" },
    { "id": 2819, "word": "ច្រវេះ" },
    { "id": 2820, "word": "ច្រវែប" },
    { "id": 2821, "word": "ច្រវោះ" },
    { "id": 2822, "word": "ច្រសៗ" },
    { "id": 2823, "word": "ច្រហ" },
    { "id": 2824, "word": "ច្រហាញ់" },
    { "id": 2825, "word": "ច្រហាប" },
    { "id": 2826, "word": "ច្រហេញ" },
    { "id": 2827, "word": "ច្រហោង" },
    { "id": 2828, "word": "ច្រហោះ" },
    { "id": 2829, "word": "ច្រហាំង" },
    { "id": 2830, "word": "ច្រឡាស" },
    { "id": 2831, "word": "ច្រឡឹង" },
    { "id": 2832, "word": "ច្រឡឺម" },
    { "id": 2833, "word": "ច្រឡុង" },
    { "id": 2834, "word": "ច្រឡូក" },
    { "id": 2835, "word": "ច្រឡើយ" },
    { "id": 2836, "word": "ច្រឡើស" },
    { "id": 2837, "word": "ច្រឡើសបើស" },
    { "id": 2838, "word": "ច្រឡេះ" },
    { "id": 2839, "word": "ច្រឡៃ" },
    { "id": 2840, "word": "ច្រឡោ" },
    { "id": 2841, "word": "ច្រឡោងខាម" },
    { "id": 2842, "word": "ច្រឡោត" },
    { "id": 2843, "word": "ច្រឡោះបោះ" },
    { "id": 2844, "word": "ច្រឡំ" },
    { "id": 2845, "word": "ច្រអរ" },
    { "id": 2846, "word": "ច្រអាង" },
    { "id": 2847, "word": "ច្រអឹង" },
    { "id": 2848, "word": "ច្រអូស" },
    { "id": 2849, "word": "ច្រាក" },
    { "id": 2850, "word": "ច្រាង" },
    { "id": 2851, "word": "ច្រាច់" },
    { "id": 2852, "word": "ច្រាញ" },
    { "id": 2853, "word": "ច្រាន" },
    { "id": 2854, "word": "ច្រាប" },
    { "id": 2855, "word": "ច្រាល" },
    { "id": 2856, "word": "ច្រាល់" },
    { "id": 2857, "word": "ច្រាវ" },
    { "id": 2858, "word": "ច្រាស" },
    { "id": 2859, "word": "ច្រាសច្រំ" },
    { "id": 2860, "word": "ច្រាស់ច្រាល់" },
    { "id": 2861, "word": "ច្រិចៗ" },
    { "id": 2862, "word": "ច្រិមច្រុម" },
    { "id": 2863, "word": "ច្រិល" },
    { "id": 2864, "word": "ច្រឹកៗ" },
    { "id": 2865, "word": "ច្រឹង" },
    { "id": 2866, "word": "ច្រឹប" },
    { "id": 2867, "word": "ច្រឺះ" },
    { "id": 2868, "word": "ច្រុង" },
    { "id": 2869, "word": "ច្រុបៗ" },
    { "id": 2870, "word": "ច្រុមៗ" },
    { "id": 2871, "word": "ច្រុះ" },
    { "id": 2872, "word": "ច្រូង" },
    { "id": 2873, "word": "ច្រូច" },
    { "id": 2874, "word": "ច្រូត" },
    { "id": 2875, "word": "ច្រួច" },
    { "id": 2876, "word": "ច្រួល" },
    { "id": 2877, "word": "ច្រើន" },
    { "id": 2878, "word": "ច្រៀក" },
    { "id": 2879, "word": "ច្រៀង" },
    { "id": 2880, "word": "ច្រៀច" },
    { "id": 2881, "word": "ច្រៀប" },
    { "id": 2882, "word": "ច្រៀវច្រៃ" },
    { "id": 2883, "word": "ច្រេច" },
    { "id": 2884, "word": "ច្រេញច្រុញ" },
    { "id": 2885, "word": "ច្រេស" },
    { "id": 2886, "word": "ច្រេះ" },
    { "id": 2887, "word": "ច្រែង" },
    { "id": 2888, "word": "ច្រែតៗ" },
    { "id": 2889, "word": "ច្រែស" },
    { "id": 2890, "word": "ច្រែះ" },
    { "id": 2891, "word": "ច្រោក" },
    { "id": 2892, "word": "ច្រោង" },
    { "id": 2893, "word": "ច្រោះ" },
    { "id": 2894, "word": "ច្រំ" },
    { "id": 2895, "word": "ច្រាំង" },
    { "id": 2896, "word": "ចក្ខុបត្ថម្ភក" },
    { "id": 2897, "word": "ចម្ងាញ់" },
    { "id": 2898, "word": "ចម្រត់" },
    { "id": 2899, "word": "ចម្រាញ" },
    { "id": 2900, "word": "ចម្រាន" },
    { "id": 2901, "word": "ចម្រាល់" },
    { "id": 2902, "word": "ចាប់ហួយ" },
    { "id": 2903, "word": "ចំណ" },
    { "id": 2904, "word": "ចំណរ" },
    { "id": 2905, "word": "ចំណាញ់" },
    { "id": 2906, "word": "ចំណាល" },
    { "id": 2907, "word": "ចំណឹក" },
    { "id": 2908, "word": "ចំណឹប" },
    { "id": 2909, "word": "ចំណុក" },
    { "id": 2910, "word": "ចំណែង" },
    { "id": 2911, "word": "ចំណែវ" },
    { "id": 2912, "word": "ចំណោល" },
    { "id": 2913, "word": "ចំណៀស" },
    { "id": 2914, "word": "ចំណំ" },
    { "id": 2915, "word": "ចំហាប" },
    { "id": 2916, "word": "ចំហួល" },
    { "id": 2917, "word": "ចំហេះ" },
    { "id": 2918, "word": "ច្រឡាម" },
    { "id": 2919, "word": "ឆ" },
    { "id": 2920, "word": "ឆក" },
    { "id": 2921, "word": "ឆក់" },
    { "id": 2922, "word": "ឆកាមាវចរ" },
    { "id": 2923, "word": "ឆកាមាវចរសួគ៌" },
    { "id": 2924, "word": "ឆក្សត្រ" },
    { "id": 2925, "word": "ឆដា" },
    { "id": 2926, "word": "ឆដាភា" },
    { "id": 2927, "word": "ឆត" },
    { "id": 2928, "word": "ឆត្រ" },
    { "id": 2929, "word": "ឆត្ររួត" },
    { "id": 2930, "word": "ឆទានសាលា" },
    { "id": 2931, "word": "ឆទ្ទន្ត" },
    { "id": 2932, "word": "ឆទ្វារ" },
    { "id": 2933, "word": "ឆន្ទ" },
    { "id": 2934, "word": "ឆន្ទៈ" },
    { "id": 2935, "word": "ឆន្ទវុត្តិប្បទីប" },
    { "id": 2936, "word": "ឆន្ទសាស្ត្រ" },
    { "id": 2937, "word": "ឆន្ទា" },
    { "id": 2938, "word": "ឆន្ទាគតិ" },
    { "id": 2939, "word": "ឆន្នអាមាត្យ" },
    { "id": 2940, "word": "ឆប" },
    { "id": 2941, "word": "ឆព្វណ្ណរង្សី" },
    { "id": 2942, "word": "ឆមាស" },
    { "id": 2943, "word": "ឆរ" },
    { "id": 2944, "word": "ឆវគ្រឹះ" },
    { "id": 2945, "word": "ឆវី" },
    { "id": 2946, "word": "ឆវីរោគ" },
    { "id": 2947, "word": "ឆវីវណ្ណ" },
    { "id": 2948, "word": "ឆស័ក" },
    { "id": 2949, "word": "ឆា" },
    { "id": 2950, "word": "ឆា៎" },
    { "id": 2951, "word": "ឆាៗ" },
    { "id": 2952, "word": "ឆាក" },
    { "id": 2953, "word": "ឆាង" },
    { "id": 2954, "word": "ឆាឆៅ" },
    { "id": 2955, "word": "ឆាតកាល" },
    { "id": 2956, "word": "ឆាតកទុក្ខ" },
    { "id": 2957, "word": "ឆាតកភ័យ" },
    { "id": 2958, "word": "ឆាតករោគ" },
    { "id": 2959, "word": "ឆាន់" },
    { "id": 2960, "word": "ឆាប" },
    { "id": 2961, "word": "ឆាប់" },
    { "id": 2962, "word": "ឆាយ" },
    { "id": 2963, "word": "ឆាយា" },
    { "id": 2964, "word": "ឆាយាធរ" },
    { "id": 2965, "word": "ឆាយាបថ" },
    { "id": 2966, "word": "ឆាយាភ្រឹត" },
    { "id": 2967, "word": "ឆាយាមិត្រ" },
    { "id": 2968, "word": "ឆាយាល័ក្ខណ៍" },
    { "id": 2969, "word": "ឆាល់" },
    { "id": 2970, "word": "ឆាវ" },
    { "id": 2971, "word": "ឆិញ" },
    { "id": 2972, "word": "ឆិត" },
    { "id": 2973, "word": "ឆិល" },
    { "id": 2974, "word": "ឆី" },
    { "id": 2975, "word": "ឆឹកៗ" },
    { "id": 2976, "word": "ឆឹង" },
    { "id": 2977, "word": "ឆឺង" },
    { "id": 2978, "word": "ឆុក" },
    { "id": 2979, "word": "ឆុង" },
    { "id": 2980, "word": "ឆុត" },
    { "id": 2981, "word": "ឆុប" },
    { "id": 2982, "word": "ឆុរ" },
    { "id": 2983, "word": "ឆូត" },
    { "id": 2984, "word": "ឆូវ" },
    { "id": 2985, "word": "ឆួង" },
    { "id": 2986, "word": "ឆួល" },
    { "id": 2987, "word": "ឆើត" },
    { "id": 2988, "word": "ឆើយ" },
    { "id": 2989, "word": "ឆៀក" },
    { "id": 2990, "word": "ឆៀង" },
    { "id": 2991, "word": "ឆៀប" },
    { "id": 2992, "word": "ឆេញ" },
    { "id": 2993, "word": "ឆេរ" },
    { "id": 2994, "word": "ឆេវ" },
    { "id": 2995, "word": "ឆេះ" },
    { "id": 2996, "word": "ឆែ" },
    { "id": 2997, "word": "ឆែក" },
    { "id": 2998, "word": "ឆែកែវ" },
    { "id": 2999, "word": "ឆែកឆេរ" },
    { "id": 3000, "word": "ឆែង" },
    { "id": 3001, "word": "ឆែត" },
    { "id": 3002, "word": "ឆែប" },
    { "id": 3003, "word": "ឆែវ" },
    { "id": 3004, "word": "ឆៃយ៉ាំ" },
    { "id": 3005, "word": "ឆោង" },
    { "id": 3006, "word": "ឆោត" },
    { "id": 3007, "word": "ឆោម" },
    { "id": 3008, "word": "ឆោឡោ" },
    { "id": 3009, "word": "ឆៅ" },
    { "id": 3010, "word": "ឆាំង" },
    { "id": 3011, "word": "ឆាំងៗ" },
    { "id": 3012, "word": "ឆាំឆា" },
    { "id": 3013, "word": "ឆ្កយ" },
    { "id": 3014, "word": "ឆ្កាង" },
    { "id": 3015, "word": "ឆ្ការ" },
    { "id": 3016, "word": "ឆ្កិល" },
    { "id": 3017, "word": "ឆ្កឹង" },
    { "id": 3018, "word": "ឆ្កឹះ" },
    { "id": 3019, "word": "ឆ្កឹះឆ្កៀល" },
    { "id": 3020, "word": "ឆ្កឺត" },
    { "id": 3021, "word": "ឆ្កុយ" },
    { "id": 3022, "word": "ឆ្កូត" },
    { "id": 3023, "word": "ឆ្កួត" },
    { "id": 3024, "word": "ឆ្កួតជ្រូក" },
    { "id": 3025, "word": "ឆ្កៀល" },
    { "id": 3026, "word": "ឆ្កៀស" },
    { "id": 3027, "word": "ឆ្កែ" },
    { "id": 3028, "word": "ឆ្កែញាំង" },
    { "id": 3029, "word": "ឆ្កែស្រែង" },
    { "id": 3030, "word": "ឆ្កោក" },
    { "id": 3031, "word": "ឆ្គង" },
    { "id": 3032, "word": "ឆ្គាំ" },
    { "id": 3033, "word": "ឆ្ងក" },
    { "id": 3034, "word": "ឆ្ងក់" },
    { "id": 3035, "word": "ឆ្ងល់" },
    { "id": 3036, "word": "ឆ្ងាញ់" },
    { "id": 3037, "word": "ឆ្ងាយ" },
    { "id": 3038, "word": "ឆ្ងិត" },
    { "id": 3039, "word": "ឆ្ងឹង" },
    { "id": 3040, "word": "ឆ្ងុយ" },
    { "id": 3041, "word": "ឆ្ងូវ" },
    { "id": 3042, "word": "ឆ្ងើក" },
    { "id": 3043, "word": "ឆ្ងើយ" },
    { "id": 3044, "word": "ឆ្ងែ" },
    { "id": 3045, "word": "ឆ្ដុប" },
    { "id": 3046, "word": "ឆ្ដេញ" },
    { "id": 3047, "word": "ឆ្ដោ" },
    { "id": 3048, "word": "ឆ្ដោរ" },
    { "id": 3049, "word": "ឆ្នង់" },
    { "id": 3050, "word": "ឆ្នាក់" },
    { "id": 3051, "word": "ឆ្នាប់មាត់" },
    { "id": 3052, "word": "ឆ្នាល់" },
    { "id": 3053, "word": "ឆ្នាល់មាន់" },
    { "id": 3054, "word": "ឆ្នាស" },
    { "id": 3055, "word": "ឆ្នឹម" },
    { "id": 3056, "word": "ឆ្នុក" },
    { "id": 3057, "word": "ឆ្នុកក្បិន" },
    { "id": 3058, "word": "ឆ្នូត" },
    { "id": 3059, "word": "ឆ្នួន" },
    { "id": 3060, "word": "ឆ្នើម" },
    { "id": 3061, "word": "ឆ្នៀង" },
    { "id": 3062, "word": "ឆ្នេរ" },
    { "id": 3063, "word": "ឆ្នែង" },
    { "id": 3064, "word": "ឆ្នៃ" },
    { "id": 3065, "word": "ឆ្នោត" },
    { "id": 3066, "word": "ឆ្នាំ" },
    { "id": 3067, "word": "ឆ្នាំង" },
    { "id": 3068, "word": "ឆ្នាំងរបួល" },
    { "id": 3069, "word": "ឆ្ពង់" },
    { "id": 3070, "word": "ឆ្ពាម" },
    { "id": 3071, "word": "ឆ្ពិត" },
    { "id": 3072, "word": "ឆ្ពិន" },
    { "id": 3073, "word": "ឆ្ពឹះ" },
    { "id": 3074, "word": "ឆ្ពុង" },
    { "id": 3075, "word": "ឆ្ពោះ" },
    { "id": 3076, "word": "ឆ្មក់" },
    { "id": 3077, "word": "ឆ្មប" },
    { "id": 3078, "word": "ឆ្មា" },
    { "id": 3079, "word": "ឆ្មាត់" },
    { "id": 3080, "word": "ឆ្មាបា" },
    { "id": 3081, "word": "ឆ្មារ" },
    { "id": 3082, "word": "ឆ្មូល" },
    { "id": 3083, "word": "ឆ្មើង" },
    { "id": 3084, "word": "ឆ្មៀង" },
    { "id": 3085, "word": "ឆ្មៃ" },
    { "id": 3086, "word": "ឆ្មាំ" },
    { "id": 3087, "word": "ឆ្លក" },
    { "id": 3088, "word": "ឆ្លង" },
    { "id": 3089, "word": "ឆ្លងព្រះបាទ" },
    { "id": 3090, "word": "ឆ្លា" },
    { "id": 3091, "word": "ឆ្លាក់" },
    { "id": 3092, "word": "ឆ្លាត" },
    { "id": 3093, "word": "ឆ្លាម" },
    { "id": 3094, "word": "ឆ្លាស" },
    { "id": 3095, "word": "ឆ្លាស់" },
    { "id": 3096, "word": "ឆ្លឺម" },
    { "id": 3097, "word": "ឆ្លុះ" },
    { "id": 3098, "word": "ឆ្លូក" },
    { "id": 3099, "word": "ឆ្លូង" },
    { "id": 3100, "word": "ឆ្លូញ" },
    { "id": 3101, "word": "ឆ្លូវ" },
    { "id": 3102, "word": "ឆ្លើយ" },
    { "id": 3103, "word": "ឆ្លៀត" },
    { "id": 3104, "word": "ឆ្លៀវឆ្លាត" },
    { "id": 3105, "word": "ឆ្លៀវឆ្លាស" },
    { "id": 3106, "word": "ឆ្លេ" },
    { "id": 3107, "word": "ឆ្លែក" },
    { "id": 3108, "word": "ឆ្លោង" },
    { "id": 3109, "word": "ឆ្លៅ" },
    { "id": 3110, "word": "ឆ្លាំង" },
    { "id": 3111, "word": "ឆ្វ" },
    { "id": 3112, "word": "ឆ្វង់" },
    { "id": 3113, "word": "ឆ្វា" },
    { "id": 3114, "word": "ឆ្វាក" },
    { "id": 3115, "word": "ឆ្វាក់" },
    { "id": 3116, "word": "ឆ្វាង" },
    { "id": 3117, "word": "ឆ្វាច" },
    { "id": 3118, "word": "ឆ្វាត់ឆ្វៀល" },
    { "id": 3119, "word": "ឆ្វាត់ឆ្វែង" },
    { "id": 3120, "word": "ឆ្វាយ" },
    { "id": 3121, "word": "ឆ្វៀល" },
    { "id": 3122, "word": "ឆ្វៀលឆ្វាត់" },
    { "id": 3123, "word": "ឆ្វេង" },
    { "id": 3124, "word": "ឆ្វេះ" },
    { "id": 3125, "word": "ឆ្វែល" },
    { "id": 3126, "word": "ឆ្អន់" },
    { "id": 3127, "word": "ឆ្អល់" },
    { "id": 3128, "word": "ឆ្អាប" },
    { "id": 3129, "word": "ឆ្អិត" },
    { "id": 3130, "word": "ឆ្អិន" },
    { "id": 3131, "word": "ឆ្អឹង" },
    { "id": 3132, "word": "ឆ្អឹងជំនីរ" },
    { "id": 3133, "word": "ឆ្អឺស" },
    { "id": 3134, "word": "ឆ្អើម" },
    { "id": 3135, "word": "ឆ្អើរ" },
    { "id": 3136, "word": "ឆ្អើសឆ្អើម" },
    { "id": 3137, "word": "ឆ្អេះ" },
    { "id": 3138, "word": "ឆ្អែង" },
    { "id": 3139, "word": "ឆ្អែត" },
    { "id": 3140, "word": "ឆ្អៅ" },
    { "id": 3141, "word": "ឆៃថាវ" },
    { "id": 3142, "word": "ឆៃប៉ូវ" },
    { "id": 3143, "word": "ឆ្នាំទៅ" },
    { "id": 3144, "word": "ជ" },
    { "id": 3145, "word": "ជក់" },
    { "id": 3146, "word": "ជគត" },
    { "id": 3147, "word": "ជង" },
    { "id": 3148, "word": "ជង់" },
    { "id": 3149, "word": "ជង្គង់" },
    { "id": 3150, "word": "ជង្ឃ" },
    { "id": 3151, "word": "ជង្ឃមគ្គ" },
    { "id": 3152, "word": "ជង្ឃមាគ៌ា" },
    { "id": 3153, "word": "ជង្ឃា" },
    { "id": 3154, "word": "ជង្ហុក" },
    { "id": 3155, "word": "ជច់" },
    { "id": 3156, "word": "ជជីក" },
    { "id": 3157, "word": "ជជុះ" },
    { "id": 3158, "word": "ជជុះជជាយ" },
    { "id": 3159, "word": "ជជួរ" },
    { "id": 3160, "word": "ជជើល" },
    { "id": 3161, "word": "ជជែក" },
    { "id": 3162, "word": "ជជ្រក" },
    { "id": 3163, "word": "ជជ្រកមមក" },
    { "id": 3164, "word": "ជជ្រុលជជ្រក" },
    { "id": 3165, "word": "ជជ្រុលជជ្រួស" },
    { "id": 3166, "word": "ជជ្រុលមមុល" },
    { "id": 3167, "word": "ជញ្ជក់" },
    { "id": 3168, "word": "ជញ្ជាត់" },
    { "id": 3169, "word": "ជញ្ជាត់ព្រលឹង" },
    { "id": 3170, "word": "ជញ្ជាន់" },
    { "id": 3171, "word": "ជញ្ជាន់ស្លាញ" },
    { "id": 3172, "word": "ជញ្ជាប" },
    { "id": 3173, "word": "ជញ្ជាប់" },
    { "id": 3174, "word": "ជញ្ជីង" },
    { "id": 3175, "word": "ជញ្ជឹង" },
    { "id": 3176, "word": "ជញ្ជូន" },
    { "id": 3177, "word": "ជញ្ជួច" },
    { "id": 3178, "word": "ជញ្ជួយ" },
    { "id": 3179, "word": "ជញ្ជែង" },
    { "id": 3180, "word": "ជញ្ជាំង" },
    { "id": 3181, "word": "ជញ្ជ្រំ" },
    { "id": 3182, "word": "ជញ្ជ្រាំង" },
    { "id": 3183, "word": "ជដា" },
    { "id": 3184, "word": "ជដាធរ" },
    { "id": 3185, "word": "ជដិល" },
    { "id": 3186, "word": "ជណ្ដើរ" },
    { "id": 3187, "word": "ជណ្ដើរស្វា" },
    { "id": 3188, "word": "ជត" },
    { "id": 3189, "word": "ជតា" },
    { "id": 3190, "word": "ជន" },
    { "id": 3191, "word": "ជន" },
    { "id": 3192, "word": "ជន់" },
    { "id": 3193, "word": "ជនក" },
    { "id": 3194, "word": "ជនកាយ" },
    { "id": 3195, "word": "ជនតា" },
    { "id": 3196, "word": "ជននាថ" },
    { "id": 3197, "word": "ជននិករ" },
    { "id": 3198, "word": "ជននិកាយ" },
    { "id": 3199, "word": "ជននី" },
    { "id": 3200, "word": "ជននីនាថ" },
    { "id": 3201, "word": "ជនបទ" },
    { "id": 3202, "word": "ជនបទាធិបតី" },
    { "id": 3203, "word": "ជនាចារ" },
    { "id": 3204, "word": "ជនាធិប" },
    { "id": 3205, "word": "ជនាធិបតី" },
    { "id": 3206, "word": "ជនានុជន" },
    { "id": 3207, "word": "ជនានុគ្រោះ" },
    { "id": 3208, "word": "ជនាស្រ័យ" },
    { "id": 3209, "word": "ជនិន្ទ" },
    { "id": 3210, "word": "ជនី" },
    { "id": 3211, "word": "ជនីនាថ" },
    { "id": 3212, "word": "ជនុបត្ថម្ភ" },
    { "id": 3213, "word": "ជនូបត្ថម្ភកៈ" },
    { "id": 3214, "word": "ជនេត្តី" },
    { "id": 3215, "word": "ជនេន្រ្ទ" },
    { "id": 3216, "word": "ជនោត្តម" },
    { "id": 3217, "word": "ជន្ម" },
    { "id": 3218, "word": "ជន្មវស្សា" },
    { "id": 3219, "word": "ជន្មា" },
    { "id": 3220, "word": "ជន្ល" },
    { "id": 3221, "word": "ជន្លជន្លេញ" },
    { "id": 3222, "word": "ជន្លង់" },
    { "id": 3223, "word": "ជន្លាត់ដៃ" },
    { "id": 3224, "word": "ជន្លាស" },
    { "id": 3225, "word": "ជន្លូស" },
    { "id": 3226, "word": "ជន្លួញ" },
    { "id": 3227, "word": "ជន្លួញបរ" },
    { "id": 3228, "word": "ជន្លួញមាន់" },
    { "id": 3229, "word": "ជន្លេញ" },
    { "id": 3230, "word": "ជន្លេន" },
    { "id": 3231, "word": "ជប" },
    { "id": 3232, "word": "ជប--" },
    { "id": 3233, "word": "ជប់" },
    { "id": 3234, "word": "ជម" },
    { "id": 3235, "word": "ជម្នះ" },
    { "id": 3236, "word": "ជម្ពូ" },
    { "id": 3237, "word": "ជម្ពូទ្វីប" },
    { "id": 3238, "word": "ជម្ពូនទៈ" },
    { "id": 3239, "word": "ជម្ពូនុទ" },
    { "id": 3240, "word": "ជម្ពូផល" },
    { "id": 3241, "word": "ជម្ពូពាន" },
    { "id": 3242, "word": "ជម្ពូព្រឹក្ស" },
    { "id": 3243, "word": "ជម្ម" },
    { "id": 3244, "word": "ជម្រក" },
    { "id": 3245, "word": "ជម្រាប" },
    { "id": 3246, "word": "ជម្រាល" },
    { "id": 3247, "word": "ជម្រុល" },
    { "id": 3248, "word": "ជម្រុះ" },
    { "id": 3249, "word": "ជម្រើស" },
    { "id": 3250, "word": "ជម្រែក" },
    { "id": 3251, "word": "ជម្រៅ" },
    { "id": 3252, "word": "ជម្រះ" },
    { "id": 3253, "word": "ជម្លើយ" },
    { "id": 3254, "word": "ជម្លៀស" },
    { "id": 3255, "word": "ជម្លោះ" },
    { "id": 3256, "word": "ជយ--" },
    { "id": 3257, "word": "ជ័យ" },
    { "id": 3258, "word": "ជរ" },
    { "id": 3259, "word": "ជរជាយ" },
    { "id": 3260, "word": "ជរជួរ" },
    { "id": 3261, "word": "ជ័រ" },
    { "id": 3262, "word": "ជរា" },
    { "id": 3263, "word": "ជរា--" },
    { "id": 3264, "word": "ជល់" },
    { "id": 3265, "word": "ជល" },
    { "id": 3266, "word": "ជល--" },
    { "id": 3267, "word": "ជវនៈ" },
    { "id": 3268, "word": "ជវនចិត្ត" },
    { "id": 3269, "word": "ជវនដ្ឋាន" },
    { "id": 3270, "word": "ជវនវីថិ" },
    { "id": 3271, "word": "ជវភាព" },
    { "id": 3272, "word": "ជវលេខ" },
    { "id": 3273, "word": "ជវលេខកៈ" },
    { "id": 3274, "word": "ជហ្វា" },
    { "id": 3275, "word": "ជា" },
    { "id": 3276, "word": "ជាក់" },
    { "id": 3277, "word": "ជាង" },
    { "id": 3278, "word": "ជាញ" },
    { "id": 3279, "word": "ជាត" },
    { "id": 3280, "word": "ជាត់" },
    { "id": 3281, "word": "ជាតក" },
    { "id": 3282, "word": "ជាតរូប" },
    { "id": 3283, "word": "ជាតវេទ" },
    { "id": 3284, "word": "ជាតសិលា" },
    { "id": 3285, "word": "ជាតស្រង់" },
    { "id": 3286, "word": "ជាតស្រះ" },
    { "id": 3287, "word": "ជាតហិង្គុល" },
    { "id": 3288, "word": "ជាតា" },
    { "id": 3289, "word": "ជាតិ" },
    { "id": 3290, "word": "ជាតិទុក្ខ" },
    { "id": 3291, "word": "ជាតិធម៌" },
    { "id": 3292, "word": "ជាតិភូមិ" },
    { "id": 3293, "word": "ជាតិរស" },
    { "id": 3294, "word": "ជាតិលិង្គ" },
    { "id": 3295, "word": "ជាតី" },
    { "id": 3296, "word": "ជាតូបករណ៍" },
    { "id": 3297, "word": "ជាតូបនីយកម្ម" },
    { "id": 3298, "word": "ជាន់" },
    { "id": 3299, "word": "ជាន់ឆាយ" },
    { "id": 3300, "word": "ជាន់ឡើង" },
    { "id": 3301, "word": "ជានបទ" },
    { "id": 3302, "word": "ជានុ" },
    { "id": 3303, "word": "ជានុមណ្ឌល" },
    { "id": 3304, "word": "ជាប់" },
    { "id": 3305, "word": "ជាម" },
    { "id": 3306, "word": "ជាមួយ" },
    { "id": 3307, "word": "ជាយ" },
    { "id": 3308, "word": "ជាយគ្រែង" },
    { "id": 3309, "word": "ជាយា" },
    { "id": 3310, "word": "ជាល" },
    { "id": 3311, "word": "ជាលា" },
    { "id": 3312, "word": "ជាលិនី" },
    { "id": 3313, "word": "ជាលី" },
    { "id": 3314, "word": "ជាវ" },
    { "id": 3315, "word": "ជាស" },
    { "id": 3316, "word": "ជិណ្ណកាយ" },
    { "id": 3317, "word": "ជិណ្ណរូប" },
    { "id": 3318, "word": "ជិត" },
    { "id": 3319, "word": "ជិត!" },
    { "id": 3320, "word": "ជិតំ!" },
    { "id": 3321, "word": "ជិតិន្ទ្រិយ" },
    { "id": 3322, "word": "ជិន" },
    { "id": 3323, "word": "ជិនបុត្រ" },
    { "id": 3324, "word": "ជិនវង្ស" },
    { "id": 3325, "word": "ជិនស្រី" },
    { "id": 3326, "word": "ជិនោរស" },
    { "id": 3327, "word": "ជិប" },
    { "id": 3328, "word": "ជិវ្ហា" },
    { "id": 3329, "word": "ជិវ្ហាបសាទ" },
    { "id": 3330, "word": "ជិះ" },
    { "id": 3331, "word": "ជី" },
    { "id": 3332, "word": "ជីក" },
    { "id": 3333, "word": "ជីក្រែង" },
    { "id": 3334, "word": "ជីងជក់" },
    { "id": 3335, "word": "ជីដូន" },
    { "id": 3336, "word": "ជីដូនមួយ" },
    { "id": 3337, "word": "ជីតា" },
    { "id": 3338, "word": "ជីតុន" },
    { "id": 3339, "word": "ជីទួត" },
    { "id": 3340, "word": "ជីទួតមួយ" },
    { "id": 3341, "word": "ជីប" },
    { "id": 3342, "word": "ជីប៉ា" },
    { "id": 3343, "word": "ជីព" },
    { "id": 3344, "word": "ជីពចរ" },
    { "id": 3345, "word": "ជីពុក" },
    { "id": 3346, "word": "ជីរ" },
    { "id": 3347, "word": "ជីលា" },
    { "id": 3348, "word": "ជីលួត" },
    { "id": 3349, "word": "ជីលួតមួយ" },
    { "id": 3350, "word": "ជីវៈ" },
    { "id": 3351, "word": "ជីវ៍" },
    { "id": 3352, "word": "ជីវកជីវាក" },
    { "id": 3353, "word": "ជីវង្គត" },
    { "id": 3354, "word": "ជីវជាតិ" },
    { "id": 3355, "word": "ជីវ័ន" },
    { "id": 3356, "word": "ជីវន្ត" },
    { "id": 3357, "word": "ជីវប្បវត្តិ" },
    { "id": 3358, "word": "ជីវពល" },
    { "id": 3359, "word": "ជីវភាព" },
    { "id": 3360, "word": "ជីវសាស្ត្រ" },
    { "id": 3361, "word": "ជីវា" },
    { "id": 3362, "word": "ជីវិត" },
    { "id": 3363, "word": "ជីវិតក្ស័យ" },
    { "id": 3364, "word": "ជីវិតន្តរាយ" },
    { "id": 3365, "word": "ជីវិតិន្ទ្រិយ" },
    { "id": 3366, "word": "ជីវិន" },
    { "id": 3367, "word": "ជីវី" },
    { "id": 3368, "word": "ជុក" },
    { "id": 3369, "word": "ជុច" },
    { "id": 3370, "word": "ជុណ្ហប័ក្ខ" },
    { "id": 3371, "word": "ជុតិមន្ត" },
    { "id": 3372, "word": "ជល់" },
    { "id": 3373, "word": "ជុលី" },
    { "id": 3374, "word": "ជុះ" },
    { "id": 3375, "word": "ជូជក" },
    { "id": 3376, "word": "ជូត" },
    { "id": 3377, "word": "ជូតកម្ម" },
    { "id": 3378, "word": "ជូតការក៍" },
    { "id": 3379, "word": "ជូតការី" },
    { "id": 3380, "word": "ជូន" },
    { "id": 3381, "word": "ជូរ" },
    { "id": 3382, "word": "ជួ" },
    { "id": 3383, "word": "ជួង" },
    { "id": 3384, "word": "ជួញ" },
    { "id": 3385, "word": "ជួត" },
    { "id": 3386, "word": "ជួន" },
    { "id": 3387, "word": "ជួនកាល" },
    { "id": 3388, "word": "ជួនណា" },
    { "id": 3389, "word": "ជួប" },
    { "id": 3390, "word": "ជួយ" },
    { "id": 3391, "word": "ជួរ" },
    { "id": 3392, "word": "ជួល" },
    { "id": 3393, "word": "ជួស" },
    { "id": 3394, "word": "ជួសជុល" },
    { "id": 3395, "word": "ជើ!" },
    { "id": 3396, "word": "ជើង" },
    { "id": 3397, "word": "ជើងកញ្ជើ" },
    { "id": 3398, "word": "ជើងកញ្ជោ" },
    { "id": 3399, "word": "ជើងកញ្ជុំ" },
    { "id": 3400, "word": "ជើងកប" },
    { "id": 3401, "word": "ជើងការ" },
    { "id": 3402, "word": "ជើងកុក" },
    { "id": 3403, "word": "ជើងកោស" },
    { "id": 3404, "word": "ជើងក្រាន" },
    { "id": 3405, "word": "ជើងក្រាស" },
    { "id": 3406, "word": "ជើងក្អែក" },
    { "id": 3407, "word": "ជើងខ្លែង" },
    { "id": 3408, "word": "ជើងគក" },
    { "id": 3409, "word": "ជើងគុល" },
    { "id": 3410, "word": "ជើងគោ" },
    { "id": 3411, "word": "ជើងគ្រុឌ" },
    { "id": 3412, "word": "ជើងគ្រុស" },
    { "id": 3413, "word": "ជើងចាប" },
    { "id": 3414, "word": "ជើងចែវ" },
    { "id": 3415, "word": "ជើងឆ្កោក" },
    { "id": 3416, "word": "ជើងជង់" },
    { "id": 3417, "word": "ជើងតាំង" },
    { "id": 3418, "word": "ជើងថ្ករ" },
    { "id": 3419, "word": "ជើងទើន" },
    { "id": 3420, "word": "ជើងទៀន" },
    { "id": 3421, "word": "ជើងទេញ" },
    { "id": 3422, "word": "ជើងទេរ" },
    { "id": 3423, "word": "ជើងទ្រនាប់" },
    { "id": 3424, "word": "ជើងបាត្រ" },
    { "id": 3425, "word": "ជើងពាន" },
    { "id": 3426, "word": "ជើងពេល" },
    { "id": 3427, "word": "ជើងព្នាយ" },
    { "id": 3428, "word": "ជើងព្រៃ" },
    { "id": 3429, "word": "ជើងព្រះ" },
    { "id": 3430, "word": "ជើងភេល" },
    { "id": 3431, "word": "ជើងម៉ា" },
    { "id": 3432, "word": "ជើងមាន់" },
    { "id": 3433, "word": "ជើងម្ដែង" },
    { "id": 3434, "word": "ជើងរមាំង" },
    { "id": 3435, "word": "ជើងរមាំងណែងណង" },
    { "id": 3436, "word": "ជើងរាវ" },
    { "id": 3437, "word": "ជើងល័ព្ធ" },
    { "id": 3438, "word": "ជើងវត្ត" },
    { "id": 3439, "word": "ជើងសក់" },
    { "id": 3440, "word": "ជើងសា" },
    { "id": 3441, "word": "ជើងសេះ" },
    { "id": 3442, "word": "ជើងស្រម" },
    { "id": 3443, "word": "ជើងស្រាពក៍" },
    { "id": 3444, "word": "ជើងស្រុក" },
    { "id": 3445, "word": "ជើងហារ" },
    { "id": 3446, "word": "ជើងអាធារ" },
    { "id": 3447, "word": "ជើងឧបោសថ៍" },
    { "id": 3448, "word": "ជើងឯក" },
    { "id": 3449, "word": "ជើត" },
    { "id": 3450, "word": "ជើយ" },
    { "id": 3451, "word": "ជឿ" },
    { "id": 3452, "word": "ជឿន" },
    { "id": 3453, "word": "ជៀត" },
    { "id": 3454, "word": "ជៀន" },
    { "id": 3455, "word": "ជៀនជួន" },
    { "id": 3456, "word": "ជៀប" },
    { "id": 3457, "word": "ជៀបកប្បាស" },
    { "id": 3458, "word": "ជៀវ" },
    { "id": 3459, "word": "ជៀស" },
    { "id": 3460, "word": "ជៀស្ឋជ័យ" },
    { "id": 3461, "word": "ជេដ្ឋមាស" },
    { "id": 3462, "word": "ជេដ្ឋា" },
    { "id": 3463, "word": "ជេតពន" },
    { "id": 3464, "word": "ជេតវន" },
    { "id": 3465, "word": "ជេតុត្តរ" },
    { "id": 3466, "word": "ជេន" },
    { "id": 3467, "word": "ជេរ" },
    { "id": 3468, "word": "ជេស្ឋ" },
    { "id": 3469, "word": "ជេស្ឋជ័យ" },
    { "id": 3470, "word": "ជេះ" },
    { "id": 3471, "word": "ជែក" },
    { "id": 3472, "word": "ជែង" },
    { "id": 3473, "word": "ជែង" },
    { "id": 3474, "word": "ជែពព្រែ" },
    { "id": 3475, "word": "ជែះ" },
    { "id": 3476, "word": "ជោក" },
    { "id": 3477, "word": "ជោគ" },
    { "id": 3478, "word": "ជោគជ័យ" },
    { "id": 3479, "word": "ជោគវាសនា" },
    { "id": 3480, "word": "ជោតក" },
    { "id": 3481, "word": "ជោតនាការ" },
    { "id": 3482, "word": "ជោតិ" },
    { "id": 3483, "word": "ជោតិក" },
    { "id": 3484, "word": "ជោតិកាចារ្យ" },
    { "id": 3485, "word": "ជោតិភាព" },
    { "id": 3486, "word": "ជោតិរស" },
    { "id": 3487, "word": "ជោតិសាស្ត្រ" },
    { "id": 3488, "word": "ជោរ" },
    { "id": 3489, "word": "ជោះ" },
    { "id": 3490, "word": "ជៅ" },
    { "id": 3491, "word": "ជុំ" },
    { "id": 3492, "word": "ជុំកន្លង់" },
    { "id": 3493, "word": "ជុំរុំ" },
    { "id": 3494, "word": "ជំ" },
    { "id": 3495, "word": "ជំងឺ" },
    { "id": 3496, "word": "ជំទង់" },
    { "id": 3497, "word": "ជំទប់" },
    { "id": 3498, "word": "ជំទយ" },
    { "id": 3499, "word": "ជំទាញ" },
    { "id": 3500, "word": "ជំទាវ" },
    { "id": 3501, "word": "ជំទាស់" },
    { "id": 3502, "word": "ជំទួយ" },
    { "id": 3503, "word": "ជំទើរ" },
    { "id": 3504, "word": "ជំទើស" },
    { "id": 3505, "word": "ជំទែង" },
    { "id": 3506, "word": "ជំទាំង" },
    { "id": 3507, "word": "ជំនន់" },
    { "id": 3508, "word": "ជំនា" },
    { "id": 3509, "word": "ជំនាង" },
    { "id": 3510, "word": "ជំនាញ" },
    { "id": 3511, "word": "ជំនាញជាញជ័យ" },
    { "id": 3512, "word": "ជំនាន់" },
    { "id": 3513, "word": "ជំនានីស" },
    { "id": 3514, "word": "ជំនាប់" },
    { "id": 3515, "word": "ជំនិត" },
    { "id": 3516, "word": "ជំនិះ" },
    { "id": 3517, "word": "ជំនីក" },
    { "id": 3518, "word": "ជំនូន" },
    { "id": 3519, "word": "ជំនួញ" },
    { "id": 3520, "word": "ជំនួប" },
    { "id": 3521, "word": "ជំនួយ" },
    { "id": 3522, "word": "ជំនួស" },
    { "id": 3523, "word": "ជំនឿ" },
    { "id": 3524, "word": "ជំនឿន" },
    { "id": 3525, "word": "ជំនោរ" },
    { "id": 3526, "word": "ជំនុំ" },
    { "id": 3527, "word": "ជំនំ" },
    { "id": 3528, "word": "ជំបួរ" },
    { "id": 3529, "word": "ជំពប់" },
    { "id": 3530, "word": "ជំពាក់" },
    { "id": 3531, "word": "ជំពូក" },
    { "id": 3532, "word": "ជំរត់" },
    { "id": 3533, "word": "ជំរិត" },
    { "id": 3534, "word": "ជំរុញ" },
    { "id": 3535, "word": "ជំរឿន" },
    { "id": 3536, "word": "ជំរំ" },
    { "id": 3537, "word": "ជំលាប" },
    { "id": 3538, "word": "ជំហប់" },
    { "id": 3539, "word": "ជំហម" },
    { "id": 3540, "word": "ជំហរ" },
    { "id": 3541, "word": "ជំហាញ" },
    { "id": 3542, "word": "ជំហាន" },
    { "id": 3543, "word": "ជំហូស" },
    { "id": 3544, "word": "ជំហោង" },
    { "id": 3545, "word": "ជំហៅ" },
    { "id": 3546, "word": "ជាំ" },
    { "id": 3547, "word": "ជះ" },
    { "id": 3548, "word": "ជ្រក" },
    { "id": 3549, "word": "ជ្រកមមក" },
    { "id": 3550, "word": "ជ្រក់" },
    { "id": 3551, "word": "ជ្រង" },
    { "id": 3552, "word": "ជ្រង់" },
    { "id": 3553, "word": "ជ្រងក់" },
    { "id": 3554, "word": "ជ្រងោ" },
    { "id": 3555, "word": "ជ្រងំ" },
    { "id": 3556, "word": "ជ្រញ់" },
    { "id": 3557, "word": "ជ្រនង់" },
    { "id": 3558, "word": "ជ្រនីក" },
    { "id": 3559, "word": "ជ្រនួច" },
    { "id": 3560, "word": "ជ្រនៀង" },
    { "id": 3561, "word": "ជ្រប" },
    { "id": 3562, "word": "ជ្រប់" },
    { "id": 3563, "word": "ជ្រមីស" },
    { "id": 3564, "word": "ជ្រមុជ" },
    { "id": 3565, "word": "ជ្រមូស" },
    { "id": 3566, "word": "ជ្រលក់" },
    { "id": 3567, "word": "ជ្រលង" },
    { "id": 3568, "word": "ជ្រលម" },
    { "id": 3569, "word": "ជ្រលិះ" },
    { "id": 3570, "word": "ជ្រលួស" },
    { "id": 3571, "word": "ជ្រលែង" },
    { "id": 3572, "word": "ជ្រហម" },
    { "id": 3573, "word": "ជ្រហិតជ្រហម" },
    { "id": 3574, "word": "ជ្រាក" },
    { "id": 3575, "word": "ជ្រាប" },
    { "id": 3576, "word": "ជ្រាម" },
    { "id": 3577, "word": "ជ្រាយ" },
    { "id": 3578, "word": "ជ្រាល" },
    { "id": 3579, "word": "ជ្រាវ" },
    { "id": 3580, "word": "ជ្រាស" },
    { "id": 3581, "word": "ជ្រិះ" },
    { "id": 3582, "word": "ជ្រីវ" },
    { "id": 3583, "word": "ជ្រឹង" },
    { "id": 3584, "word": "ជ្រុង" },
    { "id": 3585, "word": "ជ្រុល" },
    { "id": 3586, "word": "ជ្រុះ" },
    { "id": 3587, "word": "ជ្រូក" },
    { "id": 3588, "word": "ជ្រូកត្រឹប" },
    { "id": 3589, "word": "ជ្រូកព្រុល" },
    { "id": 3590, "word": "ជ្រួក" },
    { "id": 3591, "word": "ជ្រួញ" },
    { "id": 3592, "word": "ជ្រួត" },
    { "id": 3593, "word": "ជ្រួយ" },
    { "id": 3594, "word": "ជ្រួល" },
    { "id": 3595, "word": "ជ្រួស" },
    { "id": 3596, "word": "ជ្រើម" },
    { "id": 3597, "word": "ជ្រើស" },
    { "id": 3598, "word": "ជ្រៀង" },
    { "id": 3599, "word": "ជ្រៀត" },
    { "id": 3600, "word": "ជ្រេ" },
    { "id": 3601, "word": "ជ្រេញ" },
    { "id": 3602, "word": "ជ្រែ" },
    { "id": 3603, "word": "ជ្រែក" },
    { "id": 3604, "word": "ជ្រែង" },
    { "id": 3605, "word": "ជ្រែះ" },
    { "id": 3606, "word": "ជ្រៃ" },
    { "id": 3607, "word": "ជ្រោ" },
    { "id": 3608, "word": "ជ្រោក" },
    { "id": 3609, "word": "ជ្រោង" },
    { "id": 3610, "word": "ជ្រោមជ្រែង" },
    { "id": 3611, "word": "ជ្រោយ" },
    { "id": 3612, "word": "ជ្រោះ" },
    { "id": 3613, "word": "ជ្រៅ" },
    { "id": 3614, "word": "ជ្រំ" },
    { "id": 3615, "word": "ជ្រាំ" },
    { "id": 3616, "word": "ជ្រាំង" },
    { "id": 3617, "word": "ជ្រះ" },
    { "id": 3618, "word": "ជ្វា" },
    { "id": 3619, "word": "ជ្វាលា" },
    { "id": 3620, "word": "ជម្រួញ" },
    { "id": 3621, "word": "ជម្រេញ" },
    { "id": 3622, "word": "ជម្រោង" },
    { "id": 3623, "word": "ជំនក់" },
    { "id": 3624, "word": "ជំនង់" },
    { "id": 3625, "word": "ជំនច់" },
    { "id": 3626, "word": "ជំនាងផ្ទះ" },
    { "id": 3627, "word": "ជំនាត់" },
    { "id": 3628, "word": "ជំនាវ" },
    { "id": 3629, "word": "ជំនីប" },
    { "id": 3630, "word": "ជំនូត" },
    { "id": 3631, "word": "ជំនួល" },
    { "id": 3632, "word": "ជំនេរ" },
    { "id": 3633, "word": "ជំនែង" },
    { "id": 3634, "word": "ជំនោះ" },
    { "id": 3635, "word": "ឈ" },
    { "id": 3636, "word": "ឈប!" },
    { "id": 3637, "word": "ឈប់" },
    { "id": 3638, "word": "ឈម" },
    { "id": 3639, "word": "ឈរ" },
    { "id": 3640, "word": "ឈាន" },
    { "id": 3641, "word": "ឈាន--" },
    { "id": 3642, "word": "ឈាបនកិច្ច" },
    { "id": 3643, "word": "ឈាបនដ្ឋាន" },
    { "id": 3644, "word": "ឈាម" },
    { "id": 3645, "word": "ឈាវ" },
    { "id": 3646, "word": "ឈិង" },
    { "id": 3647, "word": "ឈឹង" },
    { "id": 3648, "word": "ឈឹប" },
    { "id": 3649, "word": "ឈឺ" },
    { "id": 3650, "word": "ឈឺឆ្អាល" },
    { "id": 3651, "word": "ឈុត" },
    { "id": 3652, "word": "ឈូ" },
    { "id": 3653, "word": "ឈូក" },
    { "id": 3654, "word": "ឈូង" },
    { "id": 3655, "word": "ឈូច" },
    { "id": 3656, "word": "ឈូឆរ" },
    { "id": 3657, "word": "ឈូឈី" },
    { "id": 3658, "word": "ឈូស" },
    { "id": 3659, "word": "ឈើ" },
    { "id": 3660, "word": "ឈើកង់" },
    { "id": 3661, "word": "ឈើកូត" },
    { "id": 3662, "word": "ឈើកែវ" },
    { "id": 3663, "word": "ឈើខ្មៅ" },
    { "id": 3664, "word": "ឈើគូស" },
    { "id": 3665, "word": "ឈើចាក់ធ្មេញ" },
    { "id": 3666, "word": "ឈើច្រត់" },
    { "id": 3667, "word": "ឈើច្រាន" },
    { "id": 3668, "word": "ឈើជ្រែង" },
    { "id": 3669, "word": "ឈើឈ្នាន់" },
    { "id": 3670, "word": "ឈើត្រង់" },
    { "id": 3671, "word": "ឈើទាល" },
    { "id": 3672, "word": "ឈើទាលត្រាញ់" },
    { "id": 3673, "word": "ឈើបុក" },
    { "id": 3674, "word": "ឈើផ្ដេក" },
    { "id": 3675, "word": "ឈើភ្លើង" },
    { "id": 3676, "word": "ឈើរា" },
    { "id": 3677, "word": "ឈើរឹត" },
    { "id": 3678, "word": "ឈើសូល" },
    { "id": 3679, "word": "ឈើស្ដឹង" },
    { "id": 3680, "word": "ឈើស្ទន់" },
    { "id": 3681, "word": "ឈើស្រួច" },
    { "id": 3682, "word": "ឈើហុប" },
    { "id": 3683, "word": "ឈើអណ្ដោត" },
    { "id": 3684, "word": "ឈើអន្ទង" },
    { "id": 3685, "word": "ឈើអែម" },
    { "id": 3686, "word": "ឈែល" },
    { "id": 3687, "word": "ឈោង" },
    { "id": 3688, "word": "ឈ្ងប់" },
    { "id": 3689, "word": "ឈ្ងប់ឈ្ងុយ" },
    { "id": 3690, "word": "ឈ្ងុយ" },
    { "id": 3691, "word": "ឈ្ងៀម" },
    { "id": 3692, "word": "ឈ្ងោក" },
    { "id": 3693, "word": "ឈ្នក់" },
    { "id": 3694, "word": "ឈ្នាង" },
    { "id": 3695, "word": "ឈ្នាន់" },
    { "id": 3696, "word": "ឈ្នានីស" },
    { "id": 3697, "word": "ឈ្នុល" },
    { "id": 3698, "word": "ឈ្នុលតង្ករ" },
    { "id": 3699, "word": "ឈ្នួត" },
    { "id": 3700, "word": "ឈ្នួល" },
    { "id": 3701, "word": "ឈ្នៀង" },
    { "id": 3702, "word": "ឈ្នះ" },
    { "id": 3703, "word": "ឈ្នះឈ្នាន" },
    { "id": 3704, "word": "ឈ្មង" },
    { "id": 3705, "word": "ឈ្មុល" },
    { "id": 3706, "word": "ឈ្មុស" },
    { "id": 3707, "word": "ឈ្មុសទេស" },
    { "id": 3708, "word": "ឈ្មួញ" },
    { "id": 3709, "word": "ឈ្មួយ" },
    { "id": 3710, "word": "ឈ្មៀត" },
    { "id": 3711, "word": "ឈ្មែ" },
    { "id": 3712, "word": "ឈ្មោល" },
    { "id": 3713, "word": "ឈ្មោះ" },
    { "id": 3714, "word": "ឈ្លក់" },
    { "id": 3715, "word": "ឈ្លប" },
    { "id": 3716, "word": "ឈ្លប់" },
    { "id": 3717, "word": "ឈ្លម" },
    { "id": 3718, "word": "ឈ្លានពាន" },
    { "id": 3719, "word": "ឈ្លាស" },
    { "id": 3720, "word": "ឈ្លី" },
    { "id": 3721, "word": "ឈ្លីក" },
    { "id": 3722, "word": "ឈ្លូស" },
    { "id": 3723, "word": "ឈ្លើង" },
    { "id": 3724, "word": "ឈ្លើយ" },
    { "id": 3725, "word": "ឈ្លៀស" },
    { "id": 3726, "word": "ឈ្លេច" },
    { "id": 3727, "word": "ឈ្លេម" },
    { "id": 3728, "word": "ឈ្លែម" },
    { "id": 3729, "word": "ឈ្លោះ" },
    { "id": 3730, "word": "ឈ្វាត" },
    { "id": 3731, "word": "ឈ្វេង" },
    { "id": 3732, "word": "ឈ្វេងយល់" },
    { "id": 3733, "word": "ឈ្វាំង" },
    { "id": 3734, "word": "ឈ្នួត" },
    { "id": 3735, "word": "ញ" },
    { "id": 3736, "word": "ញក" },
    { "id": 3737, "word": "ញក់" },
    { "id": 3738, "word": "ញច់" },
    { "id": 3739, "word": "ញញ័រ" },
    { "id": 3740, "word": "ញញាក់" },
    { "id": 3741, "word": "ញញិម" },
    { "id": 3742, "word": "ញញី" },
    { "id": 3743, "word": "ញញួរ" },
    { "id": 3744, "word": "ញញើត" },
    { "id": 3745, "word": "ញញើម" },
    { "id": 3746, "word": "ញញែម" },
    { "id": 3747, "word": "ញញោច" },
    { "id": 3748, "word": "ញត្តិ" },
    { "id": 3749, "word": "ញត្តិកម្ម" },
    { "id": 3750, "word": "ញត្តិចតុត្ថកម្ម" },
    { "id": 3751, "word": "ញត្តិទុតិយកម្ម" },
    { "id": 3752, "word": "ញន" },
    { "id": 3753, "word": "ញបៗ" },
    { "id": 3754, "word": "ញ៉ម" },
    { "id": 3755, "word": "ញយ" },
    { "id": 3756, "word": "ញ័រ" },
    { "id": 3757, "word": "ញល់" },
    { "id": 3758, "word": "ញាក់" },
    { "id": 3759, "word": "ញ៉ាក" },
    { "id": 3760, "word": "ញ៉ាច់!" },
    { "id": 3761, "word": "ញាណ" },
    { "id": 3762, "word": "ញាណ--" },
    { "id": 3763, "word": "ញាណី" },
    { "id": 3764, "word": "ញាត់" },
    { "id": 3765, "word": "ញាតកា" },
    { "id": 3766, "word": "ញាតស្បាត" },
    { "id": 3767, "word": "ញាតា" },
    { "id": 3768, "word": "ញាតិ" },
    { "id": 3769, "word": "ញាតិ--" },
    { "id": 3770, "word": "ញាប់" },
    { "id": 3771, "word": "ញ៉ាប" },
    { "id": 3772, "word": "ញ៉ាម" },
    { "id": 3773, "word": "ញាស់" },
    { "id": 3774, "word": "ញ៉ិកញ៉ក់" },
    { "id": 3775, "word": "ញ៉ិញញ៉ុញ" },
    { "id": 3776, "word": "ញ៉ិម" },
    { "id": 3777, "word": "ញ៉ិល" },
    { "id": 3778, "word": "ញី" },
    { "id": 3779, "word": "ញីញញូញ" },
    { "id": 3780, "word": "ញឹក" },
    { "id": 3781, "word": "ញឹកៗ" },
    { "id": 3782, "word": "ញ៉ឹង" },
    { "id": 3783, "word": "ញឹន" },
    { "id": 3784, "word": "ញ៉ឹម" },
    { "id": 3785, "word": "ញ៉ុញ" },
    { "id": 3786, "word": "ញ៉ុមៗ" },
    { "id": 3787, "word": "ញុះ" },
    { "id": 3788, "word": "ញុះញង់" },
    { "id": 3789, "word": "ញូញ" },
    { "id": 3790, "word": "ញ៉ូញញ៉ាញ" },
    { "id": 3791, "word": "ញ៉ើក" },
    { "id": 3792, "word": "ញើញ" },
    { "id": 3793, "word": "ញើបៗ" },
    { "id": 3794, "word": "ញើស" },
    { "id": 3795, "word": "ញៀច" },
    { "id": 3796, "word": "ញៀត" },
    { "id": 3797, "word": "ញៀតស្បាត" },
    { "id": 3798, "word": "ញៀន" },
    { "id": 3799, "word": "ញេញ" },
    { "id": 3800, "word": "ញេច" },
    { "id": 3801, "word": "ញ៉េចញ៉ាច" },
    { "id": 3802, "word": "ញ៉េចញ៉ូច" },
    { "id": 3803, "word": "ញ៉េបៗ" },
    { "id": 3804, "word": "ញេយ្យធម្ម" },
    { "id": 3805, "word": "ញ៉េវ" },
    { "id": 3806, "word": "ញ៉េវញ៉ាវ" },
    { "id": 3807, "word": "ញ៉េះញ៉ោះ" },
    { "id": 3808, "word": "ញ៉ែ" },
    { "id": 3809, "word": "ញែក" },
    { "id": 3810, "word": "ញ៉ែកញ៉ក" },
    { "id": 3811, "word": "ញ៉ែង" },
    { "id": 3812, "word": "ញ៉ែងញ៉ង" },
    { "id": 3813, "word": "ញ៉ែមៗ!" },
    { "id": 3814, "word": "ញ៉ោង" },
    { "id": 3815, "word": "ញោច" },
    { "id": 3816, "word": "ញោម" },
    { "id": 3817, "word": "ញោមវត្ត" },
    { "id": 3818, "word": "ញោស" },
    { "id": 3819, "word": "ញោះ" },
    { "id": 3820, "word": "ញំៗ" },
    { "id": 3821, "word": "ញាំ" },
    { "id": 3822, "word": "ញ៉ាំ" },
    { "id": 3823, "word": "ញ៉ាំង" },
    { "id": 3824, "word": "ញ៉ាំងៗ" },
    { "id": 3825, "word": "ញ៉ាំញ៉ើ" },
    { "id": 3826, "word": "ដ" },
    { "id": 3827, "word": "ដ៏" },
    { "id": 3828, "word": "ដក" },
    { "id": 3829, "word": "ដកខិម" },
    { "id": 3830, "word": "ដកគាំ" },
    { "id": 3831, "word": "ដកចន្ទន៍" },
    { "id": 3832, "word": "ដកទង" },
    { "id": 3833, "word": "ដកព" },
    { "id": 3834, "word": "ដកពាយ" },
    { "id": 3835, "word": "ដកម៉ៃ" },
    { "id": 3836, "word": "ដក់" },
    { "id": 3837, "word": "ដក់ដឿ" },
    { "id": 3838, "word": "ដង" },
    { "id": 3839, "word": "ដងកញ្ចាម" },
    { "id": 3840, "word": "ដងកន្ទុយ" },
    { "id": 3841, "word": "ដងកាំបិត" },
    { "id": 3842, "word": "ដងក្ដារ" },
    { "id": 3843, "word": "ដងខ្ទែង" },
    { "id": 3844, "word": "ដងគោម" },
    { "id": 3845, "word": "ដងដឹង" },
    { "id": 3846, "word": "ដងដោយ" },
    { "id": 3847, "word": "ដងណោះ" },
    { "id": 3848, "word": "ដងបង្ហួរ" },
    { "id": 3849, "word": "ដងព្រៃ" },
    { "id": 3850, "word": "ដងភ្នំ" },
    { "id": 3851, "word": "ដងរែក" },
    { "id": 3852, "word": "ដងស្ទឹង" },
    { "id": 3853, "word": "ដង្កាប់" },
    { "id": 3854, "word": "ដង្កាវ" },
    { "id": 3855, "word": "ដង្កូវ" },
    { "id": 3856, "word": "ដង្កែ" },
    { "id": 3857, "word": "ដង្កោ" },
    { "id": 3858, "word": "ដង្កោខ្មោច" },
    { "id": 3859, "word": "ដង្ខៅ" },
    { "id": 3860, "word": "ដង្គត់" },
    { "id": 3861, "word": "ដង្គន់" },
    { "id": 3862, "word": "ដង្គោល" },
    { "id": 3863, "word": "ដង្គុំ" },
    { "id": 3864, "word": "ដង្វិន" },
    { "id": 3865, "word": "ដង្ហក់" },
    { "id": 3866, "word": "ដង្ហាក់" },
    { "id": 3867, "word": "ដង្ហិត" },
    { "id": 3868, "word": "ដង្ហើម" },
    { "id": 3869, "word": "ដង្ហែ" },
    { "id": 3870, "word": "ដង្ហោយ" },
    { "id": 3871, "word": "ដដុស" },
    { "id": 3872, "word": "ដដែល" },
    { "id": 3873, "word": "ដណ្ដប់" },
    { "id": 3874, "word": "ដណ្ដឹង" },
    { "id": 3875, "word": "ដណ្ដើម" },
    { "id": 3876, "word": "ដណ្ដាំ" },
    { "id": 3877, "word": "ដទៃ" },
    { "id": 3878, "word": "ដន្លង" },
    { "id": 3879, "word": "ដន្លាប់" },
    { "id": 3880, "word": "ដប" },
    { "id": 3881, "word": "ដបទៀម" },
    { "id": 3882, "word": "ដប់" },
    { "id": 3883, "word": "ដម" },
    { "id": 3884, "word": "ដរ" },
    { "id": 3885, "word": "ដរធរ" },
    { "id": 3886, "word": "ដារាប" },
    { "id": 3887, "word": "ដល់" },
    { "id": 3888, "word": "ដលោក" },
    { "id": 3889, "word": "ដ៏ហើយ" },
    { "id": 3890, "word": "ដ៏ឡុង" },
    { "id": 3891, "word": "ដា" },
    { "id": 3892, "word": "ដាក់" },
    { "id": 3893, "word": "ដាង" },
    { "id": 3894, "word": "ដាច" },
    { "id": 3895, "word": "ដាច់" },
    { "id": 3896, "word": "ដាន" },
    { "id": 3897, "word": "ដាប" },
    { "id": 3898, "word": "ដាប់" },
    { "id": 3899, "word": "ដាម" },
    { "id": 3900, "word": "ដាយ" },
    { "id": 3901, "word": "ដារ" },
    { "id": 3902, "word": "ដាល" },
    { "id": 3903, "word": "ដាលវ៉ាល" },
    { "id": 3904, "word": "ដាល់" },
    { "id": 3905, "word": "ដាល់អំបុក" },
    { "id": 3906, "word": "ដាវ" },
    { "id": 3907, "word": "ដាស" },
    { "id": 3908, "word": "ដាស់" },
    { "id": 3909, "word": "ដាស់ដែ" },
    { "id": 3910, "word": "ដាស់តឿន" },
    { "id": 3911, "word": "ដាស់ទំ" },
    { "id": 3912, "word": "ដិត" },
    { "id": 3913, "word": "ដីកា" },
    { "id": 3914, "word": "ដីខ្មៅ" },
    { "id": 3915, "word": "ដីប្លី" },
    { "id": 3916, "word": "ដីលែង" },
    { "id": 3917, "word": "ដីស" },
    { "id": 3918, "word": "ដីស្អិត" },
    { "id": 3919, "word": "ដឹក" },
    { "id": 3920, "word": "ដឹកដឿ" },
    { "id": 3921, "word": "ដឹកដៀវ" },
    { "id": 3922, "word": "ដឹកនាំ" },
    { "id": 3923, "word": "ដឹង" },
    { "id": 3924, "word": "ដឹងក្ដី" },
    { "id": 3925, "word": "ដឹប" },
    { "id": 3926, "word": "ដឹស" },
    { "id": 3927, "word": "ដី" },
    { "id": 3928, "word": "ដុកដាន់" },
    { "id": 3929, "word": "ដុត" },
    { "id": 3930, "word": "ដុន" },
    { "id": 3931, "word": "ដុន!" },
    { "id": 3932, "word": "ដុប" },
    { "id": 3933, "word": "ដុបៗ" },
    { "id": 3934, "word": "ដុល" },
    { "id": 3935, "word": "ដុល្លារ" },
    { "id": 3936, "word": "ដុស" },
    { "id": 3937, "word": "ដុះ" },
    { "id": 3938, "word": "ដុះដាល" },
    { "id": 3939, "word": "ដូង" },
    { "id": 3940, "word": "ដូងចែម" },
    { "id": 3941, "word": "ដូងព្រះ" },
    { "id": 3942, "word": "ដូច" },
    { "id": 3943, "word": "ដូចដែល" },
    { "id": 3944, "word": "ដូច្នឹង" },
    { "id": 3945, "word": "ដូច្នេះ" },
    { "id": 3946, "word": "ដូច្នោះ" },
    { "id": 3947, "word": "ដូន" },
    { "id": 3948, "word": "ដូនជី" },
    { "id": 3949, "word": "ដូនតា" },
    { "id": 3950, "word": "ដូនពេញ" },
    { "id": 3951, "word": "ដូរ" },
    { "id": 3952, "word": "ដួង" },
    { "id": 3953, "word": "ដួច" },
    { "id": 3954, "word": "ដួចដល់" },
    { "id": 3955, "word": "ដួន" },
    { "id": 3956, "word": "ដួល" },
    { "id": 3957, "word": "ដួស" },
    { "id": 3958, "word": "ដើម" },
    { "id": 3959, "word": "ដើម្បី" },
    { "id": 3960, "word": "ដើរ" },
    { "id": 3961, "word": "ដើរតួ" },
    { "id": 3962, "word": "ដើរទា" },
    { "id": 3963, "word": "ដើរទេស" },
    { "id": 3964, "word": "ដើរហើរ" },
    { "id": 3965, "word": "ដៀង" },
    { "id": 3966, "word": "ដៀប" },
    { "id": 3967, "word": "ដៀមដាម" },
    { "id": 3968, "word": "ដៀល" },
    { "id": 3969, "word": "ដៀវ" },
    { "id": 3970, "word": "ដេក" },
    { "id": 3971, "word": "ដេញ" },
    { "id": 3972, "word": "ដេរ" },
    { "id": 3973, "word": "ដេរដាស" },
    { "id": 3974, "word": "ដែក" },
    { "id": 3975, "word": "ដែង" },
    { "id": 3976, "word": "ដែន" },
    { "id": 3977, "word": "ដែរ" },
    { "id": 3978, "word": "ដែល" },
    { "id": 3979, "word": "ដៃ" },
    { "id": 3980, "word": "ដៃកែវ" },
    { "id": 3981, "word": "ដៃខ្លា" },
    { "id": 3982, "word": "ដៃរគៀម" },
    { "id": 3983, "word": "ដៃរណែង" },
    { "id": 3984, "word": "ដៃរហាត់" },
    { "id": 3985, "word": "ដៃស្វា" },
    { "id": 3986, "word": "ដោក" },
    { "id": 3987, "word": "ដោច" },
    { "id": 3988, "word": "ដោត" },
    { "id": 3989, "word": "ដោប" },
    { "id": 3990, "word": "ដោម" },
    { "id": 3991, "word": "ដោយ" },
    { "id": 3992, "word": "ដោយនូវ" },
    { "id": 3993, "word": "ដោយសារ" },
    { "id": 3994, "word": "ដោយហេតុ" },
    { "id": 3995, "word": "ដោរ" },
    { "id": 3996, "word": "ដោល" },
    { "id": 3997, "word": "ដោះ" },
    { "id": 3998, "word": "ដោះគន់" },
    { "id": 3999, "word": "ដោះញ" },
    { "id": 4000, "word": "ដោះដៃ" },
    { "id": 4001, "word": "ដោះទុក្ខសត្វ" },
    { "id": 4002, "word": "ដោះសា" },
    { "id": 4003, "word": "ដៅ" },
    { "id": 4004, "word": "ដុំ" },
    { "id": 4005, "word": "ដុំដៃ" },
    { "id": 4006, "word": "ដំ" },
    { "id": 4007, "word": "ដំងើច" },
    { "id": 4008, "word": "ដំណក" },
    { "id": 4009, "word": "ដំណក់" },
    { "id": 4010, "word": "ដំណាក់" },
    { "id": 4011, "word": "ដំណាច់" },
    { "id": 4012, "word": "ដំណាប់" },
    { "id": 4013, "word": "ដំណាល" },
    { "id": 4014, "word": "ដំណឹង" },
    { "id": 4015, "word": "ដំណុស" },
    { "id": 4016, "word": "ដំណុះ" },
    { "id": 4017, "word": "ដំណូច" },
    { "id": 4018, "word": "ដំណួច" },
    { "id": 4019, "word": "ដំណួល" },
    { "id": 4020, "word": "ដំណើប" },
    { "id": 4021, "word": "ដំណើរ" },
    { "id": 4022, "word": "ដំណៀល" },
    { "id": 4023, "word": "ដំណេក" },
    { "id": 4024, "word": "ដំណេញ" },
    { "id": 4025, "word": "ដំណែង" },
    { "id": 4026, "word": "ដំណែល" },
    { "id": 4027, "word": "ដំណោះ" },
    { "id": 4028, "word": "ដំណំ" },
    { "id": 4029, "word": "ដំណាំ" },
    { "id": 4030, "word": "ដំប" },
    { "id": 4031, "word": "ដំបង" },
    { "id": 4032, "word": "ដំបងគ្រញូង" },
    { "id": 4033, "word": "ដំបងយក្ស" },
    { "id": 4034, "word": "ដំបន់" },
    { "id": 4035, "word": "ដំបារ" },
    { "id": 4036, "word": "ដំបូក" },
    { "id": 4037, "word": "ដំបូង" },
    { "id": 4038, "word": "ដំបូន្មាន" },
    { "id": 4039, "word": "ដំបូល" },
    { "id": 4040, "word": "ដំបួច" },
    { "id": 4041, "word": "ដំបែ" },
    { "id": 4042, "word": "ដំបៅ" },
    { "id": 4043, "word": "ដំរី" },
    { "id": 4044, "word": "ដំរួច" },
    { "id": 4045, "word": "ដំរួយ" },
    { "id": 4046, "word": "ដំរៀត" },
    { "id": 4047, "word": "ដំរែក" },
    { "id": 4048, "word": "ដំឡាន់" },
    { "id": 4049, "word": "ដំឡូង" },
    { "id": 4050, "word": "ដំឡើង" },
    { "id": 4051, "word": "ដំឡោក" },
    { "id": 4052, "word": "ដំអក់" },
    { "id": 4053, "word": "ដាំ" },
    { "id": 4054, "word": "ដាំដូង" },
    { "id": 4055, "word": "ដាំដែង" },
    { "id": 4056, "word": "ដាំទីង" },
    { "id": 4057, "word": "ដាំង" },
    { "id": 4058, "word": "ដ្បិត" },
    { "id": 4059, "word": "ដំណង" },
    { "id": 4060, "word": "ដំណល់" },
    { "id": 4061, "word": "ដំណាល់" },
    { "id": 4062, "word": "ដំណាស់" },
    { "id": 4063, "word": "ដំណិត" },
    { "id": 4064, "word": "ដំណុត" },
    { "id": 4065, "word": "ដំណូរ" },
    { "id": 4066, "word": "ដំណួស" },
    { "id": 4067, "word": "ដំណៀង" },
    { "id": 4068, "word": "ដំណេរ" },
    { "id": 4069, "word": "ដំណោត" },
    { "id": 4070, "word": "ដំណោយ" },
    { "id": 4071, "word": "ដំណោល" },
    { "id": 4072, "word": "ដំណៅ" },
    { "id": 4073, "word": "ឋ" },
    { "id": 4074, "word": "ឋបនកម្ម" },
    { "id": 4075, "word": "ឋបនាការ" },
    { "id": 4076, "word": "ឋបនីយភណ្ឌ" },
    { "id": 4077, "word": "ឋបនីយវត្ថុ" },
    { "id": 4078, "word": "ឋបនោកាស" },
    { "id": 4079, "word": "ឋបនោបាយ" },
    { "id": 4080, "word": "ឋាន" },
    { "id": 4081, "word": "ឋានៈ" },
    { "id": 4082, "word": "ឋានន្តរ" },
    { "id": 4083, "word": "ឋានន្តរសក្តិ" },
    { "id": 4084, "word": "ឋានបទ្ម" },
    { "id": 4085, "word": "ឋានប្បភេទ" },
    { "id": 4086, "word": "ឋានភាព" },
    { "id": 4087, "word": "ឋានានុក្រម" },
    { "id": 4088, "word": "ឋានានុរូប" },
    { "id": 4089, "word": "ឋានីយ" },
    { "id": 4090, "word": "ឋិត" },
    { "id": 4091, "word": "ឋិតថេរ" },
    { "id": 4092, "word": "ឋិតថេរចីរកាល" },
    { "id": 4093, "word": "ឋិតិ" },
    { "id": 4094, "word": "ឋិតិកាល" },
    { "id": 4095, "word": "ឋិតិភាព" },
    { "id": 4096, "word": "ឌ" },
    { "id": 4097, "word": "ឌមជន" },
    { "id": 4098, "word": "ឌាកិនី" },
    { "id": 4099, "word": "ឌាឌិម" },
    { "id": 4100, "word": "ឌាហរោគ" },
    { "id": 4101, "word": "ឌិកតេ" },
    { "id": 4102, "word": "ឌិន" },
    { "id": 4103, "word": "ឌឺ" },
    { "id": 4104, "word": "ឌឺដង" },
    { "id": 4105, "word": "ឌុដាន់" },
    { "id": 4106, "word": "ឌុកដាន់" },
    { "id": 4107, "word": "ឌុន" },
    { "id": 4108, "word": "ឌេបនកម្ម" },
    { "id": 4109, "word": "ឌេបនាការ" },
    { "id": 4110, "word": "ឍ" },
    { "id": 4111, "word": "ឍាមរា" },
    { "id": 4112, "word": "ឍាល" },
    { "id": 4113, "word": "ឍាលិន" },
    { "id": 4114, "word": "ឍុណ្ឍិ" },
    { "id": 4115, "word": "ណ" },
    { "id": 4116, "word": "ណតណយ" },
    { "id": 4117, "word": "ណា" },
    { "id": 4118, "word": "ណា៎!" },
    { "id": 4119, "word": "ណាត់" },
    { "id": 4120, "word": "ណាមស្រង់" },
    { "id": 4121, "word": "ណាយ" },
    { "id": 4122, "word": "ណាស់" },
    { "id": 4123, "word": "ណាស់សា" },
    { "id": 4124, "word": "ណិងណុង" },
    { "id": 4125, "word": "ណិមណុម" },
    { "id": 4126, "word": "ណិល" },
    { "id": 4127, "word": "ណឺង" },
    { "id": 4128, "word": "ណូង" },
    { "id": 4129, "word": "ណូរី" },
    { "id": 4130, "word": "ណេងណូង" },
    { "id": 4131, "word": "ណេះណោះ" },
    { "id": 4132, "word": "ណែ" },
    { "id": 4133, "word": "ណែកណក" },
    { "id": 4134, "word": "ណែងណង" },
    { "id": 4135, "word": "ណែងណោង" },
    { "id": 4136, "word": "ណែណន" },
    { "id": 4137, "word": "ណែន" },
    { "id": 4138, "word": "ណែនណាន់" },
    { "id": 4139, "word": "ណែនាំ" },
    { "id": 4140, "word": "ណែម" },
    { "id": 4141, "word": "ណែលណោល" },
    { "id": 4142, "word": "ណែវ" },
    { "id": 4143, "word": "ណាំនួន" },
    { "id": 4144, "word": "ណាំវ៉ា" },
    { "id": 4145, "word": "ណាំង" },
    { "id": 4146, "word": "ណ៎ះ!" },
    { "id": 4147, "word": "ណ្ហើយ" },
    { "id": 4148, "word": "ណ្ហើយចុះ" },
    { "id": 4149, "word": "ត" },
    { "id": 4150, "word": "តក់" },
    { "id": 4151, "word": "តក់ក្រហល់" },
    { "id": 4152, "word": "តក់ប្រមា" },
    { "id": 4153, "word": "តក់ស្លុត" },
    { "id": 4154, "word": "តក្ក" },
    { "id": 4155, "word": "តក្កមា" },
    { "id": 4156, "word": "តក្កវិជ្ជា" },
    { "id": 4157, "word": "តក្កវិញ្ញូ" },
    { "id": 4158, "word": "តក្កវិទ" },
    { "id": 4159, "word": "តក្កវិទូ" },
    { "id": 4160, "word": "តក្កសាស្ត្រ" },
    { "id": 4161, "word": "តង" },
    { "id": 4162, "word": "តង្ករ" },
    { "id": 4163, "word": "តង្កៀប" },
    { "id": 4164, "word": "តង្កៀបក្ដាម" },
    { "id": 4165, "word": "តង្វាយ" },
    { "id": 4166, "word": "តចបញ្ចកកម្មដ្ឋាន" },
    { "id": 4167, "word": "តចសារជាតិ" },
    { "id": 4168, "word": "តចសារព្រឹក្ស" },
    { "id": 4169, "word": "តជ្ជារី" },
    { "id": 4170, "word": "តណ្ហា" },
    { "id": 4171, "word": "តណ្ហាទាស" },
    { "id": 4172, "word": "តតងអារ៉ង" },
    { "id": 4173, "word": "តតតយ" },
    { "id": 4174, "word": "តតាក់តតាំ" },
    { "id": 4175, "word": "តតិបតតុប" },
    { "id": 4176, "word": "តតូង" },
    { "id": 4177, "word": "តតូងតតាង" },
    { "id": 4178, "word": "តតេងតតាង" },
    { "id": 4179, "word": "តតេះតតោះ" },
    { "id": 4180, "word": "តតេះតតះ" },
    { "id": 4181, "word": "តតែងតតោង" },
    { "id": 4182, "word": "តតែតតោ" },
    { "id": 4183, "word": "តតែលតតោល" },
    { "id": 4184, "word": "តតះ" },
    { "id": 4185, "word": "តថាគត" },
    { "id": 4186, "word": "តថានុរូប" },
    { "id": 4187, "word": "តន់" },
    { "id": 4188, "word": "តន័យ" },
    { "id": 4189, "word": "តនយា" },
    { "id": 4190, "word": "តនុ" },
    { "id": 4191, "word": "តនុជ" },
    { "id": 4192, "word": "តៈខេ" },
    { "id": 4193, "word": "តន្តិភាសា" },
    { "id": 4194, "word": "តន្រ្តី" },
    { "id": 4195, "word": "តន្ត្រំ" },
    { "id": 4196, "word": "តន្ថើន" },
    { "id": 4197, "word": "តប" },
    { "id": 4198, "word": "តប់" },
    { "id": 4199, "word": "តបកថា" },
    { "id": 4200, "word": "តប់កមល" },
    { "id": 4201, "word": "តបធម៌" },
    { "id": 4202, "word": "តប់ប្រមល់" },
    { "id": 4203, "word": "តបស្សី" },
    { "id": 4204, "word": "តបៈ" },
    { "id": 4205, "word": "តបោធន" },
    { "id": 4206, "word": "តបះ" },
    { "id": 4207, "word": "តពោក" },
    { "id": 4208, "word": "តម" },
    { "id": 4209, "word": "តម្កល់" },
    { "id": 4210, "word": "តម្កាត់" },
    { "id": 4211, "word": "តម្កើង" },
    { "id": 4212, "word": "តម្កុំតម្កើង" },
    { "id": 4213, "word": "តម្បាញ" },
    { "id": 4214, "word": "តម្បារ" },
    { "id": 4215, "word": "តម្បុត" },
    { "id": 4216, "word": "តម្បៀត" },
    { "id": 4217, "word": "តម្ពក់" },
    { "id": 4218, "word": "តម្ពុល" },
    { "id": 4219, "word": "តម្ពេច" },
    { "id": 4220, "word": "តម្ពែក" },
    { "id": 4221, "word": "តម្រង" },
    { "id": 4222, "word": "តម្រង់" },
    { "id": 4223, "word": "តម្រា" },
    { "id": 4224, "word": "តម្រាប់" },
    { "id": 4225, "word": "តម្រាយ" },
    { "id": 4226, "word": "តម្រាស់" },
    { "id": 4227, "word": "តម្រិះ" },
    { "id": 4228, "word": "តម្រឹម" },
    { "id": 4229, "word": "តម្រុយ" },
    { "id": 4230, "word": "តម្រូវ" },
    { "id": 4231, "word": "តម្រួត" },
    { "id": 4232, "word": "តម្រៀប" },
    { "id": 4233, "word": "តម្រេក" },
    { "id": 4234, "word": "តម្រាំ" },
    { "id": 4235, "word": "តម្លង់" },
    { "id": 4236, "word": "តម្លា" },
    { "id": 4237, "word": "តម្លឹង" },
    { "id": 4238, "word": "តម្លុញ" },
    { "id": 4239, "word": "តម្លៃ" },
    { "id": 4240, "word": "តម្លោះ" },
    { "id": 4241, "word": "តម្អឹង" },
    { "id": 4242, "word": "តម្អូញ" },
    { "id": 4243, "word": "តយ" },
    { "id": 4244, "word": "តយង៉យ" },
    { "id": 4245, "word": "តរង្គគតិ" },
    { "id": 4246, "word": "តរុណ" },
    { "id": 4247, "word": "តរុណបុត្ត" },
    { "id": 4248, "word": "តរុណភាព" },
    { "id": 4249, "word": "តរុណវ័យ" },
    { "id": 4250, "word": "តរុណី" },
    { "id": 4251, "word": "តវ៉ា" },
    { "id": 4252, "word": "តា" },
    { "id": 4253, "word": "តាក" },
    { "id": 4254, "word": "តាករខាក" },
    { "id": 4255, "word": "តាករ៉ាក" },
    { "id": 4256, "word": "តាកែ" },
    { "id": 4257, "word": "តាក់តែង" },
    { "id": 4258, "word": "តាខាយ" },
    { "id": 4259, "word": "តាខេ" },
    { "id": 4260, "word": "តាង" },
    { "id": 4261, "word": "តាដត់" },
    { "id": 4262, "word": "តាងរ៉ាង" },
    { "id": 4263, "word": "តាច" },
    { "id": 4264, "word": "តាជី" },
    { "id": 4265, "word": "តាណី" },
    { "id": 4266, "word": "តាត" },
    { "id": 4267, "word": "តាត្រៅ" },
    { "id": 4268, "word": "តាន" },
    { "id": 4269, "word": "តានតឹង" },
    { "id": 4270, "word": "តាន់" },
    { "id": 4271, "word": "តាប់តាន់" },
    { "id": 4272, "word": "តាប" },
    { "id": 4273, "word": "តាប់" },
    { "id": 4274, "word": "តាបស" },
    { "id": 4275, "word": "តាម" },
    { "id": 4276, "word": "តាមតែ" },
    { "id": 4277, "word": "តាមោង" },
    { "id": 4278, "word": "តាយគំនិត" },
    { "id": 4279, "word": "តាយបើគិត" },
    { "id": 4280, "word": "តាយសាក" },
    { "id": 4281, "word": "តាយស្មិង" },
    { "id": 4282, "word": "តាយហោង" },
    { "id": 4283, "word": "តារា" },
    { "id": 4284, "word": "តារាង" },
    { "id": 4285, "word": "តារាបថ" },
    { "id": 4286, "word": "តារាភូសា" },
    { "id": 4287, "word": "តារាសាស្ត្រ" },
    { "id": 4288, "word": "តាលបត្រ" },
    { "id": 4289, "word": "តាលវ័ន" },
    { "id": 4290, "word": "តាលហាល" },
    { "id": 4291, "word": "តាលុ" },
    { "id": 4292, "word": "តាលុជៈ" },
    { "id": 4293, "word": "តាវកាលិក" },
    { "id": 4294, "word": "តាវត្តិង្ស" },
    { "id": 4295, "word": "តាវៅ" },
    { "id": 4296, "word": "តាសក់" },
    { "id": 4297, "word": "តាអក" },
    { "id": 4298, "word": "តាឱ" },
    { "id": 4299, "word": "តិកៈ" },
    { "id": 4300, "word": "តិកតុក" },
    { "id": 4301, "word": "តិច" },
    { "id": 4302, "word": "តិចៗ" },
    { "id": 4303, "word": "តិញតុញ" },
    { "id": 4304, "word": "តិណជាតិ" },
    { "id": 4305, "word": "តិថី" },
    { "id": 4306, "word": "តិថីក្ស័យ" },
    { "id": 4307, "word": "តិបតុប" },
    { "id": 4308, "word": "តិបុក" },
    { "id": 4309, "word": "តិមធី" },
    { "id": 4310, "word": "តិរច្ឆាន" },
    { "id": 4311, "word": "តិរច្ឆានកថា" },
    { "id": 4312, "word": "តិរ្ថិយ" },
    { "id": 4313, "word": "តិរោកុឌ្ឌសូត្រ" },
    { "id": 4314, "word": "តិលក" },
    { "id": 4315, "word": "តិះ" },
    { "id": 4316, "word": "តិះដៀល" },
    { "id": 4317, "word": "តីរវិថី" },
    { "id": 4318, "word": "តឹក" },
    { "id": 4319, "word": "តឹកៗ" },
    { "id": 4320, "word": "តឹកកែ" },
    { "id": 4321, "word": "តឹកតាង" },
    { "id": 4322, "word": "តឹង" },
    { "id": 4323, "word": "តឹងរ៉ឹង" },
    { "id": 4324, "word": "តឹង" },
    { "id": 4325, "word": "តឺតរខឺត" },
    { "id": 4326, "word": "តុ" },
    { "id": 4327, "word": "តុកកែ" },
    { "id": 4328, "word": "តុកតុល" },
    { "id": 4329, "word": "តុករង្វាន់" },
    { "id": 4330, "word": "តុង" },
    { "id": 4331, "word": "តុងតាំង" },
    { "id": 4332, "word": "តុញ" },
    { "id": 4333, "word": "តុងទីន" },
    { "id": 4334, "word": "តុណ្ហីភាព" },
    { "id": 4335, "word": "តុបៗ" },
    { "id": 4336, "word": "តុមត្ថកិរិយា" },
    { "id": 4337, "word": "តុម្ព" },
    { "id": 4338, "word": "តុម្ពថូប" },
    { "id": 4339, "word": "តុរង្គ" },
    { "id": 4340, "word": "តុរិយាង្គ" },
    { "id": 4341, "word": "តុល" },
    { "id": 4342, "word": "តុលម៉ុល" },
    { "id": 4343, "word": "តុល្យ" },
    { "id": 4344, "word": "តុល្យការ" },
    { "id": 4345, "word": "តុល្យភាព" },
    { "id": 4346, "word": "តុល្យាការ" },
    { "id": 4347, "word": "តុល្យាធិករណៈ" },
    { "id": 4348, "word": "តុលា" },
    { "id": 4349, "word": "តុលាការ" },
    { "id": 4350, "word": "តុសិត" },
    { "id": 4351, "word": "តុស្ដី" },
    { "id": 4352, "word": "តុះ" },
    { "id": 4353, "word": "តូង" },
    { "id": 4354, "word": "តូងតាង" },
    { "id": 4355, "word": "តូច" },
    { "id": 4356, "word": "តូន" },
    { "id": 4357, "word": "តូប" },
    { "id": 4358, "word": "តូយ៌តន្ត្រី" },
    { "id": 4359, "word": "តួ" },
    { "id": 4360, "word": "តួច" },
    { "id": 4361, "word": "តួន" },
    { "id": 4362, "word": "តួមៗ" },
    { "id": 4363, "word": "តួយ៉ាង" },
    { "id": 4364, "word": "តួឯក" },
    { "id": 4365, "word": "តើ" },
    { "id": 4366, "word": "តើក" },
    { "id": 4367, "word": "តើកៗ" },
    { "id": 4368, "word": "តើតៗ" },
    { "id": 4369, "word": "តើន" },
    { "id": 4370, "word": "តើយ" },
    { "id": 4371, "word": "តឿ" },
    { "id": 4372, "word": "តឿន" },
    { "id": 4373, "word": "តៀង" },
    { "id": 4374, "word": "តៀជីវ" },
    { "id": 4375, "word": "តៀន" },
    { "id": 4376, "word": "តៀប" },
    { "id": 4377, "word": "តៀម" },
    { "id": 4378, "word": "តេងតាង" },
    { "id": 4379, "word": "តេចីវរិកង្គៈ" },
    { "id": 4380, "word": "តេជ" },
    { "id": 4381, "word": "តេជវន្ត" },
    { "id": 4382, "word": "តេជសី" },
    { "id": 4383, "word": "តេជានុភាព" },
    { "id": 4384, "word": "តេជោកសិណ" },
    { "id": 4385, "word": "តេជោជ័យ" },
    { "id": 4386, "word": "តេជោធាតុ" },
    { "id": 4387, "word": "តេជោពល" },
    { "id": 4388, "word": "តេជះ" },
    { "id": 4389, "word": "តេត" },
    { "id": 4390, "word": "តេន" },
    { "id": 4391, "word": "តេបតាប" },
    { "id": 4392, "word": "តេលតាល" },
    { "id": 4393, "word": "តេះតោះ" },
    { "id": 4394, "word": "តែ" },
    { "id": 4395, "word": "តែកតោក" },
    { "id": 4396, "word": "តែង" },
    { "id": 4397, "word": "តែងតោង" },
    { "id": 4398, "word": "តែងតាំង" },
    { "id": 4399, "word": "តែតោ" },
    { "id": 4400, "word": "តែនតិ៍" },
    { "id": 4401, "word": "តែម" },
    { "id": 4402, "word": "តែម" },
    { "id": 4403, "word": "តែលតោល" },
    { "id": 4404, "word": "តែវ៉ែ" },
    { "id": 4405, "word": "តៃហោង" },
    { "id": 4406, "word": "តោ" },
    { "id": 4407, "word": "តោ" },
    { "id": 4408, "word": "តោក" },
    { "id": 4409, "word": "តោកយ៉ាក" },
    { "id": 4410, "word": "តោករខោក" },
    { "id": 4411, "word": "តោកអារក្ស" },
    { "id": 4412, "word": "តោង" },
    { "id": 4413, "word": "តោងក្រពាត់" },
    { "id": 4414, "word": "តោងការ" },
    { "id": 4415, "word": "តោងទាម" },
    { "id": 4416, "word": "តោតតូង" },
    { "id": 4417, "word": "តោតម៉ា" },
    { "id": 4418, "word": "តោតម៉ោង" },
    { "id": 4419, "word": "តោន" },
    { "id": 4420, "word": "តោមរ" },
    { "id": 4421, "word": "តោមរធរ" },
    { "id": 4422, "word": "តោយ៉ោ" },
    { "id": 4423, "word": "តោរណៈ" },
    { "id": 4424, "word": "តោលម៉ោល" },
    { "id": 4425, "word": "តោសម៉ោស" },
    { "id": 4426, "word": "តោះៗ" },
    { "id": 4427, "word": "តោះតើយ" },
    { "id": 4428, "word": "តៅ" },
    { "id": 4429, "word": "តៅខូវ" },
    { "id": 4430, "word": "តៅស៊ន" },
    { "id": 4431, "word": "តៅហ៊ូ" },
    { "id": 4432, "word": "តំណ" },
    { "id": 4433, "word": "តំណក់" },
    { "id": 4434, "word": "តំណាង" },
    { "id": 4435, "word": "តំណាប់" },
    { "id": 4436, "word": "តំណាល" },
    { "id": 4437, "word": "តំណិះ" },
    { "id": 4438, "word": "តំណិះ ដំណៀល" },
    { "id": 4439, "word": "តំណុះ" },
    { "id": 4440, "word": "តំណូច" },
    { "id": 4441, "word": "តំណែង" },
    { "id": 4442, "word": "តំណាំង" },
    { "id": 4443, "word": "តំបន់" },
    { "id": 4444, "word": "តាំង" },
    { "id": 4445, "word": "តាំងយូ" },
    { "id": 4446, "word": "តាំងឱ" },
    { "id": 4447, "word": "តាំណាន" },
    { "id": 4448, "word": "តះ" },
    { "id": 4449, "word": "ត្ងោក" },
    { "id": 4450, "word": "ត្នោត" },
    { "id": 4451, "word": "ត្បក" },
    { "id": 4452, "word": "ត្បទ" },
    { "id": 4453, "word": "ត្បាញ" },
    { "id": 4454, "word": "ត្បារ" },
    { "id": 4455, "word": "ត្បាល់" },
    { "id": 4456, "word": "ត្បាល់កិន" },
    { "id": 4457, "word": "ត្បាល់ដែក" },
    { "id": 4458, "word": "ត្បិត" },
    { "id": 4459, "word": "ត្បុត" },
    { "id": 4460, "word": "ត្បុរ" },
    { "id": 4461, "word": "ត្បូង" },
    { "id": 4462, "word": "ត្បូងឃ្មុំ" },
    { "id": 4463, "word": "ត្បៀត" },
    { "id": 4464, "word": "ត្បែង" },
    { "id": 4465, "word": "ត្មាត" },
    { "id": 4466, "word": "ត្មិល" },
    { "id": 4467, "word": "ត្មោង" },
    { "id": 4468, "word": "ត្មោល" },
    { "id": 4469, "word": "ត្មះ" },
    { "id": 4470, "word": "ត្រ" },
    { "id": 4471, "word": "ត្រៈ" },
    { "id": 4472, "word": "ត្រក" },
    { "id": 4473, "word": "ត្រក់" },
    { "id": 4474, "word": "ត្រកង" },
    { "id": 4475, "word": "ត្រកាល" },
    { "id": 4476, "word": "ត្រកូល" },
    { "id": 4477, "word": "ត្រកួញ" },
    { "id": 4478, "word": "ត្រកួន" },
    { "id": 4479, "word": "ត្រកួនកន្ទែក" },
    { "id": 4480, "word": "ត្រកៀត" },
    { "id": 4481, "word": "ត្រកៀតប៉ោង" },
    { "id": 4482, "word": "ត្រគាក" },
    { "id": 4483, "word": "ត្រង" },
    { "id": 4484, "word": "ត្រង់" },
    { "id": 4485, "word": "ត្រងាល" },
    { "id": 4486, "word": "ត្រងិល" },
    { "id": 4487, "word": "ត្រងើល" },
    { "id": 4488, "word": "ត្រងោល" },
    { "id": 4489, "word": "ត្រចង់" },
    { "id": 4490, "word": "ត្រចើល" },
    { "id": 4491, "word": "ត្រចៀក" },
    { "id": 4492, "word": "ត្រចៀកកណ្ដុរ" },
    { "id": 4493, "word": "ត្រចៀកកាំ" },
    { "id": 4494, "word": "ត្រចៀកដំរី" },
    { "id": 4495, "word": "ត្រចៀកប្រើស" },
    { "id": 4496, "word": "ត្រចៀកព្នង" },
    { "id": 4497, "word": "ត្រចះ" },
    { "id": 4498, "word": "ត្រជាក់" },
    { "id": 4499, "word": "ត្រជំ" },
    { "id": 4500, "word": "ត្រឈឹង" },
    { "id": 4501, "word": "ត្រឈៃ" },
    { "id": 4502, "word": "ត្រដក់" },
    { "id": 4503, "word": "ត្រដក់ត្រសុំ" },
    { "id": 4504, "word": "ត្រដរ" },
    { "id": 4505, "word": "ត្រដាង" },
    { "id": 4506, "word": "ត្រដាច" },
    { "id": 4507, "word": "ត្រដាបត្រដួស" },
    { "id": 4508, "word": "ត្រដាល់" },
    { "id": 4509, "word": "ត្រដិត" },
    { "id": 4510, "word": "ត្រដឹង" },
    { "id": 4511, "word": "ត្រដឹម" },
    { "id": 4512, "word": "ត្រដុស" },
    { "id": 4513, "word": "ត្រដួច" },
    { "id": 4514, "word": "ត្រដេ" },
    { "id": 4515, "word": "ត្រដេប" },
    { "id": 4516, "word": "ត្រដេវ" },
    { "id": 4517, "word": "ត្រដេវវិច" },
    { "id": 4518, "word": "ត្រដែត" },
    { "id": 4519, "word": "ត្រដោក" },
    { "id": 4520, "word": "ត្រដោកក្ដារ" },
    { "id": 4521, "word": "ត្រដោកជើងចែវ" },
    { "id": 4522, "word": "ត្រដោម" },
    { "id": 4523, "word": "ត្រដោះ" },
    { "id": 4524, "word": "ត្រណម" },
    { "id": 4525, "word": "ត្រណាក់ចិត្ត" },
    { "id": 4526, "word": "ត្រណោត" },
    { "id": 4527, "word": "ត្រតៗ" },
    { "id": 4528, "word": "ត្រថុក" },
    { "id": 4529, "word": "ត្រថឿង" },
    { "id": 4530, "word": "ត្រប់" },
    { "id": 4531, "word": "ត្រប់ទុំ" },
    { "id": 4532, "word": "ត្របក" },
    { "id": 4533, "word": "ត្រប៉ក់" },
    { "id": 4534, "word": "ត្របកឈូក" },
    { "id": 4535, "word": "ត្របាក់" },
    { "id": 4536, "word": "ត្របាញ់" },
    { "id": 4537, "word": "ត្រប៉ែ" },
    { "id": 4538, "word": "ត្របែក" },
    { "id": 4539, "word": "ត្របែកជូរ" },
    { "id": 4540, "word": "ត្របែកព្រៃ" },
    { "id": 4541, "word": "ត្របែង" },
    { "id": 4542, "word": "ត្របែងដៃ" },
    { "id": 4543, "word": "ត្របោម" },
    { "id": 4544, "word": "ត្របាំងបះ" },
    { "id": 4545, "word": "ត្របះ" },
    { "id": 4546, "word": "ត្រពឹន" },
    { "id": 4547, "word": "ត្រពោក" },
    { "id": 4548, "word": "ត្រពាំង" },
    { "id": 4549, "word": "ត្រពាំងពាយ" },
    { "id": 4550, "word": "ត្រមក់" },
    { "id": 4551, "word": "ត្រមង់" },
    { "id": 4552, "word": "ត្រមុល" },
    { "id": 4553, "word": "ត្រមៀច" },
    { "id": 4554, "word": "ត្រមែង" },
    { "id": 4555, "word": "ត្រមោង" },
    { "id": 4556, "word": "ត្រមោច" },
    { "id": 4557, "word": "ត្រមោល" },
    { "id": 4558, "word": "ត្រ័យ" },
    { "id": 4559, "word": "ត្រយង" },
    { "id": 4560, "word": "ត្រយង់" },
    { "id": 4561, "word": "ត្រ័យត្រិង្ស" },
    { "id": 4562, "word": "ត្រយូង" },
    { "id": 4563, "word": "ត្រយូងចេក" },
    { "id": 4564, "word": "ត្រល់" },
    { "id": 4565, "word": "ត្រលប់" },
    { "id": 4566, "word": "ត្រលាត់" },
    { "id": 4567, "word": "ត្រលិន" },
    { "id": 4568, "word": "ត្រលុច" },
    { "id": 4569, "word": "ត្រលាំង" },
    { "id": 4570, "word": "ត្រស់" },
    { "id": 4571, "word": "ត្រស្ដិ" },
    { "id": 4572, "word": "ត្រសក់" },
    { "id": 4573, "word": "ត្រសង" },
    { "id": 4574, "word": "ត្រសាប់" },
    { "id": 4575, "word": "ត្រសាយ" },
    { "id": 4576, "word": "ត្រសាល់" },
    { "id": 4577, "word": "ត្រសុក" },
    { "id": 4578, "word": "ត្រសុល" },
    { "id": 4579, "word": "ត្រសុស" },
    { "id": 4580, "word": "ត្រសូល" },
    { "id": 4581, "word": "ត្រសៀក" },
    { "id": 4582, "word": "ត្រសេះ" },
    { "id": 4583, "word": "ត្រសែត" },
    { "id": 4584, "word": "ត្រសោម" },
    { "id": 4585, "word": "ត្រសោល" },
    { "id": 4586, "word": "ត្រសុំ" },
    { "id": 4587, "word": "ត្រឡក" },
    { "id": 4588, "word": "ត្រឡាច" },
    { "id": 4589, "word": "ត្រឡាយ" },
    { "id": 4590, "word": "ត្រឡុង" },
    { "id": 4591, "word": "ត្រឡែងកែង" },
    { "id": 4592, "word": "ត្រឡោក" },
    { "id": 4593, "word": "ត្រឡុំ" },
    { "id": 4594, "word": "ត្រអក" },
    { "id": 4595, "word": "ត្រអាល" },
    { "id": 4596, "word": "ត្រអៀន" },
    { "id": 4597, "word": "ត្រអេក" },
    { "id": 4598, "word": "ត្រឱន" },
    { "id": 4599, "word": "ត្រា" },
    { "id": 4600, "word": "ត្រក់" },
    { "id": 4601, "word": "ត្រាក់ៗ" },
    { "id": 4602, "word": "ត្រាក់ទ័រ" },
    { "id": 4603, "word": "ត្រាង" },
    { "id": 4604, "word": "ត្រាច" },
    { "id": 4605, "word": "ត្រាច់" },
    { "id": 4606, "word": "ត្រាជូ" },
    { "id": 4607, "word": "ត្រាញ់" },
    { "id": 4608, "word": "ត្រាណ" },
    { "id": 4609, "word": "ត្រាណត្រើយ" },
    { "id": 4610, "word": "ត្រាតែ" },
    { "id": 4611, "word": "ត្រាប់" },
    { "id": 4612, "word": "ត្រាយ" },
    { "id": 4613, "word": "ត្រាវ" },
    { "id": 4614, "word": "ត្រាស់" },
    { "id": 4615, "word": "ត្រិបិដក" },
    { "id": 4616, "word": "ត្រិយង្ស" },
    { "id": 4617, "word": "ត្រិល" },
    { "id": 4618, "word": "ត្រី" },
    { "id": 4619, "word": "ត្រី--" },
    { "id": 4620, "word": "ត្រីមុខ" },
    { "id": 4621, "word": "ត្រីវិស័យ" },
    { "id": 4622, "word": "ត្រឹក" },
    { "id": 4623, "word": "ត្រឹកៗ" },
    { "id": 4624, "word": "ត្រឹង" },
    { "id": 4625, "word": "ត្រឹប" },
    { "id": 4626, "word": "ត្រឹម" },
    { "id": 4627, "word": "ត្រុកៗ" },
    { "id": 4628, "word": "ត្រុដ" },
    { "id": 4629, "word": "ត្រុដិ" },
    { "id": 4630, "word": "ត្រុនៗ" },
    { "id": 4631, "word": "ត្រុយ" },
    { "id": 4632, "word": "ត្រុល" },
    { "id": 4633, "word": "ត្រុលៗ" },
    { "id": 4634, "word": "ត្រូល" },
    { "id": 4635, "word": "ត្រូវ" },
    { "id": 4636, "word": "ត្រួត" },
    { "id": 4637, "word": "ត្រួតត្រា" },
    { "id": 4638, "word": "ត្រួយ" },
    { "id": 4639, "word": "ត្រួស" },
    { "id": 4640, "word": "ត្រួសៗ" },
    { "id": 4641, "word": "ត្រើង" },
    { "id": 4642, "word": "ត្រើយ" },
    { "id": 4643, "word": "ត្រើយឆក" },
    { "id": 4644, "word": "ត្រើយត្រាណ" },
    { "id": 4645, "word": "ត្រើយលយ" },
    { "id": 4646, "word": "ត្រៀក" },
    { "id": 4647, "word": "ត្រៀប" },
    { "id": 4648, "word": "ត្រៀបត្រា" },
    { "id": 4649, "word": "ត្រៀម" },
    { "id": 4650, "word": "ត្រៀល" },
    { "id": 4651, "word": "ត្រេក" },
    { "id": 4652, "word": "ត្រេង" },
    { "id": 4653, "word": "ត្រេះត្រុះ" },
    { "id": 4654, "word": "ត្រែ" },
    { "id": 4655, "word": "ត្រែង" },
    { "id": 4656, "word": "ត្រែតៗ" },
    { "id": 4657, "word": "ត្រែតត្រត" },
    { "id": 4658, "word": "ត្រែះ" },
    { "id": 4659, "word": "ត្រៃ" },
    { "id": 4660, "word": "ត្រៃ--" },
    { "id": 4661, "word": "ត្រោក" },
    { "id": 4662, "word": "ត្រោកយោល" },
    { "id": 4663, "word": "ត្រោកសាញ" },
    { "id": 4664, "word": "ត្រោស" },
    { "id": 4665, "word": "ត្រុំ" },
    { "id": 4666, "word": "ត្រាំ" },
    { "id": 4667, "word": "ត្រាំកក់" },
    { "id": 4668, "word": "ត្រាំត្រែង" },
    { "id": 4669, "word": "ត្លឹង" },
    { "id": 4670, "word": "ត្លុក" },
    { "id": 4671, "word": "ត្លុង" },
    { "id": 4672, "word": "ត្លុម" },
    { "id": 4673, "word": "ត្លេវ" },
    { "id": 4674, "word": "ត្លែ" },
    { "id": 4675, "word": "ត្លែត" },
    { "id": 4676, "word": "ត្លោត" },
    { "id": 4677, "word": "ត្លុំ" },
    { "id": 4678, "word": "ត្វា" },
    { "id": 4679, "word": "ត្វាង" },
    { "id": 4680, "word": "ត្អឹង" },
    { "id": 4681, "word": "ត្អូញ" },
    { "id": 4682, "word": "ត្អូញត្អែរ" },
    { "id": 4683, "word": "ត្អួ" },
    { "id": 4684, "word": "ត្អួរ" },
    { "id": 4685, "word": "ត្អើក" },
    { "id": 4686, "word": "តមត្ថំ" },
    { "id": 4687, "word": "តុក្កតា" },
    { "id": 4688, "word": "តំណិច" },
    { "id": 4689, "word": "តំណឹង" },
    { "id": 4690, "word": "តំណោង" },
    { "id": 4691, "word": "តំនឿ" },
    { "id": 4692, "word": "តំនឿន" },
    { "id": 4693, "word": "ត្រហេបត្រហប" },
    { "id": 4694, "word": "ថ" },
    { "id": 4695, "word": "ថង" },
    { "id": 4696, "word": "ថង់" },
    { "id": 4697, "word": "ថៈណាយ" },
    { "id": 4698, "word": "ថងមួន" },
    { "id": 4699, "word": "ថងយ៉ត" },
    { "id": 4700, "word": "ថងយន់" },
    { "id": 4701, "word": "ថងយិប" },
    { "id": 4702, "word": "ថង់រង" },
    { "id": 4703, "word": "ថត" },
    { "id": 4704, "word": "ថនៈ" },
    { "id": 4705, "word": "ថនិកសត្វ" },
    { "id": 4706, "word": "ថប់" },
    { "id": 4707, "word": "ថមថយ" },
    { "id": 4708, "word": "ថយ" },
    { "id": 4709, "word": "ថយហ្ល័ង" },
    { "id": 4710, "word": "ថលជលិក" },
    { "id": 4711, "word": "ថលបថ" },
    { "id": 4712, "word": "ថលមគ្គ" },
    { "id": 4713, "word": "ថលយាន" },
    { "id": 4714, "word": "ថលយាត្រា" },
    { "id": 4715, "word": "ថវិកា" },
    { "id": 4716, "word": "ថា" },
    { "id": 4717, "word": "ថាថាង" },
    { "id": 4718, "word": "ថាប់" },
    { "id": 4719, "word": "ថាមពល" },
    { "id": 4720, "word": "ថាមភាព" },
    { "id": 4721, "word": "ថាមមាត្រ" },
    { "id": 4722, "word": "ថាមវន្ត" },
    { "id": 4723, "word": "ថាវ" },
    { "id": 4724, "word": "ថាវរៈ" },
    { "id": 4725, "word": "ថាវរកម្ម" },
    { "id": 4726, "word": "ថាវរវត្ថុ" },
    { "id": 4727, "word": "ថាស" },
    { "id": 4728, "word": "ថិរភាព" },
    { "id": 4729, "word": "ថិរវេលា" },
    { "id": 4730, "word": "ថិរាយុ" },
    { "id": 4731, "word": "ថី" },
    { "id": 4732, "word": "ថី?" },
    { "id": 4733, "word": "ថីនមិទ្ធ" },
    { "id": 4734, "word": "ថុច!" },
    { "id": 4735, "word": "ថូ" },
    { "id": 4736, "word": "ថូន" },
    { "id": 4737, "word": "ថួ" },
    { "id": 4738, "word": "ថួន" },
    { "id": 4739, "word": "ថួន" },
    { "id": 4740, "word": "ថើប" },
    { "id": 4741, "word": "ថឿក" },
    { "id": 4742, "word": "ថេយ្យសំវាស" },
    { "id": 4743, "word": "ថេយ្យសំវាសកៈ" },
    { "id": 4744, "word": "ថេរ" },
    { "id": 4745, "word": "ថេរៈ" },
    { "id": 4746, "word": "ថេរភាព" },
    { "id": 4747, "word": "ថេរភូមិ" },
    { "id": 4748, "word": "ថេរវាទ" },
    { "id": 4749, "word": "ថេរវាទី" },
    { "id": 4750, "word": "ថេរានុត្ថេរៈ" },
    { "id": 4751, "word": "ថេរី" },
    { "id": 4752, "word": "ថែ" },
    { "id": 4753, "word": "ថែទាំ" },
    { "id": 4754, "word": "ថែប" },
    { "id": 4755, "word": "ថែម" },
    { "id": 4756, "word": "ថែវ" },
    { "id": 4757, "word": "ថៃ" },
    { "id": 4758, "word": "ថៃហ្ល័ង" },
    { "id": 4759, "word": "ថោ" },
    { "id": 4760, "word": "ថោក" },
    { "id": 4761, "word": "ថោមនាការ" },
    { "id": 4762, "word": "ថោមភាព" },
    { "id": 4763, "word": "ថោមវាទ" },
    { "id": 4764, "word": "ថោមវាទី" },
    { "id": 4765, "word": "ថោមវាទិនី" },
    { "id": 4766, "word": "ថោះ" },
    { "id": 4767, "word": "ថៅកែ" },
    { "id": 4768, "word": "ថៅឡិង" },
    { "id": 4769, "word": "ថាំ" },
    { "id": 4770, "word": "ថាំង" },
    { "id": 4771, "word": "ថ្ករ" },
    { "id": 4772, "word": "ថ្កល់" },
    { "id": 4773, "word": "ថ្កាត់" },
    { "id": 4774, "word": "ថ្កាន" },
    { "id": 4775, "word": "ថ្កាប់" },
    { "id": 4776, "word": "ថ្កាស" },
    { "id": 4777, "word": "ថ្កូវ" },
    { "id": 4778, "word": "ថ្កើង" },
    { "id": 4779, "word": "ថ្កៀប" },
    { "id": 4780, "word": "ថ្កោល" },
    { "id": 4781, "word": "ថ្កំ" },
    { "id": 4782, "word": "ថ្គាម" },
    { "id": 4783, "word": "ថ្គោល" },
    { "id": 4784, "word": "ថ្ង" },
    { "id": 4785, "word": "ថ្ងប" },
    { "id": 4786, "word": "ថ្ងាន់" },
    { "id": 4787, "word": "ថ្ងាស" },
    { "id": 4788, "word": "ថ្ងិចថ្ងរ" },
    { "id": 4789, "word": "ថ្ងុង" },
    { "id": 4790, "word": "ថ្ងុញ" },
    { "id": 4791, "word": "ថ្ងុយ" },
    { "id": 4792, "word": "ថ្ងូរ" },
    { "id": 4793, "word": "ថ្ងូវ" },
    { "id": 4794, "word": "ថ្ងួច" },
    { "id": 4795, "word": "ថ្ងៃ" },
    { "id": 4796, "word": "ថ្ដោក" },
    { "id": 4797, "word": "ថ្ដោកក្ដារ" },
    { "id": 4798, "word": "ថ្ដោកជើងចែវ" },
    { "id": 4799, "word": "ថ្នក់" },
    { "id": 4800, "word": "ថ្នង" },
    { "id": 4801, "word": "ថ្នម" },
    { "id": 4802, "word": "ថ្នរ" },
    { "id": 4803, "word": "ថ្នល់" },
    { "id": 4804, "word": "ថ្នល់ទទឹង" },
    { "id": 4805, "word": "ថ្នាក់" },
    { "id": 4806, "word": "ថ្នាក់ថ្នម" },
    { "id": 4807, "word": "ថ្នាក់ថ្នល់" },
    { "id": 4808, "word": "ថ្នាក់ថ្នាំង" },
    { "id": 4809, "word": "ថ្នាល" },
    { "id": 4810, "word": "ថ្នាស" },
    { "id": 4811, "word": "ថ្និត" },
    { "id": 4812, "word": "ថ្នឹក" },
    { "id": 4813, "word": "ថ្នឹង" },
    { "id": 4814, "word": "ថ្នូរ" },
    { "id": 4815, "word": "ថ្នេរ" },
    { "id": 4816, "word": "ថ្នោល" },
    { "id": 4817, "word": "ថ្នាំ" },
    { "id": 4818, "word": "ថ្នាំង" },
    { "id": 4819, "word": "ថ្នាំងថ្នាក់" },
    { "id": 4820, "word": "ថ្នះ" },
    { "id": 4821, "word": "ថ្ពក់" },
    { "id": 4822, "word": "ថ្ពង" },
    { "id": 4823, "word": "ថ្ពាល់" },
    { "id": 4824, "word": "ថ្ពិន" },
    { "id": 4825, "word": "ថ្ពឹន" },
    { "id": 4826, "word": "ថ្ពូត" },
    { "id": 4827, "word": "ថ្ពេច" },
    { "id": 4828, "word": "ថ្ពែក" },
    { "id": 4829, "word": "ថ្ម" },
    { "id": 4830, "word": "ថ្មាត់" },
    { "id": 4831, "word": "ថ្មារ" },
    { "id": 4832, "word": "ថ្មី" },
    { "id": 4833, "word": "ថ្មើរ" },
    { "id": 4834, "word": "ថ្មើរជើង" },
    { "id": 4835, "word": "ថ្មើរទេស" },
    { "id": 4836, "word": "ថ្មើរព្រៃ" },
    { "id": 4837, "word": "ថ្មែ" },
    { "id": 4838, "word": "ថ្មោង" },
    { "id": 4839, "word": "ថ្លង់" },
    { "id": 4840, "word": "ថ្លា" },
    { "id": 4841, "word": "ថ្លាង" },
    { "id": 4842, "word": "ថ្លាញ់" },
    { "id": 4843, "word": "ថ្លាន់" },
    { "id": 4844, "word": "ថ្លឹង" },
    { "id": 4845, "word": "ថ្លុក" },
    { "id": 4846, "word": "ថ្លើង" },
    { "id": 4847, "word": "ថ្លើម" },
    { "id": 4848, "word": "ថ្លើមអណ្ដើក" },
    { "id": 4849, "word": "ថ្លែង" },
    { "id": 4850, "word": "ថ្លែន" },
    { "id": 4851, "word": "ថ្លៃ" },
    { "id": 4852, "word": "ថ្លៃថ្នូរ" },
    { "id": 4853, "word": "ថ្លោស" },
    { "id": 4854, "word": "ថ្លោះ" },
    { "id": 4855, "word": "ថ្លោះធ្លោយ" },
    { "id": 4856, "word": "ថ្វាក" },
    { "id": 4857, "word": "ថ្វាង" },
    { "id": 4858, "word": "ថ្វាត់" },
    { "id": 4859, "word": "ថ្វាយ" },
    { "id": 4860, "word": "ថ្វាយបង្គំ" },
    { "id": 4861, "word": "ថ្វិច" },
    { "id": 4862, "word": "ថ្វី!" },
    { "id": 4863, "word": "ថ្វីគំនិត" },
    { "id": 4864, "word": "ថ្វីដៃ" },
    { "id": 4865, "word": "ថ្វីបើ" },
    { "id": 4866, "word": "ថ្វីមាត់" },
    { "id": 4867, "word": "ថ្វីហៈថ្វីហើយ?" },
    { "id": 4868, "word": "ថ្វឺយ!" },
    { "id": 4869, "word": "ថ្វែ" },
    { "id": 4870, "word": "ទ" },
    { "id": 4871, "word": "ទក" },
    { "id": 4872, "word": "ទក់" },
    { "id": 4873, "word": "ទកាស័យ" },
    { "id": 4874, "word": "ទក្ខិណទិស" },
    { "id": 4875, "word": "ទក្ខិណនិកាយ" },
    { "id": 4876, "word": "ទក្ខិណាទាន" },
    { "id": 4877, "word": "ទក្ខិណានុទិស" },
    { "id": 4878, "word": "ទក្ខិណានុប្បទាន" },
    { "id": 4879, "word": "ទក្ខិណាព័ត៌" },
    { "id": 4880, "word": "ទក្ខិណាវដ្ដ" },
    { "id": 4881, "word": "ទក្ខិណេយ្យបុគ្គល" },
    { "id": 4882, "word": "ទក្ខិណេយ្យសម្បទា" },
    { "id": 4883, "word": "ទក្ខិណោទក" },
    { "id": 4884, "word": "ទក្សិណ" },
    { "id": 4885, "word": "ទក្សិណោទក" },
    { "id": 4886, "word": "ទង" },
    { "id": 4887, "word": "ទងកន្ត្រៃ" },
    { "id": 4888, "word": "ទងគន្លង" },
    { "id": 4889, "word": "ទងត្រសក់" },
    { "id": 4890, "word": "ទងត្រា" },
    { "id": 4891, "word": "ទងត្រៅ" },
    { "id": 4892, "word": "ទងបង្ហួរ" },
    { "id": 4893, "word": "ទងវង" },
    { "id": 4894, "word": "ទង់" },
    { "id": 4895, "word": "ទង់ជ័យ" },
    { "id": 4896, "word": "ទង្គត់" },
    { "id": 4897, "word": "អង្គិច" },
    { "id": 4898, "word": "ទង្គឹះ" },
    { "id": 4899, "word": "ទង្គុក" },
    { "id": 4900, "word": "ទង្គើ" },
    { "id": 4901, "word": "ទង្គោល" },
    { "id": 4902, "word": "ទង្គុំ" },
    { "id": 4903, "word": "ទង្គះ" },
    { "id": 4904, "word": "ទង់ដែង" },
    { "id": 4905, "word": "ទង់ទាញ" },
    { "id": 4906, "word": "ទង់ហ៊្វា" },
    { "id": 4907, "word": "ទច់" },
    { "id": 4908, "word": "ទញ់" },
    { "id": 4909, "word": "ទណ្ឌ" },
    { "id": 4910, "word": "ទណ្ឌកម្ម" },
    { "id": 4911, "word": "ទណ្ឌកម្មនាសនា" },
    { "id": 4912, "word": "ទណ្ឌឃាដ" },
    { "id": 4913, "word": "ទត" },
    { "id": 4914, "word": "ទទត់" },
    { "id": 4915, "word": "ទទ័រ" },
    { "id": 4916, "word": "ទទា" },
    { "id": 4917, "word": "ទទាក់" },
    { "id": 4918, "word": "ទទាក់ទទាម" },
    { "id": 4919, "word": "ទទារ" },
    { "id": 4920, "word": "ទទាស់ទទែង" },
    { "id": 4921, "word": "ទទីទទ័រ" },
    { "id": 4922, "word": "ទទីងទទាង" },
    { "id": 4923, "word": "ទទីមទទាម" },
    { "id": 4924, "word": "ទទីមទទើម" },
    { "id": 4925, "word": "ទទីសទទាស" },
    { "id": 4926, "word": "ទទឹក" },
    { "id": 4927, "word": "ទទឹង" },
    { "id": 4928, "word": "ទទឹងគាង" },
    { "id": 4929, "word": "ទទឹងថ្ងៃ" },
    { "id": 4930, "word": "ទទឹងទទែង" },
    { "id": 4931, "word": "ទទឹងទិស" },
    { "id": 4932, "word": "ទទឹម" },
    { "id": 4933, "word": "ទទូច" },
    { "id": 4934, "word": "ទទូរ" },
    { "id": 4935, "word": "ទទួល" },
    { "id": 4936, "word": "ទទួលទាន" },
    { "id": 4937, "word": "ទទើម" },
    { "id": 4938, "word": "ទទើសទទែង" },
    { "id": 4939, "word": "ទទេ" },
    { "id": 4940, "word": "ទទែ" },
    { "id": 4941, "word": "ទទោក" },
    { "id": 4942, "word": "ទទះ" },
    { "id": 4943, "word": "ទទ្រត" },
    { "id": 4944, "word": "ទទ្រប" },
    { "id": 4945, "word": "ទទ្រម" },
    { "id": 4946, "word": "ទទ្រាក់" },
    { "id": 4947, "word": "ទទ្រីបទទ្រប" },
    { "id": 4948, "word": "ទទ្រីបទទ្រាប" },
    { "id": 4949, "word": "ទទ្រីមទទ្រម" },
    { "id": 4950, "word": "ទទ្រឹប" },
    { "id": 4951, "word": "ទទ្រើក" },
    { "id": 4952, "word": "ទទ្រើត" },
    { "id": 4953, "word": "ទទ្រេតទទ្រោត" },
    { "id": 4954, "word": "ទទ្រែមទទ្រម" },
    { "id": 4955, "word": "ទធាក់" },
    { "id": 4956, "word": "ទធិ" },
    { "id": 4957, "word": "ទន់" },
    { "id": 4958, "word": "ទន់ដី" },
    { "id": 4959, "word": "ទន់ភ្លន់" },
    { "id": 4960, "word": "ទន្ត" },
    { "id": 4961, "word": "ទន្តកម្ម" },
    { "id": 4962, "word": "ទន្តការ" },
    { "id": 4963, "word": "ទន្តជ" },
    { "id": 4964, "word": "ទន្តធាតុ" },
    { "id": 4965, "word": "ទន្តពេទ្យ" },
    { "id": 4966, "word": "ទន្តម័យ" },
    { "id": 4967, "word": "ទន្តវេជ្ជសាស្ត្រ" },
    { "id": 4968, "word": "ទន្ត្រំ" },
    { "id": 4969, "word": "ទន្ថើន" },
    { "id": 4970, "word": "ទន្ទប" },
    { "id": 4971, "word": "ទន្ទាន់" },
    { "id": 4972, "word": "ទន្ទិញ" },
    { "id": 4973, "word": "ទន្ទឹង" },
    { "id": 4974, "word": "ទន្ទឹម" },
    { "id": 4975, "word": "ទន្ទូរ" },
    { "id": 4976, "word": "ទន្ទេង" },
    { "id": 4977, "word": "ទន្ទេញ" },
    { "id": 4978, "word": "ទន្ទាំ" },
    { "id": 4979, "word": "ទន្ទ្រាន" },
    { "id": 4980, "word": "ទន្ទ្រានខេត្ត" },
    { "id": 4981, "word": "ទន្ទ្រាម" },
    { "id": 4982, "word": "ទន្លា" },
    { "id": 4983, "word": "ទន្លាក់" },
    { "id": 4984, "word": "ទន្លាប់" },
    { "id": 4985, "word": "ទន្លីង" },
    { "id": 4986, "word": "ទន្លេ" },
    { "id": 4987, "word": "ទន្លេតូច" },
    { "id": 4988, "word": "ទន្លេធំ" },
    { "id": 4989, "word": "ទន្លេបាទី" },
    { "id": 4990, "word": "ទន្លេរពៅ" },
    { "id": 4991, "word": "ទន្លេសាប" },
    { "id": 4992, "word": "ទន្សង" },
    { "id": 4993, "word": "ទន្សា" },
    { "id": 4994, "word": "ទន្សាយ" },
    { "id": 4995, "word": "ទន្សែ" },
    { "id": 4996, "word": "ទន្សោង" },
    { "id": 4997, "word": "ទប់" },
    { "id": 4998, "word": "ទប់ទល់" },
    { "id": 4999, "word": "ទៈបាន" },
    { "id": 5000, "word": "ទ័ព" },
    { "id": 5001, "word": "ទព្វៈ" },
    { "id": 5002, "word": "ទព្វសម្ភារៈ" },
    { "id": 5003, "word": "ទម" },
    { "id": 5004, "word": "ទម័ក" },
    { "id": 5005, "word": "ទមភាព" },
    { "id": 5006, "word": "ទមិឡ" },
    { "id": 5007, "word": "ទម្ងន់" },
    { "id": 5008, "word": "ទម្រ" },
    { "id": 5009, "word": "ទម្រង់" },
    { "id": 5010, "word": "ទម្រង់ការ" },
    { "id": 5011, "word": "ទម្រង់ស័ក្ដិ" },
    { "id": 5012, "word": "ទម្រន់" },
    { "id": 5013, "word": "ទម្រម" },
    { "id": 5014, "word": "ទម្រឹង" },
    { "id": 5015, "word": "ទម្រុឌ" },
    { "id": 5016, "word": "ទម្រើស" },
    { "id": 5017, "word": "ទម្រេត" },
    { "id": 5018, "word": "ទម្រេល" },
    { "id": 5019, "word": "ទម្រោប" },
    { "id": 5020, "word": "ទម្រោម" },
    { "id": 5021, "word": "ទម្រាំ" },
    { "id": 5022, "word": "ទម្លាក់" },
    { "id": 5023, "word": "ទម្លាក់--" },
    { "id": 5024, "word": "ទម្លាប់" },
    { "id": 5025, "word": "ទម្លាយ" },
    { "id": 5026, "word": "ទម្លាយរត" },
    { "id": 5027, "word": "ទម្លាយស្មង" },
    { "id": 5028, "word": "ទម្លាយអាកាស" },
    { "id": 5029, "word": "ទម្លុះ" },
    { "id": 5030, "word": "ទយ" },
    { "id": 5031, "word": "ទរ" },
    { "id": 5032, "word": "ទល់" },
    { "id": 5033, "word": "ទល់" },
    { "id": 5034, "word": "ទល់ផ្អក" },
    { "id": 5035, "word": "ទល់អង្រែ" },
    { "id": 5036, "word": "ទ័ល" },
    { "id": 5037, "word": "ទលិទ្ទ" },
    { "id": 5038, "word": "ទលិទ្ទភាព" },
    { "id": 5039, "word": "ទស" },
    { "id": 5040, "word": "ទស់" },
    { "id": 5041, "word": "ទស--" },
    { "id": 5042, "word": "ទសវត្សរ៍" },
    { "id": 5043, "word": "ទស្សន" },
    { "id": 5044, "word": "ទស្សន--" },
    { "id": 5045, "word": "ទឡ្ហ" },
    { "id": 5046, "word": "ទឡ្ហៈ" },
    { "id": 5047, "word": "ទឡ្ហការី" },
    { "id": 5048, "word": "ទឡ្ហប្រហារ" },
    { "id": 5049, "word": "ទឡ្ហមិត្ត" },
    { "id": 5050, "word": "ទឡ្ហីកម្ម" },
    { "id": 5051, "word": "ទឡ្ហីករណៈ" },
    { "id": 5052, "word": "ទា" },
    { "id": 5053, "word": "ទាក" },
    { "id": 5054, "word": "ទាក់" },
    { "id": 5055, "word": "ទាក់ទង" },
    { "id": 5056, "word": "ទាក់ទាម" },
    { "id": 5057, "word": "ទាក់ទិន" },
    { "id": 5058, "word": "ទាង" },
    { "id": 5059, "word": "ទាច" },
    { "id": 5060, "word": "ទាញ" },
    { "id": 5061, "word": "ទាញទង់" },
    { "id": 5062, "word": "ទាញព្រ័ត្រ" },
    { "id": 5063, "word": "ទាឋធាតុ" },
    { "id": 5064, "word": "ទាឋា" },
    { "id": 5065, "word": "ទាឋាធាតុ" },
    { "id": 5066, "word": "ទាត់" },
    { "id": 5067, "word": "ទាន" },
    { "id": 5068, "word": "ទាន--" },
    { "id": 5069, "word": "ទាន់" },
    { "id": 5070, "word": "ទាន់ហន់" },
    { "id": 5071, "word": "ទាប" },
    { "id": 5072, "word": "ទាម" },
    { "id": 5073, "word": "ទាមទារ" },
    { "id": 5074, "word": "ទាយ" },
    { "id": 5075, "word": "ទាយក" },
    { "id": 5076, "word": "ទាយក សមាជិក" },
    { "id": 5077, "word": "ទាយពន្ធុ" },
    { "id": 5078, "word": "ទាយភាគ" },
    { "id": 5079, "word": "ទាយវិភាគ" },
    { "id": 5080, "word": "ទាយាទ" },
    { "id": 5081, "word": "ទាយិកា" },
    { "id": 5082, "word": "ទាយី" },
    { "id": 5083, "word": "ទារ" },
    { "id": 5084, "word": "ទារក" },
    { "id": 5085, "word": "ទារសង្រ្គោះ" },
    { "id": 5086, "word": "ទារា" },
    { "id": 5087, "word": "ទារាធីន" },
    { "id": 5088, "word": "ទារានុគ្រោះ" },
    { "id": 5089, "word": "ទារិកា" },
    { "id": 5090, "word": "ទារុកម្ម" },
    { "id": 5091, "word": "ទារុណ" },
    { "id": 5092, "word": "ទារុណកម្ម" },
    { "id": 5093, "word": "ទារុណភាព" },
    { "id": 5094, "word": "ទារុម័យ" },
    { "id": 5095, "word": "ទាល" },
    { "id": 5096, "word": "ទាល់" },
    { "id": 5097, "word": "ទាល់តែ" },
    { "id": 5098, "word": "ទាស" },
    { "id": 5099, "word": "ទាស់" },
    { "id": 5100, "word": "ទាសី" },
    { "id": 5101, "word": "ទាហាន" },
    { "id": 5102, "word": "ទិគម្ពរ" },
    { "id": 5103, "word": "ទិងទាំង" },
    { "id": 5104, "word": "ទិច" },
    { "id": 5105, "word": "ទិញ" },
    { "id": 5106, "word": "ទិដ្ឋធម្ម" },
    { "id": 5107, "word": "ទិដ្ឋធម្មិក" },
    { "id": 5108, "word": "ទិដ្ឋធម្មិកប្រយោជន៍" },
    { "id": 5109, "word": "ទិដ្ឋធម៌" },
    { "id": 5110, "word": "ទិដ្ឋភាព" },
    { "id": 5111, "word": "ទិដ្ឋមត្ត" },
    { "id": 5112, "word": "ទិដ្ឋាការ" },
    { "id": 5113, "word": "ទិដ្ឋានុគតិ" },
    { "id": 5114, "word": "ទិដ្ឋិ" },
    { "id": 5115, "word": "ទិដ្ឋិវិបត្តិ" },
    { "id": 5116, "word": "ទិដ្ឋិសម្បត្តិ" },
    { "id": 5117, "word": "ទិដ្ឋុជុកម្ម" },
    { "id": 5118, "word": "ទិតៀន" },
    { "id": 5119, "word": "ទិន" },
    { "id": 5120, "word": "ទិនករ" },
    { "id": 5121, "word": "ទិនក្ស័យ" },
    { "id": 5122, "word": "ទិនបតី" },
    { "id": 5123, "word": "ទិនប្រភា" },
    { "id": 5124, "word": "ទិនមណី" },
    { "id": 5125, "word": "ទិនមុខ" },
    { "id": 5126, "word": "ទិនរត្ន" },
    { "id": 5127, "word": "ទិនានុប្បវត្តិ" },
    { "id": 5128, "word": "ទិនានុប្រព្រឹត្តិ" },
    { "id": 5129, "word": "ទិនានុលេខន៍" },
    { "id": 5130, "word": "ទិនាវសាន" },
    { "id": 5131, "word": "ទិន្នន័យ" },
    { "id": 5132, "word": "ទិន្នភណ្ឌ" },
    { "id": 5133, "word": "ទិន្នវត្ថុ" },
    { "id": 5134, "word": "ទិន្នាទាយី" },
    { "id": 5135, "word": "ទិន្នាទាយិនី" },
    { "id": 5136, "word": "ទិនិកជន" },
    { "id": 5137, "word": "ទិនិកា" },
    { "id": 5138, "word": "ទិព្វ" },
    { "id": 5139, "word": "ទិព្វ--" },
    { "id": 5140, "word": "ទិព្យ" },
    { "id": 5141, "word": "ទិល" },
    { "id": 5142, "word": "ទិវង្គត" },
    { "id": 5143, "word": "ទិវ័ន" },
    { "id": 5144, "word": "ទិវសភាគ" },
    { "id": 5145, "word": "ទិវា" },
    { "id": 5146, "word": "ទិវាករ" },
    { "id": 5147, "word": "ទិវាចរ" },
    { "id": 5148, "word": "ទិវោក័ស" },
    { "id": 5149, "word": "ទិស" },
    { "id": 5150, "word": "ទិសា" },
    { "id": 5151, "word": "ទិសានុទិស" },
    { "id": 5152, "word": "ទិសាបាមោក្ខ" },
    { "id": 5153, "word": "ទិសាភាគ" },
    { "id": 5154, "word": "ទី" },
    { "id": 5155, "word": "ទីកោ" },
    { "id": 5156, "word": "ទីក្សា" },
    { "id": 5157, "word": "ទីឃ" },
    { "id": 5158, "word": "ទីឃ--" },
    { "id": 5159, "word": "ទីង" },
    { "id": 5160, "word": "ទីងទាង" },
    { "id": 5161, "word": "ទីងទាំង" },
    { "id": 5162, "word": "ទីងមោង" },
    { "id": 5163, "word": "ទីទុយ" },
    { "id": 5164, "word": "ទីទុយពើតពើង" },
    { "id": 5165, "word": "ទីទើរ" },
    { "id": 5166, "word": "ទីទៃ" },
    { "id": 5167, "word": "ទីន័ង" },
    { "id": 5168, "word": "ទីពោ" },
    { "id": 5169, "word": "ទីមទាម" },
    { "id": 5170, "word": "ទីវ" },
    { "id": 5171, "word": "ទឹក" },
    { "id": 5172, "word": "ទឹក--" },
    { "id": 5173, "word": "ទឹកធ្លាក់" },
    { "id": 5174, "word": "ទឹកបាក់" },
    { "id": 5175, "word": "ទឹង" },
    { "id": 5176, "word": "ទឹងទាំង" },
    { "id": 5177, "word": "ទឹងមឹង" },
    { "id": 5178, "word": "ទឹប" },
    { "id": 5179, "word": "ទឹម" },
    { "id": 5180, "word": "ទឹល" },
    { "id": 5181, "word": "ទឹល" },
    { "id": 5182, "word": "ទឺង" },
    { "id": 5183, "word": "ទឺទែ" },
    { "id": 5184, "word": "ទឺះ" },
    { "id": 5185, "word": "ទុក" },
    { "id": 5186, "word": "ទុកចិត្ត" },
    { "id": 5187, "word": "ទុកជា" },
    { "id": 5188, "word": "ទុកដាក់" },
    { "id": 5189, "word": "ទុកទ្រូ" },
    { "id": 5190, "word": "ទុកបាត្រ" },
    { "id": 5191, "word": "ទុកូលពស្ត្រ" },
    { "id": 5192, "word": "ទុកូលភស្ត្រ" },
    { "id": 5193, "word": "ទុក្កដ" },
    { "id": 5194, "word": "ទុក្ករៈ" },
    { "id": 5195, "word": "ទុក្ខ" },
    { "id": 5196, "word": "ទុក្ខ" },
    { "id": 5197, "word": "ទុក្ខំ" },
    { "id": 5198, "word": "ទុគ្គត" },
    { "id": 5199, "word": "ទុគ្គត--" },
    { "id": 5200, "word": "ទុគ្គតិ" },
    { "id": 5201, "word": "ទុគ្គតិ" },
    { "id": 5202, "word": "ទុង" },
    { "id": 5203, "word": "ទុងៗ" },
    { "id": 5204, "word": "ទុច្ចរិត" },
    { "id": 5205, "word": "ទុច្ឆន្ទៈ" },
    { "id": 5206, "word": "ទុតិយ" },
    { "id": 5207, "word": "ទុតិយសង្គាយនា" },
    { "id": 5208, "word": "ទុតិយា" },
    { "id": 5209, "word": "ទុតិយា" },
    { "id": 5210, "word": "ទុតិយាសាឍ" },
    { "id": 5211, "word": "ទុទ្ទិដ្ឋិនិយម" },
    { "id": 5212, "word": "ទុន" },
    { "id": 5213, "word": "ទុព្វចបុគ្គល" },
    { "id": 5214, "word": "ទុព្វល" },
    { "id": 5215, "word": "ទុព្វលភាព" },
    { "id": 5216, "word": "ទុព្វិជ្ជា" },
    { "id": 5217, "word": "ទុព្ភាសិត" },
    { "id": 5218, "word": "ទុព្ភិក្ខ" },
    { "id": 5219, "word": "ទុព្ភិក្ខកាល" },
    { "id": 5220, "word": "ទុព្ភិក្ខភ័យ" },
    { "id": 5221, "word": "ទុព្ភិក្ខសម័យ" },
    { "id": 5222, "word": "ទុយមុយ" },
    { "id": 5223, "word": "ទុរគត" },
    { "id": 5224, "word": "ទុរគម" },
    { "id": 5225, "word": "ទុរជន" },
    { "id": 5226, "word": "ទុរន់" },
    { "id": 5227, "word": "ទុរពល" },
    { "id": 5228, "word": "ទុរភិក្ស" },
    { "id": 5229, "word": "ទុរយស" },
    { "id": 5230, "word": "ទុរា" },
    { "id": 5231, "word": "ទុរាគមន៍" },
    { "id": 5232, "word": "ទុរាចារ" },
    { "id": 5233, "word": "ទុរេន" },
    { "id": 5234, "word": "ទុគ៌ត" },
    { "id": 5235, "word": "ទុគ៌ម" },
    { "id": 5236, "word": "ទុជ៌ន" },
    { "id": 5237, "word": "ទុព៌ល" },
    { "id": 5238, "word": "ទុរ្ភិក្ស" },
    { "id": 5239, "word": "ទុយ៌ស" },
    { "id": 5240, "word": "ទុល" },
    { "id": 5241, "word": "ទុលហ៊ែបៗ" },
    { "id": 5242, "word": "ទុល្លភៈ" },
    { "id": 5243, "word": "ទុល្លភ--" },
    { "id": 5244, "word": "ទុស្សកុដិ" },
    { "id": 5245, "word": "ទូ" },
    { "id": 5246, "word": "ទូ" },
    { "id": 5247, "word": "ទូក" },
    { "id": 5248, "word": "ទូង" },
    { "id": 5249, "word": "ទូច" },
    { "id": 5250, "word": "ទូញ" },
    { "id": 5251, "word": "ទូញទាញ" },
    { "id": 5252, "word": "ទូញបូញ" },
    { "id": 5253, "word": "ទូត" },
    { "id": 5254, "word": "ទូតក្រិយា" },
    { "id": 5255, "word": "ទូតានុទូត" },
    { "id": 5256, "word": "ទូទ័រ" },
    { "id": 5257, "word": "ទូទាត់" },
    { "id": 5258, "word": "ទូទឹម" },
    { "id": 5259, "word": "ទូទុក្ខ" },
    { "id": 5260, "word": "ទូទៅ" },
    { "id": 5261, "word": "ទូរ" },
    { "id": 5262, "word": "ទូរន់" },
    { "id": 5263, "word": "ទូរគមនាគមន៍" },
    { "id": 5264, "word": "ទូរដ្ឋាន" },
    { "id": 5265, "word": "ទូរទស្សន៍" },
    { "id": 5266, "word": "ទូរលេខ" },
    { "id": 5267, "word": "ទូរស័ព្ទ" },
    { "id": 5268, "word": "ទូល" },
    { "id": 5269, "word": "ទូលព្រះបង្គំ" },
    { "id": 5270, "word": "ទូលាយ" },
    { "id": 5271, "word": "ទូលំ" },
    { "id": 5272, "word": "ទួង" },
    { "id": 5273, "word": "ទួញ" },
    { "id": 5274, "word": "ទួត" },
    { "id": 5275, "word": "ទួទ័រ" },
    { "id": 5276, "word": "ទួទៅ" },
    { "id": 5277, "word": "ទួន" },
    { "id": 5278, "word": "ទួម" },
    { "id": 5279, "word": "ទួល" },
    { "id": 5280, "word": "ទើកមមើក" },
    { "id": 5281, "word": "ទើង" },
    { "id": 5282, "word": "ទើងមើង" },
    { "id": 5283, "word": "ទើត" },
    { "id": 5284, "word": "ទើតទើង" },
    { "id": 5285, "word": "ទើប" },
    { "id": 5286, "word": "ទើមៗ" },
    { "id": 5287, "word": "ទើរ" },
    { "id": 5288, "word": "ទៀង" },
    { "id": 5289, "word": "ទៀង--" },
    { "id": 5290, "word": "ទៀត" },
    { "id": 5291, "word": "ទៀន" },
    { "id": 5292, "word": "ទៀនកល្ប" },
    { "id": 5293, "word": "ទៀនគោល" },
    { "id": 5294, "word": "ទៀនជ័យ" },
    { "id": 5295, "word": "ទៀនវស្សា" },
    { "id": 5296, "word": "ទៀប" },
    { "id": 5297, "word": "ទៀបកោះ" },
    { "id": 5298, "word": "ទៀវ" },
    { "id": 5299, "word": "ទេ" },
    { "id": 5300, "word": "ទេញ" },
    { "id": 5301, "word": "ទេតើ" },
    { "id": 5302, "word": "ទេត្យ" },
    { "id": 5303, "word": "ទេទើរ" },
    { "id": 5304, "word": "ទេព" },
    { "id": 5305, "word": "ទេព--" },
    { "id": 5306, "word": "ទេព្ដា" },
    { "id": 5307, "word": "ទេពី" },
    { "id": 5308, "word": "ទេព្រក្ស" },
    { "id": 5309, "word": "ទេយ្យទាន" },
    { "id": 5310, "word": "ទេយ្យធម៌" },
    { "id": 5311, "word": "ទេយ្យវត្ថុ" },
    { "id": 5312, "word": "ទេរ" },
    { "id": 5313, "word": "ទេវ" },
    { "id": 5314, "word": "ទេវ--" },
    { "id": 5315, "word": "ទេវទត្ត" },
    { "id": 5316, "word": "ទេវិន្ទ" },
    { "id": 5317, "word": "ទេវី" },
    { "id": 5318, "word": "ទេស" },
    { "id": 5319, "word": "ទេសកាល" },
    { "id": 5320, "word": "ទេសចរ" },
    { "id": 5321, "word": "ទេសចរណ៍" },
    { "id": 5322, "word": "ទេសធម៌" },
    { "id": 5323, "word": "ទេសន៍" },
    { "id": 5324, "word": "ទេសនា" },
    { "id": 5325, "word": "ទេសភាព" },
    { "id": 5326, "word": "ទេសាភិបាល" },
    { "id": 5327, "word": "ទេស្នា" },
    { "id": 5328, "word": "ទេហៈ?" },
    { "id": 5329, "word": "ទេហក្ស័យ" },
    { "id": 5330, "word": "ទែង" },
    { "id": 5331, "word": "ទែន" },
    { "id": 5332, "word": "ទែនទយ" },
    { "id": 5333, "word": "ទែព" },
    { "id": 5334, "word": "ទែលម៉ូវ" },
    { "id": 5335, "word": "ទែលមែល" },
    { "id": 5336, "word": "ទែះ" },
    { "id": 5337, "word": "ទៃ" },
    { "id": 5338, "word": "ទៃគ្រូ" },
    { "id": 5339, "word": "ទោ" },
    { "id": 5340, "word": "ទោង" },
    { "id": 5341, "word": "ទោច" },
    { "id": 5342, "word": "ទោចក្រយាន" },
    { "id": 5343, "word": "ទោណ" },
    { "id": 5344, "word": "ទោម" },
    { "id": 5345, "word": "ទោមនស្ស" },
    { "id": 5346, "word": "ទោរ" },
    { "id": 5347, "word": "ទោល" },
    { "id": 5348, "word": "ទោស" },
    { "id": 5349, "word": "ទោស័ក" },
    { "id": 5350, "word": "ទោសការណ៍" },
    { "id": 5351, "word": "ទោសចរិត" },
    { "id": 5352, "word": "ទោសចិត្ត" },
    { "id": 5353, "word": "ទោសញ្ញូ" },
    { "id": 5354, "word": "ទោសពៃរ៍" },
    { "id": 5355, "word": "ទោសមូល" },
    { "id": 5356, "word": "ទោសាគតិ" },
    { "id": 5357, "word": "ទោសានុទោស" },
    { "id": 5358, "word": "ទោសោ" },
    { "id": 5359, "word": "ទោះ" },
    { "id": 5360, "word": "ទោះជា" },
    { "id": 5361, "word": "ទោះបី" },
    { "id": 5362, "word": "ទោះបីជា" },
    { "id": 5363, "word": "ទោះបីបើ" },
    { "id": 5364, "word": "ទៅ" },
    { "id": 5365, "word": "ទៅ៏!" },
    { "id": 5366, "word": "ទុំ" },
    { "id": 5367, "word": "ទុំទេស" },
    { "id": 5368, "word": "ទុំហូ" },
    { "id": 5369, "word": "ទំ" },
    { "id": 5370, "word": "ទំនង" },
    { "id": 5371, "word": "ទំនងជា" },
    { "id": 5372, "word": "ទំនញ់" },
    { "id": 5373, "word": "ទំនតព្រះនេត្រ" },
    { "id": 5374, "word": "ទំនប់" },
    { "id": 5375, "word": "ទំនាក់" },
    { "id": 5376, "word": "ទំនាញ" },
    { "id": 5377, "word": "ទំនាន់" },
    { "id": 5378, "word": "ទំនាប" },
    { "id": 5379, "word": "ទំនាយ" },
    { "id": 5380, "word": "ទំនាល់" },
    { "id": 5381, "word": "ទំនាស់" },
    { "id": 5382, "word": "ទំនិញ" },
    { "id": 5383, "word": "ទំនឹម" },
    { "id": 5384, "word": "ទំនឹមទំនៀម" },
    { "id": 5385, "word": "ទំនុក" },
    { "id": 5386, "word": "ទំនុកបម្រុង" },
    { "id": 5387, "word": "ទំនូល" },
    { "id": 5388, "word": "ទំនួញ" },
    { "id": 5389, "word": "ទំនួល" },
    { "id": 5390, "word": "ទំនើង" },
    { "id": 5391, "word": "ទំនើប" },
    { "id": 5392, "word": "ទំនៀប" },
    { "id": 5393, "word": "ទំនើរ" },
    { "id": 5394, "word": "ទំនៀម" },
    { "id": 5395, "word": "ទំនេរ" },
    { "id": 5396, "word": "ទំព័រ" },
    { "id": 5397, "word": "ទំពា" },
    { "id": 5398, "word": "ទំពុន" },
    { "id": 5399, "word": "ទំពូង" },
    { "id": 5400, "word": "ទំពួន" },
    { "id": 5401, "word": "ទំពែក" },
    { "id": 5402, "word": "ទំពោះ" },
    { "id": 5403, "word": "ទំពាំង" },
    { "id": 5404, "word": "ទំពាំងជូរ" },
    { "id": 5405, "word": "ទំយើ" },
    { "id": 5406, "word": "ទំហាត់" },
    { "id": 5407, "word": "ទំហឹង" },
    { "id": 5408, "word": "ទំហួន" },
    { "id": 5409, "word": "ទំហេង" },
    { "id": 5410, "word": "ទំហែង" },
    { "id": 5411, "word": "ទំហំ" },
    { "id": 5412, "word": "ទាំ" },
    { "id": 5413, "word": "ទាំៗ" },
    { "id": 5414, "word": "ទាំង" },
    { "id": 5415, "word": "ទាំងៗ" },
    { "id": 5416, "word": "ទាំងពួង" },
    { "id": 5417, "word": "ទាំងមូល" },
    { "id": 5418, "word": "ទាំងស្រុង" },
    { "id": 5419, "word": "ទាំងហ្លាយ" },
    { "id": 5420, "word": "ទាំងឡាយ" },
    { "id": 5421, "word": "ទាំមីង" },
    { "id": 5422, "word": "ទះ" },
    { "id": 5423, "word": "ទះកាច់" },
    { "id": 5424, "word": "ទ្រ" },
    { "id": 5425, "word": "ទ្រគោះ" },
    { "id": 5426, "word": "ទ្រង់" },
    { "id": 5427, "word": "ទ្រង់ទ្រាយ" },
    { "id": 5428, "word": "ទ្រងាង" },
    { "id": 5429, "word": "ទ្រងើង" },
    { "id": 5430, "word": "ទ្រងើល" },
    { "id": 5431, "word": "ទ្រតៗ" },
    { "id": 5432, "word": "ទ្រទូង" },
    { "id": 5433, "word": "ទ្រទួយ" },
    { "id": 5434, "word": "ទ្រទេស" },
    { "id": 5435, "word": "ទ្រទេសទ្រទន់" },
    { "id": 5436, "word": "ទ្រទេសទ្រទួយ" },
    { "id": 5437, "word": "ទ្រទ្រង់" },
    { "id": 5438, "word": "ទ្រនង់" },
    { "id": 5439, "word": "ទ្រនល់" },
    { "id": 5440, "word": "ទ្រនាប់" },
    { "id": 5441, "word": "ទ្រនាប់ជើង" },
    { "id": 5442, "word": "ទ្រនិច" },
    { "id": 5443, "word": "ទ្រនឹប" },
    { "id": 5444, "word": "ទ្រនុង" },
    { "id": 5445, "word": "ទ្រនុល" },
    { "id": 5446, "word": "ទ្រនូល" },
    { "id": 5447, "word": "ទ្រនើរ" },
    { "id": 5448, "word": "ទ្រនេល" },
    { "id": 5449, "word": "ទ្រនេស" },
    { "id": 5450, "word": "ទ្រនំ" },
    { "id": 5451, "word": "ទ្រនំលលក" },
    { "id": 5452, "word": "ទ្របៗ" },
    { "id": 5453, "word": "ទ្រពង" },
    { "id": 5454, "word": "ទ្រព្យ" },
    { "id": 5455, "word": "ទ្រព្យា" },
    { "id": 5456, "word": "ទ្រម" },
    { "id": 5457, "word": "ទ្រមក់" },
    { "id": 5458, "word": "ទ្រមម" },
    { "id": 5459, "word": "ទ្រមល់" },
    { "id": 5460, "word": "ទ្រមាក" },
    { "id": 5461, "word": "ទ្រមាក់" },
    { "id": 5462, "word": "ទ្រមាក់ខ្លា" },
    { "id": 5463, "word": "ទ្រមីង" },
    { "id": 5464, "word": "ទ្រមឹង" },
    { "id": 5465, "word": "ទ្រមូង" },
    { "id": 5466, "word": "ទ្រមូងសេក" },
    { "id": 5467, "word": "ទ្រមួច" },
    { "id": 5468, "word": "ទ្រមើ" },
    { "id": 5469, "word": "ទ្រមើង" },
    { "id": 5470, "word": "ទ្រមើម" },
    { "id": 5471, "word": "ទ្រមើយ" },
    { "id": 5472, "word": "ទ្រមេញ" },
    { "id": 5473, "word": "ទ្រមេម" },
    { "id": 5474, "word": "ទ្រមែ" },
    { "id": 5475, "word": "ទ្រមែង" },
    { "id": 5476, "word": "ទ្រមាំង" },
    { "id": 5477, "word": "ទ្រយន" },
    { "id": 5478, "word": "ទ្រយាន" },
    { "id": 5479, "word": "ទ្រយឹង" },
    { "id": 5480, "word": "ទ្រយុក" },
    { "id": 5481, "word": "ទ្រលន់" },
    { "id": 5482, "word": "ទ្រលឹងទឹង" },
    { "id": 5483, "word": "ទ្រលុក" },
    { "id": 5484, "word": "ទ្រលូ" },
    { "id": 5485, "word": "ទ្រលោម" },
    { "id": 5486, "word": "ទ្រវៀច" },
    { "id": 5487, "word": "ទ្រវែង" },
    { "id": 5488, "word": "ទ្រវះ" },
    { "id": 5489, "word": "ទ្រហឹង" },
    { "id": 5490, "word": "ទ្រហោ" },
    { "id": 5491, "word": "ទ្រាន់" },
    { "id": 5492, "word": "ទ្រាប" },
    { "id": 5493, "word": "ទ្រាប់" },
    { "id": 5494, "word": "ទ្រាយ" },
    { "id": 5495, "word": "ទ្រាល" },
    { "id": 5496, "word": "ទ្រាស" },
    { "id": 5497, "word": "ទ្រឹង" },
    { "id": 5498, "word": "ទ្រឹស្ដិ" },
    { "id": 5499, "word": "ទ្រឹស្ដិស្មូរ" },
    { "id": 5500, "word": "ទ្រឹស្ដី" },
    { "id": 5501, "word": "ទ្រុង" },
    { "id": 5502, "word": "ទ្រុឌ" },
    { "id": 5503, "word": "ទ្រុប" },
    { "id": 5504, "word": "ទ្រុបៗ" },
    { "id": 5505, "word": "ទ្រុម" },
    { "id": 5506, "word": "ទ្រុយ" },
    { "id": 5507, "word": "ទ្រុល" },
    { "id": 5508, "word": "ទ្រុស្ដ" },
    { "id": 5509, "word": "ទ្រុស្ដសីល" },
    { "id": 5510, "word": "ទ្រុះ" },
    { "id": 5511, "word": "ទ្រូ" },
    { "id": 5512, "word": "ទ្រូលាវ" },
    { "id": 5513, "word": "ទ្រូង" },
    { "id": 5514, "word": "ទ្រួក" },
    { "id": 5515, "word": "ទ្រួស" },
    { "id": 5516, "word": "ទ្រួសៗ" },
    { "id": 5517, "word": "ទ្រើង" },
    { "id": 5518, "word": "ទ្រើតៗ" },
    { "id": 5519, "word": "ទ្រើស" },
    { "id": 5520, "word": "ទ្រើសឃ្នង" },
    { "id": 5521, "word": "ទ្រើសទ្រង់" },
    { "id": 5522, "word": "ទ្រៀក" },
    { "id": 5523, "word": "ទ្រៀល" },
    { "id": 5524, "word": "ទ្រៀស" },
    { "id": 5525, "word": "ទ្រេត" },
    { "id": 5526, "word": "ទ្រេតទ្រោត" },
    { "id": 5527, "word": "ទ្រេល" },
    { "id": 5528, "word": "ទ្រែម" },
    { "id": 5529, "word": "ទ្រែលទ្រល" },
    { "id": 5530, "word": "ទ្រោប" },
    { "id": 5531, "word": "ទ្រោម" },
    { "id": 5532, "word": "ទ្រោម!" },
    { "id": 5533, "word": "ទ្រោល" },
    { "id": 5534, "word": "ទ្រាំ" },
    { "id": 5535, "word": "ទ្រាំង" },
    { "id": 5536, "word": "ទ្រាំទ្រ" },
    { "id": 5537, "word": "ទ្រាំទ្រឹស្ដិ" },
    { "id": 5538, "word": "ទ្វន្ទ" },
    { "id": 5539, "word": "ទ្វន្ទយុធ" },
    { "id": 5540, "word": "ទ្វយវាទ" },
    { "id": 5541, "word": "ទ្វាទស" },
    { "id": 5542, "word": "ទ្វាទសមាស" },
    { "id": 5543, "word": "ទ្វាទសវត្សរ៍" },
    { "id": 5544, "word": "ទ្វារ" },
    { "id": 5545, "word": "ទ្វារនាយក" },
    { "id": 5546, "word": "ទ្វារបតី" },
    { "id": 5547, "word": "ទ្វារបាល" },
    { "id": 5548, "word": "ទ្វិជក" },
    { "id": 5549, "word": "ទ្វិទន្ត" },
    { "id": 5550, "word": "ទ្វិបថ" },
    { "id": 5551, "word": "ទ្វិបទ" },
    { "id": 5552, "word": "ទ្វិបាទ" },
    { "id": 5553, "word": "ទ្វិរាប" },
    { "id": 5554, "word": "ទ្វិសប្តាហៈ" },
    { "id": 5555, "word": "ទ្វី" },
    { "id": 5556, "word": "ទ្វីគុណ" },
    { "id": 5557, "word": "ទ្វីប" },
    { "id": 5558, "word": "ទ្វេ" },
    { "id": 5559, "word": "ទ្វេគុណ" },
    { "id": 5560, "word": "ទ្វេគ្រាះ" },
    { "id": 5561, "word": "ទ្វេបាទ" },
    { "id": 5562, "word": "ទ្វេព្យាង្គ" },
    { "id": 5563, "word": "ទ្វេភាគ" },
    { "id": 5564, "word": "ទ្វេភាគី" },
    { "id": 5565, "word": "ទ្វេភាព" },
    { "id": 5566, "word": "ទ្វេស្សជន" },
    { "id": 5567, "word": "ទ្វេហារ" },
    { "id": 5568, "word": "ទទុង" },
    { "id": 5569, "word": "ទួរណឺវិស" },
    { "id": 5570, "word": "ទើស" },
    { "id": 5571, "word": "ទំនន់" },
    { "id": 5572, "word": "ទំនើស" },
    { "id": 5573, "word": "ធ" },
    { "id": 5574, "word": "ធ័ក" },
    { "id": 5575, "word": "ធញ្ញជាតិ" },
    { "id": 5576, "word": "ធញ្ញមាស" },
    { "id": 5577, "word": "ធតរដ្ឋ" },
    { "id": 5578, "word": "ធន" },
    { "id": 5579, "word": "ធន់" },
    { "id": 5580, "word": "ធនក្កីតា" },
    { "id": 5581, "word": "ធនក្រីត" },
    { "id": 5582, "word": "ធនក្ស័យ" },
    { "id": 5583, "word": "ធនទណ្ឌ" },
    { "id": 5584, "word": "ធនធាន" },
    { "id": 5585, "word": "ធនប័ណ្ណ" },
    { "id": 5586, "word": "ធនបត្រ" },
    { "id": 5587, "word": "ធនមូល" },
    { "id": 5588, "word": "ធនលាភ" },
    { "id": 5589, "word": "ធនលោភ" },
    { "id": 5590, "word": "ធនសារ" },
    { "id": 5591, "word": "ធនាករ" },
    { "id": 5592, "word": "ធនាគារ" },
    { "id": 5593, "word": "ធនាគារិក" },
    { "id": 5594, "word": "ធនាធិការី" },
    { "id": 5595, "word": "ធនិត" },
    { "id": 5596, "word": "ធនិន" },
    { "id": 5597, "word": "ធនុ" },
    { "id": 5598, "word": "ធនុហត្ថ" },
    { "id": 5599, "word": "ធមនី" },
    { "id": 5600, "word": "ធម្ម" },
    { "id": 5601, "word": "ធម្ម--" },
    { "id": 5602, "word": "ធម្មកថិក" },
    { "id": 5603, "word": "ធម្មធរ" },
    { "id": 5604, "word": "ធរណិន្ទ" },
    { "id": 5605, "word": "ធរណី" },
    { "id": 5606, "word": "ធរណីដងគោម" },
    { "id": 5607, "word": "ធរណីដងទង់" },
    { "id": 5608, "word": "ធរណីទ្វារ" },
    { "id": 5609, "word": "ធរណីសង្ឃ" },
    { "id": 5610, "word": "ធរមាន" },
    { "id": 5611, "word": "ធរមានប្បញ្ញត្តិ" },
    { "id": 5612, "word": "ធម៌" },
    { "id": 5613, "word": "ធាក់" },
    { "id": 5614, "word": "ធាង" },
    { "id": 5615, "word": "ធាត់" },
    { "id": 5616, "word": "ធាតុ" },
    { "id": 5617, "word": "ធាតុ--" },
    { "id": 5618, "word": "ធាត្រី" },
    { "id": 5619, "word": "ធាន" },
    { "id": 5620, "word": "ធានា" },
    { "id": 5621, "word": "ធានី" },
    { "id": 5622, "word": "ធារ" },
    { "id": 5623, "word": "ធី" },
    { "id": 5624, "word": "ធីតា" },
    { "id": 5625, "word": "ធីប" },
    { "id": 5626, "word": "ធឹង" },
    { "id": 5627, "word": "ធឺ" },
    { "id": 5628, "word": "ធុង" },
    { "id": 5629, "word": "ធុង" },
    { "id": 5630, "word": "ធុញ" },
    { "id": 5631, "word": "ធុតង្គ" },
    { "id": 5632, "word": "ធុន" },
    { "id": 5633, "word": "ធុរៈ" },
    { "id": 5634, "word": "ធុរនិក្ខេប" },
    { "id": 5635, "word": "ធូតង្គ" },
    { "id": 5636, "word": "ធូប" },
    { "id": 5637, "word": "ធូមកាលិក" },
    { "id": 5638, "word": "ធូមកេតុ" },
    { "id": 5639, "word": "ធូរ" },
    { "id": 5640, "word": "ធូលី" },
    { "id": 5641, "word": "ធួ" },
    { "id": 5642, "word": "ធួន" },
    { "id": 5643, "word": "ធៀប" },
    { "id": 5644, "word": "ធេង" },
    { "id": 5645, "word": "ធេងធោង" },
    { "id": 5646, "word": "ធោវកៈ" },
    { "id": 5647, "word": "ធោវនដ្ឋាន" },
    { "id": 5648, "word": "ធុំ" },
    { "id": 5649, "word": "ធំ" },
    { "id": 5650, "word": "ធ្ងន់" },
    { "id": 5651, "word": "ធ្ងន់ធ្ងរ" },
    { "id": 5652, "word": "ធ្ងាង" },
    { "id": 5653, "word": "ធ្ងើង" },
    { "id": 5654, "word": "ធ្ងើល" },
    { "id": 5655, "word": "ធ្ងោង" },
    { "id": 5656, "word": "ធ្ងោល" },
    { "id": 5657, "word": "ធ្ងាំង" },
    { "id": 5658, "word": "ធ្នង់" },
    { "id": 5659, "word": "ធ្នល់" },
    { "id": 5660, "word": "ធ្នស់" },
    { "id": 5661, "word": "ធ្នាក់" },
    { "id": 5662, "word": "ធ្នាប់" },
    { "id": 5663, "word": "ធ្នារ" },
    { "id": 5664, "word": "ធ្និម" },
    { "id": 5665, "word": "ធ្នឹម" },
    { "id": 5666, "word": "ធ្នឹមបណ្ដែត" },
    { "id": 5667, "word": "ធ្នូ" },
    { "id": 5668, "word": "ធ្នូខ្វែក" },
    { "id": 5669, "word": "ធ្នើរ" },
    { "id": 5670, "word": "ធ្នះ" },
    { "id": 5671, "word": "ធ្មង់" },
    { "id": 5672, "word": "ធ្មត់" },
    { "id": 5673, "word": "ធ្មប់" },
    { "id": 5674, "word": "ធ្មា" },
    { "id": 5675, "word": "ធ្មឹង" },
    { "id": 5676, "word": "ធ្មុង" },
    { "id": 5677, "word": "ធ្មុងកញ្ចុះ" },
    { "id": 5678, "word": "ធ្មើង" },
    { "id": 5679, "word": "ធ្មេច" },
    { "id": 5680, "word": "ធ្មេញ" },
    { "id": 5681, "word": "ធ្មេញកណ្ដុរ" },
    { "id": 5682, "word": "ធ្មេញកណ្ដូប" },
    { "id": 5683, "word": "ធ្មេញក្របី" },
    { "id": 5684, "word": "ធ្មេញចាស់" },
    { "id": 5685, "word": "ធ្មេញឈើ" },
    { "id": 5686, "word": "ធ្មេញត្រី" },
    { "id": 5687, "word": "ធ្មេញសេះ" },
    { "id": 5688, "word": "ធ្មៃ" },
    { "id": 5689, "word": "ធ្មោង" },
    { "id": 5690, "word": "ធ្មៅ" },
    { "id": 5691, "word": "ធ្មាំង" },
    { "id": 5692, "word": "ធ្យាន" },
    { "id": 5693, "word": "ធ្យានចិត្ត" },
    { "id": 5694, "word": "ធ្យានផល" },
    { "id": 5695, "word": "ធ្យានពល" },
    { "id": 5696, "word": "ធ្យានសុខ" },
    { "id": 5697, "word": "ធ្យានឫទ្ធិ" },
    { "id": 5698, "word": "ធ្យានានុភាព" },
    { "id": 5699, "word": "ធ្យូង" },
    { "id": 5700, "word": "ធ្លក" },
    { "id": 5701, "word": "ធ្លា" },
    { "id": 5702, "word": "ធ្លាក់" },
    { "id": 5703, "word": "ធ្លាប់" },
    { "id": 5704, "word": "ធ្លាយ" },
    { "id": 5705, "word": "ធ្លីង" },
    { "id": 5706, "word": "ធ្លុង" },
    { "id": 5707, "word": "ធ្លុញ" },
    { "id": 5708, "word": "ធ្លុះ" },
    { "id": 5709, "word": "ធ្លូ" },
    { "id": 5710, "word": "ធ្លូញ" },
    { "id": 5711, "word": "ធ្លួង" },
    { "id": 5712, "word": "ធ្លែរ" },
    { "id": 5713, "word": "ធ្លោ" },
    { "id": 5714, "word": "ធ្លោយ" },
    { "id": 5715, "word": "ធ្លាំង" },
    { "id": 5716, "word": "ធ្លះ" },
    { "id": 5717, "word": "ធ្វើ" },
    { "id": 5718, "word": "ធ្វើទុក្ខ" },
    { "id": 5719, "word": "ធ្វេស" },
    { "id": 5720, "word": "ធ្វេសទ្វេ" },
    { "id": 5721, "word": "ន" },
    { "id": 5722, "word": "ន៏" },
    { "id": 5723, "word": "នក" },
    { "id": 5724, "word": "នក្ខត្តឫក្ស" },
    { "id": 5725, "word": "នក្សត្រ" },
    { "id": 5726, "word": "នក្សត្រឫក្ស" },
    { "id": 5727, "word": "នខា" },
    { "id": 5728, "word": "នខ្វាក់" },
    { "id": 5729, "word": "នគរ" },
    { "id": 5730, "word": "នគរជន" },
    { "id": 5731, "word": "នគរជុំ" },
    { "id": 5732, "word": "នគរធំ" },
    { "id": 5733, "word": "នគរបាល" },
    { "id": 5734, "word": "នគរបុរី" },
    { "id": 5735, "word": "នគររាជ" },
    { "id": 5736, "word": "នគររាជជាតិ" },
    { "id": 5737, "word": "នគររាជជើងព្រៃ" },
    { "id": 5738, "word": "នគរវត្ត" },
    { "id": 5739, "word": "នគរសោភិនី" },
    { "id": 5740, "word": "នគ្គជន" },
    { "id": 5741, "word": "នង្គ័ល" },
    { "id": 5742, "word": "នត្តា" },
    { "id": 5743, "word": "នត្ថិភាព" },
    { "id": 5744, "word": "នត្ថុកម្ម" },
    { "id": 5745, "word": "នទី" },
    { "id": 5746, "word": "ននល" },
    { "id": 5747, "word": "ននៀល" },
    { "id": 5748, "word": "ននោង" },
    { "id": 5749, "word": "ននោងព្រៃ" },
    { "id": 5750, "word": "ននះ" },
    { "id": 5751, "word": "ននះនរនាទ" },
    { "id": 5752, "word": "នប" },
    { "id": 5753, "word": "នប់" },
    { "id": 5754, "word": "នបុំសកៈ" },
    { "id": 5755, "word": "នបុំសកលិង្គ" },
    { "id": 5756, "word": "នព្វ" },
    { "id": 5757, "word": "នភកេតន៍" },
    { "id": 5758, "word": "នភប្រាណ" },
    { "id": 5759, "word": "នភមណ្ឌល" },
    { "id": 5760, "word": "នភមណី" },
    { "id": 5761, "word": "នភា" },
    { "id": 5762, "word": "នភាល័យ" },
    { "id": 5763, "word": "នភោធូម" },
    { "id": 5764, "word": "នមស្ការ" },
    { "id": 5765, "word": "ន័យ" },
    { "id": 5766, "word": "នយនៈ" },
    { "id": 5767, "word": "នយនេត្រ" },
    { "id": 5768, "word": "នយលក្ខណៈ" },
    { "id": 5769, "word": "នយោបាយ" },
    { "id": 5770, "word": "នរៈ" },
    { "id": 5771, "word": "នរក" },
    { "id": 5772, "word": "នរកកុណ្ឌ" },
    { "id": 5773, "word": "នរឃាត" },
    { "id": 5774, "word": "នរឃាតក" },
    { "id": 5775, "word": "នរឃាតកម្ម" },
    { "id": 5776, "word": "នរជាតិ" },
    { "id": 5777, "word": "នរជេដ្ឋ" },
    { "id": 5778, "word": "នរណា" },
    { "id": 5779, "word": "នរទេព" },
    { "id": 5780, "word": "នរនាថ" },
    { "id": 5781, "word": "នរនាថា" },
    { "id": 5782, "word": "នរនាទ" },
    { "id": 5783, "word": "នរបតី" },
    { "id": 5784, "word": "នរពិស្វណ៍" },
    { "id": 5785, "word": "នរសីហៈ" },
    { "id": 5786, "word": "នរសឹហៈ" },
    { "id": 5787, "word": "នរាធិបតិន្ទ" },
    { "id": 5788, "word": "នរាធិប" },
    { "id": 5789, "word": "នរាសភ" },
    { "id": 5790, "word": "នរិន្ទ" },
    { "id": 5791, "word": "នរូ" },
    { "id": 5792, "word": "នរេន្ទ្រ" },
    { "id": 5793, "word": "នរេសូរ" },
    { "id": 5794, "word": "នរោត្តម" },
    { "id": 5795, "word": "នលាដ" },
    { "id": 5796, "word": "នវនីត" },
    { "id": 5797, "word": "នវមាលិកា" },
    { "id": 5798, "word": "នវាគត" },
    { "id": 5799, "word": "នវាគតភណ្ឌ" },
    { "id": 5800, "word": "នវុតិ" },
    { "id": 5801, "word": "នវោត្បន្ន" },
    { "id": 5802, "word": "នហានោទក" },
    { "id": 5803, "word": "នហារុ" },
    { "id": 5804, "word": "នហុត" },
    { "id": 5805, "word": "នា" },
    { "id": 5806, "word": "នាក់" },
    { "id": 5807, "word": "នាកាល" },
    { "id": 5808, "word": "នាគ" },
    { "id": 5809, "word": "នាគទន្ត" },
    { "id": 5810, "word": "នាគបាស" },
    { "id": 5811, "word": "នាគប្រក់" },
    { "id": 5812, "word": "នាគព័ន្ធ" },
    { "id": 5813, "word": "នាគមាណវី" },
    { "id": 5814, "word": "នាគរា" },
    { "id": 5815, "word": "នាគរាជ" },
    { "id": 5816, "word": "នាគរិក" },
    { "id": 5817, "word": "នាគរី" },
    { "id": 5818, "word": "នាគលោក" },
    { "id": 5819, "word": "នាគវិថី" },
    { "id": 5820, "word": "នាគា" },
    { "id": 5821, "word": "នាគាធិបតី" },
    { "id": 5822, "word": "នាង" },
    { "id": 5823, "word": "នាងច្រាល" },
    { "id": 5824, "word": "នាងដែង" },
    { "id": 5825, "word": "នាងដៃ" },
    { "id": 5826, "word": "នាងនក់" },
    { "id": 5827, "word": "នាងនាគ" },
    { "id": 5828, "word": "នាងនួន" },
    { "id": 5829, "word": "នាងផ្អែក" },
    { "id": 5830, "word": "នាងរង" },
    { "id": 5831, "word": "នាងវង" },
    { "id": 5832, "word": "នាងស្វាយ" },
    { "id": 5833, "word": "នាច" },
    { "id": 5834, "word": "នាដ" },
    { "id": 5835, "word": "នាដក" },
    { "id": 5836, "word": "នាដកម្ម" },
    { "id": 5837, "word": "នាដកសាល" },
    { "id": 5838, "word": "នាដកា" },
    { "id": 5839, "word": "នាថ" },
    { "id": 5840, "word": "នាទី" },
    { "id": 5841, "word": "នានា" },
    { "id": 5842, "word": "នានាជាតិ" },
    { "id": 5843, "word": "នានានុក្រម" },
    { "id": 5844, "word": "នានានុភាព" },
    { "id": 5845, "word": "នានាប្រទេស" },
    { "id": 5846, "word": "នានាសំវាស" },
    { "id": 5847, "word": "នាបី" },
    { "id": 5848, "word": "នាភី" },
    { "id": 5849, "word": "នាម" },
    { "id": 5850, "word": "នាមកិរិយា" },
    { "id": 5851, "word": "នាមគ្គហណមង្គល" },
    { "id": 5852, "word": "នាមប្បញ្ញត្តិ" },
    { "id": 5853, "word": "នាមប័ណ្ណ" },
    { "id": 5854, "word": "នាមសព្ទ" },
    { "id": 5855, "word": "នាម៉ឺន" },
    { "id": 5856, "word": "នាយ" },
    { "id": 5857, "word": "នាយក" },
    { "id": 5858, "word": "នាយកធម៌" },
    { "id": 5859, "word": "នាយចំណង់" },
    { "id": 5860, "word": "នាយទោ" },
    { "id": 5861, "word": "នាយឯក" },
    { "id": 5862, "word": "នារ" },
    { "id": 5863, "word": "នារទជាតក" },
    { "id": 5864, "word": "នារាយណ៍" },
    { "id": 5865, "word": "នារី" },
    { "id": 5866, "word": "នារីក្លាហាន" },
    { "id": 5867, "word": "នារីផល" },
    { "id": 5868, "word": "នារីរត្ន" },
    { "id": 5869, "word": "នាល" },
    { "id": 5870, "word": "នាលិ" },
    { "id": 5871, "word": "នាវ" },
    { "id": 5872, "word": "នាវា" },
    { "id": 5873, "word": "នាវិក" },
    { "id": 5874, "word": "នាវិកនាយក" },
    { "id": 5875, "word": "នាវិកបតី" },
    { "id": 5876, "word": "នាវិកា" },
    { "id": 5877, "word": "នាវិកាធិបតី" },
    { "id": 5878, "word": "នាវូបករណ៍" },
    { "id": 5879, "word": "នាសន" },
    { "id": 5880, "word": "នាសនង្គ" },
    { "id": 5881, "word": "នាសនា" },
    { "id": 5882, "word": "នាសា" },
    { "id": 5883, "word": "នាសិកដ្ឋានជៈ" },
    { "id": 5884, "word": "នាសិករោគ" },
    { "id": 5885, "word": "នាឡិ" },
    { "id": 5886, "word": "នាឡិកា" },
    { "id": 5887, "word": "និករ" },
    { "id": 5888, "word": "និកាយ" },
    { "id": 5889, "word": "និក្កង្ខា" },
    { "id": 5890, "word": "និក្ខេបបទ" },
    { "id": 5891, "word": "និគម" },
    { "id": 5892, "word": "និគមវចនៈ" },
    { "id": 5893, "word": "និគ្គហិត" },
    { "id": 5894, "word": "និគ្រន្ថ" },
    { "id": 5895, "word": "និគ្រោធ" },
    { "id": 5896, "word": "និគ្រោធព្រឹក្ស" },
    { "id": 5897, "word": "និគ្រោធារាម" },
    { "id": 5898, "word": "និង" },
    { "id": 5899, "word": "និច្ច" },
    { "id": 5900, "word": "និត្យ" },
    { "id": 5901, "word": "និទស្សន៍" },
    { "id": 5902, "word": "និទាឃៈ" },
    { "id": 5903, "word": "និទាន" },
    { "id": 5904, "word": "និទានកថា" },
    { "id": 5905, "word": "និទ្ទេស" },
    { "id": 5906, "word": "និទ្ទេសបទ" },
    { "id": 5907, "word": "និទ្ទេសវារៈ" },
    { "id": 5908, "word": "និទ្រា" },
    { "id": 5909, "word": "និន្ទា" },
    { "id": 5910, "word": "និន្នាការ" },
    { "id": 5911, "word": "និន្នាទ" },
    { "id": 5912, "word": "និប្បរិយាយ" },
    { "id": 5913, "word": "និបាត" },
    { "id": 5914, "word": "និបាត" },
    { "id": 5915, "word": "និបាតសព្ទ" },
    { "id": 5916, "word": "និពទ្ធកុសល" },
    { "id": 5917, "word": "និពន្ធ" },
    { "id": 5918, "word": "និព្វាន" },
    { "id": 5919, "word": "និព្វាននរក" },
    { "id": 5920, "word": "និមន្ត" },
    { "id": 5921, "word": "និមន្តន៍" },
    { "id": 5922, "word": "និមល" },
    { "id": 5923, "word": "និមិត" },
    { "id": 5924, "word": "និមិត្ត" },
    { "id": 5925, "word": "និមិត្តរូប" },
    { "id": 5926, "word": "និមិត្តហេតុ" },
    { "id": 5927, "word": "និម្មាបនកម្ម" },
    { "id": 5928, "word": "និម្មាបនិក" },
    { "id": 5929, "word": "និម្មានរតី" },
    { "id": 5930, "word": "និយតមិច្ឆាទិដ្ឋិ" },
    { "id": 5931, "word": "និយម" },
    { "id": 5932, "word": "និយាយ" },
    { "id": 5933, "word": "និយោជក" },
    { "id": 5934, "word": "និយោជិត" },
    { "id": 5935, "word": "និយ្យានិកធម៌" },
    { "id": 5936, "word": "និរគុណ" },
    { "id": 5937, "word": "និរណេត្រ" },
    { "id": 5938, "word": "និរតី" },
    { "id": 5939, "word": "និរទុក្ខ" },
    { "id": 5940, "word": "និរទេស" },
    { "id": 5941, "word": "និរទោស" },
    { "id": 5942, "word": "និរន្តរ" },
    { "id": 5943, "word": "និរន្តរាយ" },
    { "id": 5944, "word": "និរភ័យ" },
    { "id": 5945, "word": "និរមិត" },
    { "id": 5946, "word": "និរាស" },
    { "id": 5947, "word": "និរុត្តិ" },
    { "id": 5948, "word": "និរុទកបាយាស" },
    { "id": 5949, "word": "និរោធ" },
    { "id": 5950, "word": "និល" },
    { "id": 5951, "word": "និលពិសី" },
    { "id": 5952, "word": "និលរ័ត្ន" },
    { "id": 5953, "word": "និវត្ត" },
    { "id": 5954, "word": "និវត្តន៍" },
    { "id": 5955, "word": "និវត្តនាការ" },
    { "id": 5956, "word": "និវារណដ្ឋាន" },
    { "id": 5957, "word": "និវាសដ្ឋាន" },
    { "id": 5958, "word": "និវេទនកថា" },
    { "id": 5959, "word": "និវេសន៍" },
    { "id": 5960, "word": "និវេសនដ្ឋាន" },
    { "id": 5961, "word": "និសា" },
    { "id": 5962, "word": "និសាករ" },
    { "id": 5963, "word": "និសាចរ" },
    { "id": 5964, "word": "និស្ស័យ" },
    { "id": 5965, "word": "និស្សយជន" },
    { "id": 5966, "word": "និស្សយមុត្តកៈ" },
    { "id": 5967, "word": "និស្សយន្តេវាសិក" },
    { "id": 5968, "word": "និស្សយាចារ្យ" },
    { "id": 5969, "word": "និស្សិត" },
    { "id": 5970, "word": "និសីទនៈ" },
    { "id": 5971, "word": "និសីទនាការ" },
    { "id": 5972, "word": "នី" },
    { "id": 5973, "word": "នីតិ" },
    { "id": 5974, "word": "នីតិ--" },
    { "id": 5975, "word": "នីមួយ" },
    { "id": 5976, "word": "នីមួយៗ" },
    { "id": 5977, "word": "នីវរណធម៌" },
    { "id": 5978, "word": "នីហរណកម្ម" },
    { "id": 5979, "word": "នីហរ័ណ" },
    { "id": 5980, "word": "នីឡុង" },
    { "id": 5981, "word": "នឹក" },
    { "id": 5982, "word": "នឹង" },
    { "id": 5983, "word": "នឹម" },
    { "id": 5984, "word": "នុ៎ង" },
    { "id": 5985, "word": "នុយ" },
    { "id": 5986, "word": "នុះ" },
    { "id": 5987, "word": "នុ៎ះ" },
    { "id": 5988, "word": "នូវ" },
    { "id": 5989, "word": "នួន" },
    { "id": 5990, "word": "នួនល្អង" },
    { "id": 5991, "word": "នួនស្រី" },
    { "id": 5992, "word": "នឿក" },
    { "id": 5993, "word": "នឿយ" },
    { "id": 5994, "word": "នឿយណាយ" },
    { "id": 5995, "word": "នៀវ" },
    { "id": 5996, "word": "នេត្រ" },
    { "id": 5997, "word": "នេត្រា" },
    { "id": 5998, "word": "នេន" },
    { "id": 5999, "word": "នេមិរាជ" },
    { "id": 6000, "word": "នេរគុណ" },
    { "id": 6001, "word": "នេរទុក្ខ" },
    { "id": 6002, "word": "នេរភ័យ" },
    { "id": 6003, "word": "នេសជ្ជិកង្គៈ" },
    { "id": 6004, "word": "នេសាទ" },
    { "id": 6005, "word": "នេសាទុបករណ៍" },
    { "id": 6006, "word": "នេះ" },
    { "id": 6007, "word": "នែ!" },
    { "id": 6008, "word": "នែអ្ហឺ!" },
    { "id": 6009, "word": "នែប" },
    { "id": 6010, "word": "នែបនិត្យ" },
    { "id": 6011, "word": "នែលនល" },
    { "id": 6012, "word": "នៃ" },
    { "id": 6013, "word": "នោប" },
    { "id": 6014, "word": "នោម" },
    { "id": 6015, "word": "នោរី" },
    { "id": 6016, "word": "នោះ" },
    { "id": 6017, "word": "នៅ" },
    { "id": 6018, "word": "នំ" },
    { "id": 6019, "word": "នាំ" },
    { "id": 6020, "word": "នាំពា" },
    { "id": 6021, "word": "នាំអាទិ៍" },
    { "id": 6022, "word": "ន្របតី" },
    { "id": 6023, "word": "ន្រាយ" },
    { "id": 6024, "word": "ន្អាលនឹង" },
    { "id": 6025, "word": "ប" },
    { "id": 6026, "word": "បក" },
    { "id": 6027, "word": "បក់" },
    { "id": 6028, "word": "បក្សា" },
    { "id": 6029, "word": "បក្សី" },
    { "id": 6030, "word": "បង" },
    { "id": 6031, "word": "បង់" },
    { "id": 6032, "word": "បង់ក" },
    { "id": 6033, "word": "បង់ក្មេង" },
    { "id": 6034, "word": "បង់ខ្លាញ់" },
    { "id": 6035, "word": "បង់ឃ្លាត" },
    { "id": 6036, "word": "បង់ចាញ់" },
    { "id": 6037, "word": "បង់ចំណែង" },
    { "id": 6038, "word": "បង់ចំទាញ" },
    { "id": 6039, "word": "បង់ជំទាញ" },
    { "id": 6040, "word": "បង់បត់" },
    { "id": 6041, "word": "បង់បាញ់" },
    { "id": 6042, "word": "បង់បោយ" },
    { "id": 6043, "word": "បង់ម្សៀត" },
    { "id": 6044, "word": "បង់សៀត" },
    { "id": 6045, "word": "បង់សំណាញ់" },
    { "id": 6046, "word": "បង្ក" },
    { "id": 6047, "word": "បង្កក" },
    { "id": 6048, "word": "បង្កក់" },
    { "id": 6049, "word": "បង្កង" },
    { "id": 6050, "word": "បង្កង់" },
    { "id": 6051, "word": "បង្កប់" },
    { "id": 6052, "word": "បង្កាច់" },
    { "id": 6053, "word": "បង្កាត់" },
    { "id": 6054, "word": "បង្កាន់ដៃ" },
    { "id": 6055, "word": "បង្ការ" },
    { "id": 6056, "word": "បង្កិន" },
    { "id": 6057, "word": "បង្កិល" },
    { "id": 6058, "word": "បង្កុង" },
    { "id": 6059, "word": "បង្កូក" },
    { "id": 6060, "word": "បង្កួយ" },
    { "id": 6061, "word": "បង្កួយត្រង" },
    { "id": 6062, "word": "បង្កើច" },
    { "id": 6063, "word": "បង្កើត" },
    { "id": 6064, "word": "បង្កើន" },
    { "id": 6065, "word": "បង្កើយ" },
    { "id": 6066, "word": "បង្កើល" },
    { "id": 6067, "word": "បង្កឿង" },
    { "id": 6068, "word": "បង្កៀរ" },
    { "id": 6069, "word": "បង្កេល" },
    { "id": 6070, "word": "បង្កែក" },
    { "id": 6071, "word": "បង្កៃ" },
    { "id": 6072, "word": "បង្កោង" },
    { "id": 6073, "word": "បង្ក្រាប" },
    { "id": 6074, "word": "បង្ក្រៀក" },
    { "id": 6075, "word": "បង្ខក" },
    { "id": 6076, "word": "បង្ខន" },
    { "id": 6077, "word": "បង្ខាក" },
    { "id": 6078, "word": "បង្ខាត" },
    { "id": 6079, "word": "បង្ខាន" },
    { "id": 6080, "word": "បង្ខិត" },
    { "id": 6081, "word": "បង្ខុស" },
    { "id": 6082, "word": "បង្ខូង" },
    { "id": 6083, "word": "បង្ខូច" },
    { "id": 6084, "word": "បង្ខើច" },
    { "id": 6085, "word": "បង្ខំ" },
    { "id": 6086, "word": "បង្ខាំ" },
    { "id": 6087, "word": "បង្ខាំង" },
    { "id": 6088, "word": "បង្ខះ" },
    { "id": 6089, "word": "បង្គង" },
    { "id": 6090, "word": "បង្គន់" },
    { "id": 6091, "word": "បង្គរ" },
    { "id": 6092, "word": "បង្គា" },
    { "id": 6093, "word": "បង្គាន" },
    { "id": 6094, "word": "បង្គាប់" },
    { "id": 6095, "word": "បង្គាវ" },
    { "id": 6096, "word": "បង្គី" },
    { "id": 6097, "word": "បង្គីបង្គា" },
    { "id": 6098, "word": "បង្គុយ" },
    { "id": 6099, "word": "បង្គួរ" },
    { "id": 6100, "word": "បង្គេច" },
    { "id": 6101, "word": "បង្គោល" },
    { "id": 6102, "word": "បង្គោះ" },
    { "id": 6103, "word": "បង្គៅ" },
    { "id": 6104, "word": "បង្គំ" },
    { "id": 6105, "word": "បង្បោយ" },
    { "id": 6106, "word": "បង្គ្រប" },
    { "id": 6107, "word": "បង្គ្រប់" },
    { "id": 6108, "word": "បង្រាស" },
    { "id": 6109, "word": "បង្រុះ" },
    { "id": 6110, "word": "បង្រួញ" },
    { "id": 6111, "word": "បង្រួប" },
    { "id": 6112, "word": "បង្រួម" },
    { "id": 6113, "word": "បង្រៀន" },
    { "id": 6114, "word": "បង្រោស" },
    { "id": 6115, "word": "បង្រះ" },
    { "id": 6116, "word": "បង្វិល" },
    { "id": 6117, "word": "បង្វឹក" },
    { "id": 6118, "word": "បង្វៀន" },
    { "id": 6119, "word": "បង្វៀះ" },
    { "id": 6120, "word": "បង្វេច" },
    { "id": 6121, "word": "បង្វេះ" },
    { "id": 6122, "word": "បង្វែង" },
    { "id": 6123, "word": "បង្វែរ" },
    { "id": 6124, "word": "បង្សុកូល" },
    { "id": 6125, "word": "បង្ហក" },
    { "id": 6126, "word": "បង្ហក់" },
    { "id": 6127, "word": "បង្ហត់" },
    { "id": 6128, "word": "បង្ហប" },
    { "id": 6129, "word": "បង្ហប់" },
    { "id": 6130, "word": "បង្ហល់" },
    { "id": 6131, "word": "បង្ហា" },
    { "id": 6132, "word": "បង្ហាញ" },
    { "id": 6133, "word": "បង្ហាត់" },
    { "id": 6134, "word": "បង្ហាប់" },
    { "id": 6135, "word": "បង្ហិន" },
    { "id": 6136, "word": "បង្ហិល" },
    { "id": 6137, "word": "បង្ហុយ" },
    { "id": 6138, "word": "បង្ហូត" },
    { "id": 6139, "word": "បង្ហូរ" },
    { "id": 6140, "word": "បង្ហួត" },
    { "id": 6141, "word": "បង្ហួរ" },
    { "id": 6142, "word": "បង្ហួល" },
    { "id": 6143, "word": "បង្ហួស" },
    { "id": 6144, "word": "បង្ហើប" },
    { "id": 6145, "word": "បង្ហើម" },
    { "id": 6146, "word": "បង្ហើយ" },
    { "id": 6147, "word": "បង្ហើរ" },
    { "id": 6148, "word": "បង្ហៀរ" },
    { "id": 6149, "word": "បង្ហៀរខ្មូត" },
    { "id": 6150, "word": "បង្ហេវ" },
    { "id": 6151, "word": "បង្ហែ" },
    { "id": 6152, "word": "បង្ហែប" },
    { "id": 6153, "word": "បង្ហែល" },
    { "id": 6154, "word": "បង្ហោច" },
    { "id": 6155, "word": "បង្ហោះ" },
    { "id": 6156, "word": "បង្អក" },
    { "id": 6157, "word": "បង្អង់" },
    { "id": 6158, "word": "បង្អត់" },
    { "id": 6159, "word": "បង្អន់" },
    { "id": 6160, "word": "បង្អរ" },
    { "id": 6161, "word": "បង្អស់" },
    { "id": 6162, "word": "បង្អាក់" },
    { "id": 6163, "word": "បង្អាច" },
    { "id": 6164, "word": "បង្អាប់" },
    { "id": 6165, "word": "បង្អុរ" },
    { "id": 6166, "word": "បង្អូន" },
    { "id": 6167, "word": "បង្អូស" },
    { "id": 6168, "word": "បង្អួច" },
    { "id": 6169, "word": "បង្អួត" },
    { "id": 6170, "word": "បង្អួល" },
    { "id": 6171, "word": "បង្អើត" },
    { "id": 6172, "word": "បង្អើល" },
    { "id": 6173, "word": "បង្អៀង" },
    { "id": 6174, "word": "បង្អៀន" },
    { "id": 6175, "word": "បង្អៀវ" },
    { "id": 6176, "word": "បង្អែ" },
    { "id": 6177, "word": "បង្អែក" },
    { "id": 6178, "word": "បង្អែន" },
    { "id": 6179, "word": "បង្អែប" },
    { "id": 6180, "word": "បង្អែម" },
    { "id": 6181, "word": "បង្អោង" },
    { "id": 6182, "word": "បង្អោត" },
    { "id": 6183, "word": "បង្អោន" },
    { "id": 6184, "word": "បង្អោរ" },
    { "id": 6185, "word": "បង្អៅ" },
    { "id": 6186, "word": "បញ្ចង់" },
    { "id": 6187, "word": "បញ្ចង្គ" },
    { "id": 6188, "word": "បញ្ចប់" },
    { "id": 6189, "word": "បញ្ចពណ៌" },
    { "id": 6190, "word": "បញ្ចរង្គ" },
    { "id": 6191, "word": "បញ្ចា" },
    { "id": 6192, "word": "បញ្ចាច់" },
    { "id": 6193, "word": "បញ្ចាល់" },
    { "id": 6194, "word": "បញ្ចុក" },
    { "id": 6195, "word": "បញ្ចុះ" },
    { "id": 6196, "word": "បញ្ចូល" },
    { "id": 6197, "word": "បញ្ចើ" },
    { "id": 6198, "word": "បញ្ចើច" },
    { "id": 6199, "word": "បញ្ចៀស" },
    { "id": 6200, "word": "បញ្ចេញ" },
    { "id": 6201, "word": "បញ្ចេរ" },
    { "id": 6202, "word": "បញ្ចេះ" },
    { "id": 6203, "word": "បញ្ចោរ" },
    { "id": 6204, "word": "បញ្ចាំ" },
    { "id": 6205, "word": "បញ្ចាំង" },
    { "id": 6206, "word": "បញ្ច្រក" },
    { "id": 6207, "word": "បញ្ច្រាស" },
    { "id": 6208, "word": "បញ្ច្រិច" },
    { "id": 6209, "word": "បញ្ច្រូច" },
    { "id": 6210, "word": "បញ្ច្រោះ" },
    { "id": 6211, "word": "បញ្ឆាក" },
    { "id": 6212, "word": "បញ្ឆាច់" },
    { "id": 6213, "word": "បញ្ឆាប" },
    { "id": 6214, "word": "បញ្ឆិច" },
    { "id": 6215, "word": "បញ្ឆិត" },
    { "id": 6216, "word": "បញ្ឆឹក" },
    { "id": 6217, "word": "បញ្ឆុក" },
    { "id": 6218, "word": "បញ្ឆួល" },
    { "id": 6219, "word": "បញ្ឆើត" },
    { "id": 6220, "word": "បញ្ឆៀង" },
    { "id": 6221, "word": "បញ្ឆេះ" },
    { "id": 6222, "word": "បញ្ឆោត" },
    { "id": 6223, "word": "បញ្ជក់" },
    { "id": 6224, "word": "បញ្ជច់" },
    { "id": 6225, "word": "បញ្ជត" },
    { "id": 6226, "word": "បញ្ជរ" },
    { "id": 6227, "word": "បញ្ជល់" },
    { "id": 6228, "word": "បញ្ជា" },
    { "id": 6229, "word": "បញ្ជាក់" },
    { "id": 6230, "word": "បញ្ជាការ" },
    { "id": 6231, "word": "បញ្ជាន់" },
    { "id": 6232, "word": "បញ្ជាន់ត្រស្ដិ" },
    { "id": 6233, "word": "បញ្ជាប់" },
    { "id": 6234, "word": "បញ្ជាប់ពាក្យ" },
    { "id": 6235, "word": "បញ្ជាប់ព្រលឹង" },
    { "id": 6236, "word": "បញ្ជិកា" },
    { "id": 6237, "word": "បញ្ជិកាក្រឹត" },
    { "id": 6238, "word": "បញ្ជិះ" },
    { "id": 6239, "word": "បញ្ជី" },
    { "id": 6240, "word": "បញ្ជូន" },
    { "id": 6241, "word": "បញ្ជើច" },
    { "id": 6242, "word": "បញ្ជោក" },
    { "id": 6243, "word": "បញ្ជោរ" },
    { "id": 6244, "word": "បញ្ជោះ" },
    { "id": 6245, "word": "បញ្ជ្រក" },
    { "id": 6246, "word": "បញ្ជ្រាប" },
    { "id": 6247, "word": "បញ្ជ្រាល" },
    { "id": 6248, "word": "បញ្ជ្រិះ" },
    { "id": 6249, "word": "បញ្ជ្រុល" },
    { "id": 6250, "word": "បញ្ជ្រួស" },
    { "id": 6251, "word": "បញ្ឈប់" },
    { "id": 6252, "word": "បញ្ឈរ" },
    { "id": 6253, "word": "បញ្ឈឺ" },
    { "id": 6254, "word": "បញ្ឈែល" },
    { "id": 6255, "word": "បញ្ញត្ត" },
    { "id": 6256, "word": "បញ្ញត្តិ" },
    { "id": 6257, "word": "បញ្ញើ" },
    { "id": 6258, "word": "បញ្ញើក្អែក" },
    { "id": 6259, "word": "បញ្ញែ" },
    { "id": 6260, "word": "បញ្ញែម" },
    { "id": 6261, "word": "បញ្ហា" },
    { "id": 6262, "word": "បណ្ដា" },
    { "id": 6263, "word": "បណ្ដាក់" },
    { "id": 6264, "word": "បណ្ដាច់" },
    { "id": 6265, "word": "បណ្ដាញ" },
    { "id": 6266, "word": "បណ្ដាល" },
    { "id": 6267, "word": "បណ្ដាសា" },
    { "id": 6268, "word": "បណ្ដិប" },
    { "id": 6269, "word": "បណ្ដឹង" },
    { "id": 6270, "word": "បណ្ដឹប" },
    { "id": 6271, "word": "បណ្ដុន" },
    { "id": 6272, "word": "បណ្ដុះ" },
    { "id": 6273, "word": "បណ្ដូល" },
    { "id": 6274, "word": "បណ្ដូលល្ពៅ" },
    { "id": 6275, "word": "បណ្ដើរ" },
    { "id": 6276, "word": "បណ្ដេញ" },
    { "id": 6277, "word": "បណ្ដែត" },
    { "id": 6278, "word": "បណ្ដោយ" },
    { "id": 6279, "word": "បណ្ដោះ" },
    { "id": 6280, "word": "បណ្ដោះបណ្ដៃ" },
    { "id": 6281, "word": "បណ្ដោះអាសន្ន" },
    { "id": 6282, "word": "បណ្ដៅ" },
    { "id": 6283, "word": "បណ្ដុំ" },
    { "id": 6284, "word": "បណ្ដាំ" },
    { "id": 6285, "word": "បណ្ឌក" },
    { "id": 6286, "word": "បណ្ឌា" },
    { "id": 6287, "word": "បណ្ឌិត" },
    { "id": 6288, "word": "បណ្ឌិតមានះ" },
    { "id": 6289, "word": "បណ្ឌិតមានី" },
    { "id": 6290, "word": "បណ្ឌិត្យ" },
    { "id": 6291, "word": "បណ្ឌុកម្ពលសិលា" },
    { "id": 6292, "word": "បណ្ឌុរោគ" },
    { "id": 6293, "word": "បណ្ណសាលា" },
    { "id": 6294, "word": "បណ្ណាការ" },
    { "id": 6295, "word": "បណ្ណែ" },
    { "id": 6296, "word": "បត់" },
    { "id": 6297, "word": "បត់ជើង" },
    { "id": 6298, "word": "បទ" },
    { "id": 6299, "word": "បន" },
    { "id": 6300, "word": "បន់" },
    { "id": 6301, "word": "បន្ត" },
    { "id": 6302, "word": "បន្តក់" },
    { "id": 6303, "word": "បន្តម" },
    { "id": 6304, "word": "បន្តិច" },
    { "id": 6305, "word": "បន្តឹង" },
    { "id": 6306, "word": "បន្តុប" },
    { "id": 6307, "word": "បន្តុះ" },
    { "id": 6308, "word": "បន្តូច" },
    { "id": 6309, "word": "បន្តួច" },
    { "id": 6310, "word": "បន្តើត" },
    { "id": 6311, "word": "បន្តោក" },
    { "id": 6312, "word": "បន្តោង" },
    { "id": 6313, "word": "បន្ថត" },
    { "id": 6314, "word": "បន្ថយ" },
    { "id": 6315, "word": "បន្ថុច" },
    { "id": 6316, "word": "បន្ថើរ" },
    { "id": 6317, "word": "បន្ថែ" },
    { "id": 6318, "word": "បន្ថែម" },
    { "id": 6319, "word": "បន្ថោក" },
    { "id": 6320, "word": "បន្ទច់" },
    { "id": 6321, "word": "បន្ទន់" },
    { "id": 6322, "word": "បន្ទប់" },
    { "id": 6323, "word": "បន្ទរ" },
    { "id": 6324, "word": "បន្ទាត់" },
    { "id": 6325, "word": "បន្ទាន់" },
    { "id": 6326, "word": "បន្ទាប" },
    { "id": 6327, "word": "បន្ទាប់" },
    { "id": 6328, "word": "បន្ទាប់បន្សំ" },
    { "id": 6329, "word": "បន្ទាយ" },
    { "id": 6330, "word": "បន្ទាយកិល" },
    { "id": 6331, "word": "បន្ទាយក្ដី" },
    { "id": 6332, "word": "បន្ទាយឆ្មារ" },
    { "id": 6333, "word": "បន្ទាយមាស" },
    { "id": 6334, "word": "បន្ទាយលង្វែក" },
    { "id": 6335, "word": "បន្ទាយស្រី" },
    { "id": 6336, "word": "បន្ទារ" },
    { "id": 6337, "word": "បន្ទាល" },
    { "id": 6338, "word": "បន្ទាល់" },
    { "id": 6339, "word": "បន្ទាស" },
    { "id": 6340, "word": "បន្ទីង" },
    { "id": 6341, "word": "បន្ទុក" },
    { "id": 6342, "word": "បន្ទុល" },
    { "id": 6343, "word": "បន្ទូល" },
    { "id": 6344, "word": "បន្ទើង" },
    { "id": 6345, "word": "បន្ទើត" },
    { "id": 6346, "word": "បន្ទើរ" },
    { "id": 6347, "word": "បន្ទេរ" },
    { "id": 6348, "word": "បន្ទោ" },
    { "id": 6349, "word": "បន្ទោបង់" },
    { "id": 6350, "word": "បន្ទោស" },
    { "id": 6351, "word": "បន្ទោះ" },
    { "id": 6352, "word": "បន្ទោះប្រហុក" },
    { "id": 6353, "word": "បន្ទុំ" },
    { "id": 6354, "word": "បន្ទំ" },
    { "id": 6355, "word": "បន្ទះ" },
    { "id": 6356, "word": "បន្ទ្រាន់" },
    { "id": 6357, "word": "បន្ទ្រេត" },
    { "id": 6358, "word": "បន្ទ្រោម" },
    { "id": 6359, "word": "បន្ធាត់" },
    { "id": 6360, "word": "បន្ធូរ" },
    { "id": 6361, "word": "បន្ធំ" },
    { "id": 6362, "word": "បន្លប់" },
    { "id": 6363, "word": "បន្លា" },
    { "id": 6364, "word": "បន្លាច" },
    { "id": 6365, "word": "បន្លាយ" },
    { "id": 6366, "word": "បន្លាស់" },
    { "id": 6367, "word": "បន្លិច" },
    { "id": 6368, "word": "បន្លឹម" },
    { "id": 6369, "word": "បន្លឺ" },
    { "id": 6370, "word": "បន្លុក" },
    { "id": 6371, "word": "បន្លុង" },
    { "id": 6372, "word": "បន្លុយ" },
    { "id": 6373, "word": "បន្លួញ" },
    { "id": 6374, "word": "បន្លៀក" },
    { "id": 6375, "word": "បន្លៀន" },
    { "id": 6376, "word": "បន្លែ" },
    { "id": 6377, "word": "បន្លែបង្ការ" },
    { "id": 6378, "word": "បន្លែង" },
    { "id": 6379, "word": "បន្លោះ" },
    { "id": 6380, "word": "បន្លំ" },
    { "id": 6381, "word": "បន្សល់" },
    { "id": 6382, "word": "បន្សាក់" },
    { "id": 6383, "word": "បន្សាត់" },
    { "id": 6384, "word": "បន្សាប" },
    { "id": 6385, "word": "បន្សារ" },
    { "id": 6386, "word": "បន្សាល់" },
    { "id": 6387, "word": "បន្ស៉ី" },
    { "id": 6388, "word": "បន្សុទ្ធ" },
    { "id": 6389, "word": "បន្សើច" },
    { "id": 6390, "word": "បន្សើម" },
    { "id": 6391, "word": "បន្សោះ" },
    { "id": 6392, "word": "បន្សាំ" },
    { "id": 6393, "word": "បន្សះ" },
    { "id": 6394, "word": "បបក់" },
    { "id": 6395, "word": "បបរ" },
    { "id": 6396, "word": "បបុស" },
    { "id": 6397, "word": "បបូរ" },
    { "id": 6398, "word": "បបួល" },
    { "id": 6399, "word": "បបែល" },
    { "id": 6400, "word": "បបោស" },
    { "id": 6401, "word": "បបោសអង្អែល" },
    { "id": 6402, "word": "បព្វៈ" },
    { "id": 6403, "word": "បព្វជ្ជន្តេវាសិក" },
    { "id": 6404, "word": "បព្វជ្ជា" },
    { "id": 6405, "word": "បព្វជ្ជាកម្ម" },
    { "id": 6406, "word": "បព្វជ្ជាចារ្យ" },
    { "id": 6407, "word": "បព្វជ្ជានិសង្ស" },
    { "id": 6408, "word": "បព្វជ្ជាបេក្ខៈ" },
    { "id": 6409, "word": "បព្វជ្ជាវិធី" },
    { "id": 6410, "word": "បព្វជិត" },
    { "id": 6411, "word": "បព្វជិតនាម" },
    { "id": 6412, "word": "បព្វតរាជ" },
    { "id": 6413, "word": "បព្វាជនីយកម្ម" },
    { "id": 6414, "word": "បពិត្រ" },
    { "id": 6415, "word": "បម" },
    { "id": 6416, "word": "បម្រាប" },
    { "id": 6417, "word": "បម្រាប់" },
    { "id": 6418, "word": "បម្រាម" },
    { "id": 6419, "word": "បម្រាស" },
    { "id": 6420, "word": "បម្រាស់" },
    { "id": 6421, "word": "បម្រឹង" },
    { "id": 6422, "word": "បម្រុង" },
    { "id": 6423, "word": "បម្រើ" },
    { "id": 6424, "word": "បម្រោស" },
    { "id": 6425, "word": "បម្រះ" },
    { "id": 6426, "word": "បរ" },
    { "id": 6427, "word": "បរគាវ" },
    { "id": 6428, "word": "បរទេស" },
    { "id": 6429, "word": "បរពត" },
    { "id": 6430, "word": "បរម" },
    { "id": 6431, "word": "បរមកោដ្ឋ" },
    { "id": 6432, "word": "បរមត្ថ" },
    { "id": 6433, "word": "បរមត្ថកថា" },
    { "id": 6434, "word": "បរមត្ថវិជ្ជា" },
    { "id": 6435, "word": "បរមត្ថវិទូ" },
    { "id": 6436, "word": "បរមាឃ" },
    { "id": 6437, "word": "បរលោក" },
    { "id": 6438, "word": "បរិកម្ម" },
    { "id": 6439, "word": "បរិក្ខារ" },
    { "id": 6440, "word": "បរិច្ចាគ" },
    { "id": 6441, "word": "បរិច្ឆេទ" },
    { "id": 6442, "word": "បរិបូរ" },
    { "id": 6443, "word": "បរិបូរណ៍" },
    { "id": 6444, "word": "បរិបូណ៌" },
    { "id": 6445, "word": "បរិពារ" },
    { "id": 6446, "word": "បរិភាស" },
    { "id": 6447, "word": "បរិភាសកៈ" },
    { "id": 6448, "word": "បរិភាសន៍" },
    { "id": 6449, "word": "បរិភាសិកា" },
    { "id": 6450, "word": "បរិភោក្ដា" },
    { "id": 6451, "word": "បរិភោគ" },
    { "id": 6452, "word": "បរិភោគប័ណ្ណ" },
    { "id": 6453, "word": "បរិយាយ" },
    { "id": 6454, "word": "បរិរក្ស" },
    { "id": 6455, "word": "បរិវារ" },
    { "id": 6456, "word": "បរិវារសម្ប័ទ" },
    { "id": 6457, "word": "បរិវាស" },
    { "id": 6458, "word": "បរិវាសកម្ម" },
    { "id": 6459, "word": "បរិវេណ" },
    { "id": 6460, "word": "បរិស័ទ" },
    { "id": 6461, "word": "បរិសទ្យ" },
    { "id": 6462, "word": "បរិសុទ្ធ" },
    { "id": 6463, "word": "បរិសុទ្ធិ" },
    { "id": 6464, "word": "បរិហារ" },
    { "id": 6465, "word": "បរោហិត" },
    { "id": 6466, "word": "បវរ" },
    { "id": 6467, "word": "បវរកញ្ញា" },
    { "id": 6468, "word": "បស្ចិម" },
    { "id": 6469, "word": "បា" },
    { "id": 6470, "word": "បាក់" },
    { "id": 6471, "word": "បាក់គាំ" },
    { "id": 6472, "word": "បាក់ជ័របាយ" },
    { "id": 6473, "word": "បាក់ដង" },
    { "id": 6474, "word": "បាក់ដំឡូង" },
    { "id": 6475, "word": "បាក់បប" },
    { "id": 6476, "word": "បាក់ផ្ដៅ" },
    { "id": 6477, "word": "បាក់សាច់" },
    { "id": 6478, "word": "បាក់ស្បាត" },
    { "id": 6479, "word": "បាកាន" },
    { "id": 6480, "word": "បាខែង" },
    { "id": 6481, "word": "បាគង" },
    { "id": 6482, "word": "បាគោ" },
    { "id": 6483, "word": "បាង" },
    { "id": 6484, "word": "បាងកក" },
    { "id": 6485, "word": "បាច" },
    { "id": 6486, "word": "បាច់" },
    { "id": 6487, "word": "បាចសរ" },
    { "id": 6488, "word": "បាញ" },
    { "id": 6489, "word": "បាញ់" },
    { "id": 6490, "word": "បាញ់រង" },
    { "id": 6491, "word": "បាត" },
    { "id": 6492, "word": "បាត់" },
    { "id": 6493, "word": "បាត់ដឹង" },
    { "id": 6494, "word": "បាត់បង់" },
    { "id": 6495, "word": "បាតាល" },
    { "id": 6496, "word": "បាត្រ" },
    { "id": 6497, "word": "បាទ" },
    { "id": 6498, "word": "បាទចរណ៍" },
    { "id": 6499, "word": "បាទចារី" },
    { "id": 6500, "word": "បាទបរិចារិកា" },
    { "id": 6501, "word": "បាទមូល" },
    { "id": 6502, "word": "បាទយុគល" },
    { "id": 6503, "word": "បាទា" },
    { "id": 6504, "word": "បាទី" },
    { "id": 6505, "word": "បាទុក" },
    { "id": 6506, "word": "បាន" },
    { "id": 6507, "word": "បាប" },
    { "id": 6508, "word": "បាបកម្ម" },
    { "id": 6509, "word": "បាបគ្រោះ" },
    { "id": 6510, "word": "បាបចិត្ត" },
    { "id": 6511, "word": "បាបធម៌" },
    { "id": 6512, "word": "បាបមិត្ត" },
    { "id": 6513, "word": "បាពួន" },
    { "id": 6514, "word": "បាភ្នំ" },
    { "id": 6515, "word": "បាយ" },
    { "id": 6516, "word": "បាយកក" },
    { "id": 6517, "word": "បាយក្ដាំង" },
    { "id": 6518, "word": "បាយក្រញិញ" },
    { "id": 6519, "word": "បាយក្រៀម" },
    { "id": 6520, "word": "បាយក្អែក" },
    { "id": 6521, "word": "បាយខុន" },
    { "id": 6522, "word": "បាយខុំ" },
    { "id": 6523, "word": "បាយគំទឹក" },
    { "id": 6524, "word": "បាយដំណើប" },
    { "id": 6525, "word": "បាយតម្រាំ" },
    { "id": 6526, "word": "បាយ័ន" },
    { "id": 6527, "word": "បាយបត្តបូរ" },
    { "id": 6528, "word": "បាយបៀង" },
    { "id": 6529, "word": "បាយព្រលឹង" },
    { "id": 6530, "word": "បាយម៉ាត" },
    { "id": 6531, "word": "បាយម៉ាន" },
    { "id": 6532, "word": "បាយសិង្ឃាដក៍" },
    { "id": 6533, "word": "បាយសី" },
    { "id": 6534, "word": "បាយស្រី" },
    { "id": 6535, "word": "បាយឡី" },
    { "id": 6536, "word": "បាយឡុកបាយឡ" },
    { "id": 6537, "word": "បាយអ" },
    { "id": 6538, "word": "បាយអគោម័យ" },
    { "id": 6539, "word": "បាយាប" },
    { "id": 6540, "word": "បាយាស" },
    { "id": 6541, "word": "បារ" },
    { "id": 6542, "word": "បារគូ" },
    { "id": 6543, "word": "បារត" },
    { "id": 6544, "word": "បារទ" },
    { "id": 6545, "word": "បារម្ភ" },
    { "id": 6546, "word": "បារមី" },
    { "id": 6547, "word": "បារាយ" },
    { "id": 6548, "word": "បារាយណ៍" },
    { "id": 6549, "word": "បារាយណ៍ទឹកថ្លា" },
    { "id": 6550, "word": "បារាស" },
    { "id": 6551, "word": "បារី" },
    { "id": 6552, "word": "បារៀន" },
    { "id": 6553, "word": "បារាំ" },
    { "id": 6554, "word": "បារាំកំពូល" },
    { "id": 6555, "word": "បារាំង" },
    { "id": 6556, "word": "បារាំងសែស" },
    { "id": 6557, "word": "បារាំយ៉ត" },
    { "id": 6558, "word": "បាល់" },
    { "id": 6559, "word": "បាល័ដ្ឋ" },
    { "id": 6560, "word": "បាលី" },
    { "id": 6561, "word": "បាវ" },
    { "id": 6562, "word": "បាវព្រាវ" },
    { "id": 6563, "word": "បាស" },
    { "id": 6564, "word": "បាសក" },
    { "id": 6565, "word": "បាសកា" },
    { "id": 6566, "word": "បាស្កា" },
    { "id": 6567, "word": "បាឡាត់" },
    { "id": 6568, "word": "បាឡី" },
    { "id": 6569, "word": "បិដក" },
    { "id": 6570, "word": "បិដកត្រ័យ" },
    { "id": 6571, "word": "បិដរ" },
    { "id": 6572, "word": "បិណ្ឌ" },
    { "id": 6573, "word": "បិណ្ឌបាត" },
    { "id": 6574, "word": "បិណ្ឌបាតចារិកវត្ត" },
    { "id": 6575, "word": "បិណ្ឌបាតទាន" },
    { "id": 6576, "word": "បិណ្ឌបាតប្បច្ច័យ" },
    { "id": 6577, "word": "បិណ្ឌបាតិកង្គៈ" },
    { "id": 6578, "word": "បិត" },
    { "id": 6579, "word": "បិតរ" },
    { "id": 6580, "word": "បិតា" },
    { "id": 6581, "word": "បិតាមហា" },
    { "id": 6582, "word": "បិត្តបូរ" },
    { "id": 6583, "word": "បិទ" },
    { "id": 6584, "word": "បិទពួន" },
    { "id": 6585, "word": "បិទមុខ" },
    { "id": 6586, "word": "បិសាច" },
    { "id": 6587, "word": "បី" },
    { "id": 6588, "word": "បីដូច" },
    { "id": 6589, "word": "បីបម" },
    { "id": 6590, "word": "បីបាច់" },
    { "id": 6591, "word": "បឹង" },
    { "id": 6592, "word": "បឹម" },
    { "id": 6593, "word": "បឺត" },
    { "id": 6594, "word": "បឺះ!" },
    { "id": 6595, "word": "បុក" },
    { "id": 6596, "word": "បុកល័ក្ដ" },
    { "id": 6597, "word": "បុកស្រូវ" },
    { "id": 6598, "word": "បុគ្គល" },
    { "id": 6599, "word": "បុគ្គលប្បញ្ញត្តិ" },
    { "id": 6600, "word": "បុគ្គលាធិដ្ឋាន" },
    { "id": 6601, "word": "បុគ្គលិក" },
    { "id": 6602, "word": "បុគ្គលិកទាន" },
    { "id": 6603, "word": "បុគ្គលិកលក្ខណៈ" },
    { "id": 6604, "word": "បុញ្ញ" },
    { "id": 6605, "word": "បុញ្ញ--" },
    { "id": 6606, "word": "បុណ្ឌរិក" },
    { "id": 6607, "word": "បុណ្យ" },
    { "id": 6608, "word": "បុណ្យទិន" },
    { "id": 6609, "word": "បុត្រ" },
    { "id": 6610, "word": "បុត្រា" },
    { "id": 6611, "word": "បុត្រាធីន" },
    { "id": 6612, "word": "បុត្រានុគ្រោះ" },
    { "id": 6613, "word": "បុត្រី" },
    { "id": 6614, "word": "បុប្ផគន្ធ" },
    { "id": 6615, "word": "បុប្ផជាតិ" },
    { "id": 6616, "word": "បុប្ផវតី" },
    { "id": 6617, "word": "បុប្ផវិក័តិ" },
    { "id": 6618, "word": "បុប្ផា" },
    { "id": 6619, "word": "បុប្ផាកេសរ" },
    { "id": 6620, "word": "បុប្ផានារី" },
    { "id": 6621, "word": "បុប្ផារាម" },
    { "id": 6622, "word": "បុព្វ" },
    { "id": 6623, "word": "បុព្វ--" },
    { "id": 6624, "word": "បុព្វេ" },
    { "id": 6625, "word": "បុព្វេនិវាសានុស្សតិញ្ញាណ" },
    { "id": 6626, "word": "បុព្វេសន្និវាស" },
    { "id": 6627, "word": "បុព្វោ" },
    { "id": 6628, "word": "បុរស" },
    { "id": 6629, "word": "បុរាណ" },
    { "id": 6630, "word": "បុរាណទុតិយិកា" },
    { "id": 6631, "word": "បុរិន្ទ" },
    { "id": 6632, "word": "បុរី" },
    { "id": 6633, "word": "បុរីរក្ស" },
    { "id": 6634, "word": "បុរីរម្យ" },
    { "id": 6635, "word": "បុរោហិត" },
    { "id": 6636, "word": "បុល" },
    { "id": 6637, "word": "បុល្លិកា" },
    { "id": 6638, "word": "បុសនាគ" },
    { "id": 6639, "word": "បុស្បា" },
    { "id": 6640, "word": "បុស្បុក" },
    { "id": 6641, "word": "បុស្ស" },
    { "id": 6642, "word": "បុស្សរថ" },
    { "id": 6643, "word": "បុះ" },
    { "id": 6644, "word": "បូ" },
    { "id": 6645, "word": "បូក" },
    { "id": 6646, "word": "បូកគោ" },
    { "id": 6647, "word": "បូកបោះ" },
    { "id": 6648, "word": "បូកប៉ាន់" },
    { "id": 6649, "word": "បូកឡូក" },
    { "id": 6650, "word": "បូគ" },
    { "id": 6651, "word": "បូគគោ" },
    { "id": 6652, "word": "បូជនកិច្ច" },
    { "id": 6653, "word": "បូជនីយៈ" },
    { "id": 6654, "word": "បូជនីយេសក៍" },
    { "id": 6655, "word": "បូជា" },
    { "id": 6656, "word": "បូញ" },
    { "id": 6657, "word": "បូញបាញ" },
    { "id": 6658, "word": "បូណ៌មី" },
    { "id": 6659, "word": "បូត" },
    { "id": 6660, "word": "បូតសណ្ដែក" },
    { "id": 6661, "word": "បូម" },
    { "id": 6662, "word": "បូរបាច់" },
    { "id": 6663, "word": "បូព៌" },
    { "id": 6664, "word": "បូព៌ទិស" },
    { "id": 6665, "word": "បូព៌និមិត្ត" },
    { "id": 6666, "word": "បូរាណ" },
    { "id": 6667, "word": "បូល" },
    { "id": 6668, "word": "បូស" },
    { "id": 6669, "word": "បួ" },
    { "id": 6670, "word": "បួង" },
    { "id": 6671, "word": "បួងសួង" },
    { "id": 6672, "word": "បួន" },
    { "id": 6673, "word": "បួរ" },
    { "id": 6674, "word": "បួល" },
    { "id": 6675, "word": "បួស" },
    { "id": 6676, "word": "បើ" },
    { "id": 6677, "word": "បើក" },
    { "id": 6678, "word": "បឿន" },
    { "id": 6679, "word": "បៀ" },
    { "id": 6680, "word": "បៀក" },
    { "id": 6681, "word": "បៀត" },
    { "id": 6682, "word": "បៀត!" },
    { "id": 6683, "word": "បៀតបៀន" },
    { "id": 6684, "word": "បៀតសៀត" },
    { "id": 6685, "word": "បៀម" },
    { "id": 6686, "word": "បៀរ" },
    { "id": 6687, "word": "បៀលៀង" },
    { "id": 6688, "word": "បៀវត្ស" },
    { "id": 6689, "word": "បេង" },
    { "id": 6690, "word": "បេតុង" },
    { "id": 6691, "word": "បេះ" },
    { "id": 6692, "word": "បេះបិទ" },
    { "id": 6693, "word": "បេះបួយ" },
    { "id": 6694, "word": "បែក" },
    { "id": 6695, "word": "បែកបាយ" },
    { "id": 6696, "word": "បែង" },
    { "id": 6697, "word": "បែន" },
    { "id": 6698, "word": "បែប" },
    { "id": 6699, "word": "បែរ" },
    { "id": 6700, "word": "បៃដីកា" },
    { "id": 6701, "word": "បៃតង" },
    { "id": 6702, "word": "បៃមន់" },
    { "id": 6703, "word": "បៃរកា" },
    { "id": 6704, "word": "បោក" },
    { "id": 6705, "word": "បោកបោះ" },
    { "id": 6706, "word": "បោក្ខរណី" },
    { "id": 6707, "word": "បោក្ខរព័ស៌" },
    { "id": 6708, "word": "បោង" },
    { "id": 6709, "word": "បោច" },
    { "id": 6710, "word": "បោប" },
    { "id": 6711, "word": "បោយ" },
    { "id": 6712, "word": "បោយបក់" },
    { "id": 6713, "word": "បោរ" },
    { "id": 6714, "word": "បោរមុខ" },
    { "id": 6715, "word": "បោល" },
    { "id": 6716, "word": "បោស" },
    { "id": 6717, "word": "បោសលាន" },
    { "id": 6718, "word": "បោះ" },
    { "id": 6719, "word": "បោះបង់" },
    { "id": 6720, "word": "បោះបោក" },
    { "id": 6721, "word": "បោះពួយ" },
    { "id": 6722, "word": "បោះសោក" },
    { "id": 6723, "word": "បៅ" },
    { "id": 6724, "word": "បំណង" },
    { "id": 6725, "word": "បំណន់" },
    { "id": 6726, "word": "បំណាក់" },
    { "id": 6727, "word": "បំណាច់" },
    { "id": 6728, "word": "បំណាច់នឹង" },
    { "id": 6729, "word": "បំណុល" },
    { "id": 6730, "word": "បំណែ" },
    { "id": 6731, "word": "បំណែក" },
    { "id": 6732, "word": "បំណែកល្ង" },
    { "id": 6733, "word": "បំណាំ" },
    { "id": 6734, "word": "បំណះ" },
    { "id": 6735, "word": "បំបង់" },
    { "id": 6736, "word": "បំបត់" },
    { "id": 6737, "word": "បំបប" },
    { "id": 6738, "word": "បំបរ" },
    { "id": 6739, "word": "បំបរបង់" },
    { "id": 6740, "word": "បំបាក់" },
    { "id": 6741, "word": "បំបាត់" },
    { "id": 6742, "word": "បំបាន" },
    { "id": 6743, "word": "បំបិទ" },
    { "id": 6744, "word": "បំបួស" },
    { "id": 6745, "word": "បំបៀត" },
    { "id": 6746, "word": "បំបែក" },
    { "id": 6747, "word": "បំបែន" },
    { "id": 6748, "word": "បំបែរ" },
    { "id": 6749, "word": "បំបោរ" },
    { "id": 6750, "word": "បំបោល" },
    { "id": 6751, "word": "បំបៅ" },
    { "id": 6752, "word": "បំបាំង" },
    { "id": 6753, "word": "បំបះ" },
    { "id": 6754, "word": "បំប៉ន" },
    { "id": 6755, "word": "បំប៉ាន់" },
    { "id": 6756, "word": "បំប៉ឹម" },
    { "id": 6757, "word": "បំប៉ោង" },
    { "id": 6758, "word": "បំប៉ះ" },
    { "id": 6759, "word": "បំប្រួម" },
    { "id": 6760, "word": "បំប្លេង" },
    { "id": 6761, "word": "បំប្លែង" },
    { "id": 6762, "word": "បំប្លោង" },
    { "id": 6763, "word": "បំផត" },
    { "id": 6764, "word": "បំផាយ" },
    { "id": 6765, "word": "បំផឹក" },
    { "id": 6766, "word": "បំផុង" },
    { "id": 6767, "word": "បំផុត" },
    { "id": 6768, "word": "បំផុយ" },
    { "id": 6769, "word": "បំផុល" },
    { "id": 6770, "word": "បំផុស" },
    { "id": 6771, "word": "បំផូរ" },
    { "id": 6772, "word": "បំផើម" },
    { "id": 6773, "word": "បំផ្លាង" },
    { "id": 6774, "word": "បំផ្លាញ" },
    { "id": 6775, "word": "បំផ្លិច" },
    { "id": 6776, "word": "បំផ្លើស" },
    { "id": 6777, "word": "បំពក់" },
    { "id": 6778, "word": "បំពង" },
    { "id": 6779, "word": "បំពង់" },
    { "id": 6780, "word": "បំពង់ក" },
    { "id": 6781, "word": "បំពង់ករឿង" },
    { "id": 6782, "word": "បំពត់" },
    { "id": 6783, "word": "បំព័ទ្ធ" },
    { "id": 6784, "word": "បំពម" },
    { "id": 6785, "word": "បំពាក់" },
    { "id": 6786, "word": "បំពាន" },
    { "id": 6787, "word": "បំពារ" },
    { "id": 6788, "word": "បំពុល" },
    { "id": 6789, "word": "បំពួន" },
    { "id": 6790, "word": "បំពួនស្ករ" },
    { "id": 6791, "word": "បំពើង" },
    { "id": 6792, "word": "បំពើត" },
    { "id": 6793, "word": "បំពៀច" },
    { "id": 6794, "word": "បំពេ" },
    { "id": 6795, "word": "បំពេញ" },
    { "id": 6796, "word": "បំពេញរាជ្យ" },
    { "id": 6797, "word": "បំពេន" },
    { "id": 6798, "word": "បំពោក" },
    { "id": 6799, "word": "បំពោត" },
    { "id": 6800, "word": "បំពោប" },
    { "id": 6801, "word": "បំពោរ" },
    { "id": 6802, "word": "បំពាំ" },
    { "id": 6803, "word": "បំពាំង" },
    { "id": 6804, "word": "បំព្រង" },
    { "id": 6805, "word": "បំព្រាង" },
    { "id": 6806, "word": "បំព្រាច" },
    { "id": 6807, "word": "បំព្រាត់" },
    { "id": 6808, "word": "បំព្រុល" },
    { "id": 6809, "word": "បំព្រួម" },
    { "id": 6810, "word": "បំព្រៃ" },
    { "id": 6811, "word": "បំព្រំ" },
    { "id": 6812, "word": "បំភ័ន្ត" },
    { "id": 6813, "word": "បំភ័យ" },
    { "id": 6814, "word": "បំភល" },
    { "id": 6815, "word": "បំភាន់" },
    { "id": 6816, "word": "បំភិត" },
    { "id": 6817, "word": "បំភ្លាង" },
    { "id": 6818, "word": "បំភ្លាត់" },
    { "id": 6819, "word": "បំភ្លឺ" },
    { "id": 6820, "word": "បំភ្លូក" },
    { "id": 6821, "word": "បំភ្លេច" },
    { "id": 6822, "word": "បំភ្លៃ" },
    { "id": 6823, "word": "បំភ្លាំង" },
    { "id": 6824, "word": "បាំង" },
    { "id": 6825, "word": "បាំងខែល" },
    { "id": 6826, "word": "បាំងខ្លែង" },
    { "id": 6827, "word": "បាំងឆត្រ" },
    { "id": 6828, "word": "បាំងភក់" },
    { "id": 6829, "word": "បាំងសាច" },
    { "id": 6830, "word": "បាំងសែង" },
    { "id": 6831, "word": "បាំងស្ទើរ" },
    { "id": 6832, "word": "បះ" },
    { "id": 6833, "word": "ប៉" },
    { "id": 6834, "word": "ប៉ក" },
    { "id": 6835, "word": "ប៉ក់" },
    { "id": 6836, "word": "បកតិ" },
    { "id": 6837, "word": "បកតិទិន" },
    { "id": 6838, "word": "បកតិនាម" },
    { "id": 6839, "word": "បកតិភាព" },
    { "id": 6840, "word": "បកតិសំខ្យា" },
    { "id": 6841, "word": "ប៉័កប៉ៅ" },
    { "id": 6842, "word": "បការៈ" },
    { "id": 6843, "word": "បកិណ្ណក" },
    { "id": 6844, "word": "បកោដិ" },
    { "id": 6845, "word": "បក្ខ" },
    { "id": 6846, "word": "បក្ខគណនា" },
    { "id": 6847, "word": "បក្ខព័ន្ធ" },
    { "id": 6848, "word": "បក្ខសម្ព័ន្ធ" },
    { "id": 6849, "word": "បក្ស" },
    { "id": 6850, "word": "ប៉ង" },
    { "id": 6851, "word": "ប៉័ង" },
    { "id": 6852, "word": "ប៉ច" },
    { "id": 6853, "word": "បច្ចន្តគ្រាម" },
    { "id": 6854, "word": "បច្ចន្តជនបទ" },
    { "id": 6855, "word": "បច្ចន្តប្រទេស" },
    { "id": 6856, "word": "បច្ច័យ" },
    { "id": 6857, "word": "បច្ចយសន្និស្សិតសីល" },
    { "id": 6858, "word": "បច្ចវេក្ខណៈ" },
    { "id": 6859, "word": "បច្ចវេក្ខណញ្ញាណ" },
    { "id": 6860, "word": "បច្ចាមិត្ត" },
    { "id": 6861, "word": "បច្ចុប្បន្ន" },
    { "id": 6862, "word": "បច្ចុប្បន្នកាល" },
    { "id": 6863, "word": "បច្ចូស" },
    { "id": 6864, "word": "បច្ចូសកាល" },
    { "id": 6865, "word": "បច្ចេកៈ" },
    { "id": 6866, "word": "បច្ចេកទេស" },
    { "id": 6867, "word": "បច្ចេកពុទ្ធ" },
    { "id": 6868, "word": "បច្ចេកពោធិ" },
    { "id": 6869, "word": "បច្ចេកវិជ្ជា" },
    { "id": 6870, "word": "បច្ឆាចារ្យ" },
    { "id": 6871, "word": "បច្ឆាបរិចារកិច្ច" },
    { "id": 6872, "word": "បច្ឆាភត្ត" },
    { "id": 6873, "word": "បច្ឆាភត្តកាល" },
    { "id": 6874, "word": "បច្ឆាភត្តកិច្ច" },
    { "id": 6875, "word": "បច្ឆាសមណៈ" },
    { "id": 6876, "word": "បច្ឆិម" },
    { "id": 6877, "word": "បច្ឆិមទិស" },
    { "id": 6878, "word": "បច្ឆិមានុទិស" },
    { "id": 6879, "word": "បញ្ច" },
    { "id": 6880, "word": "បញ្ចកាមគុណ" },
    { "id": 6881, "word": "បញ្ចក្ខន្ធ" },
    { "id": 6882, "word": "បញ្ចទេព" },
    { "id": 6883, "word": "បញ្ចពិធ" },
    { "id": 6884, "word": "បញ្ចពិធកល្យាណី" },
    { "id": 6885, "word": "បញ្ចសាខា" },
    { "id": 6886, "word": "បញ្ចសីល" },
    { "id": 6887, "word": "បញ្ញវន្ត" },
    { "id": 6888, "word": "បញ្ញា" },
    { "id": 6889, "word": "បញ្ញាណ" },
    { "id": 6890, "word": "បញ្ញានុរូប" },
    { "id": 6891, "word": "បញ្ញាបារមី" },
    { "id": 6892, "word": "បដា" },
    { "id": 6893, "word": "បដិកម្ម" },
    { "id": 6894, "word": "បដិការ" },
    { "id": 6895, "word": "បដិកិរិយា" },
    { "id": 6896, "word": "បដិកូល" },
    { "id": 6897, "word": "បដិកូលសញ្ញា" },
    { "id": 6898, "word": "បដិគ្គាហក" },
    { "id": 6899, "word": "បដិឃៈ" },
    { "id": 6900, "word": "បដិច្ចសមុប្បាទ" },
    { "id": 6901, "word": "បដិញ្ញា" },
    { "id": 6902, "word": "បដិទាន" },
    { "id": 6903, "word": "បដិទិន" },
    { "id": 6904, "word": "បដិបក្ខ" },
    { "id": 6905, "word": "បដិបត្តិ" },
    { "id": 6906, "word": "បដិបទា" },
    { "id": 6907, "word": "បដិភាគ" },
    { "id": 6908, "word": "បដិភាណ" },
    { "id": 6909, "word": "បដិភូ" },
    { "id": 6910, "word": "បដិមា" },
    { "id": 6911, "word": "បដិមាករ" },
    { "id": 6912, "word": "បដិលាភ" },
    { "id": 6913, "word": "បដិលោម" },
    { "id": 6914, "word": "បដិវត្ត" },
    { "id": 6915, "word": "បដិវត្តន៍" },
    { "id": 6916, "word": "បដិសណ្ឋារៈ" },
    { "id": 6917, "word": "បដិសណ្ឋារកិច្ច" },
    { "id": 6918, "word": "បដិសន្ធិ" },
    { "id": 6919, "word": "បដិសម្ភិទា" },
    { "id": 6920, "word": "បដិសរណដ្ឋាន" },
    { "id": 6921, "word": "បដិសេធ" },
    { "id": 6922, "word": "បឋម" },
    { "id": 6923, "word": "បឋមត្រាស់" },
    { "id": 6924, "word": "បឋមាសាឍ" },
    { "id": 6925, "word": "បឋវី" },
    { "id": 6926, "word": "បឋវីកសិណ" },
    { "id": 6927, "word": "បឋវីធាតុ" },
    { "id": 6928, "word": "បណីត" },
    { "id": 6929, "word": "បណីតភាព" },
    { "id": 6930, "word": "បណីតាហារ" },
    { "id": 6931, "word": "បណ្ណាគារ" },
    { "id": 6932, "word": "បណ្ណាគារិក" },
    { "id": 6933, "word": "បណ្ណាធិការ" },
    { "id": 6934, "word": "បណ្ណារក្ខ" },
    { "id": 6935, "word": "បណ្ណាល័យ" },
    { "id": 6936, "word": "បតនី" },
    { "id": 6937, "word": "បត្តបិណ្ឌិកង្គៈ" },
    { "id": 6938, "word": "បត្តានុមោទនាមយៈ" },
    { "id": 6939, "word": "បត្តិទានមយៈ" },
    { "id": 6940, "word": "បទដ្ឋាន" },
    { "id": 6941, "word": "បទានុក្រម" },
    { "id": 6942, "word": "បទុម" },
    { "id": 6943, "word": "បទុមរាគ" },
    { "id": 6944, "word": "បទេស" },
    { "id": 6945, "word": "បទេសប្បញ្ញត្តិ" },
    { "id": 6946, "word": "បទេសរាជ" },
    { "id": 6947, "word": "បធាន" },
    { "id": 6948, "word": "បធានាធិបតី" },
    { "id": 6949, "word": "បធានានុយោគ" },
    { "id": 6950, "word": "ប៉ន់" },
    { "id": 6951, "word": "ប៉ប់" },
    { "id": 6952, "word": "ប៉ប៉ក" },
    { "id": 6953, "word": "ប៉ប៉ប់" },
    { "id": 6954, "word": "ប៉ប៉ាក់ប៉ប៉ើក" },
    { "id": 6955, "word": "ប៉ប៉ាច់" },
    { "id": 6956, "word": "ប៉ប៉ាច់ប៉ប៉ោច" },
    { "id": 6957, "word": "ប៉ប៉ិកប៉ប៉ាក់" },
    { "id": 6958, "word": "ប៉ប៉ិច" },
    { "id": 6959, "word": "ប៉ប៉ិនប៉ប៉ាន់" },
    { "id": 6960, "word": "ប៉ប៉ិល" },
    { "id": 6961, "word": "ប៉ប៉ិលប៉ប៉ូច" },
    { "id": 6962, "word": "ប៉ប៉ុក" },
    { "id": 6963, "word": "ប៉ប៉ុប" },
    { "id": 6964, "word": "ប៉ប៉ែះ" },
    { "id": 6965, "word": "ប៉ប៉ោច" },
    { "id": 6966, "word": "ប៉ប៉ៅ" },
    { "id": 6967, "word": "ប៉ប៉ះ" },
    { "id": 6968, "word": "ប៉ប៉ះប៉ប៉ុន" },
    { "id": 6969, "word": "ប៉ប្រក" },
    { "id": 6970, "word": "ប៉ប្រង" },
    { "id": 6971, "word": "ប៉ប្រច" },
    { "id": 6972, "word": "ប៉ប្រស" },
    { "id": 6973, "word": "ប៉ប្រាច់" },
    { "id": 6974, "word": "ប៉ប្រាវ" },
    { "id": 6975, "word": "ប៉ប្រិច" },
    { "id": 6976, "word": "ប៉ប្រិញ" },
    { "id": 6977, "word": "ប៉ប្រិម" },
    { "id": 6978, "word": "ប៉ប្រិល" },
    { "id": 6979, "word": "ប៉ប្រឹស" },
    { "id": 6980, "word": "ប៉ប្រុក" },
    { "id": 6981, "word": "ប៉ប្រុន" },
    { "id": 6982, "word": "ប៉ប្រុយ" },
    { "id": 6983, "word": "ប៉ប្រូង" },
    { "id": 6984, "word": "ប៉ប្រូច" },
    { "id": 6985, "word": "ប៉ប្រូស" },
    { "id": 6986, "word": "ប៉ប្រើស" },
    { "id": 6987, "word": "ប៉ប្រេញ" },
    { "id": 6988, "word": "ប៉ប្រេវ" },
    { "id": 6989, "word": "ប៉ប្រេះ" },
    { "id": 6990, "word": "ប៉ប្រែក" },
    { "id": 6991, "word": "ប៉ប្រែះ" },
    { "id": 6992, "word": "ប៉ប្រៃ" },
    { "id": 6993, "word": "ប៉ប្រោក" },
    { "id": 6994, "word": "ប៉ប្រះ" },
    { "id": 6995, "word": "ប៉ប្លក់" },
    { "id": 6996, "word": "ប៉ប្លាក់" },
    { "id": 6997, "word": "ប៉ប្លាច់" },
    { "id": 6998, "word": "ប៉ប្លាញ" },
    { "id": 6999, "word": "ប៉ប្លិក" },
    { "id": 7000, "word": "ប៉ប្លិច" },
    { "id": 7001, "word": "ប៉ប្លឹក" },
    { "id": 7002, "word": "ប៉ប្លឺម" },
    { "id": 7003, "word": "ប៉ប្លុង" },
    { "id": 7004, "word": "ប៉ប្លូក" },
    { "id": 7005, "word": "ប៉ប្លូច" },
    { "id": 7006, "word": "ប៉ប្លើក" },
    { "id": 7007, "word": "ប៉ប្លេចប៉ប្លូច" },
    { "id": 7008, "word": "ប៉ប្លេះប៉ប្លោះ" },
    { "id": 7009, "word": "ប៉ប្លោញ" },
    { "id": 7010, "word": "ប៉ប្លោត" },
    { "id": 7011, "word": "ប៉ផង់" },
    { "id": 7012, "word": "ប៉ផស" },
    { "id": 7013, "word": "ប៉ផាង" },
    { "id": 7014, "word": "ប៉ផាប់" },
    { "id": 7015, "word": "ប៉ផុក" },
    { "id": 7016, "word": "ប៉ផុត" },
    { "id": 7017, "word": "ប៉ផូង" },
    { "id": 7018, "word": "ប៉ផូរ" },
    { "id": 7019, "word": "ប៉ផូស" },
    { "id": 7020, "word": "ប៉ផែត" },
    { "id": 7021, "word": "ប៉ផ្ងាក់" },
    { "id": 7022, "word": "ប៉ផ្ងើក" },
    { "id": 7023, "word": "ប៉ផ្ចប់" },
    { "id": 7024, "word": "ប៉ផ្ញាច់" },
    { "id": 7025, "word": "ប៉ផ្ញាញ" },
    { "id": 7026, "word": "ប៉ផ្ញោញ" },
    { "id": 7027, "word": "ប៉ផ្តក់" },
    { "id": 7028, "word": "ប៉ផ្តឺត" },
    { "id": 7029, "word": "ប៉ផ្តៀច" },
    { "id": 7030, "word": "ប៉ផ្តិតប៉ផ្តូង" },
    { "id": 7031, "word": "ប៉ផ្អាក់ប៉ផ្អើក" },
    { "id": 7032, "word": "ប៉ផ្អឹះ" },
    { "id": 7033, "word": "ប៉ផ្អឹប" },
    { "id": 7034, "word": "ប៉ផ្អុក" },
    { "id": 7035, "word": "ប៉ផ្អូក" },
    { "id": 7036, "word": "ប៉ផ្អូច" },
    { "id": 7037, "word": "ប៉ផ្អួស" },
    { "id": 7038, "word": "ប៉ផ្អៀច" },
    { "id": 7039, "word": "ប៉ផ្អេះ" },
    { "id": 7040, "word": "ប៉ផ្អែប" },
    { "id": 7041, "word": "ប៉ពូ" },
    { "id": 7042, "word": "ប៉ម" },
    { "id": 7043, "word": "ប៉យ" },
    { "id": 7044, "word": "បយ្យកៈ" },
    { "id": 7045, "word": "បរទារកម្ម" },
    { "id": 7046, "word": "បរមាណូ" },
    { "id": 7047, "word": "បរមាភិធេយ្យ" },
    { "id": 7048, "word": "បរមាភិសម្ពោធិ" },
    { "id": 7049, "word": "បរមាភិសេក" },
    { "id": 7050, "word": "បរមិន្ទ" },
    { "id": 7051, "word": "បរមេស្ឋ" },
    { "id": 7052, "word": "បរមេស្វរៈ" },
    { "id": 7053, "word": "បរមោវាទ" },
    { "id": 7054, "word": "បរា" },
    { "id": 7055, "word": "បរាជ័យ" },
    { "id": 7056, "word": "បរាធីន" },
    { "id": 7057, "word": "បរាភព" },
    { "id": 7058, "word": "បរាមុខ" },
    { "id": 7059, "word": "បរិចារិកា" },
    { "id": 7060, "word": "បរិជន" },
    { "id": 7061, "word": "បរិញ្ញាបត្រ" },
    { "id": 7062, "word": "បរិត្ត" },
    { "id": 7063, "word": "បរិនាយក" },
    { "id": 7064, "word": "បរិមណ្ឌល" },
    { "id": 7065, "word": "បរិមាណ" },
    { "id": 7066, "word": "បរិយត្តិ" },
    { "id": 7067, "word": "បរិយាកាស" },
    { "id": 7068, "word": "បរិយោសាន" },
    { "id": 7069, "word": "បរិវច្ឆនដ្ឋាន" },
    { "id": 7070, "word": "បរិវិតក្ក" },
    { "id": 7071, "word": "ប៉រួត" },
    { "id": 7072, "word": "បរេ" },
    { "id": 7073, "word": "បរោ" },
    { "id": 7074, "word": "បល្ល័ង្ក" },
    { "id": 7075, "word": "បវត្តិ" },
    { "id": 7076, "word": "បវារណា" },
    { "id": 7077, "word": "បវេណី" },
    { "id": 7078, "word": "បវេសនកាល" },
    { "id": 7079, "word": "បសុពេទ្យ" },
    { "id": 7080, "word": "បសុព្យាបាល" },
    { "id": 7081, "word": "បសុសត្វ" },
    { "id": 7082, "word": "បសាទ" },
    { "id": 7083, "word": "បសំសា" },
    { "id": 7084, "word": "បស្សាវៈ" },
    { "id": 7085, "word": "បស្សាវមគ្គ" },
    { "id": 7086, "word": "បស្សាសៈ" },
    { "id": 7087, "word": "ប៉ាក់" },
    { "id": 7088, "word": "ប៉ាកកា" },
    { "id": 7089, "word": "ប៉ាកកៃ" },
    { "id": 7090, "word": "ប៉ាកណាម" },
    { "id": 7091, "word": "ប៉ាក់ថៅ" },
    { "id": 7092, "word": "ប៉ាក់ប៉ើក" },
    { "id": 7093, "word": "ប៉ាក់ប៉ៅ" },
    { "id": 7094, "word": "ប៉ាច់" },
    { "id": 7095, "word": "ប៉ាចរហាច" },
    { "id": 7096, "word": "បាចិត្តិយៈ" },
    { "id": 7097, "word": "ប៉ាឆា" },
    { "id": 7098, "word": "បាដិទេសនីយ" },
    { "id": 7099, "word": "បាដិបុគ្គលិក" },
    { "id": 7100, "word": "បាដិភោគ" },
    { "id": 7101, "word": "បាដិមោក្ខ" },
    { "id": 7102, "word": "បាដិហារិយ៍" },
    { "id": 7103, "word": "បាដិហារ្យ" },
    { "id": 7104, "word": "បាឋ" },
    { "id": 7105, "word": "បាឋកៈ" },
    { "id": 7106, "word": "បាឋកថា" },
    { "id": 7107, "word": "បាឋិកា" },
    { "id": 7108, "word": "បាណៈ" },
    { "id": 7109, "word": "បាណាតិបាត" },
    { "id": 7110, "word": "ប៉ាត" },
    { "id": 7111, "word": "បាតរាស" },
    { "id": 7112, "word": "ប៉ាតឡាត" },
    { "id": 7113, "word": "ប៉ាត់" },
    { "id": 7114, "word": "ប៉ាត់រញ៉ាត់" },
    { "id": 7115, "word": "បាតិមោក្ខ" },
    { "id": 7116, "word": "បាតុកម្ម" },
    { "id": 7117, "word": "បាតុភូត" },
    { "id": 7118, "word": "ប៉ាន" },
    { "id": 7119, "word": "ប៉ាន់" },
    { "id": 7120, "word": "បានីយ" },
    { "id": 7121, "word": "ប៉ាប់" },
    { "id": 7122, "word": "បាមោក្ខ" },
    { "id": 7123, "word": "បាមោជ្ជ" },
    { "id": 7124, "word": "ប៉ាយ" },
    { "id": 7125, "word": "ប៉ាយហួយ" },
    { "id": 7126, "word": "បារាជិក" },
    { "id": 7127, "word": "ប៉ាវ" },
    { "id": 7128, "word": "ប៉ាវគង" },
    { "id": 7129, "word": "បាវចនៈ" },
    { "id": 7130, "word": "បាសាទិកសមាជិក" },
    { "id": 7131, "word": "បាហុនកៈ" },
    { "id": 7132, "word": "បាហុនកដ្ឋាន" },
    { "id": 7133, "word": "ប៉ាហាំង" },
    { "id": 7134, "word": "ប៉ិក" },
    { "id": 7135, "word": "ប៉ិកួៈ" },
    { "id": 7136, "word": "ប៉ិច" },
    { "id": 7137, "word": "បិដ្ឋ្យដ្ឋិកសត្វ" },
    { "id": 7138, "word": "ប៉ិត" },
    { "id": 7139, "word": "ប៉ិតប៉ុត" },
    { "id": 7140, "word": "បិតុគុណ" },
    { "id": 7141, "word": "បិតុឃាត" },
    { "id": 7142, "word": "បិតុឃាតកៈ" },
    { "id": 7143, "word": "បិតុឃាតិកា" },
    { "id": 7144, "word": "បិតុច្ឆា" },
    { "id": 7145, "word": "បិតុលៈ" },
    { "id": 7146, "word": "បិតុលានី" },
    { "id": 7147, "word": "ប៉ិន" },
    { "id": 7148, "word": "ប៉ិនប៉ាន់" },
    { "id": 7149, "word": "ប៉ិល" },
    { "id": 7150, "word": "ប៉ី" },
    { "id": 7151, "word": "បីតិ" },
    { "id": 7152, "word": "ប៉ឹង" },
    { "id": 7153, "word": "ប៉ឹម" },
    { "id": 7154, "word": "ប៉ឺង" },
    { "id": 7155, "word": "ប៉ឺតប៉ោង" },
    { "id": 7156, "word": "ប៉ឺន" },
    { "id": 7157, "word": "ប៉ឺប" },
    { "id": 7158, "word": "ប៉ឺម" },
    { "id": 7159, "word": "ប៉ុក" },
    { "id": 7160, "word": "ប៉ុកៗ" },
    { "id": 7161, "word": "ប៉ុកចាយ" },
    { "id": 7162, "word": "ប៉ុកប៉ឺន" },
    { "id": 7163, "word": "ប៉ុកពើក" },
    { "id": 7164, "word": "ប៉ុង" },
    { "id": 7165, "word": "ប៉ុង" },
    { "id": 7166, "word": "បុច្ឆនសញ្ញា" },
    { "id": 7167, "word": "បុច្ឆា" },
    { "id": 7168, "word": "ប៉ុណ្ណឹង" },
    { "id": 7169, "word": "ប៉ុណ្ណេះ" },
    { "id": 7170, "word": "ប៉ុណ្ណោះ" },
    { "id": 7171, "word": "បុត្តា" },
    { "id": 7172, "word": "បុថុជ្ជន" },
    { "id": 7173, "word": "ប៉ុន" },
    { "id": 7174, "word": "បុនប្បុនក្កម្ម" },
    { "id": 7175, "word": "បុនប្បុនក្ការ" },
    { "id": 7176, "word": "ប៉ុនអម្បាល" },
    { "id": 7177, "word": "ប៉ុន្តែ" },
    { "id": 7178, "word": "ប៉ុន្មាន" },
    { "id": 7179, "word": "ប៉ុប" },
    { "id": 7180, "word": "ប៉ុយ" },
    { "id": 7181, "word": "បុរត្ថិមទិស" },
    { "id": 7182, "word": "បុរត្ថិមានុទិស" },
    { "id": 7183, "word": "បុរេភត្ត" },
    { "id": 7184, "word": "បុរេភត្តកាល" },
    { "id": 7185, "word": "បុរេភត្តកិច្ច" },
    { "id": 7186, "word": "ប៉ុស្តិ៍" },
    { "id": 7187, "word": "ប៉ូកៗ" },
    { "id": 7188, "word": "ប៉ូង" },
    { "id": 7189, "word": "ប៉ូច" },
    { "id": 7190, "word": "បូតិកាយ" },
    { "id": 7191, "word": "បូតិលតា" },
    { "id": 7192, "word": "បូរណភាព" },
    { "id": 7193, "word": "បូរណសំខ្យា" },
    { "id": 7194, "word": "ប៉ូលិស" },
    { "id": 7195, "word": "ប៉ូវ" },
    { "id": 7196, "word": "បូវដ្ឋាន" },
    { "id": 7197, "word": "ប៉ូវថៅ" },
    { "id": 7198, "word": "ប៉ើកៗ" },
    { "id": 7199, "word": "ប៉ើង" },
    { "id": 7200, "word": "ប៉ើងរ៉ើង" },
    { "id": 7201, "word": "ប៉ើច" },
    { "id": 7202, "word": "ប៉ើម" },
    { "id": 7203, "word": "បេក្ខជន" },
    { "id": 7204, "word": "ប៉េង" },
    { "id": 7205, "word": "ប៉េងប៉ោះ" },
    { "id": 7206, "word": "បេតិកភណ្ឌ" },
    { "id": 7207, "word": "បេតី" },
    { "id": 7208, "word": "បេយ្យាលៈ" },
    { "id": 7209, "word": "ប៉េលប៉ាល" },
    { "id": 7210, "word": "ប៉េវ" },
    { "id": 7211, "word": "បេសកកម្ម" },
    { "id": 7212, "word": "បេសកជន" },
    { "id": 7213, "word": "បេឡា" },
    { "id": 7214, "word": "ប៉ែ" },
    { "id": 7215, "word": "ប៉ែក" },
    { "id": 7216, "word": "ប៉ែង" },
    { "id": 7217, "word": "ប៉ែតតារាង" },
    { "id": 7218, "word": "ប៉ែតសិប" },
    { "id": 7219, "word": "ប៉ែន" },
    { "id": 7220, "word": "ប៉ែល" },
    { "id": 7221, "word": "ប៉ែះ" },
    { "id": 7222, "word": "ប៉ៃ" },
    { "id": 7223, "word": "ប៉ៃ!" },
    { "id": 7224, "word": "ប៉ៃលិន" },
    { "id": 7225, "word": "បៃសាចី" },
    { "id": 7226, "word": "ប៉ៃឡាំ" },
    { "id": 7227, "word": "ប៉ោ" },
    { "id": 7228, "word": "ប៉ោក" },
    { "id": 7229, "word": "ប៉ោង" },
    { "id": 7230, "word": "ប៉ោចៗ" },
    { "id": 7231, "word": "ប៉ោត" },
    { "id": 7232, "word": "ប៉ោម" },
    { "id": 7233, "word": "ប៉ោយ" },
    { "id": 7234, "word": "បោរាណា" },
    { "id": 7235, "word": "បោរាណានុបោរាណ" },
    { "id": 7236, "word": "បោរីភាសា" },
    { "id": 7237, "word": "ប៉ោល" },
    { "id": 7238, "word": "ប៉ោលតោក" },
    { "id": 7239, "word": "បោសិតព្វកិច្ច" },
    { "id": 7240, "word": "ប៉ោឡែ" },
    { "id": 7241, "word": "ប៉ៅ" },
    { "id": 7242, "word": "បំសុកូលិកង្គៈ" },
    { "id": 7243, "word": "ប៉ះ" },
    { "id": 7244, "word": "ប្ដី" },
    { "id": 7245, "word": "ប្ដឹង" },
    { "id": 7246, "word": "ប្ដូរ" },
    { "id": 7247, "word": "ប្ដេជ្ញា" },
    { "id": 7248, "word": "ប្រក់" },
    { "id": 7249, "word": "ប្រកប" },
    { "id": 7250, "word": "ប្រកបដោយ" },
    { "id": 7251, "word": "ប្រក់ផ្លែ" },
    { "id": 7252, "word": "ប្រក់ពល" },
    { "id": 7253, "word": "ប្រក់ព្រំ" },
    { "id": 7254, "word": "ប្រកល់" },
    { "id": 7255, "word": "ប្រកា" },
    { "id": 7256, "word": "ប្រកាក់" },
    { "id": 7257, "word": "ប្រកាច់" },
    { "id": 7258, "word": "ប្រកាន់" },
    { "id": 7259, "word": "ប្រកាប់" },
    { "id": 7260, "word": "ប្រការ" },
    { "id": 7261, "word": "ប្រកាស" },
    { "id": 7262, "word": "ប្រកាសកៈ" },
    { "id": 7263, "word": "ប្រកាសនីយបត្រ" },
    { "id": 7264, "word": "ប្រកាសិកា" },
    { "id": 7265, "word": "ប្រកាសិត" },
    { "id": 7266, "word": "ប្រកិត" },
    { "id": 7267, "word": "ប្រកឹង" },
    { "id": 7268, "word": "ប្រកុន" },
    { "id": 7269, "word": "ប្រកួត" },
    { "id": 7270, "word": "ប្រកើយ" },
    { "id": 7271, "word": "ប្រកៀក" },
    { "id": 7272, "word": "ប្រកៀង" },
    { "id": 7273, "word": "ប្រកែក" },
    { "id": 7274, "word": "ប្រកៃ" },
    { "id": 7275, "word": "ប្រកោះ" },
    { "id": 7276, "word": "ប្រកុំ" },
    { "id": 7277, "word": "ប្រកាំ" },
    { "id": 7278, "word": "ប្រកាំង" },
    { "id": 7279, "word": "ប្រក្រតិទិន" },
    { "id": 7280, "word": "ប្រក្រតី" },
    { "id": 7281, "word": "ប្រខង" },
    { "id": 7282, "word": "ប្រខុប" },
    { "id": 7283, "word": "ប្រខាំ" },
    { "id": 7284, "word": "ប្រគង" },
    { "id": 7285, "word": "ប្រគរ" },
    { "id": 7286, "word": "ប្រគល់" },
    { "id": 7287, "word": "ប្រគាក់" },
    { "id": 7288, "word": "ប្រគាប" },
    { "id": 7289, "word": "ប្រគេន" },
    { "id": 7290, "word": "ប្រគំ" },
    { "id": 7291, "word": "ប្រគ្រីវ" },
    { "id": 7292, "word": "ប្រង់" },
    { "id": 7293, "word": "ប្រច" },
    { "id": 7294, "word": "ប្រចក្ស" },
    { "id": 7295, "word": "ប្រចច" },
    { "id": 7296, "word": "ប្រចណ្ឌ" },
    { "id": 7297, "word": "ប្រចាក់" },
    { "id": 7298, "word": "ប្រចាប់" },
    { "id": 7299, "word": "ប្រចិត្ត" },
    { "id": 7300, "word": "ប្រចី" },
    { "id": 7301, "word": "ប្រចឹក" },
    { "id": 7302, "word": "ប្រចុប" },
    { "id": 7303, "word": "ប្រចួន" },
    { "id": 7304, "word": "ប្រចួប" },
    { "id": 7305, "word": "ប្រចៀច" },
    { "id": 7306, "word": "ប្រចៀវ" },
    { "id": 7307, "word": "ប្រចែ" },
    { "id": 7308, "word": "ប្រចែង" },
    { "id": 7309, "word": "ប្រចោម" },
    { "id": 7310, "word": "ប្រចាំ" },
    { "id": 7311, "word": "ប្រឆេះ" },
    { "id": 7312, "word": "ប្រឆាំង" },
    { "id": 7313, "word": "ប្រឆ្ងិត" },
    { "id": 7314, "word": "ប្រជា" },
    { "id": 7315, "word": "ប្រជាន់" },
    { "id": 7316, "word": "ប្រជាប់" },
    { "id": 7317, "word": "ប្រជួន" },
    { "id": 7318, "word": "ប្រជួប" },
    { "id": 7319, "word": "ប្រជួស" },
    { "id": 7320, "word": "ប្រជៀច" },
    { "id": 7321, "word": "ប្រជៀវ" },
    { "id": 7322, "word": "ប្រជែង" },
    { "id": 7323, "word": "ប្រជុំ" },
    { "id": 7324, "word": "ប្រជ្រុយ" },
    { "id": 7325, "word": "ប្រជ្រួស" },
    { "id": 7326, "word": "ប្រជ្រៀត" },
    { "id": 7327, "word": "ប្រឈម" },
    { "id": 7328, "word": "ប្រឈួន" },
    { "id": 7329, "word": "ប្រឈ្លោះ" },
    { "id": 7330, "word": "ប្រញប្ត" },
    { "id": 7331, "word": "ប្រញប្តិ" },
    { "id": 7332, "word": "ប្រញាប់" },
    { "id": 7333, "word": "ប្រញាយ" },
    { "id": 7334, "word": "ប្រញាល់" },
    { "id": 7335, "word": "ប្រញិប" },
    { "id": 7336, "word": "ប្រញឹក" },
    { "id": 7337, "word": "ប្រដក់" },
    { "id": 7338, "word": "ប្រដា" },
    { "id": 7339, "word": "ប្រដាក់" },
    { "id": 7340, "word": "ប្រដាក់ប្រដឺត" },
    { "id": 7341, "word": "ប្រដាក់ប្រទុក្ខ" },
    { "id": 7342, "word": "ប្រដាញ" },
    { "id": 7343, "word": "ប្រដាន់" },
    { "id": 7344, "word": "ប្រដាប់" },
    { "id": 7345, "word": "ប្រដាល់" },
    { "id": 7346, "word": "ប្រដិត" },
    { "id": 7347, "word": "ប្រដិតប្រជី" },
    { "id": 7348, "word": "ប្រដឹស" },
    { "id": 7349, "word": "ប្រដឺត" },
    { "id": 7350, "word": "ប្រដុងប្រជា" },
    { "id": 7351, "word": "ប្រដូច" },
    { "id": 7352, "word": "ប្រដើស" },
    { "id": 7353, "word": "ប្រដេញ" },
    { "id": 7354, "word": "ប្រដែ" },
    { "id": 7355, "word": "ប្រដោត" },
    { "id": 7356, "word": "ប្រដោល" },
    { "id": 7357, "word": "ប្រដៅ" },
    { "id": 7358, "word": "ប្រដំ" },
    { "id": 7359, "word": "ប្រឌិដ្ឋ" },
    { "id": 7360, "word": "ប្រណម" },
    { "id": 7361, "word": "ប្រណម្យ" },
    { "id": 7362, "word": "ប្រណាក" },
    { "id": 7363, "word": "ប្រណាម" },
    { "id": 7364, "word": "ប្រណិងប្រណុង" },
    { "id": 7365, "word": "ប្រណិត" },
    { "id": 7366, "word": "ប្រណិធាន" },
    { "id": 7367, "word": "ប្រណិធិ" },
    { "id": 7368, "word": "ប្រណិប័តន៍" },
    { "id": 7369, "word": "ប្រណី" },
    { "id": 7370, "word": "ប្រណីត" },
    { "id": 7371, "word": "ប្រណីតភាព" },
    { "id": 7372, "word": "ប្រណីតាហារ" },
    { "id": 7373, "word": "ប្រណែងប្រណោង" },
    { "id": 7374, "word": "ប្រណាំង" },
    { "id": 7375, "word": "ប្រតប់" },
    { "id": 7376, "word": "ប្រតាក" },
    { "id": 7377, "word": "ប្រតាប់ប្រញាល់" },
    { "id": 7378, "word": "ប្រតាយ" },
    { "id": 7379, "word": "ប្រតិកម្ម" },
    { "id": 7380, "word": "ប្រតិក្រិយា" },
    { "id": 7381, "word": "ប្រតិដ្ឋ" },
    { "id": 7382, "word": "ប្រតិទិន" },
    { "id": 7383, "word": "ប្រតិបត្តិ" },
    { "id": 7384, "word": "ប្រតិបទា" },
    { "id": 7385, "word": "ប្រតិព័ទ្ធ" },
    { "id": 7386, "word": "ប្រតិពន្ធ" },
    { "id": 7387, "word": "ប្រតិពល" },
    { "id": 7388, "word": "ប្រតិភាគ" },
    { "id": 7389, "word": "ប្រតិភាណ" },
    { "id": 7390, "word": "ប្រតិភូ" },
    { "id": 7391, "word": "ប្រតិមា" },
    { "id": 7392, "word": "ប្រតិមាករ" },
    { "id": 7393, "word": "ប្រតិលាភ" },
    { "id": 7394, "word": "ប្រតិលោម" },
    { "id": 7395, "word": "បតិវេទ" },
    { "id": 7396, "word": "ប្រតិវេទន៍" },
    { "id": 7397, "word": "ប្រតិសន្ធិ" },
    { "id": 7398, "word": "ប្រតិស្ន" },
    { "id": 7399, "word": "ប្រតិស្ឋាន" },
    { "id": 7400, "word": "ប្រតឺងអ៊‌ឹះ" },
    { "id": 7401, "word": "ប្រតេក" },
    { "id": 7402, "word": "ប្រតែង" },
    { "id": 7403, "word": "ប្រតោក" },
    { "id": 7404, "word": "ប្រតោង" },
    { "id": 7405, "word": "ប្រត្យក្ស" },
    { "id": 7406, "word": "ប្រថម" },
    { "id": 7407, "word": "ប្រថមាសាឍ" },
    { "id": 7408, "word": "ប្រថាន" },
    { "id": 7409, "word": "ប្រថាប់" },
    { "id": 7410, "word": "ប្រថុច" },
    { "id": 7411, "word": "ប្រថុជ្ជន" },
    { "id": 7412, "word": "ប្រថុយ" },
    { "id": 7413, "word": "ប្រថួន" },
    { "id": 7414, "word": "ប្រថំ" },
    { "id": 7415, "word": "ប្រទក្សិណ" },
    { "id": 7416, "word": "ប្រទង់" },
    { "id": 7417, "word": "ប្រទល់" },
    { "id": 7418, "word": "ប្រទាក់" },
    { "id": 7419, "word": "ប្រទាញ" },
    { "id": 7420, "word": "ប្រទាន" },
    { "id": 7421, "word": "ប្រទាល" },
    { "id": 7422, "word": "ប្រទាល់" },
    { "id": 7423, "word": "ប្រទាស" },
    { "id": 7424, "word": "ប្រទាស់" },
    { "id": 7425, "word": "ប្រទាស់កាំកី" },
    { "id": 7426, "word": "ប្រទីប" },
    { "id": 7427, "word": "ប្រទុក្ខប្រដាក់" },
    { "id": 7428, "word": "ប្រទូស" },
    { "id": 7429, "word": "ប្រទូសរ៉ាយ" },
    { "id": 7430, "word": "ប្រទើស" },
    { "id": 7431, "word": "ប្រទេច" },
    { "id": 7432, "word": "ប្រទេស" },
    { "id": 7433, "word": "ប្រទោសកាល" },
    { "id": 7434, "word": "ប្រទាំង" },
    { "id": 7435, "word": "ប្រទះ" },
    { "id": 7436, "word": "ប្រធាក់" },
    { "id": 7437, "word": "ប្រធាន" },
    { "id": 7438, "word": "ប្រធានាធិបតី" },
    { "id": 7439, "word": "ប្រធានានុយោគ" },
    { "id": 7440, "word": "ប្រធួន" },
    { "id": 7441, "word": "ប្រនៀល" },
    { "id": 7442, "word": "ប្រប" },
    { "id": 7443, "word": "ប្របិច" },
    { "id": 7444, "word": "ប្របៀត" },
    { "id": 7445, "word": "ប្របេះ" },
    { "id": 7446, "word": "ប្របែក" },
    { "id": 7447, "word": "ប្របែល" },
    { "id": 7448, "word": "ប្របោច" },
    { "id": 7449, "word": "ប្រផង់" },
    { "id": 7450, "word": "ប្រផាត់" },
    { "id": 7451, "word": "ប្រផាប់" },
    { "id": 7452, "word": "ប្រផុត" },
    { "id": 7453, "word": "ប្រផូរ" },
    { "id": 7454, "word": "ប្រផេញ" },
    { "id": 7455, "word": "ប្រផេះ" },
    { "id": 7456, "word": "ប្រផ្នូល" },
    { "id": 7457, "word": "ប្រពន្ធ" },
    { "id": 7458, "word": "ប្រព័ន្ធ" },
    { "id": 7459, "word": "ប្រពាក់" },
    { "id": 7460, "word": "ប្រពាត" },
    { "id": 7461, "word": "ប្រពាន" },
    { "id": 7462, "word": "ប្រពាយ" },
    { "id": 7463, "word": "ប្រពាល" },
    { "id": 7464, "word": "ប្រពាស" },
    { "id": 7465, "word": "ប្រពូន" },
    { "id": 7466, "word": "ប្រពៃ" },
    { "id": 7467, "word": "ប្រពៃណី" },
    { "id": 7468, "word": "ប្រព្រឹត្ត" },
    { "id": 7469, "word": "ប្រព្រឹត្តិ" },
    { "id": 7470, "word": "ប្រភព" },
    { "id": 7471, "word": "ប្រភស្សរ" },
    { "id": 7472, "word": "ប្រភា" },
    { "id": 7473, "word": "ប្រភាករ" },
    { "id": 7474, "word": "ប្រភាត" },
    { "id": 7475, "word": "ប្រភាព" },
    { "id": 7476, "word": "ប្រភាស" },
    { "id": 7477, "word": "ប្រភូ" },
    { "id": 7478, "word": "ប្រភើច" },
    { "id": 7479, "word": "ប្រភេទ" },
    { "id": 7480, "word": "ប្រមង់" },
    { "id": 7481, "word": "ប្រមល់" },
    { "id": 7482, "word": "ប្រមា" },
    { "id": 7483, "word": "ប្រមាញ់" },
    { "id": 7484, "word": "ប្រមាណ" },
    { "id": 7485, "word": "ប្រមាណបត្រ" },
    { "id": 7486, "word": "ប្រមាណបុរស" },
    { "id": 7487, "word": "ប្រមាត់" },
    { "id": 7488, "word": "ប្រមាត់កង្កែប" },
    { "id": 7489, "word": "ប្រមាត់ដី" },
    { "id": 7490, "word": "ប្រមាថ" },
    { "id": 7491, "word": "ប្រមាទ" },
    { "id": 7492, "word": "ប្រមឹក" },
    { "id": 7493, "word": "ប្រមុខ" },
    { "id": 7494, "word": "ប្រមុខរដ្ឋ" },
    { "id": 7495, "word": "ប្រមុខ្យ" },
    { "id": 7496, "word": "ប្រមុច" },
    { "id": 7497, "word": "ប្រមុញ" },
    { "id": 7498, "word": "ប្រមុម" },
    { "id": 7499, "word": "ប្រមូល" },
    { "id": 7500, "word": "ប្រមើល" },
    { "id": 7501, "word": "ប្រមៀល" },
    { "id": 7502, "word": "ប្រមេ" },
    { "id": 7503, "word": "ប្រមេហរោគ" },
    { "id": 7504, "word": "ប្រមេះ" },
    { "id": 7505, "word": "ប្រមែ" },
    { "id": 7506, "word": "ប្រមោក" },
    { "id": 7507, "word": "ប្រមោទ" },
    { "id": 7508, "word": "ប្រមោយ" },
    { "id": 7509, "word": "ប្រមោយដំរី" },
    { "id": 7510, "word": "ប្រមុំ" },
    { "id": 7511, "word": "ប្រយង្គុ" },
    { "id": 7512, "word": "ប្រយ័ត" },
    { "id": 7513, "word": "ប្រយ័ត្ន" },
    { "id": 7514, "word": "ប្រយុទ្ធ" },
    { "id": 7515, "word": "ប្រយូរ" },
    { "id": 7516, "word": "ប្រយែង" },
    { "id": 7517, "word": "ប្រយោគ" },
    { "id": 7518, "word": "ប្រយោគវិបត្តិ" },
    { "id": 7519, "word": "ប្រយោគសម្បត្តិ" },
    { "id": 7520, "word": "ប្រយោជន៍" },
    { "id": 7521, "word": "ប្រយោល" },
    { "id": 7522, "word": "ប្រលង" },
    { "id": 7523, "word": "ប្រលង់" },
    { "id": 7524, "word": "ប្រល័យ" },
    { "id": 7525, "word": "ប្រលូក" },
    { "id": 7526, "word": "ប្រលូញ" },
    { "id": 7527, "word": "ប្រលូស" },
    { "id": 7528, "word": "ប្រលួតលាក់" },
    { "id": 7529, "word": "ប្រលេះ" },
    { "id": 7530, "word": "ប្រលែង" },
    { "id": 7531, "word": "ប្រលោម" },
    { "id": 7532, "word": "ប្រលោមលោក" },
    { "id": 7533, "word": "ប្រលោះ" },
    { "id": 7534, "word": "ប្រលាំប្រកូវ" },
    { "id": 7535, "word": "ប្រវ័ញ្ច" },
    { "id": 7536, "word": "ប្រវ័ញ្ចន៍" },
    { "id": 7537, "word": "ប្រវត្តិ" },
    { "id": 7538, "word": "ប្រវត្តិរូប" },
    { "id": 7539, "word": "ប្រវត្តិសាស្ត្រ" },
    { "id": 7540, "word": "ប្រវត្តិហេតុ" },
    { "id": 7541, "word": "ប្រវា" },
    { "id": 7542, "word": "ប្រវាយ" },
    { "id": 7543, "word": "ប្រវាល" },
    { "id": 7544, "word": "ប្រវាស់" },
    { "id": 7545, "word": "ប្រវិនប្រវាន់" },
    { "id": 7546, "word": "ប្រវឹក" },
    { "id": 7547, "word": "ប្រវេ" },
    { "id": 7548, "word": "ប្រវេណី" },
    { "id": 7549, "word": "ប្រវែង" },
    { "id": 7550, "word": "ប្រស" },
    { "id": 7551, "word": "ប្រស់" },
    { "id": 7552, "word": "ប្រសប់" },
    { "id": 7553, "word": "ប្រសព្វ" },
    { "id": 7554, "word": "ប្រសា" },
    { "id": 7555, "word": "ប្រសាច" },
    { "id": 7556, "word": "ប្រសាទ" },
    { "id": 7557, "word": "ប្រសាទរូប" },
    { "id": 7558, "word": "ប្រសាធន" },
    { "id": 7559, "word": "ប្រសាសន៍" },
    { "id": 7560, "word": "ប្រសិទ្ធ" },
    { "id": 7561, "word": "ប្រសិទ្ធិ៍" },
    { "id": 7562, "word": "ប្រសិទ្ធី" },
    { "id": 7563, "word": "ប្រសិនជា" },
    { "id": 7564, "word": "ប្រសិនណាបើ" },
    { "id": 7565, "word": "ប្រសិនបើ" },
    { "id": 7566, "word": "ប្រសូត" },
    { "id": 7567, "word": "ប្រសូតិ" },
    { "id": 7568, "word": "ប្រសូតិកម្ម" },
    { "id": 7569, "word": "ប្រសូតិកា" },
    { "id": 7570, "word": "ប្រសូតិគ្រឹះ" },
    { "id": 7571, "word": "ប្រសើរ" },
    { "id": 7572, "word": "ប្រសេច" },
    { "id": 7573, "word": "ប្រស្ដែង" },
    { "id": 7574, "word": "ប្រស្នា" },
    { "id": 7575, "word": "ប្រស្និត" },
    { "id": 7576, "word": "ប្រស្រ័យ" },
    { "id": 7577, "word": "ប្រស្រាវៈ" },
    { "id": 7578, "word": "ប្រស្រាវភាជនៈ" },
    { "id": 7579, "word": "ប្រហក" },
    { "id": 7580, "word": "ប្រហាក់" },
    { "id": 7581, "word": "ប្រហាត" },
    { "id": 7582, "word": "ប្រហារ" },
    { "id": 7583, "word": "ប្រហារទាន" },
    { "id": 7584, "word": "ប្រហិត" },
    { "id": 7585, "word": "ប្រហុក" },
    { "id": 7586, "word": "ប្រហួរ" },
    { "id": 7587, "word": "ប្រហើរ" },
    { "id": 7588, "word": "ប្រហេត" },
    { "id": 7589, "word": "ប្រហែក" },
    { "id": 7590, "word": "ប្រហែង" },
    { "id": 7591, "word": "ប្រហែល" },
    { "id": 7592, "word": "ប្រហែស" },
    { "id": 7593, "word": "ប្រហោង" },
    { "id": 7594, "word": "ប្រហាំង" },
    { "id": 7595, "word": "ប្រឡង" },
    { "id": 7596, "word": "ប្រឡង់" },
    { "id": 7597, "word": "ប្រឡាក់" },
    { "id": 7598, "word": "ប្រឡាយ" },
    { "id": 7599, "word": "ប្រឡិងប្រឡាំង" },
    { "id": 7600, "word": "ប្រឡិមប្រឡុំ" },
    { "id": 7601, "word": "ប្រឡុបប៉័ច្ឆា" },
    { "id": 7602, "word": "ប្រឡូក" },
    { "id": 7603, "word": "ប្រឡូញ" },
    { "id": 7604, "word": "ប្រឡូស" },
    { "id": 7605, "word": "ប្រឡេះ" },
    { "id": 7606, "word": "ប្រឡែង" },
    { "id": 7607, "word": "ប្រឡែប្រកោ" },
    { "id": 7608, "word": "ប្រឡៃសក" },
    { "id": 7609, "word": "ប្រឡោះ" },
    { "id": 7610, "word": "ប្រឡៅ" },
    { "id": 7611, "word": "ប្រឡៅពពែ" },
    { "id": 7612, "word": "ប្រឡៅអំពែ" },
    { "id": 7613, "word": "ប្រឡាំងកាស" },
    { "id": 7614, "word": "ប្រឡាំប្រកូវ" },
    { "id": 7615, "word": "ប្រអប់" },
    { "id": 7616, "word": "ប្រអប់ជើង" },
    { "id": 7617, "word": "ប្រអូង" },
    { "id": 7618, "word": "ប្រអូស" },
    { "id": 7619, "word": "ប្រអួល" },
    { "id": 7620, "word": "ប្រឱប" },
    { "id": 7621, "word": "ប្រា" },
    { "id": 7622, "word": "ប្រាអៀវ" },
    { "id": 7623, "word": "ប្រាក" },
    { "id": 7624, "word": "ប្រាក់" },
    { "id": 7625, "word": "ប្រាកដ" },
    { "id": 7626, "word": "ប្រាការ" },
    { "id": 7627, "word": "ប្រាក្រឹត" },
    { "id": 7628, "word": "ប្រាឃាត" },
    { "id": 7629, "word": "ប្រាង្គ" },
    { "id": 7630, "word": "ប្រាង្គណ៍" },
    { "id": 7631, "word": "ប្រាច់" },
    { "id": 7632, "word": "ប្រាចិន" },
    { "id": 7633, "word": "ប្រាជ្ញ" },
    { "id": 7634, "word": "ប្រាជ្ញា" },
    { "id": 7635, "word": "ប្រាណ" },
    { "id": 7636, "word": "ប្រាត់" },
    { "id": 7637, "word": "ប្រាថ្នា" },
    { "id": 7638, "word": "ប្រាប" },
    { "id": 7639, "word": "ប្រាប់" },
    { "id": 7640, "word": "ប្រាប្ត" },
    { "id": 7641, "word": "ប្រាប្ដាភិលាភ" },
    { "id": 7642, "word": "ប្រាប្តាភិសេក" },
    { "id": 7643, "word": "ប្រាម" },
    { "id": 7644, "word": "ប្រាមោទ្យ" },
    { "id": 7645, "word": "ប្រាយ" },
    { "id": 7646, "word": "ប្រាយ" },
    { "id": 7647, "word": "ប្រារព្ធ" },
    { "id": 7648, "word": "ប្រាវ" },
    { "id": 7649, "word": "ប្រាស" },
    { "id": 7650, "word": "ប្រាស់" },
    { "id": 7651, "word": "ប្រាសាទ" },
    { "id": 7652, "word": "ប្រាស្រ័យ" },
    { "id": 7653, "word": "ប្រិច" },
    { "id": 7654, "word": "ប្រិចៗ" },
    { "id": 7655, "word": "ប្រិញៗ" },
    { "id": 7656, "word": "ប្រិត" },
    { "id": 7657, "word": "ប្រិតប្រៀង" },
    { "id": 7658, "word": "ប្រិតប្រៀន" },
    { "id": 7659, "word": "ប្រិតប្រៀប" },
    { "id": 7660, "word": "ប្រិនប្រុន" },
    { "id": 7661, "word": "ប្រិប" },
    { "id": 7662, "word": "ប្រិមប្រិយ" },
    { "id": 7663, "word": "ប្រិយប្រាយ" },
    { "id": 7664, "word": "ប្រិយភាព" },
    { "id": 7665, "word": "ប្រិល" },
    { "id": 7666, "word": "ប្រី" },
    { "id": 7667, "word": "ប្រីជា" },
    { "id": 7668, "word": "ប្រីតា" },
    { "id": 7669, "word": "ប្រឹក្សា" },
    { "id": 7670, "word": "ប្រឹង" },
    { "id": 7671, "word": "ប្រឹថពី" },
    { "id": 7672, "word": "ប្រឹប" },
    { "id": 7673, "word": "ប្រឹស" },
    { "id": 7674, "word": "ប្រឹសៗ" },
    { "id": 7675, "word": "ប្រឹស្ដាង្គ" },
    { "id": 7676, "word": "ប្រឹស្ឋ" },
    { "id": 7677, "word": "ប្រឹស្ឋាង្គ" },
    { "id": 7678, "word": "ប្រឹះៗ" },
    { "id": 7679, "word": "ប្រុង" },
    { "id": 7680, "word": "ប្រុនៗ" },
    { "id": 7681, "word": "ប្រុយ" },
    { "id": 7682, "word": "ប្រុស" },
    { "id": 7683, "word": "ប្រុះ" },
    { "id": 7684, "word": "ប្រូង" },
    { "id": 7685, "word": "ប្រូច" },
    { "id": 7686, "word": "ប្រូស" },
    { "id": 7687, "word": "ប្រួក" },
    { "id": 7688, "word": "ព្រួញ" },
    { "id": 7689, "word": "ប្រួត" },
    { "id": 7690, "word": "ប្រួម" },
    { "id": 7691, "word": "ប្រួល" },
    { "id": 7692, "word": "ប្រើ" },
    { "id": 7693, "word": "ប្រើស" },
    { "id": 7694, "word": "ប្រឿង" },
    { "id": 7695, "word": "ប្រៀច" },
    { "id": 7696, "word": "ប្រៀន" },
    { "id": 7697, "word": "ប្រៀប" },
    { "id": 7698, "word": "ប្រេង" },
    { "id": 7699, "word": "ប្រេត" },
    { "id": 7700, "word": "ប្រេតតិរោក" },
    { "id": 7701, "word": "ប្រេតលោក" },
    { "id": 7702, "word": "ប្រេតវ័ន" },
    { "id": 7703, "word": "ប្រេតវិស័យ" },
    { "id": 7704, "word": "ប្រេមប្រិយ" },
    { "id": 7705, "word": "ប្រេវ" },
    { "id": 7706, "word": "ប្រេសិត" },
    { "id": 7707, "word": "ប្រេះ" },
    { "id": 7708, "word": "ប្រែ" },
    { "id": 7709, "word": "ប្រែក" },
    { "id": 7710, "word": "ប្រែង" },
    { "id": 7711, "word": "ប្រែះៗ" },
    { "id": 7712, "word": "ប្រៃ" },
    { "id": 7713, "word": "ប្រៃសណីយ៍" },
    { "id": 7714, "word": "ប្រោក" },
    { "id": 7715, "word": "ប្រោស" },
    { "id": 7716, "word": "ប្រោះ" },
    { "id": 7717, "word": "ប្រោះព្រំ" },
    { "id": 7718, "word": "ប្រោះស្វា" },
    { "id": 7719, "word": "ប្រាំ" },
    { "id": 7720, "word": "ប្រាំង" },
    { "id": 7721, "word": "ប្រាំធាន" },
    { "id": 7722, "word": "ប្រាំបី" },
    { "id": 7723, "word": "ប្រាំបួន" },
    { "id": 7724, "word": "ប្រាំពីរ" },
    { "id": 7725, "word": "ប្រះ" },
    { "id": 7726, "word": "ប្លក់" },
    { "id": 7727, "word": "ប្លត" },
    { "id": 7728, "word": "ប្លន់" },
    { "id": 7729, "word": "ប្លប់" },
    { "id": 7730, "word": "ប្លម" },
    { "id": 7731, "word": "ប្លាច់" },
    { "id": 7732, "word": "ប្លាញៗ" },
    { "id": 7733, "word": "ប្លាត" },
    { "id": 7734, "word": "ប្លាធូ" },
    { "id": 7735, "word": "ប្លាប" },
    { "id": 7736, "word": "ប្លាប់" },
    { "id": 7737, "word": "ប្លាយ" },
    { "id": 7738, "word": "ប្លិកៗ" },
    { "id": 7739, "word": "ប្លិច" },
    { "id": 7740, "word": "ប្លឹកៗ" },
    { "id": 7741, "word": "ប្លឺម" },
    { "id": 7742, "word": "ប្លុក" },
    { "id": 7743, "word": "ប្លុង" },
    { "id": 7744, "word": "ប្លុងៗ" },
    { "id": 7745, "word": "ប្លូក" },
    { "id": 7746, "word": "ប្លូច" },
    { "id": 7747, "word": "ប្លួក" },
    { "id": 7748, "word": "ប្លើកៗ" },
    { "id": 7749, "word": "ប្លៀកៗ" },
    { "id": 7750, "word": "ប្លៀវ" },
    { "id": 7751, "word": "ប្លេង" },
    { "id": 7752, "word": "ប្លេងប្លោង" },
    { "id": 7753, "word": "ប្លេះប្លោះ" },
    { "id": 7754, "word": "ប្លែក" },
    { "id": 7755, "word": "ប្លែង" },
    { "id": 7756, "word": "ប្លែន" },
    { "id": 7757, "word": "ប្លែមៗ" },
    { "id": 7758, "word": "ប្លោក" },
    { "id": 7759, "word": "ប្លោង" },
    { "id": 7760, "word": "ប្លោញៗ" },
    { "id": 7761, "word": "ប្លោត" },
    { "id": 7762, "word": "ប្លាំ" },
    { "id": 7763, "word": "ប្អូន" },
    { "id": 7764, "word": "ប៊" },
    { "id": 7765, "word": "ប៊័រ" },
    { "id": 7766, "word": "ប៊ិក" },
    { "id": 7767, "word": "ប៊ិស្គ្វីត៍" },
    { "id": 7768, "word": "ប៊ិហ្វតិក" },
    { "id": 7769, "word": "ប៊ិះ" },
    { "id": 7770, "word": "ប៊ីដុង" },
    { "id": 7771, "word": "ប៊ីយេរ" },
    { "id": 7772, "word": "ប៊ុត" },
    { "id": 7773, "word": "ប្អ៊ឹះ" },
    { "id": 7774, "word": "បញ្ចរ" },
    { "id": 7775, "word": "បំណាក់" },
    { "id": 7776, "word": "បំណាត់" },
    { "id": 7777, "word": "បំណិទ" },
    { "id": 7778, "word": "បំណើក" },
    { "id": 7779, "word": "បំណោក" },
    { "id": 7780, "word": "ប្រជាប្រិយ" },
    { "id": 7781, "word": "ប្រជាសវនាការ" },
    { "id": 7782, "word": "ប្របេរ" },
    { "id": 7783, "word": "ប៉័ងតោ" },
    { "id": 7784, "word": "ផ" },
    { "id": 7785, "word": "ផគ្គុណ" },
    { "id": 7786, "word": "ផគ្គុនី" },
    { "id": 7787, "word": "ផង" },
    { "id": 7788, "word": "ផង់" },
    { "id": 7789, "word": "ផត" },
    { "id": 7790, "word": "ផរណាបីតិ" },
    { "id": 7791, "word": "ផរុសវាចា" },
    { "id": 7792, "word": "ផរុសសព្ទ" },
    { "id": 7793, "word": "ផល" },
    { "id": 7794, "word": "ផល--" },
    { "id": 7795, "word": "ផល់ស្មា" },
    { "id": 7796, "word": "ផលិក" },
    { "id": 7797, "word": "ផលិតកម្ម" },
    { "id": 7798, "word": "ផលិតផល" },
    { "id": 7799, "word": "ផល្គុន" },
    { "id": 7800, "word": "ផស" },
    { "id": 7801, "word": "ផស្ស" },
    { "id": 7802, "word": "ផស្សាហារ" },
    { "id": 7803, "word": "ផាក" },
    { "id": 7804, "word": "ផាក្រាប" },
    { "id": 7805, "word": "ផាង" },
    { "id": 7806, "word": "ផាឌិប" },
    { "id": 7807, "word": "ផាណិត" },
    { "id": 7808, "word": "ផាត់" },
    { "id": 7809, "word": "ផាត់ជាយ" },
    { "id": 7810, "word": "ផាតិកម្ម" },
    { "id": 7811, "word": "ផាប់" },
    { "id": 7812, "word": "ផាប៉ា" },
    { "id": 7813, "word": "ផាមួង" },
    { "id": 7814, "word": "ផាយ" },
    { "id": 7815, "word": "ផាយោង" },
    { "id": 7816, "word": "ផាល" },
    { "id": 7817, "word": "ផាវ" },
    { "id": 7818, "word": "ផាស" },
    { "id": 7819, "word": "ផាសុក" },
    { "id": 7820, "word": "ផាសុកា" },
    { "id": 7821, "word": "ផាសុវិហារ" },
    { "id": 7822, "word": "ផាហ៊ុម" },
    { "id": 7823, "word": "ផិត" },
    { "id": 7824, "word": "ផឹក" },
    { "id": 7825, "word": "ផឹង" },
    { "id": 7826, "word": "ផឺត" },
    { "id": 7827, "word": "ផុង" },
    { "id": 7828, "word": "ផុត" },
    { "id": 7829, "word": "ផុយ" },
    { "id": 7830, "word": "ផុយផាយ" },
    { "id": 7831, "word": "ផុរ" },
    { "id": 7832, "word": "ផុស" },
    { "id": 7833, "word": "ផុស្សតី" },
    { "id": 7834, "word": "ផុស្សរាគ" },
    { "id": 7835, "word": "ផូក" },
    { "id": 7836, "word": "ផូង" },
    { "id": 7837, "word": "ផូយ" },
    { "id": 7838, "word": "ផូរផង់" },
    { "id": 7839, "word": "ផូស" },
    { "id": 7840, "word": "ផួយ" },
    { "id": 7841, "word": "ផើង" },
    { "id": 7842, "word": "ផើត" },
    { "id": 7843, "word": "ផើម" },
    { "id": 7844, "word": "ផើយ" },
    { "id": 7845, "word": "ផឿក" },
    { "id": 7846, "word": "ផេង" },
    { "id": 7847, "word": "ផេរ" },
    { "id": 7848, "word": "ផេះ" },
    { "id": 7849, "word": "ផែ" },
    { "id": 7850, "word": "ផែង" },
    { "id": 7851, "word": "ផែត" },
    { "id": 7852, "word": "ផែន" },
    { "id": 7853, "word": "ផែនការ" },
    { "id": 7854, "word": "ផែនទី" },
    { "id": 7855, "word": "ផែល" },
    { "id": 7856, "word": "ផែលទឹក" },
    { "id": 7857, "word": "ផែះ" },
    { "id": 7858, "word": "ផោង" },
    { "id": 7859, "word": "ផោដ្ឋព្វៈ" },
    { "id": 7860, "word": "ផោដ្ឋព្វារម្មណ៍" },
    { "id": 7861, "word": "ផោម" },
    { "id": 7862, "word": "ផៅ" },
    { "id": 7863, "word": "ផាំង" },
    { "id": 7864, "word": "ផ្កា" },
    { "id": 7865, "word": "ផ្កាកម្រង" },
    { "id": 7866, "word": "ផ្កាចន្ទន៍" },
    { "id": 7867, "word": "ផ្កាចារ" },
    { "id": 7868, "word": "ផ្កាចេក" },
    { "id": 7869, "word": "ផ្កាឈូក" },
    { "id": 7870, "word": "ផ្កាឈើ" },
    { "id": 7871, "word": "ផ្កាញ័រ" },
    { "id": 7872, "word": "ផ្កាដំបៅ" },
    { "id": 7873, "word": "ផ្កាត្រែង" },
    { "id": 7874, "word": "ផ្កាប់" },
    { "id": 7875, "word": "ផ្កាបិណ្ឌ" },
    { "id": 7876, "word": "ផ្កាប់ផ្ងារ" },
    { "id": 7877, "word": "ផ្កាភ្លើង" },
    { "id": 7878, "word": "ផ្កាមាស" },
    { "id": 7879, "word": "ផ្កាយ" },
    { "id": 7880, "word": "ផ្ការាំង" },
    { "id": 7881, "word": "ផ្កាស" },
    { "id": 7882, "word": "ផ្កាអំបិល" },
    { "id": 7883, "word": "ផ្គង" },
    { "id": 7884, "word": "ផ្គង់" },
    { "id": 7885, "word": "ផ្គត់" },
    { "id": 7886, "word": "ផ្គរ" },
    { "id": 7887, "word": "ផ្គាក់" },
    { "id": 7888, "word": "ផ្គាប់" },
    { "id": 7889, "word": "ផ្គុន" },
    { "id": 7890, "word": "ផ្គូ" },
    { "id": 7891, "word": "ផ្គូផ្គង" },
    { "id": 7892, "word": "ផ្គួប" },
    { "id": 7893, "word": "ផ្គើន" },
    { "id": 7894, "word": "ផ្គុំ" },
    { "id": 7895, "word": "ផ្គាំ" },
    { "id": 7896, "word": "ផ្ងក់ៗ" },
    { "id": 7897, "word": "ផ្ងាក" },
    { "id": 7898, "word": "ផ្ងាក់ផ្ងើក" },
    { "id": 7899, "word": "ផ្ងារ" },
    { "id": 7900, "word": "ផ្ងាវ" },
    { "id": 7901, "word": "ផ្ងុប" },
    { "id": 7902, "word": "ផ្ងូត" },
    { "id": 7903, "word": "ផ្ងើយ" },
    { "id": 7904, "word": "ផ្ងំ" },
    { "id": 7905, "word": "ផ្ចង់" },
    { "id": 7906, "word": "ផ្ចប់ៗ" },
    { "id": 7907, "word": "ផ្ចាច់" },
    { "id": 7908, "word": "ផ្ចាញ់" },
    { "id": 7909, "word": "ផ្ចាប់ៗ" },
    { "id": 7910, "word": "ផ្ចាល" },
    { "id": 7911, "word": "ផ្ចិត" },
    { "id": 7912, "word": "ផ្ចិតផ្ចង់" },
    { "id": 7913, "word": "ផ្ចឹក" },
    { "id": 7914, "word": "ផ្ចុក" },
    { "id": 7915, "word": "ផ្ចុងផ្ដើម" },
    { "id": 7916, "word": "ផ្ចុច" },
    { "id": 7917, "word": "ផ្ចោត" },
    { "id": 7918, "word": "ផ្ញាច់ៗ" },
    { "id": 7919, "word": "ផ្ញាញៗ" },
    { "id": 7920, "word": "ផ្ញុក" },
    { "id": 7921, "word": "ផ្ញុច" },
    { "id": 7922, "word": "ផ្ញើ" },
    { "id": 7923, "word": "ផ្ញៀវ" },
    { "id": 7924, "word": "ផ្ញោញៗ" },
    { "id": 7925, "word": "ផ្ដន្ទា" },
    { "id": 7926, "word": "ផ្ដល់" },
    { "id": 7927, "word": "ផ្ដាក់ផ្ដឺត" },
    { "id": 7928, "word": "ផ្ដាច់" },
    { "id": 7929, "word": "ផ្ដាស" },
    { "id": 7930, "word": "ផ្ដាសា" },
    { "id": 7931, "word": "ផ្ដាសាយ" },
    { "id": 7932, "word": "ផ្ដិត" },
    { "id": 7933, "word": "ផ្ដិល" },
    { "id": 7934, "word": "ផ្ដឺតៗ" },
    { "id": 7935, "word": "ផ្ដឺតផ្ដក់" },
    { "id": 7936, "word": "ផ្ដុស" },
    { "id": 7937, "word": "ផ្ដូត" },
    { "id": 7938, "word": "ផ្ដួច" },
    { "id": 7939, "word": "ផ្ដួល" },
    { "id": 7940, "word": "ផ្ដើម" },
    { "id": 7941, "word": "ផ្ដៀក" },
    { "id": 7942, "word": "ផ្ដៀង" },
    { "id": 7943, "word": "ផ្ដៀងផ្ដង" },
    { "id": 7944, "word": "ផ្ដៀច" },
    { "id": 7945, "word": "ផ្ដេក" },
    { "id": 7946, "word": "ផ្ដេច" },
    { "id": 7947, "word": "ផ្ដេសផ្ដាស" },
    { "id": 7948, "word": "ផ្ដែ" },
    { "id": 7949, "word": "ផ្ដែក" },
    { "id": 7950, "word": "ផ្ដែកវេរ" },
    { "id": 7951, "word": "ផ្ដែរ" },
    { "id": 7952, "word": "ផ្ដោត" },
    { "id": 7953, "word": "ផ្ដោមៗ" },
    { "id": 7954, "word": "ផ្ដោះផ្ដង" },
    { "id": 7955, "word": "ផ្ដៅ" },
    { "id": 7956, "word": "ផ្ដុំ" },
    { "id": 7957, "word": "ផ្ដាំ" },
    { "id": 7958, "word": "ផ្តក់" },
    { "id": 7959, "word": "ផ្តិតផ្តូង" },
    { "id": 7960, "word": "ផ្តិល" },
    { "id": 7961, "word": "ផ្តឹកៗ" },
    { "id": 7962, "word": "ផ្តើកៗ" },
    { "id": 7963, "word": "ផ្តេតៗ" },
    { "id": 7964, "word": "ផ្ទក់" },
    { "id": 7965, "word": "ផ្ទញ់" },
    { "id": 7966, "word": "ផ្ទប់" },
    { "id": 7967, "word": "ផ្ទល់" },
    { "id": 7968, "word": "ផ្ទា" },
    { "id": 7969, "word": "ផ្ទាត់" },
    { "id": 7970, "word": "ផ្ទាន់" },
    { "id": 7971, "word": "ផ្ទាប់" },
    { "id": 7972, "word": "ផ្ទារ" },
    { "id": 7973, "word": "ផ្ទាល" },
    { "id": 7974, "word": "ផ្ទាល់" },
    { "id": 7975, "word": "ផ្ទី" },
    { "id": 7976, "word": "ផ្ទីង" },
    { "id": 7977, "word": "ផ្ទឹម" },
    { "id": 7978, "word": "ផ្ទឺ" },
    { "id": 7979, "word": "ផ្ទុក" },
    { "id": 7980, "word": "ផ្ទុយ" },
    { "id": 7981, "word": "ផ្ទុរ" },
    { "id": 7982, "word": "ផ្ទូរ" },
    { "id": 7983, "word": "ផ្ទួន" },
    { "id": 7984, "word": "ផ្ទៀង" },
    { "id": 7985, "word": "ផ្ទេរ" },
    { "id": 7986, "word": "ផ្ទៃ" },
    { "id": 7987, "word": "ផ្ទោង" },
    { "id": 7988, "word": "ផ្ទោល" },
    { "id": 7989, "word": "ផ្ទំ" },
    { "id": 7990, "word": "ផ្ទាំង" },
    { "id": 7991, "word": "ផ្ទះ" },
    { "id": 7992, "word": "ផ្នក់ទឹក" },
    { "id": 7993, "word": "ផ្នង់" },
    { "id": 7994, "word": "ផ្នង់ទឹក" },
    { "id": 7995, "word": "ផ្នត់" },
    { "id": 7996, "word": "ផ្នាលៗ" },
    { "id": 7997, "word": "ផ្នូកខ្សាច់" },
    { "id": 7998, "word": "ផ្នូត" },
    { "id": 7999, "word": "ផ្នូរ" },
    { "id": 8000, "word": "ផ្នូរខ្សាច់" },
    { "id": 8001, "word": "ផ្នូល" },
    { "id": 8002, "word": "ផ្នួង" },
    { "id": 8003, "word": "ផ្នួតក" },
    { "id": 8004, "word": "ផ្នួស" },
    { "id": 8005, "word": "ផ្នៀង" },
    { "id": 8006, "word": "ផ្នៀរ" },
    { "id": 8007, "word": "ផ្នែក" },
    { "id": 8008, "word": "ផ្នែលៗ" },
    { "id": 8009, "word": "ផ្នោលៗ" },
    { "id": 8010, "word": "ផ្នោះ" },
    { "id": 8011, "word": "ផ្នោះក្រាន" },
    { "id": 8012, "word": "ផ្លប់" },
    { "id": 8013, "word": "ផ្លាង" },
    { "id": 8014, "word": "ផ្លាញ" },
    { "id": 8015, "word": "ផ្លាញៗ" },
    { "id": 8016, "word": "ផ្លាន" },
    { "id": 8017, "word": "ផ្លាប់" },
    { "id": 8018, "word": "ផ្លាស់" },
    { "id": 8019, "word": "ផ្លិត" },
    { "id": 8020, "word": "ផ្លូច" },
    { "id": 8021, "word": "ផ្លូន" },
    { "id": 8022, "word": "ផ្លូវ" },
    { "id": 8023, "word": "ផ្លួក" },
    { "id": 8024, "word": "ផ្លួត" },
    { "id": 8025, "word": "ផ្លើស" },
    { "id": 8026, "word": "ផ្លៀក" },
    { "id": 8027, "word": "ផ្លេក" },
    { "id": 8028, "word": "ផ្លេកបន្ទោរ" },
    { "id": 8029, "word": "ផ្លេកផ្លោះ" },
    { "id": 8030, "word": "ផ្លែ" },
    { "id": 8031, "word": "ផ្លែង" },
    { "id": 8032, "word": "ផ្លែអាយ" },
    { "id": 8033, "word": "ផ្លោង" },
    { "id": 8034, "word": "ផ្លោត" },
    { "id": 8035, "word": "ផ្លោះ" },
    { "id": 8036, "word": "ផ្លុំ" },
    { "id": 8037, "word": "ផ្សង" },
    { "id": 8038, "word": "ផ្សងផ្សូរ" },
    { "id": 8039, "word": "ផ្សព្វ" },
    { "id": 8040, "word": "ផ្សព្វផ្សាយ" },
    { "id": 8041, "word": "ផ្សា" },
    { "id": 8042, "word": "ផ្សាយ" },
    { "id": 8043, "word": "ផ្សារ" },
    { "id": 8044, "word": "ផ្សិង" },
    { "id": 8045, "word": "ផ្សិត" },
    { "id": 8046, "word": "ផ្សឹក" },
    { "id": 8047, "word": "ផ្សូរផ្សង" },
    { "id": 8048, "word": "ផ្សើម" },
    { "id": 8049, "word": "ផ្សេង" },
    { "id": 8050, "word": "ផ្សែ" },
    { "id": 8051, "word": "ផ្សែង" },
    { "id": 8052, "word": "ផ្សែត" },
    { "id": 8053, "word": "ផ្សៃ" },
    { "id": 8054, "word": "ផ្សោ" },
    { "id": 8055, "word": "ផ្សោត" },
    { "id": 8056, "word": "ផ្សោះ" },
    { "id": 8057, "word": "ផ្សំ" },
    { "id": 8058, "word": "ផ្សាំ" },
    { "id": 8059, "word": "ផ្ស៊‍ាំ" },
    { "id": 8060, "word": "ផ្សាំង" },
    { "id": 8061, "word": "ផ្សះ" },
    { "id": 8062, "word": "ផ្សះផ្សា" },
    { "id": 8063, "word": "ផ្អក" },
    { "id": 8064, "word": "ផ្អង" },
    { "id": 8065, "word": "ផ្អប" },
    { "id": 8066, "word": "ផ្អរ" },
    { "id": 8067, "word": "ផ្អាក" },
    { "id": 8068, "word": "ផ្អាក់ផ្អើក" },
    { "id": 8069, "word": "ផ្អាប់" },
    { "id": 8070, "word": "ផ្អាវ" },
    { "id": 8071, "word": "ផ្អឹកៗ" },
    { "id": 8072, "word": "ផ្អឹប" },
    { "id": 8073, "word": "ផ្អឹះ" },
    { "id": 8074, "word": "ផ្អឺបៗ" },
    { "id": 8075, "word": "ផ្អុកៗ" },
    { "id": 8076, "word": "ផ្អុង" },
    { "id": 8077, "word": "ផ្អូក" },
    { "id": 8078, "word": "ផ្អូចៗ" },
    { "id": 8079, "word": "ផ្អូម" },
    { "id": 8080, "word": "ផ្អួរ" },
    { "id": 8081, "word": "ផ្អួសៗ" },
    { "id": 8082, "word": "ផ្អើល" },
    { "id": 8083, "word": "ផ្អើះ" },
    { "id": 8084, "word": "ផ្អៀង" },
    { "id": 8085, "word": "ផ្អេះៗ" },
    { "id": 8086, "word": "ផ្អែក" },
    { "id": 8087, "word": "ផ្អែបៗ" },
    { "id": 8088, "word": "ផ្អែម" },
    { "id": 8089, "word": "ផ្អោង" },
    { "id": 8090, "word": "ផ្អោប" },
    { "id": 8091, "word": "ផ្អោះ" },
    { "id": 8092, "word": "ព" },
    { "id": 8093, "word": "ពក" },
    { "id": 8094, "word": "ពង" },
    { "id": 8095, "word": "ដំឡើង" },
    { "id": 8096, "word": "ពងក្រពើ" },
    { "id": 8097, "word": "ពងក្អុក" },
    { "id": 8098, "word": "ពងចាប" },
    { "id": 8099, "word": "ពងត្រង" },
    { "id": 8100, "word": "ពងត្រី" },
    { "id": 8101, "word": "ពងទឹក" },
    { "id": 8102, "word": "ពងបង្កួយ" },
    { "id": 8103, "word": "ពងបែក" },
    { "id": 8104, "word": "ពងមាន់" },
    { "id": 8105, "word": "ពងលលក" },
    { "id": 8106, "word": "ពងល្វា" },
    { "id": 8107, "word": "ពងស្វាស" },
    { "id": 8108, "word": "ពង្រ" },
    { "id": 8109, "word": "ពង្រត់" },
    { "id": 8110, "word": "ពង្រន" },
    { "id": 8111, "word": "ពង្រល" },
    { "id": 8112, "word": "ពង្រា" },
    { "id": 8113, "word": "ពង្រាក" },
    { "id": 8114, "word": "ពង្រាក់" },
    { "id": 8115, "word": "ពង្រាង" },
    { "id": 8116, "word": "ពង្រាត់" },
    { "id": 8117, "word": "ពង្រាប" },
    { "id": 8118, "word": "ពង្រាយ" },
    { "id": 8119, "word": "ពង្រាល" },
    { "id": 8120, "word": "ពង្រីក" },
    { "id": 8121, "word": "ពង្រីង" },
    { "id": 8122, "word": "ពង្រឹង" },
    { "id": 8123, "word": "ពង្រឹត" },
    { "id": 8124, "word": "ពង្រឹល" },
    { "id": 8125, "word": "ពង្រុល" },
    { "id": 8126, "word": "ពង្រូង" },
    { "id": 8127, "word": "ពង្រូល" },
    { "id": 8128, "word": "ពង្រួប" },
    { "id": 8129, "word": "ពង្រួម" },
    { "id": 8130, "word": "ពង្រេ" },
    { "id": 8131, "word": "ពង្រេច" },
    { "id": 8132, "word": "ពង្រោះ" },
    { "id": 8133, "word": "ពង្វក់" },
    { "id": 8134, "word": "ពង្វាង" },
    { "id": 8135, "word": "ពង្វាត" },
    { "id": 8136, "word": "ពង្វិល" },
    { "id": 8137, "word": "ពង្វីពង្វក់" },
    { "id": 8138, "word": "ពង្វឹក" },
    { "id": 8139, "word": "ពង្វៀន" },
    { "id": 8140, "word": "ពង្វៀះ" },
    { "id": 8141, "word": "ពង្វេះ" },
    { "id": 8142, "word": "ពង្ស" },
    { "id": 8143, "word": "ពង្សាវតារ" },
    { "id": 8144, "word": "ពង្សាវលី" },
    { "id": 8145, "word": "ព័ចន៍" },
    { "id": 8146, "word": "ពញា" },
    { "id": 8147, "word": "ពញាក្រែក" },
    { "id": 8148, "word": "ពញារក្សាភិបាល" },
    { "id": 8149, "word": "ពញាឮ" },
    { "id": 8150, "word": "ពញ្ញាក់" },
    { "id": 8151, "word": "ពណ្ណរាយ" },
    { "id": 8152, "word": "ពណ៌" },
    { "id": 8153, "word": "ពណ៌នា" },
    { "id": 8154, "word": "ពត់" },
    { "id": 8155, "word": "ព័ត" },
    { "id": 8156, "word": "ព័ត៌មាន" },
    { "id": 8157, "word": "ព័ទ្ធ" },
    { "id": 8158, "word": "ព័ទ្ធធ្លុង" },
    { "id": 8159, "word": "ពទ្ធសីមា" },
    { "id": 8160, "word": "ពន" },
    { "id": 8161, "word": "ពន់" },
    { "id": 8162, "word": "ពនាល័យ" },
    { "id": 8163, "word": "ពនាស័យ" },
    { "id": 8164, "word": "ពនាស្រម" },
    { "id": 8165, "word": "ពនាស្រ័យ" },
    { "id": 8166, "word": "ពនិតា" },
    { "id": 8167, "word": "ពនេចរ" },
    { "id": 8168, "word": "ពន្ទ" },
    { "id": 8169, "word": "ពន្ធ" },
    { "id": 8170, "word": "ព័ន្ធ" },
    { "id": 8171, "word": "ព័ន្ធដាម" },
    { "id": 8172, "word": "ព័ន្ធធ្លុង" },
    { "id": 8173, "word": "ពន្ធនាការ" },
    { "id": 8174, "word": "ពន្ធនាគារ" },
    { "id": 8175, "word": "ព័ន្ធមូល" },
    { "id": 8176, "word": "ព័ន្ធលឹង" },
    { "id": 8177, "word": "ព័ន្ធស្នឹង" },
    { "id": 8178, "word": "ពន្យល់" },
    { "id": 8179, "word": "ពន្យារ" },
    { "id": 8180, "word": "ពន្យី" },
    { "id": 8181, "word": "ពន្យឺត" },
    { "id": 8182, "word": "ពន្យឺន" },
    { "id": 8183, "word": "ពន្យុយ" },
    { "id": 8184, "word": "ពន្យុល" },
    { "id": 8185, "word": "ពន្យុះ" },
    { "id": 8186, "word": "ពន្យូយ" },
    { "id": 8187, "word": "ពន្យើ" },
    { "id": 8188, "word": "ពន្យោល" },
    { "id": 8189, "word": "ពន្យះ" },
    { "id": 8190, "word": "ពន្រាយ" },
    { "id": 8191, "word": "ពន្លក" },
    { "id": 8192, "word": "ពន្លង់" },
    { "id": 8193, "word": "ពន្លត់" },
    { "id": 8194, "word": "ពន្លា" },
    { "id": 8195, "word": "ពន្លាក" },
    { "id": 8196, "word": "ពន្លាញ" },
    { "id": 8197, "word": "ពន្លាត់" },
    { "id": 8198, "word": "ពន្លិច" },
    { "id": 8199, "word": "ពន្លឹក" },
    { "id": 8200, "word": "ពន្លឹប" },
    { "id": 8201, "word": "ពន្លឺ" },
    { "id": 8202, "word": "ពន្លុង" },
    { "id": 8203, "word": "ពន្លុត" },
    { "id": 8204, "word": "ពន្លុន" },
    { "id": 8205, "word": "ពន្លូក" },
    { "id": 8206, "word": "ពន្លូច" },
    { "id": 8207, "word": "ពន្លូត" },
    { "id": 8208, "word": "ពន្លូន" },
    { "id": 8209, "word": "ពន្លួញ" },
    { "id": 8210, "word": "ពន្លើស" },
    { "id": 8211, "word": "ពន្លៀក" },
    { "id": 8212, "word": "ពន្លៀន" },
    { "id": 8213, "word": "ពន្លែង" },
    { "id": 8214, "word": "ពន្លៃ" },
    { "id": 8215, "word": "ពន្លោត" },
    { "id": 8216, "word": "ពន្លះ" },
    { "id": 8217, "word": "ពពក" },
    { "id": 8218, "word": "ពពាក់" },
    { "id": 8219, "word": "ពពាច" },
    { "id": 8220, "word": "ពពាន" },
    { "id": 8221, "word": "ពពាយនាយ" },
    { "id": 8222, "word": "ពពារ" },
    { "id": 8223, "word": "ពពារនាគរាជ" },
    { "id": 8224, "word": "ពពាល" },
    { "id": 8225, "word": "ពពាលខែ" },
    { "id": 8226, "word": "ពពិច" },
    { "id": 8227, "word": "ពពិល" },
    { "id": 8228, "word": "ពពីម" },
    { "id": 8229, "word": "ពពីរ" },
    { "id": 8230, "word": "ពពឹក" },
    { "id": 8231, "word": "ពពឹកឆ្កែ" },
    { "id": 8232, "word": "ពពុរ" },
    { "id": 8233, "word": "ពពុះ" },
    { "id": 8234, "word": "ពពុះទឹក" },
    { "id": 8235, "word": "ពពុះសណ្ដែក" },
    { "id": 8236, "word": "ពពូ" },
    { "id": 8237, "word": "ពពូក" },
    { "id": 8238, "word": "ពពូន" },
    { "id": 8239, "word": "ពពូល" },
    { "id": 8240, "word": "ពពូលថ្ម" },
    { "id": 8241, "word": "ពពូលទឹក" },
    { "id": 8242, "word": "ពពួក" },
    { "id": 8243, "word": "ពពើម" },
    { "id": 8244, "word": "ពពេច" },
    { "id": 8245, "word": "ពពេចចង្វា" },
    { "id": 8246, "word": "ពពេន" },
    { "id": 8247, "word": "ពពេល" },
    { "id": 8248, "word": "ពពែ" },
    { "id": 8249, "word": "ពពែភ្នែក" },
    { "id": 8250, "word": "ពពោក" },
    { "id": 8251, "word": "ពព្រត" },
    { "id": 8252, "word": "ពព្រល" },
    { "id": 8253, "word": "ពព្រាក់" },
    { "id": 8254, "word": "ពព្រាត" },
    { "id": 8255, "word": "ពព្រាយ" },
    { "id": 8256, "word": "ពព្រិច" },
    { "id": 8257, "word": "ពព្រឹម" },
    { "id": 8258, "word": "ពព្រឹល" },
    { "id": 8259, "word": "ពព្រឺស" },
    { "id": 8260, "word": "ពព្រុស" },
    { "id": 8261, "word": "ពព្រូស" },
    { "id": 8262, "word": "ពព្រួក" },
    { "id": 8263, "word": "ពព្រួច" },
    { "id": 8264, "word": "ពព្រើត" },
    { "id": 8265, "word": "ពព្រើម" },
    { "id": 8266, "word": "ពព្រើស" },
    { "id": 8267, "word": "ពព្រៀក" },
    { "id": 8268, "word": "ពព្រៀប" },
    { "id": 8269, "word": "ពព្រាំងពព្រើត" },
    { "id": 8270, "word": "ពព្លាក់" },
    { "id": 8271, "word": "ពព្លិកពព្លាក់" },
    { "id": 8272, "word": "ពព្លែម" },
    { "id": 8273, "word": "ពភក់" },
    { "id": 8274, "word": "ពភល" },
    { "id": 8275, "word": "ពភីង" },
    { "id": 8276, "word": "ពភឹប" },
    { "id": 8277, "word": "ពភឹល" },
    { "id": 8278, "word": "ពភឺត" },
    { "id": 8279, "word": "ពភឺស" },
    { "id": 8280, "word": "ពភុង" },
    { "id": 8281, "word": "ពភូស" },
    { "id": 8282, "word": "ពភ្លក់" },
    { "id": 8283, "word": "ពភ្លន" },
    { "id": 8284, "word": "ពភ្លា" },
    { "id": 8285, "word": "ពភ្លាក់ពភ្លើ" },
    { "id": 8286, "word": "ពភ្លាក់ពភ្លើក" },
    { "id": 8287, "word": "ពភ្លាម" },
    { "id": 8288, "word": "ពភ្លីពភ្លើ" },
    { "id": 8289, "word": "ពភ្លីមពភ្លាម" },
    { "id": 8290, "word": "ពភ្លីះពភ្លែះ" },
    { "id": 8291, "word": "ពភ្លឹបពភ្លែត" },
    { "id": 8292, "word": "ពភ្លឹម" },
    { "id": 8293, "word": "ពភ្លឹមពភ្លែត" },
    { "id": 8294, "word": "ពភ្លឹះ" },
    { "id": 8295, "word": "ពភ្លុក" },
    { "id": 8296, "word": "ពភ្លុង" },
    { "id": 8297, "word": "ពភ្លួក" },
    { "id": 8298, "word": "ពភ្លើ" },
    { "id": 8299, "word": "ពភ្លើក" },
    { "id": 8300, "word": "ពភ្លៀក" },
    { "id": 8301, "word": "ពភ្លែត" },
    { "id": 8302, "word": "ពភ្លែល" },
    { "id": 8303, "word": "ពភ្លែះ" },
    { "id": 8304, "word": "ពម" },
    { "id": 8305, "word": "ពយ" },
    { "id": 8306, "word": "ពរ" },
    { "id": 8307, "word": "ព័រ" },
    { "id": 8308, "word": "ពរ្សឺឡែន" },
    { "id": 8309, "word": "ពល" },
    { "id": 8310, "word": "ពលកាយ" },
    { "id": 8311, "word": "ពលក្ការ" },
    { "id": 8312, "word": "ពលទោ" },
    { "id": 8313, "word": "ពលនិកាយ" },
    { "id": 8314, "word": "ពលបាលត្រី" },
    { "id": 8315, "word": "ពលបាលទោ" },
    { "id": 8316, "word": "ពលបាលឯក" },
    { "id": 8317, "word": "ពលព្រះ" },
    { "id": 8318, "word": "ពលរដ្ឋ" },
    { "id": 8319, "word": "ពលសក្តិ" },
    { "id": 8320, "word": "ពលឯក" },
    { "id": 8321, "word": "ពលាហក" },
    { "id": 8322, "word": "ពលិកម្ម" },
    { "id": 8323, "word": "ពលិការ" },
    { "id": 8324, "word": "ពលិទាន" },
    { "id": 8325, "word": "ពលី" },
    { "id": 8326, "word": "ពលីការ" },
    { "id": 8327, "word": "ពលៃ" },
    { "id": 8328, "word": "ពលំ" },
    { "id": 8329, "word": "ពស់" },
    { "id": 8330, "word": "ពសុធា" },
    { "id": 8331, "word": "ពសុន្ធរា" },
    { "id": 8332, "word": "ព័ស្ដុ" },
    { "id": 8333, "word": "ពស្រ្ត" },
    { "id": 8334, "word": "ពស្ត្រាភរណៈ" },
    { "id": 8335, "word": "ពស្ត្រាលង្ការ" },
    { "id": 8336, "word": "ពហុការី" },
    { "id": 8337, "word": "ពហុកិច្ច" },
    { "id": 8338, "word": "ពហុកោណ" },
    { "id": 8339, "word": "ពហុព្យាង្គ" },
    { "id": 8340, "word": "ពហុភាសក" },
    { "id": 8341, "word": "ពហុមន្តី" },
    { "id": 8342, "word": "ពហុវចន" },
    { "id": 8343, "word": "ពហុស្សូត" },
    { "id": 8344, "word": "ពហូសក្តិ" },
    { "id": 8345, "word": "ពហូសូត" },
    { "id": 8346, "word": "ពាក់" },
    { "id": 8347, "word": "ពាក់កង" },
    { "id": 8348, "word": "ពាក់កណ្ដាល" },
    { "id": 8349, "word": "ពាក្យ" },
    { "id": 8350, "word": "ពាក្យកំព្រា" },
    { "id": 8351, "word": "ពាង" },
    { "id": 8352, "word": "ពាជី" },
    { "id": 8353, "word": "ពាជនី" },
    { "id": 8354, "word": "ពាឌីរ" },
    { "id": 8355, "word": "ពាណិជ" },
    { "id": 8356, "word": "ពាណិជ្ជ" },
    { "id": 8357, "word": "ពាណិជ្ជកម្ម" },
    { "id": 8358, "word": "ពាណិជ្ជការ" },
    { "id": 8359, "word": "ពាណិជ្យ" },
    { "id": 8360, "word": "ពាណ៌នា" },
    { "id": 8361, "word": "ពាត" },
    { "id": 8362, "word": "ពាតបា" },
    { "id": 8363, "word": "ពាទ្យ" },
    { "id": 8364, "word": "ពាទ្យភណ្ឌ" },
    { "id": 8365, "word": "ពាទ្យម៉ាង" },
    { "id": 8366, "word": "ពាធជន្ម" },
    { "id": 8367, "word": "ពាធា" },
    { "id": 8368, "word": "ពាន" },
    { "id": 8369, "word": "ពាន់" },
    { "id": 8370, "word": "ពាន់តា" },
    { "id": 8371, "word": "ពាន់នេត្រ" },
    { "id": 8372, "word": "ពានព្រះស្រី" },
    { "id": 8373, "word": "ពានរ" },
    { "id": 8374, "word": "ពានរិន្ទ" },
    { "id": 8375, "word": "ពានរី" },
    { "id": 8376, "word": "ពានរេន្ទ្រ" },
    { "id": 8377, "word": "ពានា" },
    { "id": 8378, "word": "ពាប់" },
    { "id": 8379, "word": "ពាម" },
    { "id": 8380, "word": "ពាយ" },
    { "id": 8381, "word": "ពាយងាយ" },
    { "id": 8382, "word": "ពាយព្យ" },
    { "id": 8383, "word": "ពាយុ" },
    { "id": 8384, "word": "ពាយុគុល្ម" },
    { "id": 8385, "word": "ពាយុបុត្រ" },
    { "id": 8386, "word": "ពារ" },
    { "id": 8387, "word": "ពារាណសី" },
    { "id": 8388, "word": "ពារុណី" },
    { "id": 8389, "word": "ពារាំង" },
    { "id": 8390, "word": "ពាល" },
    { "id": 8391, "word": "ពាល់" },
    { "id": 8392, "word": "ពាលមានី" },
    { "id": 8393, "word": "ពាលី" },
    { "id": 8394, "word": "ពាលុកា" },
    { "id": 8395, "word": "ពាលុកចេតិយ" },
    { "id": 8396, "word": "ពាលោ" },
    { "id": 8397, "word": "ពាស" },
    { "id": 8398, "word": "ពាសុកី" },
    { "id": 8399, "word": "ពាហនៈ" },
    { "id": 8400, "word": "ពាហនពិសេស" },
    { "id": 8401, "word": "ពាហនវិសេស" },
    { "id": 8402, "word": "ពាហនសត្វ" },
    { "id": 8403, "word": "ពាហា" },
    { "id": 8404, "word": "ពាហិរកថា" },
    { "id": 8405, "word": "ពាហុ" },
    { "id": 8406, "word": "ពាហុជៈ" },
    { "id": 8407, "word": "ពាហុប្រហារ" },
    { "id": 8408, "word": "ពាហុមូល" },
    { "id": 8409, "word": "ពាហុយុទ្ធ" },
    { "id": 8410, "word": "ពាហុរត្ន" },
    { "id": 8411, "word": "ពាហុសច្ច" },
    { "id": 8412, "word": "ពាហុសម្ភព" },
    { "id": 8413, "word": "ពាឡម្រឹគ" },
    { "id": 8414, "word": "ពិការ" },
    { "id": 8415, "word": "ពិគ្រោះ" },
    { "id": 8416, "word": "ពិឃាដ" },
    { "id": 8417, "word": "ពិច័យ" },
    { "id": 8418, "word": "ពិចារណា" },
    { "id": 8419, "word": "ពិចិត្រ" },
    { "id": 8420, "word": "ពិជ័យ" },
    { "id": 8421, "word": "ពិជ័យសង្គ្រាម" },
    { "id": 8422, "word": "ពិជិតមារ" },
    { "id": 8423, "word": "ពិជិតរដ្ឋ" },
    { "id": 8424, "word": "ពិជិតរាស្ត្រ" },
    { "id": 8425, "word": "ពិជេដ្ឋ" },
    { "id": 8426, "word": "ពិដោរ" },
    { "id": 8427, "word": "ពិណ" },
    { "id": 8428, "word": "ពិណពាទ្យ" },
    { "id": 8429, "word": "ពិត" },
    { "id": 8430, "word": "ពិតពិល" },
    { "id": 8431, "word": "ពិតាន" },
    { "id": 8432, "word": "ពិទ័គ្ធ" },
    { "id": 8433, "word": "ពិទាយ" },
    { "id": 8434, "word": "ពិទូរ្យ" },
    { "id": 8435, "word": "ពិទ្យាធរ" },
    { "id": 8436, "word": "ពិទ្រុម" },
    { "id": 8437, "word": "ពិធី" },
    { "id": 8438, "word": "ពិធុរ" },
    { "id": 8439, "word": "ពិធុរភាព" },
    { "id": 8440, "word": "ពិធូរ" },
    { "id": 8441, "word": "ពិន" },
    { "id": 8442, "word": "ពិនតូ" },
    { "id": 8443, "word": "ពិន័យ" },
    { "id": 8444, "word": "ពិនិត្យ" },
    { "id": 8445, "word": "ពិនិស្ច័យ" },
    { "id": 8446, "word": "ពិន្ទង" },
    { "id": 8447, "word": "ពិន្ទុ" },
    { "id": 8448, "word": "ពិន្ទុកប្បៈ" },
    { "id": 8449, "word": "ពិបាក" },
    { "id": 8450, "word": "ពិបិន" },
    { "id": 8451, "word": "ពិផាត" },
    { "id": 8452, "word": "ពិពឌ្ឍសច្ចា" },
    { "id": 8453, "word": "ពិពណ៌នា" },
    { "id": 8454, "word": "ពិព័រណ៍" },
    { "id": 8455, "word": "ពិពាហ៍" },
    { "id": 8456, "word": "ពិពិធ" },
    { "id": 8457, "word": "ពិភ័ក្ដិ" },
    { "id": 8458, "word": "ពិភទ្ទសច្ចា" },
    { "id": 8459, "word": "ពិភព" },
    { "id": 8460, "word": "ពិភាក្សា" },
    { "id": 8461, "word": "ពិភាល់" },
    { "id": 8462, "word": "ពិភេក" },
    { "id": 8463, "word": "ពិភេក្សណ៍" },
    { "id": 8464, "word": "ពិភេទក៍" },
    { "id": 8465, "word": "ពិមល" },
    { "id": 8466, "word": "ពិមាន" },
    { "id": 8467, "word": "ពិមានអាកាស" },
    { "id": 8468, "word": "ពិម្ព" },
    { "id": 8469, "word": "ពិម្ពា" },
    { "id": 8470, "word": "ពិម្ពិសារ" },
    { "id": 8471, "word": "ពិរាល័យ" },
    { "id": 8472, "word": "ពិរុណ" },
    { "id": 8473, "word": "ពិរុណសាស្ត្រ" },
    { "id": 8474, "word": "ពិរុទ្ធ" },
    { "id": 8475, "word": "ពិរោធ" },
    { "id": 8476, "word": "ពិរោធន៍" },
    { "id": 8477, "word": "ពិល" },
    { "id": 8478, "word": "ពិលាប" },
    { "id": 8479, "word": "ពិលាល័យ" },
    { "id": 8480, "word": "ពិលាស" },
    { "id": 8481, "word": "ពិលាស័យ" },
    { "id": 8482, "word": "ពិលាសិនី" },
    { "id": 8483, "word": "ពិលាសី" },
    { "id": 8484, "word": "ពិស" },
    { "id": 8485, "word": "ពិសម័យ" },
    { "id": 8486, "word": "ពិសា" },
    { "id": 8487, "word": "ពិសាខ" },
    { "id": 8488, "word": "ពិសាខបូជា" },
    { "id": 8489, "word": "ពិសាល" },
    { "id": 8490, "word": "ពិសិដ្ឋ" },
    { "id": 8491, "word": "ពិសី" },
    { "id": 8492, "word": "ពិសុទ្ធ" },
    { "id": 8493, "word": "ពិសុទ្ធិ" },
    { "id": 8494, "word": "ពិសេស" },
    { "id": 8495, "word": "ពិសែស" },
    { "id": 8496, "word": "ពិសោធ" },
    { "id": 8497, "word": "ពិសោធន៍" },
    { "id": 8498, "word": "ពិស្ដារ" },
    { "id": 8499, "word": "ពិស្ណុ" },
    { "id": 8500, "word": "ពិស្ណុការ" },
    { "id": 8501, "word": "ពិស្ណុលោក" },
    { "id": 8502, "word": "ពិស្ម័យ" },
    { "id": 8503, "word": "ពិស្សុត" },
    { "id": 8504, "word": "ពិឡារ" },
    { "id": 8505, "word": "ពី" },
    { "id": 8506, "word": "ពីង" },
    { "id": 8507, "word": "ពីងពង់" },
    { "id": 8508, "word": "ពីងពាង" },
    { "id": 8509, "word": "ពីងពាំង" },
    { "id": 8510, "word": "ពីជគណិត" },
    { "id": 8511, "word": "ពីជគាម" },
    { "id": 8512, "word": "ពីផាត" },
    { "id": 8513, "word": "ពីព្រោះ" },
    { "id": 8514, "word": "ពីមពើម" },
    { "id": 8515, "word": "ពីរ" },
    { "id": 8516, "word": "ពីរោះ" },
    { "id": 8517, "word": "ពីសា" },
    { "id": 8518, "word": "ពីសី" },
    { "id": 8519, "word": "ពឹង" },
    { "id": 8520, "word": "ពឹត" },
    { "id": 8521, "word": "ពឹប" },
    { "id": 8522, "word": "ពឺត" },
    { "id": 8523, "word": "ពុក" },
    { "id": 8524, "word": "ពុកចង្កា" },
    { "id": 8525, "word": "ពុកឆ្មា" },
    { "id": 8526, "word": "ពុកបង្កង" },
    { "id": 8527, "word": "ពុកមាត់" },
    { "id": 8528, "word": "ពុង" },
    { "id": 8529, "word": "ពុត" },
    { "id": 8530, "word": "ពុតធ្លេ" },
    { "id": 8531, "word": "ពុតលំញង" },
    { "id": 8532, "word": "ពុទ្ធ" },
    { "id": 8533, "word": "ពុទ្ធ --" },
    { "id": 8534, "word": "ពុទ្ធឃោសៈ" },
    { "id": 8535, "word": "ពុទ្ធជាត" },
    { "id": 8536, "word": "ពុទ្ធិ" },
    { "id": 8537, "word": "ពុទ្ធិក" },
    { "id": 8538, "word": "ពុទ្ធិចរិត" },
    { "id": 8539, "word": "ពុទ្ធិព្រឹទ្ធ" },
    { "id": 8540, "word": "ពុទ្ធិវិបល្លាស" },
    { "id": 8541, "word": "ពុទ្ធុប្បាទ" },
    { "id": 8542, "word": "ពុទ្ធោ ! " },
    { "id": 8543, "word": "ពុទ្ធោវាទ" },
    { "id": 8544, "word": "ពុទ្រា" },
    { "id": 8545, "word": "ពុធ" },
    { "id": 8546, "word": "ពុធជន" },
    { "id": 8547, "word": "ពុន" },
    { "id": 8548, "word": "ពុប" },
    { "id": 8549, "word": "ពុម្ព" },
    { "id": 8550, "word": "ពុរ" },
    { "id": 8551, "word": "ពុល" },
    { "id": 8552, "word": "ពុះ" },
    { "id": 8553, "word": "ពូ" },
    { "id": 8554, "word": "ពូក" },
    { "id": 8555, "word": "ពូកែ" },
    { "id": 8556, "word": "ពូជ" },
    { "id": 8557, "word": "ពូត" },
    { "id": 8558, "word": "ពូថៅ" },
    { "id": 8559, "word": "ពូន" },
    { "id": 8560, "word": "ពូរាង" },
    { "id": 8561, "word": "ពួក" },
    { "id": 8562, "word": "ពួច" },
    { "id": 8563, "word": "ពួត" },
    { "id": 8564, "word": "ពួន" },
    { "id": 8565, "word": "ពួយ" },
    { "id": 8566, "word": "ពួរ" },
    { "id": 8567, "word": "ពើ" },
    { "id": 8568, "word": "ពើក" },
    { "id": 8569, "word": "ពើកៗ" },
    { "id": 8570, "word": "ពើង" },
    { "id": 8571, "word": "ពើត" },
    { "id": 8572, "word": "ពើប" },
    { "id": 8573, "word": "ពើមៗ" },
    { "id": 8574, "word": "ពៀច" },
    { "id": 8575, "word": "ពៀប" },
    { "id": 8576, "word": "ពៀរ" },
    { "id": 8577, "word": "ពេក" },
    { "id": 8578, "word": "ពេចន៍" },
    { "id": 8579, "word": "ពេចពិល" },
    { "id": 8580, "word": "ពេជយ័ន្ត" },
    { "id": 8581, "word": "ពេជ្ឈឃាដ" },
    { "id": 8582, "word": "ពេជ្រ" },
    { "id": 8583, "word": "ពេញ" },
    { "id": 8584, "word": "ពេញ --" },
    { "id": 8585, "word": "ពេទ្យ" },
    { "id": 8586, "word": "ពេទ្យមន្ទីរ" },
    { "id": 8587, "word": "ពេទ្យវិទ្យា" },
    { "id": 8588, "word": "ពេទ្យសាស្ត្រ" },
    { "id": 8589, "word": "ពេទ្យស្ថាន" },
    { "id": 8590, "word": "ពេន" },
    { "id": 8591, "word": "ពេប" },
    { "id": 8592, "word": "ពេមពើម" },
    { "id": 8593, "word": "ពេល" },
    { "id": 8594, "word": "ពេលា" },
    { "id": 8595, "word": "ពេស្យា" },
    { "id": 8596, "word": "ពេស្យាគោចរ" },
    { "id": 8597, "word": "ពេស្យាស្ថាន" },
    { "id": 8598, "word": "ពែ" },
    { "id": 8599, "word": "ពែង" },
    { "id": 8600, "word": "ពែងចក" },
    { "id": 8601, "word": "ពែទ្យ" },
    { "id": 8602, "word": "ពែន" },
    { "id": 8603, "word": "ពៃ" },
    { "id": 8604, "word": "ពៃទូរ្យ" },
    { "id": 8605, "word": "ពៃរ៍" },
    { "id": 8606, "word": "ពៃរី" },
    { "id": 8607, "word": "ពៃសាលី" },
    { "id": 8608, "word": "ពៃស្រពណ៍" },
    { "id": 8609, "word": "ពោ" },
    { "id": 8610, "word": "ពោង" },
    { "id": 8611, "word": "ពោងពាយ" },
    { "id": 8612, "word": "ពោជ្ឈង្គ" },
    { "id": 8613, "word": "ពោត" },
    { "id": 8614, "word": "ពោធិ" },
    { "id": 8615, "word": "ពោធិ៍" },
    { "id": 8616, "word": "ពោធិកាល" },
    { "id": 8617, "word": "ពោធិញាណ" },
    { "id": 8618, "word": "ពោធិទ្រុម " },
    { "id": 8619, "word": "ពោធិ៍ធំ" },
    { "id": 8620, "word": "ពោធិ៍ធ្លេ" },
    { "id": 8621, "word": "ពោធិបក្ខិយធម៌" },
    { "id": 8622, "word": "ពោធិ៍បាយ" },
    { "id": 8623, "word": "ពោធិព្រឹក្ស" },
    { "id": 8624, "word": "ពោធិវ័ង្ស" },
    { "id": 8625, "word": "ពោធិសត្វ" },
    { "id": 8626, "word": "ពោធិសម័យ" },
    { "id": 8627, "word": "ពោធិសម្ភារ" },
    { "id": 8628, "word": "ពោធិ៍សាត់" },
    { "id": 8629, "word": "ពោន" },
    { "id": 8630, "word": "ពោនស្វា" },
    { "id": 8631, "word": "ពោប" },
    { "id": 8632, "word": "ពោរ" },
    { "id": 8633, "word": "ពោរយំ" },
    { "id": 8634, "word": "ពោល" },
    { "id": 8635, "word": "ពោល្យំ" },
    { "id": 8636, "word": "ពោះ" },
    { "id": 8637, "word": "ពោះដំឡើង" },
    { "id": 8638, "word": "ពោះតាំង" },
    { "id": 8639, "word": "ពោះពុង" },
    { "id": 8640, "word": "ពោះភ្លាញ" },
    { "id": 8641, "word": "ពោះម៉ាយ" },
    { "id": 8642, "word": "ពោះវៀន" },
    { "id": 8643, "word": "ពោះសម្រក" },
    { "id": 8644, "word": "ពោះអំបែង" },
    { "id": 8645, "word": "ពៅ" },
    { "id": 8646, "word": "ពុំ" },
    { "id": 8647, "word": "ពុំងា" },
    { "id": 8648, "word": "ពុំចេរ" },
    { "id": 8649, "word": "ពុំជូកាល" },
    { "id": 8650, "word": "ពុំនោះ" },
    { "id": 8651, "word": "ពុំសែន" },
    { "id": 8652, "word": "ពំនាក់" },
    { "id": 8653, "word": "ពំនិត" },
    { "id": 8654, "word": "ពំនឹង" },
    { "id": 8655, "word": "ពំនូក" },
    { "id": 8656, "word": "ពំនូត" },
    { "id": 8657, "word": "ពំនួត" },
    { "id": 8658, "word": "ពំនៀរ" },
    { "id": 8659, "word": "ពំនោល" },
    { "id": 8660, "word": "ពាំ" },
    { "id": 8661, "word": "ពាំង" },
    { "id": 8662, "word": "ពះ" },
    { "id": 8663, "word": "ពះ !" },
    { "id": 8664, "word": "ព្កុល" },
    { "id": 8665, "word": "ព្នង" },
    { "id": 8666, "word": "ព្នាយ" },
    { "id": 8667, "word": "ព្និល" },
    { "id": 8668, "word": "ព្នៀត" },
    { "id": 8669, "word": "ព្នៃ" },
    { "id": 8670, "word": "ព្នៅ" },
    { "id": 8671, "word": "ព្យគ្ឃ" },
    { "id": 8672, "word": "ព្យញ្ជនៈ" },
    { "id": 8673, "word": "ព្យញ្ជនសិលិដ្ឋ" },
    { "id": 8674, "word": "ព្យតិហារ" },
    { "id": 8675, "word": "ព្យតោបាត" },
    { "id": 8676, "word": "ព្យត្តបុគ្គល" },
    { "id": 8677, "word": "ព្យត្តភាព" },
    { "id": 8678, "word": "ព្យត្តវោហារ" },
    { "id": 8679, "word": "ព្យសន៍" },
    { "id": 8680, "word": "ព្យាករ" },
    { "id": 8681, "word": "ព្យាករណ៍" },
    { "id": 8682, "word": "ព្យាក្រឹតិ" },
    { "id": 8683, "word": "ព្យាង្គ" },
    { "id": 8684, "word": "ព្យាឌសត្វ" },
    { "id": 8685, "word": "ព្យាធិ" },
    { "id": 8686, "word": "ព្យាធិ៍" },
    { "id": 8687, "word": "ព្យាធិទុក្ខ" },
    { "id": 8688, "word": "ព្យាធិធម៌" },
    { "id": 8689, "word": "ព្យាបទ" },
    { "id": 8690, "word": "ព្យាបាទ" },
    { "id": 8691, "word": "ព្យាបារ" },
    { "id": 8692, "word": "ព្យាបាល" },
    { "id": 8693, "word": "ព្យាម" },
    { "id": 8694, "word": "ព្យាមប្បភា" },
    { "id": 8695, "word": "ព្យាយាម" },
    { "id": 8696, "word": "ព្យុហៈ" },
    { "id": 8697, "word": "ព្យុះ" },
    { "id": 8698, "word": "ព្យូហៈ" },
    { "id": 8699, "word": "ព្យូហ៍" },
    { "id": 8700, "word": "ព្យួរ" },
    { "id": 8701, "word": "ព្យោការ" },
    { "id": 8702, "word": "ព្យោម" },
    { "id": 8703, "word": "ព្រក" },
    { "id": 8704, "word": "ព្រង់" },
    { "id": 8705, "word": "ព្រងាល់" },
    { "id": 8706, "word": "ព្រងើយ" },
    { "id": 8707, "word": "ព្រញូញ" },
    { "id": 8708, "word": "ព្រតៗ" },
    { "id": 8709, "word": "ព្រត" },
    { "id": 8710, "word": "ព្រ័ត្រ" },
    { "id": 8711, "word": "ព្រនង់ " },
    { "id": 8712, "word": "ព្រនម" },
    { "id": 8713, "word": "ព្រនរ" },
    { "id": 8714, "word": "ព្រនាក់" },
    { "id": 8715, "word": "ព្រនាក់ខ្សែត្បាញ" },
    { "id": 8716, "word": "ព្រនាក់បំពង" },
    { "id": 8717, "word": "ព្រនួត" },
    { "id": 8718, "word": "ព្រម" },
    { "id": 8719, "word": "ព្រមរ" },
    { "id": 8720, "word": "ព្រមាន" },
    { "id": 8721, "word": "ព្រមឹក" },
    { "id": 8722, "word": "ព្រយ" },
    { "id": 8723, "word": "ព្រយឺត" },
    { "id": 8724, "word": "ព្រយុង" },
    { "id": 8725, "word": "ព្រយោង" },
    { "id": 8726, "word": "ព្ររឹត" },
    { "id": 8727, "word": "ព្ររួត" },
    { "id": 8728, "word": "ព្រល" },
    { "id": 8729, "word": "ព្រលប់" },
    { "id": 8730, "word": "ព្រលយ" },
    { "id": 8731, "word": "ព្រលិង" },
    { "id": 8732, "word": "ព្រលិត" },
    { "id": 8733, "word": "ព្រលីត" },
    { "id": 8734, "word": "ព្រលីស" },
    { "id": 8735, "word": "ព្រលឹង" },
    { "id": 8736, "word": "ព្រលឹត" },
    { "id": 8737, "word": "ព្រលឹម" },
    { "id": 8738, "word": "ព្រលូង" },
    { "id": 8739, "word": "ព្រលូញ" },
    { "id": 8740, "word": "ព្រលូស" },
    { "id": 8741, "word": "ព្រលួតលាក់" },
    { "id": 8742, "word": "ព្រលែត" },
    { "id": 8743, "word": "ព្រលាំ" },
    { "id": 8744, "word": "ព្រលាំង" },
    { "id": 8745, "word": "ព្រលះ" },
    { "id": 8746, "word": "ព្រវារ" },
    { "id": 8747, "word": "ព្រវីព្រវារ" },
    { "id": 8748, "word": "ព្រវឹង" },
    { "id": 8749, "word": "ព្រវែក" },
    { "id": 8750, "word": "ព្រហក់" },
    { "id": 8751, "word": "ព្រហស្បតិ៍" },
    { "id": 8752, "word": "ព្រហស្បតិចក្រ" },
    { "id": 8753, "word": "ព្រហាម" },
    { "id": 8754, "word": "ព្រហារញ្ញ" },
    { "id": 8755, "word": "ព្រហាវន" },
    { "id": 8756, "word": "ព្រហីត" },
    { "id": 8757, "word": "ព្រហូត" },
    { "id": 8758, "word": "ព្រហួញ" },
    { "id": 8759, "word": "ព្រហួម" },
    { "id": 8760, "word": "ព្រហើន" },
    { "id": 8761, "word": "ព្រហែត" },
    { "id": 8762, "word": "ព្រហ្ម" },
    { "id": 8763, "word": "ព្រហ្ម --" },
    { "id": 8764, "word": "ព្រអូញ" },
    { "id": 8765, "word": "ព្រា" },
    { "id": 8766, "word": "ព្រាក" },
    { "id": 8767, "word": "ព្រាកៗ" },
    { "id": 8768, "word": "ព្រាង" },
    { "id": 8769, "word": "ព្រាច" },
    { "id": 8770, "word": "ព្រាត" },
    { "id": 8771, "word": "ព្រាត់" },
    { "id": 8772, "word": "ព្រាន" },
    { "id": 8773, "word": "ព្រាប" },
    { "id": 8774, "word": "ព្រាម" },
    { "id": 8775, "word": "ព្រាយ" },
    { "id": 8776, "word": "ព្រាល" },
    { "id": 8777, "word": "ព្រាលៗ" },
    { "id": 8778, "word": "ព្រាវ" },
    { "id": 8779, "word": "ព្រាហ្មណ៍" },
    { "id": 8780, "word": "ព្រាហ្មណ្យ" },
    { "id": 8781, "word": "ព្រាហ្មណិក" },
    { "id": 8782, "word": "ព្រាហ្មណី" },
    { "id": 8783, "word": "ព្រិច" },
    { "id": 8784, "word": "ព្រិចៗ" },
    { "id": 8785, "word": "ព្រិញៗ" },
    { "id": 8786, "word": "ព្រិល" },
    { "id": 8787, "word": "ព្រីក" },
    { "id": 8788, "word": "ព្រីង" },
    { "id": 8789, "word": "ព្រឹក" },
    { "id": 8790, "word": "ព្រឹក្ស" },
    { "id": 8791, "word": "ព្រឹក្សា" },
    { "id": 8792, "word": "ព្រឹក្សាជាតិ" },
    { "id": 8793, "word": "ព្រឹត្តិ" },
    { "id": 8794, "word": "ព្រឹត្តិការ" },
    { "id": 8795, "word": "ព្រឹត្តិការណ៍" },
    { "id": 8796, "word": "ព្រឹត្តិបត្រ " },
    { "id": 8797, "word": "ព្រឹទ្ធ" },
    { "id": 8798, "word": "ព្រឹទ្ធសភា" },
    { "id": 8799, "word": "ព្រឹទ្ធាចារ្យ" },
    { "id": 8800, "word": "ព្រឹទ្ធាបចាយនៈ" },
    { "id": 8801, "word": "ព្រឹទ្ធ" },
    { "id": 8802, "word": "ព្រឹទ្ធិកម្ម" },
    { "id": 8803, "word": "ព្រឹទ្ធិរោគ " },
    { "id": 8804, "word": "ព្រឹទ្ធី" },
    { "id": 8805, "word": "ព្រឹន្ទ" },
    { "id": 8806, "word": "ព្រឹប" },
    { "id": 8807, "word": "ព្រឹម" },
    { "id": 8808, "word": "ព្រឹមៗ" },
    { "id": 8809, "word": "ព្រឹល" },
    { "id": 8810, "word": "ព្រឹលៗ" },
    { "id": 8811, "word": "ព្រឹស្ចិក" },
    { "id": 8812, "word": "ព្រឹសភៈ" },
    { "id": 8813, "word": "ព្រឺ" },
    { "id": 8814, "word": "ព្រឺស" },
    { "id": 8815, "word": "ព្រឺះ" },
    { "id": 8816, "word": "ព្រុកៗ" },
    { "id": 8817, "word": "ព្រុយ" },
    { "id": 8818, "word": "ព្រុល" },
    { "id": 8819, "word": "ព្រុស" },
    { "id": 8820, "word": "ព្រូ" },
    { "id": 8821, "word": "ព្រូត" },
    { "id": 8822, "word": "ព្រូន" },
    { "id": 8823, "word": "ព្រូស" },
    { "id": 8824, "word": "ព្រួក" },
    { "id": 8825, "word": "ព្រួច" },
    { "id": 8826, "word": "ព្រួញ" },
    { "id": 8827, "word": "ព្រួត" },
    { "id": 8828, "word": "ព្រួម" },
    { "id": 8829, "word": "ព្រួយ" },
    { "id": 8830, "word": "ព្រួល" },
    { "id": 8831, "word": "ព្រួស" },
    { "id": 8832, "word": "ព្រើត" },
    { "id": 8833, "word": "ព្រើម" },
    { "id": 8834, "word": "ព្រើល" },
    { "id": 8835, "word": "ព្រើស" },
    { "id": 8836, "word": "ព្រៀងលាន" },
    { "id": 8837, "word": "ព្រៀច" },
    { "id": 8838, "word": "ព្រៀប" },
    { "id": 8839, "word": "ព្រេង" },
    { "id": 8840, "word": "ព្រេច" },
    { "id": 8841, "word": "ព្រេន" },
    { "id": 8842, "word": "ព្រែ" },
    { "id": 8843, "word": "ព្រែក" },
    { "id": 8844, "word": "ព្រែល" },
    { "id": 8845, "word": "ព្រៃ" },
    { "id": 8846, "word": "ព្រៃកប្បាស" },
    { "id": 8847, "word": "ព្រៃងារ" },
    { "id": 8848, "word": "ព្រៃឈរ" },
    { "id": 8849, "word": "ព្រៃនគរ" },
    { "id": 8850, "word": "ព្រៃវែង" },
    { "id": 8851, "word": "ព្រៃអង្គរ" },
    { "id": 8852, "word": "ព្រោក" },
    { "id": 8853, "word": "ព្រោង" },
    { "id": 8854, "word": "ព្រោន" },
    { "id": 8855, "word": "ព្រោះ" },
    { "id": 8856, "word": "ព្រៅ" },
    { "id": 8857, "word": "ព្រំ" },
    { "id": 8858, "word": "ព្រាំ" },
    { "id": 8859, "word": "ព្រះ" },
    { "id": 8860, "word": "ព្រះកម្ចាត់" },
    { "id": 8861, "word": "ព្រះកម្ចាយ" },
    { "id": 8862, "word": "ព្រះក្រាប" },
    { "id": 8863, "word": "ព្រះខ្លប" },
    { "id": 8864, "word": "ព្រះជីវ៍" },
    { "id": 8865, "word": "ព្រះតេជព្រះគុណ" },
    { "id": 8866, "word": "ព្រះថោង" },
    { "id": 8867, "word": "ព្រះថ្កោល" },
    { "id": 8868, "word": "ព្រះថ្គោល" },
    { "id": 8869, "word": "ព្រះទ្រហឹង" },
    { "id": 8870, "word": "ព្រះនេត្រព្រះ" },
    { "id": 8871, "word": "ព្រះបត់" },
    { "id": 8872, "word": "ព្រះបាទ" },
    { "id": 8873, "word": "ព្រះប្រធាន" },
    { "id": 8874, "word": "ព្រះរំងាច" },
    { "id": 8875, "word": "ព្រះស្ដេច" },
    { "id": 8876, "word": "ព្រះស្ដែង" },
    { "id": 8877, "word": "ព្រះអង្កោល" },
    { "id": 8878, "word": "ព្រះអន្លក់" },
    { "id": 8879, "word": "ព្លិការ" },
    { "id": 8880, "word": "ព្លុក" },
    { "id": 8881, "word": "ព្លែមៗ" },
    { "id": 8882, "word": "ព្អឹះ" },
    { "id": 8883, "word": "ពំនត់" },
    { "id": 8884, "word": "ពំនូន" },
    { "id": 8885, "word": "ភ" },
    { "id": 8886, "word": "ភក់" },
    { "id": 8887, "word": "ភ័ក" },
    { "id": 8888, "word": "ភក្ដិ" },
    { "id": 8889, "word": "ភក្ដី" },
    { "id": 8890, "word": "ភក្ត្រ" },
    { "id": 8891, "word": "ភក្សា" },
    { "id": 8892, "word": "ភក្សាហារ" },
    { "id": 8893, "word": "ភគណ្ឌលា" },
    { "id": 8894, "word": "ភគន្ទររោគ" },
    { "id": 8895, "word": "ភគវ័ត" },
    { "id": 8896, "word": "ភគវតី" },
    { "id": 8897, "word": "ភគវន្ត" },
    { "id": 8898, "word": "ភគវន្តមុនី" },
    { "id": 8899, "word": "ភគវា" },
    { "id": 8900, "word": "ភគិនី" },
    { "id": 8901, "word": "ភគិនីភស្ដា" },
    { "id": 8902, "word": "ភង្គៈ" },
    { "id": 8903, "word": "ភង្គី" },
    { "id": 8904, "word": "ភណ្ឌ" },
    { "id": 8905, "word": "ភណ្ឌទេយ្យ" },
    { "id": 8906, "word": "ភណ្ឌនៈ" },
    { "id": 8907, "word": "ភណ្ឌហាសិនី" },
    { "id": 8908, "word": "ភណ្ឌាគារ" },
    { "id": 8909, "word": "ភណ្ឌាគារិក" },
    { "id": 8910, "word": "ភណ្ឌិល" },
    { "id": 8911, "word": "ភណ្ឌុកម្ម" },
    { "id": 8912, "word": "ភតិកម្ម" },
    { "id": 8913, "word": "ភតិការ" },
    { "id": 8914, "word": "ភត្ត" },
    { "id": 8915, "word": "ភត្តការ" },
    { "id": 8916, "word": "ភត្តកាល" },
    { "id": 8917, "word": "ភត្តកិច្ច" },
    { "id": 8918, "word": "ភត្តតិរែក" },
    { "id": 8919, "word": "ភត្តានុមោទនា" },
    { "id": 8920, "word": "ភត្តាភិហារ" },
    { "id": 8921, "word": "ភត្តាវសាន" },
    { "id": 8922, "word": "ភត្តាហារ" },
    { "id": 8923, "word": "ភត្តុទ្ទេសកៈ" },
    { "id": 8924, "word": "ភទន្ត" },
    { "id": 8925, "word": "ភទន្តេ !" },
    { "id": 8926, "word": "ភទ្ទកប្ប" },
    { "id": 8927, "word": "ភទ្របទ" },
    { "id": 8928, "word": "ភ័ន្ត" },
    { "id": 8929, "word": "ភប់" },
    { "id": 8930, "word": "ភព" },
    { "id": 8931, "word": "ភ័ព្វ" },
    { "id": 8932, "word": "ភមរ" },
    { "id": 8933, "word": "ភមរជាតិ" },
    { "id": 8934, "word": "ភមរិន្ទ" },
    { "id": 8935, "word": "ភមរី" },
    { "id": 8936, "word": "ភមូ" },
    { "id": 8937, "word": "ភយ" },
    { "id": 8938, "word": "ភ័យ" },
    { "id": 8939, "word": "ភយង្ករ" },
    { "id": 8940, "word": "ភយន្តរាយ" },
    { "id": 8941, "word": "ភយាគតិ" },
    { "id": 8942, "word": "ភយូបទ្រព" },
    { "id": 8943, "word": "ភយូបសគ្គ" },
    { "id": 8944, "word": "ភរ" },
    { "id": 8945, "word": "ភរណកម្ម" },
    { "id": 8946, "word": "ភរណី" },
    { "id": 8947, "word": "ភរិយា" },
    { "id": 8948, "word": "ភរិយាដ" },
    { "id": 8949, "word": "ភរិយាដិក" },
    { "id": 8950, "word": "ភរិយាតិក្រម" },
    { "id": 8951, "word": "ភល" },
    { "id": 8952, "word": "ភវតណ្ហា" },
    { "id": 8953, "word": "ភវាភព" },
    { "id": 8954, "word": "ភស្ដា" },
    { "id": 8955, "word": "ភស្ដុ" },
    { "id": 8956, "word": "ភស្ត្រា" },
    { "id": 8957, "word": "ភស្មការ" },
    { "id": 8958, "word": "ភាគ" },
    { "id": 8959, "word": "ភាគ" },
    { "id": 8960, "word": "ភាគិនេយ្យ" },
    { "id": 8961, "word": "ភាគិនេយ្យា" },
    { "id": 8962, "word": "ភាជនៈ" },
    { "id": 8963, "word": "ភាជនភណ្ឌ" },
    { "id": 8964, "word": "ភាជនវិសេស" },
    { "id": 8965, "word": "ភាជនីយភណ្ឌ" },
    { "id": 8966, "word": "ភាណ" },
    { "id": 8967, "word": "ភាណវារ" },
    { "id": 8968, "word": "ភាណុ" },
    { "id": 8969, "word": "ភាណុមា" },
    { "id": 8970, "word": "ភាតរភាព" },
    { "id": 8971, "word": "ភាតា" },
    { "id": 8972, "word": "ភាតុបុត្ត" },
    { "id": 8973, "word": "ភាតុភាព" },
    { "id": 8974, "word": "ភាន" },
    { "id": 8975, "word": "ភាន់" },
    { "id": 8976, "word": "ភានុ" },
    { "id": 8977, "word": "ភាព" },
    { "id": 8978, "word": "ភាពយន្ត" },
    { "id": 8979, "word": "ភាយ" },
    { "id": 8980, "word": "ភារ" },
    { "id": 8981, "word": "ភារៈ" },
    { "id": 8982, "word": "ភារត" },
    { "id": 8983, "word": "ភារតយុទ្ធ" },
    { "id": 8984, "word": "ភារធារី" },
    { "id": 8985, "word": "ភារា" },
    { "id": 8986, "word": "ភាវ" },
    { "id": 8987, "word": "ភាវ" },
    { "id": 8988, "word": "ភាវនា" },
    { "id": 8989, "word": "ភាវនូបនិស្ស័យ" },
    { "id": 8990, "word": "ភាវរូប" },
    { "id": 8991, "word": "ភាសា" },
    { "id": 8992, "word": "ភាសាបរិវត្តកៈ" },
    { "id": 8993, "word": "ភាសាបរិវត្តន៍" },
    { "id": 8994, "word": "ភាសិត" },
    { "id": 8995, "word": "ភាស៊ី" },
    { "id": 8996, "word": "ភិក្ខវោ  !" },
    { "id": 8997, "word": "ភិក្ខា" },
    { "id": 8998, "word": "ភិក្ខុ" },
    { "id": 8999, "word": "ភិក្ខុនី" },
    { "id": 9000, "word": "ភិត" },
    { "id": 9001, "word": "ភិន" },
    { "id": 9002, "word": "ភិន្នបិតុក" },
    { "id": 9003, "word": "ភិន្នោទរ" },
    { "id": 9004, "word": "ភិយ្យោ" },
    { "id": 9005, "word": "ភិយ្យោភាព" },
    { "id": 9006, "word": "ភិល" },
    { "id": 9007, "word": "ភិសវង់" },
    { "id": 9008, "word": "ភី" },
    { "id": 9009, "word": "ភីង" },
    { "id": 9010, "word": "ភីលភល" },
    { "id": 9011, "word": "ភីលៀង" },
    { "id": 9012, "word": "ភឹង" },
    { "id": 9013, "word": "ភឹប" },
    { "id": 9014, "word": "ភឹល" },
    { "id": 9015, "word": "ភឺតៗ" },
    { "id": 9016, "word": "ភឺន" },
    { "id": 9017, "word": "ភឺស" },
    { "id": 9018, "word": "ភុង" },
    { "id": 9019, "word": "ភុជង្គ" },
    { "id": 9020, "word": "ភុជង្គលីលា" },
    { "id": 9021, "word": "ភុជិស្សជន" },
    { "id": 9022, "word": "ភុជិស្សតា" },
    { "id": 9023, "word": "ភុត្តសេស" },
    { "id": 9024, "word": "ភុម្មទេវតា" },
    { "id": 9025, "word": "ភុយ" },
    { "id": 9026, "word": "ភុល" },
    { "id": 9027, "word": "ភូ" },
    { "id": 9028, "word": "ភូគោល" },
    { "id": 9029, "word": "ភូឈួយ" },
    { "id": 9030, "word": "ភូត" },
    { "id": 9031, "word": "ភូតកាល" },
    { "id": 9032, "word": "ភូតគាម" },
    { "id": 9033, "word": "ភូតពេទ្យ" },
    { "id": 9034, "word": "ភូតរូប" },
    { "id": 9035, "word": "ភូធន" },
    { "id": 9036, "word": "ភូធរ" },
    { "id": 9037, "word": "ភូបាល" },
    { "id": 9038, "word": "ភូម" },
    { "id": 9039, "word": "ភូមទេវតា" },
    { "id": 9040, "word": "ភូមរា" },
    { "id": 9041, "word": "ភូមរិន្ទ" },
    { "id": 9042, "word": "ភូមា" },
    { "id": 9043, "word": "ភូមិ" },
    { "id": 9044, "word": "ភូមិន្ទ" },
    { "id": 9045, "word": "ភូមិបាល" },
    { "id": 9046, "word": "ភូមិសាស្ត្រ" },
    { "id": 9047, "word": "ភូមី" },
    { "id": 9048, "word": "ភូមេន្ទ្រ" },
    { "id": 9049, "word": "ភូមោ" },
    { "id": 9050, "word": "ភូវន័យ" },
    { "id": 9051, "word": "ភូវាំង" },
    { "id": 9052, "word": "ភូស" },
    { "id": 9053, "word": "ភូសា" },
    { "id": 9054, "word": "ភូសាមាលា" },
    { "id": 9055, "word": "ភូះ" },
    { "id": 9056, "word": "ភួង" },
    { "id": 9057, "word": "ភួយ" },
    { "id": 9058, "word": "ភើ" },
    { "id": 9059, "word": "ភើច" },
    { "id": 9060, "word": "ភើតៗ" },
    { "id": 9061, "word": "ភឿន" },
    { "id": 9062, "word": "ភៀស" },
    { "id": 9063, "word": "ភេ" },
    { "id": 9064, "word": "ភេជ្ជរូប" },
    { "id": 9065, "word": "ភេត្រា" },
    { "id": 9066, "word": "ភេទ" },
    { "id": 9067, "word": "ភេរវៈ" },
    { "id": 9068, "word": "ភេរី" },
    { "id": 9069, "word": "ភេល" },
    { "id": 9070, "word": "ភេសជ្ជ" },
    { "id": 9071, "word": "ភែលភល" },
    { "id": 9072, "word": "ភោក្ដា" },
    { "id": 9073, "word": "ភោគ" },
    { "id": 9074, "word": "ភោគសម្ប័ទ" },
    { "id": 9075, "word": "ភោជន" },
    { "id": 9076, "word": "ភោជនាគារ" },
    { "id": 9077, "word": "ភោជនាហារ" },
    { "id": 9078, "word": "ភោជនីយ" },
    { "id": 9079, "word": "ភោជនីយសោភ័ណ" },
    { "id": 9080, "word": "ភោជនីយាហារ" },
    { "id": 9081, "word": "ភោជ្ជភ័ស្តុ" },
    { "id": 9082, "word": "ភោជ្ជសាលី" },
    { "id": 9083, "word": "ភោមីរា" },
    { "id": 9084, "word": "ភោរភាវ" },
    { "id": 9085, "word": "ភុំភឿន" },
    { "id": 9086, "word": "ភាំង" },
    { "id": 9087, "word": "ភ្ងក់ៗ" },
    { "id": 9088, "word": "ភ្ងប់" },
    { "id": 9089, "word": "ភ្ងា" },
    { "id": 9090, "word": "ភ្ងាប្រិយ" },
    { "id": 9091, "word": "ភ្ងារ" },
    { "id": 9092, "word": "ភ្ងាស" },
    { "id": 9093, "word": "ភ្ងូត" },
    { "id": 9094, "word": "ភ្ងើកៗ" },
    { "id": 9095, "word": "ភ្ងើយ" },
    { "id": 9096, "word": "ភ្ងំ" },
    { "id": 9097, "word": "ភ្ជង់" },
    { "id": 9098, "word": "ភ្ជរ" },
    { "id": 9099, "word": "ភ្ជ័រ" },
    { "id": 9100, "word": "ភ្ជល់" },
    { "id": 9101, "word": "ភ្ជាប់" },
    { "id": 9102, "word": "ភ្ជិត" },
    { "id": 9103, "word": "ភ្ជួរ" },
    { "id": 9104, "word": "ភ្ជើញ" },
    { "id": 9105, "word": "ភ្ជោក" },
    { "id": 9106, "word": "ភ្ជុំ" },
    { "id": 9107, "word": "ភ្ជាំ" },
    { "id": 9108, "word": "ភ្ញច់" },
    { "id": 9109, "word": "ភ្ញល់" },
    { "id": 9110, "word": "ភ្ញាក់" },
    { "id": 9111, "word": "ភ្ញាស់" },
    { "id": 9112, "word": "ភ្ញី" },
    { "id": 9113, "word": "ភ្ញីទៀន" },
    { "id": 9114, "word": "ភ្ញៀវ" },
    { "id": 9115, "word": "ភ្នក" },
    { "id": 9116, "word": "ភ្នក់" },
    { "id": 9117, "word": "ភ្នាក់ងារ" },
    { "id": 9118, "word": "ភ្នាក់ដៃ" },
    { "id": 9119, "word": "ភ្នាន" },
    { "id": 9120, "word": "ភ្នាល់" },
    { "id": 9121, "word": "ភ្នាស" },
    { "id": 9122, "word": "ភ្នើន" },
    { "id": 9123, "word": "ភ្នេន" },
    { "id": 9124, "word": "ភ្នែក" },
    { "id": 9125, "word": "ភ្នែកក្រួច" },
    { "id": 9126, "word": "ភ្នែកគោរ" },
    { "id": 9127, "word": "ភ្នែកឆ្មា" },
    { "id": 9128, "word": "ភ្នែកជញ្ជីង" },
    { "id": 9129, "word": "ភ្នែកព្រាប" },
    { "id": 9130, "word": "ភ្នែកមាន់" },
    { "id": 9131, "word": "ភ្នែន" },
    { "id": 9132, "word": "ភ្នែល" },
    { "id": 9133, "word": "ភ្នំ" },
    { "id": 9134, "word": "ភ្នំក្រវាញ" },
    { "id": 9135, "word": "ភ្នំខ្សាច់" },
    { "id": 9136, "word": "ភ្នំពេញ" },
    { "id": 9137, "word": "ភ្នំភ្នែង" },
    { "id": 9138, "word": "ភ្នំយោង" },
    { "id": 9139, "word": "ភ្នំស្រុក" },
    { "id": 9140, "word": "ភ្នំស្រូវ" },
    { "id": 9141, "word": "ភ្នំស្រួច" },
    { "id": 9142, "word": "ភ្នាំ" },
    { "id": 9143, "word": "ភ្មាស" },
    { "id": 9144, "word": "ភ្រមរ" },
    { "id": 9145, "word": "ភ្រឹតក" },
    { "id": 9146, "word": "ភ្រុស" },
    { "id": 9147, "word": "ភ្រូណ" },
    { "id": 9148, "word": "ភ្លក់" },
    { "id": 9149, "word": "ភ្លង" },
    { "id": 9150, "word": "ភ្លន" },
    { "id": 9151, "word": "ភ្លយ" },
    { "id": 9152, "word": "ភ្លា" },
    { "id": 9153, "word": "ភ្លាង" },
    { "id": 9154, "word": "ភ្លាត់" },
    { "id": 9155, "word": "ភ្លាម" },
    { "id": 9156, "word": "ភ្លាវ" },
    { "id": 9157, "word": "ភ្លាស" },
    { "id": 9158, "word": "ភ្លីភ្លើ" },
    { "id": 9159, "word": "ភ្លីះភ្លែះ" },
    { "id": 9160, "word": "ភ្លឹក" },
    { "id": 9161, "word": "ភ្លឹង" },
    { "id": 9162, "word": "ភ្លឹប" },
    { "id": 9163, "word": "ភ្លឹមៗ " },
    { "id": 9164, "word": "ភ្លឹះៗ" },
    { "id": 9165, "word": "ភ្លឺ" },
    { "id": 9166, "word": "ភ្លុក" },
    { "id": 9167, "word": "ភ្លុង" },
    { "id": 9168, "word": "ភ្លូ" },
    { "id": 9169, "word": "ភ្លូក" },
    { "id": 9170, "word": "ភ្លូច" },
    { "id": 9171, "word": "ភ្លួត" },
    { "id": 9172, "word": "ភ្លើ" },
    { "id": 9173, "word": "ភ្លើកៗ" },
    { "id": 9174, "word": "ភ្លើង" },
    { "id": 9175, "word": "ភ្លើតភ្លើន" },
    { "id": 9176, "word": "ភ្លើន" },
    { "id": 9177, "word": "ភ្លើយ" },
    { "id": 9178, "word": "ភ្លៀក" },
    { "id": 9179, "word": "ភ្លៀង" },
    { "id": 9180, "word": "ភ្លេង" },
    { "id": 9181, "word": "ភ្លេច" },
    { "id": 9182, "word": "ភ្លែត" },
    { "id": 9183, "word": "ភ្លែមៗ" },
    { "id": 9184, "word": "ភ្លែល" },
    { "id": 9185, "word": "ភ្លោះ" },
    { "id": 9186, "word": "ភ្លៅ" },
    { "id": 9187, "word": "ភ្លៅកង្កែប" },
    { "id": 9188, "word": "ភ្លៅក្ងោក" },
    { "id": 9189, "word": "ភ្លៅនាង" },
    { "id": 9190, "word": "ភ្លាំង" },
    { "id": 9191, "word": "ភ្សាំ" },
    { "id": 9192, "word": "ម" },
    { "id": 9193, "word": "ម៏" },
    { "id": 9194, "word": "មក" },
    { "id": 9195, "word": "ម៉ក" },
    { "id": 9196, "word": "ម៉ក់" },
    { "id": 9197, "word": "ម៉ក់ៗ" },
    { "id": 9198, "word": "មករ" },
    { "id": 9199, "word": "មករ" },
    { "id": 9200, "word": "មករន្ទ" },
    { "id": 9201, "word": "មកា" },
    { "id": 9202, "word": "មការន្ត" },
    { "id": 9203, "word": "មកុដ" },
    { "id": 9204, "word": "មក្ខជន" },
    { "id": 9205, "word": "មក្លឿ" },
    { "id": 9206, "word": "មក្លាំ" },
    { "id": 9207, "word": "មគធៈ" },
    { "id": 9208, "word": "មគធពាក្យ" },
    { "id": 9209, "word": "មគធភាសា" },
    { "id": 9210, "word": "មគធរដ្ឋ" },
    { "id": 9211, "word": "មគ្គ" },
    { "id": 9212, "word": "មគ្គទេសក៍" },
    { "id": 9213, "word": "មគ្គនកម្ម" },
    { "id": 9214, "word": "មគ្គនាយក" },
    { "id": 9215, "word": "មឃវ័ត" },
    { "id": 9216, "word": "មឃវា" },
    { "id": 9217, "word": "មង" },
    { "id": 9218, "word": "ម៉ង់ៗ" },
    { "id": 9219, "word": "មង្កុភាព" },
    { "id": 9220, "word": "មង្កុភូត" },
    { "id": 9221, "word": "មង្គល" },
    { "id": 9222, "word": "មង្គលទេពាចារ្យ" },
    { "id": 9223, "word": "មង្គលបុរី" },
    { "id": 9224, "word": "មង្ឃុត" },
    { "id": 9225, "word": "មច្ចុ" },
    { "id": 9226, "word": "មច្ឆជាតិ" },
    { "id": 9227, "word": "មច្ឆណ្ឌសញ្ញា" },
    { "id": 9228, "word": "មច្ឆព័ន្ធ" },
    { "id": 9229, "word": "មច្ឆរិយ" },
    { "id": 9230, "word": "មច្ឆរី" },
    { "id": 9231, "word": "មច្ឆា" },
    { "id": 9232, "word": "មច្ឆានុ" },
    { "id": 9233, "word": "មច្ឆេរចិត្ត" },
    { "id": 9234, "word": "ម៉ឆែ" },
    { "id": 9235, "word": "មជ្ជ" },
    { "id": 9236, "word": "មជ្ជារ" },
    { "id": 9237, "word": "មជ្ឈដ្ឋាន" },
    { "id": 9238, "word": "មជ្ឈត្តារម្មណ៍" },
    { "id": 9239, "word": "មជ្ឈន្តិកកាល" },
    { "id": 9240, "word": "មជ្ឈមណ្ឌល" },
    { "id": 9241, "word": "មជ្ឈិម" },
    { "id": 9242, "word": "មជ្ឈេលុប" },
    { "id": 9243, "word": "មឈូស" },
    { "id": 9244, "word": "មញ្ជិកា" },
    { "id": 9245, "word": "មញ្ជូសា" },
    { "id": 9246, "word": "មញ្ជេដ្ឋ" },
    { "id": 9247, "word": "ម៉ដ្ដ" },
    { "id": 9248, "word": "មណី" },
    { "id": 9249, "word": "មណ្ឌនភណ្ឌ" },
    { "id": 9250, "word": "មណ្ឌប" },
    { "id": 9251, "word": "មណ្ឌល" },
    { "id": 9252, "word": "មណ្ឌលគិរី" },
    { "id": 9253, "word": "មណ្ឌលវាត" },
    { "id": 9254, "word": "មណ្ឌុកដ" },
    { "id": 9255, "word": "មត់" },
    { "id": 9256, "word": "មតក" },
    { "id": 9257, "word": "ម៉ត់" },
    { "id": 9258, "word": "ម៉ត់ចត់" },
    { "id": 9259, "word": "ម៉ត់ម៉ង" },
    { "id": 9260, "word": "មតិ" },
    { "id": 9261, "word": "មត្តញ្ញុតា" },
    { "id": 9262, "word": "មត្តញ្ញូ" },
    { "id": 9263, "word": "មត្តិកា" },
    { "id": 9264, "word": "មត្តេយ្យកៈ" },
    { "id": 9265, "word": "មទ្ទរដ្ឋ" },
    { "id": 9266, "word": "មទ្រី" },
    { "id": 9267, "word": "មទ្រីបាព៌" },
    { "id": 9268, "word": "មធុ" },
    { "id": 9269, "word": "មធុមេហៈ" },
    { "id": 9270, "word": "មធុរៈ" },
    { "id": 9271, "word": "មធុរស" },
    { "id": 9272, "word": "មធុរោទក" },
    { "id": 9273, "word": "មធ្យ័ត" },
    { "id": 9274, "word": "មធ្យម" },
    { "id": 9275, "word": "មធ្យោបាយ" },
    { "id": 9276, "word": "មន" },
    { "id": 9277, "word": "មនសិការ" },
    { "id": 9278, "word": "មនស្ការ" },
    { "id": 9279, "word": "មនាបៈ" },
    { "id": 9280, "word": "មនុ" },
    { "id": 9281, "word": "មនុជាធិបតី" },
    { "id": 9282, "word": "មនុជិន្ទ" },
    { "id": 9283, "word": "មនុញ្ញ" },
    { "id": 9284, "word": "មនុសារ" },
    { "id": 9285, "word": "មនុស្ស" },
    { "id": 9286, "word": "មនូសារ" },
    { "id": 9287, "word": "មនោ" },
    { "id": 9288, "word": "មនោសារ" },
    { "id": 9289, "word": "មនោសិលា" },
    { "id": 9290, "word": "មន្ត" },
    { "id": 9291, "word": "មន្ត្រវិត" },
    { "id": 9292, "word": "មន្ត្រី" },
    { "id": 9293, "word": "មន្ទលេន" },
    { "id": 9294, "word": "មន្ទារ" },
    { "id": 9295, "word": "មន្ទិល" },
    { "id": 9296, "word": "មន្ទីរ" },
    { "id": 9297, "word": "មន្ទីរបាល" },
    { "id": 9298, "word": "មន្ទុរា" },
    { "id": 9299, "word": "មន្ទោទរី" },
    { "id": 9300, "word": "ម៉ប" },
    { "id": 9301, "word": "មមង់" },
    { "id": 9302, "word": "មមង្ការ" },
    { "id": 9303, "word": "មមាច" },
    { "id": 9304, "word": "មមាញ" },
    { "id": 9305, "word": "មមាញឹក" },
    { "id": 9306, "word": "មមាយ" },
    { "id": 9307, "word": "មមាល" },
    { "id": 9308, "word": "មមិងមមាំង" },
    { "id": 9309, "word": "មមិចមមៀវ" },
    { "id": 9310, "word": "មមី" },
    { "id": 9311, "word": "មមីស" },
    { "id": 9312, "word": "មមឹះ" },
    { "id": 9313, "word": "មមុល" },
    { "id": 9314, "word": "មមើ" },
    { "id": 9315, "word": "មមើក" },
    { "id": 9316, "word": "មមៀរ" },
    { "id": 9317, "word": "មម៉េះមម៉ោះ" },
    { "id": 9318, "word": "មមែ" },
    { "id": 9319, "word": "មមៃ" },
    { "id": 9320, "word": "មមោក" },
    { "id": 9321, "word": "មមំការ" },
    { "id": 9322, "word": "មយី" },
    { "id": 9323, "word": "មយូរ" },
    { "id": 9324, "word": "មយូរឆត្រ " },
    { "id": 9325, "word": "មរ" },
    { "id": 9326, "word": "មរកត" },
    { "id": 9327, "word": "មរដក" },
    { "id": 9328, "word": "មរណៈ" },
    { "id": 9329, "word": "មរណ" },
    { "id": 9330, "word": "មរណា" },
    { "id": 9331, "word": "មរណុបាយ" },
    { "id": 9332, "word": "មរតក" },
    { "id": 9333, "word": "មរុកន្តារ" },
    { "id": 9334, "word": "មលក្កា" },
    { "id": 9335, "word": "មល៉ាយូ" },
    { "id": 9336, "word": "មល្ល" },
    { "id": 9337, "word": "មល្លិកា" },
    { "id": 9338, "word": "មសារគល្ល" },
    { "id": 9339, "word": "មសិ" },
    { "id": 9340, "word": "មស្សុ" },
    { "id": 9341, "word": "មហកម្ម" },
    { "id": 9342, "word": "មហណ្ណព" },
    { "id": 9343, "word": "មហទ្ធន" },
    { "id": 9344, "word": "មហន្ត" },
    { "id": 9345, "word": "មហន្ធការ" },
    { "id": 9346, "word": "មហយ្យកោ" },
    { "id": 9347, "word": "មហយ្យកា" },
    { "id": 9348, "word": "មហល្លកៈ" },
    { "id": 9349, "word": "មហល្លកភាព" },
    { "id": 9350, "word": "មហស្ចារ្យ" },
    { "id": 9351, "word": "មហា" },
    { "id": 9352, "word": "មហា --" },
    { "id": 9353, "word": "មហាកថានៈ" },
    { "id": 9354, "word": "មហាត" },
    { "id": 9355, "word": "មហាតថៃ" },
    { "id": 9356, "word": "មហាតលិក" },
    { "id": 9357, "word": "មហាត្រកាល" },
    { "id": 9358, "word": "មហាត្រសោល" },
    { "id": 9359, "word": "មហាថៃ" },
    { "id": 9360, "word": "មហាថ្លៃ" },
    { "id": 9361, "word": "មហាបុរិសលក្ខណៈ" },
    { "id": 9362, "word": "មហាផ្ទៃ" },
    { "id": 9363, "word": "មហាភារតៈ" },
    { "id": 9364, "word": "មហាភារតយុទ្ធ" },
    { "id": 9365, "word": "មហាម៉ាត់" },
    { "id": 9366, "word": "មហារលាយ" },
    { "id": 9367, "word": "មហារាស្ត្រី" },
    { "id": 9368, "word": "មហារីក" },
    { "id": 9369, "word": "មហារម្លាយ" },
    { "id": 9370, "word": "មហាសុមេធាធិបតី" },
    { "id": 9371, "word": "មហាហង្ស" },
    { "id": 9372, "word": "មហាហិង្គុ" },
    { "id": 9373, "word": "មហាអុច" },
    { "id": 9374, "word": "មហិច្ឆតា" },
    { "id": 9375, "word": "មហិទ្ធានុភាព" },
    { "id": 9376, "word": "មហិទ្ធិឫទ្ធិ" },
    { "id": 9377, "word": "មហិន្ទត្ថេរ" },
    { "id": 9378, "word": "មហិមា" },
    { "id": 9379, "word": "មហិស្សរៈ" },
    { "id": 9380, "word": "មហី" },
    { "id": 9381, "word": "មហីលតា" },
    { "id": 9382, "word": "មហឹសា" },
    { "id": 9383, "word": "មហេសក្ខ" },
    { "id": 9384, "word": "មហេសី" },
    { "id": 9385, "word": "មហេស្វរៈ" },
    { "id": 9386, "word": "មហៃសូរ្យ" },
    { "id": 9387, "word": "មហោឃ" },
    { "id": 9388, "word": "មហោរធឹក" },
    { "id": 9389, "word": "មហោរស្រព" },
    { "id": 9390, "word": "មហោរី" },
    { "id": 9391, "word": "មហោសថ" },
    { "id": 9392, "word": "មហោស្រព" },
    { "id": 9393, "word": "មហោឡារ" },
    { "id": 9394, "word": "មហោឡារិក" },
    { "id": 9395, "word": "មា" },
    { "id": 9396, "word": "ម៉ាក់" },
    { "id": 9397, "word": "មាក់ក្លឿ" },
    { "id": 9398, "word": "មាក់ងាយ" },
    { "id": 9399, "word": "មាក់ដោក" },
    { "id": 9400, "word": "មាក់ថោក" },
    { "id": 9401, "word": "មាក់បាត" },
    { "id": 9402, "word": "មាក់ប៉ែន" },
    { "id": 9403, "word": "មាក់ប្រាង" },
    { "id": 9404, "word": "មាក់ប្រិង" },
    { "id": 9405, "word": "មាក់ប្រេង" },
    { "id": 9406, "word": "មាក់សាង" },
    { "id": 9407, "word": "មាក់សាន់" },
    { "id": 9408, "word": "មាគធៈ" },
    { "id": 9409, "word": "មាគធី" },
    { "id": 9410, "word": "មាគសិរ" },
    { "id": 9411, "word": "មាគ៌" },
    { "id": 9412, "word": "មាគ៌ា" },
    { "id": 9413, "word": "មាឃ" },
    { "id": 9414, "word": "មាឃនក្សត្រ" },
    { "id": 9415, "word": "មាឃបូជា" },
    { "id": 9416, "word": "ម៉ាង" },
    { "id": 9417, "word": "ម៉ាច់" },
    { "id": 9418, "word": "មាឌ" },
    { "id": 9419, "word": "មាណព" },
    { "id": 9420, "word": "មាណពក៍" },
    { "id": 9421, "word": "មាណវិកា" },
    { "id": 9422, "word": "មាត់" },
    { "id": 9423, "word": "ម៉ាត់" },
    { "id": 9424, "word": "មាត់ចាប" },
    { "id": 9425, "word": "មាត់ជ្រូក" },
    { "id": 9426, "word": "មាត់ដង្កាប់" },
    { "id": 9427, "word": "មាត់នៀវ" },
    { "id": 9428, "word": "មាតលី" },
    { "id": 9429, "word": "មាតា" },
    { "id": 9430, "word": "មាតាបិតុគុណ" },
    { "id": 9431, "word": "មាតាបិតុបដ្ឋាន" },
    { "id": 9432, "word": "មាតាមហៈ" },
    { "id": 9433, "word": "មាតាមហយ្យកៈ" },
    { "id": 9434, "word": "មាតាមហយ្យកា" },
    { "id": 9435, "word": "មាតាមហី" },
    { "id": 9436, "word": "មាតិកា" },
    { "id": 9437, "word": "មាតិកានុក្រម" },
    { "id": 9438, "word": "មាតិកាប្រភេទ" },
    { "id": 9439, "word": "មាតុគុណ" },
    { "id": 9440, "word": "មាតុគ្រាម" },
    { "id": 9441, "word": "មាតុឃាត" },
    { "id": 9442, "word": "មាតុឃាតកៈ" },
    { "id": 9443, "word": "មាតុឃាតិកា" },
    { "id": 9444, "word": "មាតុច្ឆា" },
    { "id": 9445, "word": "មាតុប្រទេស" },
    { "id": 9446, "word": "មាតុភូមិ" },
    { "id": 9447, "word": "មាតុលៈ" },
    { "id": 9448, "word": "មាតុលានី" },
    { "id": 9449, "word": "មាត្រ" },
    { "id": 9450, "word": "មាត្រា" },
    { "id": 9451, "word": "មាត្រាទណ្ឌ" },
    { "id": 9452, "word": "មាន" },
    { "id": 9453, "word": "មាន់" },
    { "id": 9454, "word": "មានទណ្ឌ" },
    { "id": 9455, "word": "មាន់ទឹក" },
    { "id": 9456, "word": "មាន់ទោរ" },
    { "id": 9457, "word": "មាន់ព្រៃ" },
    { "id": 9458, "word": "មាន់រងាវ" },
    { "id": 9459, "word": "មានះ" },
    { "id": 9460, "word": "មាយា" },
    { "id": 9461, "word": "មាយី" },
    { "id": 9462, "word": "មារ" },
    { "id": 9463, "word": "មារគា" },
    { "id": 9464, "word": "មារយាទ" },
    { "id": 9465, "word": "មាលសាលា" },
    { "id": 9466, "word": "មាលកសាលា" },
    { "id": 9467, "word": "មាលតី" },
    { "id": 9468, "word": "មាល័យ" },
    { "id": 9469, "word": "មាលា" },
    { "id": 9470, "word": "មាលាការ" },
    { "id": 9471, "word": "មាលាវិក័តិ" },
    { "id": 9472, "word": "មាលី" },
    { "id": 9473, "word": "មាល្បាយ" },
    { "id": 9474, "word": "មាស" },
    { "id": 9475, "word": "មាសក" },
    { "id": 9476, "word": "មាសម័យ" },
    { "id": 9477, "word": "មាសសេស" },
    { "id": 9478, "word": "មាសស្ងួន" },
    { "id": 9479, "word": "មាសានុប្បវត្តិ" },
    { "id": 9480, "word": "មាសានុប្រព្រឹត្តិ" },
    { "id": 9481, "word": "មាសិកជន" },
    { "id": 9482, "word": "មាសិកា" },
    { "id": 9483, "word": "ម៉ាស៊ីន" },
    { "id": 9484, "word": "មិគជាតិ" },
    { "id": 9485, "word": "មិគទាយពន" },
    { "id": 9486, "word": "មិគព័ន្ធន៍" },
    { "id": 9487, "word": "មិគរាជ" },
    { "id": 9488, "word": "មិគសិរ" },
    { "id": 9489, "word": "មិងមាំង" },
    { "id": 9490, "word": "មិច" },
    { "id": 9491, "word": "មិច្ឆា" },
    { "id": 9492, "word": "មិច្ឆា --" },
    { "id": 9493, "word": "មិតភាណី" },
    { "id": 9494, "word": "ម៉ិតប្រាយ" },
    { "id": 9495, "word": "មិត្ត" },
    { "id": 9496, "word": "មិត្តទ្រុស្ត" },
    { "id": 9497, "word": "មិត្តភាព" },
    { "id": 9498, "word": "មិត្តភេទ" },
    { "id": 9499, "word": "មិត្តភ្ងា" },
    { "id": 9500, "word": "មិត្តលាភ" },
    { "id": 9501, "word": "មិត្តសន្ថវភាព" },
    { "id": 9502, "word": "មិត្រ" },
    { "id": 9503, "word": "មិត្រភាព" },
    { "id": 9504, "word": "មិត្រភេទ" },
    { "id": 9505, "word": "មិត្រភ្ងា" },
    { "id": 9506, "word": "មិត្រលាភ" },
    { "id": 9507, "word": "មិត្រាភិបាល" },
    { "id": 9508, "word": "មិថិលា" },
    { "id": 9509, "word": "មិថុន" },
    { "id": 9510, "word": "មិថុនរាសី" },
    { "id": 9511, "word": "មិថ្យាចារ" },
    { "id": 9512, "word": "មិទ្ធៈ" },
    { "id": 9513, "word": "មិន" },
    { "id": 9514, "word": "ម៉ិម" },
    { "id": 9515, "word": "ម៉ិមៗ" },
    { "id": 9516, "word": "មិលក្ខៈ" },
    { "id": 9517, "word": "មិល្លីម៉ែត្រ" },
    { "id": 9518, "word": "មី" },
    { "id": 9519, "word": "មីង" },
    { "id": 9520, "word": "មីន" },
    { "id": 9521, "word": "មីនរាសី" },
    { "id": 9522, "word": "មីរ" },
    { "id": 9523, "word": "មីសួ" },
    { "id": 9524, "word": "មឹក" },
    { "id": 9525, "word": "មឹង" },
    { "id": 9526, "word": "ម៉ឹង" },
    { "id": 9527, "word": "ម៉ឹងៗ" },
    { "id": 9528, "word": "មឹត" },
    { "id": 9529, "word": "មឹតពត់" },
    { "id": 9530, "word": "មឹន" },
    { "id": 9531, "word": "ម៉ឹប" },
    { "id": 9532, "word": "ម៉ឹម" },
    { "id": 9533, "word": "ម៉ឹមៗ" },
    { "id": 9534, "word": "មឹះៗ" },
    { "id": 9535, "word": "ម៉ឺង" },
    { "id": 9536, "word": "មឺត" },
    { "id": 9537, "word": "ម៉ឺន" },
    { "id": 9538, "word": "មុក្ដា" },
    { "id": 9539, "word": "មុខ" },
    { "id": 9540, "word": "មុខកំពូល" },
    { "id": 9541, "word": "មុខគួរ" },
    { "id": 9542, "word": "មុខជា" },
    { "id": 9543, "word": "មុខឈ្នាង" },
    { "id": 9544, "word": "មុខដាច់" },
    { "id": 9545, "word": "មុខតែ" },
    { "id": 9546, "word": "មុខទ្វារ" },
    { "id": 9547, "word": "មុខបាឋ" },
    { "id": 9548, "word": "មុខបាទ" },
    { "id": 9549, "word": "មុខមគ្គ" },
    { "id": 9550, "word": "មុខរោ" },
    { "id": 9551, "word": "មុង" },
    { "id": 9552, "word": "ម៉ុង" },
    { "id": 9553, "word": "មុង្គ្រេ" },
    { "id": 9554, "word": "មុច្ឆា" },
    { "id": 9555, "word": "មុជ" },
    { "id": 9556, "word": "មុញ្ចនាការ" },
    { "id": 9557, "word": "មុញ្ចនោបាយ" },
    { "id": 9558, "word": "មុត" },
    { "id": 9559, "word": "មុតមាំ" },
    { "id": 9560, "word": "មុត្តា" },
    { "id": 9561, "word": "មុទិតា" },
    { "id": 9562, "word": "មុទុ" },
    { "id": 9563, "word": "មុទុតា" },
    { "id": 9564, "word": "មុទ្ធជៈ" },
    { "id": 9565, "word": "មុទ្ធា" },
    { "id": 9566, "word": "មុទ្ធាភិសិត្ត" },
    { "id": 9567, "word": "មុទ្ធាភិសេក" },
    { "id": 9568, "word": "មុទ្រា" },
    { "id": 9569, "word": "មុន" },
    { "id": 9570, "word": "មុនិ" },
    { "id": 9571, "word": "មុនី" },
    { "id": 9572, "word": "មុម" },
    { "id": 9573, "word": "ម៉ុម" },
    { "id": 9574, "word": "មុយៗ" },
    { "id": 9575, "word": "មុសា" },
    { "id": 9576, "word": "មុសាវាទ" },
    { "id": 9577, "word": "មុសាវាទី" },
    { "id": 9578, "word": "មុហុត្តវិជាតវាទី" },
    { "id": 9579, "word": "ម៉ូក" },
    { "id": 9580, "word": "មូគវត្ត" },
    { "id": 9581, "word": "មូង" },
    { "id": 9582, "word": "ម៉ូង" },
    { "id": 9583, "word": "ម៉ូងគ្រុំ" },
    { "id": 9584, "word": "ម៉ូត" },
    { "id": 9585, "word": "មូត្រ" },
    { "id": 9586, "word": "មូត្រាស័យ" },
    { "id": 9587, "word": "មូទូ" },
    { "id": 9588, "word": "មូរ" },
    { "id": 9589, "word": "មូរតី" },
    { "id": 9590, "word": "មូរ៉ា" },
    { "id": 9591, "word": "មូល" },
    { "id": 9592, "word": "មូលី" },
    { "id": 9593, "word": "មូល្យ" },
    { "id": 9594, "word": "មូស" },
    { "id": 9595, "word": "មូសិកទន្ត" },
    { "id": 9596, "word": "មូស្យាយ័ណ" },
    { "id": 9597, "word": "មូឡ្ហៈ" },
    { "id": 9598, "word": "មួ" },
    { "id": 9599, "word": "មួក" },
    { "id": 9600, "word": "មួន" },
    { "id": 9601, "word": "មួម៉ៅ" },
    { "id": 9602, "word": "មួយ" },
    { "id": 9603, "word": "មួយក្លាយជាដប់" },
    { "id": 9604, "word": "មួយអន្លើ" },
    { "id": 9605, "word": "មួរ" },
    { "id": 9606, "word": "មួល" },
    { "id": 9607, "word": "មួហ្មង" },
    { "id": 9608, "word": "មើ" },
    { "id": 9609, "word": "មើកៗ" },
    { "id": 9610, "word": "មើម" },
    { "id": 9611, "word": "មើល" },
    { "id": 9612, "word": "មើលងាយ" },
    { "id": 9613, "word": "មើលបំណាំ" },
    { "id": 9614, "word": "មឿង" },
    { "id": 9615, "word": "មៀង" },
    { "id": 9616, "word": "មៀងមើល" },
    { "id": 9617, "word": "មៀន" },
    { "id": 9618, "word": "មៀម" },
    { "id": 9619, "word": "មេ" },
    { "id": 9620, "word": "មេ ! " },
    { "id": 9621, "word": "មេកង" },
    { "id": 9622, "word": "មេកន្ទ្រាញ" },
    { "id": 9623, "word": "មេកុង" },
    { "id": 9624, "word": "មេកំព្រា" },
    { "id": 9625, "word": "មេក្រមី" },
    { "id": 9626, "word": "មេខលា" },
    { "id": 9627, "word": "មេខា" },
    { "id": 9628, "word": "មេខ្លោង" },
    { "id": 9629, "word": "មេគណ" },
    { "id": 9630, "word": "មេឃ" },
    { "id": 9631, "word": "មេឃច្ឆាយ" },
    { "id": 9632, "word": "មេឃុំ" },
    { "id": 9633, "word": "ម៉េច" },
    { "id": 9634, "word": "មេឆា" },
    { "id": 9635, "word": "មេជ័រ" },
    { "id": 9636, "word": "មេជី" },
    { "id": 9637, "word": "មេដាយ" },
    { "id": 9638, "word": "មេដែក" },
    { "id": 9639, "word": "មេដោះ" },
    { "id": 9640, "word": "មេដំបូល" },
    { "id": 9641, "word": "ម៉េតប្រាយ" },
    { "id": 9642, "word": "មេត្តា" },
    { "id": 9643, "word": "មេត្រី" },
    { "id": 9644, "word": "មេថុន" },
    { "id": 9645, "word": "មេទនី" },
    { "id": 9646, "word": "មេទោ" },
    { "id": 9647, "word": "មេធគភាព" },
    { "id": 9648, "word": "មេធា" },
    { "id": 9649, "word": "មេធាវី" },
    { "id": 9650, "word": "មេន" },
    { "id": 9651, "word": "មេនំ" },
    { "id": 9652, "word": "មេបា" },
    { "id": 9653, "word": "មេភ្លៀង" },
    { "id": 9654, "word": "មេមត់" },
    { "id": 9655, "word": "មេម៉ាយ" },
    { "id": 9656, "word": "មេរ័យ" },
    { "id": 9657, "word": "មេរុ" },
    { "id": 9658, "word": "មេរៀម" },
    { "id": 9659, "word": "មេលឹម" },
    { "id": 9660, "word": "មេលេខ" },
    { "id": 9661, "word": "មេលោង" },
    { "id": 9662, "word": "មេលំ" },
    { "id": 9663, "word": "មេវត្ត" },
    { "id": 9664, "word": "មេ-ស" },
    { "id": 9665, "word": "មេស" },
    { "id": 9666, "word": "មេសបាល" },
    { "id": 9667, "word": "មេសរាសី" },
    { "id": 9668, "word": "មេសូត្រ" },
    { "id": 9669, "word": "មេស្រុក" },
    { "id": 9670, "word": "មេអណ្ដើក" },
    { "id": 9671, "word": "មេអំបៅ" },
    { "id": 9672, "word": "មែ" },
    { "id": 9673, "word": "ម៉ែ" },
    { "id": 9674, "word": "មែក" },
    { "id": 9675, "word": "ម៉ែត្រ" },
    { "id": 9676, "word": "មែន" },
    { "id": 9677, "word": "មែនមាន" },
    { "id": 9678, "word": "ម៉ៃ" },
    { "id": 9679, "word": "មៃៗ" },
    { "id": 9680, "word": "ម៉ៃស័ក" },
    { "id": 9681, "word": "មោក" },
    { "id": 9682, "word": "មោក្ខ" },
    { "id": 9683, "word": "មោក្ខុបាយ" },
    { "id": 9684, "word": "មោគ្គល្លាន" },
    { "id": 9685, "word": "មោឃ" },
    { "id": 9686, "word": "មោង" },
    { "id": 9687, "word": "ម៉ោង" },
    { "id": 9688, "word": "ម៉ោងជាង" },
    { "id": 9689, "word": "មោទកភាព" },
    { "id": 9690, "word": "មោទនា" },
    { "id": 9691, "word": "មោនភាព" },
    { "id": 9692, "word": "មោនេយ្យភាព" },
    { "id": 9693, "word": "មោរកលាប" },
    { "id": 9694, "word": "មោរ៉ា" },
    { "id": 9695, "word": "មោលី" },
    { "id": 9696, "word": "មោហៈ" },
    { "id": 9697, "word": "មោហ៍" },
    { "id": 9698, "word": "មោហន្ធ" },
    { "id": 9699, "word": "មោហន្ធការ" },
    { "id": 9700, "word": "មោហាគតិ" },
    { "id": 9701, "word": "មោហោ" },
    { "id": 9702, "word": "មោះ" },
    { "id": 9703, "word": "មោះមុត" },
    { "id": 9704, "word": "មៅ" },
    { "id": 9705, "word": "ម៉ៅ" },
    { "id": 9706, "word": "មំសៈ" },
    { "id": 9707, "word": "មំសំ" },
    { "id": 9708, "word": "មាំ" },
    { "id": 9709, "word": "ម៉ាំ" },
    { "id": 9710, "word": "ម៉ាំង" },
    { "id": 9711, "word": "ម្កាក់" },
    { "id": 9712, "word": "ម្កាល" },
    { "id": 9713, "word": "ម្ខាង" },
    { "id": 9714, "word": "ម្ង៉ិកម៉្ងក់" },
    { "id": 9715, "word": "ម្ង៉ៃ" },
    { "id": 9716, "word": "ម្ចត់" },
    { "id": 9717, "word": "ម្ចាក់" },
    { "id": 9718, "word": "ម្ចាន" },
    { "id": 9719, "word": "ម្ចាស់" },
    { "id": 9720, "word": "ម្ចាស់ជីវិត" },
    { "id": 9721, "word": "ម្ចាស់ផែនដី" },
    { "id": 9722, "word": "ម្ជុល" },
    { "id": 9723, "word": "ម្ជូរ" },
    { "id": 9724, "word": "ម្ញ៉ិកម្ញ៉ក់" },
    { "id": 9725, "word": "ម្ញ៉ែម្ញ៉" },
    { "id": 9726, "word": "ម្ដង" },
    { "id": 9727, "word": "ម្ដា" },
    { "id": 9728, "word": "ម្ដាយ" },
    { "id": 9729, "word": "ម្ដេច" },
    { "id": 9730, "word": "ម្ដុំ" },
    { "id": 9731, "word": "ម្ទេស" },
    { "id": 9732, "word": "ម្នា" },
    { "id": 9733, "word": "ម្នាក់ " },
    { "id": 9734, "word": "ម្នាង" },
    { "id": 9735, "word": "ម្នាងសិលា" },
    { "id": 9736, "word": "ម្នាល" },
    { "id": 9737, "word": "ម្នាស់" },
    { "id": 9738, "word": "ម្និល" },
    { "id": 9739, "word": "ម្នីម្នា" },
    { "id": 9740, "word": "ម្នេញ" },
    { "id": 9741, "word": "ម្នោម្នេញ" },
    { "id": 9742, "word": "ម្នោម្នះ" },
    { "id": 9743, "word": "ម្នៅៗ" },
    { "id": 9744, "word": "ម្ភៃ" },
    { "id": 9745, "word": "ម្យប់" },
    { "id": 9746, "word": "ម្យ៉ាង" },
    { "id": 9747, "word": "ម្យាម" },
    { "id": 9748, "word": "ម្យីម្យ៉" },
    { "id": 9749, "word": "ម្យីម្យា" },
    { "id": 9750, "word": "ម្យ៉ែម្យ៉" },
    { "id": 9751, "word": "ម្រយ" },
    { "id": 9752, "word": "ម្រ័ក្សណ៍" },
    { "id": 9753, "word": "ម្រាក់" },
    { "id": 9754, "word": "ម៉្រាង" },
    { "id": 9755, "word": "ម្រាម" },
    { "id": 9756, "word": "ម្រីកៗ" },
    { "id": 9757, "word": "ម្រឹកម្រៃ" },
    { "id": 9758, "word": "ម្រឹគ" },
    { "id": 9759, "word": "ម្រឹត" },
    { "id": 9760, "word": "ម្រឹត្យុ" },
    { "id": 9761, "word": "ម្រឹត្យុសយ្យា" },
    { "id": 9762, "word": "ម្រឹត្យូវ" },
    { "id": 9763, "word": "ម្រឹទិនី" },
    { "id": 9764, "word": "ម្រុម" },
    { "id": 9765, "word": "ម្រើមព្រះ" },
    { "id": 9766, "word": "ម្រេច" },
    { "id": 9767, "word": "ម្រេចកង្កែប" },
    { "id": 9768, "word": "ម្រេញ" },
    { "id": 9769, "word": "ម្រេញកង្វាល" },
    { "id": 9770, "word": "ម្រែង" },
    { "id": 9771, "word": "ម្រោម" },
    { "id": 9772, "word": "ម្រុំ" },
    { "id": 9773, "word": "ម្រះ" },
    { "id": 9774, "word": "ម្រះព្រៅ" },
    { "id": 9775, "word": "ម្លប់" },
    { "id": 9776, "word": "ម៉្លា" },
    { "id": 9777, "word": "ម្លាន់" },
    { "id": 9778, "word": "ម្លាយៗ" },
    { "id": 9779, "word": "ម្លិះ" },
    { "id": 9780, "word": "ម្ល៉ឹង" },
    { "id": 9781, "word": "ម្លឺតៗ" },
    { "id": 9782, "word": "ម្លូ" },
    { "id": 9783, "word": "ម្លូទេស" },
    { "id": 9784, "word": "ម្លូព្រៃ" },
    { "id": 9785, "word": "ម្ល៉េះ" },
    { "id": 9786, "word": "ម្សាញ់" },
    { "id": 9787, "word": "ម្សិល" },
    { "id": 9788, "word": "ម្សិលម៉្ងៃ" },
    { "id": 9789, "word": "ម្សិលម្ង៉ៃមួយនាយ" },
    { "id": 9790, "word": "ម្សៀត" },
    { "id": 9791, "word": "ម្សេវ" },
    { "id": 9792, "word": "ម្សៅ" },
    { "id": 9793, "word": "ម្ហបៗ" },
    { "id": 9794, "word": "ម្ហា" },
    { "id": 9795, "word": "ម្ហ៊ិះៗ" },
    { "id": 9796, "word": "ម្ហូប" },
    { "id": 9797, "word": "ម្ហើបៗ" },
    { "id": 9798, "word": "ម្ហេបៗ" },
    { "id": 9799, "word": "ម្ហេបម្ហប" },
    { "id": 9800, "word": "ម្ហេះៗ" },
    { "id": 9801, "word": "ម្ហ៊ែតៗ" },
    { "id": 9802, "word": "ម្ហែបម្ហប" },
    { "id": 9803, "word": "ម្អម" },
    { "id": 9804, "word": "ម្អមក្ដាម" },
    { "id": 9805, "word": "យ" },
    { "id": 9806, "word": "យ៉" },
    { "id": 9807, "word": "យក៍" },
    { "id": 9808, "word": "យក" },
    { "id": 9809, "word": "យក់" },
    { "id": 9810, "word": "យក់ !" },
    { "id": 9811, "word": "យកនៈ" },
    { "id": 9812, "word": "យក្រឹត" },
    { "id": 9813, "word": "យក្ខ" },
    { "id": 9814, "word": "យក្ខិនី" },
    { "id": 9815, "word": "យក្សា" },
    { "id": 9816, "word": "យក្សី" },
    { "id": 9817, "word": "យ៉ង" },
    { "id": 9818, "word": "យង់" },
    { "id": 9819, "word": "យង់ឃ្នង" },
    { "id": 9820, "word": "យង់យល់" },
    { "id": 9821, "word": "យញ្ញ" },
    { "id": 9822, "word": "យដ្ឋិ" },
    { "id": 9823, "word": "យតិ" },
    { "id": 9824, "word": "យតិភង្គ" },
    { "id": 9825, "word": "យថាកម្ម" },
    { "id": 9826, "word": "យថាកាម" },
    { "id": 9827, "word": "យថាក្រម" },
    { "id": 9828, "word": "យថាឋាន" },
    { "id": 9829, "word": "យថានុក្រម" },
    { "id": 9830, "word": "យថានុរូប" },
    { "id": 9831, "word": "យថាផាសុក" },
    { "id": 9832, "word": "យថាភូត" },
    { "id": 9833, "word": "យថាលាភ" },
    { "id": 9834, "word": "យថាហេតុ" },
    { "id": 9835, "word": "យន់" },
    { "id": 9836, "word": "យន្ត" },
    { "id": 9837, "word": "យ័ន្ត" },
    { "id": 9838, "word": "យប់" },
    { "id": 9839, "word": "យមៈ" },
    { "id": 9840, "word": "យមក" },
    { "id": 9841, "word": "យមទូត" },
    { "id": 9842, "word": "យមបាល" },
    { "id": 9843, "word": "យមរាជ" },
    { "id": 9844, "word": "យមលោក" },
    { "id": 9845, "word": "យមុនា" },
    { "id": 9846, "word": "យ័រ !" },
    { "id": 9847, "word": "យល់" },
    { "id": 9848, "word": "យល់សប្ត" },
    { "id": 9849, "word": "យល់សប្ន" },
    { "id": 9850, "word": "យល់សូង" },
    { "id": 9851, "word": "យស" },
    { "id": 9852, "word": "យ៉ស" },
    { "id": 9853, "word": "យសោធរា" },
    { "id": 9854, "word": "យ៉ាក" },
    { "id": 9855, "word": "យាគូ" },
    { "id": 9856, "word": "យាង" },
    { "id": 9857, "word": "យ៉ាង" },
    { "id": 9858, "word": "យាងចុះ" },
    { "id": 9859, "word": "យាងយាវ" },
    { "id": 9860, "word": "យាងយាស" },
    { "id": 9861, "word": "យាចក" },
    { "id": 9862, "word": "យ៉ាដាំ" },
    { "id": 9863, "word": "យាណូវ" },
    { "id": 9864, "word": "យាត្រា" },
    { "id": 9865, "word": "យាន" },
    { "id": 9866, "word": "យ៉ាន័ត្ថុ" },
    { "id": 9867, "word": "យានបាត្រ" },
    { "id": 9868, "word": "យានមាស" },
    { "id": 9869, "word": "យានូបករណ៍" },
    { "id": 9870, "word": "យ៉ាប់" },
    { "id": 9871, "word": "យ៉ាបឆា" },
    { "id": 9872, "word": "យាបនមត្ត" },
    { "id": 9873, "word": "យ៉ាប់យ៉ឺន" },
    { "id": 9874, "word": "យាប្លង" },
    { "id": 9875, "word": "យាម" },
    { "id": 9876, "word": "យាមៈ" },
    { "id": 9877, "word": "យាមកាលិក" },
    { "id": 9878, "word": "យាមឃោស" },
    { "id": 9879, "word": "យាមនាលី" },
    { "id": 9880, "word": "យាមវតី" },
    { "id": 9881, "word": "យាមា" },
    { "id": 9882, "word": "យាមិក" },
    { "id": 9883, "word": "យាយ" },
    { "id": 9884, "word": "យាយី" },
    { "id": 9885, "word": "យារ" },
    { "id": 9886, "word": "យាវ" },
    { "id": 9887, "word": "យ៉ាវ" },
    { "id": 9888, "word": "យាវកាលិក" },
    { "id": 9889, "word": "យ៉ាវឆាខ្វៃ" },
    { "id": 9890, "word": "យាវជីវិក" },
    { "id": 9891, "word": "យាវជីវំ" },
    { "id": 9892, "word": "យាស" },
    { "id": 9893, "word": "យាស់" },
    { "id": 9894, "word": "យិតថោ" },
    { "id": 9895, "word": "យី !" },
    { "id": 9896, "word": "យីកយោក" },
    { "id": 9897, "word": "យីកេ" },
    { "id": 9898, "word": "យីថោ" },
    { "id": 9899, "word": "យីស៊ុន" },
    { "id": 9900, "word": "យីហ៊ុន" },
    { "id": 9901, "word": "យីហ៊ុប" },
    { "id": 9902, "word": "យីហោ" },
    { "id": 9903, "word": "យីអើ !" },
    { "id": 9904, "word": "យីះ !" },
    { "id": 9905, "word": "យឹត" },
    { "id": 9906, "word": "យឹតយោង" },
    { "id": 9907, "word": "យឺត" },
    { "id": 9908, "word": "យឺន" },
    { "id": 9909, "word": "យ៉ឺរ" },
    { "id": 9910, "word": "យុក" },
    { "id": 9911, "word": "យុកក្ប័ត្រ" },
    { "id": 9912, "word": "យុកយាក់" },
    { "id": 9913, "word": "យុគ" },
    { "id": 9914, "word": "យុគគ្រាះ" },
    { "id": 9915, "word": "យុគន្តកល" },
    { "id": 9916, "word": "យុគន្ធរ" },
    { "id": 9917, "word": "យុគលៈ" },
    { "id": 9918, "word": "យុគលពិន្ទុ" },
    { "id": 9919, "word": "យុត្តៈ" },
    { "id": 9920, "word": "យុត្តិធម៌" },
    { "id": 9921, "word": "យុថ្កា" },
    { "id": 9922, "word": "យុទ្ធ" },
    { "id": 9923, "word": "យុទ្ធនា" },
    { "id": 9924, "word": "យុទ្ធនាធិការ" },
    { "id": 9925, "word": "យុទ្ធុបករណ៍" },
    { "id": 9926, "word": "យុទ្ធោបករណ៍" },
    { "id": 9927, "word": "យុពា" },
    { "id": 9928, "word": "យុយ !" },
    { "id": 9929, "word": "យុរ" },
    { "id": 9930, "word": "យុរស្បូវ" },
    { "id": 9931, "word": "យុវៈ" },
    { "id": 9932, "word": "យុវតី" },
    { "id": 9933, "word": "យុះៗ !" },
    { "id": 9934, "word": "យូយ !" },
    { "id": 9935, "word": "យ៉ូយ !" },
    { "id": 9936, "word": "យូរ" },
    { "id": 9937, "word": "យូហឺ" },
    { "id": 9938, "word": "យួន" },
    { "id": 9939, "word": "យួរ" },
    { "id": 9940, "word": "យើ !" },
    { "id": 9941, "word": "យ៉ើ !" },
    { "id": 9942, "word": "យើង" },
    { "id": 9943, "word": "យ៉ើរ" },
    { "id": 9944, "word": "យ៉ើះ !" },
    { "id": 9945, "word": "យេកយោក" },
    { "id": 9946, "word": "យេស៊ូ" },
    { "id": 9947, "word": "យ៉េៈយ៉ុ" },
    { "id": 9948, "word": "យែក" },
    { "id": 9949, "word": "យៃ" },
    { "id": 9950, "word": "យ៉ៃ" },
    { "id": 9951, "word": "យោ" },
    { "id": 9952, "word": "យោក" },
    { "id": 9953, "word": "យោក្ប័ត្រ" },
    { "id": 9954, "word": "យោគ" },
    { "id": 9955, "word": "យោគ" },
    { "id": 9956, "word": "យោគាវចរ" },
    { "id": 9957, "word": "យោគិន" },
    { "id": 9958, "word": "យោគ្យភាព" },
    { "id": 9959, "word": "យោង" },
    { "id": 9960, "word": "យោជន៍" },
    { "id": 9961, "word": "យោជនា" },
    { "id": 9962, "word": "យោធ" },
    { "id": 9963, "word": "យោធា" },
    { "id": 9964, "word": "យោធិន" },
    { "id": 9965, "word": "យោន" },
    { "id": 9966, "word": "យោនយកកំណើត" },
    { "id": 9967, "word": "យោនយាន" },
    { "id": 9968, "word": "យោនិសោមនសិការ" },
    { "id": 9969, "word": "យោនី" },
    { "id": 9970, "word": "យោបល់" },
    { "id": 9971, "word": "យោបំ " },
    { "id": 9972, "word": "យោព្វនៈ" },
    { "id": 9973, "word": "យោមរាជ" },
    { "id": 9974, "word": "យោល" },
    { "id": 9975, "word": "យោសា" },
    { "id": 9976, "word": "យោសោ" },
    { "id": 9977, "word": "យៅ" },
    { "id": 9978, "word": "យៅវ៍" },
    { "id": 9979, "word": "យៅវ័ន" },
    { "id": 9980, "word": "យំ" },
    { "id": 9981, "word": "យាំង" },
    { "id": 9982, "word": "យះ" },
    { "id": 9983, "word": "យះកន្ធែក" },
    { "id": 9984, "word": "រ" },
    { "id": 9985, "word": "រ៉" },
    { "id": 9986, "word": "រក៍" },
    { "id": 9987, "word": "រក" },
    { "id": 9988, "word": "រ៉ក" },
    { "id": 9989, "word": "រកកល់" },
    { "id": 9990, "word": "រកតែ" },
    { "id": 9991, "word": "រកម" },
    { "id": 9992, "word": "រកា" },
    { "id": 9993, "word": "រកាដែក" },
    { "id": 9994, "word": "រកឹក" },
    { "id": 9995, "word": "រកឹង" },
    { "id": 9996, "word": "រកូត" },
    { "id": 9997, "word": "រកៀស" },
    { "id": 9998, "word": "រកេត" },
    { "id": 9999, "word": "រកាំ" },
    { "id": 10000, "word": "រកាំរកូស" },
    { "id": 10001, "word": "រក្ស" },
    { "id": 10002, "word": "រក្សា" },
    { "id": 10003, "word": "រក្សាភិបាល" },
    { "id": 10004, "word": "រក្សាព្រះអង្គ" },
    { "id": 10005, "word": "រក្សាស្រុក" },
    { "id": 10006, "word": "រខក" },
    { "id": 10007, "word": "រខក់" },
    { "id": 10008, "word": "រខាក" },
    { "id": 10009, "word": "រខិករខក់" },
    { "id": 10010, "word": "រខិញ" },
    { "id": 10011, "word": "រខិត" },
    { "id": 10012, "word": "រខិន" },
    { "id": 10013, "word": "រខឺត" },
    { "id": 10014, "word": "រខុញ" },
    { "id": 10015, "word": "រខូស" },
    { "id": 10016, "word": "រខេក" },
    { "id": 10017, "word": "រខែក" },
    { "id": 10018, "word": "រខែះ" },
    { "id": 10019, "word": "រខោក" },
    { "id": 10020, "word": "រគង" },
    { "id": 10021, "word": "រគាម" },
    { "id": 10022, "word": "រគិបរគុប" },
    { "id": 10023, "word": "រគីង" },
    { "id": 10024, "word": "រគីម" },
    { "id": 10025, "word": "រគឹង" },
    { "id": 10026, "word": "រគុប" },
    { "id": 10027, "word": "រគើម" },
    { "id": 10028, "word": "រគើល" },
    { "id": 10029, "word": "រគេង" },
    { "id": 10030, "word": "រគោង" },
    { "id": 10031, "word": "រគោល" },
    { "id": 10032, "word": "រគាំង" },
    { "id": 10033, "word": "រឃិករឃុក" },
    { "id": 10034, "word": "រឃិងរឃុង" },
    { "id": 10035, "word": "រឃឹករឃុក" },
    { "id": 10036, "word": "រឃុករឃាក់" },
    { "id": 10037, "word": "រឃុង" },
    { "id": 10038, "word": "រឃុងរឃាំង" },
    { "id": 10039, "word": "រឃាំង" },
    { "id": 10040, "word": "រង" },
    { "id": 10041, "word": "រង" },
    { "id": 10042, "word": "រង់" },
    { "id": 10043, "word": "រងឆាយ" },
    { "id": 10044, "word": "រងជើង" },
    { "id": 10045, "word": "រង់ដឿង" },
    { "id": 10046, "word": "រងទឹក" },
    { "id": 10047, "word": "រងល់" },
    { "id": 10048, "word": "រងា" },
    { "id": 10049, "word": "រងាក់" },
    { "id": 10050, "word": "រងាក់រងើក" },
    { "id": 10051, "word": "រង៉ាក់រង៉ើក" },
    { "id": 10052, "word": "រងាន់" },
    { "id": 10053, "word": "រងាប់" },
    { "id": 10054, "word": "រង៉ាប់រងួ" },
    { "id": 10055, "word": "រង៉ាប់រងើ" },
    { "id": 10056, "word": "រងាល" },
    { "id": 10057, "word": "រងាវ" },
    { "id": 10058, "word": "រងាវកក" },
    { "id": 10059, "word": "រង៉ិករង៉ក់" },
    { "id": 10060, "word": "រងីក" },
    { "id": 10061, "word": "រងីរងើ" },
    { "id": 10062, "word": "រង៉ឺត" },
    { "id": 10063, "word": "រងុម" },
    { "id": 10064, "word": "រងូ" },
    { "id": 10065, "word": "រង៉ូវ" },
    { "id": 10066, "word": "រងួយ" },
    { "id": 10067, "word": "រងើក" },
    { "id": 10068, "word": "រងើម" },
    { "id": 10069, "word": "រងៀក" },
    { "id": 10070, "word": "រងៀម" },
    { "id": 10071, "word": "រងេរងើ" },
    { "id": 10072, "word": "រង៉ែ" },
    { "id": 10073, "word": "រងែក" },
    { "id": 10074, "word": "រងៃ" },
    { "id": 10075, "word": "រងោក" },
    { "id": 10076, "word": "រង៉ោម" },
    { "id": 10077, "word": "រងុំ" },
    { "id": 10078, "word": "រងំ" },
    { "id": 10079, "word": "រង្កៀក" },
    { "id": 10080, "word": "រង្កៀកបង្គោល" },
    { "id": 10081, "word": "រង្កៀស" },
    { "id": 10082, "word": "រង្គ" },
    { "id": 10083, "word": "រង្គាជីព" },
    { "id": 10084, "word": "រង្គាត់" },
    { "id": 10085, "word": "រង្គាល" },
    { "id": 10086, "word": "រង្គើ" },
    { "id": 10087, "word": "រង្គើក" },
    { "id": 10088, "word": "រង្គោះ" },
    { "id": 10089, "word": "រង្គំ" },
    { "id": 10090, "word": "រង្វង់" },
    { "id": 10091, "word": "រង្វាន់" },
    { "id": 10092, "word": "រង្វាល់" },
    { "id": 10093, "word": "រង្វាស់" },
    { "id": 10094, "word": "រង្វឹង" },
    { "id": 10095, "word": "រង្វើល" },
    { "id": 10096, "word": "រង្វេល" },
    { "id": 10097, "word": "រង្វះ" },
    { "id": 10098, "word": "រង្សី" },
    { "id": 10099, "word": "រចនា" },
    { "id": 10100, "word": "រចនាបទុម" },
    { "id": 10101, "word": "រចនាប័ទ្ម" },
    { "id": 10102, "word": "រចល់" },
    { "id": 10103, "word": "រចលេខា" },
    { "id": 10104, "word": "រចេចរចាច" },
    { "id": 10105, "word": "រចែករចោក" },
    { "id": 10106, "word": "រឆៀបរញេញ" },
    { "id": 10107, "word": "រឆេងរឆូង" },
    { "id": 10108, "word": "រឆេចរឆូច" },
    { "id": 10109, "word": "រឆេតរឆូត" },
    { "id": 10110, "word": "រជក" },
    { "id": 10111, "word": "រជកី" },
    { "id": 10112, "word": "រជតៈ" },
    { "id": 10113, "word": "រជនកម្ម" },
    { "id": 10114, "word": "រជនី" },
    { "id": 10115, "word": "រជយ" },
    { "id": 10116, "word": "រជិកា" },
    { "id": 10117, "word": "រជើប" },
    { "id": 10118, "word": "រជោរ" },
    { "id": 10119, "word": "រជ្ជកាល" },
    { "id": 10120, "word": "រជ្ជទាយាទ" },
    { "id": 10121, "word": "រជ្ជប្បវេណី" },
    { "id": 10122, "word": "រជ្ជសម័យ" },
    { "id": 10123, "word": "រជ្ជសីមា" },
    { "id": 10124, "word": "រជ្ជូបករណ៍" },
    { "id": 10125, "word": "រជ្ជូបការ" },
    { "id": 10126, "word": "រញ់" },
    { "id": 10127, "word": "រញ៉" },
    { "id": 10128, "word": "រញង់" },
    { "id": 10129, "word": "រញម" },
    { "id": 10130, "word": "រញា" },
    { "id": 10131, "word": "រញ៉ាល់" },
    { "id": 10132, "word": "រញ៉ិករញ៉ុក " },
    { "id": 10133, "word": "រញ៉ិងរញ៉ាំង" },
    { "id": 10134, "word": "រញ៉ិបរញ៉ុប" },
    { "id": 10135, "word": "រញ៉ិម" },
    { "id": 10136, "word": "រញ៉ិល" },
    { "id": 10137, "word": "រញី" },
    { "id": 10138, "word": "រញ៉ី" },
    { "id": 10139, "word": "រញីវ" },
    { "id": 10140, "word": "រញឹក" },
    { "id": 10141, "word": "រញឹករញ៉ី" },
    { "id": 10142, "word": "រញ៉ឹករញ៉ែ" },
    { "id": 10143, "word": "រញូរញេញ" },
    { "id": 10144, "word": "រញៀវ" },
    { "id": 10145, "word": "រញ៉េចរញ៉ាច" },
    { "id": 10146, "word": "រញ៉េចរញ៉ូច" },
    { "id": 10147, "word": "រញេញ" },
    { "id": 10148, "word": "រញ៉េវរញ៉ាវ" },
    { "id": 10149, "word": "រញ៉េះរញ៉ោះ" },
    { "id": 10150, "word": "រញ៉ែ" },
    { "id": 10151, "word": "រញ៉ែករញ៉ក" },
    { "id": 10152, "word": "រញ៉ែរញ៉ូវ" },
    { "id": 10153, "word": "រញោរញេញ" },
    { "id": 10154, "word": "រញ៉ាំ" },
    { "id": 10155, "word": "រញ៉ាំរញ៉ូវ" },
    { "id": 10156, "word": "រញ្ជួយ" },
    { "id": 10157, "word": "រដក" },
    { "id": 10158, "word": "រដាក់" },
    { "id": 10159, "word": "រដាច់" },
    { "id": 10160, "word": "រដាច់រដោច" },
    { "id": 10161, "word": "រដិប" },
    { "id": 10162, "word": "រដឹក" },
    { "id": 10163, "word": "រដឺន" },
    { "id": 10164, "word": "រដុប" },
    { "id": 10165, "word": "រដូក" },
    { "id": 10166, "word": "រដៀន" },
    { "id": 10167, "word": "រដេច" },
    { "id": 10168, "word": "រដេមរដម" },
    { "id": 10169, "word": "រដែ" },
    { "id": 10170, "word": "រដែត" },
    { "id": 10171, "word": "រដែមរដម" },
    { "id": 10172, "word": "រដោះ" },
    { "id": 10173, "word": "រដ្ឋ" },
    { "id": 10174, "word": "រឌុក" },
    { "id": 10175, "word": "រណៈ" },
    { "id": 10176, "word": "រណប" },
    { "id": 10177, "word": "រណារ" },
    { "id": 10178, "word": "រណិងរណុង" },
    { "id": 10179, "word": "រណិមរណុំ" },
    { "id": 10180, "word": "រណិល" },
    { "id": 10181, "word": "រណូងរណាង" },
    { "id": 10182, "word": "រណេបរណប" },
    { "id": 10183, "word": "រណេបរណឺប" },
    { "id": 10184, "word": "រណែង" },
    { "id": 10185, "word": "រណែរណោ" },
    { "id": 10186, "word": "រណែបរណប" },
    { "id": 10187, "word": "រណែល" },
    { "id": 10188, "word": "រណោង" },
    { "id": 10189, "word": "រណោបាយ" },
    { "id": 10190, "word": "រណ្តាប់" },
    { "id": 10191, "word": "រណ្តាស" },
    { "id": 10192, "word": "រណ្ដៅ" },
    { "id": 10193, "word": "រណ្តំ" },
    { "id": 10194, "word": "រណ្ឌកព្រឹក្ស" },
    { "id": 10195, "word": "រត" },
    { "id": 10196, "word": "រត់" },
    { "id": 10197, "word": "រតនៈ" },
    { "id": 10198, "word": "រតន --" },
    { "id": 10199, "word": "រតនគិរី" },
    { "id": 10200, "word": "រតនា" },
    { "id": 10201, "word": "រតនោភាស" },
    { "id": 10202, "word": "រត់យួន" },
    { "id": 10203, "word": "រតាក" },
    { "id": 10204, "word": "រតាត់" },
    { "id": 10205, "word": "រតាយ" },
    { "id": 10206, "word": "រតាវ" },
    { "id": 10207, "word": "រតិ" },
    { "id": 10208, "word": "រតិករតុក" },
    { "id": 10209, "word": "រតិបរតុប" },
    { "id": 10210, "word": "រតឹង" },
    { "id": 10211, "word": "រតូត" },
    { "id": 10212, "word": "រតូវ" },
    { "id": 10213, "word": "រតេក" },
    { "id": 10214, "word": "រតេត" },
    { "id": 10215, "word": "រតេយ" },
    { "id": 10216, "word": "រតេវ" },
    { "id": 10217, "word": "រតែក" },
    { "id": 10218, "word": "រតែង" },
    { "id": 10219, "word": "រតោក" },
    { "id": 10220, "word": "រតោង" },
    { "id": 10221, "word": "រត្ត" },
    { "id": 10222, "word": "រត្តញ្ញូ" },
    { "id": 10223, "word": "រត្តិកាល" },
    { "id": 10224, "word": "រត្តិចរ" },
    { "id": 10225, "word": "រត្តិច្ឆេទ" },
    { "id": 10226, "word": "រត្តិន្ទិព" },
    { "id": 10227, "word": "រត្តិភាគ" },
    { "id": 10228, "word": "រត្តុប្បល" },
    { "id": 10229, "word": "រត្ន --" },
    { "id": 10230, "word": "រត្នត្រ័យ" },
    { "id": 10231, "word": "រត្នា" },
    { "id": 10232, "word": "រត្នាករ" },
    { "id": 10233, "word": "រថ" },
    { "id": 10234, "word": "រថ --" },
    { "id": 10235, "word": "រថា --" },
    { "id": 10236, "word": "រថូបករណ៍" },
    { "id": 10237, "word": "រទង" },
    { "id": 10238, "word": "រទាស" },
    { "id": 10239, "word": "រទីស" },
    { "id": 10240, "word": "រទុះ" },
    { "id": 10241, "word": "រទូ" },
    { "id": 10242, "word": "រទូរទាំ" },
    { "id": 10243, "word": "រទើស" },
    { "id": 10244, "word": "រទេញ" },
    { "id": 10245, "word": "រទេះ" },
    { "id": 10246, "word": "រទែង" },
    { "id": 10247, "word": "រទោងៗ" },
    { "id": 10248, "word": "រទាំ" },
    { "id": 10249, "word": "រទាំង" },
    { "id": 10250, "word": "រន" },
    { "id": 10251, "word": "រនង" },
    { "id": 10252, "word": "រនល" },
    { "id": 10253, "word": "រនាត" },
    { "id": 10254, "word": "រនាប" },
    { "id": 10255, "word": "រនាម" },
    { "id": 10256, "word": "រនាល" },
    { "id": 10257, "word": "រនាស់" },
    { "id": 10258, "word": "រនិងរនាំង" },
    { "id": 10259, "word": "រនុក" },
    { "id": 10260, "word": "រនូត" },
    { "id": 10261, "word": "រនួត" },
    { "id": 10262, "word": "រនេល" },
    { "id": 10263, "word": "រនោង" },
    { "id": 10264, "word": "រនោច" },
    { "id": 10265, "word": "រនោល" },
    { "id": 10266, "word": "រនាំង" },
    { "id": 10267, "word": "រនះ" },
    { "id": 10268, "word": "រនះរនាត" },
    { "id": 10269, "word": "រន្តិភាព" },
    { "id": 10270, "word": "រន្ថាន់" },
    { "id": 10271, "word": "រន្ទា" },
    { "id": 10272, "word": "រន្ទាល" },
    { "id": 10273, "word": "រន្ទឺ" },
    { "id": 10274, "word": "រន្ទេប" },
    { "id": 10275, "word": "រន្ទះ" },
    { "id": 10276, "word": "រន្ទះមាត់" },
    { "id": 10277, "word": "រន្ធ" },
    { "id": 10278, "word": "រន្ធកសត្ត" },
    { "id": 10279, "word": "រន្ធគវេសិនី" },
    { "id": 10280, "word": "រន្ធគវេសី" },
    { "id": 10281, "word": "រន្ធត់" },
    { "id": 10282, "word": "រន្ធវាស" },
    { "id": 10283, "word": "រន្ធវាសិនី" },
    { "id": 10284, "word": "រន្ធវាសី" },
    { "id": 10285, "word": "រប" },
    { "id": 10286, "word": "របក" },
    { "id": 10287, "word": "របង" },
    { "id": 10288, "word": "របត់" },
    { "id": 10289, "word": "របទិម" },
    { "id": 10290, "word": "របប" },
    { "id": 10291, "word": "របរ" },
    { "id": 10292, "word": "របស់" },
    { "id": 10293, "word": "របា" },
    { "id": 10294, "word": "របាញ" },
    { "id": 10295, "word": "រប៉ាត់រប៉ាយ" },
    { "id": 10296, "word": "របាទ" },
    { "id": 10297, "word": "របាយ" },
    { "id": 10298, "word": "រប៉ាយ" },
    { "id": 10299, "word": "របារ" },
    { "id": 10300, "word": "របាល" },
    { "id": 10301, "word": "រប៉ិករប៉ុក" },
    { "id": 10302, "word": "រប៉ិចរប៉ី" },
    { "id": 10303, "word": "របិញរបុញ" },
    { "id": 10304, "word": "រប៉ិតរប៉ុត" },
    { "id": 10305, "word": "រប៉ិនរប៉ាន់" },
    { "id": 10306, "word": "រប៉ិលរប៉ូច" },
    { "id": 10307, "word": "របឹង" },
    { "id": 10308, "word": "របឹប" },
    { "id": 10309, "word": "រប៉ឺតរប៉ោង" },
    { "id": 10310, "word": "របុក" },
    { "id": 10311, "word": "របុកជាស" },
    { "id": 10312, "word": "របុង" },
    { "id": 10313, "word": "របុញ" },
    { "id": 10314, "word": "របុម" },
    { "id": 10315, "word": "របូត" },
    { "id": 10316, "word": "របួល" },
    { "id": 10317, "word": "របួស" },
    { "id": 10318, "word": "របើក" },
    { "id": 10319, "word": "របើរ" },
    { "id": 10320, "word": "របើស" },
    { "id": 10321, "word": "របៀង" },
    { "id": 10322, "word": "របៀន" },
    { "id": 10323, "word": "របៀប" },
    { "id": 10324, "word": "របេង" },
    { "id": 10325, "word": "របេញរបុញ" },
    { "id": 10326, "word": "រប៉េសរប៉ស" },
    { "id": 10327, "word": "របេះ" },
    { "id": 10328, "word": "រប៉េះរប៉ោះ" },
    { "id": 10329, "word": "រប៉ែករប៉ាយ" },
    { "id": 10330, "word": "រប៉ែករប៉ោក" },
    { "id": 10331, "word": "របែង" },
    { "id": 10332, "word": "របែររបោរ" },
    { "id": 10333, "word": "រប៉ែសរប៉ស" },
    { "id": 10334, "word": "របៃ" },
    { "id": 10335, "word": "របៃរៃដាក់" },
    { "id": 10336, "word": "របោច" },
    { "id": 10337, "word": "របោម" },
    { "id": 10338, "word": "របោយ" },
    { "id": 10339, "word": "រប៉ោយ" },
    { "id": 10340, "word": "របោះ" },
    { "id": 10341, "word": "របោះរបោយ" },
    { "id": 10342, "word": "របុំ" },
    { "id": 10343, "word": "របាំ" },
    { "id": 10344, "word": "របាំង" },
    { "id": 10345, "word": "របាំងភក់" },
    { "id": 10346, "word": "របាំងមុខ" },
    { "id": 10347, "word": "របះ" },
    { "id": 10348, "word": "របះ --" },
    { "id": 10349, "word": "របះរបើង" },
    { "id": 10350, "word": "របះរបោរ" },
    { "id": 10351, "word": "រផាត់រទាំង" },
    { "id": 10352, "word": "រផាត់រផុយ" },
    { "id": 10353, "word": "រពាក់" },
    { "id": 10354, "word": "រពាយ" },
    { "id": 10355, "word": "រពីង" },
    { "id": 10356, "word": "រពឹក" },
    { "id": 10357, "word": "រពឹល" },
    { "id": 10358, "word": "រពឹស" },
    { "id": 10359, "word": "រពុក" },
    { "id": 10360, "word": "រពុយ" },
    { "id": 10361, "word": "រពើតរពើង" },
    { "id": 10362, "word": "រពោង" },
    { "id": 10363, "word": "រម" },
    { "id": 10364, "word": "រម៉ង់" },
    { "id": 10365, "word": "រមណី" },
    { "id": 10366, "word": "រមណីយ" },
    { "id": 10367, "word": "រមត់" },
    { "id": 10368, "word": "រមតិ" },
    { "id": 10369, "word": "រមទម" },
    { "id": 10370, "word": "រមាក" },
    { "id": 10371, "word": "រមាត់" },
    { "id": 10372, "word": "រមាស" },
    { "id": 10373, "word": "រមាស់" },
    { "id": 10374, "word": "រម៉ិករម៉ក់" },
    { "id": 10375, "word": "រម៉ិង" },
    { "id": 10376, "word": "រម៉ិងរម៉ាំង" },
    { "id": 10377, "word": "រមិល" },
    { "id": 10378, "word": "រមិលគុណ" },
    { "id": 10379, "word": "រម៉ឹម" },
    { "id": 10380, "word": "រមឹល" },
    { "id": 10381, "word": "រមឹលគុណ" },
    { "id": 10382, "word": "រមូរ" },
    { "id": 10383, "word": "រមូល" },
    { "id": 10384, "word": "រមួល" },
    { "id": 10385, "word": "រមួលក្រពើ" },
    { "id": 10386, "word": "រមៀត" },
    { "id": 10387, "word": "រមៀល" },
    { "id": 10388, "word": "រមេញ" },
    { "id": 10389, "word": "រម៉េះរម៉ោះ" },
    { "id": 10390, "word": "រមែង" },
    { "id": 10391, "word": "រម៉ោក" },
    { "id": 10392, "word": "រមាំង" },
    { "id": 10393, "word": "រមាំងបើក បាស" },
    { "id": 10394, "word": "រម៉ាំងរម៉ោក" },
    { "id": 10395, "word": "រម្ងក" },
    { "id": 10396, "word": "រម្ងាច" },
    { "id": 10397, "word": "រម្ងាប់" },
    { "id": 10398, "word": "រម្ងាស់" },
    { "id": 10399, "word": "រម្ងើក" },
    { "id": 10400, "word": "រម្តោះ" },
    { "id": 10401, "word": "រម្ភា" },
    { "id": 10402, "word": "រម្យ" },
    { "id": 10403, "word": "រម្យទម" },
    { "id": 10404, "word": "រម្យា" },
    { "id": 10405, "word": "រម្លត់" },
    { "id": 10406, "word": "រម្លប់" },
    { "id": 10407, "word": "រម្លស់" },
    { "id": 10408, "word": "រម្លាក" },
    { "id": 10409, "word": "រម្លាយ" },
    { "id": 10410, "word": "រម្លីង" },
    { "id": 10411, "word": "រម្លឹក" },
    { "id": 10412, "word": "រម្លុប" },
    { "id": 10413, "word": "រម្លុះ" },
    { "id": 10414, "word": "រម្លូត" },
    { "id": 10415, "word": "រម្លើង" },
    { "id": 10416, "word": "រម្លោក" },
    { "id": 10417, "word": "រម្លំ" },
    { "id": 10418, "word": "រម្សាយ" },
    { "id": 10419, "word": "រម្ហ" },
    { "id": 10420, "word": "រម្ហាច" },
    { "id": 10421, "word": "រម្ហូត" },
    { "id": 10422, "word": "រម្ហើយ" },
    { "id": 10423, "word": "រម្ហែ" },
    { "id": 10424, "word": "រម្អា" },
    { "id": 10425, "word": "រម្អិល" },
    { "id": 10426, "word": "រម្អែង" },
    { "id": 10427, "word": "រយ" },
    { "id": 10428, "word": "រយៈ" },
    { "id": 10429, "word": "រ៉យកែវ" },
    { "id": 10430, "word": "រយ៉ា" },
    { "id": 10431, "word": "រយាក" },
    { "id": 10432, "word": "រយាង" },
    { "id": 10433, "word": "រយាន" },
    { "id": 10434, "word": "រយាប" },
    { "id": 10435, "word": "រយាយ" },
    { "id": 10436, "word": "រយាល" },
    { "id": 10437, "word": "រយ៉ិល" },
    { "id": 10438, "word": "រយ៉ី" },
    { "id": 10439, "word": "រយីក" },
    { "id": 10440, "word": "រយីករយោក" },
    { "id": 10441, "word": "រយីង" },
    { "id": 10442, "word": "រយឺតៗ" },
    { "id": 10443, "word": "រយេករយោក" },
    { "id": 10444, "word": "រយេង" },
    { "id": 10445, "word": "រយ៉ៃ" },
    { "id": 10446, "word": "រយោង" },
    { "id": 10447, "word": "រយោន" },
    { "id": 10448, "word": "រយំ" },
    { "id": 10449, "word": "រយះ" },
    { "id": 10450, "word": "រល " },
    { "id": 10451, "word": "រល់" },
    { "id": 10452, "word": "រលក" },
    { "id": 10453, "word": "រលកកែវ" },
    { "id": 10454, "word": "រលករង្គំ" },
    { "id": 10455, "word": "រលង" },
    { "id": 10456, "word": "រលង់" },
    { "id": 10457, "word": "រលត់" },
    { "id": 10458, "word": "រលប់" },
    { "id": 10459, "word": "រលម" },
    { "id": 10460, "word": "រលរ" },
    { "id": 10461, "word": "រលស់" },
    { "id": 10462, "word": "រលា" },
    { "id": 10463, "word": "រលាក" },
    { "id": 10464, "word": "រលាក់" },
    { "id": 10465, "word": "រលាត" },
    { "id": 10466, "word": "រលាត់" },
    { "id": 10467, "word": "រលាប" },
    { "id": 10468, "word": "រលាប្អៀរ" },
    { "id": 10469, "word": "រលាម" },
    { "id": 10470, "word": "រលាយ" },
    { "id": 10471, "word": "រលាស់" },
    { "id": 10472, "word": "រលិស" },
    { "id": 10473, "word": "រលី" },
    { "id": 10474, "word": "រលីក" },
    { "id": 10475, "word": "រលីង" },
    { "id": 10476, "word": "រលីងឈូក" },
    { "id": 10477, "word": "រលីងរលោង" },
    { "id": 10478, "word": "រលីបរលាប" },
    { "id": 10479, "word": "រលីមរលាម" },
    { "id": 10480, "word": "រលីវ" },
    { "id": 10481, "word": "រលឹក" },
    { "id": 10482, "word": "រលឹបរល" },
    { "id": 10483, "word": "រលឹម" },
    { "id": 10484, "word": "រលុង" },
    { "id": 10485, "word": "រលុប" },
    { "id": 10486, "word": "រលុះ" },
    { "id": 10487, "word": "រលុះរលាញ" },
    { "id": 10488, "word": "រលូករល" },
    { "id": 10489, "word": "រលូង" },
    { "id": 10490, "word": "រលូត" },
    { "id": 10491, "word": "រលូន" },
    { "id": 10492, "word": "រលួត" },
    { "id": 10493, "word": "រលួយ" },
    { "id": 10494, "word": "រលួស" },
    { "id": 10495, "word": "រលួសផ្អុង" },
    { "id": 10496, "word": "រលើ" },
    { "id": 10497, "word": "រលើង" },
    { "id": 10498, "word": "រលើប " },
    { "id": 10499, "word": "រលឿ" },
    { "id": 10500, "word": "រលៀក" },
    { "id": 10501, "word": "រលៀង" },
    { "id": 10502, "word": "រលេ" },
    { "id": 10503, "word": "រលេងរលោង" },
    { "id": 10504, "word": "រលេញ" },
    { "id": 10505, "word": "រលេះ" },
    { "id": 10506, "word": "រលែក" },
    { "id": 10507, "word": "រលែម" },
    { "id": 10508, "word": "រលែះ" },
    { "id": 10509, "word": "រលៃ" },
    { "id": 10510, "word": "រលោក" },
    { "id": 10511, "word": "រលោង" },
    { "id": 10512, "word": "រលោច" },
    { "id": 10513, "word": "រលោរលាំ" },
    { "id": 10514, "word": "រលំ" },
    { "id": 10515, "word": "រលាំ" },
    { "id": 10516, "word": "រលាំង" },
    { "id": 10517, "word": "រលះ" },
    { "id": 10518, "word": "រលះរលាំង" },
    { "id": 10519, "word": "រវ៉ក់" },
    { "id": 10520, "word": "រវ័ណ្ឌ" },
    { "id": 10521, "word": "រវល់" },
    { "id": 10522, "word": "រវាង" },
    { "id": 10523, "word": "រវ៉ាច់" },
    { "id": 10524, "word": "រវាត" },
    { "id": 10525, "word": "រវាន" },
    { "id": 10526, "word": "រវាន់" },
    { "id": 10527, "word": "រវាម" },
    { "id": 10528, "word": "រវិ" },
    { "id": 10529, "word": "រវ៉ិក" },
    { "id": 10530, "word": "រវច" },
    { "id": 10531, "word": "រវិចរវាម" },
    { "id": 10532, "word": "រវិន" },
    { "id": 10533, "word": "រវិន្ទ" },
    { "id": 10534, "word": "រវិហង្ស" },
    { "id": 10535, "word": "រវីក" },
    { "id": 10536, "word": "រវីម" },
    { "id": 10537, "word": "រវីស" },
    { "id": 10538, "word": "រវូប" },
    { "id": 10539, "word": "រវម" },
    { "id": 10540, "word": "រវ៉ូស" },
    { "id": 10541, "word": "រវើក" },
    { "id": 10542, "word": "រវ៉ើក" },
    { "id": 10543, "word": "រវើម" },
    { "id": 10544, "word": "រវើរវាយ" },
    { "id": 10545, "word": "រវៀស" },
    { "id": 10546, "word": "រវេ" },
    { "id": 10547, "word": "រវ៉េតរវ៉ត" },
    { "id": 10548, "word": "រវ៉េសរវ៉ស" },
    { "id": 10549, "word": "រវ៉េសរវ៉ាស" },
    { "id": 10550, "word": "រវ៉េសរវ៉ូស" },
    { "id": 10551, "word": "រវែង" },
    { "id": 10552, "word": "រវែងបង់" },
    { "id": 10553, "word": "រវ៉ែតរវ៉ត" },
    { "id": 10554, "word": "រវៃ" },
    { "id": 10555, "word": "រវ៉ោច" },
    { "id": 10556, "word": "រវ៉ោប" },
    { "id": 10557, "word": "រវាំង" },
    { "id": 10558, "word": "រវាំងព្រៃ" },
    { "id": 10559, "word": "រវះរវាម" },
    { "id": 10560, "word": "រស" },
    { "id": 10561, "word": "រស់" },
    { "id": 10562, "word": "រ៉ស់" },
    { "id": 10563, "word": "រសក" },
    { "id": 10564, "word": "រសាក" },
    { "id": 10565, "word": "រសាច" },
    { "id": 10566, "word": "រសាត់" },
    { "id": 10567, "word": "រសាប់រសល់" },
    { "id": 10568, "word": "រសាប់រសាយ" },
    { "id": 10569, "word": "រសាយ" },
    { "id": 10570, "word": "រសាយនវិទ" },
    { "id": 10571, "word": "រសាវ" },
    { "id": 10572, "word": "រសិក" },
    { "id": 10573, "word": "រសី" },
    { "id": 10574, "word": "រសឹប" },
    { "id": 10575, "word": "រសឹបរសៀប" },
    { "id": 10576, "word": "រសឹបរសៀវ" },
    { "id": 10577, "word": "រសុក" },
    { "id": 10578, "word": "រសុល" },
    { "id": 10579, "word": "រសុស" },
    { "id": 10580, "word": "រសូវ" },
    { "id": 10581, "word": "រសើប" },
    { "id": 10582, "word": "រសៀល" },
    { "id": 10583, "word": "រសេច" },
    { "id": 10584, "word": "រសេមរសាម" },
    { "id": 10585, "word": "រសេវ" },
    { "id": 10586, "word": "រសេះរសោះ" },
    { "id": 10587, "word": "រសោង" },
    { "id": 10588, "word": "រសោះ" },
    { "id": 10589, "word": "រស្មី" },
    { "id": 10590, "word": "រស្មីម័ត" },
    { "id": 10591, "word": "រស្ស" },
    { "id": 10592, "word": "រស្សកជាតិ" },
    { "id": 10593, "word": "រស្សកសត្ត" },
    { "id": 10594, "word": "រស្សកាល" },
    { "id": 10595, "word": "រស្សជាតិ" },
    { "id": 10596, "word": "រស្សទស្សិនី" },
    { "id": 10597, "word": "រស្សទស្សី" },
    { "id": 10598, "word": "រស្សសញ្ញា" },
    { "id": 10599, "word": "រស្សសព្ទ" },
    { "id": 10600, "word": "រស្សសរ" },
    { "id": 10601, "word": "រស្សាវុធ" },
    { "id": 10602, "word": "រហ" },
    { "id": 10603, "word": "រហក" },
    { "id": 10604, "word": "រហក់" },
    { "id": 10605, "word": "រហង់" },
    { "id": 10606, "word": "រហទដ្ឋាន" },
    { "id": 10607, "word": "រហទប្បទេស" },
    { "id": 10608, "word": "រហប" },
    { "id": 10609, "word": "រហ័ស" },
    { "id": 10610, "word": "រហស្ថាន" },
    { "id": 10611, "word": "រហស្ស" },
    { "id": 10612, "word": "រហាក់" },
    { "id": 10613, "word": "រហាច" },
    { "id": 10614, "word": "រហាត់" },
    { "id": 10615, "word": "រហាត់ទឹក" },
    { "id": 10616, "word": "រហាម" },
    { "id": 10617, "word": "រហាល" },
    { "id": 10618, "word": "រហាល់" },
    { "id": 10619, "word": "រហិក" },
    { "id": 10620, "word": "រហិច" },
    { "id": 10621, "word": "រហិត" },
    { "id": 10622, "word": "រហិតរហៃ" },
    { "id": 10623, "word": "រហិល" },
    { "id": 10624, "word": "រហ៊ិះ" },
    { "id": 10625, "word": "រហ៊ិះរហ៊ុះ" },
    { "id": 10626, "word": "រហឹម" },
    { "id": 10627, "word": "រហ៊ឹម" },
    { "id": 10628, "word": "រហ៊ឹះ" },
    { "id": 10629, "word": "រហ៊ុម" },
    { "id": 10630, "word": "រហុយ" },
    { "id": 10631, "word": "រហ៊ុះ" },
    { "id": 10632, "word": "រហូត" },
    { "id": 10633, "word": "រហូន" },
    { "id": 10634, "word": "រហើង" },
    { "id": 10635, "word": "រហើត" },
    { "id": 10636, "word": "រហើតរហាំង" },
    { "id": 10637, "word": "រហើយ" },
    { "id": 10638, "word": "រហើររហាយ" },
    { "id": 10639, "word": "រហៀង" },
    { "id": 10640, "word": "រហៀរ" },
    { "id": 10641, "word": "រហេងរហាង" },
    { "id": 10642, "word": "រហេតរហូត" },
    { "id": 10643, "word": "រហេម" },
    { "id": 10644, "word": "រហេវ" },
    { "id": 10645, "word": "រហេវរហាវ" },
    { "id": 10646, "word": "រហែ" },
    { "id": 10647, "word": "រហែក" },
    { "id": 10648, "word": "រហែង" },
    { "id": 10649, "word": "រហែល" },
    { "id": 10650, "word": "រហោក" },
    { "id": 10651, "word": "រហោ" },
    { "id": 10652, "word": "រហោឋាន" },
    { "id": 10653, "word": "រហោភាព" },
    { "id": 10654, "word": "រហោល" },
    { "id": 10655, "word": "រហោស" },
    { "id": 10656, "word": "រឡ" },
    { "id": 10657, "word": "រឡប់" },
    { "id": 10658, "word": "រឡាក់" },
    { "id": 10659, "word": "រឡាញ" },
    { "id": 10660, "word": "រឡាម" },
    { "id": 10661, "word": "រឡិករឡក់" },
    { "id": 10662, "word": "រឡិករឡាក់" },
    { "id": 10663, "word": "រឡិងរឡង់" },
    { "id": 10664, "word": "រឡិបរឡប់" },
    { "id": 10665, "word": "រឡឺម" },
    { "id": 10666, "word": "រឡូ" },
    { "id": 10667, "word": "រឡូង" },
    { "id": 10668, "word": "រឡូងរឡាង" },
    { "id": 10669, "word": "រឡូរឡា" },
    { "id": 10670, "word": "រឡេមរឡាម" },
    { "id": 10671, "word": "រឡេមរឡឺម" },
    { "id": 10672, "word": "រឡេះរឡោះ" },
    { "id": 10673, "word": "រឡេះរឡះ" },
    { "id": 10674, "word": "រឡែរឡ" },
    { "id": 10675, "word": "រឡែរឡប់" },
    { "id": 10676, "word": "រឡៅ" },
    { "id": 10677, "word": "រអា" },
    { "id": 10678, "word": "រអាករពាយ" },
    { "id": 10679, "word": "រអាករអាយ" },
    { "id": 10680, "word": "រអាក់រអួល" },
    { "id": 10681, "word": "រអាក់រអើ" },
    { "id": 10682, "word": "រអាង" },
    { "id": 10683, "word": "រអាត" },
    { "id": 10684, "word": "រអាម" },
    { "id": 10685, "word": "រអារអូម" },
    { "id": 10686, "word": "រអិច" },
    { "id": 10687, "word": "រអិល" },
    { "id": 10688, "word": "រអ៊‌ិះរអ៊ុះ" },
    { "id": 10689, "word": "រអ៊‌ីរអ៊ូ" },
    { "id": 10690, "word": "រអឹក" },
    { "id": 10691, "word": "រអឹករអឺន" },
    { "id": 10692, "word": "រអឹករអាំ" },
    { "id": 10693, "word": "រអឺត" },
    { "id": 10694, "word": "រអុច" },
    { "id": 10695, "word": "រអ៊ុះ" },
    { "id": 10696, "word": "រអ៊ូ" },
    { "id": 10697, "word": "រអូច" },
    { "id": 10698, "word": "រអូចរអើប" },
    { "id": 10699, "word": "រអូចរអើម" },
    { "id": 10700, "word": "រអ៊ូរទាំ" },
    { "id": 10701, "word": "រអើតរអើម" },
    { "id": 10702, "word": "រអើប" },
    { "id": 10703, "word": "រអើបរជើប" },
    { "id": 10704, "word": "រអើបរជោរ" },
    { "id": 10705, "word": "រអើម" },
    { "id": 10706, "word": "រអើល" },
    { "id": 10707, "word": "រអៀករអាយ" },
    { "id": 10708, "word": "រអៀច" },
    { "id": 10709, "word": "រអៀស" },
    { "id": 10710, "word": "រអេចរអូច" },
    { "id": 10711, "word": "រអេតរអត" },
    { "id": 10712, "word": "រអេះរអុះ" },
    { "id": 10713, "word": "រអេៈរអុ" },
    { "id": 10714, "word": "រអែក" },
    { "id": 10715, "word": "រអែង" },
    { "id": 10716, "word": "រអែតរអត" },
    { "id": 10717, "word": "រអែរអូវ" },
    { "id": 10718, "word": "រអៃ" },
    { "id": 10719, "word": "រអោក" },
    { "id": 10720, "word": "រឱស" },
    { "id": 10721, "word": "រឱសឋាន" },
    { "id": 10722, "word": "រឭក" },
    { "id": 10723, "word": "រា" },
    { "id": 10724, "word": "រ៉ា" },
    { "id": 10725, "word": "រាក" },
    { "id": 10726, "word": "រាក់" },
    { "id": 10727, "word": "រាក់ទាក់" },
    { "id": 10728, "word": "រាក្ស័ស" },
    { "id": 10729, "word": "រាក្សសី" },
    { "id": 10730, "word": "រាគ" },
    { "id": 10731, "word": "រាង" },
    { "id": 10732, "word": "រ៉ាង" },
    { "id": 10733, "word": "រាងដូចជា " },
    { "id": 10734, "word": "រាងរៅ" },
    { "id": 10735, "word": "រាច" },
    { "id": 10736, "word": "រាជ" },
    { "id": 10737, "word": "រាជកកុធភណ្ឌ" },
    { "id": 10738, "word": "រាជឆ្ពឹស" },
    { "id": 10739, "word": "រាជតាទ្រិ" },
    { "id": 10740, "word": "រាជតាន្វិត" },
    { "id": 10741, "word": "រាជបណ្ឌិត្យសភា" },
    { "id": 10742, "word": "រាជបណ្ឌិត្យស្ថាន" },
    { "id": 10743, "word": "រាជព្រឹក្ស" },
    { "id": 10744, "word": "រាជវ័តិ" },
    { "id": 10745, "word": "រាជា" },
    { "id": 10746, "word": "រាជាគណៈ" },
    { "id": 10747, "word": "រាជាធិការី" },
    { "id": 10748, "word": "រាជាយតនៈ" },
    { "id": 10749, "word": "រាជាយតនចេតិយ" },
    { "id": 10750, "word": "រាជិនី" },
    { "id": 10751, "word": "រាជិនីកូល" },
    { "id": 10752, "word": "រាជិសី" },
    { "id": 10753, "word": "រាជី" },
    { "id": 10754, "word": "រាជូបករណ៍" },
    { "id": 10755, "word": "រាជេន្ទ្រ" },
    { "id": 10756, "word": "រាជោបករណ៍" },
    { "id": 10757, "word": "រាជ្យ" },
    { "id": 10758, "word": "រាជ្យាង្គ" },
    { "id": 10759, "word": "រាត់" },
    { "id": 10760, "word": "រ៉ាត់" },
    { "id": 10761, "word": "រាតត្បាត" },
    { "id": 10762, "word": "រ៉ាត់ប្រខុត" },
    { "id": 10763, "word": "រាតម្បាញ" },
    { "id": 10764, "word": "រាត់រាយ" },
    { "id": 10765, "word": "រាត្រី" },
    { "id": 10766, "word": "រាធន៍" },
    { "id": 10767, "word": "រាន" },
    { "id": 10768, "word": "រាន់" },
    { "id": 10769, "word": "រានកាន" },
    { "id": 10770, "word": "រានហាល" },
    { "id": 10771, "word": "រាប" },
    { "id": 10772, "word": "រាប់" },
    { "id": 10773, "word": "រ៉ាប់" },
    { "id": 10774, "word": "រាបទាប" },
    { "id": 10775, "word": "រ៉ាប់រង" },
    { "id": 10776, "word": "រាប់រៀប" },
    { "id": 10777, "word": "រាបសា" },
    { "id": 10778, "word": "រាប់អាន" },
    { "id": 10779, "word": "រាបណ៍" },
    { "id": 10780, "word": "រាម" },
    { "id": 10781, "word": "រាមកិរ្តិ៍" },
    { "id": 10782, "word": "រាមចន្ទ្រ" },
    { "id": 10783, "word": "រាមញ្ញ" },
    { "id": 10784, "word": "រាមណេយ្យ" },
    { "id": 10785, "word": "រាមភូមិ" },
    { "id": 10786, "word": "រាមរាជ្យ" },
    { "id": 10787, "word": "រាមសូរ" },
    { "id": 10788, "word": "រាមាយណ" },
    { "id": 10789, "word": "រាមាយណិក" },
    { "id": 10790, "word": "រាយ" },
    { "id": 10791, "word": "រាយង៉ាន" },
    { "id": 10792, "word": "រាយពពាយ" },
    { "id": 10793, "word": "រាយមាយ" },
    { "id": 10794, "word": "រាយរង" },
    { "id": 10795, "word": "រាយរាប់" },
    { "id": 10796, "word": "រារង់" },
    { "id": 10797, "word": "រារែក" },
    { "id": 10798, "word": "រារាំង" },
    { "id": 10799, "word": "រាល" },
    { "id": 10800, "word": "រាល់" },
    { "id": 10801, "word": "រាវ" },
    { "id": 10802, "word": "រ៉ាវ" },
    { "id": 10803, "word": "រ៉ាវតាវ" },
    { "id": 10804, "word": "រាវី" },
    { "id": 10805, "word": "រាស់" },
    { "id": 10806, "word": "រាសិចក្រ" },
    { "id": 10807, "word": "រាសី" },
    { "id": 10808, "word": "រាសីចក្រ" },
    { "id": 10809, "word": "រាស្ត្រ" },
    { "id": 10810, "word": "រាហុ" },
    { "id": 10811, "word": "រាហុ៍" },
    { "id": 10812, "word": "រាហុល" },
    { "id": 10813, "word": "រាហុលមាតា" },
    { "id": 10814, "word": "រាហូ" },
    { "id": 10815, "word": "រាហូ" },
    { "id": 10816, "word": "រិញៗ" },
    { "id": 10817, "word": "រិត្តភាព" },
    { "id": 10818, "word": "រិបុញ្ជ័យ" },
    { "id": 10819, "word": "រិម" },
    { "id": 10820, "word": "រិល" },
    { "id": 10821, "word": "រ៉ិល" },
    { "id": 10822, "word": "រិស្ត" },
    { "id": 10823, "word": "រិះ" },
    { "id": 10824, "word": "រី" },
    { "id": 10825, "word": "រ៉ី ?" },
    { "id": 10826, "word": "រីក" },
    { "id": 10827, "word": "រីករាយ" },
    { "id": 10828, "word": "រីង" },
    { "id": 10829, "word": "រីត" },
    { "id": 10830, "word": "រីតិ" },
    { "id": 10831, "word": "រឹង" },
    { "id": 10832, "word": "រឹងត្អឹង" },
    { "id": 10833, "word": "រឹងប៉ឹង" },
    { "id": 10834, "word": "រឹងរឹត" },
    { "id": 10835, "word": "រឹងរូស" },
    { "id": 10836, "word": "រ៉ឹង" },
    { "id": 10837, "word": "រឹត" },
    { "id": 10838, "word": "រឹតត្បិត" },
    { "id": 10839, "word": "រឹទ្ធិ" },
    { "id": 10840, "word": "រឹប" },
    { "id": 10841, "word": "រឹម" },
    { "id": 10842, "word": "រឹមៗ" },
    { "id": 10843, "word": "រឹល" },
    { "id": 10844, "word": "រឹស្យា" },
    { "id": 10845, "word": "រឹះ" },
    { "id": 10846, "word": "រ៉ឺងៗ" },
    { "id": 10847, "word": "រឺត" },
    { "id": 10848, "word": "រុក" },
    { "id": 10849, "word": "រុកកួន" },
    { "id": 10850, "word": "រុករ" },
    { "id": 10851, "word": "រុករាន" },
    { "id": 10852, "word": "រុក្ខ" },
    { "id": 10853, "word": "រុក្ខា" },
    { "id": 10854, "word": "រុង" },
    { "id": 10855, "word": "រុងរឿង" },
    { "id": 10856, "word": "រុងរោចន៍" },
    { "id": 10857, "word": "រុងរាំង" },
    { "id": 10858, "word": "រុចិរ" },
    { "id": 10859, "word": "រុច្ចនៈ" },
    { "id": 10860, "word": "រុជា" },
    { "id": 10861, "word": "រុញ" },
    { "id": 10862, "word": "រ៉ុញ" },
    { "id": 10863, "word": "រុញអង្រែ" },
    { "id": 10864, "word": "រុណ្ណ" },
    { "id": 10865, "word": "រុត" },
    { "id": 10866, "word": "រ៉ុតណាម" },
    { "id": 10867, "word": "រុន" },
    { "id": 10868, "word": "រុម្មិណ្តេ" },
    { "id": 10869, "word": "រុយ" },
    { "id": 10870, "word": "រ៉ុយ" },
    { "id": 10871, "word": "រ៉ុយៗ" },
    { "id": 10872, "word": "រុល" },
    { "id": 10873, "word": "រ៉ុល" },
    { "id": 10874, "word": "រុះ" },
    { "id": 10875, "word": "រូ" },
    { "id": 10876, "word": "រូង" },
    { "id": 10877, "word": "រ៉ូង" },
    { "id": 10878, "word": "រូត" },
    { "id": 10879, "word": "រូតរះ" },
    { "id": 10880, "word": "រូប" },
    { "id": 10881, "word": "រូប --" },
    { "id": 10882, "word": "រូបា" },
    { "id": 10883, "word": "រូបា --" },
    { "id": 10884, "word": "រូបិនី" },
    { "id": 10885, "word": "រូបិយ " },
    { "id": 10886, "word": "រូបី" },
    { "id": 10887, "word": "រូពី" },
    { "id": 10888, "word": "រូស" },
    { "id": 10889, "word": "រូហាន" },
    { "id": 10890, "word": "រួច" },
    { "id": 10891, "word": "រួចរាល់" },
    { "id": 10892, "word": "រួញ" },
    { "id": 10893, "word": "រួញរា" },
    { "id": 10894, "word": "រួត" },
    { "id": 10895, "word": "រួន" },
    { "id": 10896, "word": "រួប" },
    { "id": 10897, "word": "រួបរឹត" },
    { "id": 10898, "word": "រួបរួម" },
    { "id": 10899, "word": "រួម" },
    { "id": 10900, "word": "រួយ" },
    { "id": 10901, "word": "រួល" },
    { "id": 10902, "word": "រួស" },
    { "id": 10903, "word": "រួសរក" },
    { "id": 10904, "word": "រួសរាន់" },
    { "id": 10905, "word": "រួសរាយ" },
    { "id": 10906, "word": "រួសរ៉ាវ" },
    { "id": 10907, "word": "រើ" },
    { "id": 10908, "word": "រ៉ើកៗ" },
    { "id": 10909, "word": "រ៉ើងៗ" },
    { "id": 10910, "word": "រើប" },
    { "id": 10911, "word": "រើម" },
    { "id": 10912, "word": "រើស" },
    { "id": 10913, "word": "រើសត្អើស" },
    { "id": 10914, "word": "រើសអើង" },
    { "id": 10915, "word": "រើអៀង" },
    { "id": 10916, "word": "រឿ" },
    { "id": 10917, "word": "រឿង" },
    { "id": 10918, "word": "រឿងរ៉ាវ" },
    { "id": 10919, "word": "រឿណរង្គ" },
    { "id": 10920, "word": "រឿនហ្លួង" },
    { "id": 10921, "word": "រឿយ" },
    { "id": 10922, "word": "រៀង" },
    { "id": 10923, "word": "រៀន" },
    { "id": 10924, "word": "រៀប" },
    { "id": 10925, "word": "រៀបចំ" },
    { "id": 10926, "word": "រៀបរប" },
    { "id": 10927, "word": "រៀបរយ" },
    { "id": 10928, "word": "រៀបរាប់" },
    { "id": 10929, "word": "រៀបរៀង" },
    { "id": 10930, "word": "រៀម" },
    { "id": 10931, "word": "រៀមច្បង " },
    { "id": 10932, "word": "រៀរ៉ាយ" },
    { "id": 10933, "word": "រៀរ៉ៃ" },
    { "id": 10934, "word": "រៀល" },
    { "id": 10935, "word": "រៀវ" },
    { "id": 10936, "word": "រេ" },
    { "id": 10937, "word": "រ៉េ" },
    { "id": 10938, "word": "រេខា" },
    { "id": 10939, "word": "រេច" },
    { "id": 10940, "word": "រេចក ភេសជ្ជៈ" },
    { "id": 10941, "word": "រេចនកម្ម" },
    { "id": 10942, "word": "រេញ" },
    { "id": 10943, "word": "រេញៗ" },
    { "id": 10944, "word": "រេណុ" },
    { "id": 10945, "word": "រេប័ស" },
    { "id": 10946, "word": "រេផៈ" },
    { "id": 10947, "word": "រេពល" },
    { "id": 10948, "word": "រេរង់" },
    { "id": 10949, "word": "រេល" },
    { "id": 10950, "word": "រ៉េវ" },
    { "id": 10951, "word": "រេវតី" },
    { "id": 10952, "word": "រេហ៍ពល" },
    { "id": 10953, "word": "រេះ" },
    { "id": 10954, "word": "រ៉េះៗ " },
    { "id": 10955, "word": "រ៉ែៗ" },
    { "id": 10956, "word": "រែក" },
    { "id": 10957, "word": "រែង" },
    { "id": 10958, "word": "រ៉ែងៗ" },
    { "id": 10959, "word": "រ៉ែត" },
    { "id": 10960, "word": "រ៉ែរ៉" },
    { "id": 10961, "word": "រែះ" },
    { "id": 10962, "word": "រៃ" },
    { "id": 10963, "word": "រ៉ៃ" },
    { "id": 10964, "word": "រៃទឹក" },
    { "id": 10965, "word": "រោក" },
    { "id": 10966, "word": "រោគ" },
    { "id": 10967, "word": "រោគា" },
    { "id": 10968, "word": "រោគាពាធ" },
    { "id": 10969, "word": "រោគាយតនៈ" },
    { "id": 10970, "word": "រោគិនី" },
    { "id": 10971, "word": "រោគី" },
    { "id": 10972, "word": "រោង" },
    { "id": 10973, "word": "រោច" },
    { "id": 10974, "word": "រោចនៈ" },
    { "id": 10975, "word": "រោទ៍" },
    { "id": 10976, "word": "រោទន" },
    { "id": 10977, "word": "រោធន" },
    { "id": 10978, "word": "រោបក" },
    { "id": 10979, "word": "រោបន" },
    { "id": 10980, "word": "រោបការិនី" },
    { "id": 10981, "word": "រោម" },
    { "id": 10982, "word": "រោយ" },
    { "id": 10983, "word": "រោយរាយ" },
    { "id": 10984, "word": "រោយរៀវ" },
    { "id": 10985, "word": "រោយស្បៃ" },
    { "id": 10986, "word": "រោរព" },
    { "id": 10987, "word": "រោល" },
    { "id": 10988, "word": "រោលរាល" },
    { "id": 10989, "word": "រោស" },
    { "id": 10990, "word": "រោហិណី" },
    { "id": 10991, "word": "រោហិត" },
    { "id": 10992, "word": "រុំ" },
    { "id": 10993, "word": "រុំកោះ" },
    { "id": 10994, "word": "រំ" },
    { "id": 10995, "word": "រំកាច់" },
    { "id": 10996, "word": "រំកាច់មាស" },
    { "id": 10997, "word": "រំកាច់រំកោច" },
    { "id": 10998, "word": "រំកិល" },
    { "id": 10999, "word": "រំខាន" },
    { "id": 11000, "word": "រំគងកែវស្នេហ៍" },
    { "id": 11001, "word": "រំគាយ" },
    { "id": 11002, "word": "រំគាល" },
    { "id": 11003, "word": "រំគេញ" },
    { "id": 11004, "word": "រំងក" },
    { "id": 11005, "word": "រំងាច" },
    { "id": 11006, "word": "រំងាប់" },
    { "id": 11007, "word": "រំងាស់" },
    { "id": 11008, "word": "រំងើក" },
    { "id": 11009, "word": "រំចាក" },
    { "id": 11010, "word": "រំចីដៃ" },
    { "id": 11011, "word": "រំចេក" },
    { "id": 11012, "word": "រំជា" },
    { "id": 11013, "word": "រំជីក" },
    { "id": 11014, "word": "រំជីរំជា" },
    { "id": 11015, "word": "រំជួល" },
    { "id": 11016, "word": "រំជើប" },
    { "id": 11017, "word": "រំជេញ" },
    { "id": 11018, "word": "រំជែ" },
    { "id": 11019, "word": "រំជែក" },
    { "id": 11020, "word": "រំជំរំជែង " },
    { "id": 11021, "word": "រំដាក" },
    { "id": 11022, "word": "រំដួល" },
    { "id": 11023, "word": "រំដេក" },
    { "id": 11024, "word": "រំដេង" },
    { "id": 11025, "word": "រំដេញ" },
    { "id": 11026, "word": "រំដេញមាស" },
    { "id": 11027, "word": "រំដោះ" },
    { "id": 11028, "word": "រំទំ" },
    { "id": 11029, "word": "រំបល់" },
    { "id": 11030, "word": "រំប៉ើក" },
    { "id": 11031, "word": "រំពង" },
    { "id": 11032, "word": "រំពត់" },
    { "id": 11033, "word": "រំពា" },
    { "id": 11034, "word": "រំពាត់" },
    { "id": 11035, "word": "រំពាស់" },
    { "id": 11036, "word": "រំពឹង" },
    { "id": 11037, "word": "រំពុះ" },
    { "id": 11038, "word": "រំពើក" },
    { "id": 11039, "word": "រំពើន" },
    { "id": 11040, "word": "រំពេ" },
    { "id": 11041, "word": "រំពេច" },
    { "id": 11042, "word": "រំពេន" },
    { "id": 11043, "word": "រំពៃ" },
    { "id": 11044, "word": "រំភាយ" },
    { "id": 11045, "word": "រំភើក" },
    { "id": 11046, "word": "រំភើប" },
    { "id": 11047, "word": "រំភើយ" },
    { "id": 11048, "word": "រំយាក" },
    { "id": 11049, "word": "រំយីក" },
    { "id": 11050, "word": "រំយោល" },
    { "id": 11051, "word": "រំលង" },
    { "id": 11052, "word": "រំលត់" },
    { "id": 11053, "word": "រំលប់" },
    { "id": 11054, "word": "រំលស់" },
    { "id": 11055, "word": "រំលា" },
    { "id": 11056, "word": "រំលាក" },
    { "id": 11057, "word": "រំលាង" },
    { "id": 11058, "word": "រំលាយ" },
    { "id": 11059, "word": "រំលិច" },
    { "id": 11060, "word": "រំលីង" },
    { "id": 11061, "word": "រំលឹក" },
    { "id": 11062, "word": "រំលុង" },
    { "id": 11063, "word": "រំលុប" },
    { "id": 11064, "word": "រំលុះ" },
    { "id": 11065, "word": "រំលូត" },
    { "id": 11066, "word": "រំលើក" },
    { "id": 11067, "word": "រំលើង" },
    { "id": 11068, "word": "រំលៀក" },
    { "id": 11069, "word": "រំលៀង" },
    { "id": 11070, "word": "រំលេច" },
    { "id": 11071, "word": "រំលេប" },
    { "id": 11072, "word": "រំលេម" },
    { "id": 11073, "word": "រំលេះ" },
    { "id": 11074, "word": "រំលែក" },
    { "id": 11075, "word": "រំលែះ" },
    { "id": 11076, "word": "រំលោក" },
    { "id": 11077, "word": "រំលោង" },
    { "id": 11078, "word": "រំលោភ" },
    { "id": 11079, "word": "រំលំ" },
    { "id": 11080, "word": "រំសាយ" },
    { "id": 11081, "word": "រំសុស" },
    { "id": 11082, "word": "រំសេវ" },
    { "id": 11083, "word": "រំសោះ" },
    { "id": 11084, "word": "រំហ" },
    { "id": 11085, "word": "រំហ័ស" },
    { "id": 11086, "word": "រំហាច" },
    { "id": 11087, "word": "រំហុក" },
    { "id": 11088, "word": "រំហូត" },
    { "id": 11089, "word": "រំហូរ" },
    { "id": 11090, "word": "រំហួត" },
    { "id": 11091, "word": "រំហើយ" },
    { "id": 11092, "word": "រំហែ" },
    { "id": 11093, "word": "រំហោក" },
    { "id": 11094, "word": "រំអា" },
    { "id": 11095, "word": "រំអិល " },
    { "id": 11096, "word": "រំអុក" },
    { "id": 11097, "word": "រំអុករំអែ" },
    { "id": 11098, "word": "រំអួយ" },
    { "id": 11099, "word": "រំអើក" },
    { "id": 11100, "word": "រំអែង" },
    { "id": 11101, "word": "រំអែរំអួយ" },
    { "id": 11102, "word": "រំឭក" },
    { "id": 11103, "word": "រាំ" },
    { "id": 11104, "word": "រ៉ាំ" },
    { "id": 11105, "word": "រាំង" },
    { "id": 11106, "word": "រាំងគន្លង" },
    { "id": 11107, "word": "រាំងជល" },
    { "id": 11108, "word": "រ៉ាំងណុក" },
    { "id": 11109, "word": "រាំងរា" },
    { "id": 11110, "word": "រាំងសាប" },
    { "id": 11111, "word": "រាំរៀល" },
    { "id": 11112, "word": "រ៉ាំរ៉ៃ" },
    { "id": 11113, "word": "រះ" },
    { "id": 11114, "word": "រះមុខ" },
    { "id": 11115, "word": "រះសំបែង" },
    { "id": 11116, "word": "ឫ" },
    { "id": 11117, "word": "ឫក" },
    { "id": 11118, "word": "ឫក្ស" },
    { "id": 11119, "word": "ឫក្សណៈ" },
    { "id": 11120, "word": "ឫក្សពារ" },
    { "id": 11121, "word": "ឫក្សេស" },
    { "id": 11122, "word": "ឫគ្វេទ" },
    { "id": 11123, "word": "ឫណ" },
    { "id": 11124, "word": "ឫត" },
    { "id": 11125, "word": "ឫតិយា" },
    { "id": 11126, "word": "ឫតុ" },
    { "id": 11127, "word": "ឫទ្ធ" },
    { "id": 11128, "word": "ឫទ្ធា " },
    { "id": 11129, "word": "ឫទ្ធានុភាព" },
    { "id": 11130, "word": "ឫទ្ធិ" },
    { "id": 11131, "word": "ឫស" },
    { "id": 11132, "word": "ឫសដី" },
    { "id": 11133, "word": "ឫសដូង" },
    { "id": 11134, "word": "ឫសដូងបាត" },
    { "id": 11135, "word": "ឫសភ" },
    { "id": 11136, "word": "ឫសី" },
    { "id": 11137, "word": "ឫសីប្លែងសារ" },
    { "id": 11138, "word": "ឫសីផ្សំ ស្រេច" },
    { "id": 11139, "word": "ឫស្ដី" },
    { "id": 11140, "word": "ឫស្យា" },
    { "id": 11141, "word": "ឫស្សី" },
    { "id": 11142, "word": "ឬ" },
    { "id": 11143, "word": "ឬ" },
    { "id": 11144, "word": "ល" },
    { "id": 11145, "word": "។ល។" },
    { "id": 11146, "word": "លក" },
    { "id": 11147, "word": "លក់" },
    { "id": 11148, "word": "ល័ក្កចាន់" },
    { "id": 11149, "word": "លក្ខ" },
    { "id": 11150, "word": "លក្ខខណ្ឌ" },
    { "id": 11151, "word": "លក្ខណ" },
    { "id": 11152, "word": "លក្ខណ៍" },
    { "id": 11153, "word": "ល័ក្ខណ៍" },
    { "id": 11154, "word": "លក្ខណា" },
    { "id": 11155, "word": "លក្ខន្តិក" },
    { "id": 11156, "word": "ល័ក្ត" },
    { "id": 11157, "word": "លក្សណ៍" },
    { "id": 11158, "word": "លក្ស្មណៈ" },
    { "id": 11159, "word": "លក្ស្មី" },
    { "id": 11160, "word": "ល័ខ" },
    { "id": 11161, "word": "លគុឌ" },
    { "id": 11162, "word": "លឃុ" },
    { "id": 11163, "word": "លង" },
    { "id": 11164, "word": "លង់" },
    { "id": 11165, "word": "លង់ទ្រនេស" },
    { "id": 11166, "word": "លង់លុះ" },
    { "id": 11167, "word": "លង់ហិន" },
    { "id": 11168, "word": "លង្កា" },
    { "id": 11169, "word": "លង្កាទ្វីប" },
    { "id": 11170, "word": "លង្ឃនៈ" },
    { "id": 11171, "word": "លង្វែក" },
    { "id": 11172, "word": "លង្ហិន" },
    { "id": 11173, "word": "លជ្ជាភាព" },
    { "id": 11174, "word": "លជ្ជិនី" },
    { "id": 11175, "word": "លជ្ជី" },
    { "id": 11176, "word": "លញ់" },
    { "id": 11177, "word": "លញ្ច" },
    { "id": 11178, "word": "លញ្ឆករ" },
    { "id": 11179, "word": "លញ្ឆការ" },
    { "id": 11180, "word": "លញ្ជិកា" },
    { "id": 11181, "word": "លត" },
    { "id": 11182, "word": "លត់" },
    { "id": 11183, "word": "លតា" },
    { "id": 11184, "word": "លទ្ធ" },
    { "id": 11185, "word": "លទ្ធិ" },
    { "id": 11186, "word": "លន" },
    { "id": 11187, "word": "លន់" },
    { "id": 11188, "word": "លន់តួ " },
    { "id": 11189, "word": "លន្តែ" },
    { "id": 11190, "word": "លន្លង់" },
    { "id": 11191, "word": "លន្លាម" },
    { "id": 11192, "word": "លន្លឹម" },
    { "id": 11193, "word": "លន្លោច" },
    { "id": 11194, "word": "លប" },
    { "id": 11195, "word": "លប់" },
    { "id": 11196, "word": "លពបុរី" },
    { "id": 11197, "word": "ល័ព្ធ" },
    { "id": 11198, "word": "លម" },
    { "id": 11199, "word": "លម៉ើ" },
    { "id": 11200, "word": "លម្បដ" },
    { "id": 11201, "word": "លម្ហ" },
    { "id": 11202, "word": "លម្ហាច" },
    { "id": 11203, "word": "លម្ហើយ" },
    { "id": 11204, "word": "លម្ហែ" },
    { "id": 11205, "word": "លម្អ" },
    { "id": 11206, "word": "លម្អក់" },
    { "id": 11207, "word": "លម្អក់ព័ណ៌" },
    { "id": 11208, "word": "លម្អង" },
    { "id": 11209, "word": "លម្អន់" },
    { "id": 11210, "word": "លម្អិត" },
    { "id": 11211, "word": "លម្អៀង" },
    { "id": 11212, "word": "លយ" },
    { "id": 11213, "word": "លយៈ" },
    { "id": 11214, "word": "លយកែវ" },
    { "id": 11215, "word": "លយឆាយ" },
    { "id": 11216, "word": "លលក" },
    { "id": 11217, "word": "លលកខ្មោច" },
    { "id": 11218, "word": "លលកទ្រាំង" },
    { "id": 11219, "word": "លលកប្រះ" },
    { "id": 11220, "word": "លលកស" },
    { "id": 11221, "word": "លលា" },
    { "id": 11222, "word": "លលា" },
    { "id": 11223, "word": "លលាដ" },
    { "id": 11224, "word": "លលាដបដ្ដ" },
    { "id": 11225, "word": "លលាតែ" },
    { "id": 11226, "word": "លលាម" },
    { "id": 11227, "word": "លលិត" },
    { "id": 11228, "word": "លលីមលលាម" },
    { "id": 11229, "word": "លលឹម" },
    { "id": 11230, "word": "លលួង" },
    { "id": 11231, "word": "លលេ" },
    { "id": 11232, "word": "លលៃ" },
    { "id": 11233, "word": "លវោ" },
    { "id": 11234, "word": "លស់" },
    { "id": 11235, "word": "លស់លា" },
    { "id": 11236, "word": "លហុ" },
    { "id": 11237, "word": "លហុកាបត្តិ" },
    { "id": 11238, "word": "លា" },
    { "id": 11239, "word": "លាក" },
    { "id": 11240, "word": "លាក់" },
    { "id": 11241, "word": "លាក់កន្សែង" },
    { "id": 11242, "word": "លាក់កូន កាស" },
    { "id": 11243, "word": "លាក់ធ្យូង" },
    { "id": 11244, "word": "លាកុដិក" },
    { "id": 11245, "word": "លាឃវៈ" },
    { "id": 11246, "word": "លាង" },
    { "id": 11247, "word": "លាងសាធ" },
    { "id": 11248, "word": "លាជ" },
    { "id": 11249, "word": "លាជផ្ទុះ" },
    { "id": 11250, "word": "លាញ" },
    { "id": 11251, "word": "លាត" },
    { "id": 11252, "word": "លាត់" },
    { "id": 11253, "word": "លាទា" },
    { "id": 11254, "word": "លាន" },
    { "id": 11255, "word": "លាន់" },
    { "id": 11256, "word": "លានជាង" },
    { "id": 11257, "word": "លាប" },
    { "id": 11258, "word": "លាប់" },
    { "id": 11259, "word": "លាភ" },
    { "id": 11260, "word": "លាភូបនិសា" },
    { "id": 11261, "word": "លាម" },
    { "id": 11262, "word": "លាមក" },
    { "id": 11263, "word": "លាយ" },
    { "id": 11264, "word": "លាយដៃ" },
    { "id": 11265, "word": "លាយទែង" },
    { "id": 11266, "word": "លាយនកម្ម" },
    { "id": 11267, "word": "លាយលក្ខណ៍" },
    { "id": 11268, "word": "លាយល័ក្ត" },
    { "id": 11269, "word": "លាយល័ខ" },
    { "id": 11270, "word": "លាយសាំ" },
    { "id": 11271, "word": "លាយឡំ" },
    { "id": 11272, "word": "លាវ" },
    { "id": 11273, "word": "លាវក" },
    { "id": 11274, "word": "លាវ័ណ្យ " },
    { "id": 11275, "word": "លាវិកា" },
    { "id": 11276, "word": "លាស" },
    { "id": 11277, "word": "លាស់" },
    { "id": 11278, "word": "លាសក" },
    { "id": 11279, "word": "លាសន" },
    { "id": 11280, "word": "លាសិកា" },
    { "id": 11281, "word": "លិកេ" },
    { "id": 11282, "word": "លិក្ខា" },
    { "id": 11283, "word": "លិខនកម្ម" },
    { "id": 11284, "word": "លិខនកិច្ច" },
    { "id": 11285, "word": "លិខិត" },
    { "id": 11286, "word": "លិខិតគោចរ" },
    { "id": 11287, "word": "លិខិតឆ្លងដែន" },
    { "id": 11288, "word": "លិង្គ" },
    { "id": 11289, "word": "លិង្គត្ថេនកៈ" },
    { "id": 11290, "word": "លិង្គនាសនា" },
    { "id": 11291, "word": "លិង្គព្រឹត្តិ" },
    { "id": 11292, "word": "លិង្គវិបល្លាស" },
    { "id": 11293, "word": "លិង្គអរិយៈ" },
    { "id": 11294, "word": "លិច" },
    { "id": 11295, "word": "លិញ" },
    { "id": 11296, "word": "លិញគិញ" },
    { "id": 11297, "word": "លិឍ" },
    { "id": 11298, "word": "លិទ្ធ" },
    { "id": 11299, "word": "លិនជី" },
    { "id": 11300, "word": "លិបិការ" },
    { "id": 11301, "word": "លិបិការិកា" },
    { "id": 11302, "word": "លិបិក្រម" },
    { "id": 11303, "word": "លិបិសជ្ជា" },
    { "id": 11304, "word": "លិប្តា" },
    { "id": 11305, "word": "លិប្សា" },
    { "id": 11306, "word": "លិម្បកម្ម" },
    { "id": 11307, "word": "លិម្បការ" },
    { "id": 11308, "word": "លិម្បការិកា" },
    { "id": 11309, "word": "លី" },
    { "id": 11310, "word": "លីកលាន" },
    { "id": 11311, "word": "លីង" },
    { "id": 11312, "word": "លីងល័ក្ត" },
    { "id": 11313, "word": "លីងលាជ" },
    { "id": 11314, "word": "លីលា" },
    { "id": 11315, "word": "លីលាប់" },
    { "id": 11316, "word": "លីលាស" },
    { "id": 11317, "word": "លីវ" },
    { "id": 11318, "word": "លីឡ្ហា" },
    { "id": 11319, "word": "លឹន" },
    { "id": 11320, "word": "លឹប" },
    { "id": 11321, "word": "លឹមៗ" },
    { "id": 11322, "word": "លឺ" },
    { "id": 11323, "word": "លឺជ័យ" },
    { "id": 11324, "word": "លឺជា" },
    { "id": 11325, "word": "លឺលាន់" },
    { "id": 11326, "word": "លឺសាយ" },
    { "id": 11327, "word": "លុក" },
    { "id": 11328, "word": "លុង" },
    { "id": 11329, "word": "លុត" },
    { "id": 11330, "word": "លុត្ត" },
    { "id": 11331, "word": "លុទ្ទៈ" },
    { "id": 11332, "word": "លុទ្ធបុគ្គល" },
    { "id": 11333, "word": "លុន" },
    { "id": 11334, "word": "លុប" },
    { "id": 11335, "word": "លុបន័យ" },
    { "id": 11336, "word": "លុម្បក" },
    { "id": 11337, "word": "លុម្បកម្ម" },
    { "id": 11338, "word": "លុម្បិកា " },
    { "id": 11339, "word": "លុម្ពិនី" },
    { "id": 11340, "word": "លុយ" },
    { "id": 11341, "word": "លុះ" },
    { "id": 11342, "word": "លូ" },
    { "id": 11343, "word": "លូក" },
    { "id": 11344, "word": "លូកឃុន" },
    { "id": 11345, "word": "លូកលាន់" },
    { "id": 11346, "word": "លូខ" },
    { "id": 11347, "word": "លូច" },
    { "id": 11348, "word": "លូត" },
    { "id": 11349, "word": "លូន" },
    { "id": 11350, "word": "លួង" },
    { "id": 11351, "word": "លួច" },
    { "id": 11352, "word": "លួត" },
    { "id": 11353, "word": "លួស" },
    { "id": 11354, "word": "លើ" },
    { "id": 11355, "word": "លើក" },
    { "id": 11356, "word": "លើង" },
    { "id": 11357, "word": "លើស" },
    { "id": 11358, "word": "លឿង" },
    { "id": 11359, "word": "លឿងឮ" },
    { "id": 11360, "word": "លឿន" },
    { "id": 11361, "word": "លឿម" },
    { "id": 11362, "word": "លឿយ" },
    { "id": 11363, "word": "លៀង" },
    { "id": 11364, "word": "លៀងភា" },
    { "id": 11365, "word": "លៀត" },
    { "id": 11366, "word": "លៀន" },
    { "id": 11367, "word": "លៀប" },
    { "id": 11368, "word": "លៀម" },
    { "id": 11369, "word": "លៀវ" },
    { "id": 11370, "word": "លៀស" },
    { "id": 11371, "word": "លេខ" },
    { "id": 11372, "word": "លេខ" },
    { "id": 11373, "word": "លេខកៈ" },
    { "id": 11374, "word": "លេខទោ" },
    { "id": 11375, "word": "លេខនី" },
    { "id": 11376, "word": "លេខបត្រ" },
    { "id": 11377, "word": "លេខហារី" },
    { "id": 11378, "word": "លេខអស្ដា" },
    { "id": 11379, "word": "លេខា" },
    { "id": 11380, "word": "លេខាធិការ" },
    { "id": 11381, "word": "លេខានុការ" },
    { "id": 11382, "word": "លេង" },
    { "id": 11383, "word": "លេច" },
    { "id": 11384, "word": "លេញ" },
    { "id": 11385, "word": "លេញលេង" },
    { "id": 11386, "word": "លេញ្ជា" },
    { "id": 11387, "word": "លេឌ្ឌុបាត" },
    { "id": 11388, "word": "លេណដ្ឋាន" },
    { "id": 11389, "word": "លេណ្ឌុបាត" },
    { "id": 11390, "word": "លេប" },
    { "id": 11391, "word": "លេបកម្ម" },
    { "id": 11392, "word": "លេបការ" },
    { "id": 11393, "word": "លេលា" },
    { "id": 11394, "word": "លេលាប់" },
    { "id": 11395, "word": "លេស" },
    { "id": 11396, "word": "លេះ" },
    { "id": 11397, "word": "លែ" },
    { "id": 11398, "word": "លែង" },
    { "id": 11399, "word": "លែនពែន" },
    { "id": 11400, "word": "លែនលន" },
    { "id": 11401, "word": "លែបខាយ" },
    { "id": 11402, "word": "លែះ" },
    { "id": 11403, "word": "លៃ" },
    { "id": 11404, "word": "លៃលក" },
    { "id": 11405, "word": "លោ" },
    { "id": 11406, "word": "លោក" },
    { "id": 11407, "word": "លោក --" },
    { "id": 11408, "word": "លោកន្តរនរក" },
    { "id": 11409, "word": "លោកា" },
    { "id": 11410, "word": "លោកា --" },
    { "id": 11411, "word": "លោកិយ" },
    { "id": 11412, "word": "លោកីយ៍" },
    { "id": 11413, "word": "លោកុត្តរ" },
    { "id": 11414, "word": "លោកេស្វរៈ" },
    { "id": 11415, "word": "លោង" },
    { "id": 11416, "word": "លោណ ម្ពិល" },
    { "id": 11417, "word": "លោត" },
    { "id": 11418, "word": "លោតអង្រែ" },
    { "id": 11419, "word": "លោតអន្ទាក់" },
    { "id": 11420, "word": "លោតែ" },
    { "id": 11421, "word": "លោទ" },
    { "id": 11422, "word": "លោប" },
    { "id": 11423, "word": "លោភ" },
    { "id": 11424, "word": "លោភៈ" },
    { "id": 11425, "word": "លោភោ" },
    { "id": 11426, "word": "លោម" },
    { "id": 11427, "word": "លោមទោម " },
    { "id": 11428, "word": "លោមព័ណ៌" },
    { "id": 11429, "word": "លោមសារ" },
    { "id": 11430, "word": "លោមា" },
    { "id": 11431, "word": "លោលតា" },
    { "id": 11432, "word": "លោលា" },
    { "id": 11433, "word": "លោលុប" },
    { "id": 11434, "word": "លោហៈ" },
    { "id": 11435, "word": "លោហ --" },
    { "id": 11436, "word": "លោហិត" },
    { "id": 11437, "word": "លោហិត បក្ខន្ទិកាពាធ" },
    { "id": 11438, "word": "លោហិតភក្ខ" },
    { "id": 11439, "word": "លោហិតាគារ" },
    { "id": 11440, "word": "លោហិតាពាធ" },
    { "id": 11441, "word": "លោហិតុប្បាទ" },
    { "id": 11442, "word": "លោះ" },
    { "id": 11443, "word": "លោះលាយ" },
    { "id": 11444, "word": "លៅ" },
    { "id": 11445, "word": "លំ" },
    { "id": 11446, "word": "លំគេញ" },
    { "id": 11447, "word": "លំចង់" },
    { "id": 11448, "word": "លំញង" },
    { "id": 11449, "word": "លំដាប់" },
    { "id": 11450, "word": "លំដោយ" },
    { "id": 11451, "word": "លំទោន" },
    { "id": 11452, "word": "លំនាច" },
    { "id": 11453, "word": "លំនឹង" },
    { "id": 11454, "word": "លំនៅ" },
    { "id": 11455, "word": "លំនាំ" },
    { "id": 11456, "word": "លំនាំសមសារ" },
    { "id": 11457, "word": "លំប៉ា" },
    { "id": 11458, "word": "លំបាក" },
    { "id": 11459, "word": "លំបិន" },
    { "id": 11460, "word": "លំបេក" },
    { "id": 11461, "word": "លំផក" },
    { "id": 11462, "word": "លំផូង" },
    { "id": 11463, "word": "លំពង់" },
    { "id": 11464, "word": "លំពស់" },
    { "id": 11465, "word": "លំពាន់" },
    { "id": 11466, "word": "លំពាស់" },
    { "id": 11467, "word": "លំពើន" },
    { "id": 11468, "word": "លំពែង" },
    { "id": 11469, "word": "លំពែងព្រះរាម" },
    { "id": 11470, "word": "លំពែងស្នែងក្របី" },
    { "id": 11471, "word": "លំពែងអរឹស" },
    { "id": 11472, "word": "លំពាំង" },
    { "id": 11473, "word": "លំហ" },
    { "id": 11474, "word": "លំហាច" },
    { "id": 11475, "word": "លំហុក" },
    { "id": 11476, "word": "លំហួត" },
    { "id": 11477, "word": "លំហើយ" },
    { "id": 11478, "word": "លំហែ" },
    { "id": 11479, "word": "លំហោក" },
    { "id": 11480, "word": "លំអ" },
    { "id": 11481, "word": "លំអក់" },
    { "id": 11482, "word": "លំអក់ព័ណ៌" },
    { "id": 11483, "word": "លំអង" },
    { "id": 11484, "word": "លំអន់" },
    { "id": 11485, "word": "លំអិត" },
    { "id": 11486, "word": "លំអិតលំអូន" },
    { "id": 11487, "word": "លំអុត" },
    { "id": 11488, "word": "លំអូត" },
    { "id": 11489, "word": "លំអៀង" },
    { "id": 11490, "word": "លំឱន" },
    { "id": 11491, "word": "លាំ" },
    { "id": 11492, "word": "លាំង" },
    { "id": 11493, "word": "លាំងៗ" },
    { "id": 11494, "word": "លាំងជ័យ" },
    { "id": 11495, "word": "លាំងសាត" },
    { "id": 11496, "word": "លាំលើស" },
    { "id": 11497, "word": "លះ" },
    { "id": 11498, "word": "លះបង់" },
    { "id": 11499, "word": "លះលាក" },
    { "id": 11500, "word": "លះលែង" },
    { "id": 11501, "word": "ល្កក់" },
    { "id": 11502, "word": "ល្កម" },
    { "id": 11503, "word": "ល្ខោន" },
    { "id": 11504, "word": "ល្គង" },
    { "id": 11505, "word": "ល្គាយ" },
    { "id": 11506, "word": "ល្គាយល្គង" },
    { "id": 11507, "word": "ល្គឹក" },
    { "id": 11508, "word": "ល្គឹកណាតែ" },
    { "id": 11509, "word": "ល្គេន" },
    { "id": 11510, "word": "ល្ង" },
    { "id": 11511, "word": "ល្ងង់" },
    { "id": 11512, "word": "ល្ងម" },
    { "id": 11513, "word": "ល្ងាច" },
    { "id": 11514, "word": "ល្ងាន់" },
    { "id": 11515, "word": "ល្ងីល្ងើ" },
    { "id": 11516, "word": "ល្ងៀង" },
    { "id": 11517, "word": "ល្ងៀងជូតអាចម៍កូន" },
    { "id": 11518, "word": "ល្ងៀម" },
    { "id": 11519, "word": "ល្ងេល្ងើ" },
    { "id": 11520, "word": "ល្បក" },
    { "id": 11521, "word": "ល្បក់" },
    { "id": 11522, "word": "ល្បង" },
    { "id": 11523, "word": "ល្បត់" },
    { "id": 11524, "word": "ល្បប់" },
    { "id": 11525, "word": "ល្បាក់" },
    { "id": 11526, "word": "ល្បាក់ទឹក" },
    { "id": 11527, "word": "ល្បាក់សា" },
    { "id": 11528, "word": "ល្បាញ" },
    { "id": 11529, "word": "ល្បាត" },
    { "id": 11530, "word": "ល្បាប់" },
    { "id": 11531, "word": "ល្បាយ" },
    { "id": 11532, "word": "ល្បាស់" },
    { "id": 11533, "word": "ល្បាស់កាំ" },
    { "id": 11534, "word": "ល្បិច" },
    { "id": 11535, "word": "ល្បិចចៅក្រម" },
    { "id": 11536, "word": "ល្បី" },
    { "id": 11537, "word": "ល្បុក្កតោ" },
    { "id": 11538, "word": "ល្បុង" },
    { "id": 11539, "word": "ល្បួង" },
    { "id": 11540, "word": "ល្បើក" },
    { "id": 11541, "word": "ល្បឿន" },
    { "id": 11542, "word": "ល្បែង" },
    { "id": 11543, "word": "ល្បោយ" },
    { "id": 11544, "word": "ល្បោះ" },
    { "id": 11545, "word": "ល្បោះល្បោយ" },
    { "id": 11546, "word": "ល្បះ" },
    { "id": 11547, "word": "ល្ពេញល្ពៅ" },
    { "id": 11548, "word": "ល្ពៅ" },
    { "id": 11549, "word": "ល្មម" },
    { "id": 11550, "word": "ល្មមល្មៃ" },
    { "id": 11551, "word": "ល្មាក់" },
    { "id": 11552, "word": "ល្មាស" },
    { "id": 11553, "word": "ល្មិច" },
    { "id": 11554, "word": "ល្មីល្មើ" },
    { "id": 11555, "word": "ល្មុង" },
    { "id": 11556, "word": "ល្មុត" },
    { "id": 11557, "word": "ល្មួច" },
    { "id": 11558, "word": "ល្មួត" },
    { "id": 11559, "word": "ល្ម៉ើ" },
    { "id": 11560, "word": "ល្មើស" },
    { "id": 11561, "word": "ល្មឿង" },
    { "id": 11562, "word": "ល្មឿយ" },
    { "id": 11563, "word": "ល្មៀត" },
    { "id": 11564, "word": "ល្មេច" },
    { "id": 11565, "word": "ល្មេញល្មើ" },
    { "id": 11566, "word": "ល្មែះ" },
    { "id": 11567, "word": "ល្មៃ" },
    { "id": 11568, "word": "ល្មោភ" },
    { "id": 11569, "word": "ល្មាំង" },
    { "id": 11570, "word": "ល្យំ" },
    { "id": 11571, "word": "ល្វក់" },
    { "id": 11572, "word": "ល្វត" },
    { "id": 11573, "word": "ល្វន់" },
    { "id": 11574, "word": "ល្វា" },
    { "id": 11575, "word": "ល្វាចេក" },
    { "id": 11576, "word": "ល្វាដី" },
    { "id": 11577, "word": "ល្វាសល្វន់" },
    { "id": 11578, "word": "ល្វីង" },
    { "id": 11579, "word": "ល្វឹង" },
    { "id": 11580, "word": "ល្វឹងល្វើយ" },
    { "id": 11581, "word": "ល្វើយ" },
    { "id": 11582, "word": "ល្វៀង" },
    { "id": 11583, "word": "ល្វេងល្វើយ" },
    { "id": 11584, "word": "ល្វែង" },
    { "id": 11585, "word": "ល្វែត" },
    { "id": 11586, "word": "ល្វៃ" },
    { "id": 11587, "word": "ល្ហ" },
    { "id": 11588, "word": "ល្ហក" },
    { "id": 11589, "word": "ល្ហក់" },
    { "id": 11590, "word": "ល្ហាច" },
    { "id": 11591, "word": "ល្ហាល" },
    { "id": 11592, "word": "ល្ហិតល្ហៃ" },
    { "id": 11593, "word": "ល្ហឹម" },
    { "id": 11594, "word": "ល្ហុង" },
    { "id": 11595, "word": "ល្ហួត" },
    { "id": 11596, "word": "ល្ហើយ" },
    { "id": 11597, "word": "ល្ហេវ" },
    { "id": 11598, "word": "ល្ហែ" },
    { "id": 11599, "word": "ល្ហែម" },
    { "id": 11600, "word": "ល្ហោល" },
    { "id": 11601, "word": "ល្ហោស" },
    { "id": 11602, "word": "ល្អ" },
    { "id": 11603, "word": "ល្អក់" },
    { "id": 11604, "word": "ល្អង" },
    { "id": 11605, "word": "ល្អន់" },
    { "id": 11606, "word": "ល្អាង" },
    { "id": 11607, "word": "ល្អាច់" },
    { "id": 11608, "word": "ល្អាត" },
    { "id": 11609, "word": "ល្អាន" },
    { "id": 11610, "word": "ល្អិត" },
    { "id": 11611, "word": "ល្អិន" },
    { "id": 11612, "word": "ល្អី" },
    { "id": 11613, "word": "ល្អូក" },
    { "id": 11614, "word": "ល្អូត" },
    { "id": 11615, "word": "ល្អួត" },
    { "id": 11616, "word": "ល្អៀង" },
    { "id": 11617, "word": "ល្អៀច" },
    { "id": 11618, "word": "ល្អៀចល្អែ" },
    { "id": 11619, "word": "ល្អោច" },
    { "id": 11620, "word": "ល្អោញ" },
    { "id": 11621, "word": "ល្អោម" },
    { "id": 11622, "word": "ល្អះ" },
    { "id": 11623, "word": "ឭ" },
    { "id": 11624, "word": "ឮ" },
    { "id": 11625, "word": "ឮជ័យ" },
    { "id": 11626, "word": "ឮជា" },
    { "id": 11627, "word": "ឮលាន់" },
    { "id": 11628, "word": "ឮសាយ" },
    { "id": 11629, "word": "វ" },
    { "id": 11630, "word": "វ៉" },
    { "id": 11631, "word": "វៈ ! " },
    { "id": 11632, "word": "វក" },
    { "id": 11633, "word": "វ៉ក !" },
    { "id": 11634, "word": "វក់" },
    { "id": 11635, "word": "វក្កំ" },
    { "id": 11636, "word": "វគ្គ" },
    { "id": 11637, "word": "វគ្គន្តៈ" },
    { "id": 11638, "word": "វគ្គុ" },
    { "id": 11639, "word": "វង" },
    { "id": 11640, "word": "វង់" },
    { "id": 11641, "word": "វ៉ង់" },
    { "id": 11642, "word": "វង់ក្រចក" },
    { "id": 11643, "word": "វង់ព្រះអាទិត្យ" },
    { "id": 11644, "word": "វង្កៈ" },
    { "id": 11645, "word": "វង្កត" },
    { "id": 11646, "word": "វង្វាន់" },
    { "id": 11647, "word": "វង្វេង" },
    { "id": 11648, "word": "វង្ស" },
    { "id": 11649, "word": "វង្សា" },
    { "id": 11650, "word": "វង្សា --" },
    { "id": 11651, "word": "វង្សាអគ្គរាជ" },
    { "id": 11652, "word": "វចនៈ" },
    { "id": 11653, "word": "វចន --" },
    { "id": 11654, "word": "វចនា --" },
    { "id": 11655, "word": "វចនាធិប្បាយ" },
    { "id": 11656, "word": "វចនានុក្រម" },
    { "id": 11657, "word": "វចី" },
    { "id": 11658, "word": "វចីកម្ម" },
    { "id": 11659, "word": "វច្ច" },
    { "id": 11660, "word": "វជិរៈ" },
    { "id": 11661, "word": "វជិរបាណី" },
    { "id": 11662, "word": "វជីរ" },
    { "id": 11663, "word": "វជ្ជទស្សិនី" },
    { "id": 11664, "word": "វជ្ជទស្សី" },
    { "id": 11665, "word": "វញ្ច" },
    { "id": 11666, "word": "វញ្ចនាការ" },
    { "id": 11667, "word": "វញ្ឈៈ" },
    { "id": 11668, "word": "វញ្ឈា" },
    { "id": 11669, "word": "វដ្ដ" },
    { "id": 11670, "word": "វដ្ដ --" },
    { "id": 11671, "word": "វឌ្ឍកី" },
    { "id": 11672, "word": "វឌ្ឍន" },
    { "id": 11673, "word": "វឌ្ឍន --" },
    { "id": 11674, "word": "វឌ្ឍនាការ" },
    { "id": 11675, "word": "វណរោគ" },
    { "id": 11676, "word": "វណិជ្ជា" },
    { "id": 11677, "word": "វណិព្វក" },
    { "id": 11678, "word": "វណ្ដ" },
    { "id": 11679, "word": "វ័ណ្ដ" },
    { "id": 11680, "word": "វណ្ណ" },
    { "id": 11681, "word": "វណ្ណនា" },
    { "id": 11682, "word": "វណ្ណយុត្ត" },
    { "id": 11683, "word": "វត្ត" },
    { "id": 11684, "word": "វត្តនី" },
    { "id": 11685, "word": "វត្តមាន" },
    { "id": 11686, "word": "វត្តមានកាល" },
    { "id": 11687, "word": "វត្តមានា" },
    { "id": 11688, "word": "វត្ថ" },
    { "id": 11689, "word": "វត្ថ --" },
    { "id": 11690, "word": "វត្ថពន្ធ" },
    { "id": 11691, "word": "វត្ថា --" },
    { "id": 11692, "word": "វត្ថិ" },
    { "id": 11693, "word": "វត្ថុ" },
    { "id": 11694, "word": "វត្ថុ --" },
    { "id": 11695, "word": "វត្ស" },
    { "id": 11696, "word": "វត្សរ៍" },
    { "id": 11697, "word": "វទ័ន" },
    { "id": 11698, "word": "វទញ្ញូ" },
    { "id": 11699, "word": "វ័ធ" },
    { "id": 11700, "word": "វធភូមិ" },
    { "id": 11701, "word": "វធូ" },
    { "id": 11702, "word": "វធ្យស្ថាន" },
    { "id": 11703, "word": "វន" },
    { "id": 11704, "word": "វន --" },
    { "id": 11705, "word": "វនន្តរ" },
    { "id": 11706, "word": "វនប្បតិ" },
    { "id": 11707, "word": "វនរ័ត" },
    { "id": 11708, "word": "វនរ័តន៍" },
    { "id": 11709, "word": "វនស្បតិ" },
    { "id": 11710, "word": "វនា --" },
    { "id": 11711, "word": "វនិតា" },
    { "id": 11712, "word": "វនិព្វក" },
    { "id": 11713, "word": "វនេចរ" },
    { "id": 11714, "word": "វន្ត" },
    { "id": 11715, "word": "វន្ទនា" },
    { "id": 11716, "word": "វន្ទន្ត" },
    { "id": 11717, "word": "វន្ទន្តី" },
    { "id": 11718, "word": "វន្ទា" },
    { "id": 11719, "word": "វន្ទីយ៍" },
    { "id": 11720, "word": "វន្ទីយបុគ្គល" },
    { "id": 11721, "word": "វ៉ប" },
    { "id": 11722, "word": "វប្ប" },
    { "id": 11723, "word": "វប្ប --" },
    { "id": 11724, "word": "វមរោគ" },
    { "id": 11725, "word": "វម្មិត" },
    { "id": 11726, "word": "វយ" },
    { "id": 11727, "word": "វយវឌ្ឍនាការ" },
    { "id": 11728, "word": "វយស្ថ" },
    { "id": 11729, "word": "យស្យ" },
    { "id": 11730, "word": "វរ" },
    { "id": 11731, "word": "វរ --" },
    { "id": 11732, "word": "វរោ --" },
    { "id": 11733, "word": "វរុណ" },
    { "id": 11734, "word": "វណ៌" },
    { "id": 11735, "word": "វរ្ម័ន" },
    { "id": 11736, "word": "វរ្មិត" },
    { "id": 11737, "word": "វល់" },
    { "id": 11738, "word": "វល័យ" },
    { "id": 11739, "word": "វលាហក" },
    { "id": 11740, "word": "វលី" },
    { "id": 11741, "word": "វលីមុខ" },
    { "id": 11742, "word": "វល្មីកិ" },
    { "id": 11743, "word": "វល្លភៈ" },
    { "id": 11744, "word": "វល្លភា" },
    { "id": 11745, "word": "វល្លិ" },
    { "id": 11746, "word": "វល្លិជាតិ" },
    { "id": 11747, "word": "វ៉ស" },
    { "id": 11748, "word": "វសនដ្ឋាន" },
    { "id": 11749, "word": "វសន្តតិលក" },
    { "id": 11750, "word": "វសន្តរដូវ" },
    { "id": 11751, "word": "វសល" },
    { "id": 11752, "word": "វសវត្តី" },
    { "id": 11753, "word": "វសុធា" },
    { "id": 11754, "word": "វសុន្ធរា" },
    { "id": 11755, "word": "វសុមតី" },
    { "id": 11756, "word": "វស្សកាល" },
    { "id": 11757, "word": "វស្សវលាហក" },
    { "id": 11758, "word": "វស្សា" },
    { "id": 11759, "word": "វស្សានៈ" },
    { "id": 11760, "word": "វស្សូបនាយិកា" },
    { "id": 11761, "word": "វហតី" },
    { "id": 11762, "word": "វហនកម្ម" },
    { "id": 11763, "word": "វា" },
    { "id": 11764, "word": "វ៉ា" },
    { "id": 11765, "word": "វាក់" },
    { "id": 11766, "word": "វាកចិរពស្ដ្រ" },
    { "id": 11767, "word": "វាក្យ" },
    { "id": 11768, "word": "វាក្យ --" },
    { "id": 11769, "word": "វាក្យា --" },
    { "id": 11770, "word": "វាគារ" },
    { "id": 11771, "word": "វាគុរា" },
    { "id": 11772, "word": "វាគុរិក" },
    { "id": 11773, "word": "វាគ្មិន" },
    { "id": 11774, "word": "វាង" },
    { "id": 11775, "word": "វ៉ាង" },
    { "id": 11776, "word": "វ៉ាងមុខ" },
    { "id": 11777, "word": "វាងវៃ" },
    { "id": 11778, "word": "វាច" },
    { "id": 11779, "word": "វាចក" },
    { "id": 11780, "word": "វាចសិក" },
    { "id": 11781, "word": "វាចា" },
    { "id": 11782, "word": "វាចា --" },
    { "id": 11783, "word": "វាចាល" },
    { "id": 11784, "word": "វាចាសិលិដ្ឋ" },
    { "id": 11785, "word": "វាចិក" },
    { "id": 11786, "word": "វាចិកបត្រ" },
    { "id": 11787, "word": "វាចិកហារក" },
    { "id": 11788, "word": "វាចិកហារិកា" },
    { "id": 11789, "word": "វាជិនី" },
    { "id": 11790, "word": "វាណវារ" },
    { "id": 11791, "word": "វាណិជ" },
    { "id": 11792, "word": "វាណិជ្ជ" },
    { "id": 11793, "word": "វាណិជ្ជកម្ម" },
    { "id": 11794, "word": "វាណិជ្ជការ" },
    { "id": 11795, "word": "វាណី" },
    { "id": 11796, "word": "វាត" },
    { "id": 11797, "word": "វាត" },
    { "id": 11798, "word": "វាត --" },
    { "id": 11799, "word": "វាត់" },
    { "id": 11800, "word": "វាតវលាហក" },
    { "id": 11801, "word": "វាតអាទិ" },
    { "id": 11802, "word": "វាតុល" },
    { "id": 11803, "word": "វាតុលា" },
    { "id": 11804, "word": "វាត្យា" },
    { "id": 11805, "word": "វាទ" },
    { "id": 11806, "word": "វាទកៈ" },
    { "id": 11807, "word": "វាទនកម្ម" },
    { "id": 11808, "word": "វាទអាទិ៍" },
    { "id": 11809, "word": "វាទិកា" },
    { "id": 11810, "word": "វាទិនី" },
    { "id": 11811, "word": "វាទី" },
    { "id": 11812, "word": "វាទ្យភណ្ឌ" },
    { "id": 11813, "word": "វាន់" },
    { "id": 11814, "word": "វានៈ" },
    { "id": 11815, "word": "វានរ" },
    { "id": 11816, "word": "វានរិន្ទ" },
    { "id": 11817, "word": "វានរី" },
    { "id": 11818, "word": "វានរេន្ទ្រ" },
    { "id": 11819, "word": "វ៉ាន់ស៊ុយ" },
    { "id": 11820, "word": "វាប់" },
    { "id": 11821, "word": "វ៉ាប់" },
    { "id": 11822, "word": "វាបី" },
    { "id": 11823, "word": "វាមលូរ" },
    { "id": 11824, "word": "វាយ" },
    { "id": 11825, "word": "វាយទណ្ឌ" },
    { "id": 11826, "word": "វាយុ" },
    { "id": 11827, "word": "វាយុ --" },
    { "id": 11828, "word": "វាយោ" },
    { "id": 11829, "word": "វារ" },
    { "id": 11830, "word": "វារៈ" },
    { "id": 11831, "word": "វារជើង" },
    { "id": 11832, "word": "វារណៈ" },
    { "id": 11833, "word": "វារវលាសិនី" },
    { "id": 11834, "word": "វារាណសី" },
    { "id": 11835, "word": "វារិ" },
    { "id": 11836, "word": "វារិ --" },
    { "id": 11837, "word": "វារុណី" },
    { "id": 11838, "word": "វារេណវាក្យ" },
    { "id": 11839, "word": "វ៉ារោង" },
    { "id": 11840, "word": "វាល" },
    { "id": 11841, "word": "វាលៈ" },
    { "id": 11842, "word": "វាល --" },
    { "id": 11843, "word": "វាល់" },
    { "id": 11844, "word": "វ៉ាល់" },
    { "id": 11845, "word": "វាលមីកិ" },
    { "id": 11846, "word": "វាលវីជនី" },
    { "id": 11847, "word": "វាលិកា" },
    { "id": 11848, "word": "វ៉ាលិស" },
    { "id": 11849, "word": "វាលុកចេតិយ" },
    { "id": 11850, "word": "វលុកា" },
    { "id": 11851, "word": "វាល្មីកៈ" },
    { "id": 11852, "word": "វាវ" },
    { "id": 11853, "word": "វាស" },
    { "id": 11854, "word": "វ៉ាស" },
    { "id": 11855, "word": "វាស់" },
    { "id": 11856, "word": "វាសនដ្ឋាន" },
    { "id": 11857, "word": "វាសនា" },
    { "id": 11858, "word": "វាសរ" },
    { "id": 11859, "word": "វាសរសង្គៈ" },
    { "id": 11860, "word": "វាសរសង្គាភិវាទ" },
    { "id": 11861, "word": "វាសវៈ" },
    { "id": 11862, "word": "វាសវាង" },
    { "id": 11863, "word": "វាសាគារ" },
    { "id": 11864, "word": "វាសិត" },
    { "id": 11865, "word": "វាសុកី" },
    { "id": 11866, "word": "វាសុទេព" },
    { "id": 11867, "word": "វាសុរា" },
    { "id": 11868, "word": "វាស្នា" },
    { "id": 11869, "word": "វាហនៈ" },
    { "id": 11870, "word": "វាហនវិសេស" },
    { "id": 11871, "word": "វាហនសត្វ" },
    { "id": 11872, "word": "វាហិនី" },
    { "id": 11873, "word": "វាឡគ្គាហិនី" },
    { "id": 11874, "word": "វាឡគ្គាហី" },
    { "id": 11875, "word": "វាឡម្រឹគ" },
    { "id": 11876, "word": "វាឡសត្វ" },
    { "id": 11877, "word": "វិកតិ" },
    { "id": 11878, "word": "វិកតិកត្តា" },
    { "id": 11879, "word": "វិកតិកម្ម" },
    { "id": 11880, "word": "វិកតិកា" },
    { "id": 11881, "word": "វិកតិកាសនៈ" },
    { "id": 11882, "word": "វិកត្ថនៈ" },
    { "id": 11883, "word": "វិកប្ប" },
    { "id": 11884, "word": "វិកប្បសន្ធាន" },
    { "id": 11885, "word": "វិករ" },
    { "id": 11886, "word": "វិកល" },
    { "id": 11887, "word": "វិកល្យ" },
    { "id": 11888, "word": "វិកសិត" },
    { "id": 11889, "word": "វិការ" },
    { "id": 11890, "word": "វិកាល" },
    { "id": 11891, "word": "វិកាស" },
    { "id": 11892, "word": "វិក្កយបត្រ" },
    { "id": 11893, "word": "វិក្កយសាលា" },
    { "id": 11894, "word": "វិក្កយិក" },
    { "id": 11895, "word": "វិក្កាយិក" },
    { "id": 11896, "word": "វិក្ខិត្តចិត្ត" },
    { "id": 11897, "word": "វិក្ខេប" },
    { "id": 11898, "word": "វិក្រម" },
    { "id": 11899, "word": "វិក្រយគ្រឹះ" },
    { "id": 11900, "word": "វិក្រយាគារ" },
    { "id": 11901, "word": "វិក្រយានុស័យ" },
    { "id": 11902, "word": "វិក្រយិក" },
    { "id": 11903, "word": "វិក្រាន្ត" },
    { "id": 11904, "word": "វិក្រាយិក" },
    { "id": 11905, "word": "វិក្រិយា" },
    { "id": 11906, "word": "វិក្រីឌា" },
    { "id": 11907, "word": "វិក្រោស" },
    { "id": 11908, "word": "វិគ្គហ" },
    { "id": 11909, "word": "វិគ្រោះ" },
    { "id": 11910, "word": "វិឃាតភាព" },
    { "id": 11911, "word": "វិឃាសាត" },
    { "id": 11912, "word": "វិឃាសាទា" },
    { "id": 11913, "word": "វិឃាសាហារ" },
    { "id": 11914, "word": "វិឃ្នភាព" },
    { "id": 11915, "word": "វិឃ្នេស" },
    { "id": 11916, "word": "វិឃ្រភាព" },
    { "id": 11917, "word": "វិងស៊ុង" },
    { "id": 11918, "word": "វិច" },
    { "id": 11919, "word": "វិចៗ " },
    { "id": 11920, "word": "វិចក្ខណ" },
    { "id": 11921, "word": "វិចក្ខុ" },
    { "id": 11922, "word": "វិចន្ទ្រ" },
    { "id": 11923, "word": "វិចយ" },
    { "id": 11924, "word": "វិចយ --" },
    { "id": 11925, "word": "វិចល" },
    { "id": 11926, "word": "វិចលាចល" },
    { "id": 11927, "word": "វិចារ" },
    { "id": 11928, "word": "វិចារកៈ" },
    { "id": 11929, "word": "វិចារណ៍" },
    { "id": 11930, "word": "វិចារណកថា" },
    { "id": 11931, "word": "វិចារណញ្ញា ណ" },
    { "id": 11932, "word": "វិចារិកា" },
    { "id": 11933, "word": "វិចិកិច្ឆា" },
    { "id": 11934, "word": "វិចិត្រ" },
    { "id": 11935, "word": "វិចិន្តា" },
    { "id": 11936, "word": "វិចេយ្យទាន" },
    { "id": 11937, "word": "វិចេស្តន" },
    { "id": 11938, "word": "វិច្ឆន្ទគ្រឹះ" },
    { "id": 11939, "word": "វិច្ឆាយ" },
    { "id": 11940, "word": "វិច្ឆាយ --" },
    { "id": 11941, "word": "វិច្ឆិកៈ" },
    { "id": 11942, "word": "វិច្ឆិករាសី" },
    { "id": 11943, "word": "វិច្ឆេទ" },
    { "id": 11944, "word": "វិច្ឆេទ --" },
    { "id": 11945, "word": "វិជនដ្ឋាន" },
    { "id": 11946, "word": "វិជយ" },
    { "id": 11947, "word": "វិជយ --" },
    { "id": 11948, "word": "វិជយិន" },
    { "id": 11949, "word": "វិជយិនី" },
    { "id": 11950, "word": "វិជយី" },
    { "id": 11951, "word": "វិជលដ្ឋាន" },
    { "id": 11952, "word": "វិជាត" },
    { "id": 11953, "word": "វិជាត --" },
    { "id": 11954, "word": "វិជាតិ" },
    { "id": 11955, "word": "វិជាតីយ" },
    { "id": 11956, "word": "វិជិតមារ" },
    { "id": 11957, "word": "វិជិតរដ្ឋ" },
    { "id": 11958, "word": "វិជិតរាស្ត្រ" },
    { "id": 11959, "word": "វិជ្ជមាន" },
    { "id": 11960, "word": "វិជ្ជា" },
    { "id": 11961, "word": "វិជ្ជា --" },
    { "id": 11962, "word": "វិជ្ជុ" },
    { "id": 11963, "word": "វិជ្ជុតា" },
    { "id": 11964, "word": "វិជ្ជោត" },
    { "id": 11965, "word": "វិញ" },
    { "id": 11966, "word": "វិញ្ញត្តិ" },
    { "id": 11967, "word": "វិញ្ញាណ" },
    { "id": 11968, "word": "វិញ្ញាតកម្ម" },
    { "id": 11969, "word": "វិញ្ញាបនបត្រ" },
    { "id": 11970, "word": "វិញ្ញាបនី" },
    { "id": 11971, "word": "វិញ្ញាសា" },
    { "id": 11972, "word": "វិញ្ញូ" },
    { "id": 11973, "word": "វិតក្ក" },
    { "id": 11974, "word": "វិតស្តិ" },
    { "id": 11975, "word": "វិត្តៈ" },
    { "id": 11976, "word": "វិត្ថារ" },
    { "id": 11977, "word": "វិទ័គ្ធ" },
    { "id": 11978, "word": "វិទត្ថិ" },
    { "id": 11979, "word": "វិទូ" },
    { "id": 11980, "word": "វិទេស" },
    { "id": 11981, "word": "វិទេសិក" },
    { "id": 11982, "word": "វិទេសិកា" },
    { "id": 11983, "word": "វិទ្ទស" },
    { "id": 11984, "word": "វិទ្ទេស" },
    { "id": 11985, "word": "វិទ្ទេសិនី" },
    { "id": 11986, "word": "វិទ្ទេសី" },
    { "id": 11987, "word": "វិទ្ធង្សនា" },
    { "id": 11988, "word": "វិទ្ធង្សនាការ" },
    { "id": 11989, "word": "វិទ្យា" },
    { "id": 11990, "word": "វិទ្យុ" },
    { "id": 11991, "word": "វិទ្យុត" },
    { "id": 11992, "word": "វិទ្យុលតា" },
    { "id": 11993, "word": "វិទ្យោត" },
    { "id": 11994, "word": "វិទ្រុម" },
    { "id": 11995, "word": "វិទ្វា" },
    { "id": 11996, "word": "វិធវា" },
    { "id": 11997, "word": "វិធា" },
    { "id": 11998, "word": "វិធាន" },
    { "id": 11999, "word": "វិធិ" },
    { "id": 12000, "word": "វិធី" },
    { "id": 12001, "word": "វិធុរ" },
    { "id": 12002, "word": "វិធុរភាព" },
    { "id": 12003, "word": "វិធូបក" },
    { "id": 12004, "word": "វិធូបនកម្ម" },
    { "id": 12005, "word": "វិធូបិកា" },
    { "id": 12006, "word": "វិនយ" },
    { "id": 12007, "word": "វិនយ --" },
    { "id": 12008, "word": "វិនាឌិកា" },
    { "id": 12009, "word": "វិនាថ" },
    { "id": 12010, "word": "វិនាថា" },
    { "id": 12011, "word": "វិនាយក" },
    { "id": 12012, "word": "វិនាយិកា" },
    { "id": 12013, "word": "វិនាស" },
    { "id": 12014, "word": "វិនាសនៈ" },
    { "id": 12015, "word": "វិនិការ" },
    { "id": 12016, "word": "វិនិច្ឆយ" },
    { "id": 12017, "word": "វិនិទ្រា" },
    { "id": 12018, "word": "វិនិបាត" },
    { "id": 12019, "word": "វិនិបាតិក" },
    { "id": 12020, "word": "វិនីត" },
    { "id": 12021, "word": "វិន្ទ" },
    { "id": 12022, "word": "វិន្ទុ" },
    { "id": 12023, "word": "វិបក្ខ" },
    { "id": 12024, "word": "វិបត្តិ" },
    { "id": 12025, "word": "វិប័ទ" },
    { "id": 12026, "word": "វិបរិណាមធម៌" },
    { "id": 12027, "word": "វិបរិត" },
    { "id": 12028, "word": "វិបរិយាយ" },
    { "id": 12029, "word": "វិបរិយាស" },
    { "id": 12030, "word": "វិបយ៌ាយ" },
    { "id": 12031, "word": "វិបយ៌ាស" },
    { "id": 12032, "word": "វិបល្លាស" },
    { "id": 12033, "word": "វិបស្ចិត" },
    { "id": 12034, "word": "វិបស្សនា" },
    { "id": 12035, "word": "វិបស្សិនី" },
    { "id": 12036, "word": "វិបាក" },
    { "id": 12037, "word": "វិបាចនកម្ម" },
    { "id": 12038, "word": "វិបុល" },
    { "id": 12039, "word": "វិប្បការ" },
    { "id": 12040, "word": "វិប្បកិណ្ណភាព" },
    { "id": 12041, "word": "វិប្បដិសារៈ" },
    { "id": 12042, "word": "វិប្បដិសារិនី" },
    { "id": 12043, "word": "វិប្បដិសារី" },
    { "id": 12044, "word": "វិប្បយោគ" },
    { "id": 12045, "word": "វិប្បលាប" },
    { "id": 12046, "word": "វិប្បវាស" },
    { "id": 12047, "word": "វិប្រការ" },
    { "id": 12048, "word": "វិប្រក្រឹតិ" },
    { "id": 12049, "word": "វិប្រច្ឆន្ន" },
    { "id": 12050, "word": "វិប្រតិការ" },
    { "id": 12051, "word": "វិប្រតិបត្តិ" },
    { "id": 12052, "word": "វិប្រតិសារៈ" },
    { "id": 12053, "word": "វិប្រយោគ" },
    { "id": 12054, "word": "វិប្រលាប" },
    { "id": 12055, "word": "វិប្រវាស" },
    { "id": 12056, "word": "វិពន្ធរោគ" },
    { "id": 12057, "word": "វិពុធ" },
    { "id": 12058, "word": "វិព្ភន្ត" },
    { "id": 12059, "word": "វិព្ភន្តក" },
    { "id": 12060, "word": "វិព្ភន្តិកា" },
    { "id": 12061, "word": "វិភង្គ" },
    { "id": 12062, "word": "វិភត្តិ" },
    { "id": 12063, "word": "វិភព" },
    { "id": 12064, "word": "វិភា" },
    { "id": 12065, "word": "វិភាករ" },
    { "id": 12066, "word": "វិភាគ" },
    { "id": 12067, "word": "វិភាគទាន" },
    { "id": 12068, "word": "វិភាជក" },
    { "id": 12069, "word": "វិភាជិកា" },
    { "id": 12070, "word": "វិភាតកាល" },
    { "id": 12071, "word": "វិភាព" },
    { "id": 12072, "word": "វិភាវរី" },
    { "id": 12073, "word": "វិភាវិនី" },
    { "id": 12074, "word": "វិភាវី" },
    { "id": 12075, "word": "វិភីសណៈ" },
    { "id": 12076, "word": "វិភូ" },
    { "id": 12077, "word": "វិភូសនៈ" },
    { "id": 12078, "word": "វិភូសា" },
    { "id": 12079, "word": "វិភូសិត" },
    { "id": 12080, "word": "វិមតិ" },
    { "id": 12081, "word": "វិមល" },
    { "id": 12082, "word": "វិមលា" },
    { "id": 12083, "word": "វិមាន" },
    { "id": 12084, "word": "វិមានវត្ថុ" },
    { "id": 12085, "word": "វិមានអាកាស" },
    { "id": 12086, "word": "វិមុត្ត" },
    { "id": 12087, "word": "វិមុត្តិ" },
    { "id": 12088, "word": "វិមោក្ខ" },
    { "id": 12089, "word": "វិម្ហយៈ" },
    { "id": 12090, "word": "វិយោគ" },
    { "id": 12091, "word": "វិរតិ" },
    { "id": 12092, "word": "វិរាគ" },
    { "id": 12093, "word": "វិរាព" },
    { "id": 12094, "word": "វិរាម" },
    { "id": 12095, "word": "វិរាល័យ" },
    { "id": 12096, "word": "វិរុទ្ធ" },
    { "id": 12097, "word": "វិរុឡ្ហៈ" },
    { "id": 12098, "word": "វិរុឡ្ហក" },
    { "id": 12099, "word": "វិរូប" },
    { "id": 12100, "word": "វិរូបក្ខ" },
    { "id": 12101, "word": "វិរូឡ្ហក" },
    { "id": 12102, "word": "វិរេចន" },
    { "id": 12103, "word": "វិរោគភាព" },
    { "id": 12104, "word": "វិរោចនៈ" },
    { "id": 12105, "word": "វិរោធ" },
    { "id": 12106, "word": "វិល" },
    { "id": 12107, "word": "វិល !" },
    { "id": 12108, "word": "វិលមុខ" },
    { "id": 12109, "word": "វិលាប" },
    { "id": 12110, "word": "វិលាល័យ" },
    { "id": 12111, "word": "វិលាស" },
    { "id": 12112, "word": "វិលាសិនី" },
    { "id": 12113, "word": "វិលាសី" },
    { "id": 12114, "word": "វិលិប្តា" },
    { "id": 12115, "word": "វិលីនធាតុ" },
    { "id": 12116, "word": "វិលុម្បក" },
    { "id": 12117, "word": "វិលេបនៈ" },
    { "id": 12118, "word": "វិលោកនៈ" },
    { "id": 12119, "word": "វិលោភនៈ" },
    { "id": 12120, "word": "វិវដ្ដ" },
    { "id": 12121, "word": "វិវឌ្ឍនៈ" },
    { "id": 12122, "word": "វិវរដ្ឋាន" },
    { "id": 12123, "word": "វិវរណៈ" },
    { "id": 12124, "word": "វិវរណីយៈ" },
    { "id": 12125, "word": "វិវាទ" },
    { "id": 12126, "word": "វិវាទ --" },
    { "id": 12127, "word": "វិវាហៈ" },
    { "id": 12128, "word": "វិវាហកៅតុក" },
    { "id": 12129, "word": "វិវិត្ត" },
    { "id": 12130, "word": "វិវិធ" },
    { "id": 12131, "word": "វិវេក" },
    { "id": 12132, "word": "វិសជ្ជនា" },
    { "id": 12133, "word": "វិសញ្ញិភាព" },
    { "id": 12134, "word": "វិសទព័ណ៌" },
    { "id": 12135, "word": "វិសទិស" },
    { "id": 12136, "word": "វិសភាគ" },
    { "id": 12137, "word": "វិសម" },
    { "id": 12138, "word": "វិសមានចិត្ត" },
    { "id": 12139, "word": "វិសយ" },
    { "id": 12140, "word": "វិសគ៌ៈ" },
    { "id": 12141, "word": "វិសាខ" },
    { "id": 12142, "word": "វិសាខបូជា" },
    { "id": 12143, "word": "វិសាខា" },
    { "id": 12144, "word": "វិសាទិស" },
    { "id": 12145, "word": "វិសាមញ្ញ" },
    { "id": 12146, "word": "វិសារទ" },
    { "id": 12147, "word": "វិសាល" },
    { "id": 12148, "word": "វិសិដ្ឋ" },
    { "id": 12149, "word": "វិសុទ្ធ" },
    { "id": 12150, "word": "វិសុទ្ធិ" },
    { "id": 12151, "word": "វិសុទ្ធិមគ្គ" },
    { "id": 12152, "word": "វិសូចិកា" },
    { "id": 12153, "word": "វិសេស" },
    { "id": 12154, "word": "វិសេសគុណនាម" },
    { "id": 12155, "word": "វិសេសត្ថវាចក" },
    { "id": 12156, "word": "វិសេសន" },
    { "id": 12157, "word": "វិសេសន សព្វនាម" },
    { "id": 12158, "word": "វិសោធន" },
    { "id": 12159, "word": "វិស្ណុ" },
    { "id": 12160, "word": "វិស្ម័យ" },
    { "id": 12161, "word": "វិស្វករ" },
    { "id": 12162, "word": "វិស្វនាថ" },
    { "id": 12163, "word": "វិស្វាមិត្រ" },
    { "id": 12164, "word": "វិស្វាសបាត្រ" },
    { "id": 12165, "word": "វិស្សកម្ម" },
    { "id": 12166, "word": "វិស្សម" },
    { "id": 12167, "word": "វិស្សាសៈ" },
    { "id": 12168, "word": "វិស្សាសិក" },
    { "id": 12169, "word": "វិស្សាសិកា" },
    { "id": 12170, "word": "វិស្សុត" },
    { "id": 12171, "word": "វិស្សុតនាម" },
    { "id": 12172, "word": "វិហគ" },
    { "id": 12173, "word": "វិហគ --" },
    { "id": 12174, "word": "វិហា" },
    { "id": 12175, "word": "វិហារ" },
    { "id": 12176, "word": "វិហារៈ" },
    { "id": 12177, "word": "វិហារ --" },
    { "id": 12178, "word": "វិហិង្សា" },
    { "id": 12179, "word": "វិហេសកកម្ម" },
    { "id": 12180, "word": "វិឡារ" },
    { "id": 12181, "word": "វិះ" },
    { "id": 12182, "word": "វី" },
    { "id": 12183, "word": "វ៉ី" },
    { "id": 12184, "word": "វីជនី" },
    { "id": 12185, "word": "វីត" },
    { "id": 12186, "word": "វីតាមីន" },
    { "id": 12187, "word": "វីតិក្កម" },
    { "id": 12188, "word": "វីថិ" },
    { "id": 12189, "word": "វីមង្សា" },
    { "id": 12190, "word": "វីមវាម" },
    { "id": 12191, "word": "វីមវើម" },
    { "id": 12192, "word": "វីរ" },
    { "id": 12193, "word": "វីរិយ" },
    { "id": 12194, "word": "វីរិយ --" },
    { "id": 12195, "word": "វីវក់" },
    { "id": 12196, "word": "វីវរ" },
    { "id": 12197, "word": "វីវាច" },
    { "id": 12198, "word": "វីវែក" },
    { "id": 12199, "word": "វឹក" },
    { "id": 12200, "word": "វឹកវរ" },
    { "id": 12201, "word": "វឹង" },
    { "id": 12202, "word": "វឹត" },
    { "id": 12203, "word": "វឹប" },
    { "id": 12204, "word": "វឹល" },
    { "id": 12205, "word": "វឹល !" },
    { "id": 12206, "word": "វិលមុខ" },
    { "id": 12207, "word": "វឹះ" },
    { "id": 12208, "word": "វឺ" },
    { "id": 12209, "word": "វ៉ឺង" },
    { "id": 12210, "word": "វ៉ឺងវ៉ាង" },
    { "id": 12211, "word": "វ៉ឺតៗ" },
    { "id": 12212, "word": "វ៉ឺនវ៉ាយ" },
    { "id": 12213, "word": "វឺបៗ" },
    { "id": 12214, "word": "វ៉ឺយ" },
    { "id": 12215, "word": "វ៉ឺះ" },
    { "id": 12216, "word": "វុឌ្ឍាចារ្យ" },
    { "id": 12217, "word": "វុឌ្ឍាបចាយនៈ" },
    { "id": 12218, "word": "វុឌ្ឍិ" },
    { "id": 12219, "word": "វុត្ត" },
    { "id": 12220, "word": "វុត្តពីជ" },
    { "id": 12221, "word": "វុត្តិ" },
    { "id": 12222, "word": "វុត្តោទ័យ" },
    { "id": 12223, "word": "វុទ្ធាចារ្យ" },
    { "id": 12224, "word": "វុទ្ធាបចាយនៈ" },
    { "id": 12225, "word": "វុទ្ធិរោគ" },
    { "id": 12226, "word": "វុន" },
    { "id": 12227, "word": "វុនវ៉ាយ" },
    { "id": 12228, "word": "វ៉ុល" },
    { "id": 12229, "word": "វូ" },
    { "id": 12230, "word": "វ៉ូ" },
    { "id": 12231, "word": "វ៉ូង" },
    { "id": 12232, "word": "វ៉ូងវ៉ាង" },
    { "id": 12233, "word": "វ៉ូត" },
    { "id": 12234, "word": "វូប" },
    { "id": 12235, "word": "វ៉ូប" },
    { "id": 12236, "word": "វូបសន្ត" },
    { "id": 12237, "word": "វូម" },
    { "id": 12238, "word": "វូមវៈ!" },
    { "id": 12239, "word": "វ៉ូស" },
    { "id": 12240, "word": "វ៉ូសវ៉ាស" },
    { "id": 12241, "word": "វើក" },
    { "id": 12242, "word": "វើកៗ" },
    { "id": 12243, "word": "វើត" },
    { "id": 12244, "word": "វើមៗ" },
    { "id": 12245, "word": "វៀង" },
    { "id": 12246, "word": "វៀងជ័យ" },
    { "id": 12247, "word": "វៀច" },
    { "id": 12248, "word": "វៀន" },
    { "id": 12249, "word": "វៀរ" },
    { "id": 12250, "word": "វៀល" },
    { "id": 12251, "word": "វៀះ" },
    { "id": 12252, "word": "វៀះវៀន" },
    { "id": 12253, "word": "វ៉េ" },
    { "id": 12254, "word": "វេគពល" },
    { "id": 12255, "word": "វេគសរ" },
    { "id": 12256, "word": "វេគិនី" },
    { "id": 12257, "word": "វេគី" },
    { "id": 12258, "word": "វេច" },
    { "id": 12259, "word": "វេចា" },
    { "id": 12260, "word": "វេច្ច" },
    { "id": 12261, "word": "វេជយ័ន្ត" },
    { "id": 12262, "word": "វេជ្ជ" },
    { "id": 12263, "word": "វេញ" },
    { "id": 12264, "word": "វេឋនពស្ត្រ" },
    { "id": 12265, "word": "វេឌា" },
    { "id": 12266, "word": "វេតាល" },
    { "id": 12267, "word": "វេតាឡិក" },
    { "id": 12268, "word": "វេទ" },
    { "id": 12269, "word": "វេទ --" },
    { "id": 12270, "word": "វេទគូ" },
    { "id": 12271, "word": "វេទនា" },
    { "id": 12272, "word": "វេទនា --" },
    { "id": 12273, "word": "វេទន្ត" },
    { "id": 12274, "word": "វេទាង្គ" },
    { "id": 12275, "word": "វេទាន្ត" },
    { "id": 12276, "word": "វេទិកា" },
    { "id": 12277, "word": "វេទិនី" },
    { "id": 12278, "word": "វេទី" },
    { "id": 12279, "word": "វេធកម្ម" },
    { "id": 12280, "word": "វេធី" },
    { "id": 12281, "word": "វេន" },
    { "id": 12282, "word": "វេនតេយ្យ" },
    { "id": 12283, "word": "វេនេយ្យ" },
    { "id": 12284, "word": "វេបចិត្តិ" },
    { "id": 12285, "word": "វេបេតិក" },
    { "id": 12286, "word": "វេបេតិកា" },
    { "id": 12287, "word": "វេមវើម" },
    { "id": 12288, "word": "វេមាតិក" },
    { "id": 12289, "word": "វេមាតិកា" },
    { "id": 12290, "word": "វេមានិកប្រេត" },
    { "id": 12291, "word": "វេមានិកប្រេតី" },
    { "id": 12292, "word": "វេយ្យាករណ៍" },
    { "id": 12293, "word": "វេយ្យាករ ណិក" },
    { "id": 12294, "word": "វេយ្យាករ ណិកា" },
    { "id": 12295, "word": "វេយ្យាវច្ច" },
    { "id": 12296, "word": "វេរ" },
    { "id": 12297, "word": "វេរប្បដិវេរ" },
    { "id": 12298, "word": "វេរភាព" },
    { "id": 12299, "word": "វេរមណី" },
    { "id": 12300, "word": "វេរម្ភវាត" },
    { "id": 12301, "word": "វេរវេគ" },
    { "id": 12302, "word": "វេរា" },
    { "id": 12303, "word": "វេរិ --" },
    { "id": 12304, "word": "វេរិនី" },
    { "id": 12305, "word": "វេរី" },
    { "id": 12306, "word": "វេលា" },
    { "id": 12307, "word": "វ៉េវ" },
    { "id": 12308, "word": "វេវចនៈ" },
    { "id": 12309, "word": "វ៉េវវ៉ាវ" },
    { "id": 12310, "word": "វ៉េសវ៉ស" },
    { "id": 12311, "word": "វ៉េសវ៉ាស" },
    { "id": 12312, "word": "វ៉េសវ៉ូស" },
    { "id": 12313, "word": "វេសាលី" },
    { "id": 12314, "word": "វេសិយា" },
    { "id": 12315, "word": "វេស្តនព្រស្ត" },
    { "id": 12316, "word": "វេស្ម័ន" },
    { "id": 12317, "word": "វេស្សៈ" },
    { "id": 12318, "word": "វេស្សន្តរ" },
    { "id": 12319, "word": "វេស្សភូ" },
    { "id": 12320, "word": "វេស្សវ័ណ" },
    { "id": 12321, "word": "វេស្សានរ" },
    { "id": 12322, "word": "វេហា" },
    { "id": 12323, "word": "វេឡុវ័ន" },
    { "id": 12324, "word": "វេះ" },
    { "id": 12325, "word": "វេះវៀន" },
    { "id": 12326, "word": "វែក" },
    { "id": 12327, "word": "វែកចំហៀង" },
    { "id": 12328, "word": "វែកឱ" },
    { "id": 12329, "word": "វែង" },
    { "id": 12330, "word": "វ៉ែត" },
    { "id": 12331, "word": "វ៉ែន" },
    { "id": 12332, "word": "វ៉ែនតា" },
    { "id": 12333, "word": "វ៉ែបៗ" },
    { "id": 12334, "word": "វៃ" },
    { "id": 12335, "word": "វៃក្វែន" },
    { "id": 12336, "word": "វ៉ៃ" },
    { "id": 12337, "word": "វៃតាលិក" },
    { "id": 12338, "word": "វៃយរាពណ៍" },
    { "id": 12339, "word": "វៃយាករណ៍" },
    { "id": 12340, "word": "វៃស្ណវៈ" },
    { "id": 12341, "word": "វៃស្យៈ" },
    { "id": 12342, "word": "វោ ! " },
    { "id": 12343, "word": "វោការ" },
    { "id": 12344, "word": "វោត" },
    { "id": 12345, "word": "វោទានកម្ម" },
    { "id": 12346, "word": "វ៉ោបៗ" },
    { "id": 12347, "word": "វោលោកនៈ" },
    { "id": 12348, "word": "វោហារ" },
    { "id": 12349, "word": "វោហារិនី" },
    { "id": 12350, "word": "វោហារី" },
    { "id": 12351, "word": "វោហារុបជីវិនី" },
    { "id": 12352, "word": "វោហារុបជីវី" },
    { "id": 12353, "word": "វ៉ៅ" },
    { "id": 12354, "word": "វាំង" },
    { "id": 12355, "word": "វាំងជា" },
    { "id": 12356, "word": "វាំងនន" },
    { "id": 12357, "word": "វាំងនាំ" },
    { "id": 12358, "word": "វះ" },
    { "id": 12359, "word": "វ្ហី" },
    { "id": 12360, "word": "វ្ហើយ" },
    { "id": 12361, "word": "វ្ហោះវ្ហើយ" },
    { "id": 12362, "word": "ស" },
    { "id": 12363, "word": "សក" },
    { "id": 12364, "word": "សក់" },
    { "id": 12365, "word": "ស៊ក" },
    { "id": 12366, "word": "ស-ក" },
    { "id": 12367, "word": "ស័ក" },
    { "id": 12368, "word": "សក់ក័ន្ត" },
    { "id": 12369, "word": "សក់កន្ទុយ" },
    { "id": 12370, "word": "សកកាល" },
    { "id": 12371, "word": "សកញ៉ក" },
    { "id": 12372, "word": "សកដមគ្គ" },
    { "id": 12373, "word": "សកដមាគ៌ា" },
    { "id": 12374, "word": "សកដ្ឋាន នាសិកជៈ" },
    { "id": 12375, "word": "សកត្ថ" },
    { "id": 12376, "word": "សកទាគាមិ" },
    { "id": 12377, "word": "សកទាគាមិនី" },
    { "id": 12378, "word": "សកទាគាមី" },
    { "id": 12379, "word": "សកនិរុត្តិ" },
    { "id": 12380, "word": "សកភាសា" },
    { "id": 12381, "word": "សកម៉្ញក" },
    { "id": 12382, "word": "សកម្ម" },
    { "id": 12383, "word": "សកម្មកិរិយា" },
    { "id": 12384, "word": "សកម្មធាតុ" },
    { "id": 12385, "word": "សកម្មភាព" },
    { "id": 12386, "word": "សកម្មាកម្មកិរិយា" },
    { "id": 12387, "word": "សករណីយ" },
    { "id": 12388, "word": "សករណីយា" },
    { "id": 12389, "word": "សករាជ" },
    { "id": 12390, "word": "សកល" },
    { "id": 12391, "word": "សកវាទ៍" },
    { "id": 12392, "word": "សកវាទិ៍ " },
    { "id": 12393, "word": "សកវាទិនី" },
    { "id": 12394, "word": "សកវាទី" },
    { "id": 12395, "word": "ស៊កសៀត" },
    { "id": 12396, "word": "សក់សេះ" },
    { "id": 12397, "word": "សក់ស្វាយ" },
    { "id": 12398, "word": "សក់ឡក់" },
    { "id": 12399, "word": "សកអំពៅ" },
    { "id": 12400, "word": "សកាយទិដ្ឋិ" },
    { "id": 12401, "word": "សកាយនិរុត្តិ" },
    { "id": 12402, "word": "សកុណជាតិ" },
    { "id": 12403, "word": "សកុណណ្ឌ" },
    { "id": 12404, "word": "សក្ក" },
    { "id": 12405, "word": "សក្កដភាសា" },
    { "id": 12406, "word": "សក្ការ" },
    { "id": 12407, "word": "សក្ការសម្មាន" },
    { "id": 12408, "word": "សក្ខរា" },
    { "id": 12409, "word": "សក្ខី" },
    { "id": 12410, "word": "សក្តា" },
    { "id": 12411, "word": "សក្ដិ" },
    { "id": 12412, "word": "ស័ក្ដិសិទ្ធិ" },
    { "id": 12413, "word": "សក្យ" },
    { "id": 12414, "word": "សក្យ --" },
    { "id": 12415, "word": "សក្លាត" },
    { "id": 12416, "word": "សខិលភាស" },
    { "id": 12417, "word": "សខិលភាសា" },
    { "id": 12418, "word": "សខិលភាសិនី" },
    { "id": 12419, "word": "សខិលភាសី" },
    { "id": 12420, "word": "សគារវកថា" },
    { "id": 12421, "word": "សគុណ" },
    { "id": 12422, "word": "សគោត្ត" },
    { "id": 12423, "word": "សគ្គ" },
    { "id": 12424, "word": "សង" },
    { "id": 12425, "word": "សង់" },
    { "id": 12426, "word": "ស៊ង" },
    { "id": 12427, "word": "សងខាង" },
    { "id": 12428, "word": "សង់ខ្យា" },
    { "id": 12429, "word": "សង់គោល" },
    { "id": 12430, "word": "សង់ជ្រោង" },
    { "id": 12431, "word": "សង់ទីម៉ែត្រ" },
    { "id": 12432, "word": "សង់ទ្រយុង" },
    { "id": 12433, "word": "សង់ផ្ទះ" },
    { "id": 12434, "word": "សងសឹក" },
    { "id": 12435, "word": "សង់សឿ" },
    { "id": 12436, "word": "សង៉ា" },
    { "id": 12437, "word": "សង្កត់" },
    { "id": 12438, "word": "សង្កត់សង្កិន" },
    { "id": 12439, "word": "សង្កថា" },
    { "id": 12440, "word": "សង្កប្ប" },
    { "id": 12441, "word": "សង្ករ" },
    { "id": 12442, "word": "សង្កល" },
    { "id": 12443, "word": "សង្កល់" },
    { "id": 12444, "word": "ស័ង្កសី" },
    { "id": 12445, "word": "សង្កា" },
    { "id": 12446, "word": "សង្កាត់" },
    { "id": 12447, "word": "សង្ការ" },
    { "id": 12448, "word": "សង្ការី" },
    { "id": 12449, "word": "សង្កាស" },
    { "id": 12450, "word": "សង្កិណ្ណ" },
    { "id": 12451, "word": "សង្កិន" },
    { "id": 12452, "word": "សង្កិម" },
    { "id": 12453, "word": "សង្កិលេស" },
    { "id": 12454, "word": "សង្កិលេសិក" },
    { "id": 12455, "word": "សង្កឹម" },
    { "id": 12456, "word": "សង្កួត" },
    { "id": 12457, "word": "សង្កើច" },
    { "id": 12458, "word": "សង្កើសង្កាញ់" },
    { "id": 12459, "word": "សង្កៀត" },
    { "id": 12460, "word": "សង្កៀរ" },
    { "id": 12461, "word": "សង្កេត" },
    { "id": 12462, "word": "សង្កែ" },
    { "id": 12463, "word": "សង្កែភ្លើង" },
    { "id": 12464, "word": "សង្កោចន" },
    { "id": 12465, "word": "សង្កោប" },
    { "id": 12466, "word": "សង្ក្រាន្ត" },
    { "id": 12467, "word": "ស័ង្ខ" },
    { "id": 12468, "word": "សង្ខកុដ្ឋិ" },
    { "id": 12469, "word": "សង្ខតធម៌" },
    { "id": 12470, "word": "សង្ខារ" },
    { "id": 12471, "word": "សង្ខិត្ត" },
    { "id": 12472, "word": "សង្ខុញ" },
    { "id": 12473, "word": "សង្ខេប" },
    { "id": 12474, "word": "សង្ខោភ" },
    { "id": 12475, "word": "សង្ខ្យា" },
    { "id": 12476, "word": "សង្ខ្យានុគ្រោះ" },
    { "id": 12477, "word": "សង្គតិ" },
    { "id": 12478, "word": "សង្គម" },
    { "id": 12479, "word": "សង្គមរាស្ត្រនិយម" },
    { "id": 12480, "word": "សង្គហៈ" },
    { "id": 12481, "word": "សង្គាយនា" },
    { "id": 12482, "word": "សង្គាហក" },
    { "id": 12483, "word": "សង្គីតិ" },
    { "id": 12484, "word": "សង្គីតិក" },
    { "id": 12485, "word": "សង្គ្រាជ" },
    { "id": 12486, "word": "សង្គ្រាម" },
    { "id": 12487, "word": "សង្គ្រុប" },
    { "id": 12488, "word": "សង្គ្រោះ" },
    { "id": 12489, "word": "សង្គ្រះ" },
    { "id": 12490, "word": "សង្ឃ" },
    { "id": 12491, "word": "សង្ឃ --" },
    { "id": 12492, "word": "សង្ឃក" },
    { "id": 12493, "word": "សង្ឃ័រ" },
    { "id": 12494, "word": "សង្ឃរា" },
    { "id": 12495, "word": "សង្ឃា" },
    { "id": 12496, "word": "សង្ឃាដី" },
    { "id": 12497, "word": "សង្ឃាត" },
    { "id": 12498, "word": "សង្ឃិក" },
    { "id": 12499, "word": "សង្ឃឹក" },
    { "id": 12500, "word": "សង្ឃឹម" },
    { "id": 12501, "word": "សង្ឃុដ្ឋសព្ទ" },
    { "id": 12502, "word": "សង្ឃ្រាជ" },
    { "id": 12503, "word": "សង្រួបសង្រួម" },
    { "id": 12504, "word": "សង្រួម" },
    { "id": 12505, "word": "សង្រេង" },
    { "id": 12506, "word": "សង្រែក" },
    { "id": 12507, "word": "សង្រៃ" },
    { "id": 12508, "word": "សង្វរ" },
    { "id": 12509, "word": "សង្វាត" },
    { "id": 12510, "word": "សង្វារ" },
    { "id": 12511, "word": "សង្វាស" },
    { "id": 12512, "word": "សង្វិត" },
    { "id": 12513, "word": "សង្វិល" },
    { "id": 12514, "word": "សង្វៀន" },
    { "id": 12515, "word": "សង្វេគ" },
    { "id": 12516, "word": "សង្វែង" },
    { "id": 12517, "word": "សង្វោយ" },
    { "id": 12518, "word": "សង្ស័យ" },
    { "id": 12519, "word": "សង្សារ" },
    { "id": 12520, "word": "សង្ហរ" },
    { "id": 12521, "word": "សង្ហរណ៍" },
    { "id": 12522, "word": "សង្ហា" },
    { "id": 12523, "word": "សង្ហារ" },
    { "id": 12524, "word": "សង្ហារិម" },
    { "id": 12525, "word": "សង្អន់" },
    { "id": 12526, "word": "សង្អារ" },
    { "id": 12527, "word": "សចិត្តកៈ" },
    { "id": 12528, "word": "សច្ច" },
    { "id": 12529, "word": "សច្ច --" },
    { "id": 12530, "word": "សច្ចា" },
    { "id": 12531, "word": "សច្ចាធិដ្ឋាន" },
    { "id": 12532, "word": "សច្ចាប្រណិធាន" },
    { "id": 12533, "word": "សច្ចំ" },
    { "id": 12534, "word": "សច្ឆន្ទ" },
    { "id": 12535, "word": "សច្ឆិកិរិយា" },
    { "id": 12536, "word": "សជន" },
    { "id": 12537, "word": "សជី" },
    { "id": 12538, "word": "សជីព" },
    { "id": 12539, "word": "សជ្ឈ" },
    { "id": 12540, "word": "សជ្ឈាយនកម្ម" },
    { "id": 12541, "word": "សញ្ចរ" },
    { "id": 12542, "word": "សញ្ចារ" },
    { "id": 12543, "word": "សញ្ចារិកា" },
    { "id": 12544, "word": "សញ្ជប់" },
    { "id": 12545, "word": "សញ្ជ័យ" },
    { "id": 12546, "word": "សញ្ជាត" },
    { "id": 12547, "word": "សញ្ជាតិ" },
    { "id": 12548, "word": "សញ្ជីព" },
    { "id": 12549, "word": "សញ្ជីវ័ន" },
    { "id": 12550, "word": "សញ្ជីវនកម្ម" },
    { "id": 12551, "word": "សញ្ជឹង" },
    { "id": 12552, "word": "សញ្ឈា" },
    { "id": 12553, "word": "សញ្ញា" },
    { "id": 12554, "word": "សញ្ញា --" },
    { "id": 12555, "word": "សញ្ញាណ" },
    { "id": 12556, "word": "សញ្ញី" },
    { "id": 12557, "word": "សញ្ញោជន" },
    { "id": 12558, "word": "សដាយុស" },
    { "id": 12559, "word": "សដូវ" },
    { "id": 12560, "word": "សឌាង្គ" },
    { "id": 12561, "word": "សណ្ដ" },
    { "id": 12562, "word": "សណ្ដក" },
    { "id": 12563, "word": "សណ្ដង់" },
    { "id": 12564, "word": "សណ្ដា" },
    { "id": 12565, "word": "សណ្ដាន់" },
    { "id": 12566, "word": "សណ្ដាប" },
    { "id": 12567, "word": "សណ្ដាប់" },
    { "id": 12568, "word": "សណ្ដាប់ធ្នាប់" },
    { "id": 12569, "word": "សណ្ដាយ" },
    { "id": 12570, "word": "សណ្ដូក" },
    { "id": 12571, "word": "សណ្ដូន" },
    { "id": 12572, "word": "សណ្ដែក" },
    { "id": 12573, "word": "សណ្ដែកដី" },
    { "id": 12574, "word": "សណ្ដោង" },
    { "id": 12575, "word": "សណ្ដំ" },
    { "id": 12576, "word": "សណ្ឋាគារ" },
    { "id": 12577, "word": "សណ្ឋាន" },
    { "id": 12578, "word": "សណ្ឋិត" },
    { "id": 12579, "word": "សណ្ឌច្ឆាយព្រឹក្យ" },
    { "id": 12580, "word": "សណ្ឌាស" },
    { "id": 12581, "word": "សណ្ហ" },
    { "id": 12582, "word": "សត" },
    { "id": 12583, "word": "សត --" },
    { "id": 12584, "word": "សតនាគនហុត" },
    { "id": 12585, "word": "សតិ" },
    { "id": 12586, "word": "សតិ --" },
    { "id": 12587, "word": "សតិម" },
    { "id": 12588, "word": "សតេកិច្ឆៈ" },
    { "id": 12589, "word": "សត្ត" },
    { "id": 12590, "word": "សត្ត" },
    { "id": 12591, "word": "សត្ត --" },
    { "id": 12592, "word": "សត្ត --" },
    { "id": 12593, "word": "សត្តបង្ក័ជ" },
    { "id": 12594, "word": "សត្តបុស្ប" },
    { "id": 12595, "word": "សត្តបុស្ស" },
    { "id": 12596, "word": "សត្តប្បករណ៍" },
    { "id": 12597, "word": "សត្តប្បករណាភិធម្ម" },
    { "id": 12598, "word": "សត្តម" },
    { "id": 12599, "word": "សត្តមហាឋាន" },
    { "id": 12600, "word": "សត្តមី" },
    { "id": 12601, "word": "សត្យ" },
    { "id": 12602, "word": "សត្យ --" },
    { "id": 12603, "word": "សត្យា" },
    { "id": 12604, "word": "សត្រា" },
    { "id": 12605, "word": "សត្រី" },
    { "id": 12606, "word": "សត្រូវ" },
    { "id": 12607, "word": "សត្វ" },
    { "id": 12608, "word": "សត្វា" },
    { "id": 12609, "word": "សថូប" },
    { "id": 12610, "word": "សទាគតិ" },
    { "id": 12611, "word": "សទាទាន" },
    { "id": 12612, "word": "សទាផល" },
    { "id": 12613, "word": "សទាព្រឹក្ស" },
    { "id": 12614, "word": "សទារសន្ដោស" },
    { "id": 12615, "word": "សទិស" },
    { "id": 12616, "word": "សទិសសញ្ញា" },
    { "id": 12617, "word": "សទ្ទ" },
    { "id": 12618, "word": "សទ្ទ--" },
    { "id": 12619, "word": "សទ្ធម្ម" },
    { "id": 12620, "word": "សទ្ធា" },
    { "id": 12621, "word": "សទ្ធា --" },
    { "id": 12622, "word": "សទ្ធិវិហារិក" },
    { "id": 12623, "word": "ស៊ន" },
    { "id": 12624, "word": "សន្តតិ" },
    { "id": 12625, "word": "សន្ដាន" },
    { "id": 12626, "word": "សន្ដាប" },
    { "id": 12627, "word": "សន្តិ" },
    { "id": 12628, "word": "សន្តុដ្ឋី" },
    { "id": 12629, "word": "សន្ដោស" },
    { "id": 12630, "word": "សន្ថត" },
    { "id": 12631, "word": "សន្ថវៈ" },
    { "id": 12632, "word": "សន្ថាគារ" },
    { "id": 12633, "word": "សន្ទនា " },
    { "id": 12634, "word": "សន្ទិដ្ឋមិត្ត" },
    { "id": 12635, "word": "សន្ទិដ្ឋិក" },
    { "id": 12636, "word": "សន្ទិះ" },
    { "id": 12637, "word": "សន្ទុះ" },
    { "id": 12638, "word": "សន្ទូង" },
    { "id": 12639, "word": "សន្ទូច" },
    { "id": 12640, "word": "សន្ទេសហារ" },
    { "id": 12641, "word": "សន្ទេសហារិនី" },
    { "id": 12642, "word": "សន្ទេហ" },
    { "id": 12643, "word": "សន្ទេះ" },
    { "id": 12644, "word": "សន្ទៃ" },
    { "id": 12645, "word": "សន្ទះ" },
    { "id": 12646, "word": "សន្ទ្រាព" },
    { "id": 12647, "word": "សន្ធប់" },
    { "id": 12648, "word": "សន្ធរ" },
    { "id": 12649, "word": "សន្ធាន" },
    { "id": 12650, "word": "សន្ធានី" },
    { "id": 12651, "word": "សន្ធាប់" },
    { "id": 12652, "word": "សន្ធារណៈ" },
    { "id": 12653, "word": "សន្ធិ" },
    { "id": 12654, "word": "សន្ធិប្រកាស" },
    { "id": 12655, "word": "សន្ធិយា" },
    { "id": 12656, "word": "សន្ធឹក" },
    { "id": 12657, "word": "សន្ធឹកផ្គរគ្រាំ" },
    { "id": 12658, "word": "សន្ធឹកសន្ធៃ" },
    { "id": 12659, "word": "សន្ធឹង" },
    { "id": 12660, "word": "សន្ធៃ" },
    { "id": 12661, "word": "សន្ធោ" },
    { "id": 12662, "word": "សន្ធៅ" },
    { "id": 12663, "word": "សន្ធំ" },
    { "id": 12664, "word": "សន្ធ្យា" },
    { "id": 12665, "word": "សន្និច្ច័យ" },
    { "id": 12666, "word": "សន្និដ្ឋាន" },
    { "id": 12667, "word": "សន្និធិ" },
    { "id": 12668, "word": "សន្និបាត" },
    { "id": 12669, "word": "សន្និពន្ធ" },
    { "id": 12670, "word": "សន្និពន្ធន៍" },
    { "id": 12671, "word": "សន្និភ" },
    { "id": 12672, "word": "សន្និវាស" },
    { "id": 12673, "word": "សន្និវេស" },
    { "id": 12674, "word": "សន្និស័ទ" },
    { "id": 12675, "word": "សន្និសីទ" },
    { "id": 12676, "word": "សន្មត" },
    { "id": 12677, "word": "សន្មតិ" },
    { "id": 12678, "word": "សន្យា" },
    { "id": 12679, "word": "សន្យាសភាព" },
    { "id": 12680, "word": "សន្លង់" },
    { "id": 12681, "word": "សន្លប់" },
    { "id": 12682, "word": "សន្លាក់" },
    { "id": 12683, "word": "សន្លាង" },
    { "id": 12684, "word": "សន្លិន" },
    { "id": 12685, "word": "សន្លឹក" },
    { "id": 12686, "word": "សន្លឹង" },
    { "id": 12687, "word": "សន្លឹម" },
    { "id": 12688, "word": "សន្លុង" },
    { "id": 12689, "word": "សន្សឹម" },
    { "id": 12690, "word": "សន្សើម" },
    { "id": 12691, "word": "សន្សែ" },
    { "id": 12692, "word": "សន្សំ" },
    { "id": 12693, "word": "សប" },
    { "id": 12694, "word": "សប់" },
    { "id": 12695, "word": "ស៊ប់" },
    { "id": 12696, "word": "សបត្តជន" },
    { "id": 12697, "word": "សបថ" },
    { "id": 12698, "word": "សប៊ូ" },
    { "id": 12699, "word": "សប្ត" },
    { "id": 12700, "word": "សប្តប្រករណ៍" },
    { "id": 12701, "word": "សប្ប" },
    { "id": 12702, "word": "សប្បដិភ័យ" },
    { "id": 12703, "word": "សប្បដិភាគ" },
    { "id": 12704, "word": "សប្បធន់" },
    { "id": 12705, "word": "សប្បាយ" },
    { "id": 12706, "word": "សប្បិ" },
    { "id": 12707, "word": "សប្បុរស" },
    { "id": 12708, "word": "សប្បុរិស" },
    { "id": 12709, "word": "សព" },
    { "id": 12710, "word": "សព្ទ" },
    { "id": 12711, "word": "សព្វ" },
    { "id": 12712, "word": "សព --" },
    { "id": 12713, "word": "សព្វនាម" },
    { "id": 12714, "word": "សព្វបើ" },
    { "id": 12715, "word": "សញ្វវុធ" },
    { "id": 12716, "word": "សព្ភិ" },
    { "id": 12717, "word": "សព្រហ្មចារិនី" },
    { "id": 12718, "word": "សព្រហ្មចារី" },
    { "id": 12719, "word": "សភា" },
    { "id": 12720, "word": "សភា --" },
    { "id": 12721, "word": "សភាគ" },
    { "id": 12722, "word": "សភាជន" },
    { "id": 12723, "word": "សភាព" },
    { "id": 12724, "word": "សភាវៈ" },
    { "id": 12725, "word": "សម" },
    { "id": 12726, "word": "សម" },
    { "id": 12727, "word": "សម" },
    { "id": 12728, "word": "សម៉" },
    { "id": 12729, "word": "សមគ្គ" },
    { "id": 12730, "word": "សមជ្ជ" },
    { "id": 12731, "word": "សមជ្ជា" },
    { "id": 12732, "word": "សមញ្ញា" },
    { "id": 12733, "word": "សមណ" },
    { "id": 12734, "word": "សមណ --" },
    { "id": 12735, "word": "សមណគោតម" },
    { "id": 12736, "word": "សមណសក្ដិ" },
    { "id": 12737, "word": "សមណី" },
    { "id": 12738, "word": "សមណុត្តមាភិសេក" },
    { "id": 12739, "word": "សមណុទ្ទេស" },
    { "id": 12740, "word": "សមណោគ្រួ" },
    { "id": 12741, "word": "សមត្ថ" },
    { "id": 12742, "word": "សមត្ថ --" },
    { "id": 12743, "word": "សមថ" },
    { "id": 12744, "word": "សមន្ធការ" },
    { "id": 12745, "word": "សមព្រមត់" },
    { "id": 12746, "word": "សមភាព" },
    { "id": 12747, "word": "សមភិហារ" },
    { "id": 12748, "word": "សម័យ" },
    { "id": 12749, "word": "សមរ" },
    { "id": 12750, "word": "សមវាយ" },
    { "id": 12751, "word": "សមសញ្ញា" },
    { "id": 12752, "word": "សមសែម" },
    { "id": 12753, "word": "សមាគតរដ្ឋ" },
    { "id": 12754, "word": "សមាគម" },
    { "id": 12755, "word": "សមាចារ" },
    { "id": 12756, "word": "សមាជ" },
    { "id": 12757, "word": "សមាជិក" },
    { "id": 12758, "word": "សមាជិកា" },
    { "id": 12759, "word": "សមាទាន" },
    { "id": 12760, "word": "សមាធាន" },
    { "id": 12761, "word": "សមាធិ" },
    { "id": 12762, "word": "សមាន" },
    { "id": 12763, "word": "សមាបត្តិ" },
    { "id": 12764, "word": "សមាយោគ" },
    { "id": 12765, "word": "សមារម្ភ" },
    { "id": 12766, "word": "សមាស" },
    { "id": 12767, "word": "សមាស័ទ" },
    { "id": 12768, "word": "សមាហិតចិត្ត" },
    { "id": 12769, "word": "សមិត" },
    { "id": 12770, "word": "សមិតិ" },
    { "id": 12771, "word": "សមិទ្ធ" },
    { "id": 12772, "word": "សមិទ្ធិ" },
    { "id": 12773, "word": "សមិន្ធន៍" },
    { "id": 12774, "word": "សមុច្ច័យ" },
    { "id": 12775, "word": "សមុច្ឆេទ" },
    { "id": 12776, "word": "សមុជ្ជល" },
    { "id": 12777, "word": "សមុដ្ឋាន" },
    { "id": 12778, "word": "សមុទយៈ" },
    { "id": 12779, "word": "សមុទាចារ" },
    { "id": 12780, "word": "សមុទាយ" },
    { "id": 12781, "word": "សមុទ្ទ" },
    { "id": 12782, "word": "សមុហ៍" },
    { "id": 12783, "word": "សមុហបញ្ជី" },
    { "id": 12784, "word": "សមូវ" },
    { "id": 12785, "word": "សមូហ" },
    { "id": 12786, "word": "សមោធាន" },
    { "id": 12787, "word": "សមោសរ" },
    { "id": 12788, "word": "សមោសរណៈ" },
    { "id": 12789, "word": "សម្កក" },
    { "id": 12790, "word": "សម្កាក" },
    { "id": 12791, "word": "សម្កុង" },
    { "id": 12792, "word": "សម្កុល" },
    { "id": 12793, "word": "សម្កូញ" },
    { "id": 12794, "word": "សម្កូវ" },
    { "id": 12795, "word": "សម្គម" },
    { "id": 12796, "word": "សម្គាល់" },
    { "id": 12797, "word": "សម្គុល" },
    { "id": 12798, "word": "សម្គោក" },
    { "id": 12799, "word": "សម្គាំង" },
    { "id": 12800, "word": "សម្ងាច" },
    { "id": 12801, "word": "សម្ងាត់" },
    { "id": 12802, "word": "សម្ងើច" },
    { "id": 12803, "word": "សម្ងំ" },
    { "id": 12804, "word": "សម្ញាញ" },
    { "id": 12805, "word": "សម្ញេញ" },
    { "id": 12806, "word": "សម្ញែង" },
    { "id": 12807, "word": "សម្ដី" },
    { "id": 12808, "word": "សម្ដឹង" },
    { "id": 12809, "word": "សម្ដឺត" },
    { "id": 12810, "word": "សម្ដើង" },
    { "id": 12811, "word": "សម្ដេច" },
    { "id": 12812, "word": "សម្ដេជ" },
    { "id": 12813, "word": "សម្ដែង" },
    { "id": 12814, "word": "សម្ដោះ" },
    { "id": 12815, "word": "សម្តត" },
    { "id": 12816, "word": "សម្តុល" },
    { "id": 12817, "word": "សម្តោក" },
    { "id": 12818, "word": "សម្ទក់" },
    { "id": 12819, "word": "សម្ទង់" },
    { "id": 12820, "word": "សម្ទល" },
    { "id": 12821, "word": "សម្ទាញ" },
    { "id": 12822, "word": "សម្ទាយ" },
    { "id": 12823, "word": "សម្ទារ" },
    { "id": 12824, "word": "សម្ទីក" },
    { "id": 12825, "word": "សម្ទុះ" },
    { "id": 12826, "word": "សម្ទុះក្អែក" },
    { "id": 12827, "word": "សម្ទូង" },
    { "id": 12828, "word": "សម្ទើញ" },
    { "id": 12829, "word": "សម្ទេះ" },
    { "id": 12830, "word": "សម្ទែល" },
    { "id": 12831, "word": "សម្នាក់" },
    { "id": 12832, "word": "សម្នាដៃ" },
    { "id": 12833, "word": "សម្នាម" },
    { "id": 12834, "word": "សម្បក" },
    { "id": 12835, "word": "សម្បជញ្ញៈ" },
    { "id": 12836, "word": "សម្បជាន មុសាវាទ" },
    { "id": 12837, "word": "សម្បត្តិ" },
    { "id": 12838, "word": "សម្បថ" },
    { "id": 12839, "word": "សម្ប័ទ" },
    { "id": 12840, "word": "សម្បទាន" },
    { "id": 12841, "word": "សម្បធាន" },
    { "id": 12842, "word": "សម្បយុត្ត" },
    { "id": 12843, "word": "សម្បយោគ" },
    { "id": 12844, "word": "សម្បរាយ" },
    { "id": 12845, "word": "សម្បរាយិក" },
    { "id": 12846, "word": "សម្បរិ វត្តន៍" },
    { "id": 12847, "word": "សម្បសាទ" },
    { "id": 12848, "word": "សម្បហារ" },
    { "id": 12849, "word": "សម្បា" },
    { "id": 12850, "word": "សម្បាច់" },
    { "id": 12851, "word": "សម្បារ" },
    { "id": 12852, "word": "សម្បុក" },
    { "id": 12853, "word": "សម្បុកចាប" },
    { "id": 12854, "word": "សម្បុកទ្រយុក" },
    { "id": 12855, "word": "សម្បុដ" },
    { "id": 12856, "word": "សម្បុរ" },
    { "id": 12857, "word": "សម្បុរថ្ងៃ" },
    { "id": 12858, "word": "សម្បុរល្វែង" },
    { "id": 12859, "word": "សម្បុរស្បែក" },
    { "id": 12860, "word": "សម្បូងសង្រូង" },
    { "id": 12861, "word": "សម្បូរ" },
    { "id": 12862, "word": "សម្បូណ៌" },
    { "id": 12863, "word": "សម្បួរ" },
    { "id": 12864, "word": "សម្បើម" },
    { "id": 12865, "word": "សម្បែង" },
    { "id": 12866, "word": "សម្បោរ" },
    { "id": 12867, "word": "សម្ផប្បលាប" },
    { "id": 12868, "word": "សម្ផស្ស" },
    { "id": 12869, "word": "សម្ផុល្ល" },
    { "id": 12870, "word": "សម្ពង្ស" },
    { "id": 12871, "word": "សម្ពច្ឆរៈ" },
    { "id": 12872, "word": "សម្ពន្ធ" },
    { "id": 12873, "word": "សម្ពន្ធ --" },
    { "id": 12874, "word": "សម្ពន្ធិន" },
    { "id": 12875, "word": "សម្ពន្ធិនី" },
    { "id": 12876, "word": "សម្ពរ" },
    { "id": 12877, "word": "សម្ពល" },
    { "id": 12878, "word": "សម្ពលី" },
    { "id": 12879, "word": "សម្ពាធ" },
    { "id": 12880, "word": "សម្ពាធ --" },
    { "id": 12881, "word": "សម្ពាយ" },
    { "id": 12882, "word": "សម្ពាហក" },
    { "id": 12883, "word": "សម្ពាហនកម្ម" },
    { "id": 12884, "word": "សម្ពាហិកា" },
    { "id": 12885, "word": "សម្ពឹក" },
    { "id": 12886, "word": "សម្ពុទ្ធ" },
    { "id": 12887, "word": "សម្ពៀត" },
    { "id": 12888, "word": "សម្ពែះ" },
    { "id": 12889, "word": "សម្ពោធ" },
    { "id": 12890, "word": "សម្ពោធនៈ" },
    { "id": 12891, "word": "សម្ពោធិ" },
    { "id": 12892, "word": "សម្ភត្តមិត្ត" },
    { "id": 12893, "word": "សម្ភព" },
    { "id": 12894, "word": "សម្ភវរាគ" },
    { "id": 12895, "word": "សម្ភវេសី" },
    { "id": 12896, "word": "សម្ភាពន៍" },
    { "id": 12897, "word": "សម្ភារ" },
    { "id": 12898, "word": "សម្ភារ ភ្លឹក" },
    { "id": 12899, "word": "សម្ភាវកថា" },
    { "id": 12900, "word": "សម្ភាវនៈ" },
    { "id": 12901, "word": "សម្ភាវរាគ" },
    { "id": 12902, "word": "សម្ភាវិត" },
    { "id": 12903, "word": "សម្ភាស" },
    { "id": 12904, "word": "សម្ភាសា" },
    { "id": 12905, "word": "សម្ភាសិត" },
    { "id": 12906, "word": "សម្ភិត" },
    { "id": 12907, "word": "សម្ភិន្ន" },
    { "id": 12908, "word": "សម្ភី" },
    { "id": 12909, "word": "សម្ភូតិ" },
    { "id": 12910, "word": "សម្ភេទ" },
    { "id": 12911, "word": "សម្ភោគ" },
    { "id": 12912, "word": "សម្ភោជ" },
    { "id": 12913, "word": "សម្ភោទ្យ" },
    { "id": 12914, "word": "សម្ភោរ" },
    { "id": 12915, "word": "សម្មជ្ជន" },
    { "id": 12916, "word": "សម្មជ្ជនី" },
    { "id": 12917, "word": "សម្មត" },
    { "id": 12918, "word": "សម្មតិ" },
    { "id": 12919, "word": "សម្មតិ --" },
    { "id": 12920, "word": "សម្មតិលិង្គ" },
    { "id": 12921, "word": "សម្មា" },
    { "id": 12922, "word": "សម្មា --" },
    { "id": 12923, "word": "សម្មាន" },
    { "id": 12924, "word": "សម្មាសម្ពុទ្ធ" },
    { "id": 12925, "word": "សម្មុខីភូត" },
    { "id": 12926, "word": "សម្មោទនកថា" },
    { "id": 12927, "word": "សម្មោទនីយកថា" },
    { "id": 12928, "word": "សម្រក" },
    { "id": 12929, "word": "សម្រក់" },
    { "id": 12930, "word": "សម្រង់" },
    { "id": 12931, "word": "សម្រន់" },
    { "id": 12932, "word": "សម្រប" },
    { "id": 12933, "word": "សម្រស់" },
    { "id": 12934, "word": "សម្រាក" },
    { "id": 12935, "word": "សម្រាជ" },
    { "id": 12936, "word": "សម្រាត" },
    { "id": 12937, "word": "សម្រាន្ត" },
    { "id": 12938, "word": "សម្រាប់" },
    { "id": 12939, "word": "សម្រាយ" },
    { "id": 12940, "word": "សម្រាល" },
    { "id": 12941, "word": "សម្រាស់" },
    { "id": 12942, "word": "សម្រិត" },
    { "id": 12943, "word": "សម្រិល" },
    { "id": 12944, "word": "សម្រឹង" },
    { "id": 12945, "word": "សម្រុក" },
    { "id": 12946, "word": "សម្រុង" },
    { "id": 12947, "word": "សម្រុញ" },
    { "id": 12948, "word": "សម្រុត" },
    { "id": 12949, "word": "សម្រុះ" },
    { "id": 12950, "word": "សម្រុះសម្រួល" },
    { "id": 12951, "word": "សម្រូត" },
    { "id": 12952, "word": "សម្រូប" },
    { "id": 12953, "word": "សម្រួច" },
    { "id": 12954, "word": "សម្រួត" },
    { "id": 12955, "word": "សម្រួល" },
    { "id": 12956, "word": "សម្រើប" },
    { "id": 12957, "word": "សម្រេក" },
    { "id": 12958, "word": "សម្រេង" },
    { "id": 12959, "word": "សម្រេច" },
    { "id": 12960, "word": "សម្រេះ" },
    { "id": 12961, "word": "សម្រែក" },
    { "id": 12962, "word": "សម្រែកសត្វ" },
    { "id": 12963, "word": "សម្រែង" },
    { "id": 12964, "word": "សម្រោច" },
    { "id": 12965, "word": "សម្រោប" },
    { "id": 12966, "word": "សម្រោះ" },
    { "id": 12967, "word": "សម្រាំង" },
    { "id": 12968, "word": "សម្ល" },
    { "id": 12969, "word": "សម្លក់" },
    { "id": 12970, "word": "សម្លប" },
    { "id": 12971, "word": "សម្លាក" },
    { "id": 12972, "word": "សម្លាក់សំខាន់" },
    { "id": 12973, "word": "សម្លាញ់" },
    { "id": 12974, "word": "សម្លាប់" },
    { "id": 12975, "word": "សម្លាប់ កង្កែប" },
    { "id": 12976, "word": "សម្លិច" },
    { "id": 12977, "word": "សម្លី" },
    { "id": 12978, "word": "សម្លឹង" },
    { "id": 12979, "word": "សម្លុក" },
    { "id": 12980, "word": "សម្លុត" },
    { "id": 12981, "word": "សម្លុយ" },
    { "id": 12982, "word": "សម្លូត" },
    { "id": 12983, "word": "សម្លើត" },
    { "id": 12984, "word": "សម្លេក" },
    { "id": 12985, "word": "សម្លេច" },
    { "id": 12986, "word": "សម្លែវ" },
    { "id": 12987, "word": "សម្លោក" },
    { "id": 12988, "word": "សម្អក" },
    { "id": 12989, "word": "សម្អប់" },
    { "id": 12990, "word": "សម្អប់ពុត" },
    { "id": 12991, "word": "សម្អាង" },
    { "id": 12992, "word": "សម្អាត" },
    { "id": 12993, "word": "សម្អិត" },
    { "id": 12994, "word": "សម្អុយ" },
    { "id": 12995, "word": "សម្អេក" },
    { "id": 12996, "word": "សម្អែល" },
    { "id": 12997, "word": "សយ" },
    { "id": 12998, "word": "ស៊យ" },
    { "id": 12999, "word": "សយនៈ" },
    { "id": 13000, "word": "សយន --" },
    { "id": 13001, "word": "សយម្ពរា" },
    { "id": 13002, "word": "សយម្ភូ" },
    { "id": 13003, "word": "សយាលុ" },
    { "id": 13004, "word": "សយ្យា" },
    { "id": 13005, "word": "សយ្យាសន៍" },
    { "id": 13006, "word": "សយូវ" },
    { "id": 13007, "word": "សរ" },
    { "id": 13008, "word": "សរៈ" },
    { "id": 13009, "word": "សគ៌ៈ" },
    { "id": 13010, "word": "សរណៈ" },
    { "id": 13011, "word": "សរណ --" },
    { "id": 13012, "word": "សរទៈ" },
    { "id": 13013, "word": "សរទកាល" },
    { "id": 13014, "word": "សរពាង្គ" },
    { "id": 13015, "word": "សរពើ" },
    { "id": 13016, "word": "សរពេជ្ញ" },
    { "id": 13017, "word": "សព៌ជ្ញ" },
    { "id": 13018, "word": "សព៌ាង្គ" },
    { "id": 13019, "word": "សព៌េជ្ញ" },
    { "id": 13020, "word": "សរព្រះ" },
    { "id": 13021, "word": "សរភញ្ញ" },
    { "id": 13022, "word": "សរសន់" },
    { "id": 13023, "word": "សរសើរ" },
    { "id": 13024, "word": "សរសេរ" },
    { "id": 13025, "word": "សរសៃ" },
    { "id": 13026, "word": "សរស្វ័ត" },
    { "id": 13027, "word": "សរិល" },
    { "id": 13028, "word": "សរីរៈ" },
    { "id": 13029, "word": "សរីរ --" },
    { "id": 13030, "word": "សរីរិន" },
    { "id": 13031, "word": "សរីស្រឹប" },
    { "id": 13032, "word": "សរុប" },
    { "id": 13033, "word": "សរោជ" },
    { "id": 13034, "word": "សល់" },
    { "id": 13035, "word": "សល់វ៉ល់" },
    { "id": 13036, "word": "សលាក" },
    { "id": 13037, "word": "សលាដុផល" },
    { "id": 13038, "word": "សលៀង" },
    { "id": 13039, "word": "សល្លាប" },
    { "id": 13040, "word": "សវ" },
    { "id": 13041, "word": "សវនៈ" },
    { "id": 13042, "word": "សវន --" },
    { "id": 13043, "word": "សវនីយ៍" },
    { "id": 13044, "word": "សវនូ --" },
    { "id": 13045, "word": "សវន្តី" },
    { "id": 13046, "word": "សវិញ្ញាណកៈ" },
    { "id": 13047, "word": "ស៊សគ្រលស" },
    { "id": 13048, "word": "សសរ" },
    { "id": 13049, "word": "សសាង្ក" },
    { "id": 13050, "word": "សសិ" },
    { "id": 13051, "word": "សសិត" },
    { "id": 13052, "word": "សសិន" },
    { "id": 13053, "word": "សសឹក" },
    { "id": 13054, "word": "សសុក មម៉ុក" },
    { "id": 13055, "word": "សសុរៈ" },
    { "id": 13056, "word": "សសុល" },
    { "id": 13057, "word": "សសូល" },
    { "id": 13058, "word": "សសៀរ" },
    { "id": 13059, "word": "សសេះ" },
    { "id": 13060, "word": "សសោះ" },
    { "id": 13061, "word": "សសោះអន្ទង" },
    { "id": 13062, "word": "សស្ត្រ" },
    { "id": 13063, "word": "សស្ត្រ --" },
    { "id": 13064, "word": "សស្ត្រា" },
    { "id": 13065, "word": "សស្រាក់" },
    { "id": 13066, "word": "សស្រាញ់" },
    { "id": 13067, "word": "សស្រ៊ាស" },
    { "id": 13068, "word": "សស្រិក" },
    { "id": 13069, "word": "សស្រិច" },
    { "id": 13070, "word": "សស្រិប" },
    { "id": 13071, "word": "សស្រ៊‌ឹង" },
    { "id": 13072, "word": "សស្រឹប" },
    { "id": 13073, "word": "សស្រ៊‌ឹប" },
    { "id": 13074, "word": "សស៊្រ‌ឹម" },
    { "id": 13075, "word": "សស្រ៊ុច" },
    { "id": 13076, "word": "សស្រ៊ុប" },
    { "id": 13077, "word": "សស្រូស" },
    { "id": 13078, "word": "សស្រូះ" },
    { "id": 13079, "word": "សស្រួញ" },
    { "id": 13080, "word": "សស្រេកសស្រាក" },
    { "id": 13081, "word": "សស្រោក" },
    { "id": 13082, "word": "សស្រាំ" },
    { "id": 13083, "word": "សស្លក់" },
    { "id": 13084, "word": "សស្លន់សស្លោ" },
    { "id": 13085, "word": "សស្លើត" },
    { "id": 13086, "word": "សស្លើតសស្លក់" },
    { "id": 13087, "word": "សស្លោ" },
    { "id": 13088, "word": "សស្ស" },
    { "id": 13089, "word": "សស្សុ" },
    { "id": 13090, "word": "សហ" },
    { "id": 13091, "word": "សហ --" },
    { "id": 13092, "word": "សហ័ស" },
    { "id": 13093, "word": "សហសា" },
    { "id": 13094, "word": "សហស្ស" },
    { "id": 13095, "word": "សហស្ស --" },
    { "id": 13096, "word": "សហា --" },
    { "id": 13097, "word": "សហាយ" },
    { "id": 13098, "word": "សហាយិកា" },
    { "id": 13099, "word": "សហារ" },
    { "id": 13100, "word": "សហិច សហារ" },
    { "id": 13101, "word": "សហោទរ" },
    { "id": 13102, "word": "សា" },
    { "id": 13103, "word": "សាក" },
    { "id": 13104, "word": "សាក់" },
    { "id": 13105, "word": "សាក --" },
    { "id": 13106, "word": "សាកៈ" },
    { "id": 13107, "word": "សាកច្ឆា" },
    { "id": 13108, "word": "សាកត្រាក" },
    { "id": 13109, "word": "សាកន្ទេល" },
    { "id": 13110, "word": "សាក់បើ" },
    { "id": 13111, "word": "សាកប៉ត្រាក" },
    { "id": 13112, "word": "សាកម៉្ញាក" },
    { "id": 13113, "word": "សាកល" },
    { "id": 13114, "word": "សាកសព" },
    { "id": 13115, "word": "សាកសួរ" },
    { "id": 13116, "word": "សាកិយៈ" },
    { "id": 13117, "word": "សាកិយានី" },
    { "id": 13118, "word": "សាកុណិក" },
    { "id": 13119, "word": "សាកេ" },
    { "id": 13120, "word": "សាក្យ" },
    { "id": 13121, "word": "សាក្សី" },
    { "id": 13122, "word": "សាខា" },
    { "id": 13123, "word": "សាគរ" },
    { "id": 13124, "word": "សាគរវិទ្យា" },
    { "id": 13125, "word": "សាគូ" },
    { "id": 13126, "word": "សាគូរនាម" },
    { "id": 13127, "word": "សាង" },
    { "id": 13128, "word": "សាងញ៉ាង" },
    { "id": 13129, "word": "សាច" },
    { "id": 13130, "word": "សាច់" },
    { "id": 13131, "word": "សាច់ជូរ" },
    { "id": 13132, "word": "សាជី" },
    { "id": 13133, "word": "សាជូរ" },
    { "id": 13134, "word": "សាញ" },
    { "id": 13135, "word": "សាញ្ជនសត្វ" },
    { "id": 13136, "word": "សាដក" },
    { "id": 13137, "word": "សាដាន" },
    { "id": 13138, "word": "សាដៀវ" },
    { "id": 13139, "word": "សាណ" },
    { "id": 13140, "word": "សាណពស្ត្រ" },
    { "id": 13141, "word": "សាណិ" },
    { "id": 13142, "word": "សាណិយា" },
    { "id": 13143, "word": "សាត" },
    { "id": 13144, "word": "សាត់" },
    { "id": 13145, "word": "សាតាំង" },
    { "id": 13146, "word": "សាត្រា" },
    { "id": 13147, "word": "សាទរ" },
    { "id": 13148, "word": "សាទិន" },
    { "id": 13149, "word": "សាទិស" },
    { "id": 13150, "word": "សាទុក្ខ" },
    { "id": 13151, "word": "សាទុភោជន" },
    { "id": 13152, "word": "សាទោស" },
    { "id": 13153, "word": "សាធ" },
    { "id": 13154, "word": "សាធក" },
    { "id": 13155, "word": "សាធនៈ" },
    { "id": 13156, "word": "សាធារណៈ" },
    { "id": 13157, "word": "សាធារណ --" },
    { "id": 13158, "word": "សាធុ" },
    { "id": 13159, "word": "សាធុ --" },
    { "id": 13160, "word": "សាធ្វសាធុ" },
    { "id": 13161, "word": "សាធ្វាចារ" },
    { "id": 13162, "word": "សាន" },
    { "id": 13163, "word": "សានក្រម" },
    { "id": 13164, "word": "សានណូវ" },
    { "id": 13165, "word": "សាន់វុ័ណ្ត" },
    { "id": 13166, "word": "សាន់វ៉ាន់" },
    { "id": 13167, "word": "សានុសិស្ស" },
    { "id": 13168, "word": "សានូ" },
    { "id": 13169, "word": "សាន្ត" },
    { "id": 13170, "word": "សាន្តិ" },
    { "id": 13171, "word": "សាប" },
    { "id": 13172, "word": "សាប" },
    { "id": 13173, "word": "សាប់" },
    { "id": 13174, "word": "សាបតេយ្យ" },
    { "id": 13175, "word": "សាបតៃយ" },
    { "id": 13176, "word": "សាបាន" },
    { "id": 13177, "word": "សាបាល" },
    { "id": 13178, "word": "សាប៊ូ" },
    { "id": 13179, "word": "សាពិភ័ក្តិ" },
    { "id": 13180, "word": "សាមៈ" },
    { "id": 13181, "word": "សាមគ្គី" },
    { "id": 13182, "word": "សាមគ្គីភេទ" },
    { "id": 13183, "word": "សាមញ្ញ" },
    { "id": 13184, "word": "សាមញ្ញ" },
    { "id": 13185, "word": "សាមណេរ" },
    { "id": 13186, "word": "សាមណេរី" },
    { "id": 13187, "word": "សាមន្ត" },
    { "id": 13188, "word": "សាមសិប" },
    { "id": 13189, "word": "សាមហាប" },
    { "id": 13190, "word": "សាមាន្យ" },
    { "id": 13191, "word": "សាមាយិក" },
    { "id": 13192, "word": "សាមិក" },
    { "id": 13193, "word": "សាមិនី" },
    { "id": 13194, "word": "សាមី" },
    { "id": 13195, "word": "សាមីចិ" },
    { "id": 13196, "word": "សាមីសម្ពន្ធ" },
    { "id": 13197, "word": "សាមុទ្ទៈ" },
    { "id": 13198, "word": "សាមុទ្ទិក" },
    { "id": 13199, "word": "សាយ" },
    { "id": 13200, "word": "សាយដៀវ" },
    { "id": 13201, "word": "សាយណ្ហៈ" },
    { "id": 13202, "word": "សាយណ្ហ --" },
    { "id": 13203, "word": "សាយបាត" },
    { "id": 13204, "word": "សាយភោជន" },
    { "id": 13205, "word": "សាយមាស" },
    { "id": 13206, "word": "សាយយុត" },
    { "id": 13207, "word": "សាយឺន" },
    { "id": 13208, "word": "សារ" },
    { "id": 13209, "word": "សារ --" },
    { "id": 13210, "word": "សារណិក" },
    { "id": 13211, "word": "សារណិកា" },
    { "id": 13212, "word": "សារត្រា" },
    { "id": 13213, "word": "សារថី" },
    { "id": 13214, "word": "សារទិក" },
    { "id": 13215, "word": "សារបាប់" },
    { "id": 13216, "word": "សារព័ន" },
    { "id": 13217, "word": "សារពាង្គ" },
    { "id": 13218, "word": "សារពើ" },
    { "id": 13219, "word": "សារពើយុត្ត" },
    { "id": 13220, "word": "សារពើសូត្រ" },
    { "id": 13221, "word": "សារពេជ្ញ" },
    { "id": 13222, "word": "សារភាព" },
    { "id": 13223, "word": "សារម្ភកថា" },
    { "id": 13224, "word": "សារវ័ត្រ" },
    { "id": 13225, "word": "សារា --" },
    { "id": 13226, "word": "សារាណីយ" },
    { "id": 13227, "word": "សារាយ" },
    { "id": 13228, "word": "សារាយអណ្តែត" },
    { "id": 13229, "word": "សារិកា" },
    { "id": 13230, "word": "សារី" },
    { "id": 13231, "word": "សារីបុត្ត" },
    { "id": 13232, "word": "សារីរសាស្រ្ត" },
    { "id": 13233, "word": "សារីរិក" },
    { "id": 13234, "word": "សារុង" },
    { "id": 13235, "word": "សារុប្ប" },
    { "id": 13236, "word": "សារូ" },
    { "id": 13237, "word": "សារូប" },
    { "id": 13238, "word": "សារោជ" },
    { "id": 13239, "word": "សាល" },
    { "id": 13240, "word": "សាលចតុម្មុខ" },
    { "id": 13241, "word": "សាលព្រឹក្ស" },
    { "id": 13242, "word": "សាល់" },
    { "id": 13243, "word": "សាលា" },
    { "id": 13244, "word": "សាលាដ" },
    { "id": 13245, "word": "សាលិកា" },
    { "id": 13246, "word": "សាលី" },
    { "id": 13247, "word": "សាលោហិត" },
    { "id": 13248, "word": "សាវ" },
    { "id": 13249, "word": "សាវក" },
    { "id": 13250, "word": "សាវកែ" },
    { "id": 13251, "word": "សាវជៃ" },
    { "id": 13252, "word": "សាវណមាស" },
    { "id": 13253, "word": "សាវតារ" },
    { "id": 13254, "word": "សាវត្ថី" },
    { "id": 13255, "word": "សាវទាវ" },
    { "id": 13256, "word": "សាវម៉ាវ" },
    { "id": 13257, "word": "សាវយុត" },
    { "id": 13258, "word": "សាវសេស" },
    { "id": 13259, "word": "សាវឡិក" },
    { "id": 13260, "word": "សាវា" },
    { "id": 13261, "word": "សាវិកា" },
    { "id": 13262, "word": "សាសង" },
    { "id": 13263, "word": "សាសន" },
    { "id": 13264, "word": "សាសន --" },
    { "id": 13265, "word": "សាសន៍" },
    { "id": 13266, "word": "សាសនា" },
    { "id": 13267, "word": "សាសនិក" },
    { "id": 13268, "word": "សាសព្ទ" },
    { "id": 13269, "word": "សាសរោគ" },
    { "id": 13270, "word": "សាស្ដា" },
    { "id": 13271, "word": "សាស្ត្រ" },
    { "id": 13272, "word": "សាស្ត្រា" },
    { "id": 13273, "word": "សាហត្ថ" },
    { "id": 13274, "word": "សាហ័ស" },
    { "id": 13275, "word": "សាហារ" },
    { "id": 13276, "word": "សាហាវ" },
    { "id": 13277, "word": "សហុ !" },
    { "id": 13278, "word": "សាហេតុ" },
    { "id": 13279, "word": "សិក្ខ" },
    { "id": 13280, "word": "សិក្ខមានា" },
    { "id": 13281, "word": "សិក្ខា" },
    { "id": 13282, "word": "សិក្សា" },
    { "id": 13283, "word": "សិខណ្ឌិន" },
    { "id": 13284, "word": "សិខរិន" },
    { "id": 13285, "word": "សិខា" },
    { "id": 13286, "word": "សិខិន" },
    { "id": 13287, "word": "សិគាល" },
    { "id": 13288, "word": "សិគាលី" },
    { "id": 13289, "word": "សិង" },
    { "id": 13290, "word": "សិង្គាល" },
    { "id": 13291, "word": "សិង្ឃាដ" },
    { "id": 13292, "word": "សិង្ឃាដក" },
    { "id": 13293, "word": "សិង្ឃានិក" },
    { "id": 13294, "word": "សិង្ហ" },
    { "id": 13295, "word": "សិង្ហៈ" },
    { "id": 13296, "word": "សិង្ហល" },
    { "id": 13297, "word": "សិចប៉ប្រិច" },
    { "id": 13298, "word": "សិចមម៉ិច" },
    { "id": 13299, "word": "សិញ " },
    { "id": 13300, "word": "សិត" },
    { "id": 13301, "word": "សិតការណ៍" },
    { "id": 13302, "word": "សិតអន្លិក" },
    { "id": 13303, "word": "សិថិល" },
    { "id": 13304, "word": "សិថិល --" },
    { "id": 13305, "word": "សិទ្ធ" },
    { "id": 13306, "word": "សិទ្ធ --" },
    { "id": 13307, "word": "សិទ្ធត្ថ" },
    { "id": 13308, "word": "សិទ្ធា --" },
    { "id": 13309, "word": "សិទ្ធាថ៌" },
    { "id": 13310, "word": "សិទ្ធិ" },
    { "id": 13311, "word": "សិទ្ធិ --" },
    { "id": 13312, "word": "សិន" },
    { "id": 13313, "word": "ស៊ិនសែ" },
    { "id": 13314, "word": "សិនិទ្ធ" },
    { "id": 13315, "word": "សិនេរុ" },
    { "id": 13316, "word": "សិនេហ" },
    { "id": 13317, "word": "សិនេហ --" },
    { "id": 13318, "word": "សិន្ទ" },
    { "id": 13319, "word": "សិន្ធព" },
    { "id": 13320, "word": "សិន្ធពអមរិន្ទ" },
    { "id": 13321, "word": "សិន្ធវ" },
    { "id": 13322, "word": "សិន្ធុ" },
    { "id": 13323, "word": "សិន្ធុសង្គម" },
    { "id": 13324, "word": "សិន្ធៅវ៍" },
    { "id": 13325, "word": "សិប្ប" },
    { "id": 13326, "word": "សិប្ប --" },
    { "id": 13327, "word": "សិប្បិកៈ" },
    { "id": 13328, "word": "សិប្បិកា" },
    { "id": 13329, "word": "សិប្បិយការ" },
    { "id": 13330, "word": "សិប្បី" },
    { "id": 13331, "word": "សិប្បីជាតិ" },
    { "id": 13332, "word": "សិព្វន" },
    { "id": 13333, "word": "សិព្វនី" },
    { "id": 13334, "word": "សិម្ពលី" },
    { "id": 13335, "word": "សិរ" },
    { "id": 13336, "word": "សិរ --" },
    { "id": 13337, "word": "សិរមាន់" },
    { "id": 13338, "word": "សិរស៍" },
    { "id": 13339, "word": "សិរោ --" },
    { "id": 13340, "word": "សិរិ" },
    { "id": 13341, "word": "សិរី" },
    { "id": 13342, "word": "សិរី --" },
    { "id": 13343, "word": "សិរ្ស" },
    { "id": 13344, "word": "សិលា" },
    { "id": 13345, "word": "សិលា --" },
    { "id": 13346, "word": "សិលុច្ច័យ" },
    { "id": 13347, "word": "សិលោក" },
    { "id": 13348, "word": "សិលោរស្ក" },
    { "id": 13349, "word": "សិល្ប" },
    { "id": 13350, "word": "សិល្ប --" },
    { "id": 13351, "word": "សិវៈ" },
    { "id": 13352, "word": "សិវ --" },
    { "id": 13353, "word": "សិវិកា" },
    { "id": 13354, "word": "សិសិរៈ" },
    { "id": 13355, "word": "សិសុ" },
    { "id": 13356, "word": "សិស្យ" },
    { "id": 13357, "word": "សិស្ស" },
    { "id": 13358, "word": "សិស្សានុសិស្ស" },
    { "id": 13359, "word": "សី" },
    { "id": 13360, "word": "ស៊ី" },
    { "id": 13361, "word": "ស៊ី --" },
    { "id": 13362, "word": "ស៊ីគោល" },
    { "id": 13363, "word": "សីឃ" },
    { "id": 13364, "word": "ស៊ីញេ" },
    { "id": 13365, "word": "សីត" },
    { "id": 13366, "word": "សីត --" },
    { "id": 13367, "word": "សីតា" },
    { "id": 13368, "word": "សីតាលុ" },
    { "id": 13369, "word": "សីទន្តរ" },
    { "id": 13370, "word": "ស៊ីប៉ារេត" },
    { "id": 13371, "word": "ស៊ីម៉ងត៍" },
    { "id": 13372, "word": "សីមន្តរិក" },
    { "id": 13373, "word": "សីមា" },
    { "id": 13374, "word": "ស៊ីមឹង" },
    { "id": 13375, "word": "សីរសាច់" },
    { "id": 13376, "word": "ស៊ីរ៉ូប៍" },
    { "id": 13377, "word": "សីល" },
    { "id": 13378, "word": "សីល --" },
    { "id": 13379, "word": "សីលព្វត --" },
    { "id": 13380, "word": "សីលព្វ័ត" },
    { "id": 13381, "word": "សីលា --" },
    { "id": 13382, "word": "សីវថិកា" },
    { "id": 13383, "word": "ស៊ីវិឡាត" },
    { "id": 13384, "word": "សីស --" },
    { "id": 13385, "word": "សីសៈ" },
    { "id": 13386, "word": "ស៊ីសង" },
    { "id": 13387, "word": "ស៊ីសឹក" },
    { "id": 13388, "word": "ស៊ីសូផុន" },
    { "id": 13389, "word": "សីហៈ" },
    { "id": 13390, "word": "សីហៈ" },
    { "id": 13391, "word": "សីហ --" },
    { "id": 13392, "word": "សីហល" },
    { "id": 13393, "word": "សីហលោ" },
    { "id": 13394, "word": "សីហឡ" },
    { "id": 13395, "word": "សីហា --" },
    { "id": 13396, "word": "សឹក" },
    { "id": 13397, "word": "សឹកប៉ប្លឹក" },
    { "id": 13398, "word": "សឹកប្តឹក" },
    { "id": 13399, "word": "សឹង" },
    { "id": 13400, "word": "ស៊ឹង" },
    { "id": 13401, "word": "សឹម" },
    { "id": 13402, "word": "សឺ" },
    { "id": 13403, "word": "សុក" },
    { "id": 13404, "word": "ស៊ុកគ្រលុក" },
    { "id": 13405, "word": "សុក័ន្ត" },
    { "id": 13406, "word": "សុកមម៉ុក" },
    { "id": 13407, "word": "សុករ" },
    { "id": 13408, "word": "សុកុមារ" },
    { "id": 13409, "word": "សុកុមារី" },
    { "id": 13410, "word": "សុក្ក" },
    { "id": 13411, "word": "សុក្ក --" },
    { "id": 13412, "word": "សុក្រ" },
    { "id": 13413, "word": "សុក្រឹត" },
    { "id": 13414, "word": "សុខ" },
    { "id": 13415, "word": "សុខ --" },
    { "id": 13416, "word": "សុខកំបុត" },
    { "id": 13417, "word": "សុខដុម" },
    { "id": 13418, "word": "សុខដុំ" },
    { "id": 13419, "word": "សុខិតកាល" },
    { "id": 13420, "word": "សុខុម" },
    { "id": 13421, "word": "សុខុម --" },
    { "id": 13422, "word": "សុខុមាល" },
    { "id": 13423, "word": "សុខេធិត" },
    { "id": 13424, "word": "សុខោទ័យ" },
    { "id": 13425, "word": "សុគត" },
    { "id": 13426, "word": "សុគតិ" },
    { "id": 13427, "word": "សុគន្ធ" },
    { "id": 13428, "word": "សុគន្ធ --" },
    { "id": 13429, "word": "សុគមនំ" },
    { "id": 13430, "word": "សុគ្រីព" },
    { "id": 13431, "word": "សុង" },
    { "id": 13432, "word": "សុង្ក" },
    { "id": 13433, "word": "សុច" },
    { "id": 13434, "word": "សុចរិត" },
    { "id": 13435, "word": "សុចនីយ៍ " },
    { "id": 13436, "word": "សុចិ" },
    { "id": 13437, "word": "សុចិ --" },
    { "id": 13438, "word": "សុចិត" },
    { "id": 13439, "word": "សុចិត្តា" },
    { "id": 13440, "word": "សុចិត្រ" },
    { "id": 13441, "word": "សុ.ចិ.បុ.លិ." },
    { "id": 13442, "word": "សុច្ឆន្ទៈ" },
    { "id": 13443, "word": "សុជន" },
    { "id": 13444, "word": "សុជម្បតី" },
    { "id": 13445, "word": "សុផាត" },
    { "id": 13446, "word": "សុជាតា" },
    { "id": 13447, "word": "សុជីវធម៌" },
    { "id": 13448, "word": "សុញ" },
    { "id": 13449, "word": "សុញ្ញ" },
    { "id": 13450, "word": "សុញ្ញ --" },
    { "id": 13451, "word": "សុញ្ញោ" },
    { "id": 13452, "word": "សុដន់" },
    { "id": 13453, "word": "សុណិសា" },
    { "id": 13454, "word": "សុតៈ" },
    { "id": 13455, "word": "ស៊ុត" },
    { "id": 13456, "word": "ស៊ុតទ្រុឌ" },
    { "id": 13457, "word": "សុត្តន្តបិដក" },
    { "id": 13458, "word": "សុទន្ត" },
    { "id": 13459, "word": "សុទស្សា" },
    { "id": 13460, "word": "សុទស្សី" },
    { "id": 13461, "word": "សុទិដ្ឋិនិយម" },
    { "id": 13462, "word": "សុទិន" },
    { "id": 13463, "word": "សុទិន្ន" },
    { "id": 13464, "word": "សុទុក្ករ" },
    { "id": 13465, "word": "សុទ្ទៈ" },
    { "id": 13466, "word": "សុទ្ទី" },
    { "id": 13467, "word": "សុទ្ធ" },
    { "id": 13468, "word": "សុទ្ធ --" },
    { "id": 13469, "word": "សុទ្ធតែ" },
    { "id": 13470, "word": "សុទ្ធិ" },
    { "id": 13471, "word": "សុទ្ធិ --" },
    { "id": 13472, "word": "សុទ្ធោ --" },
    { "id": 13473, "word": "សុទ្ធោទនៈ" },
    { "id": 13474, "word": "សុទ្ធោទនិ" },
    { "id": 13475, "word": "សុធម្ម" },
    { "id": 13476, "word": "សុធម្មា" },
    { "id": 13477, "word": "សុធម្មាធិបតី" },
    { "id": 13478, "word": "សុធា" },
    { "id": 13479, "word": "សុធា --" },
    { "id": 13480, "word": "សុធី" },
    { "id": 13481, "word": "សុធីរ" },
    { "id": 13482, "word": "ស៊ុន" },
    { "id": 13483, "word": "សុនក" },
    { "id": 13484, "word": "សុនខី" },
    { "id": 13485, "word": "សុនត្រុន" },
    { "id": 13486, "word": "សុនន្ទា" },
    { "id": 13487, "word": "សុនីតិ" },
    { "id": 13488, "word": "សុន្ទរ" },
    { "id": 13489, "word": "សុន្ទរ --" },
    { "id": 13490, "word": "សុន្ទរ៍ទាន" },
    { "id": 13491, "word": "សុន្ទរី" },
    { "id": 13492, "word": "សុន្ទរោ --" },
    { "id": 13493, "word": "ស៊ុប" },
    { "id": 13494, "word": "សុបណ្ណ" },
    { "id": 13495, "word": "ស៊ុបទ្រុប" },
    { "id": 13496, "word": "សុបប្រឡុប" },
    { "id": 13497, "word": "សុបសៅ" },
    { "id": 13498, "word": "សុបិន" },
    { "id": 13499, "word": "សុប្បថ" },
    { "id": 13500, "word": "សុប្រកាស" },
    { "id": 13501, "word": "សុប្បភាត" },
    { "id": 13502, "word": "សុប្រភាព" },
    { "id": 13503, "word": "សុប្រយោគ" },
    { "id": 13504, "word": "សុប្រាត" },
    { "id": 13505, "word": "សុផល" },
    { "id": 13506, "word": "សុពចៈ" },
    { "id": 13507, "word": "សុពច --" },
    { "id": 13508, "word": "សុពណ៌" },
    { "id": 13509, "word": "សុភ" },
    { "id": 13510, "word": "សុភ --" },
    { "id": 13511, "word": "សុភ័គ" },
    { "id": 13512, "word": "សុភរ" },
    { "id": 13513, "word": "សុភា" },
    { "id": 13514, "word": "សុភា --" },
    { "id": 13515, "word": "សុភាចារបុរស" },
    { "id": 13516, "word": "សុភាតុលាការ" },
    { "id": 13517, "word": "សុភាព" },
    { "id": 13518, "word": "សុភាសិត" },
    { "id": 13519, "word": "សុភាសិត --" },
    { "id": 13520, "word": "សុភិក្ខ" },
    { "id": 13521, "word": "សុភោជន" },
    { "id": 13522, "word": "សុភំ" },
    { "id": 13523, "word": "ស៊ុម" },
    { "id": 13524, "word": "ស៊ុមគ្រលុំ" },
    { "id": 13525, "word": "ស៊ុមទ្រុម" },
    { "id": 13526, "word": "សុមនា" },
    { "id": 13527, "word": "សុមាលី" },
    { "id": 13528, "word": "សុមេធ" },
    { "id": 13529, "word": "សុមេធា" },
    { "id": 13530, "word": "សុមេរុ" },
    { "id": 13531, "word": "សុយម៉ុយ" },
    { "id": 13532, "word": "សុយម៉េៈ" },
    { "id": 13533, "word": "សុយាត្រា" },
    { "id": 13534, "word": "សុរ" },
    { "id": 13535, "word": "សុរ --" },
    { "id": 13536, "word": "សុរក្ខា" },
    { "id": 13537, "word": "សុរភី" },
    { "id": 13538, "word": "សុរសភោជន " },
    { "id": 13539, "word": "សុរា" },
    { "id": 13540, "word": "សុរា --" },
    { "id": 13541, "word": "សុរា --" },
    { "id": 13542, "word": "សុរិន្ទ" },
    { "id": 13543, "word": "សុរិន្ទខ្នងភ្នំ" },
    { "id": 13544, "word": "សុរិន្ទាធិបតី" },
    { "id": 13545, "word": "សុរិយ" },
    { "id": 13546, "word": "សុរិយ --" },
    { "id": 13547, "word": "សុរិយង្គ" },
    { "id": 13548, "word": "សុរិយ័ន" },
    { "id": 13549, "word": "សុរិយា" },
    { "id": 13550, "word": "សុរិយា --" },
    { "id": 13551, "word": "សុរិយា ល្ងាចថ្ងៃ" },
    { "id": 13552, "word": "សុរិយេ" },
    { "id": 13553, "word": "សុរិយោ --" },
    { "id": 13554, "word": "សុរិយោដី" },
    { "id": 13555, "word": "សុរិល" },
    { "id": 13556, "word": "សុរូប" },
    { "id": 13557, "word": "សុរេន្ទ្រ" },
    { "id": 13558, "word": "សុល" },
    { "id": 13559, "word": "សុលៗ" },
    { "id": 13560, "word": "សុលក្ខណៈ" },
    { "id": 13561, "word": "ស៊ុលគឃុល" },
    { "id": 13562, "word": "សុលភ" },
    { "id": 13563, "word": "សុលាល័យ" },
    { "id": 13564, "word": "សុល្ក" },
    { "id": 13565, "word": "សុវចៈ" },
    { "id": 13566, "word": "សុវណ្ណ" },
    { "id": 13567, "word": "សុវណ្ណ --" },
    { "id": 13568, "word": "សុវត្ថិ" },
    { "id": 13569, "word": "សុវសនភាព" },
    { "id": 13570, "word": "សុវិចិត្រ" },
    { "id": 13571, "word": "សុវិជ្ជា" },
    { "id": 13572, "word": "សុវោហារ" },
    { "id": 13573, "word": "សុស" },
    { "id": 13574, "word": "សុសយ្យា" },
    { "id": 13575, "word": "សុសាន" },
    { "id": 13576, "word": "សុសិក្សា" },
    { "id": 13577, "word": "សុសេយ្យា" },
    { "id": 13578, "word": "សុស្ម័ន " },
    { "id": 13579, "word": "សុស្មិន" },
    { "id": 13580, "word": "សុហ្ឫទ" },
    { "id": 13581, "word": "សូ" },
    { "id": 13582, "word": "ស៊ូ" },
    { "id": 13583, "word": "សូក" },
    { "id": 13584, "word": "សូករ" },
    { "id": 13585, "word": "សូករន្តកៈ" },
    { "id": 13586, "word": "សូករមទ្ទវៈ" },
    { "id": 13587, "word": "សូករិក" },
    { "id": 13588, "word": "សូញម៉ូញ" },
    { "id": 13589, "word": "សូត" },
    { "id": 13590, "word": "សូត្រ" },
    { "id": 13591, "word": "សូទ" },
    { "id": 13592, "word": "សូទ្រ" },
    { "id": 13593, "word": "សូទ្រនិគម" },
    { "id": 13594, "word": "សូទ្រា" },
    { "id": 13595, "word": "ស៊ូទ្រូ" },
    { "id": 13596, "word": "សូធ្យ" },
    { "id": 13597, "word": "សូន" },
    { "id": 13598, "word": "សូន្យ" },
    { "id": 13599, "word": "សូប" },
    { "id": 13600, "word": "ស៊ូប៉ទ្រូ" },
    { "id": 13601, "word": "សូម" },
    { "id": 13602, "word": "សូមក្រាប បង្គំទូល" },
    { "id": 13603, "word": "សូរ" },
    { "id": 13604, "word": "សូរង" },
    { "id": 13605, "word": "សូរ្យ" },
    { "id": 13606, "word": "សូរ្យ --" },
    { "id": 13607, "word": "សូរ្យកាន្ត" },
    { "id": 13608, "word": "សូរេច" },
    { "id": 13609, "word": "សូល" },
    { "id": 13610, "word": "សូលី" },
    { "id": 13611, "word": "សូវ" },
    { "id": 13612, "word": "សូវៗ" },
    { "id": 13613, "word": "សួ" },
    { "id": 13614, "word": "សួង" },
    { "id": 13615, "word": "សួត" },
    { "id": 13616, "word": "សួន" },
    { "id": 13617, "word": "សួយ" },
    { "id": 13618, "word": "សួរ" },
    { "id": 13619, "word": "សួគ៌" },
    { "id": 13620, "word": "សួគ៌ា" },
    { "id": 13621, "word": "សួស្តិ៍" },
    { "id": 13622, "word": "សួស្ដី" },
    { "id": 13623, "word": "សើ" },
    { "id": 13624, "word": "សើក" },
    { "id": 13625, "word": "ស៊ើកៗ" },
    { "id": 13626, "word": "សើកត្រើក" },
    { "id": 13627, "word": "សើកប៉ប្រើក" },
    { "id": 13628, "word": "សើកប៉ប្លើក" },
    { "id": 13629, "word": "ស៊ើកពពើក" },
    { "id": 13630, "word": "ស៊ើកពភ្លើក" },
    { "id": 13631, "word": "ស៊ើកមមើក" },
    { "id": 13632, "word": "ស៊ើងទ្រើង" },
    { "id": 13633, "word": "សើងមម៉ើង" },
    { "id": 13634, "word": "ស៊ើងមើង" },
    { "id": 13635, "word": "សើច" },
    { "id": 13636, "word": "សើន" },
    { "id": 13637, "word": "ស៊ើប" },
    { "id": 13638, "word": "សើម" },
    { "id": 13639, "word": "ស៊ើមគគ្រើម" },
    { "id": 13640, "word": "សើយ" },
    { "id": 13641, "word": "សើរើ" },
    { "id": 13642, "word": "សើវ៉ើ" },
    { "id": 13643, "word": "ស៊ើស គ្រមើស" },
    { "id": 13644, "word": "សឿង" },
    { "id": 13645, "word": "សៀ" },
    { "id": 13646, "word": "សៀង" },
    { "id": 13647, "word": "សៀត" },
    { "id": 13648, "word": "សៀតផ្កា" },
    { "id": 13649, "word": "សៀធី" },
    { "id": 13650, "word": "សៀន" },
    { "id": 13651, "word": "សៀនមមៀន" },
    { "id": 13652, "word": "សៀប្រៀប" },
    { "id": 13653, "word": "សៀម" },
    { "id": 13654, "word": "សៀមប្រៀម" },
    { "id": 13655, "word": "សៀមរាប" },
    { "id": 13656, "word": "សៀរ" },
    { "id": 13657, "word": "សៀវ" },
    { "id": 13658, "word": "សៀវភៅ" },
    { "id": 13659, "word": "សេ" },
    { "id": 13660, "word": "សេក" },
    { "id": 13661, "word": "សេកកិច្ច" },
    { "id": 13662, "word": "សេក្ខ" },
    { "id": 13663, "word": "សេង" },
    { "id": 13664, "word": "សេចក្ដី" },
    { "id": 13665, "word": "សេចក្ដាំ" },
    { "id": 13666, "word": "សេចគ្រេច" },
    { "id": 13667, "word": "សេចនកិច្ច" },
    { "id": 13668, "word": "សេញ" },
    { "id": 13669, "word": "សេដ្ឋ" },
    { "id": 13670, "word": "សេដ្ឋ--" },
    { "id": 13671, "word": "សេដ្ឋិនី" },
    { "id": 13672, "word": "សេដ្ឋី" },
    { "id": 13673, "word": "សេដ្ឋោ" },
    { "id": 13674, "word": "សេណី" },
    { "id": 13675, "word": "សេត" },
    { "id": 13676, "word": "សេត --" },
    { "id": 13677, "word": "សេតម្ពរ" },
    { "id": 13678, "word": "សេតបណ្ណ" },
    { "id": 13679, "word": "សេទៈ" },
    { "id": 13680, "word": "សេទជ" },
    { "id": 13681, "word": "សេទោ" },
    { "id": 13682, "word": "សេន" },
    { "id": 13683, "word": "សេនបទ" },
    { "id": 13684, "word": "សេនា" },
    { "id": 13685, "word": "សេនា--" },
    { "id": 13686, "word": "សេនាសនៈ" },
    { "id": 13687, "word": "សេនាសន --" },
    { "id": 13688, "word": "សេនីយ៍" },
    { "id": 13689, "word": "សេន្ត" },
    { "id": 13690, "word": "សេផាលិកា" },
    { "id": 13691, "word": "សេព" },
    { "id": 13692, "word": "សេម្ហៈ" },
    { "id": 13693, "word": "សេយ្យា " },
    { "id": 13694, "word": "សេយ្យាសន៍" },
    { "id": 13695, "word": "សេរ" },
    { "id": 13696, "word": "សេរ" },
    { "id": 13697, "word": "សេរមាន់" },
    { "id": 13698, "word": "សេរិនី" },
    { "id": 13699, "word": "សេរី" },
    { "id": 13700, "word": "សេល" },
    { "id": 13701, "word": "សេល--" },
    { "id": 13702, "word": "សេវ" },
    { "id": 13703, "word": "សេវកៈ" },
    { "id": 13704, "word": "សេវក--" },
    { "id": 13705, "word": "សេវនៈ" },
    { "id": 13706, "word": "សេវាល" },
    { "id": 13707, "word": "សេវិកា" },
    { "id": 13708, "word": "សេស" },
    { "id": 13709, "word": "សេសវគ្គ" },
    { "id": 13710, "word": "សេសា" },
    { "id": 13711, "word": "សេសំ" },
    { "id": 13712, "word": "សេះ" },
    { "id": 13713, "word": "សេះពាក់បង្កង់" },
    { "id": 13714, "word": "សែ" },
    { "id": 13715, "word": "ស៊ែ" },
    { "id": 13716, "word": "សែក" },
    { "id": 13717, "word": "សែង" },
    { "id": 13718, "word": "សែងព្រះអាទិត្យ" },
    { "id": 13719, "word": "សែដា" },
    { "id": 13720, "word": "សែត" },
    { "id": 13721, "word": "សែតអញ្ជង់" },
    { "id": 13722, "word": "សែន" },
    { "id": 13723, "word": "សែនត្វ័ន" },
    { "id": 13724, "word": "សែនទ្វី" },
    { "id": 13725, "word": "សែនបទ" },
    { "id": 13726, "word": "សែន្យ" },
    { "id": 13727, "word": "ស៊ែម" },
    { "id": 13728, "word": "ស៊ែស គ្រមែស" },
    { "id": 13729, "word": "សែសិប" },
    { "id": 13730, "word": "ស៊ែះពភ្លែះ" },
    { "id": 13731, "word": "សៃមម៉ៃ" },
    { "id": 13732, "word": "សៃយ" },
    { "id": 13733, "word": "សៃយា" },
    { "id": 13734, "word": "សៃយាសន៍" },
    { "id": 13735, "word": "សៃយ៉ឺន" },
    { "id": 13736, "word": "សោ" },
    { "id": 13737, "word": "សោក" },
    { "id": 13738, "word": "សោកគ្រោក" },
    { "id": 13739, "word": "សោកត្រោក" },
    { "id": 13740, "word": "សោក័ន្ត" },
    { "id": 13741, "word": "សោកប៉ត្រោក" },
    { "id": 13742, "word": "សោកមម៉ោក" },
    { "id": 13743, "word": "សោកា" },
    { "id": 13744, "word": "សោកាន្ត" },
    { "id": 13745, "word": "សោកិនី" },
    { "id": 13746, "word": "សោកី" },
    { "id": 13747, "word": "សោកៀ" },
    { "id": 13748, "word": "សោគន្ធិកៈ" },
    { "id": 13749, "word": "សោគន្ធិកា" },
    { "id": 13750, "word": "សោគ្រោក" },
    { "id": 13751, "word": "ស៊ោង អំពោង" },
    { "id": 13752, "word": "សោច" },
    { "id": 13753, "word": "សោដា" },
    { "id": 13754, "word": "សោត" },
    { "id": 13755, "word": "សោត" },
    { "id": 13756, "word": "សោតា" },
    { "id": 13757, "word": "សោត្រោ" },
    { "id": 13758, "word": "សោត្ថិភាព" },
    { "id": 13759, "word": "សោទក" },
    { "id": 13760, "word": "សោទកបាយាស" },
    { "id": 13761, "word": "សោទរ" },
    { "id": 13762, "word": "សោទរា" },
    { "id": 13763, "word": "សោធន" },
    { "id": 13764, "word": "សោធនី" },
    { "id": 13765, "word": "សោប៉ត្រោ" },
    { "id": 13766, "word": "សោបាន" },
    { "id": 13767, "word": "សោភគ្គ" },
    { "id": 13768, "word": "សោភ័ណ" },
    { "id": 13769, "word": "សោភា" },
    { "id": 13770, "word": "សោភិនី" },
    { "id": 13771, "word": "សោម" },
    { "id": 13772, "word": "សោមគ្រោះ" },
    { "id": 13773, "word": "សោមនស្ស" },
    { "id": 13774, "word": "សោមពារ" },
    { "id": 13775, "word": "សោមលតា" },
    { "id": 13776, "word": "សោមវល្លិ" },
    { "id": 13777, "word": "សោមវារៈ" },
    { "id": 13778, "word": "សោមាន" },
    { "id": 13779, "word": "សោយ" },
    { "id": 13780, "word": "សោរពារ" },
    { "id": 13781, "word": "សោវណ្ណ" },
    { "id": 13782, "word": "សោវណ្ណម័យ" },
    { "id": 13783, "word": "សោសិ" },
    { "id": 13784, "word": "សោហ៊ុយ" },
    { "id": 13785, "word": "សោឡស" },
    { "id": 13786, "word": "សោះ" },
    { "id": 13787, "word": "សោះសា" },
    { "id": 13788, "word": "សោះអង្គើយ" },
    { "id": 13789, "word": "សៅ" },
    { "id": 13790, "word": "សៅកែ" },
    { "id": 13791, "word": "សៅគន្ធ" },
    { "id": 13792, "word": "សៅជៃ" },
    { "id": 13793, "word": "សៅដៅ" },
    { "id": 13794, "word": "សៅភាគ្យ" },
    { "id": 13795, "word": "សៅម៉ង" },
    { "id": 13796, "word": "សៅរ៍" },
    { "id": 13797, "word": "សៅរ័ភ" },
    { "id": 13798, "word": "សៅរភា" },
    { "id": 13799, "word": "សៅរសេនី" },
    { "id": 13800, "word": "សៅវគន្ធ" },
    { "id": 13801, "word": "សៅវតារ" },
    { "id": 13802, "word": "សៅវនីយ៍" },
    { "id": 13803, "word": "សៅវភា" },
    { "id": 13804, "word": "សៅវភាគ្យ" },
    { "id": 13805, "word": "សៅវលក្សណ៍" },
    { "id": 13806, "word": "សៅសោក" },
    { "id": 13807, "word": "សៅហ្មង" },
    { "id": 13808, "word": "សៅហ្ឫទ" },
    { "id": 13809, "word": "សៅឡឹក" },
    { "id": 13810, "word": "សុំ" },
    { "id": 13811, "word": "សំ" },
    { "id": 13812, "word": "សំកក" },
    { "id": 13813, "word": "សំកាក" },
    { "id": 13814, "word": "សំកុក" },
    { "id": 13815, "word": "សំកុង" },
    { "id": 13816, "word": "សំកុល" },
    { "id": 13817, "word": "សំកូញ" },
    { "id": 13818, "word": "សំកូវ" },
    { "id": 13819, "word": "សំកេក" },
    { "id": 13820, "word": "សំកោក" },
    { "id": 13821, "word": "សំកាំង" },
    { "id": 13822, "word": "សំខាន់" },
    { "id": 13823, "word": "សំខ្យា" },
    { "id": 13824, "word": "សំខ្យានុគ្រោះ" },
    { "id": 13825, "word": "សំគម" },
    { "id": 13826, "word": "សំគាល់" },
    { "id": 13827, "word": "សំគិស" },
    { "id": 13828, "word": "សំគីម" },
    { "id": 13829, "word": "សំគុល" },
    { "id": 13830, "word": "សំគែម" },
    { "id": 13831, "word": "សំគោក" },
    { "id": 13832, "word": "សំគាំង" },
    { "id": 13833, "word": "សំងាច" },
    { "id": 13834, "word": "សំងាត់" },
    { "id": 13835, "word": "សំងើច" },
    { "id": 13836, "word": "សំងំ" },
    { "id": 13837, "word": "សំចត" },
    { "id": 13838, "word": "សំច័យ" },
    { "id": 13839, "word": "សំចែ" },
    { "id": 13840, "word": "សំចៃ" },
    { "id": 13841, "word": "សំញៅ" },
    { "id": 13842, "word": "សំដិល" },
    { "id": 13843, "word": "សំដី" },
    { "id": 13844, "word": "សំដឹង" },
    { "id": 13845, "word": "សំដឺត" },
    { "id": 13846, "word": "សំដើង" },
    { "id": 13847, "word": "សំដែង" },
    { "id": 13848, "word": "សំដោះ " },
    { "id": 13849, "word": "សំដៅ" },
    { "id": 13850, "word": "សំណ" },
    { "id": 13851, "word": "សំណក" },
    { "id": 13852, "word": "សំណង" },
    { "id": 13853, "word": "សំណង់" },
    { "id": 13854, "word": "សំណព្វ" },
    { "id": 13855, "word": "សំណល់" },
    { "id": 13856, "word": "សំណាក" },
    { "id": 13857, "word": "សំណាក់" },
    { "id": 13858, "word": "សំណាង" },
    { "id": 13859, "word": "សំណាញ" },
    { "id": 13860, "word": "សំណាញ់" },
    { "id": 13861, "word": "សំណាញ់ញាណ" },
    { "id": 13862, "word": "សំណាដៃ" },
    { "id": 13863, "word": "សំណាត់" },
    { "id": 13864, "word": "សំណាប" },
    { "id": 13865, "word": "សំណាម" },
    { "id": 13866, "word": "សំណិង" },
    { "id": 13867, "word": "សំណឹក" },
    { "id": 13868, "word": "សំណុស" },
    { "id": 13869, "word": "សំណុះ" },
    { "id": 13870, "word": "សំណូក" },
    { "id": 13871, "word": "សំណូម" },
    { "id": 13872, "word": "សំណួរ" },
    { "id": 13873, "word": "សំណើច" },
    { "id": 13874, "word": "សំណើម" },
    { "id": 13875, "word": "សំណើ" },
    { "id": 13876, "word": "សំណេះ" },
    { "id": 13877, "word": "សំណេះសំណាល" },
    { "id": 13878, "word": "សំណែន" },
    { "id": 13879, "word": "សំណែព" },
    { "id": 13880, "word": "សំណែស" },
    { "id": 13881, "word": "សំណោក" },
    { "id": 13882, "word": "សំណៅ" },
    { "id": 13883, "word": "សំណុំ" },
    { "id": 13884, "word": "សំណំ" },
    { "id": 13885, "word": "សំតត" },
    { "id": 13886, "word": "សំតុល" },
    { "id": 13887, "word": "សំតេត" },
    { "id": 13888, "word": "សំតែក" },
    { "id": 13889, "word": "សំតោក" },
    { "id": 13890, "word": "សំទក់" },
    { "id": 13891, "word": "សំទង់" },
    { "id": 13892, "word": "សំទល" },
    { "id": 13893, "word": "សំទាញ" },
    { "id": 13894, "word": "សំទារ" },
    { "id": 13895, "word": "សំទីក" },
    { "id": 13896, "word": "សំទុះ" },
    { "id": 13897, "word": "សំទុះក្អែក" },
    { "id": 13898, "word": "សំទូង" },
    { "id": 13899, "word": "សំទើញ" },
    { "id": 13900, "word": "សំទេះ" },
    { "id": 13901, "word": "សំទែល" },
    { "id": 13902, "word": "សំទែះ" },
    { "id": 13903, "word": "សំនឹក" },
    { "id": 13904, "word": "សំនួន" },
    { "id": 13905, "word": "សំនៀង" },
    { "id": 13906, "word": "សំបក" },
    { "id": 13907, "word": "សំបថ" },
    { "id": 13908, "word": "សំបា" },
    { "id": 13909, "word": "សំបាច់" },
    { "id": 13910, "word": "សំប៉ាត" },
    { "id": 13911, "word": "សំប៉ាន" },
    { "id": 13912, "word": "សំបារ" },
    { "id": 13913, "word": "សំបុក" },
    { "id": 13914, "word": "សំបុកចាប" },
    { "id": 13915, "word": "សំបុកទ្រយុក" },
    { "id": 13916, "word": "សំបុដ" },
    { "id": 13917, "word": "សំបុត្រ" },
    { "id": 13918, "word": "សំបូងសង្រូង" },
    { "id": 13919, "word": "សំបួរ" },
    { "id": 13920, "word": "សំបួរកក់" },
    { "id": 13921, "word": "សំបែង" },
    { "id": 13922, "word": "សំប៉ែត" },
    { "id": 13923, "word": "សំបោរ" },
    { "id": 13924, "word": "សំផិង" },
    { "id": 13925, "word": "សំផុល្ល" },
    { "id": 13926, "word": "សំពង" },
    { "id": 13927, "word": "សំពង់" },
    { "id": 13928, "word": "សំពត់" },
    { "id": 13929, "word": "សំព័រ" },
    { "id": 13930, "word": "សំពាយ" },
    { "id": 13931, "word": "សំពិន" },
    { "id": 13932, "word": "សំពីង" },
    { "id": 13933, "word": "សំពឹក" },
    { "id": 13934, "word": "សំពុង" },
    { "id": 13935, "word": "សំពូ" },
    { "id": 13936, "word": "សំពៀត" },
    { "id": 13937, "word": "សំពេះ" },
    { "id": 13938, "word": "សំពែះ" },
    { "id": 13939, "word": "សំពោង" },
    { "id": 13940, "word": "សំពោច" },
    { "id": 13941, "word": "សំពៅ" },
    { "id": 13942, "word": "សំពៅថយ" },
    { "id": 13943, "word": "សំពះ" },
    { "id": 13944, "word": "សំព្រុស" },
    { "id": 13945, "word": "សំព្រោ" },
    { "id": 13946, "word": "សំភី" },
    { "id": 13947, "word": "សំភោរ" },
    { "id": 13948, "word": "សំយាក" },
    { "id": 13949, "word": "សំយាប" },
    { "id": 13950, "word": "សំយាយ" },
    { "id": 13951, "word": "សំយុង" },
    { "id": 13952, "word": "សំយេះ" },
    { "id": 13953, "word": "សំយោគ" },
    { "id": 13954, "word": "សំយោគសញ្ញា" },
    { "id": 13955, "word": "សំយោជនៈ" },
    { "id": 13956, "word": "សំរង" },
    { "id": 13957, "word": "សំរាជ" },
    { "id": 13958, "word": "សំរាម" },
    { "id": 13959, "word": "សំរឹទ្ធ" },
    { "id": 13960, "word": "សំរឹទ្ធិ--" },
    { "id": 13961, "word": "សំរឹទ្ធី" },
    { "id": 13962, "word": "សំរុង" },
    { "id": 13963, "word": "សំរូប" },
    { "id": 13964, "word": "សំរៀម" },
    { "id": 13965, "word": "សំរែ" },
    { "id": 13966, "word": "សំរោង" },
    { "id": 13967, "word": "សំឫទ្ធ" },
    { "id": 13968, "word": "សំឫទ្ធី" },
    { "id": 13969, "word": "សំលៀង" },
    { "id": 13970, "word": "សំវរ" },
    { "id": 13971, "word": "សំវរី" },
    { "id": 13972, "word": "សំវាស" },
    { "id": 13973, "word": "សំវាសនាសនា" },
    { "id": 13974, "word": "សំវេគ" },
    { "id": 13975, "word": "សំវេជនីយ" },
    { "id": 13976, "word": "សំសន្ទនា" },
    { "id": 13977, "word": "សំសយត្ថនិបាត" },
    { "id": 13978, "word": "សំសយត្ថវាចក" },
    { "id": 13979, "word": "សំសារៈ" },
    { "id": 13980, "word": "សំសារ" },
    { "id": 13981, "word": "សំសេទជ" },
    { "id": 13982, "word": "សំសែ" },
    { "id": 13983, "word": "សំស្ការ" },
    { "id": 13984, "word": "សំស្ក្រឹត" },
    { "id": 13985, "word": "សំហារិម" },
    { "id": 13986, "word": "សំឡាញ" },
    { "id": 13987, "word": "សំឡី" },
    { "id": 13988, "word": "សំឡេង" },
    { "id": 13989, "word": "សំឡេះ" },
    { "id": 13990, "word": "សំឡែះ" },
    { "id": 13991, "word": "សំអក" },
    { "id": 13992, "word": "សំអប់" },
    { "id": 13993, "word": "សំអប់ពុត" },
    { "id": 13994, "word": "សំអាង" },
    { "id": 13995, "word": "សំអាត" },
    { "id": 13996, "word": "សំអិត" },
    { "id": 13997, "word": "សំអុយ" },
    { "id": 13998, "word": "សំអុះ" },
    { "id": 13999, "word": "សំអេក" },
    { "id": 14000, "word": "សំអែក" },
    { "id": 14001, "word": "សំអែល" },
    { "id": 14002, "word": "សំអោក" },
    { "id": 14003, "word": "សាំ" },
    { "id": 14004, "word": "ស៊ាំ" },
    { "id": 14005, "word": "សាំង" },
    { "id": 14006, "word": "សាំង្កសី" },
    { "id": 14007, "word": "សាំញ៉ាំ" },
    { "id": 14008, "word": "សាំដែល" },
    { "id": 14009, "word": "សាំទាំ" },
    { "id": 14010, "word": "សាំប៉ៃសាំម៉ា" },
    { "id": 14011, "word": "សាំមណោគ្រួ" },
    { "id": 14012, "word": "ស៊ាំស៊ន" },
    { "id": 14013, "word": "សះ" },
    { "id": 14014, "word": "ស្កក" },
    { "id": 14015, "word": "ស្កន្ទ" },
    { "id": 14016, "word": "ស្កន្ធ" },
    { "id": 14017, "word": "ស្កន្ធាពារ" },
    { "id": 14018, "word": "ស្កប់" },
    { "id": 14019, "word": "ស្ករ" },
    { "id": 14020, "word": "ស្កល់" },
    { "id": 14021, "word": "ស្កា" },
    { "id": 14022, "word": "ស្កាក" },
    { "id": 14023, "word": "ស្កាញ" },
    { "id": 14024, "word": "ស្កាត" },
    { "id": 14025, "word": "ស្កាត់" },
    { "id": 14026, "word": "ស្ការ" },
    { "id": 14027, "word": "ស្កាល" },
    { "id": 14028, "word": "ស្កិល" },
    { "id": 14029, "word": "ស្កឹមស្កៃ" },
    { "id": 14030, "word": "ស្កុង" },
    { "id": 14031, "word": "ស្កុន" },
    { "id": 14032, "word": "ស្កុយ" },
    { "id": 14033, "word": "ស្កុល" },
    { "id": 14034, "word": "ស្កូញ" },
    { "id": 14035, "word": "ស្កូវ" },
    { "id": 14036, "word": "ស្កូវលលក" },
    { "id": 14037, "word": "ស្កួយ" },
    { "id": 14038, "word": "ស្កើក" },
    { "id": 14039, "word": "ស្កៀប" },
    { "id": 14040, "word": "ស្កាំ" },
    { "id": 14041, "word": "ស្កះ" },
    { "id": 14042, "word": "ស្គន់" },
    { "id": 14043, "word": "ស្គន់ទំនប់" },
    { "id": 14044, "word": "ស្គម" },
    { "id": 14045, "word": "ស្គរ" },
    { "id": 14046, "word": "ស្គា" },
    { "id": 14047, "word": "ស្គាក់" },
    { "id": 14048, "word": "ស្គាយ" },
    { "id": 14049, "word": "ស្គារ" },
    { "id": 14050, "word": "ស្គាល់" },
    { "id": 14051, "word": "ស្គឹះ" },
    { "id": 14052, "word": "ស្គឺ" },
    { "id": 14053, "word": "ស្គុយ" },
    { "id": 14054, "word": "ស្គុល" },
    { "id": 14055, "word": "ស្គុស" },
    { "id": 14056, "word": "ស្គុះ" },
    { "id": 14057, "word": "ស្គួយ" },
    { "id": 14058, "word": "ស្គោក" },
    { "id": 14059, "word": "ស្គាំង" },
    { "id": 14060, "word": "ស្ងប់" },
    { "id": 14061, "word": "ស្ងាច" },
    { "id": 14062, "word": "ស្ងាត់" },
    { "id": 14063, "word": "ស្ងាប" },
    { "id": 14064, "word": "ស្ងួត" },
    { "id": 14065, "word": "ស្ងួន" },
    { "id": 14066, "word": "ស្ងើក" },
    { "id": 14067, "word": "ស្ងើច" },
    { "id": 14068, "word": "ស្ងើន" },
    { "id": 14069, "word": "ស្ងៀម" },
    { "id": 14070, "word": "ស្ងោរ" },
    { "id": 14071, "word": "ស្ញក់" },
    { "id": 14072, "word": "ស្ញប់" },
    { "id": 14073, "word": "ស្ញាញ" },
    { "id": 14074, "word": "ស្ញាញទ្រា" },
    { "id": 14075, "word": "ស្ញិញ" },
    { "id": 14076, "word": "ស្ញុក" },
    { "id": 14077, "word": "ស្ញុកស្ញូវ" },
    { "id": 14078, "word": "ស្ញុរ" },
    { "id": 14079, "word": "ស្ញូញ" },
    { "id": 14080, "word": "ស្ញើប" },
    { "id": 14081, "word": "ស្ញេញ" },
    { "id": 14082, "word": "ស្ញែ" },
    { "id": 14083, "word": "ស្ញែង" },
    { "id": 14084, "word": "ស្ញោរ" },
    { "id": 14085, "word": "ស្ដ" },
    { "id": 14086, "word": "ស្ដន" },
    { "id": 14087, "word": "ស្ដម្ភ" },
    { "id": 14088, "word": "ស្ដាប់" },
    { "id": 14089, "word": "ស្ដាយ" },
    { "id": 14090, "word": "ស្ដារ" },
    { "id": 14091, "word": "ស្ដី" },
    { "id": 14092, "word": "ស្ដឹង" },
    { "id": 14093, "word": "ស្ដឺត" },
    { "id": 14094, "word": "ស្ដុក" },
    { "id": 14095, "word": "ស្ដុកស្ដុរ" },
    { "id": 14096, "word": "ស្ដូក" },
    { "id": 14097, "word": "ស្ដួច" },
    { "id": 14098, "word": "ស្ដើង" },
    { "id": 14099, "word": "ស្ដៀង" },
    { "id": 14100, "word": "ស្ដៀន" },
    { "id": 14101, "word": "ស្ដេច" },
    { "id": 14102, "word": "ស្ដេចចង់" },
    { "id": 14103, "word": "ស្ដេចដើរ" },
    { "id": 14104, "word": "ស្ដេចត្រាញ់" },
    { "id": 14105, "word": "ស្ដេចផ្ទំ" },
    { "id": 14106, "word": "ស្ដែង" },
    { "id": 14107, "word": "ស្ដោះ" },
    { "id": 14108, "word": "ស្ដៅ" },
    { "id": 14109, "word": "ស្ដាំ" },
    { "id": 14110, "word": "ស្តត" },
    { "id": 14111, "word": "ស្តនិកសត្វ" },
    { "id": 14112, "word": "ស្តា" },
    { "id": 14113, "word": "ស្តឹក" },
    { "id": 14114, "word": "ស្តុក" },
    { "id": 14115, "word": "ស្តុតិ" },
    { "id": 14116, "word": "ស្តុតិ--" },
    { "id": 14117, "word": "ស្តុល" },
    { "id": 14118, "word": "ស្តូប" },
    { "id": 14119, "word": "ស្តូបៈ" },
    { "id": 14120, "word": "ស្តេត" },
    { "id": 14121, "word": "ស្តែក" },
    { "id": 14122, "word": "ស្តែត" },
    { "id": 14123, "word": "ស្តោ" },
    { "id": 14124, "word": "ស្តោក" },
    { "id": 14125, "word": "ស្តោមនាការ" },
    { "id": 14126, "word": "ស្ត្រី" },
    { "id": 14127, "word": "ស្ត្រី --" },
    { "id": 14128, "word": "ស្ថវិរៈ" },
    { "id": 14129, "word": "ស្ថាន" },
    { "id": 14130, "word": "ស្ថានីយ" },
    { "id": 14131, "word": "ស្ថាបនៈ" },
    { "id": 14132, "word": "ស្ថាបនកម្ម" },
    { "id": 14133, "word": "ស្ថាបនិក" },
    { "id": 14134, "word": "ស្ថាបនិកា" },
    { "id": 14135, "word": "ស្ថាពរ" },
    { "id": 14136, "word": "ស្ថាវរ --" },
    { "id": 14137, "word": "ស្ថិត" },
    { "id": 14138, "word": "ស្ថិតិ" },
    { "id": 14139, "word": "ស្ថិតិ --" },
    { "id": 14140, "word": "ស្ថិរ" },
    { "id": 14141, "word": "ស្ទក់" },
    { "id": 14142, "word": "ស្ទង" },
    { "id": 14143, "word": "ស្ទង់" },
    { "id": 14144, "word": "ស្ទន់" },
    { "id": 14145, "word": "ស្ទប" },
    { "id": 14146, "word": "ស្ទប់" },
    { "id": 14147, "word": "ស្ទល" },
    { "id": 14148, "word": "ស្ទល់" },
    { "id": 14149, "word": "ស្ទា" },
    { "id": 14150, "word": "ស្ទាក់" },
    { "id": 14151, "word": "ស្ទាក់ស្ទើរ" },
    { "id": 14152, "word": "ស្ទាញ" },
    { "id": 14153, "word": "ស្ទាត់" },
    { "id": 14154, "word": "ស្ទាប" },
    { "id": 14155, "word": "ស្ទាល់" },
    { "id": 14156, "word": "ស្ទាវ" },
    { "id": 14157, "word": "ស្ទិល" },
    { "id": 14158, "word": "ស្ទីក" },
    { "id": 14159, "word": "ស្ទឹង" },
    { "id": 14160, "word": "ស្ទឹម" },
    { "id": 14161, "word": "ស្ទឹល" },
    { "id": 14162, "word": "ស្ទុង" },
    { "id": 14163, "word": "ស្ទុយ" },
    { "id": 14164, "word": "ស្ទុលៗ" },
    { "id": 14165, "word": "ស្ទុះ" },
    { "id": 14166, "word": "ស្ទូង" },
    { "id": 14167, "word": "ស្ទូច" },
    { "id": 14168, "word": "ស្ទូរ" },
    { "id": 14169, "word": "ស្ទួន" },
    { "id": 14170, "word": "ស្ទួយ" },
    { "id": 14171, "word": "ស្ទើង" },
    { "id": 14172, "word": "ស្ទើញ" },
    { "id": 14173, "word": "ស្ទើត" },
    { "id": 14174, "word": "ស្ទើរ" },
    { "id": 14175, "word": "ស្ទើរកោះ" },
    { "id": 14176, "word": "ស្ទើរកំណើត" },
    { "id": 14177, "word": "ស្ទៀង" },
    { "id": 14178, "word": "ស្ទេង" },
    { "id": 14179, "word": "ស្ទេញ" },
    { "id": 14180, "word": "ស្ទេះ" },
    { "id": 14181, "word": "ស្ទែ" },
    { "id": 14182, "word": "ស្ទែត" },
    { "id": 14183, "word": "ស្ទែល" },
    { "id": 14184, "word": "ស្ទែះ" },
    { "id": 14185, "word": "ស្ទៃ" },
    { "id": 14186, "word": "ស្ទោក" },
    { "id": 14187, "word": "ស្ទោង" },
    { "id": 14188, "word": "ស្ទោះ" },
    { "id": 14189, "word": "ស្ទំ" },
    { "id": 14190, "word": "ស្ទាំង" },
    { "id": 14191, "word": "ស្ទាំងហើរ" },
    { "id": 14192, "word": "ស្ទះ" },
    { "id": 14193, "word": "ស្ន" },
    { "id": 14194, "word": "ស្នង" },
    { "id": 14195, "word": "ស្នប" },
    { "id": 14196, "word": "ស្នប់" },
    { "id": 14197, "word": "ស្នល" },
    { "id": 14198, "word": "ស្នា" },
    { "id": 14199, "word": "ស្នាច" },
    { "id": 14200, "word": "ស្នាដៃ" },
    { "id": 14201, "word": "ស្នាតក" },
    { "id": 14202, "word": "ស្នាន" },
    { "id": 14203, "word": "ស្នានីយ" },
    { "id": 14204, "word": "ស្នាប" },
    { "id": 14205, "word": "ស្នាប់" },
    { "id": 14206, "word": "ស្នាប់ --" },
    { "id": 14207, "word": "ស្នាបក" },
    { "id": 14208, "word": "ស្នាប់មុខ" },
    { "id": 14209, "word": "ស្នាម" },
    { "id": 14210, "word": "ស្នាមភ្លោះ" },
    { "id": 14211, "word": "ស្នាយ" },
    { "id": 14212, "word": "ស្នាយដែល" },
    { "id": 14213, "word": "ស្នាយុ" },
    { "id": 14214, "word": "ស្នាល" },
    { "id": 14215, "word": "ស្និត" },
    { "id": 14216, "word": "ស្និទ្ធ" },
    { "id": 14217, "word": "ស្និទ្ធ --" },
    { "id": 14218, "word": "ស្និទ្ធស្នាល" },
    { "id": 14219, "word": "ស្និម" },
    { "id": 14220, "word": "ស្នឹង" },
    { "id": 14221, "word": "ស្នូក" },
    { "id": 14222, "word": "ស្នូរ" },
    { "id": 14223, "word": "ស្នូល" },
    { "id": 14224, "word": "ស្នួ" },
    { "id": 14225, "word": "ស្នួល" },
    { "id": 14226, "word": "ស្នើ" },
    { "id": 14227, "word": "ស្នៀត" },
    { "id": 14228, "word": "ស្នេហ៍" },
    { "id": 14229, "word": "ស្នេហា" },
    { "id": 14230, "word": "ស្នេហ៍ហឺត" },
    { "id": 14231, "word": "ស្នេហ៍ហៃ" },
    { "id": 14232, "word": "ស្នែង" },
    { "id": 14233, "word": "ស្នែងទន្សោង" },
    { "id": 14234, "word": "ស្នែងពពែ" },
    { "id": 14235, "word": "ស្នោ" },
    { "id": 14236, "word": "ស្នោទក" },
    { "id": 14237, "word": "ស្នុំ" },
    { "id": 14238, "word": "ស្នំ" },
    { "id": 14239, "word": "ស្បង់" },
    { "id": 14240, "word": "ស្បង្ក័ជ" },
    { "id": 14241, "word": "ស្បថ" },
    { "id": 14242, "word": "ស្ប័ស្ដ" },
    { "id": 14243, "word": "ស្បាត" },
    { "id": 14244, "word": "ស្បាត់" },
    { "id": 14245, "word": "ស្បាន់" },
    { "id": 14246, "word": "ស្បិត" },
    { "id": 14247, "word": "ស្បិតរឹត" },
    { "id": 14248, "word": "ស្បឺត" },
    { "id": 14249, "word": "ស្បុរ" },
    { "id": 14250, "word": "ស្បូន" },
    { "id": 14251, "word": "ស្បូវ" },
    { "id": 14252, "word": "ស្បើម" },
    { "id": 14253, "word": "ស្បើយ" },
    { "id": 14254, "word": "ស្បៀង" },
    { "id": 14255, "word": "ស្បេត" },
    { "id": 14256, "word": "ស្បែ" },
    { "id": 14257, "word": "ស្បែក" },
    { "id": 14258, "word": "ស្បែកជើង" },
    { "id": 14259, "word": "ស្បែង" },
    { "id": 14260, "word": "ស្បែប" },
    { "id": 14261, "word": "ស្បៃ" },
    { "id": 14262, "word": "ស្បៃរឿង" },
    { "id": 14263, "word": "ស្បៃរោយ" },
    { "id": 14264, "word": "ស្បោង" },
    { "id": 14265, "word": "ស្ប៉ត" },
    { "id": 14266, "word": "ស្ប៉ឹម" },
    { "id": 14267, "word": "ស្ប៉ុរ" },
    { "id": 14268, "word": "ស្ប៉ែត" },
    { "id": 14269, "word": "ស្ពក" },
    { "id": 14270, "word": "ស្ពង់" },
    { "id": 14271, "word": "ស្ពាន" },
    { "id": 14272, "word": "ស្ពាន់" },
    { "id": 14273, "word": "ស្ពាន់ក្រាប" },
    { "id": 14274, "word": "ស្ពាន់ធ័រ" },
    { "id": 14275, "word": "ស្ពានមេត្រី" },
    { "id": 14276, "word": "ស្ពាយ" },
    { "id": 14277, "word": "ស្ពាយឆៀង" },
    { "id": 14278, "word": "ស្ពាយលៀង" },
    { "id": 14279, "word": "ស្ពីង" },
    { "id": 14280, "word": "ស្ពឹក" },
    { "id": 14281, "word": "ស្ពឹង" },
    { "id": 14282, "word": "ស្ពឺ" },
    { "id": 14283, "word": "ស្ពុច" },
    { "id": 14284, "word": "ស្ពុយ" },
    { "id": 14285, "word": "ស្ពុរ" },
    { "id": 14286, "word": "ស្ពើន" },
    { "id": 14287, "word": "ស្ពៀត" },
    { "id": 14288, "word": "ស្ពេះ" },
    { "id": 14289, "word": "ស្ពែត" },
    { "id": 14290, "word": "ស្ពែះ" },
    { "id": 14291, "word": "ស្ពៃ" },
    { "id": 14292, "word": "ស្ពៃគោក" },
    { "id": 14293, "word": "ស្ពោត" },
    { "id": 14294, "word": "ស្ពោរ" },
    { "id": 14295, "word": "ស្ពៅ" },
    { "id": 14296, "word": "ស្ម័គ្រ" },
    { "id": 14297, "word": "ស្មង" },
    { "id": 14298, "word": "ស្មត់" },
    { "id": 14299, "word": "ស្មន់" },
    { "id": 14300, "word": "ស្មន្ធ" },
    { "id": 14301, "word": "ស្មរ" },
    { "id": 14302, "word": "ស្មសាន" },
    { "id": 14303, "word": "ស្មា" },
    { "id": 14304, "word": "ស្មាក្តី" },
    { "id": 14305, "word": "ស្មាគម" },
    { "id": 14306, "word": "ស្មាច់" },
    { "id": 14307, "word": "ស្មាច់ដោម" },
    { "id": 14308, "word": "ស្មាជិក" },
    { "id": 14309, "word": "ស្មាញ" },
    { "id": 14310, "word": "ស្មាទាន" },
    { "id": 14311, "word": "ស្មាធិ" },
    { "id": 14312, "word": "ស្មាធិ៍" },
    { "id": 14313, "word": "ស្មាន" },
    { "id": 14314, "word": "ស្មាន់" },
    { "id": 14315, "word": "ស្មាភាព" },
    { "id": 14316, "word": "ស្មារតី" },
    { "id": 14317, "word": "ស្មារ្តី" },
    { "id": 14318, "word": "ស្មារលា" },
    { "id": 14319, "word": "ស្មិង" },
    { "id": 14320, "word": "ស្មិញ" },
    { "id": 14321, "word": "ស្មិត" },
    { "id": 14322, "word": "ស្មិប" },
    { "id": 14323, "word": "ស្មិល" },
    { "id": 14324, "word": "ស្មី" },
    { "id": 14325, "word": "ស្មឹង" },
    { "id": 14326, "word": "ស្មឹប" },
    { "id": 14327, "word": "ស្មឹម" },
    { "id": 14328, "word": "ស្មឺ" },
    { "id": 14329, "word": "ស្មឺប" },
    { "id": 14330, "word": "ស្មុគ" },
    { "id": 14331, "word": "ស្មុតទ្រុឌ" },
    { "id": 14332, "word": "ស្មុយ" },
    { "id": 14333, "word": "ស្មូញ" },
    { "id": 14334, "word": "ស្មូត" },
    { "id": 14335, "word": "ស្មូន" },
    { "id": 14336, "word": "ស្មូនឆ្នាំង" },
    { "id": 14337, "word": "ស្មូម" },
    { "id": 14338, "word": "ស្មូរ" },
    { "id": 14339, "word": "ស្មូរជន" },
    { "id": 14340, "word": "ស្មើ" },
    { "id": 14341, "word": "ស្មឿក" },
    { "id": 14342, "word": "ស្មៀន" },
    { "id": 14343, "word": "ស្មេ" },
    { "id": 14344, "word": "ស្មេញ" },
    { "id": 14345, "word": "ស្មេរ" },
    { "id": 14346, "word": "ស្មែ" },
    { "id": 14347, "word": "ស្មែក" },
    { "id": 14348, "word": "ស្មែង" },
    { "id": 14349, "word": "ស្មោក" },
    { "id": 14350, "word": "ស្មោកគ្រោក" },
    { "id": 14351, "word": "ស្ម៊ោកគ្រោក" },
    { "id": 14352, "word": "ស្មោង" },
    { "id": 14353, "word": "ស្មោញ" },
    { "id": 14354, "word": "ស្មោះ" },
    { "id": 14355, "word": "ស្មោះងារ" },
    { "id": 14356, "word": "ស្មោះសរ" },
    { "id": 14357, "word": "ស្មៅ" },
    { "id": 14358, "word": "ស្មៅស្រូបពិសពស់" },
    { "id": 14359, "word": "ស្មុំ" },
    { "id": 14360, "word": "ស្យា" },
    { "id": 14361, "word": "ស្យាម" },
    { "id": 14362, "word": "ស្យុល" },
    { "id": 14363, "word": "ស្រ" },
    { "id": 14364, "word": "ស្រៈ" },
    { "id": 14365, "word": "ស្រក" },
    { "id": 14366, "word": "ស្រក់" },
    { "id": 14367, "word": "ស្រកក់" },
    { "id": 14368, "word": "ស្រករ" },
    { "id": 14369, "word": "ស្រកា" },
    { "id": 14370, "word": "ស្រកាក" },
    { "id": 14371, "word": "ស្រកានាគ" },
    { "id": 14372, "word": "ស្រកី" },
    { "id": 14373, "word": "ស្រកីអណ្តែង" },
    { "id": 14374, "word": "ស្រកូក" },
    { "id": 14375, "word": "ស្រកេក" },
    { "id": 14376, "word": "ស្រកោក" },
    { "id": 14377, "word": "ស្រខក់" },
    { "id": 14378, "word": "ស្រខូវ" },
    { "id": 14379, "word": "ស្រគត់ស្រគំ" },
    { "id": 14380, "word": "ស្រគាល" },
    { "id": 14381, "word": "ស្រគិល ស្រគុល" },
    { "id": 14382, "word": "ស្រគុក" },
    { "id": 14383, "word": "ស្រគុល" },
    { "id": 14384, "word": "ស្រគែល" },
    { "id": 14385, "word": "ស្រគោម" },
    { "id": 14386, "word": "ស្រគំ" },
    { "id": 14387, "word": "ស្រគាំ" },
    { "id": 14388, "word": "ស្រឃិល ស្រឃុល" },
    { "id": 14389, "word": "ស្រឃុល" },
    { "id": 14390, "word": "ស្រង" },
    { "id": 14391, "word": "ស្រង់" },
    { "id": 14392, "word": "ស្រងក" },
    { "id": 14393, "word": "ស្រងល់" },
    { "id": 14394, "word": "ស្រងាក" },
    { "id": 14395, "word": "ស្រងាកស្ដាប់ផ្គរ" },
    { "id": 14396, "word": "ស្រងាត់" },
    { "id": 14397, "word": "ស្រងឹម" },
    { "id": 14398, "word": "ស្រងូត" },
    { "id": 14399, "word": "ស្រងើ" },
    { "id": 14400, "word": "ស្រងៀវ" },
    { "id": 14401, "word": "ស្រងេវ" },
    { "id": 14402, "word": "ស្រងេះស្រងោច" },
    { "id": 14403, "word": "ស្រងែ" },
    { "id": 14404, "word": "ស្រងោច" },
    { "id": 14405, "word": "ស្រងៅ" },
    { "id": 14406, "word": "ស្រងាំ" },
    { "id": 14407, "word": "ស្រជែត" },
    { "id": 14408, "word": "ស្រដាស់" },
    { "id": 14409, "word": "ស្រដី" },
    { "id": 14410, "word": "ស្រណាង" },
    { "id": 14411, "word": "ស្រណាន" },
    { "id": 14412, "word": "ស្រណុក" },
    { "id": 14413, "word": "ស្រណោក" },
    { "id": 14414, "word": "ស្រណោះ" },
    { "id": 14415, "word": "ស្រតឹក" },
    { "id": 14416, "word": "ស្រតូវ" },
    { "id": 14417, "word": "ស្រទន់" },
    { "id": 14418, "word": "ស្រទប" },
    { "id": 14419, "word": "ស្រទាង" },
    { "id": 14420, "word": "ស្រទាប់" },
    { "id": 14421, "word": "ស្រទៀក" },
    { "id": 14422, "word": "ស្រទំ" },
    { "id": 14423, "word": "ស្រទ្ធា" },
    { "id": 14424, "word": "ស្រន់" },
    { "id": 14425, "word": "ស្រប" },
    { "id": 14426, "word": "ស្រប់" },
    { "id": 14427, "word": "ស្របក់" },
    { "id": 14428, "word": "ស្របក់ស្របាល" },
    { "id": 14429, "word": "ស្របាល" },
    { "id": 14430, "word": "ស្របាំង" },
    { "id": 14431, "word": "ស្រប៉ាប" },
    { "id": 14432, "word": "ស្រប៉ូប" },
    { "id": 14433, "word": "ស្រប៉ើក" },
    { "id": 14434, "word": "ស្រប៉េក" },
    { "id": 14435, "word": "ស្រៈផ្សំ" },
    { "id": 14436, "word": "ស្រព" },
    { "id": 14437, "word": "ស្រពន់" },
    { "id": 14438, "word": "ស្រពាប" },
    { "id": 14439, "word": "ស្រពាប់" },
    { "id": 14440, "word": "ស្រពិល" },
    { "id": 14441, "word": "ស្រពេចស្រពិល" },
    { "id": 14442, "word": "ស្រៈពេញតួ" },
    { "id": 14443, "word": "ស្រពោន" },
    { "id": 14444, "word": "ស្រម៉" },
    { "id": 14445, "word": "ស្រមក" },
    { "id": 14446, "word": "ស្រមណៈ" },
    { "id": 14447, "word": "ស្រមណ --" },
    { "id": 14448, "word": "ស្រមណសក្ដិ" },
    { "id": 14449, "word": "ស្រមណី" },
    { "id": 14450, "word": "ស្រមណុទ្ទេស" },
    { "id": 14451, "word": "ស្រមាក់" },
    { "id": 14452, "word": "ស្រមាញ" },
    { "id": 14453, "word": "ស្រមាម" },
    { "id": 14454, "word": "ស្រមាមប៉ាក" },
    { "id": 14455, "word": "ស្រមិក" },
    { "id": 14456, "word": "ស្រមឹម" },
    { "id": 14457, "word": "ស្រមុក" },
    { "id": 14458, "word": "ស្រមុតចិត្ត" },
    { "id": 14459, "word": "ស្រមុយ" },
    { "id": 14460, "word": "ស្រមូញ" },
    { "id": 14461, "word": "ស្រមូម" },
    { "id": 14462, "word": "ស្រមូល" },
    { "id": 14463, "word": "ស្រមូវ" },
    { "id": 14464, "word": "ស្រមើ" },
    { "id": 14465, "word": "ស្រមើង" },
    { "id": 14466, "word": "ស្រមើល" },
    { "id": 14467, "word": "ស្រមៀន" },
    { "id": 14468, "word": "ស្រមេក" },
    { "id": 14469, "word": "ស្រមេម" },
    { "id": 14470, "word": "ស្រមេវ" },
    { "id": 14471, "word": "ស្រមេះ" },
    { "id": 14472, "word": "ស្រមៃ" },
    { "id": 14473, "word": "ស្រមោច" },
    { "id": 14474, "word": "ស្រមោល" },
    { "id": 14475, "word": "ស្រ័យ" },
    { "id": 14476, "word": "ស្រយង់" },
    { "id": 14477, "word": "ស្រយម" },
    { "id": 14478, "word": "ស្រយាក" },
    { "id": 14479, "word": "ស្រយាល" },
    { "id": 14480, "word": "ស្រយាវ" },
    { "id": 14481, "word": "ស្រយឺល" },
    { "id": 14482, "word": "ស្រយុត" },
    { "id": 14483, "word": "ស្រយូវ" },
    { "id": 14484, "word": "ស្រយើល" },
    { "id": 14485, "word": "ស្រលក" },
    { "id": 14486, "word": "ស្រល់" },
    { "id": 14487, "word": "ស្រលន" },
    { "id": 14488, "word": "ស្រលាញ់" },
    { "id": 14489, "word": "ស្រលាប" },
    { "id": 14490, "word": "ស្រលិត" },
    { "id": 14491, "word": "ស្រលឹង" },
    { "id": 14492, "word": "ស្រលឹប" },
    { "id": 14493, "word": "ស្រលឺកឺ" },
    { "id": 14494, "word": "ស្រលុង" },
    { "id": 14495, "word": "ស្រលូង" },
    { "id": 14496, "word": "ស្រលួត" },
    { "id": 14497, "word": "ស្រលួន" },
    { "id": 14498, "word": "ស្រលើ" },
    { "id": 14499, "word": "ស្រលើកើ" },
    { "id": 14500, "word": "ស្រលៀង" },
    { "id": 14501, "word": "ស្រលេញ" },
    { "id": 14502, "word": "ស្រលេត" },
    { "id": 14503, "word": "ស្រលេវ" },
    { "id": 14504, "word": "ស្រលែវ" },
    { "id": 14505, "word": "ស្រលះ" },
    { "id": 14506, "word": "ស្រវន្តី" },
    { "id": 14507, "word": "ស្រវា" },
    { "id": 14508, "word": "ស្រវាក់ស្រវាន់" },
    { "id": 14509, "word": "ស្រវាស្រទេញ" },
    { "id": 14510, "word": "ស្រវឹង" },
    { "id": 14511, "word": "ស្រវើន" },
    { "id": 14512, "word": "ស្រវាំង" },
    { "id": 14513, "word": "ស្រស" },
    { "id": 14514, "word": "ស្រស់" },
    { "id": 14515, "word": "ស្រ័ស" },
    { "id": 14516, "word": "ស្រស់បស់" },
    { "id": 14517, "word": "ស្រស់ស្រាយ" },
    { "id": 14518, "word": "ស្រស់ស្រូប" },
    { "id": 14519, "word": "ស្រស់ស្រោង" },
    { "id": 14520, "word": "ស្រឡក" },
    { "id": 14521, "word": "ស្រឡក់" },
    { "id": 14522, "word": "ស្រឡន" },
    { "id": 14523, "word": "ស្រឡប់" },
    { "id": 14524, "word": "ស្រឡាង" },
    { "id": 14525, "word": "ស្រឡាញ់" },
    { "id": 14526, "word": "ស្រឡាប" },
    { "id": 14527, "word": "ស្រឡិត" },
    { "id": 14528, "word": "ស្រឡឹង" },
    { "id": 14529, "word": "ស្រឡឹប" },
    { "id": 14530, "word": "ស្រឡឺកឺ" },
    { "id": 14531, "word": "ស្រឡុង" },
    { "id": 14532, "word": "ស្រឡូង" },
    { "id": 14533, "word": "ស្រឡើ" },
    { "id": 14534, "word": "ស្រឡើកើ" },
    { "id": 14535, "word": "ស្រឡេត" },
    { "id": 14536, "word": "ស្រឡេវ" },
    { "id": 14537, "word": "ស្រឡែវ" },
    { "id": 14538, "word": "ស្រឡៃ" },
    { "id": 14539, "word": "ស្រឡៃ" },
    { "id": 14540, "word": "ស្រឡោ" },
    { "id": 14541, "word": "ស្រឡោកោ" },
    { "id": 14542, "word": "ស្រឡោច" },
    { "id": 14543, "word": "ស្រឡៅ" },
    { "id": 14544, "word": "ស្រឡំ" },
    { "id": 14545, "word": "ស្រឡាំងកាំង" },
    { "id": 14546, "word": "ស្រឡះ" },
    { "id": 14547, "word": "ស្រអ័ព្ទ" },
    { "id": 14548, "word": "ស្រអាប់" },
    { "id": 14549, "word": "ស្រអិប" },
    { "id": 14550, "word": "ស្រអ៊ុក" },
    { "id": 14551, "word": "ស្រអ៊ុម" },
    { "id": 14552, "word": "ស្រអែត" },
    { "id": 14553, "word": "ស្រអែម" },
    { "id": 14554, "word": "ស្រអ៊ុំ" },
    { "id": 14555, "word": "ស្រា" },
    { "id": 14556, "word": "ស្រាក" },
    { "id": 14557, "word": "ស្រាក់" },
    { "id": 14558, "word": "ស្រាក់ៗ" },
    { "id": 14559, "word": "ស្រាង" },
    { "id": 14560, "word": "ស្រាញ" },
    { "id": 14561, "word": "ស្រាត" },
    { "id": 14562, "word": "ស្រាទ្ធពិធី" },
    { "id": 14563, "word": "ស្រាន្ត" },
    { "id": 14564, "word": "ស្រាប់" },
    { "id": 14565, "word": "ស្រាប់តែ" },
    { "id": 14566, "word": "ស្រាពក៍" },
    { "id": 14567, "word": "ស្រាពណ៍" },
    { "id": 14568, "word": "ស្រាពណី" },
    { "id": 14569, "word": "ស្រាយ" },
    { "id": 14570, "word": "ស្រាល" },
    { "id": 14571, "word": "ស្រាល់" },
    { "id": 14572, "word": "ស្រាវ" },
    { "id": 14573, "word": "ស្រាវក" },
    { "id": 14574, "word": "ស្រាវជ្រាវ" },
    { "id": 14575, "word": "ស្រាវណី" },
    { "id": 14576, "word": "ស្រាវិកា" },
    { "id": 14577, "word": "ស្រាស់" },
    { "id": 14578, "word": "ស្រិចៗ" },
    { "id": 14579, "word": "ស្រិត" },
    { "id": 14580, "word": "ស្រិបៗ" },
    { "id": 14581, "word": "ស្រិបស្រៀប" },
    { "id": 14582, "word": "ស្រិម" },
    { "id": 14583, "word": "ស្រិល" },
    { "id": 14584, "word": "ស្រី" },
    { "id": 14585, "word": "ស្រីប្រសើរ" },
    { "id": 14586, "word": "ស្រីម័ត" },
    { "id": 14587, "word": "ស្រីមតី" },
    { "id": 14588, "word": "ស្រីសោភ័ណ" },
    { "id": 14589, "word": "ស្រឹង" },
    { "id": 14590, "word": "ស្រ៊ឹង" },
    { "id": 14591, "word": "ស្រឹង្គ" },
    { "id": 14592, "word": "ស្រឹង្គារ" },
    { "id": 14593, "word": "ស្រឹង្គី" },
    { "id": 14594, "word": "ស្រឹប" },
    { "id": 14595, "word": "ស្រ៊ឹប" },
    { "id": 14596, "word": "ស្រឹបៗ" },
    { "id": 14597, "word": "ស្រឹបស្រៀប" },
    { "id": 14598, "word": "ស្រឹម" },
    { "id": 14599, "word": "ស្រុក" },
    { "id": 14600, "word": "ស្រុង" },
    { "id": 14601, "word": "ស្រ៊ុច" },
    { "id": 14602, "word": "ស្រុញ" },
    { "id": 14603, "word": "ស្រុត" },
    { "id": 14604, "word": "ស្រុតិ" },
    { "id": 14605, "word": "ស្រ៊ុប" },
    { "id": 14606, "word": "ស្រុស" },
    { "id": 14607, "word": "ស្រុះ" },
    { "id": 14608, "word": "ស្រូត" },
    { "id": 14609, "word": "ស្រូប" },
    { "id": 14610, "word": "ស្រូល" },
    { "id": 14611, "word": "ស្រូស" },
    { "id": 14612, "word": "ស្រ៊ូស" },
    { "id": 14613, "word": "ស្រួច" },
    { "id": 14614, "word": "ស្រួចស្រាល់" },
    { "id": 14615, "word": "ស្រួត" },
    { "id": 14616, "word": "ស្រួប" },
    { "id": 14617, "word": "ស្រួយ" },
    { "id": 14618, "word": "ស្រួល" },
    { "id": 14619, "word": "ស្រួលបួល" },
    { "id": 14620, "word": "ស្រើប" },
    { "id": 14621, "word": "ស្រើបស្រាល" },
    { "id": 14622, "word": "ស្រឿង" },
    { "id": 14623, "word": "ស្រៀក" },
    { "id": 14624, "word": "ស្រៀវ" },
    { "id": 14625, "word": "ស្រេក" },
    { "id": 14626, "word": "ស្រេង" },
    { "id": 14627, "word": "ស្រេច" },
    { "id": 14628, "word": "ស្រេចបាច់" },
    { "id": 14629, "word": "ស្រេណី" },
    { "id": 14630, "word": "ស្រេះ" },
    { "id": 14631, "word": "ស្រែ" },
    { "id": 14632, "word": "ស្រែក" },
    { "id": 14633, "word": "ស្រែង" },
    { "id": 14634, "word": "ស្រែងកង្កែប" },
    { "id": 14635, "word": "ស្រែន្យ" },
    { "id": 14636, "word": "ស្រែមួរ" },
    { "id": 14637, "word": "ស្រែស" },
    { "id": 14638, "word": "ស្រែះ" },
    { "id": 14639, "word": "ស្រោក" },
    { "id": 14640, "word": "ស្រោកទឹក" },
    { "id": 14641, "word": "ស្រោង" },
    { "id": 14642, "word": "ស្រោច" },
    { "id": 14643, "word": "ស្រោតា" },
    { "id": 14644, "word": "ស្រោត្រ" },
    { "id": 14645, "word": "ស្រោត្រិយៈ" },
    { "id": 14646, "word": "ស្រោប" },
    { "id": 14647, "word": "ស្រោបដណ្តប់" },
    { "id": 14648, "word": "ស្រោម" },
    { "id": 14649, "word": "ស្រោលៗ" },
    { "id": 14650, "word": "ស្រំ" },
    { "id": 14651, "word": "ស្រាំ" },
    { "id": 14652, "word": "ស្រាំង" },
    { "id": 14653, "word": "ស្រះ" },
    { "id": 14654, "word": "ស្ល" },
    { "id": 14655, "word": "ស្លក់" },
    { "id": 14656, "word": "ស្លង់" },
    { "id": 14657, "word": "ស្លត" },
    { "id": 14658, "word": "ស្លន់" },
    { "id": 14659, "word": "ស្លប" },
    { "id": 14660, "word": "ស្លា" },
    { "id": 14661, "word": "ស្លាក" },
    { "id": 14662, "word": "ស្លាក់" },
    { "id": 14663, "word": "ស្លាកស្នាម" },
    { "id": 14664, "word": "ស្លាកំញាន" },
    { "id": 14665, "word": "ស្លាជម" },
    { "id": 14666, "word": "ស្លាជ្វា" },
    { "id": 14667, "word": "ស្លាឈ្មោល" },
    { "id": 14668, "word": "ស្លាត" },
    { "id": 14669, "word": "ស្លាតាឱន" },
    { "id": 14670, "word": "ស្លាត្រួយ" },
    { "id": 14671, "word": "ស្លាធម៌" },
    { "id": 14672, "word": "ស្លាប" },
    { "id": 14673, "word": "ស្លាប់" },
    { "id": 14674, "word": "ស្លាបកែវ" },
    { "id": 14675, "word": "ស្លាបច្រវា" },
    { "id": 14676, "word": "ស្លាបទា" },
    { "id": 14677, "word": "ស្លាបប៉ាកកា" },
    { "id": 14678, "word": "ស្លាបប្រចៀវ" },
    { "id": 14679, "word": "ស្លាបព្រា" },
    { "id": 14680, "word": "ស្លាបព្រិល" },
    { "id": 14681, "word": "ស្លាយ" },
    { "id": 14682, "word": "ស្លាស្ងាប" },
    { "id": 14683, "word": "ស្លាអី" },
    { "id": 14684, "word": "ស្លឹក" },
    { "id": 14685, "word": "ស្លឹកគ្រៃ" },
    { "id": 14686, "word": "ស្លឹកពោធិ៍" },
    { "id": 14687, "word": "ស្លឹង" },
    { "id": 14688, "word": "ស្លឹប" },
    { "id": 14689, "word": "ស្លឺ" },
    { "id": 14690, "word": "ស្លឺត" },
    { "id": 14691, "word": "ស្លឺតស្លក់" },
    { "id": 14692, "word": "ស្លុក" },
    { "id": 14693, "word": "ស្លុង" },
    { "id": 14694, "word": "ស្លុត" },
    { "id": 14695, "word": "ស្លុតី" },
    { "id": 14696, "word": "ស្លុប" },
    { "id": 14697, "word": "ស្លុយ" },
    { "id": 14698, "word": "ស្លុះ " },
    { "id": 14699, "word": "ស្លូញ" },
    { "id": 14700, "word": "ស្លូត" },
    { "id": 14701, "word": "ស្លូតបូត" },
    { "id": 14702, "word": "ស្លើត" },
    { "id": 14703, "word": "ស្លើតស្លក់" },
    { "id": 14704, "word": "ស្លៀក" },
    { "id": 14705, "word": "ស្លេក" },
    { "id": 14706, "word": "ស្លេវ" },
    { "id": 14707, "word": "ស្លេស្ម" },
    { "id": 14708, "word": "ស្លេះ" },
    { "id": 14709, "word": "ស្លែ" },
    { "id": 14710, "word": "ស្លែង" },
    { "id": 14711, "word": "ស្លែងដងដឹង" },
    { "id": 14712, "word": "ស្លែងព្រវៀក" },
    { "id": 14713, "word": "ស្លែត" },
    { "id": 14714, "word": "ស្លែវ" },
    { "id": 14715, "word": "ស្លោ" },
    { "id": 14716, "word": "ស្លោក" },
    { "id": 14717, "word": "ស្លោម" },
    { "id": 14718, "word": "ស្លៅ" },
    { "id": 14719, "word": "ស្លាំង" },
    { "id": 14720, "word": "ស្វច្ឆន្ទ" },
    { "id": 14721, "word": "ស្វជន" },
    { "id": 14722, "word": "ស្វត" },
    { "id": 14723, "word": "ស្វទេស" },
    { "id": 14724, "word": "ស្វភូមិ" },
    { "id": 14725, "word": "ស្វយ័ត" },
    { "id": 14726, "word": "ស្វយម្ពរា" },
    { "id": 14727, "word": "ស្វយម្ភូ" },
    { "id": 14728, "word": "ស្វ័យត្រាណ" },
    { "id": 14729, "word": "ស្វ័យប្រវត្ត" },
    { "id": 14730, "word": "ស្វ័យប្រវត្តិ" },
    { "id": 14731, "word": "ស្វ័យភាព " },
    { "id": 14732, "word": "ស្វរៈ" },
    { "id": 14733, "word": "ស្វស្តិ" },
    { "id": 14734, "word": "ស្វស្ដិក" },
    { "id": 14735, "word": "ស្វស្ដី" },
    { "id": 14736, "word": "ស្វា" },
    { "id": 14737, "word": "ស្វាក់" },
    { "id": 14738, "word": "ស្វាគត" },
    { "id": 14739, "word": "ស្វាគតំ !" },
    { "id": 14740, "word": "ស្វាគមន៍" },
    { "id": 14741, "word": "ស្វាង" },
    { "id": 14742, "word": "ស្វាង្គ" },
    { "id": 14743, "word": "ស្វាង្គនា" },
    { "id": 14744, "word": "ស្វាង្គា" },
    { "id": 14745, "word": "ស្វាញាក់ចិញ្ចើម" },
    { "id": 14746, "word": "ស្វាត" },
    { "id": 14747, "word": "ស្វាទុ" },
    { "id": 14748, "word": "ស្វាធីន" },
    { "id": 14749, "word": "ស្វាធ្យាយ" },
    { "id": 14750, "word": "ស្វាធ្យាយន៍" },
    { "id": 14751, "word": "ស្វាធ្យាយិន" },
    { "id": 14752, "word": "ស្វាន" },
    { "id": 14753, "word": "ស្វាមី" },
    { "id": 14754, "word": "ស្វាយ" },
    { "id": 14755, "word": "ស្វាយចន្ទី" },
    { "id": 14756, "word": "ស្វាយត្រាំ" },
    { "id": 14757, "word": "ស្វាយព្រៃ" },
    { "id": 14758, "word": "ស្វារាជ" },
    { "id": 14759, "word": "ស្វារាជ្យ" },
    { "id": 14760, "word": "ស្វាស" },
    { "id": 14761, "word": "ស្វាសរោគ" },
    { "id": 14762, "word": "ស្វាហៈ" },
    { "id": 14763, "word": "ស្ដាប់ស្វាហា" },
    { "id": 14764, "word": "ស្វាហាប់" },
    { "id": 14765, "word": "ស្វាហាបតិ" },
    { "id": 14766, "word": "ស្វាហាយ" },
    { "id": 14767, "word": "ស្វាហិច ស្វាហារ" },
    { "id": 14768, "word": "ស្វិត" },
    { "id": 14769, "word": "ស្វិតចៅ" },
    { "id": 14770, "word": "ស្វិតស្វាញ" },
    { "id": 14771, "word": "ស្វីករណ៍" },
    { "id": 14772, "word": "ស្វីការ" },
    { "id": 14773, "word": "ស្វីក្រឹតិ" },
    { "id": 14774, "word": "ស្វេត" },
    { "id": 14775, "word": "ស្វែង" },
    { "id": 14776, "word": "ស្វែត" },
    { "id": 14777, "word": "ស្វៃរិន" },
    { "id": 14778, "word": "ស្វៃរិនី" },
    { "id": 14779, "word": "ស្វោយ" },
    { "id": 14780, "word": "ស្វះ" },
    { "id": 14781, "word": "ស្វះពន្លះ" },
    { "id": 14782, "word": "ស្អក" },
    { "id": 14783, "word": "ស្អប់" },
    { "id": 14784, "word": "ស្អយ" },
    { "id": 14785, "word": "ស្អា" },
    { "id": 14786, "word": "ស្អាង" },
    { "id": 14787, "word": "ស្អាត" },
    { "id": 14788, "word": "ស្អាតបាត" },
    { "id": 14789, "word": "ស្អាន" },
    { "id": 14790, "word": "ស្អាប់" },
    { "id": 14791, "word": "ស្អិត" },
    { "id": 14792, "word": "ស្អិតស្អាង" },
    { "id": 14793, "word": "ស្អី" },
    { "id": 14794, "word": "ស្អុង" },
    { "id": 14795, "word": "ស្អុយ" },
    { "id": 14796, "word": "ស៊្អុយ" },
    { "id": 14797, "word": "ស្អុះ" },
    { "id": 14798, "word": "ស្អូច" },
    { "id": 14799, "word": "ស្អៀច" },
    { "id": 14800, "word": "ស្អេក" },
    { "id": 14801, "word": "ស្អែក" },
    { "id": 14802, "word": "ស្អែល" },
    { "id": 14803, "word": "ស្អំ" },
    { "id": 14804, "word": "ហ" },
    { "id": 14805, "word": "ហ !" },
    { "id": 14806, "word": "ហ៊" },
    { "id": 14807, "word": "ហៈ" },
    { "id": 14808, "word": "ហក" },
    { "id": 14809, "word": "ហក់" },
    { "id": 14810, "word": "ហង" },
    { "id": 14811, "word": "ហង្ស" },
    { "id": 14812, "word": "ហង្ស --" },
    { "id": 14813, "word": "ហង្សបាទ" },
    { "id": 14814, "word": "ហដ្ដចោរក" },
    { "id": 14815, "word": "ហដ្ដចោរិកា" },
    { "id": 14816, "word": "ហដ្ដវិលាសិនី" },
    { "id": 14817, "word": "ហដ្ឋចិត្ត" },
    { "id": 14818, "word": "ហឋយោគ" },
    { "id": 14819, "word": "ហឋវិទ្យា" },
    { "id": 14820, "word": "ហត់" },
    { "id": 14821, "word": "ហតក្កិលេស" },
    { "id": 14822, "word": "ហ័តហោង" },
    { "id": 14823, "word": "ហត្ថ" },
    { "id": 14824, "word": "ហត្ថ --" },
    { "id": 14825, "word": "ហត្ថបាស" },
    { "id": 14826, "word": "ហត្ថា --" },
    { "id": 14827, "word": "ហត្ថិគោបក" },
    { "id": 14828, "word": "ហត្ថិគោបិកា" },
    { "id": 14829, "word": "ហត្ថិនី" },
    { "id": 14830, "word": "ហត្ថិបាល" },
    { "id": 14831, "word": "ហត្ថិមារក" },
    { "id": 14832, "word": "ហត្ថិលិង្គ" },
    { "id": 14833, "word": "ហត្ថី" },
    { "id": 14834, "word": "ហទ័យ" },
    { "id": 14835, "word": "ហ័ន" },
    { "id": 14836, "word": "ហនុមាន" },
    { "id": 14837, "word": "ហនូ" },
    { "id": 14838, "word": "ហនេយ្យុំ" },
    { "id": 14839, "word": "ហន្ទយុំ" },
    { "id": 14840, "word": "ហប" },
    { "id": 14841, "word": "ហប់" },
    { "id": 14842, "word": "ហ៊ប !" },
    { "id": 14843, "word": "ហម្មិយ" },
    { "id": 14844, "word": "ហយ --" },
    { "id": 14845, "word": "ហយៈ" },
    { "id": 14846, "word": "ហយា --" },
    { "id": 14847, "word": "ហយិន" },
    { "id": 14848, "word": "ហយោ  --" },
    { "id": 14849, "word": "ហរ --" },
    { "id": 14850, "word": "ហរៈ" },
    { "id": 14851, "word": "ហរិ" },
    { "id": 14852, "word": "ហរិ --" },
    { "id": 14853, "word": "ហរិត" },
    { "id": 14854, "word": "ហរិតាល" },
    { "id": 14855, "word": "ហឫទ័យ" },
    { "id": 14856, "word": "ហល់" },
    { "id": 14857, "word": "ហលាហល" },
    { "id": 14858, "word": "ហ័វ" },
    { "id": 14859, "word": "ហវិស" },
    { "id": 14860, "word": "ហស" },
    { "id": 14861, "word": "ហ៊ស" },
    { "id": 14862, "word": "ហសន --" },
    { "id": 14863, "word": "ហសនៈ" },
    { "id": 14864, "word": "ហសនា --" },
    { "id": 14865, "word": "ហសនីយ" },
    { "id": 14866, "word": "ហសនីយ --" },
    { "id": 14867, "word": "ហសនោ  --" },
    { "id": 14868, "word": "ហសាភិប្រាយ" },
    { "id": 14869, "word": "ហសិកា" },
    { "id": 14870, "word": "ហសិត" },
    { "id": 14871, "word": "ហសិត --" },
    { "id": 14872, "word": "ហស្ត" },
    { "id": 14873, "word": "ហស្ដិន" },
    { "id": 14874, "word": "ហហ្មុក" },
    { "id": 14875, "word": "ហា" },
    { "id": 14876, "word": "ហា" },
    { "id": 14877, "word": "ហា !" },
    { "id": 14878, "word": "ហាក់" },
    { "id": 14879, "word": "ហាក់ៗ" },
    { "id": 14880, "word": "ហាង" },
    { "id": 14881, "word": "ហាច់" },
    { "id": 14882, "word": "ហាច់ជា" },
    { "id": 14883, "word": "ហាដក" },
    { "id": 14884, "word": "ហាណូយ" },
    { "id": 14885, "word": "ហាត់" },
    { "id": 14886, "word": "ហាត់ព្យាម" },
    { "id": 14887, "word": "ហាត់ហោង" },
    { "id": 14888, "word": "ហាន" },
    { "id": 14889, "word": "ហាន់" },
    { "id": 14890, "word": "ហ៊ាន" },
    { "id": 14891, "word": "ហានតែថា" },
    { "id": 14892, "word": "ហានភាគិនី" },
    { "id": 14893, "word": "ហានភាគិយ" },
    { "id": 14894, "word": "ហានភាគី" },
    { "id": 14895, "word": "ហាប" },
    { "id": 14896, "word": "ហាប់" },
    { "id": 14897, "word": "ហាម" },
    { "id": 14898, "word": "ហាយន --" },
    { "id": 14899, "word": "ហាយនៈ" },
    { "id": 14900, "word": "ហារ" },
    { "id": 14901, "word": "ហារិន" },
    { "id": 14902, "word": "ហារិនី" },
    { "id": 14903, "word": "ហារី" },
    { "id": 14904, "word": "ហាល" },
    { "id": 14905, "word": "ហាវ" },
    { "id": 14906, "word": "ហាវ  !" },
    { "id": 14907, "word": "ហាស  !" },
    { "id": 14908, "word": "ហាស" },
    { "id": 14909, "word": "ហាសនីយ" },
    { "id": 14910, "word": "ហាសហាយ!" },
    { "id": 14911, "word": "ហាសហឺយ" },
    { "id": 14912, "word": "ហាសិប" },
    { "id": 14913, "word": "ហាហា" },
    { "id": 14914, "word": "ហាអឺ ៗ" },
    { "id": 14915, "word": "ហ៊‌ិ" },
    { "id": 14916, "word": "ហិង្គុ" },
    { "id": 14917, "word": "ហិង្គុល" },
    { "id": 14918, "word": "ហិង្សា" },
    { "id": 14919, "word": "ហិច" },
    { "id": 14920, "word": "ហិញ " },
    { "id": 14921, "word": "ហិណ្ឌិក" },
    { "id": 14922, "word": "ហិណ្ឌូ" },
    { "id": 14923, "word": "ហិត" },
    { "id": 14924, "word": "ហិត" },
    { "id": 14925, "word": "ហិត --" },
    { "id": 14926, "word": "ហិតប្រណី" },
    { "id": 14927, "word": "ហិតរោគ" },
    { "id": 14928, "word": "ហិតា --" },
    { "id": 14929, "word": "ហិន" },
    { "id": 14930, "word": "ហិនហុន" },
    { "id": 14931, "word": "ហិប" },
    { "id": 14932, "word": "ហិម --" },
    { "id": 14933, "word": "ហិមៈ" },
    { "id": 14934, "word": "ហិមពាន្ត" },
    { "id": 14935, "word": "ហិមវ័ត" },
    { "id": 14936, "word": "ហិមា --" },
    { "id": 14937, "word": "ហិមាល័យ" },
    { "id": 14938, "word": "ហិរញ្ញ" },
    { "id": 14939, "word": "ហិរញ្ញ --" },
    { "id": 14940, "word": "ហិរណ្យ" },
    { "id": 14941, "word": "ហិរិ" },
    { "id": 14942, "word": "ហិរិ --" },
    { "id": 14943, "word": "ហិរោត្តប្បៈ" },
    { "id": 14944, "word": "ហិល" },
    { "id": 14945, "word": "ហ៊‌ិះ" },
    { "id": 14946, "word": "ហ៊‌ី" },
    { "id": 14947, "word": "ហ៊‌ីង" },
    { "id": 14948, "word": "ហ៊‌ីងហ៊ាង" },
    { "id": 14949, "word": "ហីន" },
    { "id": 14950, "word": "ហីន --" },
    { "id": 14951, "word": "ហីនយាន" },
    { "id": 14952, "word": "ហីរ" },
    { "id": 14953, "word": "ហ៊‌ឹ !" },
    { "id": 14954, "word": "ហ៊‌ឹក" },
    { "id": 14955, "word": "ហ៊‌ឹកហ៊ាក់" },
    { "id": 14956, "word": "ហ៊‌ឹង" },
    { "id": 14957, "word": "ហឹប" },
    { "id": 14958, "word": "ហ៊‌ឹប" },
    { "id": 14959, "word": "ហ៊‌ឹមៗ" },
    { "id": 14960, "word": "ហឹរ" },
    { "id": 14961, "word": "ហឹសា" },
    { "id": 14962, "word": "ហ៊‌ឹះ" },
    { "id": 14963, "word": "ហឺ" },
    { "id": 14964, "word": "ហ៊‌ឺ" },
    { "id": 14965, "word": "ហ៊‌ឺៈ !" },
    { "id": 14966, "word": "ហឺត" },
    { "id": 14967, "word": "ហឺប" },
    { "id": 14968, "word": "ហឺយ !" },
    { "id": 14969, "word": "ហ៊‌ឺយ" },
    { "id": 14970, "word": "ហ៊‌ឺហា" },
    { "id": 14971, "word": "ហុកសិប" },
    { "id": 14972, "word": "ហុង" },
    { "id": 14973, "word": "ហុច" },
    { "id": 14974, "word": "ហុត" },
    { "id": 14975, "word": "ហ៊ុត" },
    { "id": 14976, "word": "ហុត" },
    { "id": 14977, "word": "ហុត --" },
    { "id": 14978, "word": "ហ៊ុន" },
    { "id": 14979, "word": "ហ៊ុនហយ" },
    { "id": 14980, "word": "ហ៊ុម" },
    { "id": 14981, "word": "ហ៊ុមព្រែ" },
    { "id": 14982, "word": "ហ៊ុមរោង" },
    { "id": 14983, "word": "ហ៊ុមហ" },
    { "id": 14984, "word": "ហុយ" },
    { "id": 14985, "word": "ហុយហាយ" },
    { "id": 14986, "word": "ហុរៗ " },
    { "id": 14987, "word": "ហ៊ុះៗ" },
    { "id": 14988, "word": "ហ៊ូ" },
    { "id": 14989, "word": "ហូត" },
    { "id": 14990, "word": "ហូតថ្នាក់" },
    { "id": 14991, "word": "ហូនហ៊ក់" },
    { "id": 14992, "word": "ហូប" },
    { "id": 14993, "word": "ហ៊ូពាន់" },
    { "id": 14994, "word": "ហ៊ូពូ" },
    { "id": 14995, "word": "ហូរ" },
    { "id": 14996, "word": "ហូល" },
    { "id": 14997, "word": "ហួង" },
    { "id": 14998, "word": "ហួងហែង" },
    { "id": 14999, "word": "ហួងហែន" },
    { "id": 15000, "word": "ហួច" },
    { "id": 15001, "word": "ហួញ" },
    { "id": 15002, "word": "ហួត" },
    { "id": 15003, "word": "ហួម" },
    { "id": 15004, "word": "ហួម៉ៃ" },
    { "id": 15005, "word": "ហួយ" },
    { "id": 15006, "word": "ហួរ" },
    { "id": 15007, "word": "ហួល" },
    { "id": 15008, "word": "ហួស" },
    { "id": 15009, "word": "ហើប" },
    { "id": 15010, "word": "ហើម" },
    { "id": 15011, "word": "ហើមស្រក" },
    { "id": 15012, "word": "ហើយ" },
    { "id": 15013, "word": "ហ៊‌ើយ !" },
    { "id": 15014, "word": "ហើរ" },
    { "id": 15015, "word": "ហៀ" },
    { "id": 15016, "word": "ហៀន" },
    { "id": 15017, "word": "ហៀបនឹង" },
    { "id": 15018, "word": "ហៀរ" },
    { "id": 15019, "word": "ហៀវ" },
    { "id": 15020, "word": "ហៀវហោះ" },
    { "id": 15021, "word": "ហេ" },
    { "id": 15022, "word": "ហេ !" },
    { "id": 15023, "word": "ហេៈ" },
    { "id": 15024, "word": "ហេង" },
    { "id": 15025, "word": "ហេងហាង" },
    { "id": 15026, "word": "ហេញ" },
    { "id": 15027, "word": "ហេដ្ឋិម" },
    { "id": 15028, "word": "ហេតុ" },
    { "id": 15029, "word": "ហេតុ --" },
    { "id": 15030, "word": "ហេបៗ" },
    { "id": 15031, "word": "ហេម" },
    { "id": 15032, "word": "ហេម --" },
    { "id": 15033, "word": "ហេមន្ត" },
    { "id": 15034, "word": "ហេមន្ត --" },
    { "id": 15035, "word": "ហេមពាន្ត" },
    { "id": 15036, "word": "ហេមវ័ត" },
    { "id": 15037, "word": "ហេមវតី" },
    { "id": 15038, "word": "ហេមវ័ន្ត" },
    { "id": 15039, "word": "ហេម្បូពាន្ត" },
    { "id": 15040, "word": "ហេមាទ្រិ" },
    { "id": 15041, "word": "ហេរញ្ញិក" },
    { "id": 15042, "word": "ហេរញ្ញិកា" },
    { "id": 15043, "word": "ហេរិក" },
    { "id": 15044, "word": "ហេរិកា" },
    { "id": 15045, "word": "ហេលហល" },
    { "id": 15046, "word": "ហេល ហាល" },
    { "id": 15047, "word": "ហេវ" },
    { "id": 15048, "word": "ហេៈហ៏" },
    { "id": 15049, "word": "ហេហា" },
    { "id": 15050, "word": "ហេះៗ" },
    { "id": 15051, "word": "ហែ" },
    { "id": 15052, "word": "ហ៊ែ" },
    { "id": 15053, "word": "ហ៊ែៈ" },
    { "id": 15054, "word": "ហែក" },
    { "id": 15055, "word": "ហែង" },
    { "id": 15056, "word": "ហែប" },
    { "id": 15057, "word": "ហែម" },
    { "id": 15058, "word": "ហែហៃ" },
    { "id": 15059, "word": "ហែលហល" },
    { "id": 15060, "word": "ហែៈហ៏" },
    { "id": 15061, "word": "ហែហម" },
    { "id": 15062, "word": "ហែហួច" },
    { "id": 15063, "word": "ហែះ" },
    { "id": 15064, "word": "ហ៊ែះ" },
    { "id": 15065, "word": "ហៃ" },
    { "id": 15066, "word": "ហៃណាំ" },
    { "id": 15067, "word": "ហៃមពណ៌" },
    { "id": 15068, "word": "ហៃមវតី" },
    { "id": 15069, "word": "ហៃរិក" },
    { "id": 15070, "word": "ហៃសាន" },
    { "id": 15071, "word": "ហៃអើ !" },
    { "id": 15072, "word": "ហោ" },
    { "id": 15073, "word": "ហ៊ោ" },
    { "id": 15074, "word": "ហោ --" },
    { "id": 15075, "word": "ហោក" },
    { "id": 15076, "word": "ហោង" },
    { "id": 15077, "word": "ហោច" },
    { "id": 15078, "word": "ហោចល្អោញ" },
    { "id": 15079, "word": "ហោជាង" },
    { "id": 15080, "word": "ហោណ័ង" },
    { "id": 15081, "word": "ហោតិល" },
    { "id": 15082, "word": "ហោត្រ" },
    { "id": 15083, "word": "ហោត្រ័យ" },
    { "id": 15084, "word": "ហោប៉ៅ" },
    { "id": 15085, "word": "ហោម" },
    { "id": 15086, "word": "ហោម --" },
    { "id": 15087, "word": "ហោមរោង" },
    { "id": 15088, "word": "ហោរ" },
    { "id": 15089, "word": "ហោរ  --" },
    { "id": 15090, "word": "ហោរា" },
    { "id": 15091, "word": "ហោរា  --" },
    { "id": 15092, "word": "ហោរ៉ា" },
    { "id": 15093, "word": "ហោល" },
    { "id": 15094, "word": "ហោលៗ" },
    { "id": 15095, "word": "ហោះ" },
    { "id": 15096, "word": "ហៅ" },
    { "id": 15097, "word": "ហ៊ៅ" },
    { "id": 15098, "word": "ហៅហាន" },
    { "id": 15099, "word": "ហំ" },
    { "id": 15100, "word": "ហ្ន" },
    { "id": 15101, "word": "ហ្ន័ង" },
    { "id": 15102, "word": "ហ្នា៎ !" },
    { "id": 15103, "word": "ហ្នឹង" },
    { "id": 15104, "word": "ហ្នាំង" },
    { "id": 15105, "word": "ហ្ន៎ះ !" },
    { "id": 15106, "word": "ហ្ម" },
    { "id": 15107, "word": "ហ្ម --" },
    { "id": 15108, "word": "ហ្មគ្វាម" },
    { "id": 15109, "word": "ហ្មង" },
    { "id": 15110, "word": "ហ្មត់" },
    { "id": 15111, "word": "ហ្មត់ចត់" },
    { "id": 15112, "word": "ហ្មត់ហ្មង" },
    { "id": 15113, "word": "ហ្មប" },
    { "id": 15114, "word": "ហ្មបហ្មាយ" },
    { "id": 15115, "word": "ហ្មាយ" },
    { "id": 15116, "word": "ហ្មឺន" },
    { "id": 15117, "word": "ហ្មូត" },
    { "id": 15118, "word": "ហ្មេ !" },
    { "id": 15119, "word": "ហ្រស្វ" },
    { "id": 15120, "word": "ហ្វ្រង្ក" },
    { "id": 15121, "word": "ហ្វ្រ័ង" },
    { "id": 15122, "word": "ហ្ឫទ័យ" },
    { "id": 15123, "word": "ហ្ល័ក" },
    { "id": 15124, "word": "ហ្ល័កហ្ល័ង" },
    { "id": 15125, "word": "ហ្លាក" },
    { "id": 15126, "word": "ហ្លាក់" },
    { "id": 15127, "word": "ហ្លាក់ --" },
    { "id": 15128, "word": "ហ្លាក់ហ្លាំង" },
    { "id": 15129, "word": "ហ្លាយ" },
    { "id": 15130, "word": "ហ្លួង" },
    { "id": 15131, "word": "ហ្លួងព្រះបាង" },
    { "id": 15132, "word": "ហ្លេវហ្លៃ" },
    { "id": 15133, "word": "ហ្វង់" },
    { "id": 15134, "word": "ហ្វារ" },
    { "id": 15135, "word": "ហ្វ៊‌ីល" },
    { "id": 15136, "word": "ហ្វឹក" },
    { "id": 15137, "word": "ហ្វឹកហ្វឺន" },
    { "id": 15138, "word": "ហ្វូង" },
    { "id": 15139, "word": "ហ្វូងហ្វាយ" },
    { "id": 15140, "word": "ហ្វូងដិន" },
    { "id": 15141, "word": "ហ្វេ" },
    { "id": 15142, "word": "ហ្វៅ" },
    { "id": 15143, "word": "ឡ" },
    { "id": 15144, "word": "ឡក" },
    { "id": 15145, "word": "ឡកឡាយ" },
    { "id": 15146, "word": "ឡងៗ" },
    { "id": 15147, "word": "ឡង់" },
    { "id": 15148, "word": "ឡត" },
    { "id": 15149, "word": "ឡប់" },
    { "id": 15150, "word": "ឡប់ៗ" },
    { "id": 15151, "word": "ឡប់ឡែ" },
    { "id": 15152, "word": "ឡាក" },
    { "id": 15153, "word": "ឡាក់" },
    { "id": 15154, "word": "ឡាក់ឡាំង" },
    { "id": 15155, "word": "ឡាចៅ" },
    { "id": 15156, "word": "ឡាញ់" },
    { "id": 15157, "word": "ឡាន" },
    { "id": 15158, "word": "ឡាន់" },
    { "id": 15159, "word": "ឡាប" },
    { "id": 15160, "word": "ឡាប់យេរ" },
    { "id": 15161, "word": "ឡាយ" },
    { "id": 15162, "word": "ឡាយឡុង" },
    { "id": 15163, "word": "ឡាវ" },
    { "id": 15164, "word": "ឡាវហាវ" },
    { "id": 15165, "word": "ឡិកឡក់" },
    { "id": 15166, "word": "ឡិងឡង់" },
    { "id": 15167, "word": "ឡិងឡាំង" },
    { "id": 15168, "word": "ឡិច" },
    { "id": 15169, "word": "ឡិន" },
    { "id": 15170, "word": "ឡិបឡុប" },
    { "id": 15171, "word": "ឡិមឡុម" },
    { "id": 15172, "word": "ឡឹប" },
    { "id": 15173, "word": "ឡឹមៗ " },
    { "id": 15174, "word": "ឡឺត" },
    { "id": 15175, "word": "ឡឺនឡង់" },
    { "id": 15176, "word": "ឡឺម" },
    { "id": 15177, "word": "ឡុកឡាក់" },
    { "id": 15178, "word": "ឡុងចុង" },
    { "id": 15179, "word": "ឡុងបុត" },
    { "id": 15180, "word": "ឡុងសុង" },
    { "id": 15181, "word": "ឡុបៗ" },
    { "id": 15182, "word": "ឡុលៗ" },
    { "id": 15183, "word": "ឡូ" },
    { "id": 15184, "word": "ឡូង" },
    { "id": 15185, "word": "ឡូងឡាង" },
    { "id": 15186, "word": "ឡូញ" },
    { "id": 15187, "word": "ឡូត៍" },
    { "id": 15188, "word": "ឡូយ" },
    { "id": 15189, "word": "ឡូយថូយ" },
    { "id": 15190, "word": "ឡូឡា" },
    { "id": 15191, "word": "ឡើង" },
    { "id": 15192, "word": "ឡើងចាង" },
    { "id": 15193, "word": "ឡើយ" },
    { "id": 15194, "word": "ឡើយនីលែង" },
    { "id": 15195, "word": "ឡេមឡាម" },
    { "id": 15196, "word": "ឡេមឡឺម" },
    { "id": 15197, "word": "ឡេវ" },
    { "id": 15198, "word": "ឡេវឡៃ" },
    { "id": 15199, "word": "ឡេវអាវ" },
    { "id": 15200, "word": "ឡេះឡោះ" },
    { "id": 15201, "word": "ឡេះឡះ" },
    { "id": 15202, "word": "ឡែៗ" },
    { "id": 15203, "word": "ឡែក" },
    { "id": 15204, "word": "ឡែកឡាន់" },
    { "id": 15205, "word": "ឡែបខាយ" },
    { "id": 15206, "word": "ឡែបឡប" },
    { "id": 15207, "word": "ឡែមៗ" },
    { "id": 15208, "word": "ឡែឡ" },
    { "id": 15209, "word": "ឡែឡប់" },
    { "id": 15210, "word": "ឡោ" },
    { "id": 15211, "word": "ឡោក" },
    { "id": 15212, "word": "ឡោម" },
    { "id": 15213, "word": "ឡៅ" },
    { "id": 15214, "word": "ឡៅតេង" },
    { "id": 15215, "word": "ឡាំ" },
    { "id": 15216, "word": "ឡាំង" },
    { "id": 15217, "word": "ឡាំប៉ា" },
    { "id": 15218, "word": "ឡាំសាំ" },
    { "id": 15219, "word": "ឡះ " },
    { "id": 15220, "word": "អ" },
    { "id": 15221, "word": "អ !" },
    { "id": 15222, "word": "អក" },
    { "id": 15223, "word": "អកតញ្ញុតា" },
    { "id": 15224, "word": "អកតញ្ញូ" },
    { "id": 15225, "word": "អកតវេទិតា" },
    { "id": 15226, "word": "អកតវេទិនី" },
    { "id": 15227, "word": "អកតវេទី" },
    { "id": 15228, "word": "អកនិដ្ឋ" },
    { "id": 15229, "word": "អកនិដ្ឋា" },
    { "id": 15230, "word": "អកប្បិយ" },
    { "id": 15231, "word": "អកម្មកិរិយា" },
    { "id": 15232, "word": "អកម្មធាតុ" },
    { "id": 15233, "word": "អកយំ" },
    { "id": 15234, "word": "អករ៍" },
    { "id": 15235, "word": "អករណីយ" },
    { "id": 15236, "word": "អកអំបុក" },
    { "id": 15237, "word": "អកាល" },
    { "id": 15238, "word": "អកិរិយវាទ" },
    { "id": 15239, "word": "អកិរិយវាទិនី" },
    { "id": 15240, "word": "អកិរិយវាទី" },
    { "id": 15241, "word": "អកុសល" },
    { "id": 15242, "word": "អកុសល --" },
    { "id": 15243, "word": "អក្ក" },
    { "id": 15244, "word": "អក្កោសន" },
    { "id": 15245, "word": "អក្កោសន  --" },
    { "id": 15246, "word": "អក្កោសវត្ថុ" },
    { "id": 15247, "word": "អក្ខណៈ" },
    { "id": 15248, "word": "អក្ខទស្ស" },
    { "id": 15249, "word": "អក្ខទេវិនី" },
    { "id": 15250, "word": "អក្ខទេវី" },
    { "id": 15251, "word": "អក្ខធុត្តី" },
    { "id": 15252, "word": "អក្ខធូត" },
    { "id": 15253, "word": "អក្ខន្តី" },
    { "id": 15254, "word": "អក្ខបាដ" },
    { "id": 15255, "word": "អក្ខបាដក" },
    { "id": 15256, "word": "អក្ខមា" },
    { "id": 15257, "word": "អក្ខរ" },
    { "id": 15258, "word": "អក្ខរ --" },
    { "id": 15259, "word": "អក្ខរកោវិទ" },
    { "id": 15260, "word": "អក្ខរប្បភេទ" },
    { "id": 15261, "word": "អក្ខរា" },
    { "id": 15262, "word": "អក្ខរា --" },
    { "id": 15263, "word": "អក្ខិ" },
    { "id": 15264, "word": "អក្ខោ" },
    { "id": 15265, "word": "អក្ខោភិនី" },
    { "id": 15266, "word": "អក្ខោហិណី" },
    { "id": 15267, "word": "អ័ក្ស" },
    { "id": 15268, "word": "អក្សណៈ" },
    { "id": 15269, "word": "អក្សទេវិន" },
    { "id": 15270, "word": "អក្សមា" },
    { "id": 15271, "word": "អក្សរ" },
    { "id": 15272, "word": "អក្សរ" },
    { "id": 15273, "word": "អក្សរ --" },
    { "id": 15274, "word": "អក្សាន្តី" },
    { "id": 15275, "word": "អក្សិ" },
    { "id": 15276, "word": "អក្សៅហិណី" },
    { "id": 15277, "word": "អគតិ" },
    { "id": 15278, "word": "អគន្ធក" },
    { "id": 15279, "word": "អគមនីយ" },
    { "id": 15280, "word": "អគាធ" },
    { "id": 15281, "word": "អគារ" },
    { "id": 15282, "word": "អគារវៈ" },
    { "id": 15283, "word": "អគុណ" },
    { "id": 15284, "word": "អគោចរ" },
    { "id": 15285, "word": "អគ្គ" },
    { "id": 15286, "word": "អគ្គ --" },
    { "id": 15287, "word": "អគ្គិ" },
    { "id": 15288, "word": "អគ្គិ --" },
    { "id": 15289, "word": "អគ្ឃ" },
    { "id": 15290, "word": "អគ្នន្យ័ស្ត្រ" },
    { "id": 15291, "word": "អគ្នន្យុត្បាត" },
    { "id": 15292, "word": "អគ្និ" },
    { "id": 15293, "word": "អគ្និ --" },
    { "id": 15294, "word": "អគ្យាគារ" },
    { "id": 15295, "word": "អគ្រ" },
    { "id": 15296, "word": "អឃម័យ" },
    { "id": 15297, "word": "អឃោស" },
    { "id": 15298, "word": "អង" },
    { "id": 15299, "word": "អង់" },
    { "id": 15300, "word": "អង់គ្លេស" },
    { "id": 15301, "word": "អង់អាច" },
    { "id": 15302, "word": "អង្ក" },
    { "id": 15303, "word": "អង្កត់" },
    { "id": 15304, "word": "អង្កត់ខ្មៅ" },
    { "id": 15305, "word": "អង្កន់" },
    { "id": 15306, "word": "អង្កបាលិកា" },
    { "id": 15307, "word": "អង្ករ" },
    { "id": 15308, "word": "អង្កា" },
    { "id": 15309, "word": "អង្កាញ់" },
    { "id": 15310, "word": "អង្កាន់" },
    { "id": 15311, "word": "អង្កាប់អង្កើ" },
    { "id": 15312, "word": "អង្កាម" },
    { "id": 15313, "word": "អង្កាល់" },
    { "id": 15314, "word": "អង្កឹ" },
    { "id": 15315, "word": "អង្កឹក" },
    { "id": 15316, "word": "អង្កឺល" },
    { "id": 15317, "word": "អង្កុក" },
    { "id": 15318, "word": "អង្កុញ" },
    { "id": 15319, "word": "អង្កុល" },
    { "id": 15320, "word": "អង្កុស" },
    { "id": 15321, "word": "អង្កូរ" },
    { "id": 15322, "word": "អង្កួច" },
    { "id": 15323, "word": "អង្កួញ" },
    { "id": 15324, "word": "អង្កួញដី" },
    { "id": 15325, "word": "អង្កើក" },
    { "id": 15326, "word": "អង្កៀម" },
    { "id": 15327, "word": "អង្កៀមងៀត" },
    { "id": 15328, "word": "អង្កេត" },
    { "id": 15329, "word": "អង្កែ" },
    { "id": 15330, "word": "អង្កែត" },
    { "id": 15331, "word": "អង្កែលអង្កៃ" },
    { "id": 15332, "word": "អង្កោល" },
    { "id": 15333, "word": "អង្កាំ" },
    { "id": 15334, "word": "អង្ក្រង" },
    { "id": 15335, "word": "អង្ក្រត" },
    { "id": 15336, "word": "អង្ក្រេតអង្ក្រត" },
    { "id": 15337, "word": "អង្គ" },
    { "id": 15338, "word": "អង្គ --" },
    { "id": 15339, "word": "អង្គញ់" },
    { "id": 15340, "word": "អង្គញ់ស្វា" },
    { "id": 15341, "word": "អង្គត់" },
    { "id": 15342, "word": "អង្គនា" },
    { "id": 15343, "word": "អង្គប់" },
    { "id": 15344, "word": "អង្គរ" },
    { "id": 15345, "word": "អង្គរ --" },
    { "id": 15346, "word": "អង្គរជុំ" },
    { "id": 15347, "word": "អង្គរាគ" },
    { "id": 15348, "word": "អង្គ័ល" },
    { "id": 15349, "word": "អង្គា" },
    { "id": 15350, "word": "រង្គា --" },
    { "id": 15351, "word": "អង្គាដី" },
    { "id": 15352, "word": "អង្គាបុស្ប" },
    { "id": 15353, "word": "អង្គារ" },
    { "id": 15354, "word": "អង្គារ --" },
    { "id": 15355, "word": "អង្គារិ" },
    { "id": 15356, "word": "អង្គាលឿង" },
    { "id": 15357, "word": "អង្គាស" },
    { "id": 15358, "word": "អង្គាសីល" },
    { "id": 15359, "word": "អង្គីករណ៍" },
    { "id": 15360, "word": "អង្គីរស" },
    { "id": 15361, "word": "អង្គឺ" },
    { "id": 15362, "word": "អង្គឺអង្គែ" },
    { "id": 15363, "word": "អង្គុក" },
    { "id": 15364, "word": "អង្គុកអង្គុល" },
    { "id": 15365, "word": "អង្គុយ" },
    { "id": 15366, "word": "អង្គុយចាំតែ" },
    { "id": 15367, "word": "អង្គុល" },
    { "id": 15368, "word": "អង្គុលៈ" },
    { "id": 15369, "word": "អង្គុលី" },
    { "id": 15370, "word": "អង្គុលី --" },
    { "id": 15371, "word": "អង្គុល្យាភរណៈ" },
    { "id": 15372, "word": "អង្គែ" },
    { "id": 15373, "word": "អង្គំ" },
    { "id": 15374, "word": "អង្គ្រ័ក្ស" },
    { "id": 15375, "word": "អង្គ្រង" },
    { "id": 15376, "word": "អង្គ្រឺត" },
    { "id": 15377, "word": "អង្គ្លេស" },
    { "id": 15378, "word": "អង្ឃាក់" },
    { "id": 15379, "word": "អង្ឃើល" },
    { "id": 15380, "word": "អង្រង់" },
    { "id": 15381, "word": "អង្រន់" },
    { "id": 15382, "word": "អង្រឹង" },
    { "id": 15383, "word": "អង្រុត" },
    { "id": 15384, "word": "អង្រូស" },
    { "id": 15385, "word": "អង្រួន" },
    { "id": 15386, "word": "អង្រៀតនឹង" },
    { "id": 15387, "word": "អង្រែ" },
    { "id": 15388, "word": "អង្រែដែក" },
    { "id": 15389, "word": "អង្វរ" },
    { "id": 15390, "word": "អង្វរករ" },
    { "id": 15391, "word": "អង្វែង" },
    { "id": 15392, "word": "អង្ស" },
    { "id": 15393, "word": "អង្ស --" },
    { "id": 15394, "word": "អង្ស័ក" },
    { "id": 15395, "word": "អង្សា" },
    { "id": 15396, "word": "អង្សា" },
    { "id": 15397, "word": "អង្សិក" },
    { "id": 15398, "word": "អង្សុ" },
    { "id": 15399, "word": "អង្អែល" },
    { "id": 15400, "word": "អចរណភាព" },
    { "id": 15401, "word": "អចល" },
    { "id": 15402, "word": "អចល --" },
    { "id": 15403, "word": "អចលន --" },
    { "id": 15404, "word": "អចលនៈ" },
    { "id": 15405, "word": "អចលា" },
    { "id": 15406, "word": "អចិត្ត" },
    { "id": 15407, "word": "អចិត្តក --" },
    { "id": 15408, "word": "អចិត្តកៈ" },
    { "id": 15409, "word": "អចិត្តិភាព" },
    { "id": 15410, "word": "អចិន្តា" },
    { "id": 15411, "word": "អចិន្ត្រៃយ៍" },
    { "id": 15412, "word": "អចិរ" },
    { "id": 15413, "word": "អចិរ --" },
    { "id": 15414, "word": "អចេលកៈ" },
    { "id": 15415, "word": "អចេស្ដា" },
    { "id": 15416, "word": "អចៃដន្យ" },
    { "id": 15417, "word": "អច្ចុត" },
    { "id": 15418, "word": "អច្ចេក" },
    { "id": 15419, "word": "អច្ឆរា" },
    { "id": 15420, "word": "អច្ឆរិយ" },
    { "id": 15421, "word": "អច្ឆរិយ --" },
    { "id": 15422, "word": "អច្ឆាទនៈ" },
    { "id": 15423, "word": "អច្ឆាវ័ទ" },
    { "id": 15424, "word": "អច្ឆិទ្ទវុត្តិនី" },
    { "id": 15425, "word": "អច្ឆិទ្ទវុត្តី" },
    { "id": 15426, "word": "អច្ឆិទ្រព្រឹត្តិ" },
    { "id": 15427, "word": "អជដាកាស" },
    { "id": 15428, "word": "អជនប្រទេស" },
    { "id": 15429, "word": "អជ្ឈត្តសន្តាន" },
    { "id": 15430, "word": "អជ្ឈត្តិកទាន" },
    { "id": 15431, "word": "អជ្ឈាចារ" },
    { "id": 15432, "word": "អជ្ឈាស័យ" },
    { "id": 15433, "word": "អជ្ឈុប្បាតកៈ" },
    { "id": 15434, "word": "អជ្ឈេសនា" },
    { "id": 15435, "word": "អជ្ឈោកាស" },
    { "id": 15436, "word": "អជ្ឈោសាន" },
    { "id": 15437, "word": "អញ" },
    { "id": 15438, "word": "អញ្ចង" },
    { "id": 15439, "word": "អញ្ចាច" },
    { "id": 15440, "word": "អញ្ចាញ" },
    { "id": 15441, "word": "អញ្ចាប" },
    { "id": 15442, "word": "អញ្ចូចៗ" },
    { "id": 15443, "word": "អញ្ឆើល" },
    { "id": 15444, "word": "អញ្ជចៗ" },
    { "id": 15445, "word": "អញ្ជ័ន" },
    { "id": 15446, "word": "អញ្ជលិ" },
    { "id": 15447, "word": "អញ្ជុល" },
    { "id": 15448, "word": "អញ្ជុលី" },
    { "id": 15449, "word": "អញ្ជើញ " },
    { "id": 15450, "word": "អញាតកជន" },
    { "id": 15451, "word": "អញ្ញត្រ" },
    { "id": 15452, "word": "អញ្ញត្រសព្ទ" },
    { "id": 15453, "word": "អញ្ញថាភាព" },
    { "id": 15454, "word": "អញ្ញបទ" },
    { "id": 15455, "word": "អញ្ញវាទកម្ម" },
    { "id": 15456, "word": "អញ្ញាត" },
    { "id": 15457, "word": "អញ្ញាត --" },
    { "id": 15458, "word": "អញ្ញាតកជន" },
    { "id": 15459, "word": "អញ្ញាតកវេស" },
    { "id": 15460, "word": "អញ្ញាតកវេសក" },
    { "id": 15461, "word": "អញ្ញូបត្ថម្ភិត" },
    { "id": 15462, "word": "អញ្ញោបត្ថម្ភិត" },
    { "id": 15463, "word": "អដដ" },
    { "id": 15464, "word": "អដវិក" },
    { "id": 15465, "word": "អដវី" },
    { "id": 15466, "word": "អដ្តប្រតិភូ" },
    { "id": 15467, "word": "អដ្ឋ" },
    { "id": 15468, "word": "អដ្ឋ --" },
    { "id": 15469, "word": "អដ្ឋកថា" },
    { "id": 15470, "word": "អដ្ឋបរិក្ខារ" },
    { "id": 15471, "word": "អដ្ឋបាន" },
    { "id": 15472, "word": "អដ្ឋិ" },
    { "id": 15473, "word": "អដ្ឋិ --" },
    { "id": 15474, "word": "អឌ្ឍ" },
    { "id": 15475, "word": "អឌ្ឍ --" },
    { "id": 15476, "word": "អឌ្ឍចន្ទ" },
    { "id": 15477, "word": "អឌ្ឍយោគ" },
    { "id": 15478, "word": "អណូ" },
    { "id": 15479, "word": "អណ្ដាក់អណ្ដល់" },
    { "id": 15480, "word": "អណ្ដាត" },
    { "id": 15481, "word": "អណ្ដាតគោ" },
    { "id": 15482, "word": "អណ្ដាតឆ្កែ" },
    { "id": 15483, "word": "អណ្ដាតឆ្លាម" },
    { "id": 15484, "word": "អណ្ដាតត្រកួត" },
    { "id": 15485, "word": "អណ្ដាតសមុទ្រ" },
    { "id": 15486, "word": "អណ្ដាប់" },
    { "id": 15487, "word": "អណ្ដាប់អណ្ដា" },
    { "id": 15488, "word": "អណ្ដាប់អណ្ដោយ" },
    { "id": 15489, "word": "អណ្ដឺតអណ្ដក" },
    { "id": 15490, "word": "អណ្ដូង" },
    { "id": 15491, "word": "អណ្ដើក" },
    { "id": 15492, "word": "អណ្ដើកមាស" },
    { "id": 15493, "word": "អណ្ដើរ" },
    { "id": 15494, "word": "អណ្ដែង" },
    { "id": 15495, "word": "អណ្ដែត" },
    { "id": 15496, "word": "អណ្ដែត  --" },
    { "id": 15497, "word": "អណ្ដោត" },
    { "id": 15498, "word": "អណ្ឌ --" },
    { "id": 15499, "word": "អណ្ឌៈ" },
    { "id": 15500, "word": "អណ្ឌា --" },
    { "id": 15501, "word": "អណ្ណព" },
    { "id": 15502, "word": "អណ្ណាម" },
    { "id": 15503, "word": "អត" },
    { "id": 15504, "word": "អត់" },
    { "id": 15505, "word": "អតប្បា" },
    { "id": 15506, "word": "អតិ" },
    { "id": 15507, "word": "អតិ --" },
    { "id": 15508, "word": "អតិថិ" },
    { "id": 15509, "word": "អតិថិ --" },
    { "id": 15510, "word": "អតិរេក" },
    { "id": 15511, "word": "អតិរេក --" },
    { "id": 15512, "word": "អតិសារ" },
    { "id": 15513, "word": "អតីត" },
    { "id": 15514, "word": "អតីត --" },
    { "id": 15515, "word": "អតេកិច្ឆ" },
    { "id": 15516, "word": "អតេកិច្ឆ --" },
    { "id": 15517, "word": "អត្ត" },
    { "id": 15518, "word": "អត្ត --" },
    { "id": 15519, "word": "អត្តៈ" },
    { "id": 15520, "word": "អត្តខាត់" },
    { "id": 15521, "word": "អត្តនោបទ" },
    { "id": 15522, "word": "អត្តនោម័តិ" },
    { "id": 15523, "word": "អត្តនោមត្យា ធិប្បាយ" },
    { "id": 15524, "word": "អត្តា" },
    { "id": 15525, "word": "អត្តា --" },
    { "id": 15526, "word": "អត្តិខាត់ --" },
    { "id": 15527, "word": "អត្តុ --" },
    { "id": 15528, "word": "អត្ថ" },
    { "id": 15529, "word": "អត្ថ --" },
    { "id": 15530, "word": "អត្ថង្គត" },
    { "id": 15531, "word": "អត្ថា --" },
    { "id": 15532, "word": "អត្ថិភាព" },
    { "id": 15533, "word": "អត្រជៈ" },
    { "id": 15534, "word": "អត្រជា" },
    { "id": 15535, "word": "អត្រានុកូលដ្ឋាន" },
    { "id": 15536, "word": "អថ័ន" },
    { "id": 15537, "word": "អថព្វ" },
    { "id": 15538, "word": "អថិរភាព" },
    { "id": 15539, "word": "អទាយាទ" },
    { "id": 15540, "word": "អទារជន" },
    { "id": 15541, "word": "អទារុណ" },
    { "id": 15542, "word": "អទាសតា" },
    { "id": 15543, "word": "អទាសព្យ" },
    { "id": 15544, "word": "អទិដ្ឋ" },
    { "id": 15545, "word": "អទិដ្ឋមិត្ត" },
    { "id": 15546, "word": "អទិន្ន" },
    { "id": 15547, "word": "អទិន្ន --" },
    { "id": 15548, "word": "អទិស្សមាន" },
    { "id": 15549, "word": "អទុរាគត" },
    { "id": 15550, "word": "អទុរាគតា" },
    { "id": 15551, "word": "អទ្ធគូ" },
    { "id": 15552, "word": "អទ្ធា" },
    { "id": 15553, "word": "អទ្ធាន" },
    { "id": 15554, "word": "អទ្ធាន --" },
    { "id": 15555, "word": "អធម" },
    { "id": 15556, "word": "អធម្ម" },
    { "id": 15557, "word": "អធម្ម --" },
    { "id": 15558, "word": "អធម៌" },
    { "id": 15559, "word": "អធរមាន" },
    { "id": 15560, "word": "អធិក" },
    { "id": 15561, "word": "អធិក --" },
    { "id": 15562, "word": "អធិករណ --" },
    { "id": 15563, "word": "អធិករណៈ" },
    { "id": 15564, "word": "អធិកអធម" },
    { "id": 15565, "word": "អធិការ" },
    { "id": 15566, "word": "អធិការិណី" },
    { "id": 15567, "word": "អធិការី " },
    { "id": 15568, "word": "អធិក្រម" },
    { "id": 15569, "word": "អធិក្រឹតិ" },
    { "id": 15570, "word": "អធិគត" },
    { "id": 15571, "word": "អធិគត --" },
    { "id": 15572, "word": "អធិគម" },
    { "id": 15573, "word": "អធិគុណ" },
    { "id": 15574, "word": "អធិគុណា" },
    { "id": 15575, "word": "អធិចិត្ត" },
    { "id": 15576, "word": "អធិជ័យ" },
    { "id": 15577, "word": "អធិជេដ្ឋ" },
    { "id": 15578, "word": "អធិជេដ្ឋា" },
    { "id": 15579, "word": "អធិជ្យោតិស" },
    { "id": 15580, "word": "អធិដ្ឋាន" },
    { "id": 15581, "word": "អធិប" },
    { "id": 15582, "word": "អធិបតី" },
    { "id": 15583, "word": "អធិបតេយ្យ" },
    { "id": 15584, "word": "អធិប្បញ្ញា" },
    { "id": 15585, "word": "អធិប្បាយ" },
    { "id": 15586, "word": "អធិព្រឹក្ស" },
    { "id": 15587, "word": "អធិភូ" },
    { "id": 15588, "word": "អធិមត្ត" },
    { "id": 15589, "word": "អធិមានិក" },
    { "id": 15590, "word": "អធិមានិកា" },
    { "id": 15591, "word": "អធិមុត្តិ" },
    { "id": 15592, "word": "អធិមោក្ខ" },
    { "id": 15593, "word": "អធិយោគ" },
    { "id": 15594, "word": "អធិរាជ" },
    { "id": 15595, "word": "អធិរាជិនី" },
    { "id": 15596, "word": "អធិរោហិណី" },
    { "id": 15597, "word": "អធិលោក" },
    { "id": 15598, "word": "អធិវចនៈ" },
    { "id": 15599, "word": "អធិវាស" },
    { "id": 15600, "word": "អធិវាសន" },
    { "id": 15601, "word": "អធិវាសនា" },
    { "id": 15602, "word": "អធិសីល" },
    { "id": 15603, "word": "អធិស្ឋាន" },
    { "id": 15604, "word": "អធីន" },
    { "id": 15605, "word": "អធុនាគត" },
    { "id": 15606, "word": "អធុនាគតា" },
    { "id": 15607, "word": "អធុនិក" },
    { "id": 15608, "word": "អធុនិកា" },
    { "id": 15609, "word": "អធោ" },
    { "id": 15610, "word": "អធោ --" },
    { "id": 15611, "word": "អធ្យាស្រ័យ" },
    { "id": 15612, "word": "អធ្យោគ" },
    { "id": 15613, "word": "អធ្រាត្រ" },
    { "id": 15614, "word": "អធ្វ័ន" },
    { "id": 15615, "word": "អន" },
    { "id": 15616, "word": "អន់" },
    { "id": 15617, "word": "អនគ្ឃ" },
    { "id": 15618, "word": "អនគ្ឃា" },
    { "id": 15619, "word": "អនង្គ" },
    { "id": 15620, "word": "អនង្គ --" },
    { "id": 15621, "word": "អនង្គណ" },
    { "id": 15622, "word": "អនញ្ញ" },
    { "id": 15623, "word": "អនញ្ញ --" },
    { "id": 15624, "word": "អនត្តលក្ខណ" },
    { "id": 15625, "word": "អនត្តសញ្ញា" },
    { "id": 15626, "word": "អនត្តា" },
    { "id": 15627, "word": "អនត្តា --" },
    { "id": 15628, "word": "អនត្ថ" },
    { "id": 15629, "word": "អនត្ថ --" },
    { "id": 15630, "word": "អនន្ត" },
    { "id": 15631, "word": "អនន្ត --" },
    { "id": 15632, "word": "អនន្តរ" },
    { "id": 15633, "word": "អនន្តរ --" },
    { "id": 15634, "word": "អនន្តរិយកម្ម" },
    { "id": 15635, "word": "អនន្តា --" },
    { "id": 15636, "word": "អនភិសិត្តរាជ" },
    { "id": 15637, "word": "អនរិយ" },
    { "id": 15638, "word": "អនរិយ --" },
    { "id": 15639, "word": "អនវតប្តៈ" },
    { "id": 15640, "word": "អនវទ្យ" },
    { "id": 15641, "word": "អនវ៉ន" },
    { "id": 15642, "word": "អនស្ចារ្យ" },
    { "id": 15643, "word": "អនាកុល" },
    { "id": 15644, "word": "អនាគត" },
    { "id": 15645, "word": "អនាគត --" },
    { "id": 15646, "word": "អនាគម" },
    { "id": 15647, "word": "អនាគាមា" },
    { "id": 15648, "word": "អនាគាមិ --" },
    { "id": 15649, "word": "អនាគាមី" },
    { "id": 15650, "word": "អនាគារ" },
    { "id": 15651, "word": "អនាគារិយ" },
    { "id": 15652, "word": "អនាចារ" },
    { "id": 15653, "word": "អនាតុរភាព" },
    { "id": 15654, "word": "អនាត្ម័ន" },
    { "id": 15655, "word": "អនាថ" },
    { "id": 15656, "word": "អនាថ --" },
    { "id": 15657, "word": "អនាថបិណ្ឌិក" },
    { "id": 15658, "word": "អនាថា" },
    { "id": 15659, "word": "អនាទរ" },
    { "id": 15660, "word": "អនាទរ --" },
    { "id": 15661, "word": "អនាទិភាព" },
    { "id": 15662, "word": "អនាធិបតេយ្យ" },
    { "id": 15663, "word": "អនាបត្តិ" },
    { "id": 15664, "word": "អនាមយ" },
    { "id": 15665, "word": "អនាមយ --" },
    { "id": 15666, "word": "អនាមរូប" },
    { "id": 15667, "word": "អនាមិក" },
    { "id": 15668, "word": "អនាយ៌" },
    { "id": 15669, "word": "អនាល័យ" },
    { "id": 15670, "word": "អនាវាស" },
    { "id": 15671, "word": "អនាវាសា" },
    { "id": 15672, "word": "អនាសវ --" },
    { "id": 15673, "word": "អនាសវៈ" },
    { "id": 15674, "word": "អនាសវា" },
    { "id": 15675, "word": "អនាស្រព" },
    { "id": 15676, "word": "អនិច្ច" },
    { "id": 15677, "word": "អនិច្ច --" },
    { "id": 15678, "word": "អនិច្ចំ" },
    { "id": 15679, "word": "អនិច្ចា" },
    { "id": 15680, "word": "អនិច្ចា --" },
    { "id": 15681, "word": "អនិដ្ឋារម្មណ៍" },
    { "id": 15682, "word": "អនិទ្រា" },
    { "id": 15683, "word": "អនិមន្តន៍" },
    { "id": 15684, "word": "អនិមិត្ត" },
    { "id": 15685, "word": "អនិយត" },
    { "id": 15686, "word": "អនិយម" },
    { "id": 15687, "word": "អនិយម --" },
    { "id": 15688, "word": "អនិល" },
    { "id": 15689, "word": "អនិស្សយមុត្តក" },
    { "id": 15690, "word": "អនិស្សយមុត្តិកា" },
    { "id": 15691, "word": "អនិស្សរ" },
    { "id": 15692, "word": "អនិស្សរ --" },
    { "id": 15693, "word": "អនីកទស្សន៍" },
    { "id": 15694, "word": "អនីកលក្ខណៈ" },
    { "id": 15695, "word": "អនុ" },
    { "id": 15696, "word": "អនុ --" },
    { "id": 15697, "word": "អនុកូល" },
    { "id": 15698, "word": "អនុគ្រោះ" },
    { "id": 15699, "word": "អនុជ" },
    { "id": 15700, "word": "អនុញ្ញាត" },
    { "id": 15701, "word": "អនុត្តរ" },
    { "id": 15702, "word": "អនុត្ថេរ" },
    { "id": 15703, "word": "អនុទិស" },
    { "id": 15704, "word": "អនុទូត" },
    { "id": 15705, "word": "អនុធម្មចារិនី" },
    { "id": 15706, "word": "អនុនាយក" },
    { "id": 15707, "word": "អនុបការ" },
    { "id": 15708, "word": "អនុបចារ" },
    { "id": 15709, "word": "អនុបត្ថម្ភ" },
    { "id": 15710, "word": "អនុបត្ថម្ភក" },
    { "id": 15711, "word": "អនុបត្ថម្ភិកា" },
    { "id": 15712, "word": "អនុបទេស" },
    { "id": 15713, "word": "អនុបទ្រព" },
    { "id": 15714, "word": "អនុបធិ" },
    { "id": 15715, "word": "អនុបភោគ" },
    { "id": 15716, "word": "អនុបមា" },
    { "id": 15717, "word": "អនុបមេយ្យ" },
    { "id": 15718, "word": "អនុបវាទ" },
    { "id": 15719, "word": "អនុបវាទិន" },
    { "id": 15720, "word": "អនុបវាទី" },
    { "id": 15721, "word": "អនុបសគ្គ" },
    { "id": 15722, "word": "អនុបសម្បន្ន" },
    { "id": 15723, "word": "អនុបសម្បន្នា" },
    { "id": 15724, "word": "អនុបាទិន្នក" },
    { "id": 15725, "word": "អនុបាទិសេសនិព្វាន" },
    { "id": 15726, "word": "អនុប្រការ" },
    { "id": 15727, "word": "អនុប្រយោគ" },
    { "id": 15728, "word": "អនុពាល" },
    { "id": 15729, "word": "អនុភាព" },
    { "id": 15730, "word": "អនុមន្ត្រី" },
    { "id": 15731, "word": "អនុមាត្រា" },
    { "id": 15732, "word": "អនុមោទនា" },
    { "id": 15733, "word": "អនុយោគ" },
    { "id": 15734, "word": "អនុលោម" },
    { "id": 15735, "word": "អនុវាត" },
    { "id": 15736, "word": "អនុសារ" },
    { "id": 15737, "word": "អនុស្វារ" },
    { "id": 15738, "word": "អនុស្សាវនក" },
    { "id": 15739, "word": "អនុស្សាវនា" },
    { "id": 15740, "word": "អនុស្សាវរីយ" },
    { "id": 15741, "word": "អនេក" },
    { "id": 15742, "word": "អនេក --" },
    { "id": 15743, "word": "អនេកត្ថសំខ្យា" },
    { "id": 15744, "word": "អនេសនៈ" },
    { "id": 15745, "word": "អនោកាស" },
    { "id": 15746, "word": "អនោតត្ត" },
    { "id": 15747, "word": "អនោតត្តស្រះ" },
    { "id": 15748, "word": "អនោម" },
    { "id": 15749, "word": "អនោម --" },
    { "id": 15750, "word": "អនោមទស្សី" },
    { "id": 15751, "word": "អនោសជ្ជភាព" },
    { "id": 15752, "word": "អន្ត" },
    { "id": 15753, "word": "អន្ត --" },
    { "id": 15754, "word": "អន្តៈ" },
    { "id": 15755, "word": "អន្តគុណ" },
    { "id": 15756, "word": "អន្តយ" },
    { "id": 15757, "word": "អន្តរ" },
    { "id": 15758, "word": "អន្ដរ !" },
    { "id": 15759, "word": "អន្តរ --" },
    { "id": 15760, "word": "អន្តរដ្ឋកា" },
    { "id": 15761, "word": "អន្តរត្ថវាចក" },
    { "id": 15762, "word": "អន្ដរធាន" },
    { "id": 15763, "word": "អន្តរវាសក" },
    { "id": 15764, "word": "អន្តរា" },
    { "id": 15765, "word": "អន្តរា --" },
    { "id": 15766, "word": "អន្តរាគមន៍" },
    { "id": 15767, "word": "អន្តរាយ" },
    { "id": 15768, "word": "អន្តរាយិកធម៌" },
    { "id": 15769, "word": "អន្តរីក្ស" },
    { "id": 15770, "word": "អន្តរីប" },
    { "id": 15771, "word": "អន្តលិក្ខ" },
    { "id": 15772, "word": "អន្តសយ្យា" },
    { "id": 15773, "word": "អន្តាក់អន្តិច" },
    { "id": 15774, "word": "អន្តាយ" },
    { "id": 15775, "word": "អន្តិតអន្តូង" },
    { "id": 15776, "word": "អន្តិម" },
    { "id": 15777, "word": "អន្តិម --" },
    { "id": 15778, "word": "អន្តឺត" },
    { "id": 15779, "word": "អន្តឺរ៉ឺរ៉ឺត" },
    { "id": 15780, "word": "អន្តុយ" },
    { "id": 15781, "word": "អន្តុល" },
    { "id": 15782, "word": "អន្តេ" },
    { "id": 15783, "word": "អន្តេ --" },
    { "id": 15784, "word": "អន្តេបអន្តាប" },
    { "id": 15785, "word": "អន្តេវាសិក" },
    { "id": 15786, "word": "អន្តេវាសិន" },
    { "id": 15787, "word": "អន្តែងអន្តៃ" },
    { "id": 15788, "word": "អន្តោ" },
    { "id": 15789, "word": "អន្តោ --" },
    { "id": 15790, "word": "អន្ត្រត" },
    { "id": 15791, "word": "អន្ត្រាក់" },
    { "id": 15792, "word": "អន្ត្រឹក" },
    { "id": 15793, "word": "អន្ត្រុក" },
    { "id": 15794, "word": "អន្ត្រើក" },
    { "id": 15795, "word": "អន្ត្រោក" },
    { "id": 15796, "word": "អន្ថម" },
    { "id": 15797, "word": "អន្ថឺម" },
    { "id": 15798, "word": "អន្ថោចៗ" },
    { "id": 15799, "word": "អន្ទង" },
    { "id": 15800, "word": "អន្ទង់" },
    { "id": 15801, "word": "អន្ទង់បារ" },
    { "id": 15802, "word": "អន្ទង់រុក" },
    { "id": 15803, "word": "អន្ទង់វិត" },
    { "id": 15804, "word": "អន្ទង់អាំង" },
    { "id": 15805, "word": "អន្ទាក់" },
    { "id": 15806, "word": "អន្ទាក់ខ្លា" },
    { "id": 15807, "word": "អន្ទិកា" },
    { "id": 15808, "word": "អន្ទិល" },
    { "id": 15809, "word": "អន្ទឺរឺរឺត" },
    { "id": 15810, "word": "អន្ទុ" },
    { "id": 15811, "word": "អន្ទើត" },
    { "id": 15812, "word": "អន្ទោក" },
    { "id": 15813, "word": "អន្ទោកអន្ទោល" },
    { "id": 15814, "word": "អន្ទោល" },
    { "id": 15815, "word": "អន្ទាំស្លា" },
    { "id": 15816, "word": "អន្ទះសា" },
    { "id": 15817, "word": "អន្ទះអន្ទែង" },
    { "id": 15818, "word": "អន្ទ្រក់" },
    { "id": 15819, "word": "អន្ទ្រត" },
    { "id": 15820, "word": "អន្ទ្រាក" },
    { "id": 15821, "word": "អន្ទ្រាម" },
    { "id": 15822, "word": "អន្ទ្រឺត" },
    { "id": 15823, "word": "អន្ទ្រុក" },
    { "id": 15824, "word": "អន្ទ្រូត" },
    { "id": 15825, "word": "អន្ទ្រើតៗ" },
    { "id": 15826, "word": "អន្ទ្រើម" },
    { "id": 15827, "word": "អន្ធ" },
    { "id": 15828, "word": "អន្ធ --" },
    { "id": 15829, "word": "អន្ធិកា" },
    { "id": 15830, "word": "អន្ធិល" },
    { "id": 15831, "word": "អន្ធូ --" },
    { "id": 15832, "word": "អន្ទួម" },
    { "id": 15833, "word": "អន្ធើម" },
    { "id": 15834, "word": "អន្ធោ" },
    { "id": 15835, "word": "អន្ន" },
    { "id": 15836, "word": "អន្ន --" },
    { "id": 15837, "word": "អន្យតិរ្ថិយ" },
    { "id": 15838, "word": "អន្យបទ" },
    { "id": 15839, "word": "អន្លក់" },
    { "id": 15840, "word": "អន្លង" },
    { "id": 15841, "word": "អន្លង់" },
    { "id": 15842, "word": "អន្លាយ" },
    { "id": 15843, "word": "អន្លីង" },
    { "id": 15844, "word": "អន្លឹប" },
    { "id": 15845, "word": "អន្លូង" },
    { "id": 15846, "word": "អន្លូងក្បាលស្វា" },
    { "id": 15847, "word": "អន្លូញ" },
    { "id": 15848, "word": "អន្លើ" },
    { "id": 15849, "word": "អន្លៃ" },
    { "id": 15850, "word": "អន្វក្ខរៈ" },
    { "id": 15851, "word": "អន្វយវាចក" },
    { "id": 15852, "word": "អន្វេស" },
    { "id": 15853, "word": "អន្សម" },
    { "id": 15854, "word": "អប" },
    { "id": 15855, "word": "អប់" },
    { "id": 15856, "word": "អប" },
    { "id": 15857, "word": "អប --" },
    { "id": 15858, "word": "អបចាយន" },
    { "id": 15859, "word": "អបចាយិត" },
    { "id": 15860, "word": "អបចាយិតា" },
    { "id": 15861, "word": "អបណ្ណកប្បដិបទា" },
    { "id": 15862, "word": "អបទេស" },
    { "id": 15863, "word": "អបមង្គល" },
    { "id": 15864, "word": "អបមារ" },
    { "id": 15865, "word": "អបយស" },
    { "id": 15866, "word": "អបរកាល" },
    { "id": 15867, "word": "អបរគោយាន" },
    { "id": 15868, "word": "អបរណ្ណជាតិ" },
    { "id": 15869, "word": "អបរភាគ" },
    { "id": 15870, "word": "អបរលោក" },
    { "id": 15871, "word": "អបរសម័យ" },
    { "id": 15872, "word": "អបរាជ័យ" },
    { "id": 15873, "word": "អបរាជិត" },
    { "id": 15874, "word": "អបរាធ" },
    { "id": 15875, "word": "អបរិមាណ" },
    { "id": 15876, "word": "អបរិមាណ --" },
    { "id": 15877, "word": "អបរិយោសាន" },
    { "id": 15878, "word": "អបរូប" },
    { "id": 15879, "word": "អបរូបា" },
    { "id": 15880, "word": "អប់រំ" },
    { "id": 15881, "word": "អបលក្ខណ៍" },
    { "id": 15882, "word": "អបលាភ" },
    { "id": 15883, "word": "អបលាភា" },
    { "id": 15884, "word": "អបលោក" },
    { "id": 15885, "word": "អបលោកន" },
    { "id": 15886, "word": "អបលោភ" },
    { "id": 15887, "word": "អបលោភា" },
    { "id": 15888, "word": "អបវាទ" },
    { "id": 15889, "word": "អបសក្តិ" },
    { "id": 15890, "word": "អបហារ" },
    { "id": 15891, "word": "អបហាស" },
    { "id": 15892, "word": "អបាករណ៍" },
    { "id": 15893, "word": "អបាចី" },
    { "id": 15894, "word": "អបាទក" },
    { "id": 15895, "word": "អបាយ" },
    { "id": 15896, "word": "អបាយ --" },
    { "id": 15897, "word": "អបុញ្ញលាភ" },
    { "id": 15898, "word": "អបុញ្ញាភិ សង្ខារ" },
    { "id": 15899, "word": "អបុត្តក" },
    { "id": 15900, "word": "អបុត្តកោ" },
    { "id": 15901, "word": "អបុត្តិកា" },
    { "id": 15902, "word": "អបុនប្បុនក្កម្ម" },
    { "id": 15903, "word": "អបេក្ខា" },
    { "id": 15904, "word": "អបេតវិញ្ញាណ" },
    { "id": 15905, "word": "អបោគណ្ឌ" },
    { "id": 15906, "word": "អប្ប" },
    { "id": 15907, "word": "អប្ប --" },
    { "id": 15908, "word": "អប្បការ" },
    { "id": 15909, "word": "អប្បច្ចយភាព" },
    { "id": 15910, "word": "អប្បដិ" },
    { "id": 15911, "word": "អប្បដិ --" },
    { "id": 15912, "word": "អប្បនា" },
    { "id": 15913, "word": "អប្បនា --" },
    { "id": 15914, "word": "អប្បមាណ" },
    { "id": 15915, "word": "អប្បមាណ --" },
    { "id": 15916, "word": "អប្បមាទ" },
    { "id": 15917, "word": "អប្បមាទ --" },
    { "id": 15918, "word": "អប្បមេយ្យ" },
    { "id": 15919, "word": "អប្បសាន្ត" },
    { "id": 15920, "word": "អប្បិច្ឆ" },
    { "id": 15921, "word": "អប្បិច្ឆ --" },
    { "id": 15922, "word": "អប្បិច្ឆា" },
    { "id": 15923, "word": "អប្បិច្ឆោ" },
    { "id": 15924, "word": "អប្បិយ" },
    { "id": 15925, "word": "អប្បិយ --," },
    { "id": 15926, "word": "អប្បេសក្ខ" },
    { "id": 15927, "word": "អប្បេសក្ខ --" },
    { "id": 15928, "word": "អប្បោទក" },
    { "id": 15929, "word": "អប្បោទក --" },
    { "id": 15930, "word": "អប្ផោដនសព្ទ" },
    { "id": 15931, "word": "អប្រការ" },
    { "id": 15932, "word": "អប្រតិ --" },
    { "id": 15933, "word": "អប្រមាណ" },
    { "id": 15934, "word": "អប្រមាថ" },
    { "id": 15935, "word": "អប្រិយ" },
    { "id": 15936, "word": "អប្សរ" },
    { "id": 15937, "word": "អប្សរា" },
    { "id": 15938, "word": "អប្សាន្ត" },
    { "id": 15939, "word": "អផលព្រឹក្ស" },
    { "id": 15940, "word": "អផលប្រទានព្រឹក្ស" },
    { "id": 15941, "word": "អផាសុ" },
    { "id": 15942, "word": "អផាសុក" },
    { "id": 15943, "word": "អផ្ទក់" },
    { "id": 15944, "word": "អផ្ទង់" },
    { "id": 15945, "word": "អផ្ទាញ" },
    { "id": 15946, "word": "អផ្សុក" },
    { "id": 15947, "word": "អផ្សាន" },
    { "id": 15948, "word": "អព័ទ្ធ" },
    { "id": 15949, "word": "អពទ្ធសីមា" },
    { "id": 15950, "word": "អពពៈ" },
    { "id": 15951, "word": "អពមង្គល" },
    { "id": 15952, "word": "អពយព" },
    { "id": 15953, "word": "អពល" },
    { "id": 15954, "word": "អពលា" },
    { "id": 15955, "word": "អពុទ្ធិ" },
    { "id": 15956, "word": "អ័ព្ទ" },
    { "id": 15957, "word": "អព្វុទ" },
    { "id": 15958, "word": "អញ្វេហារិក" },
    { "id": 15959, "word": "អព្វោហារិកា" },
    { "id": 15960, "word": "អព្ភ" },
    { "id": 15961, "word": "អព្ភ --" },
    { "id": 15962, "word": "អព្ភក្ខាន" },
    { "id": 15963, "word": "អព្ភក្ខាន --" },
    { "id": 15964, "word": "អព្ភន្តរ" },
    { "id": 15965, "word": "អព្ភន្តរ --" },
    { "id": 15966, "word": "អព្ភា" },
    { "id": 15967, "word": "អញ្ភន" },
    { "id": 15968, "word": "អញ្ភស" },
    { "id": 15969, "word": "អព្ភូត" },
    { "id": 15970, "word": "អព្ភោកាស" },
    { "id": 15971, "word": "អព្ភោកាសិក" },
    { "id": 15972, "word": "អព្យត្ត" },
    { "id": 15973, "word": "អព្យត្ត --" },
    { "id": 15974, "word": "អព្យព" },
    { "id": 15975, "word": "អព្យយៈ" },
    { "id": 15976, "word": "អព្យយីភាព" },
    { "id": 15977, "word": "អព្យាកត " },
    { "id": 15978, "word": "អព្យាបាទ" },
    { "id": 15979, "word": "អព្រហ្មចរិយ" },
    { "id": 15980, "word": "អព្រហ្មចារិនី " },
    { "id": 15981, "word": "អព្រហ្មចារី" },
    { "id": 15982, "word": "អភព្វ --" },
    { "id": 15983, "word": "អភ័ព្វ" },
    { "id": 15984, "word": "អភញ្វ" },
    { "id": 15985, "word": "អភយ --" },
    { "id": 15986, "word": "អភ័យ" },
    { "id": 15987, "word": "អភយូ --" },
    { "id": 15988, "word": "អភាព " },
    { "id": 15989, "word": "អភិ" },
    { "id": 15990, "word": "អភិ --" },
    { "id": 15991, "word": "អភិជ្ឈា" },
    { "id": 15992, "word": "អភិញ្ញា" },
    { "id": 15993, "word": "អភិញ្ញាណ" },
    { "id": 15994, "word": "អភិណ្ហ" },
    { "id": 15995, "word": "អភិណ្ហ --" },
    { "id": 15996, "word": "អភិទោស" },
    { "id": 15997, "word": "អភិទ្រោះ" },
    { "id": 15998, "word": "អភិធជមហារដ្ឋគុរុ" },
    { "id": 15999, "word": "អភិធម្ម " },
    { "id": 16000, "word": "អភិធាន" },
    { "id": 16001, "word": "អភិធានសព្ទ" },
    { "id": 16002, "word": "អភិនិវេស" },
    { "id": 16003, "word": "អភិនិស្ក្រមណ៍" },
    { "id": 16004, "word": "អភិនីហារ" },
    { "id": 16005, "word": "អភិនីហារសម្បន្ន" },
    { "id": 16006, "word": "អភិនេស្ក្រម៍" },
    { "id": 16007, "word": "អភិនេស្ក្រមណ៍" },
    { "id": 16008, "word": "អភិបាល" },
    { "id": 16009, "word": "អភិបាល --" },
    { "id": 16010, "word": "អភិប្រណិប័ត" },
    { "id": 16011, "word": "អភិប្រណិប័តន៍ " },
    { "id": 16012, "word": "អភិប្រាយ" },
    { "id": 16013, "word": "អភិមង្គល" },
    { "id": 16014, "word": "អភិមង្គល៍" },
    { "id": 16015, "word": "អភិរដ្ឋមន្ត្រី" },
    { "id": 16016, "word": "អភិរម" },
    { "id": 16017, "word": "អភិរម្យ" },
    { "id": 16018, "word": "អភិរាជ" },
    { "id": 16019, "word": "អភិរាម" },
    { "id": 16020, "word": "អភិរាស្ត្រមន្ត្រី" },
    { "id": 16021, "word": "អភិរូហ៍" },
    { "id": 16022, "word": "អភិរំ" },
    { "id": 16023, "word": "អភិលក្ខិតកាល" },
    { "id": 16024, "word": "អភិវឌ្ឍ" },
    { "id": 16025, "word": "អភិវន្ទ" },
    { "id": 16026, "word": "អភិវន្ទន៍" },
    { "id": 16027, "word": "អភិសម័យ" },
    { "id": 16028, "word": "អភិសមាចារ" },
    { "id": 16029, "word": "អភិសមាចារិកវត្ត" },
    { "id": 16030, "word": "អភិសម្ពោធិ" },
    { "id": 16031, "word": "អភិសិត្តរាជ" },
    { "id": 16032, "word": "អភិសេក" },
    { "id": 16033, "word": "អភិសោធ" },
    { "id": 16034, "word": "អភិសោធន៍" },
    { "id": 16035, "word": "អភូត" },
    { "id": 16036, "word": "អភូត --" },
    { "id": 16037, "word": "អភេជ្ជរូប" },
    { "id": 16038, "word": "អភេទ" },
    { "id": 16039, "word": "អភ្យាគត" },
    { "id": 16040, "word": "អភ្យាគម" },
    { "id": 16041, "word": "អភ្យាគមនាគមន៍" },
    { "id": 16042, "word": "អ័ភ្រ" },
    { "id": 16043, "word": "អភ្រំសៈ" },
    { "id": 16044, "word": "អម" },
    { "id": 16045, "word": "អមគម" },
    { "id": 16046, "word": "អមគាង" },
    { "id": 16047, "word": "អមច្ចា" },
    { "id": 16048, "word": "អមត" },
    { "id": 16049, "word": "អមត --" },
    { "id": 16050, "word": "អមត្តញ្ញុតា" },
    { "id": 16051, "word": "អមត្តញ្ញូ" },
    { "id": 16052, "word": "អមនុស្ស" },
    { "id": 16053, "word": "អមរ" },
    { "id": 16054, "word": "អមរ --" },
    { "id": 16055, "word": "អមរគោយាន" },
    { "id": 16056, "word": "អមរា --" },
    { "id": 16057, "word": "អមរាវិក្ខេប" },
    { "id": 16058, "word": "អមរិន្ទ" },
    { "id": 16059, "word": "អមាត្យ" },
    { "id": 16060, "word": "អមាវសី" },
    { "id": 16061, "word": "អមិដា" },
    { "id": 16062, "word": "អមិត " },
    { "id": 16063, "word": "អមិតាភៈ" },
    { "id": 16064, "word": "អមិតាយុស" },
    { "id": 16065, "word": "អមិត្ត" },
    { "id": 16066, "word": "អមូល" },
    { "id": 16067, "word": "អមូលកែ" },
    { "id": 16068, "word": "អមោក្ស" },
    { "id": 16069, "word": "អមោក្សា" },
    { "id": 16070, "word": "អមោឃ" },
    { "id": 16071, "word": "អមោឃ --" },
    { "id": 16072, "word": "អមោហៈ" },
    { "id": 16073, "word": "អម្ចត់" },
    { "id": 16074, "word": "អម្ចាស់" },
    { "id": 16075, "word": "អម្នេញ" },
    { "id": 16076, "word": "អម្បាញ់មិញ" },
    { "id": 16077, "word": "អម្បាយ" },
    { "id": 16078, "word": "អម្បាល" },
    { "id": 16079, "word": "អម្បាល  --" },
    { "id": 16080, "word": "អម្បូរ" },
    { "id": 16081, "word": "អម្បោស" },
    { "id": 16082, "word": "អម្ព" },
    { "id": 16083, "word": "អម្ពកា" },
    { "id": 16084, "word": "អម្ពរ" },
    { "id": 16085, "word": "អម្ពា" },
    { "id": 16086, "word": "អម្ពាលា" },
    { "id": 16087, "word": "អម្ពិល" },
    { "id": 16088, "word": "អម្ពិលទឹក" },
    { "id": 16089, "word": "អម្ពិលប្រក់ផ្លែ" },
    { "id": 16090, "word": "អម្ពុ" },
    { "id": 16091, "word": "អម្ពុ --" },
    { "id": 16092, "word": "អម្ពុះ" },
    { "id": 16093, "word": "អម្ភ័ស" },
    { "id": 16094, "word": "អម្ភោ ! " },
    { "id": 16095, "word": "អម្ភោជិនី" },
    { "id": 16096, "word": "អម្ភោទ" },
    { "id": 16097, "word": "អម្ភោធិ" },
    { "id": 16098, "word": "អម្មា" },
    { "id": 16099, "word": "អម្រ" },
    { "id": 16100, "word": "អម្រស់" },
    { "id": 16101, "word": "អម្រាម" },
    { "id": 16102, "word": "អម្រឹត" },
    { "id": 16103, "word": "អយនកាល" },
    { "id": 16104, "word": "អយនភាគ" },
    { "id": 16105, "word": "អយសង្ខលិក" },
    { "id": 16106, "word": "អយស្កាន្ត" },
    { "id": 16107, "word": "អយស្ការ" },
    { "id": 16108, "word": "អយស្កុម្ភ" },
    { "id": 16109, "word": "អយស្ម័យ" },
    { "id": 16110, "word": "អយីដា" },
    { "id": 16111, "word": "អយុត្ត" },
    { "id": 16112, "word": "អយុត្ត --" },
    { "id": 16113, "word": "អយុត្តិធម៌" },
    { "id": 16114, "word": "អយុទ្ធ" },
    { "id": 16115, "word": "អយុធ្យា" },
    { "id": 16116, "word": "អយោ" },
    { "id": 16117, "word": "អយោ --" },
    { "id": 16118, "word": "អយោគិន" },
    { "id": 16119, "word": "អយោគី" },
    { "id": 16120, "word": "អយោធ" },
    { "id": 16121, "word": "អយោធិន" },
    { "id": 16122, "word": "អយោធ្យា" },
    { "id": 16123, "word": "អយោនិសោមនសិការ" },
    { "id": 16124, "word": "អយ្យ" },
    { "id": 16125, "word": "អយ្យ --" },
    { "id": 16126, "word": "អយ្យក" },
    { "id": 16127, "word": "អយ្យក --" },
    { "id": 16128, "word": "អយ្យកា" },
    { "id": 16129, "word": "អយ្យការ" },
    { "id": 16130, "word": "អយ្យកោ" },
    { "id": 16131, "word": "អយ្យា" },
    { "id": 16132, "word": "អយ្យិកា" },
    { "id": 16133, "word": "អរ" },
    { "id": 16134, "word": "អរ --" },
    { "id": 16135, "word": "អរក្ខកម្ម" },
    { "id": 16136, "word": "អរជុន" },
    { "id": 16137, "word": "អរជូន" },
    { "id": 16138, "word": "អរញ្ញ" },
    { "id": 16139, "word": "អរញ្ញ --" },
    { "id": 16140, "word": "អរញ្ញិក" },
    { "id": 16141, "word": "អរណី" },
    { "id": 16142, "word": "អរណ្យ" },
    { "id": 16143, "word": "អរពិន្ទ" },
    { "id": 16144, "word": "អរសភាព" },
    { "id": 16145, "word": "អរសរូប" },
    { "id": 16146, "word": "អរហត្ត" },
    { "id": 16147, "word": "អរហទ្ធជ" },
    { "id": 16148, "word": "អរហន្ត" },
    { "id": 16149, "word": "អរហន្តា" },
    { "id": 16150, "word": "អរហា" },
    { "id": 16151, "word": "អរហំ" },
    { "id": 16152, "word": "អរាគ" },
    { "id": 16153, "word": "អារាគា" },
    { "id": 16154, "word": "អរាជក" },
    { "id": 16155, "word": "អរិ" },
    { "id": 16156, "word": "អរិ --" },
    { "id": 16157, "word": "អរិយ" },
    { "id": 16158, "word": "អរិយ --" },
    { "id": 16159, "word": "អរិយក" },
    { "id": 16160, "word": "អរិយក --" },
    { "id": 16161, "word": "អរិយុ --" },
    { "id": 16162, "word": "អរុណ" },
    { "id": 16163, "word": "អរុណ --" },
    { "id": 16164, "word": "អរូប" },
    { "id": 16165, "word": "អរូប --" },
    { "id": 16166, "word": "អរេ ! " },
    { "id": 16167, "word": "អរោគ" },
    { "id": 16168, "word": "អរោគ --" },
    { "id": 16169, "word": "អឃ៌" },
    { "id": 16170, "word": "អជ៌ុន" },
    { "id": 16171, "word": "អថ៌" },
    { "id": 16172, "word": "អលក្ខិនី" },
    { "id": 16173, "word": "អលក្ខី" },
    { "id": 16174, "word": "អលង្កត" },
    { "id": 16175, "word": "អលង្ករណ៍" },
    { "id": 16176, "word": "អលង្ការ" },
    { "id": 16177, "word": "អលង្ក្រឹត" },
    { "id": 16178, "word": "អលជ្ជាភាព" },
    { "id": 16179, "word": "អលជ្ជិតា" },
    { "id": 16180, "word": "អលជ្ជិនី" },
    { "id": 16181, "word": "អលជ្ជី" },
    { "id": 16182, "word": "អលជ្ជី --" },
    { "id": 16183, "word": "អលសភាព" },
    { "id": 16184, "word": "អល់អែក" },
    { "id": 16185, "word": "អលាភ" },
    { "id": 16186, "word": "អលាភ --" },
    { "id": 16187, "word": "អលាភា !" },
    { "id": 16188, "word": "អលាភោ" },
    { "id": 16189, "word": "អលិង្គ" },
    { "id": 16190, "word": "អលោភ" },
    { "id": 16191, "word": "អលោភោ" },
    { "id": 16192, "word": "អល្បវិទ្យ" },
    { "id": 16193, "word": "អល្លោ !" },
    { "id": 16194, "word": "អវកដ" },
    { "id": 16195, "word": "អវកាស" },
    { "id": 16196, "word": "អវកុដារ" },
    { "id": 16197, "word": "អវគមន៍" },
    { "id": 16198, "word": "អវគ្គ" },
    { "id": 16199, "word": "អវគ្រហៈ" },
    { "id": 16200, "word": "អវគ្រោះ" },
    { "id": 16201, "word": "អវចរ" },
    { "id": 16202, "word": "អវជ័យ" },
    { "id": 16203, "word": "អវជាត" },
    { "id": 16204, "word": "អវជ្ឈាន" },
    { "id": 16205, "word": "អវតារ" },
    { "id": 16206, "word": "អវទាន" },
    { "id": 16207, "word": "អវធាន" },
    { "id": 16208, "word": "អវន្ទីយ" },
    { "id": 16209, "word": "អវមាន" },
    { "id": 16210, "word": "អវយវៈ" },
    { "id": 16211, "word": "អវរុទ្ធ" },
    { "id": 16212, "word": "អវរុទ្ធា" },
    { "id": 16213, "word": "អវលោកនៈ" },
    { "id": 16214, "word": "អវលោកិតេស្វរ" },
    { "id": 16215, "word": "អវលោកេស្វរ" },
    { "id": 16216, "word": "អវសរ" },
    { "id": 16217, "word": "អវសាន" },
    { "id": 16218, "word": "អវសាន --" },
    { "id": 16219, "word": "អវសិដ្ឋ" },
    { "id": 16220, "word": "អវសេក" },
    { "id": 16221, "word": "អវសេស" },
    { "id": 16222, "word": "អវស្រ័យ" },
    { "id": 16223, "word": "អវហារ" },
    { "id": 16224, "word": "អវាចី" },
    { "id": 16225, "word": "អវាដ" },
    { "id": 16226, "word": "អវាសែ" },
    { "id": 16227, "word": "អវិចី" },
    { "id": 16228, "word": "អវិជ្ជន្ធការ" },
    { "id": 16229, "word": "អវិជ្ជមាន" },
    { "id": 16230, "word": "អវិជ្ជា" },
    { "id": 16231, "word": "អវិញ្ញាណក" },
    { "id": 16232, "word": "អវិញ្ញូ" },
    { "id": 16233, "word": "អវិទ្យា" },
    { "id": 16234, "word": "អវិនយ --" },
    { "id": 16235, "word": "អវិន័យ" },
    { "id": 16236, "word": "អវិរុទ្ធ" },
    { "id": 16237, "word": "អវិរុទ្ធ --" },
    { "id": 16238, "word": "អវិរូឡ្ហ" },
    { "id": 16239, "word": "អវិរោធ" },
    { "id": 16240, "word": "អវិរោធនៈ" },
    { "id": 16241, "word": "អវិសារទ" },
    { "id": 16242, "word": "អវិសារទា" },
    { "id": 16243, "word": "អវិស្សាសិក" },
    { "id": 16244, "word": "អវិស្សាសិកា" },
    { "id": 16245, "word": "អវិហា" },
    { "id": 16246, "word": "អវិហិង្សា" },
    { "id": 16247, "word": "អវីចី" },
    { "id": 16248, "word": "អវីតិក្កម" },
    { "id": 16249, "word": "អស់" },
    { "id": 16250, "word": "អស់ --" },
    { "id": 16251, "word": "អសង្ខតធម៌" },
    { "id": 16252, "word": "អសង្ខតធាតុ" },
    { "id": 16253, "word": "អសង្ខេយ្យ" },
    { "id": 16254, "word": "អសង្ខៃយ" },
    { "id": 16255, "word": "អសង្ហារិម --" },
    { "id": 16256, "word": "អសង្ហារិមៈ" },
    { "id": 16257, "word": "អសញ្ញកម្ម" },
    { "id": 16258, "word": "អសញ្ញភាព" },
    { "id": 16259, "word": "អសញ្ញី" },
    { "id": 16260, "word": "អសត្យ" },
    { "id": 16261, "word": "អសត្យ --" },
    { "id": 16262, "word": "អសទិស" },
    { "id": 16263, "word": "អសទិសទាន" },
    { "id": 16264, "word": "អសទ្ធម្ម" },
    { "id": 16265, "word": "អសនី" },
    { "id": 16266, "word": "អសនី --" },
    { "id": 16267, "word": "អសន្តិសុខ" },
    { "id": 16268, "word": "អសប្បុរស" },
    { "id": 16269, "word": "អសប្បុរិស" },
    { "id": 16270, "word": "អសប្បុរិស --" },
    { "id": 16271, "word": "អសព្ភិ" },
    { "id": 16272, "word": "អសព្ភិ --" },
    { "id": 16273, "word": "អសម្ភិន្ន" },
    { "id": 16274, "word": "អសម្ភិន្ន --" },
    { "id": 16275, "word": "អស់លោក" },
    { "id": 16276, "word": "អស់អញ" },
    { "id": 16277, "word": "អស់អញលំគេញ" },
    { "id": 16278, "word": "អស់អ្នក" },
    { "id": 16279, "word": "អសាកល្យត្ថវាចក" },
    { "id": 16280, "word": "អសាធារណ" },
    { "id": 16281, "word": "អសាធារណៈ" },
    { "id": 16282, "word": "អសាធុ" },
    { "id": 16283, "word": "អសាធុ --" },
    { "id": 16284, "word": "អសារ" },
    { "id": 16285, "word": "អសារ --" },
    { "id": 16286, "word": "អសិរិកា" },
    { "id": 16287, "word": "អសិរី" },
    { "id": 16288, "word": "អសីតិសាវក" },
    { "id": 16289, "word": "អសីត្យានុព្យញ្ជនៈ" },
    { "id": 16290, "word": "អសុចិ" },
    { "id": 16291, "word": "អសុចិ --" },
    { "id": 16292, "word": "អសុទ្ធិ" },
    { "id": 16293, "word": "អសុទ្ធិ --" },
    { "id": 16294, "word": "អសុន្ទរ" },
    { "id": 16295, "word": "អសុន្ទរ --" },
    { "id": 16296, "word": "អសុន្ទរា" },
    { "id": 16297, "word": "អសុភ" },
    { "id": 16298, "word": "អសុភ --" },
    { "id": 16299, "word": "អសុភា" },
    { "id": 16300, "word": "អសុរ" },
    { "id": 16301, "word": "អសុរ --" },
    { "id": 16302, "word": "អសុរិន្ទ" },
    { "id": 16303, "word": "អសុរី" },
    { "id": 16304, "word": "អសុរោះ" },
    { "id": 16305, "word": "អសេក្ខ --" },
    { "id": 16306, "word": "អសេក្ខៈ" },
    { "id": 16307, "word": "អសេរិនី" },
    { "id": 16308, "word": "អសេរី" },
    { "id": 16309, "word": "អសេរី --" },
    { "id": 16310, "word": "អសោក" },
    { "id": 16311, "word": "អសោច" },
    { "id": 16312, "word": "អសំហារិមៈ" },
    { "id": 16313, "word": "អស្ចារ្យ" },
    { "id": 16314, "word": "អស្តង្គត" },
    { "id": 16315, "word": "អស្តង្គត --" },
    { "id": 16316, "word": "អស្តង្គមន៍" },
    { "id": 16317, "word": "អស្តា" },
    { "id": 16318, "word": "អស្តា --" },
    { "id": 16319, "word": "អស្មិ" },
    { "id": 16320, "word": "អស្មិមានះ" },
    { "id": 16321, "word": "អស្រី" },
    { "id": 16322, "word": "អស្វ" },
    { "id": 16323, "word": "អស្វ --" },
    { "id": 16324, "word": "អស្វត្ថព្រឹក្ស" },
    { "id": 16325, "word": "អស្វយុជ" },
    { "id": 16326, "word": "អស្វា --" },
    { "id": 16327, "word": "អស្វាមិក" },
    { "id": 16328, "word": "អស្វាមិកា" },
    { "id": 16329, "word": "អស្វិន" },
    { "id": 16330, "word": "អស្វៃរិន" },
    { "id": 16331, "word": "អស្ស --" },
    { "id": 16332, "word": "អស្សត្ថព្រឹក្ស" },
    { "id": 16333, "word": "អស្សយុជ" },
    { "id": 16334, "word": "អស្សា --" },
    { "id": 16335, "word": "អស្សាមិក" },
    { "id": 16336, "word": "អស្សាមិកា" },
    { "id": 16337, "word": "អស្សាសៈ" },
    { "id": 16338, "word": "អស្សាសប្បស្សាសៈ" },
    { "id": 16339, "word": "អស្សុ" },
    { "id": 16340, "word": "អស្សុ --" },
    { "id": 16341, "word": "អស្សុជ" },
    { "id": 16342, "word": "អស្សុត" },
    { "id": 16343, "word": "អស្សុពាហ៍" },
    { "id": 16344, "word": "អហង្ការ" },
    { "id": 16345, "word": "អហង្ការិន" },
    { "id": 16346, "word": "អហង្ការិនី" },
    { "id": 16347, "word": "អហហៈ" },
    { "id": 16348, "word": "អហិ" },
    { "id": 16349, "word": "អហិ --" },
    { "id": 16350, "word": "អហិង្សា " },
    { "id": 16351, "word": "អហិត" },
    { "id": 16352, "word": "អហិត --" },
    { "id": 16353, "word": "អហិម" },
    { "id": 16354, "word": "អហិម --" },
    { "id": 16355, "word": "អហិរិក" },
    { "id": 16356, "word": "អហិរិក --" },
    { "id": 16357, "word": "អហេតុក" },
    { "id": 16358, "word": "អហេតុក --" },
    { "id": 16359, "word": "អហេសា" },
    { "id": 16360, "word": "អហោ" },
    { "id": 16361, "word": "អហោរត្ត" },
    { "id": 16362, "word": "អហោសិកម្ម" },
    { "id": 16363, "word": "អហំការ" },
    { "id": 16364, "word": "អា" },
    { "id": 16365, "word": "អា !" },
    { "id": 16366, "word": "អា៎ !" },
    { "id": 16367, "word": "អាក់" },
    { "id": 16368, "word": "អាកង្ខា" },
    { "id": 16369, "word": "អាកប្ប" },
    { "id": 16370, "word": "អាករ" },
    { "id": 16371, "word": "អាករ --" },
    { "id": 16372, "word": "អាការ" },
    { "id": 16373, "word": "អាការសាហាវ" },
    { "id": 16374, "word": "អាកាស" },
    { "id": 16375, "word": "អាកាស --" },
    { "id": 16376, "word": "អាកិណ្ណ" },
    { "id": 16377, "word": "អាកិណ្ណ --" },
    { "id": 16378, "word": "អាកុល --" },
    { "id": 16379, "word": "អាកូល" },
    { "id": 16380, "word": "អាកោ" },
    { "id": 16381, "word": "អាកោដ" },
    { "id": 16382, "word": "អាក្រក់" },
    { "id": 16383, "word": "អាក្រម" },
    { "id": 16384, "word": "អាក្រាត" },
    { "id": 16385, "word": "អាក្រីឌ" },
    { "id": 16386, "word": "អាក្រោធ" },
    { "id": 16387, "word": "អាក្រោធន" },
    { "id": 16388, "word": "អាក្រោស" },
    { "id": 16389, "word": "អាខ្យា" },
    { "id": 16390, "word": "អាខ្យាត" },
    { "id": 16391, "word": "អាខ្យាន" },
    { "id": 16392, "word": "អាគតដ្ឋាន" },
    { "id": 16393, "word": "អាគតសញ្ញា" },
    { "id": 16394, "word": "អាគន្តុ" },
    { "id": 16395, "word": "អាគន្តុក" },
    { "id": 16396, "word": "អាគន្តុក --" },
    { "id": 16397, "word": "អាគម" },
    { "id": 16398, "word": "អាគារ" },
    { "id": 16399, "word": "អាគារិក" },
    { "id": 16400, "word": "អាគារិយ" },
    { "id": 16401, "word": "អាគ្នេយ៍" },
    { "id": 16402, "word": "អាឃាត" },
    { "id": 16403, "word": "អាឃាត --" },
    { "id": 16404, "word": "អាឃាតនៈ" },
    { "id": 16405, "word": "អាឃោសន" },
    { "id": 16406, "word": "អាង" },
    { "id": 16407, "word": "អាងខ្នាង" },
    { "id": 16408, "word": "អាច" },
    { "id": 16409, "word": "អាចក្តី" },
    { "id": 16410, "word": "អាចម" },
    { "id": 16411, "word": "អាចម៍" },
    { "id": 16412, "word": "អាចម៍កន្លង់" },
    { "id": 16413, "word": "អាចម៍កុក" },
    { "id": 16414, "word": "អាចម៍ក្រចក" },
    { "id": 16415, "word": "អាចម៍ក្រពើ" },
    { "id": 16416, "word": "អាចម៍គោ" },
    { "id": 16417, "word": "អាចម៍ច្រមុះ" },
    { "id": 16418, "word": "អាចម៍ឆ្កែ" },
    { "id": 16419, "word": "អាចម៍ឆ្មា" },
    { "id": 16420, "word": "អាចម៍ឆ្ពឹស" },
    { "id": 16421, "word": "អាចម៍ដី" },
    { "id": 16422, "word": "អាចម៍ដែក" },
    { "id": 16423, "word": "អាចម៍ដំរី" },
    { "id": 16424, "word": "អាចម៍ត្រចៀក" },
    { "id": 16425, "word": "អាចម៍ធ្មេញ" },
    { "id": 16426, "word": "អាចមន" },
    { "id": 16427, "word": "អាចម៍បន្ទោះ" },
    { "id": 16428, "word": "អាចម៍បំណះ" },
    { "id": 16429, "word": "អាចម៍ផ្កាយ" },
    { "id": 16430, "word": "អាចម៍ផ្ចិត" },
    { "id": 16431, "word": "អាចម៍មាន់" },
    { "id": 16432, "word": "អាចម៍រមាំង" },
    { "id": 16433, "word": "អាចម៍រុយ" },
    { "id": 16434, "word": "អាចម៍ល័ក្ត" },
    { "id": 16435, "word": "អាចម៍សត្វ" },
    { "id": 16436, "word": "អាចម៍សេះ" },
    { "id": 16437, "word": "អាចម៍អណ្ដើក" },
    { "id": 16438, "word": "អាចយ" },
    { "id": 16439, "word": "អាចយ --" },
    { "id": 16440, "word": "អាចរិយ" },
    { "id": 16441, "word": "អាចរិយ --" },
    { "id": 16442, "word": "អាចារ" },
    { "id": 16443, "word": "អាចារ --" },
    { "id": 16444, "word": "អាចារា --" },
    { "id": 16445, "word": "អាចារិនី" },
    { "id": 16446, "word": "អាចារី" },
    { "id": 16447, "word": "អាចារ្យ" },
    { "id": 16448, "word": "អាចារ្យ --" },
    { "id": 16449, "word": "អាចិណ្ណ" },
    { "id": 16450, "word": "អាចិណ្ណ --" },
    { "id": 16451, "word": "អាជានីយ" },
    { "id": 16452, "word": "អាជានេយ្យ" },
    { "id": 16453, "word": "អាជានៃយ" },
    { "id": 16454, "word": "អាជិ" },
    { "id": 16455, "word": "អាជីព " },
    { "id": 16456, "word": "អាជីវ --" },
    { "id": 16457, "word": "អាជីវក" },
    { "id": 16458, "word": "អាជីវិកា" },
    { "id": 16459, "word": "អាជ្ជវៈ" },
    { "id": 16460, "word": "អាជ្ញា" },
    { "id": 16461, "word": "អាជ្ញា --" },
    { "id": 16462, "word": "អាដានា" },
    { "id": 16463, "word": "អាឌម្ពរ" },
    { "id": 16464, "word": "អាឍ្យចរ" },
    { "id": 16465, "word": "អាណត្តិ" },
    { "id": 16466, "word": "អាណត្តិ --" },
    { "id": 16467, "word": "អាណា" },
    { "id": 16468, "word": "អាណា --" },
    { "id": 16469, "word": "អាណិកជន" },
    { "id": 16470, "word": "អាណិត" },
    { "id": 16471, "word": "អាណោច" },
    { "id": 16472, "word": "អាត់" },
    { "id": 16473, "word": "អាត់តែ" },
    { "id": 16474, "word": "អាតាបៈ" },
    { "id": 16475, "word": "អាតាបិនី" },
    { "id": 16476, "word": "អាតាបី" },
    { "id": 16477, "word": "អាតុរ" },
    { "id": 16478, "word": "អាតុរ --" },
    { "id": 16479, "word": "អាត្ម" },
    { "id": 16480, "word": "អាត្ម --" },
    { "id": 16481, "word": "អាត្ម័ន" },
    { "id": 16482, "word": "អាត្មា" },
    { "id": 16483, "word": "អាត្មា --" },
    { "id": 16484, "word": "អាត្មាធីន" },
    { "id": 16485, "word": "អាត្មោបជីវិន" },
    { "id": 16486, "word": "អាត្មោបជីវិនី" },
    { "id": 16487, "word": "អាទរ" },
    { "id": 16488, "word": "អាទរ --" },
    { "id": 16489, "word": "អាទាហនស្ថាន" },
    { "id": 16490, "word": "អាទិ" },
    { "id": 16491, "word": "អាទិ --" },
    { "id": 16492, "word": "អាទិច្ច" },
    { "id": 16493, "word": "អាទិដ្ឋសព្ទ" },
    { "id": 16494, "word": "អាទិត្យ" },
    { "id": 16495, "word": "អាទីនព " },
    { "id": 16496, "word": "អាទេស" },
    { "id": 16497, "word": "អាទ្យ" },
    { "id": 16498, "word": "អាទ្យូន" },
    { "id": 16499, "word": "អាធ័ម" },
    { "id": 16500, "word": "អាធម្ម" },
    { "id": 16501, "word": "អាធារ" },
    { "id": 16502, "word": "អាធិបតេយ្យ" },
    { "id": 16503, "word": "អាន" },
    { "id": 16504, "word": "អាន" },
    { "id": 16505, "word": "អាន់ជ្រី" },
    { "id": 16506, "word": "អានន្ទ" },
    { "id": 16507, "word": "អានាបា" },
    { "id": 16508, "word": "អានាបាណ" },
    { "id": 16509, "word": "អានាប្រាណ" },
    { "id": 16510, "word": "អានាហរោគ" },
    { "id": 16511, "word": "អានីតភណ្ឌ" },
    { "id": 16512, "word": "អានិសង្ស" },
    { "id": 16513, "word": "អានិសន្ទានុភាព" },
    { "id": 16514, "word": "អានុភាព" },
    { "id": 16515, "word": "អាប" },
    { "id": 16516, "word": "អាប់" },
    { "id": 16517, "word": "អាប់ --" },
    { "id": 16518, "word": "អាប់ចុន" },
    { "id": 16519, "word": "អាបណ " },
    { "id": 16520, "word": "អាបណ --" },
    { "id": 16521, "word": "អាបណក" },
    { "id": 16522, "word": "អាបណិកា" },
    { "id": 16523, "word": "អាបត្តិ" },
    { "id": 16524, "word": "អាប័ទ" },
    { "id": 16525, "word": "អាប់ប៉ត្រាប់" },
    { "id": 16526, "word": "អាបឡាប" },
    { "id": 16527, "word": "អាបាន" },
    { "id": 16528, "word": "អាបាយិកសត្ត" },
    { "id": 16529, "word": "អាបុច្ឆន" },
    { "id": 16530, "word": "អាបុច្ឆន --" },
    { "id": 16531, "word": "អាបុច្ឆា" },
    { "id": 16532, "word": "អាបោ" },
    { "id": 16533, "word": "អាបោ --" },
    { "id": 16534, "word": "អាប៉ោង" },
    { "id": 16535, "word": "អាព័ទ្ធ" },
    { "id": 16536, "word": "អាពាធ" },
    { "id": 16537, "word": "អាពាធិក" },
    { "id": 16538, "word": "អាពាធិកា" },
    { "id": 16539, "word": "អាពាហ៍ពិពាហ៍" },
    { "id": 16540, "word": "អាពុក" },
    { "id": 16541, "word": "អាពៀស " },
    { "id": 16542, "word": "អាភរណៈ" },
    { "id": 16543, "word": "អាភស្សរ" },
    { "id": 16544, "word": "អាភា" },
    { "id": 16545, "word": "អាភាស" },
    { "id": 16546, "word": "អាភិធម្មិក" },
    { "id": 16547, "word": "អាភិធម្មិកា" },
    { "id": 16548, "word": "អាភិសមាចារិក" },
    { "id": 16549, "word": "អាភិសមាចារិកា" },
    { "id": 16550, "word": "អាភៀន" },
    { "id": 16551, "word": "អាភៀស" },
    { "id": 16552, "word": "អាភេទ" },
    { "id": 16553, "word": "អាភោគចិត្ត" },
    { "id": 16554, "word": "អាម" },
    { "id": 16555, "word": "អាមក" },
    { "id": 16556, "word": "អាមក --" },
    { "id": 16557, "word": "អាមណាម" },
    { "id": 16558, "word": "អាមន្តន" },
    { "id": 16559, "word": "អាមន្តន --" },
    { "id": 16560, "word": "អាមយ" },
    { "id": 16561, "word": "អាមវាត" },
    { "id": 16562, "word": "អាមសូល" },
    { "id": 16563, "word": "អាមាតិសារ" },
    { "id": 16564, "word": "អាមាត្យ" },
    { "id": 16565, "word": "អាម៉ាស់" },
    { "id": 16566, "word": "អាមាសយ" },
    { "id": 16567, "word": "អាមាសយរោគ" },
    { "id": 16568, "word": "អាមិស" },
    { "id": 16569, "word": "អាមិស --" },
    { "id": 16570, "word": "អាមុកុលិត" },
    { "id": 16571, "word": "អាមេណ្ឌន" },
    { "id": 16572, "word": "អាមេណ្ឌិត" },
    { "id": 16573, "word": "អាមេណ្ឌិត--" },
    { "id": 16574, "word": "អាមេណ្ឌិតលេខ" },
    { "id": 16575, "word": "អាម៉េរិក" },
    { "id": 16576, "word": "អាម៉េរិក័ង" },
    { "id": 16577, "word": "អាម៉េរិគ" },
    { "id": 16578, "word": "អាមោទ" },
    { "id": 16579, "word": "អាមោទ --" },
    { "id": 16580, "word": "អាយ" },
    { "id": 16581, "word": "អាយ័ត" },
    { "id": 16582, "word": "អាយតនៈ" },
    { "id": 16583, "word": "អាយតនិបាត" },
    { "id": 16584, "word": "អាយលម្ពាយ" },
    { "id": 16585, "word": "អាយាចន --" },
    { "id": 16586, "word": "អាយាចនៈ" },
    { "id": 16587, "word": "អាយ៉ាត់" },
    { "id": 16588, "word": "អាយុ" },
    { "id": 16589, "word": "អាយុ --" },
    { "id": 16590, "word": "អាយុត្តកៈ" },
    { "id": 16591, "word": "អាយុធ" },
    { "id": 16592, "word": "អាយូស" },
    { "id": 16593, "word": "អាយោគ" },
    { "id": 16594, "word": "អាយោធន" },
    { "id": 16595, "word": "អារ" },
    { "id": 16596, "word": "អារកូដ" },
    { "id": 16597, "word": "អារក្ខ" },
    { "id": 16598, "word": "អារក្ខ --" },
    { "id": 16599, "word": "អារក្ខា" },
    { "id": 16600, "word": "អារក្ស --" },
    { "id": 16601, "word": "អារញ្ញ" },
    { "id": 16602, "word": "អារញ្ញក --" },
    { "id": 16603, "word": "អារណ្យ" },
    { "id": 16604, "word": "អារតិ" },
    { "id": 16605, "word": "អារម្ភ" },
    { "id": 16606, "word": "អារម្ភ --" },
    { "id": 16607, "word": "អារម្មណ --" },
    { "id": 16608, "word": "អារម្មណ៍" },
    { "id": 16609, "word": "អារាធក" },
    { "id": 16610, "word": "អារាធន --" },
    { "id": 16611, "word": "អារាធនា" },
    { "id": 16612, "word": "អារាម" },
    { "id": 16613, "word": "អារាម --" },
    { "id": 16614, "word": "អារាមិក" },
    { "id": 16615, "word": "អារាមិកា" },
    { "id": 16616, "word": "អារាលិក" },
    { "id": 16617, "word": "អារ៉ិច" },
    { "id": 16618, "word": "អារីអារ៉ប" },
    { "id": 16619, "word": "អារឹស" },
    { "id": 16620, "word": "អារ៉េច" },
    { "id": 16621, "word": "អារោគ្យ" },
    { "id": 16622, "word": "អារោចន" },
    { "id": 16623, "word": "អារោចន-" },
    { "id": 16624, "word": "អារោទន" },
    { "id": 16625, "word": "អារោទន-" },
    { "id": 16626, "word": "អាឃ៌" },
    { "id": 16627, "word": "អាថ៌" },
    { "id": 16628, "word": "អារ្យ" },
    { "id": 16629, "word": "អារ្យក" },
    { "id": 16630, "word": "អាយ៌េន" },
    { "id": 16631, "word": "អាល" },
    { "id": 16632, "word": "អាល័ក្ខណ៍" },
    { "id": 16633, "word": "អាល័ក្ស" },
    { "id": 16634, "word": "អាល័ក្សណ៍" },
    { "id": 16635, "word": "អាលបន" },
    { "id": 16636, "word": "អាលម្ពរ" },
    { "id": 16637, "word": "អាលម្ពាយ" },
    { "id": 16638, "word": "អាលយ --" },
    { "id": 16639, "word": "អាល័យ" },
    { "id": 16640, "word": "អាល័យតែ" },
    { "id": 16641, "word": "អាលាប" },
    { "id": 16642, "word": "អាលិង្គន" },
    { "id": 16643, "word": "អាលុលិក" },
    { "id": 16644, "word": "អាលោកកសិណ" },
    { "id": 16645, "word": "អាវ" },
    { "id": 16646, "word": "អាវបន" },
    { "id": 16647, "word": "អាវបន --" },
    { "id": 16648, "word": "អាវរណ" },
    { "id": 16649, "word": "អាវរណ --" },
    { "id": 16650, "word": "អាវាដ" },
    { "id": 16651, "word": "អាវាស" },
    { "id": 16652, "word": "អាវាសិក" },
    { "id": 16653, "word": "អាវាសិក --" },
    { "id": 16654, "word": "អាវាសែ" },
    { "id": 16655, "word": "អាវាហៈ" },
    { "id": 16656, "word": "អាវុធ" },
    { "id": 16657, "word": "អាវុធ --" },
    { "id": 16658, "word": "អាវុសោ" },
    { "id": 16659, "word": "អាវ៉ូកាចេរ" },
    { "id": 16660, "word": "អាវ៉ូកាត៍" },
    { "id": 16661, "word": "អាវេសនៈ" },
    { "id": 16662, "word": "អាវេសិក" },
    { "id": 16663, "word": "អាវេសិក --" },
    { "id": 16664, "word": "អាស" },
    { "id": 16665, "word": "អាស !" },
    { "id": 16666, "word": "អាសគ្រាម" },
    { "id": 16667, "word": "អាសង្កា" },
    { "id": 16668, "word": "អាសន --" },
    { "id": 16669, "word": "អាសនៈ" },
    { "id": 16670, "word": "អាសន្ទិ" },
    { "id": 16671, "word": "អាសន្ន" },
    { "id": 16672, "word": "អាសន្ន --" },
    { "id": 16673, "word": "អាសភិវាចា" },
    { "id": 16674, "word": "អាសយដ្ឋាន" },
    { "id": 16675, "word": "អាសវ" },
    { "id": 16676, "word": "អាសវ --" },
    { "id": 16677, "word": "អាសអាភាស" },
    { "id": 16678, "word": "អាសា" },
    { "id": 16679, "word": "អាសាញ់" },
    { "id": 16680, "word": "អាសាឍ" },
    { "id": 16681, "word": "អាសាឍមាស" },
    { "id": 16682, "word": "អាសិញ្ចនកម្ម" },
    { "id": 16683, "word": "អាសិដ្ឋ" },
    { "id": 16684, "word": "អាសិរពិស" },
    { "id": 16685, "word": "អាសិរ្ពិស" },
    { "id": 16686, "word": "អាស៊ី" },
    { "id": 16687, "word": "អាសីពិស" },
    { "id": 16688, "word": "អាសូរ" },
    { "id": 16689, "word": "អាស្ថាន" },
    { "id": 16690, "word": "អាស្យាទិគ" },
    { "id": 16691, "word": "អាស្រម" },
    { "id": 16692, "word": "អាស្រ័យ" },
    { "id": 16693, "word": "អាស្រាត" },
    { "id": 16694, "word": "អាស្រូវ" },
    { "id": 16695, "word": "អាស្រូវ --" },
    { "id": 16696, "word": "អាស្វាស" },
    { "id": 16697, "word": "អាហរ័ណ" },
    { "id": 16698, "word": "អាហារ" },
    { "id": 16699, "word": "អាហារ --" },
    { "id": 16700, "word": "អាហ្វ្រិក" },
    { "id": 16701, "word": "អាហ្វ្រិក័ង" },
    { "id": 16702, "word": "អាហ្វ្រិគ" },
    { "id": 16703, "word": "អាឡារិក" },
    { "id": 16704, "word": "អាឡារិកា" },
    { "id": 16705, "word": "អាឡាហណដ្ឋាន" },
    { "id": 16706, "word": "អាឡោះ" },
    { "id": 16707, "word": "អាឡ្ហក" },
    { "id": 16708, "word": "អាះ !" },
    { "id": 16709, "word": "អ៊‌ិកអ៊ាក់" },
    { "id": 16710, "word": "ឥក្ស្វាកុ" },
    { "id": 16711, "word": "ឥច្ឆា" },
    { "id": 16712, "word": "ឥច្ឆា --" },
    { "id": 16713, "word": "ឥដ្ឋ" },
    { "id": 16714, "word": "ឥដ្ឋ --" },
    { "id": 16715, "word": "ឥដ្ឋារម្មណ៍" },
    { "id": 16716, "word": "ឥណ" },
    { "id": 16717, "word": "ឥណ --" },
    { "id": 16718, "word": "ឥណ្ឌា" },
    { "id": 16719, "word": "ឥណ្ឌុស" },
    { "id": 16720, "word": "ឥណ្ឌូ" },
    { "id": 16721, "word": "ឥណ្ឌូចិន" },
    { "id": 16722, "word": "ឥណ្ឌូស៊ីន" },
    { "id": 16723, "word": "ឥណ្ឌៀ" },
    { "id": 16724, "word": "ឥត" },
    { "id": 16725, "word": "ឥត --" },
    { "id": 16726, "word": "ឥតិវុត្តក" },
    { "id": 16727, "word": "ឥតិហាស" },
    { "id": 16728, "word": "ឥត្ថាគារ" },
    { "id": 16729, "word": "ឥត្ថី" },
    { "id": 16730, "word": "ឥត្ថី --" },
    { "id": 16731, "word": "ឥទ្ធានុភាព" },
    { "id": 16732, "word": "ឥទ្ធិ" },
    { "id": 16733, "word": "ឥទ្ធិ --" },
    { "id": 16734, "word": "ឥទ្ធិបាទ" },
    { "id": 16735, "word": "ឥធលោក" },
    { "id": 16736, "word": "ឥន្ទ" },
    { "id": 16737, "word": "ឥន្ទ --" },
    { "id": 16738, "word": "ឥន្ទចាប" },
    { "id": 16739, "word": "ឥន្ទជិត" },
    { "id": 16740, "word": "ឥន្ទធនូ" },
    { "id": 16741, "word": "ឥន្ទនិល" },
    { "id": 16742, "word": "ឥន្ទនេល" },
    { "id": 16743, "word": "ឥន្ទបត្ត" },
    { "id": 16744, "word": "ឥន្ទលាំ" },
    { "id": 16745, "word": "ឥន្ទវង្ស" },
    { "id": 16746, "word": "ឥន្ទវជិរច្ឆន្ទ" },
    { "id": 16747, "word": "ឥន្ទាវុធ" },
    { "id": 16748, "word": "ឥន្ទុ" },
    { "id": 16749, "word": "ឥន្ទ្រ" },
    { "id": 16750, "word": "ឥន្ទ្រកីល" },
    { "id": 16751, "word": "ឥន្ទ្រជិត" },
    { "id": 16752, "word": "ឥន្ទ្រា" },
    { "id": 16753, "word": "ឥន្ទ្រិយ" },
    { "id": 16754, "word": "ឥន្រ្ទិយ --" },
    { "id": 16755, "word": "ឥន្រ្ទី" },
    { "id": 16756, "word": "ឥន្ធនៈ" },
    { "id": 16757, "word": "អិមអៀម" },
    { "id": 16758, "word": "ឥរា" },
    { "id": 16759, "word": "ឥរិយា" },
    { "id": 16760, "word": "ឥរិយាបថ" },
    { "id": 16761, "word": "ឥរិយាបថ --" },
    { "id": 16762, "word": "ឥរុវេទ" },
    { "id": 16763, "word": "ឥលូវ" },
    { "id": 16764, "word": "ឥស" },
    { "id": 16765, "word": "ឥសិ" },
    { "id": 16766, "word": "ឥសិ --" },
    { "id": 16767, "word": "ឥសិន្ធរ" },
    { "id": 16768, "word": "ឥសី" },
    { "id": 16769, "word": "ឥសីប្លែងសារ" },
    { "id": 16770, "word": "ឥសីផ្សំស្រេច" },
    { "id": 16771, "word": "ឥសីភទ្ទ " },
    { "id": 16772, "word": "ឥសីភេសជ្ជ" },
    { "id": 16773, "word": "ឥសុការ" },
    { "id": 16774, "word": "ឥសូរ" },
    { "id": 16775, "word": "ឥស្សរ" },
    { "id": 16776, "word": "ឥស្សរ --" },
    { "id": 16777, "word": "ឥស្សរិយ" },
    { "id": 16778, "word": "ឥស្សរិយ-" },
    { "id": 16779, "word": "ឥស្សា" },
    { "id": 16780, "word": "ឥឡា" },
    { "id": 16781, "word": "ឥឡូវ" },
    { "id": 16782, "word": "អ៊‌ិះអ៊ុះ" },
    { "id": 16783, "word": "អី ?" },
    { "id": 16784, "word": "អ៊‌ី !" },
    { "id": 16785, "word": "អ៊‌ីកអ៊ាក" },
    { "id": 16786, "word": "អ៊‌ីចឹង" },
    { "id": 16787, "word": "អ៊‌ីចុង" },
    { "id": 16788, "word": "អ៊‌ីចុះ" },
    { "id": 16789, "word": "អ៊‌ីចេះ" },
    { "id": 16790, "word": "អ៊‌ីតើ" },
    { "id": 16791, "word": "អ៊‌ីថា" },
    { "id": 16792, "word": "អីវ៉ាន់" },
    { "id": 16793, "word": "អីវ៉ែ" },
    { "id": 16794, "word": "ឦស" },
    { "id": 16795, "word": "ឦសធរ" },
    { "id": 16796, "word": "ឦសាន" },
    { "id": 16797, "word": "ឦសូរ" },
    { "id": 16798, "word": "ឦស្វរៈ" },
    { "id": 16799, "word": "អ៊‌ឹកធឹក" },
    { "id": 16800, "word": "អឹង" },
    { "id": 16801, "word": "អឹងកង" },
    { "id": 16802, "word": "អឹមអៀម" },
    { "id": 16803, "word": "អ៊‌ិម" },
    { "id": 16804, "word": "អ៊‌ឹម" },
    { "id": 16805, "word": "អ៊‌ឹះ" },
    { "id": 16806, "word": "អ៊‌ឹះអ៊ះ" },
    { "id": 16807, "word": "អឺ" },
    { "id": 16808, "word": "អឺងកង" },
    { "id": 16809, "word": "អឺងអាប់" },
    { "id": 16810, "word": "អឺត" },
    { "id": 16811, "word": "អ៊‌ឺត" },
    { "id": 16812, "word": "អឺបឡឺប" },
    { "id": 16813, "word": "អឺយ" },
    { "id": 16814, "word": "អឺ៎យ" },
    { "id": 16815, "word": "អឺរ៉ុប" },
    { "id": 16816, "word": "អឺរ៉ូប្យាំង" },
    { "id": 16817, "word": "អឺអឹង" },
    { "id": 16818, "word": "អឺះ !" },
    { "id": 16819, "word": "អឺ៎ះ !" },
    { "id": 16820, "word": "អ៊‌ឺះ !" },
    { "id": 16821, "word": "ឧក" },
    { "id": 16822, "word": "អុ៎ក" },
    { "id": 16823, "word": "ឧកញ៉ា" },
    { "id": 16824, "word": "ឧកហ្លួង" },
    { "id": 16825, "word": "អុកឡុក" },
    { "id": 16826, "word": "ឧកាស ! " },
    { "id": 16827, "word": "ឧក្កដ្ឋ" },
    { "id": 16828, "word": "ឧក្កដ្ឋ --" },
    { "id": 16829, "word": "ឧក្កដ្ឋិសព្ទ" },
    { "id": 16830, "word": "ឧក្កាបាត" },
    { "id": 16831, "word": "ឧក្រិដ្ឋ" },
    { "id": 16832, "word": "ឧគ្គហនិមិត្ត" },
    { "id": 16833, "word": "ឧគ្ឃោសនា" },
    { "id": 16834, "word": "អុង" },
    { "id": 16835, "word": "អុងប៉ាង" },
    { "id": 16836, "word": "អុងម៉ុង្គ" },
    { "id": 16837, "word": "អុងឡូ" },
    { "id": 16838, "word": "អ៊ុង៉ាៗ" },
    { "id": 16839, "word": "អុច" },
    { "id": 16840, "word": "អុចៗ" },
    { "id": 16841, "word": "អុចអាល" },
    { "id": 16842, "word": "ឧច្ច" },
    { "id": 16843, "word": "ឧច្ច --" },
    { "id": 16844, "word": "ឧច្ចារ" },
    { "id": 16845, "word": "ឧច្ចារ --" },
    { "id": 16846, "word": "ឧច្ចិនកម្ម" },
    { "id": 16847, "word": "ឧច្ឆេទ" },
    { "id": 16848, "word": "ឧច្ឆេទ --" },
    { "id": 16849, "word": "អុជ" },
    { "id": 16850, "word": "អុជៗ " },
    { "id": 16851, "word": "អុជអាល" },
    { "id": 16852, "word": "ឧជុ" },
    { "id": 16853, "word": "ឧជុ --" },
    { "id": 16854, "word": "ឧជ្ឈាន" },
    { "id": 16855, "word": "ឧជ្ឈាន --" },
    { "id": 16856, "word": "អុញ !" },
    { "id": 16857, "word": "ឧដុង្គ" },
    { "id": 16858, "word": "ឧដ្ឋាន" },
    { "id": 16859, "word": "ឧដ្ឋាន --" },
    { "id": 16860, "word": "ឧណ្ណា" },
    { "id": 16861, "word": "ឧណ្ណា --" },
    { "id": 16862, "word": "ឧណ្ហ" },
    { "id": 16863, "word": "ឧណ្ហ --" },
    { "id": 16864, "word": "ឧណ្ហីស" },
    { "id": 16865, "word": "អុត" },
    { "id": 16866, "word": "អ៊ុត" },
    { "id": 16867, "word": "ឧតុ" },
    { "id": 16868, "word": "ឧតុ --" },
    { "id": 16869, "word": "ឧត្ដម" },
    { "id": 16870, "word": "ឧត្ដម --" },
    { "id": 16871, "word": "ឧត្ដរ" },
    { "id": 16872, "word": "ឧត្ដរ --" },
    { "id": 16873, "word": "ឧត្ដរទិស" },
    { "id": 16874, "word": "ឧត្ដរមានជ័យ" },
    { "id": 16875, "word": "ឧត្តរានុទិស" },
    { "id": 16876, "word": "ឧត្តរិ" },
    { "id": 16877, "word": "ឧត្តរិ --" },
    { "id": 16878, "word": "ឧត្តល" },
    { "id": 16879, "word": "ឧត្តាន" },
    { "id": 16880, "word": "ឧត្តាន --" },
    { "id": 16881, "word": "ឧត្តាស" },
    { "id": 16882, "word": "ឧត្តាស --" },
    { "id": 16883, "word": "ឧត្ដុង្គ" },
    { "id": 16884, "word": "ឧត្បល" },
    { "id": 16885, "word": "ឧត្បល --" },
    { "id": 16886, "word": "ឧត្បាត" },
    { "id": 16887, "word": "ឧត្រាសៈ" },
    { "id": 16888, "word": "ឧត្សាហៈ" },
    { "id": 16889, "word": "ឧទក" },
    { "id": 16890, "word": "ឧទក --" },
    { "id": 16891, "word": "ឧទយ" },
    { "id": 16892, "word": "ឧទយ --" },
    { "id": 16893, "word": "ឧទរ" },
    { "id": 16894, "word": "ឧទរ --" },
    { "id": 16895, "word": "ឧទរិយៈ" },
    { "id": 16896, "word": "ឧទាន" },
    { "id": 16897, "word": "ឧទាន --" },
    { "id": 16898, "word": "ឧទាហរណ--" },
    { "id": 16899, "word": "ឧទាហរណ៍" },
    { "id": 16900, "word": "ឧទុម្ពរ" },
    { "id": 16901, "word": "ឧទេន" },
    { "id": 16902, "word": "ឧទ្ទាន" },
    { "id": 16903, "word": "ឧទ្ទាម" },
    { "id": 16904, "word": "ឧទ្ទិន" },
    { "id": 16905, "word": "ឧទ្ទិស" },
    { "id": 16906, "word": "ឧទ្ទេស" },
    { "id": 16907, "word": "ឧទ្ទេស --" },
    { "id": 16908, "word": "ឧទ្ទេសក" },
    { "id": 16909, "word": "ឧទ្ទេសា --" },
    { "id": 16910, "word": "ឧទ្ទេសិកា" },
    { "id": 16911, "word": "ឧទ្ទោសិត" },
    { "id": 16912, "word": "ឧទ្ធច្ច " },
    { "id": 16913, "word": "ឧទ្ធច្ច --" },
    { "id": 16914, "word": "ឧទ្ធទេហិក" },
    { "id": 16915, "word": "ឧទ្ធរណ៍" },
    { "id": 16916, "word": "ឧទ្យាន" },
    { "id": 16917, "word": "ឧទ្យោគ" },
    { "id": 16918, "word": "ឧន្មាគ៌ា" },
    { "id": 16919, "word": "ឧបករណ៍" },
    { "id": 16920, "word": "ឧបការ" },
    { "id": 16921, "word": "ឧបការ --" },
    { "id": 16922, "word": "ឧបការិណី" },
    { "id": 16923, "word": "ឧបការី" },
    { "id": 16924, "word": "ឧបកិច្ច" },
    { "id": 16925, "word": "ឧបក្កិលេស" },
    { "id": 16926, "word": "ឧបក្រម" },
    { "id": 16927, "word": "ឧបក្រឹត្យ" },
    { "id": 16928, "word": "ឧបក្រោស" },
    { "id": 16929, "word": "ឧបឃាត" },
    { "id": 16930, "word": "ឧបឃាតក" },
    { "id": 16931, "word": "ឧបឃាតិកា" },
    { "id": 16932, "word": "ឧបចារ" },
    { "id": 16933, "word": "ឧបចារ --" },
    { "id": 16934, "word": "ឧបច្ឆេទ" },
    { "id": 16935, "word": "ឧបច្ឆេទក" },
    { "id": 16936, "word": "ឧបច្ឆេទក --" },
    { "id": 16937, "word": "អុបឆឺយ" },
    { "id": 16938, "word": "ឧបជាតិច្ឆន្ទ" },
    { "id": 16939, "word": "ឧបជីវិក" },
    { "id": 16940, "word": "ឧបជីវិកា" },
    { "id": 16941, "word": "ឧបជីវិន" },
    { "id": 16942, "word": "ឧបជីវិនី" },
    { "id": 16943, "word": "ឧបជ្ឈា" },
    { "id": 16944, "word": "ឧបញ្ញាសកថា" },
    { "id": 16945, "word": "ឧបដ្ឋាក" },
    { "id": 16946, "word": "ឧបដ្ឋាន" },
    { "id": 16947, "word": "ឧបដ្ឋាយិកា" },
    { "id": 16948, "word": "ឧបឌ្ឍ" },
    { "id": 16949, "word": "ឧបឌ្ឍ --" },
    { "id": 16950, "word": "ឧបត្ថម្ភ" },
    { "id": 16951, "word": "ឧបត្ថម្ភក" },
    { "id": 16952, "word": "ឧបត្ថម្ភក --" },
    { "id": 16953, "word": "ឧបទិស" },
    { "id": 16954, "word": "ឧបទេស" },
    { "id": 16955, "word": "ឧបទ្ទវ" },
    { "id": 16956, "word": "ឧបទ្ទវ --" },
    { "id": 16957, "word": "ឧបទ្រព" },
    { "id": 16958, "word": "ឧបទ្វីប" },
    { "id": 16959, "word": "ឧបធិ" },
    { "id": 16960, "word": "ឧបធិ --" },
    { "id": 16961, "word": "ឧបធិក" },
    { "id": 16962, "word": "ឧបធិកា" },
    { "id": 16963, "word": "ឧបនាយក" },
    { "id": 16964, "word": "ឧបនាយិកា" },
    { "id": 16965, "word": "ឧបនាហៈ" },
    { "id": 16966, "word": "ឧបនិធិ" },
    { "id": 16967, "word": "ឧបនិមន្តន៍" },
    { "id": 16968, "word": "ឧបនិស័ទ" },
    { "id": 16969, "word": "ឧបនិស្សយ --" },
    { "id": 16970, "word": "ឧបនិស្ស័យ" },
    { "id": 16971, "word": "ឧបន្យាសកថា" },
    { "id": 16972, "word": "ឧបបាតិក" },
    { "id": 16973, "word": "ឧបបីឡកកម្ម" },
    { "id": 16974, "word": "ឧបភោគ" },
    { "id": 16975, "word": "ឧបមា" },
    { "id": 16976, "word": "ឧបមាតា" },
    { "id": 16977, "word": "ឧបមាន" },
    { "id": 16978, "word": "ឧបមេយ្យ" },
    { "id": 16979, "word": "ឧបមៃយ" },
    { "id": 16980, "word": "ឧបយមមង្គល" },
    { "id": 16981, "word": "ឧបយុវរាជ" },
    { "id": 16982, "word": "ឧបយោគ" },
    { "id": 16983, "word": "ឧបយៅវរាជ" },
    { "id": 16984, "word": "ឧបរាជ" },
    { "id": 16985, "word": "ឧបរាជ្យ" },
    { "id": 16986, "word": "ឧបរិម" },
    { "id": 16987, "word": "ឧបរិម --" },
    { "id": 16988, "word": "ឧបរិមទិស" },
    { "id": 16989, "word": "ឧបរោធ" },
    { "id": 16990, "word": "ឧបរោធ --" },
    { "id": 16991, "word": "ឧបលក្ខិត" },
    { "id": 16992, "word": "ឧបលក្ខិត --" },
    { "id": 16993, "word": "ឧបលិង្គ" },
    { "id": 16994, "word": "ឧបលិង្គ --" },
    { "id": 16995, "word": "ឧបវាទ" },
    { "id": 16996, "word": "ឧបវាទ --" },
    { "id": 16997, "word": "ឧបវាទិនី" },
    { "id": 16998, "word": "ឧបវាទី" },
    { "id": 16999, "word": "ឧបវេសន៍" },
    { "id": 17000, "word": "ឧបសគ្គ" },
    { "id": 17001, "word": "ឧបសគ្គ --" },
    { "id": 17002, "word": "ឧបសម្ប័ទ" },
    { "id": 17003, "word": "ឧបសម្បទ --" },
    { "id": 17004, "word": "ឧបសម្បន្ន" },
    { "id": 17005, "word": "ឧបសម្បន្នា" },
    { "id": 17006, "word": "ឧបសេនាបតី" },
    { "id": 17007, "word": "ឧបស្ស័យ" },
    { "id": 17008, "word": "ឧបហាស" },
    { "id": 17009, "word": "ឧបហាស --" },
    { "id": 17010, "word": "ឧបហេតុ" },
    { "id": 17011, "word": "ឧបាទវ៍" },
    { "id": 17012, "word": "ឧបាទាន" },
    { "id": 17013, "word": "ឧបាទាន --" },
    { "id": 17014, "word": "ឧបាទិន្នក" },
    { "id": 17015, "word": "ឧបាទិសេស និញ្វន" },
    { "id": 17016, "word": "ឧបាធ្យាយ" },
    { "id": 17017, "word": "ឧបាយ" },
    { "id": 17018, "word": "ឧបាយាស" },
    { "id": 17019, "word": "ឧបាសក" },
    { "id": 17020, "word": "ឧបាសក --" },
    { "id": 17021, "word": "ឧបាហន" },
    { "id": 17022, "word": "ឧបេក្ខា" },
    { "id": 17023, "word": "ឧបេន្ទវជិរច្ឆន្ទ" },
    { "id": 17024, "word": "ឧបោសថ" },
    { "id": 17025, "word": "ឧបោសថ --" },
    { "id": 17026, "word": "ឧបោសថាគារ" },
    { "id": 17027, "word": "ឧបោសថិក" },
    { "id": 17028, "word": "ឧបោសថិក --" },
    { "id": 17029, "word": "ឧប្បត្តិ" },
    { "id": 17030, "word": "ឧប្បត្តិ --" },
    { "id": 17031, "word": "ឧប្បត្តិក" },
    { "id": 17032, "word": "ឧប្បល" },
    { "id": 17033, "word": "ឧប្បាត" },
    { "id": 17034, "word": "ឧព្វេធ" },
    { "id": 17035, "word": "ឧភតោ" },
    { "id": 17036, "word": "ឧភតោ --" },
    { "id": 17037, "word": "ឧភយ" },
    { "id": 17038, "word": "ឧភយ --" },
    { "id": 17039, "word": "ឧភយោរាជ" },
    { "id": 17040, "word": "ឧភយោរាជ្យ" },
    { "id": 17041, "word": "ឧមា" },
    { "id": 17042, "word": "ឧម្មង្គ" },
    { "id": 17043, "word": "ឧម្មត្តក" },
    { "id": 17044, "word": "ឧម្មត្តកោ" },
    { "id": 17045, "word": "អ៊ុយ" },
    { "id": 17046, "word": "ឧយ្យាន" },
    { "id": 17047, "word": "ឧយ្យាមភាព" },
    { "id": 17048, "word": "ឧយ្យោធិក" },
    { "id": 17049, "word": "អុរ" },
    { "id": 17050, "word": "ឧរគ" },
    { "id": 17051, "word": "ឧរង្គ" },
    { "id": 17052, "word": "ឧរច្ឆ័ទ" },
    { "id": 17053, "word": "ឧរា" },
    { "id": 17054, "word": "ឧរុបតី" },
    { "id": 17055, "word": "ឧរ៉ៃ" },
    { "id": 17056, "word": "អុល" },
    { "id": 17057, "word": "អ៊ុលអាល់" },
    { "id": 17058, "word": "ឧល្កាបាត" },
    { "id": 17059, "word": "ឧល្លង្ឃន --" },
    { "id": 17060, "word": "ឧល្លង្ឃនៈ" },
    { "id": 17061, "word": "ឧល្លោកនៈ" },
    { "id": 17062, "word": "ឧស" },
    { "id": 17063, "word": "ឧសភ" },
    { "id": 17064, "word": "ឧសា" },
    { "id": 17065, "word": "ឧសុការ" },
    { "id": 17066, "word": "ឧសុម" },
    { "id": 17067, "word": "ឧស្សវ --" },
    { "id": 17068, "word": "ឧស្សវៈ" },
    { "id": 17069, "word": "ឧស្សាហ --" },
    { "id": 17070, "word": "ឧស្សាហៈ" },
    { "id": 17071, "word": "អុហ្វសិត" },
    { "id": 17072, "word": "ឧឡារ" },
    { "id": 17073, "word": "ឧឡារ --" },
    { "id": 17074, "word": "ឧឡុរាជ" },
    { "id": 17075, "word": "អុះ !" },
    { "id": 17076, "word": "អ្ហុះ !" },
    { "id": 17077, "word": "ឪ" },
    { "id": 17078, "word": "ឪជំ" },
    { "id": 17079, "word": "ឪជ្រឹង" },
    { "id": 17080, "word": "ឪណុល" },
    { "id": 17081, "word": "ឪទឹន" },
    { "id": 17082, "word": "ឪពុក" },
    { "id": 17083, "word": "ឪម៉ាល់" },
    { "id": 17084, "word": "ឪម៉ៃ" },
    { "id": 17085, "word": "ឪឡ" },
    { "id": 17086, "word": "ឪឡឹក" },
    { "id": 17087, "word": "ឪឡុង" },
    { "id": 17088, "word": "ឪឡោក" },
    { "id": 17089, "word": "អូ! " },
    { "id": 17090, "word": "អ៊ូ" },
    { "id": 17091, "word": "ឩកា" },
    { "id": 17092, "word": "អ៊ូង" },
    { "id": 17093, "word": "អ៊ូងព្រនូង" },
    { "id": 17094, "word": "អូងឡូង" },
    { "id": 17095, "word": "អ៊ូច" },
    { "id": 17096, "word": "អូចៗ" },
    { "id": 17097, "word": "អ៊ូញ" },
    { "id": 17098, "word": "ឩដ្ឋ" },
    { "id": 17099, "word": "អូត" },
    { "id": 17100, "word": "អ៊ូទ្រូ" },
    { "id": 17101, "word": "អូន" },
    { "id": 17102, "word": "ឩន" },
    { "id": 17103, "word": "អ៊ូប៉ទ្រូ" },
    { "id": 17104, "word": "ឩម !" },
    { "id": 17105, "word": "អូយ !" },
    { "id": 17106, "word": "អ៊ូយ !" },
    { "id": 17107, "word": "អូរ" },
    { "id": 17108, "word": "ឩរព្យ" },
    { "id": 17109, "word": "ឩរុ" },
    { "id": 17110, "word": "អូស" },
    { "id": 17111, "word": "ឩសវ័ត" },
    { "id": 17112, "word": "អូស្ត្រាលី" },
    { "id": 17113, "word": "អូស្ត្រាលីយ័ង" },
    { "id": 17114, "word": "អូស្យានី" },
    { "id": 17115, "word": "អូស្យានីយ័ង" },
    { "id": 17116, "word": "អូះ !" },
    { "id": 17117, "word": "អ៊ូអរ" },
    { "id": 17118, "word": "អ៊ូអា" },
    { "id": 17119, "word": "អ៊ូអ៊ា" },
    { "id": 17120, "word": "អ៊ូអែ" },
    { "id": 17121, "word": "អួ" },
    { "id": 17122, "word": "អួត" },
    { "id": 17123, "word": "អួទីនួ" },
    { "id": 17124, "word": "អួន" },
    { "id": 17125, "word": "អួល" },
    { "id": 17126, "word": "អួសៗ" },
    { "id": 17127, "word": "អើ" },
    { "id": 17128, "word": "អើត" },
    { "id": 17129, "word": "អើតអើម" },
    { "id": 17130, "word": "អើបឡើប" },
    { "id": 17131, "word": "អើពើ" },
    { "id": 17132, "word": "អើយ" },
    { "id": 17133, "word": "អៀ" },
    { "id": 17134, "word": "អៀង" },
    { "id": 17135, "word": "អៀន" },
    { "id": 17136, "word": "អៀនប្រៀន" },
    { "id": 17137, "word": "អៀម" },
    { "id": 17138, "word": "អៀរមមៀរ" },
    { "id": 17139, "word": "អៀវ" },
    { "id": 17140, "word": "អៀវ !" },
    { "id": 17141, "word": "អេក" },
    { "id": 17142, "word": "អេចអូច" },
    { "id": 17143, "word": "អេប !" },
    { "id": 17144, "word": "អេៈអុ" },
    { "id": 17145, "word": "អេះ" },
    { "id": 17146, "word": "អេះអុះ" },
    { "id": 17147, "word": "ឯ" },
    { "id": 17148, "word": "អែ" },
    { "id": 17149, "word": "ឯក" },
    { "id": 17150, "word": "ឯក --" },
    { "id": 17151, "word": "ឯក" },
    { "id": 17152, "word": "ឯកតោ" },
    { "id": 17153, "word": "ឯកសេសន័យ" },
    { "id": 17154, "word": "ឯកអគ្គរដ្ឋទូត" },
    { "id": 17155, "word": "ឯកឧកញ៉ា" },
    { "id": 17156, "word": "ឯកា" },
    { "id": 17157, "word": "ឯង" },
    { "id": 17158, "word": "អែងអោង" },
    { "id": 17159, "word": "ឯតទគ្គៈ" },
    { "id": 17160, "word": "ឯតទគ្គ --" },
    { "id": 17161, "word": "ឯតើ" },
    { "id": 17162, "word": "ឯថា" },
    { "id": 17163, "word": "អ៊ែន" },
    { "id": 17164, "word": "អែនអន" },
    { "id": 17165, "word": "អែប" },
    { "id": 17166, "word": "អែម" },
    { "id": 17167, "word": "អែមផ្លែម" },
    { "id": 17168, "word": "ឯរាវ័ណ" },
    { "id": 17169, "word": "អែលអល" },
    { "id": 17170, "word": "អ៊ែលអ៊ល" },
    { "id": 17171, "word": "ឯវំ" },
    { "id": 17172, "word": "អ៊ែសមមែស" },
    { "id": 17173, "word": "អែអង់" },
    { "id": 17174, "word": "ឯ. ឧ." },
    { "id": 17175, "word": "អែអុក" },
    { "id": 17176, "word": "ឰ" },
    { "id": 17177, "word": "អៃ" },
    { "id": 17178, "word": "ឰ ! " },
    { "id": 17179, "word": "អៃ --" },
    { "id": 17180, "word": "ឰក --" },
    { "id": 17181, "word": "ឰដ៏" },
    { "id": 17182, "word": "អៃរ៉ា" },
    { "id": 17183, "word": "ឰរាវ័ណ" },
    { "id": 17184, "word": "ឰរាវ័ត" },
    { "id": 17185, "word": "ឰសូរ" },
    { "id": 17186, "word": "អៃសូរ" },
    { "id": 17187, "word": "ឱ !" },
    { "id": 17188, "word": "អោ៎ !" },
    { "id": 17189, "word": "ឱក័ស" },
    { "id": 17190, "word": "ឱកាក" },
    { "id": 17191, "word": "ឱកាស" },
    { "id": 17192, "word": "ឱកាស !" },
    { "id": 17193, "word": "ឱកាស --" },
    { "id": 17194, "word": "ឱឃ" },
    { "id": 17195, "word": "ឱងឡោង" },
    { "id": 17196, "word": "ឱង្កា" },
    { "id": 17197, "word": "ឱង្ការ" },
    { "id": 17198, "word": "ឱច្ចាសន៍" },
    { "id": 17199, "word": "ឱជ" },
    { "id": 17200, "word": "ឱដ្ឋជ" },
    { "id": 17201, "word": "ឱត" },
    { "id": 17202, "word": "ឱត្តប្ប" },
    { "id": 17203, "word": "ឱទក" },
    { "id": 17204, "word": "ឱទ្យាន" },
    { "id": 17205, "word": "ឱន" },
    { "id": 17206, "word": "ឱប" },
    { "id": 17207, "word": "ឱបក្កមិកាពាធ" },
    { "id": 17208, "word": "ឱបបាតិក" },
    { "id": 17209, "word": "ឱបម្មសំសន្ទនា" },
    { "id": 17210, "word": "ឱភាស" },
    { "id": 17211, "word": "ឱម !" },
    { "id": 17212, "word": "ឱមសត្ត" },
    { "id": 17213, "word": "ឱ្យ" },
    { "id": 17214, "word": "ឱរស" },
    { "id": 17215, "word": "ឱរា" },
    { "id": 17216, "word": "ឱរ៉ុប" },
    { "id": 17217, "word": "ឱរ៉ៃ" },
    { "id": 17218, "word": "ឱវាទ" },
    { "id": 17219, "word": "ឱវាទ --" },
    { "id": 17220, "word": "ឱសថ" },
    { "id": 17221, "word": "ឱសធ --" },
    { "id": 17222, "word": "ឱសានវាទ" },
    { "id": 17223, "word": "ឱសាហ៍" },
    { "id": 17224, "word": "ឱស្ឋ" },
    { "id": 17225, "word": "ឱស្រព" },
    { "id": 17226, "word": "ឱហាត" },
    { "id": 17227, "word": "ឱឡារិក" },
    { "id": 17228, "word": "ឱឡិគល្ល" },
    { "id": 17229, "word": "ឱះ !" },
    { "id": 17230, "word": "ឳ !" },
    { "id": 17231, "word": "ឳទក" },
    { "id": 17232, "word": "អុំ" },
    { "id": 17233, "word": "អុំត្រុំ" },
    { "id": 17234, "word": "អុំទូក" },
    { "id": 17235, "word": "អ៊ំ" },
    { "id": 17236, "word": "អំណត់" },
    { "id": 17237, "word": "អំណរ" },
    { "id": 17238, "word": "អំណស់" },
    { "id": 17239, "word": "អំណាច" },
    { "id": 17240, "word": "អំណឹះ" },
    { "id": 17241, "word": "អំណោយ" },
    { "id": 17242, "word": "អំនួត" },
    { "id": 17243, "word": "អំបាញ់មិញ" },
    { "id": 17244, "word": "អំបាត" },
    { "id": 17245, "word": "អំបាយ" },
    { "id": 17246, "word": "អំបាល" },
    { "id": 17247, "word": "អំបិល" },
    { "id": 17248, "word": "អំបិលម្ទេស" },
    { "id": 17249, "word": "អំបឹះ" },
    { "id": 17250, "word": "អំបុក" },
    { "id": 17251, "word": "អំបូង" },
    { "id": 17252, "word": "អំបូរ" },
    { "id": 17253, "word": "អំបើះ" },
    { "id": 17254, "word": "អំបែង" },
    { "id": 17255, "word": "អំបែងចេះ" },
    { "id": 17256, "word": "អំបែងថ្ងៃ" },
    { "id": 17257, "word": "អំបោស" },
    { "id": 17258, "word": "អំបោះ" },
    { "id": 17259, "word": "អំបោះខ្មោច" },
    { "id": 17260, "word": "អំបោះព្រះ" },
    { "id": 17261, "word": "អំបៅអំបែក" },
    { "id": 17262, "word": "អំប៉ើក" },
    { "id": 17263, "word": "អំប៉េះអំប៉ោះ" },
    { "id": 17264, "word": "អំពក" },
    { "id": 17265, "word": "អំព័ន្ធ" },
    { "id": 17266, "word": "អំពល់" },
    { "id": 17267, "word": "អំពាច" },
    { "id": 17268, "word": "អំពាន់" },
    { "id": 17269, "word": "អំពាវ" },
    { "id": 17270, "word": "អំពាស" },
    { "id": 17271, "word": "អំពិលអំពែក" },
    { "id": 17272, "word": "អំពី" },
    { "id": 17273, "word": "អំពុត" },
    { "id": 17274, "word": "អំពុះ" },
    { "id": 17275, "word": "អំពើ" },
    { "id": 17276, "word": "អំពៀរ" },
    { "id": 17277, "word": "អំពេះ" },
    { "id": 17278, "word": "អំពែ" },
    { "id": 17279, "word": "អំពែះ" },
    { "id": 17280, "word": "អំពៅ" },
    { "id": 17281, "word": "អំពៅព្រៃ" },
    { "id": 17282, "word": "អំពះ" },
    { "id": 17283, "word": "អំព្រំ" },
    { "id": 17284, "word": "អំព្រំប្រែក្រោយ" },
    { "id": 17285, "word": "អំមិញ" },
    { "id": 17286, "word": "អំលុង" },
    { "id": 17287, "word": "អំឡុង" },
    { "id": 17288, "word": "អាំ" },
    { "id": 17289, "word": "អាំង" },
    { "id": 17290, "word": "អាំងយី" },
    { "id": 17291, "word": "អាំងឡូ" },
    { "id": 17292, "word": "អាំងឡាំង" },
    { "id": 17293, "word": "អះ !" },
    { "id": 17294, "word": "អះអាង" },
    { "id": 17295, "word": "អ្ងែង" },
    { "id": 17296, "word": "អ្នក" },
    { "id": 17297, "word": "អ្នក --" },
    { "id": 17298, "word": "អ្នកកន្ដៀត" },
    { "id": 17299, "word": "អ្នកងារ" },
    { "id": 17300, "word": "អ្នកដូន" },
    { "id": 17301, "word": "អ្នកតា" },
    { "id": 17302, "word": "អ្នកបាទ" },
    { "id": 17303, "word": "អ្នកបុណ្យ" },
    { "id": 17304, "word": "អ្នកផង" },
    { "id": 17305, "word": "អ្នកផ្លូវ" },
    { "id": 17306, "word": "អ្នកមហា" },
    { "id": 17307, "word": "អ្នកមួយ" },
    { "id": 17308, "word": "អ្នកយើង" },
    { "id": 17309, "word": "អ្នកសិល្ប៍" },
    { "id": 17310, "word": "អ្វី" },
    { "id": 17311, "word": "អ្ហ !" },
    { "id": 17312, "word": "អ្ហ៊ៈ !" },
    { "id": 17313, "word": "អ្ហា !" },
    { "id": 17314, "word": "អ្ហាៈ !" },
    { "id": 17315, "word": "អ្ហាះ !" },
    { "id": 17316, "word": "អ្ហឹៈ !" },
    { "id": 17317, "word": "អ៊្ហ‌ឹះ !" },
    { "id": 17318, "word": "អ្ហឺ !" },
    { "id": 17319, "word": "អ៊្ហ‌ឺ !" },
    { "id": 17320, "word": "អ្ហ៊‌ឺ៎ះ !" },
    { "id": 17321, "word": "អ៊្ហុះ" },
    { "id": 17322, "word": "អ្ហូ!" },
    { "id": 17323, "word": "អ្ហូះ !" },
    { "id": 17324, "word": "អ្ហ៊ែៈ !" },
    { "id": 17325, "word": "អ្ហែង" },
    { "id": 17326, "word": "អ្ហ៊ៃ ?" },
    { "id": 17327, "word": "អ្ហោ !" },
    { "id": 17328, "word": "អ្ហោះ !" },
    { "id": 17329, "word": "អ្ហះ !" }
]
